import React from "react";
import "./Map.scss";

function Map({
  handleClickMetroArea,
  handleMouseEnterMetroArea,
  handleMouseLeaveMetroArea,
  colorCode,
  g,
  zoomed,
  northAm,
  currentClickedArea,
  stateLines,
}) {
  return (
    <svg
      version="1.1"
      id="svg9559"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 555.2 351.7"
      className="na"
      ref={northAm}
    >
      <g id="stylegroup" ref={g}>
        <path
          id="FIPS_02185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M62.7,259.3l0.9-0.9l0.7-0.4l0.2,0.4l-0.4,0.2h0.4l2.2-0.7l2-2.4l1.8,0.9v0.4l-0.7,0.7v0.7
		l0.7-0.2l0.4-1.1l0.4-0.4l0.7,0.7l0.2,0.9l0.7,0.2l0.2-0.4l1.1-0.2h1.8l0.2,0.2l-0.4,0.7v0.2l1.3,0.2l-0.2,0.7h0.9l1.1-0.7l2.4-0.2
		l1.5,0.4h0.7l0.7,0.2l0.2,0.2h0.9l1.1-0.2h1.3l1.5,0.4l0.4-0.2l0.9-0.7l0.2-0.2l0.4-0.4l1.5,0.2l3.5,1.1l1.1,3.5l0.7,2.2l-9,2.2
		l0.4,2.4l-1.8,0.4l-4.6,0.9h-0.2l-10.4,1.1h-2.4v-0.4h-1.8v-0.4h-1.8l-1.8,0.2h-1.3v-0.4h-0.7v0.2h-2l-0.4-0.2H60v0.2h-0.9
		l-0.2-0.4h-1.1v0.4h-0.4l-3.1-0.2v0.9h-1.5l-1.3-0.7l-0.7-0.9l0.4-1.3l0.2-1.5l1.5,0.2l2-0.2l0.7-0.2l1.3-1.5l0.7-2l1.3-2l0.9-0.9
		l0.7,0.2l0.9-0.4L62.7,259.3z	"
        >
          <title id="t0">North Slope, AK</title>
        </path>
        <path
          id="FIPS_02188"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M74.3,278.7h-0.4l-0.9,0.4l0.2,0.4h-1.3v1.3l-0.9,0.2v-0.4l-0.4-0.4h-0.9v0.9h-0.9v-0.9h-1.8
		v2h-2.2v0.9h-1.3v2.2h-0.4v0.4h-0.4l-7.7-0.2v-0.9h-0.2l-0.2-0.2v-0.7l-0.4-0.2v-1.8l-0.2-2.2h0.9l0.4,0.2l-0.4,1.5l0.2,0.9l4,0.4
		l1.1-1.1h0.7l-0.2-0.4l-0.7-0.4l-0.7-0.4l-0.9-1.1l-0.4-0.2l-0.2-0.7l0.2-0.2h0.4l0.7,1.5l0.9,0.9l0.4-0.2l-0.4-0.2l-0.7-0.9
		l0.4-1.3l0.2,0.2v-0.2l-0.7-0.4l-1.1,0.2h-0.9l-1.5-0.7l-0.7-2.4l-2.2-2.4h1.5v-0.9l3.1,0.2h0.4V271h1.1l0.2,0.4H60v-0.2h0.2
		l0.4,0.2h2v-0.2h0.7v0.4h1.3l1.8-0.2h1.8v0.4h1.8v0.4h1.8v1.1h0.4v0.4l0.9,0.9v1.3h0.9l0.4,0.4l0.2,1.3L74.3,278.7	"
        >
          <title id="t1">Northwest Arctic, AK</title>
        </path>
        <path
          id="FIPS_02130"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M140.7,317.9l0.9-1.1l1.8,1.5l0.4,1.3l-0.2,0.7l-0.9,0.2l-1.5-0.4v-0.4l0.2-0.4L140.7,317.9z
		 M141.3,320.1l0.7,0.4l0.2,0.9l-0.7-0.7L141.3,320.1z	"
        >
          <title id="t2">Ketchikan Gateway, AK</title>
        </path>
        <path
          id="FIPS_02201"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M139.6,319.2l0.7,0.2v-0.9l-0.2-0.2v-0.9l0.2-0.4l0.7-0.4l0.7-0.9l0.2-0.4l-0.7-0.4l0.9-0.2
		l1.3,0.7h0.7l0.2-0.4l0.7,0.4v1.3l1.5,2v1.8l-0.4,1.5l-0.7,0.2l-0.4-0.2l-1.1-1.5l0.2-0.9l-0.9-1.5l-1.5-1.1l-0.9,1.1l-0.4,0.2
		l0.4,0.2v1.5H140l-0.7-0.7L139.6,319.2z M134.7,317.9l1.1-0.4l3.1,1.8l1.3,1.5l0.9,0.4l1.1,2v0.7l-0.7,0.2l-1.3-1.1l-2-0.7l1.1,1.5
		l0.4-0.4l0.4,0.2l0.4,1.1H140l-2.6-1.8l-0.2-0.4l0.9-0.9l-0.7-0.7h-0.7l-1.1-0.4l0.2-0.2h0.4l0.2-0.2l-0.7-0.9l-0.2,0.7l-0.4,0.2
		l-0.2-0.2l0.2-0.7l-0.4-1.1V317.9z M134.9,320.1v0.4l-0.2-0.2L134.9,320.1z M142.4,321.4l-0.2-0.9l0.9,0.2l0.2,0.7l-0.7,0.4
		L142.4,321.4z M136,321.7l0.9-0.4l0.4,0.2l-0.4,1.1l-0.9-0.2V321.7z M143.7,321.4l0.2,0.2v0.4h-0.7L143.7,321.4z	"
        >
          <title id="t3">Prince of Wales-Outer Ketchikan, AK</title>
        </path>
        <path
          id="FIPS_02280"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M140,318.4l0.2,0.2v0.9l-0.7-0.2l0.2-0.7l-0.4-1.8l-0.2,0.9l0.2,0.4l-0.2,0.4l-1.1-0.2
		l-0.7-0.4v-0.4l0.4-0.9l-0.4-1.5l-1.3-0.4l-0.7-0.4l-0.2-0.4l-1.1,0.2h-0.7l0.2-0.4h0.7l0.2-0.9l0.4-0.7l0.9-0.2l0.7,0.7v0.7
		l0.9-0.2l0.2,0.9l0.7,0.2l0.7,0.7l0.4-0.2l1.8,0.4l0.7,0.4l-0.2,0.4l-0.7,0.9l-0.7,0.4l-0.2,0.4L140,318.4z M132.9,315.5l-0.7-0.4
		l0.2-0.4h1.5l0.7-0.4l2.4,1.3l-0.7,0.9h-0.7v-0.4l-1.1-0.7v0.4l0.9,0.4l0.2,0.4l-0.2,0.4h-0.7v0.2l-0.4,0.2l-0.7-1.3l-0.2-0.2
		l-0.4-0.2L132.9,315.5z M133.2,317.7l-1.1-0.7l-0.4-0.7l0.2-0.7l0.4-0.2l0.7,0.4h0.7l0.4,0.9l-0.4,0.2v0.4l0.2,0.7h0.4v1.3
		l-0.4-0.4l0.2,1.1l-0.4-0.2l-0.4-1.1v-0.7h0.4L133.2,317.7z M136.3,316.8l0.7-0.4l0.4,0.9l-0.4,0.2h-0.7V316.8z M132.3,319.7
		l-0.2-0.4h0.2v0.7V319.7z M133.8,320.6h0.4L134,321l-0.4-0.2L133.8,320.6z	"
        >
          <title id="t4">Wrangell-Petersburg, AK</title>
        </path>
        <path
          id="FIPS_02220"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M126.8,312.6l1.1,0.4l0.9-0.4l0.7,1.1v0.2l-0.7,0.2l-1.5-0.7l-0.2,0.2l0.7,0.9l-0.2,0.7H127
		l-2-1.8l0.9-0.2v-0.9L126.8,312.6z M132.3,319.7v0.2l-0.4-0.2l-1.1-1.1v-0.7l-0.4,0.4l-0.2-0.4l-0.7-0.2l-0.4-1.3l-0.4-0.4v-0.4
		l-0.4,0.2l-0.7-0.4l0.4-1.3l0.9,0.4l0.9-0.2l0.2,0.4l-0.4,0.2h0.4l1.5,2.4l0.9,2h-0.2L132.3,319.7z M127.2,315.5l0.2-0.2l0.9,0.9
		v0.7l-0.4,0.2L127.2,315.5z	"
        >
          <title id="t5">Sitka, AK</title>
        </path>
        <path
          id="FIPS_02100"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M126.1,306.9l-0.2,0.2l-0.7-1.1l-0.7-0.4v0.2l1.1,1.8l0.9,1.3l1.1,1.8h-0.9l-0.7-0.7l-0.2-0.2
		l0.4-0.4l-0.4-0.4l-1.1-0.2l0.2-1.1l-0.9-0.7h-2v-1.8l0.9-1.1l1.8,1.3l0.7-0.2l0.2,0.2h0.9l0.4,0.4l0.2-0.2l0.4,0.7h0.2
		L126.1,306.9z	"
        >
          <title id="t6">Haines, AK</title>
        </path>
        <path
          id="FIPS_02110"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M131.9,310.6v0.4h-0.4l-1.5-1.3l-1.1,0.4l-1.8-1.1l-1.1-2l0.2-0.2l1.8-0.7l0.4,0.4l0.7,0.2
		l2.2,0.9v0.4l1.1,0.7l-0.4,1.5L131.9,310.6z M129,310.9h-0.4l-0.2-0.7l0.2,0.2l0.2-0.2l1.1-0.2l-0.7,0.4l-0.2,0.2V310.9z	"
        >
          <title id="t7">Juneau, AK</title>
        </path>
        <path
          id="FIPS_02232"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M124.8,305.4L123,304l0.4-0.7l0.9,0.2l0.7,0.4l0.4,1.1L124.8,305.4z M125.9,309.8l0.2,0.2
		l-1.1,0.7l-0.4-1.3l-0.7-0.7v0.4h-0.2l-2-0.4v0.2h0.9l1.3,0.4l0.9,1.3l-1.3,1.3l-0.9-0.4h-0.4l-0.7-0.2l-2.2-0.9l0.9-0.9l1.3-2
		l0.7-0.2v-0.4h2l0.9,0.7l-0.2,1.1l1.1,0.2l0.4,0.4L125.9,309.8z M134.3,313.5h-0.7l-0.2,0.4l-0.2-1.1l-1.1-1.1v-0.4l-0.2-0.7v-0.2
		l0.4-1.5l3.5,2.9l-0.9,0.2l-0.4,0.7L134.3,313.5z M129.2,310.4l0.7-0.4v0.2l1.8,1.8h-0.4l-0.7-0.9l-0.2,0.2l1.5,1.5l0.2,0.4
		l-0.4,0.7v0.7l-0.7,1.1l-0.7-0.9v-1.3l-1.1-0.9l-0.9-1.8l-0.9-1.1v-0.2h0.2l0.7,0.7l0.2,0.7h0.4v-0.2L129.2,310.4z M126.8,312.6
		l-0.9-0.2v0.9l-0.9,0.2l-0.7-0.2l-0.2-0.7l0.2-1.1l0.9-0.2l0.4-0.4l2.4,0.4l0.2,0.4l0.2,0.7l-0.2,0.2l-0.4,0.2L126.8,312.6z	"
        >
          <title id="t8">Skagway-Hoonah-Angoon, AK</title>
        </path>
        <path
          id="FIPS_02282"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M109.6,305.4h1.1l0.2-0.4l1.3,0.2l0.4-0.9l1.3-0.4l0.2,1.3l0.4,0.2l1.1,0.2l0.4,0.7l3.3,1.8
		l0.7,1.5l-0.9,0.9V310l-0.7-0.4l-4.8-1.1l-0.2-0.2v-0.4h0.4v-0.4l-0.7-1.1l-0.2,0.7l-0.9,0.9l-2,0.2l-1.3-0.7l-2.9,0.2l-3.1,1.1
		l1.1-2.9l2.9-0.9h0.4v0.4l1.5-0.4h0.4L109.6,305.4z	"
        >
          <title id="t9">Yakutat, AK</title>
        </path>
        <path
          id="FIPS_02016"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M34.9,325.4l-0.4,0.4l-0.2-0.2v-0.2L34.9,325.4z M36,328.9h0.2l-0.2,0.2l-0.4-0.4L36,328.9z
		 M43.5,343l0.9,0.9l-0.2,0.4l-1.8,1.3l-0.7,0.2h-0.7l-1.8,0.7l-0.7-0.4l2.4-0.9l0.2-1.8l0.2-0.2l1.3-0.2v0.4l0.2,0.2l0.2-0.2
		L43.5,343z M35.8,346.5l1.3-0.9l0.2-0.4l0.4-0.2l0.7-0.2l0.7,0.2l-0.4,0.9l-0.9,0.2l-1.1,1.1l-1.3,0.7l-0.7,0.2l1.1-1.1L35.8,346.5
		z M4.1,346.5l0.2,0.2L4.1,347l-0.2-0.2L4.1,346.5z M6.3,346.8h0.4l0.4,0.9l-0.7,0.4l-0.4-0.2l-0.2-1.1H6.3z M32.9,346.8v0.4
		l-0.2-0.2L32.9,346.8z M31.8,347.2h0.2l-0.2,0.2l-0.2-0.2H31.8z M18.2,347.9l-0.2-0.2l0.9-0.4l0.4,0.7l-0.7,0.9h-1.3l-2.4-0.4
		l2.2,0.2l1.1-0.4l0.2-0.2H18.2z M12.4,347.4h0.4v0.4l-0.2,0.2l-0.4-0.2v-0.4H12.4z M9.1,347.4l0.4,0.2l-0.7,0.9H8.5l-0.7-0.4
		l1.1-0.2L9.1,347.4z M32.7,347.4l0.2,0.2l-0.2,0.2l-0.9-0.2l0.2-0.2H32.7z M11.1,348.3l0.7,0.2l-0.2,0.4l-2.2,0.2l1.1-1.5h0.7v0.2
		h-0.2l-0.2,0.4L11.1,348.3z M31.4,347.9h0.2v0.2h-0.2V347.9z M29.9,347.9l0.2,0.2l-0.2,0.4h-0.7v-0.4L29.9,347.9z M13.5,348.3
		l0.2,0.2h-0.2V348.3z M12,348.5h0.7l0.2,0.2l-0.7,0.2l-0.4-0.2L12,348.5z M3,348.5v0.2L2.8,349L3,348.5z M27.9,348.5l0.2,0.2
		l-0.2,0.2l-0.2-0.2L27.9,348.5z M24.1,348.5l0.2,0.2v0.2h-0.9l0.2-0.2L24.1,348.5z M20.2,349l0.4,0.2l1.5,0.4h-1.8l-0.9-0.2
		l-0.7-0.7l0.7,0.2L20.2,349z M2.5,348.8v0.4H2.3L2.5,348.8z	"
        >
          <title id="t10">Aleutians West, AK</title>
        </path>
        <path
          id="FIPS_02013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M63.8,335.3v0.4l-0.2-0.4v-0.4l-0.4-0.2l-0.2,0.4h-0.4l-0.2,0.4l-1.1,0.9l-2,0.7l-0.9-0.2
		l0.4-1.1h-0.7l-1.1,2.6l-0.9,0.4l-0.7-0.2v-1.1l-0.4-0.2l-0.2,0.4l0.2,0.4l0.2,0.9l-0.9,0.2l-0.4-1.1l-0.7,0.2l0.4,0.9v1.3
		l-0.7-0.2l-0.9,0.2h-1.5l-0.4,0.2l-0.7,0.7h-1.1l-0.2-0.7v-0.4l0.7-0.2l0.4-0.7l2.4-1.1h0.7l0.2,1.1H53v-1.3l1.3-0.4l2-2.2l1.3-1.1
		l1.3-0.4l0.7,0.2l0.7,0.2H60v0.4l0.2,0.4l0.4-0.2l0.2-0.4V334l0.7-1.5l1.3-1.1l2.6-1.8l0.2,0.2v0.2l-0.4,0.4h-0.7v0.4h-0.9v0.4
		h-0.9v0.9h0.2v1.8l-0.2,0.4h0.9L63.8,335.3z M61.8,336.6h0.4v0.4h-0.4l-0.2-0.2L61.8,336.6z M61.1,337.3h0.4v0.4l-0.4,0.7l-0.9-0.2
		l-0.2-0.9l0.2-0.2h0.4L61.1,337.3z M62.9,337.5l0.2,0.9l-1.1,1.3v-1.3l0.2-0.2l0.4,0.2L62.9,337.5z M64,337.7v1.1h-0.4L64,337.7z
		 M57.8,338.4l0.2,0.2h-0.4l-0.4-0.4l0.2-0.2L57.8,338.4z M64.4,338.6l0.2,0.4l-0.4,0.2v-0.7H64.4z M56.1,339.1v0.4l-0.2,0.2
		l-0.4-0.4L56.1,339.1z M64.7,339.3l0.2,0.2l-0.2,0.2V339.3z M54.3,341.5l0.7,0.2v0.2h-0.7l-0.2-0.2L54.3,341.5z M46.2,341.9h0.2
		v0.4l-0.4,0.4l-0.2-0.7l0.2-0.2H46.2z M45.5,342.6l-0.2,0.4h-0.7l-0.2-0.4l0.4-0.4L45.5,342.6z M47.7,342.8h0.2v0.2H47L47.7,342.8z
		 M46.8,343l0.2,0.2l-0.7-0.2H46.8z	"
        >
          <title id="t11">Aleutians East, AK</title>
        </path>
        <path
          id="FIPS_02150"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M72.2,326.7l0.4-0.7l0.7-0.4l0.2-0.2l0.2,0.2l0.2-0.2l0.4-0.7l0.9-0.7l-0.2-1.8l0.9-0.4
		l1.1-0.4l0.7-0.4v-1.1h0.7l0.7-0.2l-0.2-0.4h1.1l-0.2-0.7h0.4l-0.2,0.7l-0.4,0.4l-0.4,0.2l-0.4,0.7l-0.2,1.5l-0.4,0.7l-0.7,0.4
		l-0.4-0.2l-0.7,0.2l-0.4,0.4l-0.4,1.1h-0.4l-0.7,0.9l-0.4,0.2l-0.2-0.2v0.4l-1.3,0.9v0.2l0.4-0.2v0.9h-1.1v-0.4l0.4-0.2L72.2,326.7
		z M81.6,322.8l-0.2,0.2l-1.1-0.4l0.9-1.3l0.9-1.5l0.7-0.2l-0.2,0.9v0.4l0.9-0.2l0.4,0.2l0.2,0.7l-0.2,0.4l-1.8,0.7l-0.7-0.4
		l-0.2,0.2L81.6,322.8z M79,325.4l0.2,0.7l0.4,0.2l-0.4-0.4l-0.2-1.8l0.4-0.4l1.3-0.2l0.4-0.2h0.7l-0.2,0.7l0.2,0.2l0.9-0.9l0.4-0.2
		l-0.2,0.9l0.4,0.7h0.4l-0.4,0.9l-1.1,1.1l-1.1,1.3L81,328l-0.2-0.4l0.2-0.4h-0.2l-0.7,1.5l-0.7,0.7l-0.7,0.2l-0.4-0.7l-0.7-1.1
		l-0.2-0.7l-0.4-0.4l0.2-1.1l0.7-0.7l1.1-0.2L79,325.4z M78.8,330.2l0.9,0.2l-0.2,0.2h-0.9l-0.2-0.2L78.8,330.2z M77.9,330.2
		l0.4,0.2l-1.1,0.9v-0.4L77.9,330.2z M75,334l0.4,0.2v0.9l-0.9-0.2v-0.4L75,334z	"
        >
          <title id="t12">Kodiak Island, AK</title>
        </path>
        <path
          id="FIPS_02060"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M70.6,319h1.8v1.3l-2.4,0.2l0.4-0.7L70.6,319z	"
        >
          <title id="t13">Bristol Bay, AK</title>
        </path>
        <path
          id="FIPS_02070"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M70.2,319v0.2l-2.6,1.3l-0.4-0.2l-0.9-1.3l-0.2,0.2l-0.2,0.9l0.4,1.1l-0.7,0.4h-0.4l-1.3-2.4
		l-0.4-0.2l-0.2,0.7h-0.2l-1.1-0.9l0.2-0.2l-0.2-0.2l-1.8,1.1v-0.9h0.4l0.4-1.3l0.4-0.4l0.2-1.3l0.4-0.9h0.7v-0.9l0.7-1.3l0.4-0.9
		h0.4l1.1-2.6H68v0.4h0.4l0.4-0.4v-0.7h0.9v0.4h2.9v0.4l0.2,1.5l0.2,4.2h-0.4v0.7h-0.9l-0.4,0.4l-0.2,0.9h-0.7l-0.7,0.4L70.2,319z
		 M59.2,319.9v-0.4h0.7L59.2,319.9z	"
        >
          <title id="t14">Dillingham, AK</title>
        </path>
        <path
          id="FIPS_02164"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M72.2,326.7l-0.2,0.4l-0.4,0.2v0.4h1.1l-2.4,1.8l-0.4-0.2l-0.2,0.9l-1.3,0.4v0.2h0.2l0.2,0.4
		h-1.3l-0.4,0.7l0.9,0.9l-0.9,1.1l-2.9,0.7v0.7l-0.2,0.4v-1.3h-0.9l0.2-0.4v-1.8h-0.2v-0.9h0.9v-0.4h0.9v-0.4h0.7l0.4-0.4v-0.2h0.7
		l-0.2-0.9l0.4-0.9l2.2-2.2l0.4-4.2l0.7-1.1l2.4-0.2V319h-1.8l-0.2-0.2l-0.2,0.4V319l-0.4-1.8l0.7-0.4H71l0.2-0.9l0.4-0.4h0.9v-0.7
		H73l-0.2-4.2l-0.2-1.5v-0.4l3.5-0.2l1.3-0.2h1.3l0.4,2.2h-0.4l0.2,1.8h-0.4l0.2,0.4v1.3h-0.2v0.4h-0.4v0.4l-0.2,0.4l-0.2,0.2
		l-0.4,0.4l-0.2,0.9h-0.7v0.9l0.2,0.2v0.4l0.2,1.5h0.9v1.1l-0.7,0.4l-1.1,0.4l-0.9,0.4l0.2,1.8l-0.9,0.7l-0.4,0.7l-0.2,0.2l-0.2-0.2
		l-0.2,0.2l-0.7,0.4L72.2,326.7z M70.6,330.9l0.4,0.2h-0.9l0.2-0.2H70.6z	"
        >
          <title id="t15">Lake and Peninsula, AK</title>
        </path>
        <path
          id="FIPS_02122"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M77,316.8l0.2-0.9l0.4-0.4l0.2-0.2l0.2-0.4v-0.4h0.4v-0.4h0.2v-1.3l-0.2-0.4H79l-0.2-1.8h0.4
		l-0.4-2.2V308l-0.2-2v-0.4h0.2l0.9-0.2h0.9l0.4-0.2l2.6-0.2v0.9h0.7l0.4,0.2l-0.4,0.4l-1.1,0.9l-0.9,1.5l-0.9,2.4v1.1l-1.1,1.8
		l-1.1,0.7l-0.7,0.9l-0.7,0.4l-0.2,1.3l0.2,0.4l0.2-0.2l0.9-0.2l1.1,0.9v0.2h-0.4l0.2,0.7h-1.1l0.2,0.4l-0.7,0.2h-1.5l-0.2-1.5v-0.4
		l-0.2-0.2v-0.9L77,316.8z M83.4,315.5l1.5-1.1l0.4-0.9h-0.4l-0.7,0.7l-0.4-0.2l-0.4-0.4l0.2-1.3l0.4-1.1l0.2-0.9v-0.9l-0.4-0.9
		l0.9-0.4l1.3-1.3l0.4,0.4h0.7l0.7-0.4l0.7,0.2h0.9l0.2,0.2l0.7,0.4h0.4v0.2l0.2,0.9v0.2l0.2,0.2l0.2,2v0.2l-1.8,0.2l-0.9,0.4v1.3
		l-1.5,1.3l-0.2-0.2l-0.4,0.4l-0.4,1.1l-2,0.7l-0.7-0.4L83.4,315.5z	"
        >
          <title id="t16">Kenai Peninsula, AK</title>
        </path>
        <path
          id="FIPS_02020"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M87.8,306.7l-1.1-0.9l0.2-0.2v-0.2h0.2l0.4-0.9l0.2-0.2H88l0.2-0.2h0.2l0.2,0.2l1.8-0.4v0.7
		l0.2,0.7v0.7l0.2,0.2v0.9h-0.7v0.4l0.2,0.2h-0.2l-0.7-0.4l-0.2-0.2h-0.9L87.8,306.7z	"
        >
          <title id="t17">Anchorage, AK</title>
        </path>
        <path
          id="FIPS_02261"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M90.9,306.5V306l-0.2-0.2v-0.7l-0.2-0.7v-0.7l1.8-0.2l1.3-0.2l-0.2-0.2h0.2l0.4-0.2l-0.4-2.4
		v-0.2l-0.4-1.1l1.1-0.2l0.2-0.2l-0.2-0.7v-0.2l-0.7-2.9l-0.2-0.7l0.9-0.4l0.7-0.2h0.2l0.4-0.2h0.7l0.7,0.2H97l3.7-0.9l0.4,0.7
		l0.2,1.1v0.7h0.7l0.2-0.7h0.9l1.1,0.7l0.4,1.5l0.4,0.2v0.2l0.2,0.9l1.8-0.7l2.2,7.5h-0.4l-1.5,0.4v-0.4H107l-2.9,0.9l-1.1,2.9
		l-2.9-0.9v-0.7l-0.9,0.4l0.4,0.4l-1.8-0.7l-2,1.8l-0.4-0.7l0.2-0.7h0.4l0.9-0.4l0.4-0.4v-0.4l-1.1,0.4h-0.9l-0.2-0.2l0.9-0.7
		l0.2-0.2l-0.9,0.4l-0.2-0.4l-0.2,0.2v-1.1l-1.3,0.7l-0.2,0.7l-1.5,0.7h-0.2l0.2-1.3l-0.4,0.2l-0.2,1.1l0.7,0.2l0.7,1.5l-0.2,0.9
		l0.9,0.9l-0.4,0.7l-1.5,0.2v-0.2l-0.2-2l-0.2-0.2v-0.2l-0.2-0.9v-0.2h-0.2l-0.2-0.2v-0.4h0.7L90.9,306.5z M94.2,306v0.2h-0.4
		L94.2,306z M93.5,307.1l0.4,0.2l-0.4,0.2V307.1z M92.2,307.1l0.4,0.2l-0.2,0.2l-0.2-0.2V307.1z M93.3,307.8v2.2l-0.7-0.4l0.2-1.1
		L93.3,307.8z M94.8,309.5l-0.4,0.7l-0.2,1.3l-0.9,0.4v-0.9l1.1-1.8v-0.4l0.2-0.2l0.7,0.2L94.8,309.5z	"
        >
          <title id="t18">Valdez-Cordova, AK</title>
        </path>
        <path
          id="FIPS_02170"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M88.5,304h-0.2l-0.2,0.2h-0.2l-0.2,0.2l-0.4,0.9h-0.2v0.2h-1.8l-0.4,0.4l-0.4-0.2h-0.7v-0.9
		l-2.6,0.2l-0.4,0.2h-0.9v-0.4l-0.2-0.2v-2l-0.2-0.2v-1.5l-0.2-2.2l2.4-0.2v-0.4l5.3-3.5l3.1-0.4v-0.2l-0.2-0.4L92,293l1.1-0.2
		l0.2,1.5l0.2,0.7l0.7,2.9v0.2l0.2,0.7l-0.2,0.2l-1.1,0.2l0.4,1.1v0.2l0.4,2.4l-0.4,0.2h-0.2l0.2,0.2l-1.3,0.2l-1.8,0.2l-1.8,0.4
		L88.5,304z	"
        >
          <title id="t19">Matanuska-Susitna, AK</title>
        </path>
        <path
          id="FIPS_02240"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M94.8,293.7l-0.7,0.2l-0.9,0.4l-0.2-1.5L92,293l-0.9-4l1.3-0.4l0.4-0.7l0.7-0.4h0.7l2.6-2h0.9
		v-0.2l0.4-0.7l-0.4-0.7l0.2-0.4l0.2-0.4l0.7-0.4l0.2-1.3h0.2l0.7-0.7l0.7-0.2l0.7-0.9v-0.7l0.4-0.7l5.5,19.2l-1.8,0.7l-0.2-0.9V297
		l-0.4-0.2l-0.4-1.5l-1.1-0.7h-0.9l-0.2,0.7h-0.7v-0.7l-0.2-1.1l-0.4-0.7l-3.7,0.9h-0.2l-0.7-0.2h-0.7l-0.4,0.2L94.8,293.7z	"
        >
          <title id="t20">Southeast Fairbanks, AK</title>
        </path>
        <path
          id="FIPS_02090"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M87.4,288v-0.2l-0.7-2.9h0.2l2.2-0.4l0.2-0.4h0.9l0.4-0.4l0.4-0.7l0.4-0.2l0.4,0.2v0.4
		l0.4,0.4h0.2l0.4,0.7l0.2,0.2l2.4-0.9l1.1-0.2l-0.2,0.4l0.2,1.5l-2.6,2h-0.7l-0.7,0.4l-0.4,0.7l-1.3,0.4l-1.5,0.2l-0.7-0.2h-0.2
		l-0.9-1.1L87.4,288z	"
        >
          <title id="t21">Fairbanks North Star, AK</title>
        </path>
        <path
          id="FIPS_02068"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M86.7,294.6l-5.3,3.5v0.4l-2.4,0.2l0.9-2.4v-0.7l-0.9-0.2l-0.2-1.3l1.3-0.2l0.4-0.9l-0.2-0.9
		l0.7-0.7h0.4l0.7,0.2l0.9-1.8l3.3-0.4l2.6-0.4l0.7,0.2l1.5-0.2l0.9,4l-2.4,0.4l0.2,0.4v0.2L86.7,294.6z	"
        >
          <title id="t22">Denali, AK</title>
        </path>
        <path
          id="FIPS_02050"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M78.5,306l0.2,2v0.2h-1.3l-1.3,0.2l-3.5,0.2h-2.9v-0.4h-0.9v0.7l-0.4,0.4H68v-0.4h-2.6
		l-1.1,2.6h-0.4l-0.4,0.9l-0.7,1.3v0.9H62l-0.4,0.9l-0.2,1.3l-0.4,0.4l-0.4,1.3H60v0.9h-0.9v0.9l-0.7,0.2l-1.5-0.2l0.4-0.2l0.4,0.2
		l0.2-0.9l-0.2-1.3l-0.4-0.9l0.9-1.1l-0.4-1.3v-0.2l-1.1-2.2l-0.4,0.9l-1.5,0.9l-1.5,0.2l-0.9-0.4l-0.2-0.7l-0.9-1.3l-2-1.8l1.3-0.9
		l-0.2-0.7h-0.4v-0.2l0.2-0.2h1.3l1.1-0.2l1.1-1.8l2.2-0.4l0.2-0.2l0.7-0.2l1.3,0.4l2-0.4l0.7-0.7l1.1-0.7l-0.2-0.4h2.9v-0.4h1.8
		v-0.4l3.5-0.2v0.4H73l1.1-0.2h2l0.9-0.2h0.4v-0.4l0.9-0.2v-0.2l0.2-0.2H79l0.2-0.4v1.5l0.2,0.2v2l0.2,0.2v0.4l-0.9,0.2h-0.2
		L78.5,306z M30.7,307.1l0.2,0.7l0.2,0.4l0.9,0.4l0.2,0.2h-0.9l-0.2-0.4l-0.7-0.9L30.7,307.1z M46.8,310.9l0.7-0.2l1.1,0.9l-0.2,1.3
		l-0.2,0.4l-1.1,0.4l-2.2-1.1l-0.7-0.7v-0.4l0.2-0.2h1.3l0.9-0.7L46.8,310.9z	"
        >
          <title id="t23">Bethel, AK</title>
        </path>
        <path
          id="FIPS_02158"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M61.6,303.6l0.2,0.4l-1.1,0.7l-0.7,0.7l-2,0.4l-1.3-0.4l-0.7,0.2l-0.2,0.2l-2.2,0.4l-1.1,1.8
		l-1.1,0.2h-1.3V308l0.4-0.2l0.2-0.4l-0.9-0.4l-0.2,0.4l-0.7-0.2l-1.1-2.2l0.2-1.3l2.4-3.1l1.1-0.9l-0.2-0.7l0.4-1.1l0.9-1.1
		l0.9-0.2l1.5,1.3l0.7-0.2l1.1-1.1l0.4,0.2l0.9,1.3h2.6h-0.2l-0.2,0.7l-0.2,1.8v1.8h0.4l-0.2,0.7v0.4l0.2,0.2L61.6,303.6z	"
        >
          <title id="t24">Kusilvak, AK</title>
        </path>
        <path
          id="FIPS_02180"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M63.3,293.2v0.9h-0.4v0.4l-0.4,0.4h-0.9l-0.4,0.4v1.3h-0.2v1.3h-2.6l-0.9-1.3l-0.4-0.2
		l0.7-0.9l0.7,0.2h0.9l1.1-0.2l0.7-1.3l0.2-0.7l-0.7-2L60,291v-0.7h0.4l0.7-0.4v-0.7l-0.9-0.9l-0.4,0.7l-1.8,0.4l-0.9,0.7l-3.5-0.2
		l-1.8,0.4l-2.4-0.9l-0.4-0.4l-0.2-0.4L49,288l-0.2-1.3l0.2-0.2l0.2-0.7l-2-0.9l-1.3-0.9v-0.7l4-2.2l0.4,0.4l1.1,0.2v-0.2l-0.7-0.4
		v-0.4l3.1-1.1l0.2,2.2v1.8l0.4,0.2v0.7l0.2,0.2H55v0.9l7.7,0.2h0.4v-0.4H64v1.3h-0.2v1.8h-0.4v0.9h-0.4v3.5h0.4L63.3,293.2z
		 M50.6,280.9l-0.2,0.2v-0.2H50.6z M45.3,286.9l0.4-0.2l0.2,0.4l-0.4,0.2L45.3,286.9z M36.7,292.1l0.2-0.4v0.7l1.3,0.9l1.1-0.7
		l0.4,0.2l0.4,0.4v0.7l1.1,0.9l1.8,0.4l-0.4,0.9l-0.9-0.4l-0.7,0.4l-0.7-0.2l-1.3-1.5l-0.9-0.4h-0.4l-0.9,0.4l-0.7-0.4v-0.4
		L36.7,292.1z M57.4,294.8v0.4h-0.7l0.2-0.4H57.4z	"
        >
          <title id="t25">Nome, AK</title>
        </path>
        <path
          id="FIPS_02290"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M78.8,301.4h-0.2l-0.2,0.2v0.2l-0.9,0.2v0.4H77l-0.9,0.2h-2l-1.1,0.2h-3.3v-0.4l-3.5,0.2v0.4
		h-1.8v0.4h-3.7l-0.2-0.2v-0.4l0.2-0.7h-0.4v-1.8l0.2-1.8l0.2-0.7h0.2v-1.3h0.2v-1.3l0.4-0.4h0.9l0.4-0.4v-0.4h0.4v-1.3h-0.4v-3.5
		h0.4v-0.9h0.4v-1.8H64v-1.3h-0.4v-2.2h1.3v-0.9h2.2v-2h1.8v0.9h0.9v-0.9h0.9l0.4,0.4v0.4l0.9-0.2v-1.3h1.3l-0.2-0.4l0.9-0.4h0.4
		l0.2-0.9l-0.2-1.3l-0.4-0.4H73v-1.3l-0.9-0.9v-0.4h-0.4v-1.1h0.7l10.4-1.1h0.2l4.6-0.9l1.8-0.4l-0.4-2.4l9-2.2l3.7,13l-0.4,0.7v0.7
		l-0.7,0.9l-0.7,0.2l-0.7,0.7H99l-0.2,1.3l-0.7,0.4l-0.2,0.4l-0.2,0.4l0.4,0.7l-0.4,0.7v0.2h-0.9l-0.2-1.5l0.2-0.4l-1.1,0.2
		l-2.4,0.9l-0.2-0.2l-0.4-0.7h-0.2l-0.4-0.4v-0.4l-0.4-0.2l-0.4,0.2l-0.4,0.7l-0.4,0.4h-0.9l-0.2,0.4l-2.2,0.4h-0.2l0.7,2.9v0.2h0.4
		l0.9,1.1h0.2l-2.6,0.4l-3.3,0.4l-0.9,1.8l-0.7-0.2H81l-0.7,0.7l0.2,0.9l-0.4,0.9l-1.3,0.2l0.2,1.3l0.9,0.2v0.7l-0.9,2.4l0.2,2.2
		l-0.2,0.4L78.8,301.4z	"
        >
          <title id="t26">Yukon-Koyukuk, AK</title>
        </path>
        <path
          id="FIPS_01069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.7,255.3l3.6-0.3l-0.1,0.3l-0.1,0.3l0.2,0.9l0.1,0.3l0.1,0.1h0.1l0.1,0l0.5,0.6l0.1,0.1
		l0.1,0.3l0.3,0.9l-5.3,0.6l-0.1-1l-0.2-1.6l-1.1,0.2l-1.4,0.1l0.4-1l0.1-0.1l0.3-0.1l0.2,0l0.2,0l0.4,0.1l0.3,0.1l0.5,0l0.2,0
		l0.7-0.6L409.7,255.3	"
        >
          <title id="t27">Houston, AL</title>
        </path>
        <path
          id="FIPS_01067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.2,251.4l-0.1-1.1l2.2-0.2l0.1-0.1l0.2-0.5l0.3-0.4l0.1,0h0.1l0.2,0.1l0.1,0.1l1.2,3
		l-0.1,2.7l-3.6,0.3L409.2,251.4z	"
        >
          <title id="t28">Henry, AL</title>
        </path>
        <path
          id="FIPS_01061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.8,257.3l0.9-0.1l1.4-0.1l1.1-0.2l0.2,1.6l0.1,1l-0.1,0l-5.9,0.7l-1.7,0.2l-0.3-2.5
		L405.8,257.3z	"
        >
          <title id="t29">Geneva, AL</title>
        </path>
        <path
          id="FIPS_01045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.6,251.8l3.6-0.4l0.4,3.9l0,0.4l-0.7,0.6l-0.2,0l-0.5,0l-0.3-0.1l-0.4-0.1l-0.2,0l-0.2,0
		l-0.3,0.1l-0.1,0.1l-0.4,1l-0.9,0.1l-0.6-5.4L405.6,251.8z	"
        >
          <title id="t30">Dale, AL</title>
        </path>
        <path
          id="FIPS_01031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.2,251.9l0.6,5.4l-4.4,0.5l-0.3-3.2l-0.1-1.2l0.4,0l0.1-0.1l-0.1-1L405.2,251.9z	"
        >
          <title id="t31">Coffee, AL</title>
        </path>
        <path
          id="FIPS_01039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.6,253.9l1.1-0.1l1.1-0.1l0.2,0l0,0.2l0.1,0.7l0.2,0.2l0.7-0.1l0.3,3.2l0.3,2.5l-2.2,0.2
		l-3.3,0.3l-0.4-2.5l-0.4-4.3L397.6,253.9z	"
        >
          <title id="t32">Covington, AL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "33660"
              ? `metroArea clickedArea state-al`
              : `metroArea ${colorCode[33660]} state-al`
          }
          id="FIPS_33660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_01097"
            className="FIPS_33660 st0 state-al"
            d="M381.9,260l0.1,0.2l0.2,1l0.3,1.8l-0.5,0.9l-0.3,1.2l0,0.3l0.2,0.5l0.2,0.5l-0.2-0.1l0,0
		l-0.5,0.5l-0.3,1.9l-1,1.9l-0.6-0.2l-0.9,0l-0.2,0l-0.1,0l-0.2,0.2v0l-0.6-4.7l-0.4-3.4l-0.2-1.5l1.1-0.1l1.1-0.3l2.2-0.3
		L381.9,260z	"
          >
            <title id="t33">Mobile, AL</title>
          </path>
        </g>
        <path
          id="FIPS_01003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384,258.1l1.7,0.5l0.5,3.2l-0.2,1.7l0.1,0.2l1.1,1.2l0.4,0.2l0.1,0l0.2,0l0.4,0.2l0.5,0.3
		l0.1,0.2l0,0.2l0,0.2l-0.1,2.8l-0.1,1.4l-0.7,0.3l-1.5,0.5l-1.6,0.4l-0.4,0.1L383,272l-0.1-0.1l0.6-0.2l1.5-1l-2-4l-0.1-0.2
		l-0.1-0.1l-0.5-0.2l-0.2,0l-0.2-0.5l-0.2-0.5l0-0.3l0.3-1.2l0.5-0.9l-0.3-1.8l-0.2-1l-0.1-0.2l0.3-0.4L384,258.1z	"
        >
          <title id="t34">Baldwin, AL</title>
        </path>
        <path
          id="FIPS_01053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.8,258.4l0.4,2.5l-1.1,0.1l-4.1,0.4l-4.8,0.5l-0.5-3.2l0.6,0.2l0.1,0l0.6-0.4l0.7-0.1
		l7.3-0.7l0,0.1l0,0.6l0,0.1l0,0.1l0.1,0.1l0.5,0L395.8,258.4z	"
        >
          <title id="t35">Escambia, AL</title>
        </path>
        <path
          id="FIPS_01035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.4,254.1l0.4,4.3l-0.2,0.1l-0.5,0l-0.1-0.1l0-0.1l0-0.1l0-0.6l0-0.1l-7.3,0.7l0-0.1
		l0.1-0.2l1.2-1.7l0.7-0.7l0.8-2.3l0-0.2l1.1-1l0.9-0.5l0.2-0.1l0.1,0l0.1,1.5l0.6,1.1l0.3,0.2L395.4,254.1z	"
        >
          <title id="t36">Conecuh, AL</title>
        </path>
        <path
          id="FIPS_01129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.9,253.6l4.1-0.4l0,0.5l0.2,0.7l0.6,0.5l0.1,0.1l0.5,0.2l0.4,0.1l0.4,0.4l0.3,1.3l0,0.1
		l0,0.4l-0.1,0.4l-0.2,0.2l-0.2,0.3l-0.2,0.5l0.3,0.7l-0.3,0.4l-0.5,0.3l-2.2,0.3L378,261l-1.1,0.1L375.9,253.6z	"
        >
          <title id="t37">Washington, AL</title>
        </path>
        <path
          id="FIPS_01023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.8,245.7l5.3-0.5l-0.5,0.1l-0.3,0.2l-0.1,0.2l-0.8,3.1l0,0.5l0.1,0.1l0.1,0.1l0.1,0.1
		l0.3,0l0.2,3.8l-4.1,0.4l-0.3-2.5l0.1-4.3L375.8,245.7z	"
        >
          <title id="t38">Choctaw, AL</title>
        </path>
        <path
          id="FIPS_01025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.3,249.1l2,1.9l-0.2,0.2l-0.4,1.6l0.2,1.7l0.1,1.3l-0.1,0.4l-0.2,0.3l-0.1,0.1l-0.1,0
		l-0.2-0.2l-0.1,0l-0.1,0l-1,0.9l-0.2,0.5v0.1l0,0.1l0,0.1l0.2,0.1l-1.9,1.5l-0.3-0.7l0.2-0.5l0.2-0.3l0.2-0.2l0.1-0.4l0-0.4l0-0.1
		l-0.3-1.3l-0.4-0.4l-0.4-0.1l-0.5-0.2l-0.1-0.1l-0.6-0.5l-0.2-0.7l0-0.5l-0.2-3.8L384.3,249.1z	"
        >
          <title id="t39">Clarke, AL</title>
        </path>
        <path
          id="FIPS_01099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.7,250.4l0.1,1l-0.1,0l-0.2,0.1l-0.9,0.5l-1.1,1l0,0.2l-0.8,2.3l-0.7,0.7l-1.2,1.7
		l-0.1,0.2l0,0.1l-0.7,0.1l-0.6,0.4l-0.1,0l-0.6-0.2l-1.7-0.5l-0.2-0.1l0-0.1l0-0.1v-0.1l0.2-0.5l1-0.9l0.1,0l0.1,0l0.2,0.2l0.1,0
		l0.1-0.1l0.2-0.3l0.1-0.4l-0.1-1.3l-0.2-1.7l0.4-1.6l0.2-0.2l2.9-0.3l1.6-0.1L392.7,250.4z	"
        >
          <title id="t40">Monroe, AL</title>
        </path>
        <path
          id="FIPS_01131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.1,245.4l0.3-0.1l0.1,0l1.3,0.9l1.7,1.6l2.9-0.3l0.6,1.1l-0.4,1.7l-2,0.2l-1.6,0.1
		l-2.9,0.3l-2-1.9l0.5-0.2l-0.1-1.6l1-1.7l0.1-0.2l0.1,0l0.2,0L386.1,245.4z	"
        >
          <title id="t41">Wilcox, AL</title>
        </path>
        <path
          id="FIPS_01013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M393.1,248.6l4.4-0.5l0.3,3.2l0,0.8l-0.6,0.1l0.2,1.7l-2.2,0.2l-1.5,0.1l-0.3-0.2l-0.6-1.1
		l-0.1-1.5l-0.1-1L393.1,248.6z	"
        >
          <title id="t42">Butler, AL</title>
        </path>
        <path
          id="FIPS_01041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.3,247.9l1,4.4l0.1,1l-0.1,0.1l-0.4,0l0.1,1.2l-0.7,0.1l-0.2-0.2l-0.1-0.7l0-0.2l-0.2,0
		l-1.1,0.1l-1.1,0.1l-0.2-1.7l0.6-0.1l0-0.8l-0.3-3.2l0.3-1.2l1.1-0.1l0.1,1.1L400.3,247.9z	"
        >
          <title id="t43">Crenshaw, AL</title>
        </path>
        <path
          id="FIPS_01109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.3,246.6l0.4-0.2l0.5,0l0.2,0.1l0.5,1l0.8,1l1.5-0.2l-0.6,3.5l-0.4,0l-3.9,0.4l-1-4.4
		L402.3,246.6z	"
        >
          <title id="t44">Pike, AL</title>
        </path>
        <path
          id="FIPS_01011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.2,243.5l0.4,1.1l-0.2,0.1l0.1,1.1l0.1,0.5l-0.9,0.3l-0.9,0.3l-0.5,1l-0.1,0.3l0,0.1
		l-1.5,0.2l-0.8-1l-0.5-1l-0.2-0.1l-0.5,0l-0.4,0.2l0.5-3l0.7,0.4l0.1,0L408.2,243.5z	"
        >
          <title id="t45">Bullock, AL</title>
        </path>
        <path
          id="FIPS_01087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.8,239.2l0,0.2l2.3,0.8l0.5-0.1l0.2,1.1l0.3,2.2l-4.6,0.5l-0.1,0l-0.7-0.4l-1.3-1.8
		l1.4-1.1l1-0.1l0.3-1.2L404.8,239.2z	"
        >
          <title id="t46">Macon, AL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "33860"
              ? `metroArea clickedArea state-al`
              : `metroArea ${colorCode[33860]} state-al`
          }
          id="FIPS_33860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_01001"
            className="FIPS_33860 st0 state-al"
            d="M397,238.6l0.4,3.8l-0.8,0.9l-1.3-0.6l-1.3,0.2l-0.5,0.1l0,0.1l-0.3,0.7l-1.5-4.1l1.1-0.1
		l1.1-0.1l-0.1-0.6L397,238.6z	"
          >
            <title id="t50">Autauga, AL</title>
          </path>
          <path
            id="FIPS_01051"
            className="FIPS_33860 st0 state-al"
            d="M401.3,237.5l1.3-0.1l0,0l0,0.2l-0.1,0.4l0.3,2.7l0,0.1l0,0l-1.4,1.1l-0.3,0.2l-0.7-0.1
		l-0.9-0.2l0-0.1l-0.5-0.6l-0.1-0.1l-0.2-0.1l-0.1,0l-1.5,1.3l-0.4-3.8l0.3-0.6L401.3,237.5z	"
          >
            <title id="t49">Elmore, AL</title>
          </path>
          <path
            id="FIPS_01085"
            className="FIPS_33860 st0 state-al"
            d="M393.1,243.7l0.3-0.7l0-0.1l0.5-0.1l1.3-0.2l1.3,0.6l1.4,3.7l-0.3,1.2l-4.4,0.5l-0.6-1.1
		L393.1,243.7z	"
          >
            <title id="t47">Lowndes, AL</title>
          </path>
          <path
            id="FIPS_01101"
            className="FIPS_33860 st0 state-al"
            d="M397.4,242.4l1.5-1.3l0.1,0l0.2,0.1l0.1,0.1l0.5,0.6l0,0.1l0.9,0.2l0.7,0.1l0.3-0.2l1.3,1.8
		l-0.5,3l-2,1.3l-1.2,0.1l-0.1-1.1l-1.1,0.1l-1.4-3.7L397.4,242.4z	"
          >
            <title id="t48">Montgomery, AL</title>
          </path>
        </g>
        <path
          id="FIPS_01047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.4,238.9l1.2,0.7l1.5,4.1l-0.6,3.9l-2.9,0.3l-1.7-1.6l-1.3-0.9l-0.1,0l-0.3,0.1l-0.1-0.6
		l0.6-0.1l-0.2-2.2l1.9-0.2l1.5-0.2l0.1-0.2l0.3-1l0.2-0.8L390.4,238.9z	"
        >
          <title id="t51">Dallas, AL</title>
        </path>
        <path
          id="FIPS_01091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.1,242.4l0.9-0.1l0.1,0.6l2.2-0.2l0.8,2.2l0.1,0.6l-0.2,0l-0.2,0l-0.1,0l-0.1,0.2l-1,1.7
		l0.1,1.6l-0.5,0.2l-4.4,0.4l-0.3,0l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.5l0.8-3.1l0.1-0.2l0.3-0.2l0.5-0.1l-0.5-0.4l-0.8-0.3l0-0.1
		l0-0.5l0.1-0.2l1.2-1.2l0.1-0.1l0.5-0.2L382.1,242.4z	"
        >
          <title id="t52">Marengo, AL</title>
        </path>
        <path
          id="FIPS_01119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.9,236.8l1.8-0.2l-0.1,1.1l0.2,0.9l1.3,2.7l0.3,0.3l0,0l0.5-0.1l0.4-0.2l0.1-0.1l0.2-0.1
		l0.2-0.1l0.1,0l0.1,0.1l0.7,1.1l-0.5,0.2l-0.1,0.1l-1.2,1.2l-0.1,0.2l0,0.5l0,0.1l0.8,0.3l0.5,0.4l-5.3,0.5l0.1-3.5l0.1-4.6
		L375.9,236.8z	"
        >
          <title id="t53">Sumter, AL</title>
        </path>
        <path
          id="FIPS_01105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.9,237.5l1.1-0.1l0.1,0.6l0.7-0.1l2.5-0.3l0.1,1.4l-0.2,1.2l-0.2,0.8l-0.3,1l-0.1,0.2
		l-1.5,0.2l-1.9,0.2l0.2,2.2l-0.6,0.1l-0.8-2.2l-0.2-2.2l0.4-1.7L385.9,237.5z	"
        >
          <title id="t54">Perry, AL</title>
        </path>

        <path
          id="FIPS_01037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M399,233.2h1.8l0.5,4.3l-4,0.4l-1.8-3.3l0.2-1.1L399,233.2z	"
        >
          <title id="t56">Coosa, AL</title>
        </path>
        <path
          id="FIPS_01123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.6,232.6l0.6-0.1l0.5,4.9l-0.9,1.8l-0.6,0.3l-0.3,1.2l-1,0.1l0,0l0-0.1l-0.3-2.7l0.1-0.4
		l0-0.2l0,0l-1.3,0.1l-0.5-4.3L404.6,232.6z	"
        >
          <title id="t57">Tallapoosa, AL</title>
        </path>
        <path
          id="FIPS_01027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.9,227.8l-0.4,0.3l0,0.1l1.1-0.1l0.2-0.2l0-0.2l1.3-0.1l0.4,5l-3.8,0.6H399l-0.1-1.2
		l0.9-1.4l1.1-1.2l0.5-1.6L401.9,227.8z	"
        >
          <title id="t58">Clay, AL</title>
        </path>
        <path
          id="FIPS_01121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.5,225.8l1,0l0.3,0.3l0.1,0.5l0.3,0.3l2.1-0.2l0,0.4l-0.5,0.8l-0.6,0.1l-0.5,1.6l-1.1,1.2
		l-0.9,1.4l0.1,1.2l-3.4,0.4l0-0.8l1.2-1.8l0.1-0.8l-0.1-0.2l-0.3-0.2l1.1-1.4l0.4-1l0-0.1l-0.1-0.2l0-0.1l0.5-1.1L398.5,225.8z	"
        >
          <title id="t59">Talladega, AL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "13820"
              ? `metroArea clickedArea state-al`
              : `metroArea ${colorCode[13820]} state-al`
          }
          id="FIPS_13820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_01007"
            className="FIPS_13820 st0 state-al"
            d="M389.3,232.3l0.4,0l1.8,2.4l0.1,0.8l0.2,1.9l-1.5,0.1l-2.5,0.3l-0.7,0.1l-0.1-0.6l-1.1,0.1
		l-0.2-1.7l1.1-0.1l0-1.1l0.3-0.5l0.8-0.9l0.5-0.5l0.1-0.1l0.7-0.2L389.3,232.3z	"
          >
            <title id="t61">Bibb, AL</title>
          </path>
          <path
            id="FIPS_01009"
            className="FIPS_13820 st0 state-al"
            d="M394.5,218.6l1.8,1.9l-0.2,0.4l-0.3,1.8l0.5-0.1l-0.4,1l-0.3,0.4l-0.3,0.3h-0.1l-0.1-0.1
		l-1.4,0.4l0,0.5L393,225l-1.2-0.7l-1.3,0.1l-0.7,0.4l-0.2-0.5l0.4-0.5l0.8-0.8l1-0.8l1.4-1.8l0.1-0.1l0.6-1.5l0,0l0.3-0.1
		L394.5,218.6z	"
          >
            <title id="t74">Blount, AL</title>
          </path>
          <path
            id="FIPS_01021"
            className="FIPS_13820 st0 state-al"
            d="M395.4,234.7l1.8,3.3l-0.3,0.6l-3.2,0.3l0.1,0.6l-1.1,0.1l-1.1,0.1l-1.2-0.7l-0.1-1.4l1.5-0.1
		l-0.2-1.9l-0.1-0.8l0-0.3l1.7-0.1l1.2-0.1l0.2,0.2l0.3,0.2L395.4,234.7z	"
          >
            <title id="t55">Chilton, AL</title>
          </path>
          <path
            id="FIPS_01073"
            className="FIPS_13820 st0 state-al"
            d="M389.8,224.9l0.7-0.4l1.3-0.1l1.2,0.7l0.8,0.1l0.4,0l0.2,0.5l0.1,0.8l-0.1,0.3l-0.1,0
		l-0.1,0.2l0.1,0.7l0.1,0.1l0.3,0.1l0,0.3l-0.9,0.8l-0.7,0.1l-2,2l-0.4,0.7l-0.2,0.2l-0.3,0.2l-0.5,0.2l-0.4,0l-0.5-0.5l-1-0.6
		l-0.4-0.4l-0.7-0.8l-0.2-0.6l0.4-0.3l0.2-0.1l0.3-0.2l1.2-1.3l0.2-0.4l0.2-0.4l0.7-1.4L389.8,224.9z	"
          >
            <title id="t66">Jefferson, AL</title>
          </path>
          <path
            id="FIPS_01115"
            className="FIPS_13820 st0 state-al"
            d="M396.3,222.6L396.3,222.6l0.1-0.2l0.2-0.4l0.1-0.1l0.8-0.1l0.1,0.1l0.1,0.1l0.2,0.5l0.3,0.3
		l0.1,0.1l0.2-0.1l0.6,0.7l0.1,0.1l0,0.1l0,0.8l-0.8,0.7l0,0.1l0,0.3l-0.2,0.1l-0.5,1.1l0,0.1l0.1,0.2l0,0.1l-0.4,1l-1.1,1.4
		l-1.7-1.8l-0.3-0.1l-0.1-0.1l-0.1-0.7l0.1-0.2l0.1,0l0.1-0.3l-0.1-0.8l-0.2-0.5l-0.4,0l0-0.5l1.4-0.4l0.1,0.1h0.1l0.3-0.3l0.3-0.4
		L396.3,222.6z	"
          >
            <title id="t75">St. Clair, AL</title>
          </path>
          <path
            id="FIPS_01117"
            className="FIPS_13820 st0 state-al"
            d="M394.8,227.9l1.7,1.8l0.3,0.2l0.1,0.2l-0.1,0.8l-1.2,1.8l0,0.8l-0.2,1.1l-0.5,0l-0.3-0.2
		l-0.2-0.2l-1.2,0.1l-1.7,0.1l0,0.3l-1.8-2.4l0.5-0.2l0.3-0.2l0.2-0.2l0.4-0.7l2-2l0.7-0.1l0.9-0.8L394.8,227.9z	"
          >
            <title id="t60">Shelby, AL</title>
          </path>
          <path
            id="FIPS_01127"
            className="FIPS_13820 st0 state-al"
            d="M387.5,222.8l2.1,1.6l0.2,0.5l-0.1,0.4l-0.7,1.4l-0.2,0.4l-0.2,0.4l-1.2,1.3l-0.3,0.2
		l-0.2,0.1l-0.5,0l-0.1-0.9l-0.9-0.1l-0.2,0l-0.1-1.1l-1.1,0.1l-0.2-2.3l-1.1,0l0-0.6l-0.1-1.1L387.5,222.8z	"
          >
            <title id="t67">Walker, AL</title>
          </path>
        </g>
        <path
          id="FIPS_01065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.6,236l3.2-0.2l0.2,1.7l-0.4,1.2l-0.4,1.7l0.2,2.2l-2.2,0.2l-0.1-0.6l-0.9,0.1l0.6-1.2
		l-0.5-0.6l-0.4-1.3l-0.2-1l0-0.3L382.6,236z	"
        >
          <title id="t62">Hale, AL</title>
        </path>
        <path
          id="FIPS_01063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M381.1,234.3l1.5,1.8l-1.1,1.9l0,0.3l0.2,1l0.4,1.3l0.5,0.6l-0.6,1.2l-0.5-0.1l-0.7-1.1
		l-0.1-0.1l-0.1,0l-0.2,0.1l-0.2,0.1l-0.1,0.1l-0.4,0.2l-0.5,0.1l0,0l-0.3-0.3l-1.3-2.7l-0.2-0.9l0.1-1.1l0-0.1l0.9-0.6l0.8-0.5
		l0.4-0.1L381.1,234.3z	"
        >
          <title id="t63">Greene, AL</title>
        </path>
        <path
          id="FIPS_01107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.7,229.5l0.4,4.8l-1.3,1.1l-0.4,0.1l-0.8,0.5l-0.9,0.6l0,0.1l-1.8,0.2l0.1-3.9l0.1-3.2
		l3.5-0.2L380.7,229.5z	"
        >
          <title id="t64">Pickens, AL</title>
        </path>
        <path
          id="FIPS_01125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385,228.1l0.2,0l0.9,0.1l0.1,0.9l0.5,0l-0.4,0.3l0.2,0.6l0.7,0.8l0.4,0.4l1,0.6l0.5,0.5
		l-0.1,0l-0.7,0.2l-0.1,0.1l-0.5,0.5l-0.8,0.9l-0.3,0.5l0,1.1l-1.1,0.1l-3.2,0.2l-1.5-1.8l-0.4-4.8l1.1,0l0.8-0.1l-0.1-0.7l0.3-0.5
		L385,228.1z	"
        >
          <title id="t65">Tuscaloosa, AL</title>
        </path>

        <path
          id="FIPS_01075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.2,222.9l2.3-0.1l0.4,0.4l0.2,2.1l0.3,3.1l0.1,1.2l-3.5,0.2l0.1-2.7L376.2,222.9z	"
        >
          <title id="t68">Lamar, AL</title>
        </path>
        <path
          id="FIPS_01057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M379.1,224.5l3.4-0.2l0,0.6l1.1,0l0.2,2.3l1.1-0.1l0.1,1.1l-2.2,0.1l-0.3,0.5l0.1,0.7
		l-0.8,0.1l-1.1,0l-1.1,0.1l-0.1-1.2l-0.3-3.1L379.1,224.5z	"
        >
          <title id="t69">Fayette, AL</title>
        </path>
        <path
          id="FIPS_01059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.4,216.1l6.4-0.4l0.3,3.4l-1.1,0.1l-0.9,0l-2.3,0.2l-2.5,0.1l0-1.9L376.4,216.1z	"
        >
          <title id="t70">Franklin, AL</title>
        </path>
        <path
          id="FIPS_01093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.3,219.5l2.5-0.1l2.3-0.2l0.9,0l0.3,3.9l0.1,1.1l-3.4,0.2l-0.1-1.3l-0.4-0.4l-2.3,0.1
		l0-0.4L376.3,219.5z	"
        >
          <title id="t71">Marion, AL</title>
        </path>
        <path
          id="FIPS_01133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.1,219.1l4.4-0.3l-0.1,4l-5.2,0.4l-0.3-3.9L383.1,219.1z	"
        >
          <title id="t72">Winston, AL</title>
        </path>
        <path
          id="FIPS_01043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387.5,218.6l5.6-0.4l1.4,0.4l-0.3,0l-0.3,0.1l0,0l-0.6,1.5l-0.1,0.1l-1.4,1.8l-1,0.8
		l-0.8,0.8l-0.4,0.5l-2.1-1.6l0.1-4L387.5,218.6z	"
        >
          <title id="t73">Cullman, AL</title>
        </path>

        <path
          id="FIPS_01015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.5,221.6l2.2,0.1l-1,1l0.1,1.3l0.2,1.6l-0.2,0.3l-0.8,1l-0.6,0.1l0-0.4l-2.1,0.2l-0.3-0.3
		l-0.1-0.5l-0.3-0.3l-1,0l0-0.3l0-0.1l0.8-0.7l0-0.8l0-0.1l-0.1-0.1l0.2,0l0.3-0.2l0.3-0.2l0.6-0.6l0.3-0.5l0.2-0.1l0.6-0.1l0.9,0.1
		L402.5,221.6z	"
        >
          <title id="t76">Calhoun, AL</title>
        </path>
        <path
          id="FIPS_01055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.3,219l2.8-0.3l0.1,1.1l0.5,0l0.8,1.4l0,0.3l0,0.4l-0.9-0.1L401,222l-0.2,0.1l-0.3,0.5
		l-0.6,0.6l-0.3,0.2l-0.3,0.2l-0.2,0l-0.6-0.7l-0.2,0.1l-0.1-0.1l-0.3-0.3l-0.2-0.5l-0.1-0.1l-0.1-0.1l-0.8,0.1l-0.1,0.1l-0.2,0.4
		l-0.1,0.1l0,0l-0.5,0.1l0.3-1.8l0.2-0.4L398.3,219z	"
        >
          <title id="t77">Etowah, AL</title>
        </path>
        <path
          id="FIPS_01095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.4,214.1l1.9-0.2l0.1,0.7l1,0.7l-0.1,3.6l-2,1.5l-1.8-1.9l-1.4-0.4l0-3.1l0.2,0.5l0.4,0.2
		l0.4,0.1l0.4-0.1l1-0.5l0.1-0.4l0.1-0.5l-0.1-0.2l-0.1-0.1L395.4,214.1z	"
        >
          <title id="t78">Marshall, AL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19460"
              ? `metroArea clickedArea state-al`
              : `metroArea ${colorCode[19460]} state-al`
          }
          id="FIPS_19460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_01103"
            className="FIPS_19460 st0 state-al"
            d="M390.6,215.2l2.5-0.2l0,3.1l-5.6,0.4l-0.4-4.8L390.6,215.2z	"
          >
            <title id="t79">Morgan, AL</title>
          </path>
          <path
            id="FIPS_01079"
            className="FIPS_19460 st0 state-al"
            d="M383.6,212.6l1.8,0.4l1.7,0.8l0.4,4.8l0,0.2l-4.4,0.3l-0.3-3.4L383.6,212.6z	"
          >
            <title id="t80">Lawrence, AL</title>
          </path>
        </g>
        <path
          id="FIPS_01033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.5,212l0.4-0.2l0.2,0l0.7,0.2l0.2,0.2l0.2,0.2l0.1,0.1l0.1,0.3l0.1,0.2l0.8,0.7l0.1,0
		l0.3,0.1l0.5-0.1l0.3-0.2l0.1-0.1l0.2-0.3l1.2-0.7l0.4-0.2l0.2-0.1l0.1,0l1,0.3l-0.8,3.1l-6.4,0.4L376.5,212z	"
        >
          <title id="t81">Colbert, AL</title>
        </path>
        <path
          id="FIPS_01077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.5,209.9l0.1,0l-0.2,3.2l-1.8-0.4l-1-0.3l-0.1,0l-0.2,0.1l-0.4,0.2l-1.2,0.7l-0.2,0.3
		l-0.1,0.1l-0.3,0.2l-0.5,0.1l-0.3-0.1l-0.1,0l-0.8-0.7l-0.1-0.2l-0.1-0.3l-0.1-0.1l-0.2-0.2l-0.2-0.2l-0.7-0.2l-0.2,0l-0.4,0.2
		l-1.2-1.2l2.2-0.3l4-0.3L385.5,209.9z	"
        >
          <title id="t82">Lauderdale, AL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "26620"
              ? `metroArea clickedArea state-al`
              : `metroArea ${colorCode[26620]} state-al`
          }
          id="FIPS_26620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_01083"
            className="FIPS_26620 st0 state-al"
            d="M389.6,209.6l0.5-0.1l0.5,5.7l-3.5-1.4l-1.7-0.8l0.2-3.2L389.6,209.6z	"
          >
            <title id="t83">Limestone, AL</title>
          </path>
          <path
            id="FIPS_01089"
            className="FIPS_26620 st0 state-al"
            d="M395,209l0.2,0.6l-0.3,1.5l-0.1,1.3l0.1,1.3l0.4,0.4l0.1,0l0.1,0.1l0.1,0.2l-0.1,0.5l-0.1,0.4
		l-1,0.5l-0.4,0.1l-0.4-0.1l-0.4-0.2l-0.2-0.5l-2.5,0.2l-0.5-5.7L395,209L395,209z	"
          >
            <title id="t84">Madison, AL</title>
          </path>
        </g>
        <path
          id="FIPS_01071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.4,208.3l0.4,1.6l-0.7,1.4l-1.1,1.8l-1.8,1.9l-0.3,0.2l-0.2,0.1l-0.3,0l-1-0.7l-0.1-0.7
		l-1.9,0.2l-0.4-0.4l-0.1-1.3l0.1-1.3l0.3-1.5l-0.2-0.6l4.7-0.5L402.4,208.3z	"
        >
          <title id="t85">Jackson, AL</title>
        </path>
        <path
          id="FIPS_01049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.8,209.9l0.8,3l0.1,0.4l0.2,0.8l-0.1,0l0,0l-0.5,0.6l-0.1,0.7l-0.3,0.7l-1.4,1.7l-0.4,0
		l-0.3,0.2l-0.1,0.1l0,0.4l-2.8,0.3l0.1-3.6l0.3,0l0.2-0.1l0.3-0.2l1.8-1.9l1.1-1.8L402.8,209.9z	"
        >
          <title id="t86">DeKalb, AL</title>
        </path>
        <path
          id="FIPS_01019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404,214.2l0.9,3l0.7,2.6l0.4,1.5l-1.4,0.4l-2.2-0.1l0-0.3l-0.8-1.4l-0.5,0l-0.1-1.1l0-0.4
		l0.1-0.1l0.3-0.2l0.4,0l1.4-1.7l0.3-0.7l0.1-0.7l0.5-0.6L404,214.2L404,214.2z	"
        >
          <title id="t87">Cherokee, AL</title>
        </path>
        <path
          id="FIPS_01029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.1,221.2l0.2,0.8l0.9,3.1l0.6,2.1l-3.6,0.2l-1.3,0.1l0,0.2l-0.2,0.2l-1.1,0.1l0-0.1
		l0.4-0.3l0.5-0.8l0.6-0.1l0.8-1l0.2-0.3l-0.2-1.6l-0.1-1.3l1-1L406.1,221.2z	"
        >
          <title id="t88">Cleburne, AL</title>
        </path>
        <path
          id="FIPS_01111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.1,227.6l3.6-0.2l0.2,0.7l1,3.8l0.1,0.3l-3.9,0.4l-0.6,0.1L404.1,227.6z	"
        >
          <title id="t89">Randolph, AL</title>
        </path>
        <path
          id="FIPS_01017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.1,232.1l0.9,3l0.7,1.5l-1.2,0.2l-0.4,0.2l-3.3,0.4l-0.5-4.9L409.1,232.1z	"
        >
          <title id="t90">Chambers, AL</title>
        </path>
        <path
          id="FIPS_01081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.8,237.4l3.3-0.4l0.4-0.2l1.2-0.2l0.8,1.7l1,1.1l-0.6,0.6l-1.9,0.5l-0.9,0.6l-1.1,0.1
		l-0.2-1.1l-0.5,0.1l-2.3-0.8l0-0.2L405.8,237.4z	"
        >
          <title id="t91">Lee, AL</title>
        </path>
        <path
          id="FIPS_01113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.7,241.2l-0.1,0.5l0,0.1l0.1,0.1l0.7,0.2l0.3,0.2l0.1,0.2l-0.1,0.4l0,0l-1.2,2.3l-1.4,0.2
		l-0.1,0l-0.4-0.5l0-0.1l-0.3-0.4l-1.6,0.2l-0.4-1.1l-0.3-2.2l1.1-0.1l0.9-0.6l1.9-0.5l0.6-0.6L412.7,241.2z	"
        >
          <title id="t92">Russell, AL</title>
        </path>
        <path
          id="FIPS_01005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.5,245.3l0,1L412,249l0.2,0.3l-0.1-0.1l-0.2-0.1h-0.1l-0.1,0l-0.3,0.4l-0.2,0.5l-0.1,0.1
		l-2.2,0.2l0.1,1.1l-3.6,0.4l0.6-3.5l0-0.1l0.1-0.3l0.5-1l0.9-0.3l0.9-0.3l-0.1-0.5l-0.1-1.1l0.2-0.1l1.6-0.2l0.3,0.4l0,0.1l0.4,0.5
		l0.1,0L412.5,245.3z	"
        >
          <title id="t93">Barbour, AL</title>
        </path>
        <path
          id="FIPS_05017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.5,231.5l0.1,0.4l0,0l0.5,0.4l0.4,0.3l0.1,0.3l-0.1,0.3l-0.6,0.2l0.5,1.5l0.4,0.7l0.3,0.3
		l0,1v0l-0.3,1.4l0,0l-0.3,0.4l-0.1,0.1l-1.1,0l-1.8,0.1l-0.3,0l-0.2-5l-0.1-2.3l1.1-0.1l0.1,0.4l0.3,0.2l0.8,0L344.5,231.5z	"
        >
          <title id="t94">Chicot, AR</title>
        </path>
        <path
          id="FIPS_05003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.5,233.9l5.7-0.1l0.2,5l-6.5,0.3l-0.8-2l0.3-0.6l0.4-0.5l0.5-0.4l0.2-0.1l0.3-0.3l0.1-1
		L336.5,233.9z	"
        >
          <title id="t95">Ashley, AR</title>
        </path>
        <path
          id="FIPS_05115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.7,204.1l0,1.7l-0.4,0.5l0,1.1l-0.3,3.8l-1.3,0.1l-2.7-1.9l-0.2-0.1l0-1.9l0.2,0l0.6-0.6
		l0.5-1.1l0-1.7l2.2,0L326.7,204.1z	"
        >
          <title id="t96">Pope, AR</title>
        </path>
        <path
          id="FIPS_05101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.1,199.1l0.1,5.1l-2.2,0l-3.7-0.3l-0.1-0.8l0-0.8l0.2-0.6l0.3-0.6l-0.2-2l1.9,0
		L325.1,199.1z	"
        >
          <title id="t97">Newton, AR</title>
        </path>

        <path
          id="FIPS_05047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.2,204l2.2-0.2l0,5.1l-3.3,2.2l-0.5-3l0.2-0.1l0.2-0.6l0.1-0.7l0-1.4l1.1-0.9l0.2-0.2
		l0-0.2L315.2,204z	"
        >
          <title id="t99">Franklin, AR</title>
        </path>
        <path
          id="FIPS_05071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.4,203.8l1.8,0l3.7,0.3l0,1.7l-0.5,1.1l-0.6,0.6l-0.2,0l0,1.9l-1.9-1.1l-0.4,0.2l-0.8,0.3
		l-1.2,0.1L317.4,203.8z	"
        >
          <title id="t100">Johnson, AR</title>
        </path>
        <path
          id="FIPS_05083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.4,208.9l1.2-0.1l0.8-0.3l0.4-0.2l1.9,1.1l0.2,0.1l0,1.4l-2.1,0.5l-1.9,0.5l-0.5,0.2v1.1
		l0.1,0.3l-2.2,0l-1.7,0l-0.7-0.4v-0.6l0-0.6l1.1,0l0-0.9L317.4,208.9z	"
        >
          <title id="t101">Logan, AR</title>
        </path>
        <path
          id="FIPS_05149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M322,209.6l2.7,1.9l1.3-0.1l-1.5,1.3l-0.8,0.8l-0.8,0.8l-0.4,0.4l-0.5,0.7l0,1.3l-1.1,0.4
		l-3.3,0.1l0-3.6l-0.1-0.3V212l0.5-0.2l1.9-0.5l2.1-0.5L322,209.6z	"
        >
          <title id="t102">Yell, AR</title>
        </path>

        <path
          id="FIPS_05029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.4,207.5l3.9,0l0,1.1l-0.6,3.3l-0.5,0.4l-0.1,0l-0.2,0l-0.9,0.1l-3.4,0l1.5-1.3
		L326.4,207.5z	"
        >
          <title id="t104">Conway, AR</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "30780"
              ? `metroArea clickedArea state-ar`
              : `metroArea ${colorCode[30780]} state-ar`
          }
          id="FIPS_30780"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_05045"
            className="FIPS_30780 st0 state-ar"
            d="M334.1,208.6l0.1,3.8l0,0.7l-1.1,0l-0.3,1.1l-2.1,0l-0.8-0.2l-0.2-0.1l-0.1-0.1l-0.1-0.1
		l-0.1-0.2l0-0.2l0-0.2l0.1-0.1l0.2-0.1l0.1-0.1l0.1-0.1l0-0.1l0-0.3l0-0.1l-0.1-0.3l0-0.1l0.6-3.3l2.4,0L334.1,208.6z	"
          >
            <title id="t105">Faulkner, AR</title>
          </path>
          <path
            id="FIPS_05053"
            className="FIPS_30780 st0 state-ar"
            d="M333.6,219.9l0.1,3.4l-0.2,0.8l0,1.4l-1.1,0.1l-1-0.8l-0.7-0.2h-1.9l0-3.4l0.5-0.1l0.7-0.5
		l1.6-0.6l1.7,0L333.6,219.9z	"
          >
            <title id="t146">Grant, AR</title>
          </path>
          <path
            id="FIPS_05085"
            className="FIPS_30780 st0 state-ar"
            d="M334.2,212.4l1.4,0l0.5,0.2l1.5,0.1l0,1.4l1.2,0l0.8,3.8l0.1,0.8l0,0.2l-0.4,0.9h-0.3
		l-3.4,0.1l-0.1-1.7l-0.6-1.4l-0.1-3.6l-0.5,0L334.2,212.4z	"
          >
            <title id="t140">Lonoke, AR</title>
          </path>
          <path
            id="FIPS_05105"
            className="FIPS_30780 st0 state-ar"
            d="M324.5,212.6l3.4,0l0.9-0.1l0.2,0l0.1,0l0.5-0.4l0,0.1l0.1,0.3l0,0.1l0,0.3l0,0.1l-0.1,0.1
		l-0.1,0.1l-0.2,0.1l-0.1,0.1l0,0.2l0,0.2l0.1,0.2l0.1,0.1l0.1,0.1l0.2,0.1l-0.3,0.2l-0.8,0.2l-1.1,0.2l0,0.7l0.2,0l-0.1,0.2
		l-0.8-0.2h-1.5l-1.1,0l0,1.1l-2.2,0.1l0-1.3l0.5-0.7l0.4-0.4l0.8-0.8L324.5,212.6z	"
          >
            <title id="t103">Perry, AR</title>
          </path>
          <path
            id="FIPS_05125"
            className="FIPS_30780 st0 state-ar"
            d="M327.8,215.4l0.9,0.7l1.1,1.1l1.5,1.1l1.7,0.5l0.1,1.1l-1.7,0l-1.6,0.6l-0.7,0.5l-0.5,0.1
		l-1.4-1.1l0-0.8l-0.2-0.4l-1.1-0.6l-0.7-0.6l0-1.1l-1.1,0l0-1.1l1.1,0h1.5l0.8,0.2L327.8,215.4z	"
          >
            <title id="t138">Saline, AR</title>
          </path>
          <path
            id="FIPS_05119"
            className="FIPS_30780 st0 state-ar"
            d="M334.2,213.1l0.5,0l0.1,3.6l0.6,1.4l0.1,1.7l-1.9,0l-0.4,0l-0.1-1.1l-1.7-0.5l-1.5-1.1
		l-1.1-1.1l-0.9-0.7l-0.2,0l0-0.7l1.1-0.2l0.8-0.2l0.3-0.2l0.8,0.2l2.1,0l0.3-1.1L334.2,213.1z	"
          >
            <title id="t139">Pulaski, AR</title>
          </path>
        </g>
        <path
          id="FIPS_05141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.7,203.1l1.9,0.9l0.1,4.5l-2.4,0l0-1.1l-3.9,0l0-1.1l0.4-0.5l0-1.7l1.9,0l0-0.9
		L330.7,203.1z	"
        >
          <title id="t106">Van Buren, AR</title>
        </path>
        <path
          id="FIPS_05129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.1,199.1l0.6,0l0.6,0.6l4.4-0.1l0,1.1l0.1,2.4l-2.2,0.1l0,0.9l-1.9,0l-1.5,0L325.1,199.1z
			"
        >
          <title id="t107">Searcy, AR</title>
        </path>
        <path
          id="FIPS_05137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M332.8,198.6l1.2,0.9l0.1,0l0.2,0.2l0,0.1l-0.3,0.8l2,1l0.5,0.2l0.2,2.1l-4.2,0.1l-1.9-0.9
		l-0.1-2.4l1.1,0l1.1-1.2L332.8,198.6z	"
        >
          <title id="t108">Stone, AR</title>
        </path>
        <path
          id="FIPS_05023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.8,204l0.5,2.2l0,1l-0.5,1.3l-2.7,0.1l-1.5,0l-0.1-4.5L336.8,204z	"
        >
          <title id="t109">Cleburne, AR</title>
        </path>
        <path
          id="FIPS_05145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.3,206.2l2.2-0.1l2.5,1.1l-0.8,1l0,0.8l0,0.1l0.3,0.4l-0.2,2l-0.2,0.3l-3.5,0.9l-1.5-0.1
		l-0.5-0.2l-1.4,0l-0.1-3.8l2.7-0.1l0.5-1.3L337.3,206.2z	"
        >
          <title id="t110">White, AR</title>
        </path>
        <path
          id="FIPS_05063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M341.6,201.4l1.6-0.1l-0.1,0.2l-0.1,0.3l-0.3,0.7l-0.9,1.9l-0.2,1.7l-1.4,0l-0.8,0l-2.2,0.1
		l-0.5-2.2l-0.2-2.1l1.4-1l2.6-0.1l0,0.6L341.6,201.4z	"
        >
          <title id="t111">Independence, AR</title>
        </path>
        <path
          id="FIPS_05067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.3,201.3l1.7,0l0.1,2.3l0.2,3.4l0.1,1.1l-2.2,0.1l-0.1-1.1l-1,0.1l0,0.1l-2.5-1.1l0.8,0
		l1.4,0l0.2-1.7l0.9-1.9l0.3-0.7l0.1-0.3L343.3,201.3z	"
        >
          <title id="t112">Jackson, AR</title>
        </path>
        <path
          id="FIPS_05147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342,207.2L342,207.2l1-0.1l0.1,1.1l2.2-0.1l0.1,2.7l-1,1.9l-0.9,0l-0.5,0.3l-0.1,0.4l0,0.5
		l-0.8,0l0-1.8l-1,0l-0.1-0.1l0-0.3l0.2-0.3l0.2-2l-0.3-0.4l0-0.1l0-0.8L342,207.2z	"
        >
          <title id="t113">Woodruff, AR</title>
        </path>
        <path
          id="FIPS_05123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.1,210.6l1.1-0.1l0.1,1.9l0,1.3l-5.6,0.3l-1.1,0l-0.6,0l0,0.6l-0.6-1.7l1-1.9L351.1,210.6
		z	"
        >
          <title id="t114">St. Francis, AR</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "32820"
              ? `metroArea clickedArea state-tn state-ms state-ar`
              : `metroArea ${colorCode[32820]} state-tn state-ms state-ar`
          }
          id="FIPS_32820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_05035"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M354.5,206.5l0.7,0.7l0,0.1l0.4,3l0,0v0l0,0l0,0l-0.2,0.2l-1.1,0.8l-1,0.3l-0.1,0.4l0,0.2
		l0.3,1.7l-1.2,0.4l-0.1-0.9l0-1.3l-0.1-1.9l-1.1,0.1l-0.2-3.9l2.2-0.1L354.5,206.5z	"
          >
            <title id="t115">Crittenden, AR</title>
          </path>
          <path
            id="FIPS_28093"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M360.2,211.9l3.1-0.2l0.3,1.3l0.4,0.6l0.3,3.4l0.6,0l0.1,1.1l-1.1-0.3l-1.4-0.3l-0.9,0
		l-1.1,0.1l-0.1-1.6l-0.6-0.1l-0.1-1.1l-0.2-2.9L360.2,211.9z	"
          >
            <title id="t1545">Marshall, MS</title>
          </path>
          <path
            id="FIPS_28033"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M359.3,212l0.2,2.9l-2,0.1l-2,0.6l-1,0.2l-1.1-1.7l-0.3-1.7L359.3,212z	"
          >
            <title id="t1546">DeSoto, MS</title>
          </path>
          <path
            id="FIPS_28137"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M354.6,215.8l1-0.2l2-0.6l2-0.1l0.1,1.1l0.6,0.1l0.1,1.6l-0.6,0l-5,0.3L354.6,215.8z	"
          >
            <title id="t1525">Tate, MS</title>
          </path>
          <path
            id="FIPS_28143"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M353.5,214.1l1.1,1.7l0.2,2.2l0,0.6l-1.1,0.1l0.1,1.1l-1,0.1l-1.9-1.2l-0.1-1.5l1.6-2.6
		L353.5,214.1z	"
          >
            <title id="t1547">Tunica, MS</title>
          </path>
          <path
            id="FIPS_47047"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M361.6,206.5l3-0.1l0.2,5.2l-1.6,0.1l-3.1,0.2l-0.1-1.7l-0.1-1.7l0-1.5L361.6,206.5z	"
          >
            <title id="t2430">Fayette, TN</title>
          </path>
          <path
            id="FIPS_47167"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M361.1,204.2l0.5,2.3L360,207l-0.2-0.1l-0.5-0.2l-0.1,0l-3.5,0.4l-0.5,0.2l-0.7-0.7l2.4-1.5
		l0.2-0.4l0.2-0.2l0.5-0.5l0.2-0.2l0.3-0.1l1.4-0.1l0.8,0.4L361.1,204.2z	"
          >
            <title id="t2441">Tipton, TN</title>
          </path>
          <path
            id="FIPS_47157"
            className="FIPS_32820 st0 state-tn state-ms state-ar"
            d="M355.2,207.2l0.5-0.2l3.5-0.4l0.1,0l0.5,0.2l0.2,0.1l0,1.5l0.1,1.7l0.1,1.7l-0.8,0.1l-6.1,0.4
		l0-0.2l0.1-0.4l1-0.3l1.1-0.8l0.2-0.2l0,0l0,0v0l0,0l-0.4-3L355.2,207.2z	"
          >
            <title id="t2442">Shelby, TN</title>
          </path>
        </g>
        <path
          id="FIPS_05037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M350.9,206.7l0.2,3.9l-5.6,0.3l-0.1-2.7l-0.1-1.1l1,0l2.4-0.2l1.1-0.1L350.9,206.7z	"
        >
          <title id="t116">Cross, AR</title>
        </path>
        <path
          id="FIPS_05111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345.1,203.5l2-0.1l4.1-0.2l1.7-0.1l0.2,3.4l-2.2,0.1l-1.1,0l-1.1,0.1l-2.4,0.2l-1,0
		L345.1,203.5z	"
        >
          <title id="t117">Poinsett, AR</title>
        </path>
        <path
          id="FIPS_05093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.4,199l0.6,1.2l-0.3,0l-0.2,0l-0.2,0.1l0,0l-0.1,0.1l-0.9,1.9l-0.3,2.7l-2.4,1.5l-1.4,0.1
		l-0.2-3.4l-0.3-3.8l3.4-0.2L358.4,199z	"
        >
          <title id="t118">Mississippi, AR</title>
        </path>
        <path
          id="FIPS_05031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.6,199.4l0.3,3.8l-1.7,0.1l-4.1,0.2l-2,0.1l-0.1-2.3l1.8-1.2l4.8-0.2l0.2-0.4L352.6,199.4
		z	"
        >
          <title id="t119">Craighead, AR</title>
        </path>
        <path
          id="FIPS_05065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338,196.8l0,4.1l-1.4,1l-0.5-0.2l-2-1l0.3-0.8l0-0.1l-0.2-0.2l-0.1,0l-1.2-0.9h-0.2l0-0.5
		l0.6-0.2l0-0.9L338,196.8z	"
        >
          <title id="t120">Izard, AR</title>
        </path>
        <path
          id="FIPS_05075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.4,196.5l1.3,1.1l0.7,0.6l0.3-0.5l2.4-0.1l0.6,0l0,0.1l-0.2,0.5l-0.3,0.3l-0.1,0.1
		l-0.4,1.1l0.1,0.4l-1.8,1.2l-1.7,0l-1.6,0.1l0-1.7l-0.1-2l0-0.7l0.2-0.2L342.4,196.5z	"
        >
          <title id="t121">Lawrence, AR</title>
        </path>
        <path
          id="FIPS_05135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.8,193.5l0,0.1l0.6,0.6l0.4,0.2l0.4,0.6l0.2,0.7l0,0.8l-0.7,0.2l-0.2,0.2l0,0.7l0.1,2
		l0,1.7l-1.1,0l0-0.6l-2.6,0.1l0-4.1l1.3,0l1.1-1.5l0-1.7L340.8,193.5z	"
        >
          <title id="t122">Sharp, AR</title>
        </path>
        <path
          id="FIPS_05055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.1,196.2l0.9-0.1l3.4-0.1l0.7,0.3l0,0.4l1.3-0.1l-1.6,2.8l-0.2,0.4l-4.8,0.2l-0.1-0.4
		l0.4-1.1l0.1-0.1l0.3-0.3l0.2-0.5l0-0.1l-0.6,0L347.1,196.2z	"
        >
          <title id="t123">Greene, AR</title>
        </path>
        <path
          id="FIPS_05021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349.3,193l3.7-0.2l0.3,0l0.4,0l0.9,1.3l0.1,0.1l0.1,1l-0.1,0.3l-0.1,0.1l-1.1,1l-1.3,0.1
		l0-0.4l-0.7-0.3l-3.4,0.1l-0.9,0.1l0.1-3L349.3,193z	"
        >
          <title id="t124">Clay, AR</title>
        </path>
        <path
          id="FIPS_05121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.2,193.2l-0.1,3l0,1.5l-2.4,0.1l-0.3,0.5l-0.7-0.6l-1.3-1.1l0-0.8l-0.2-0.7l-0.4-0.6
		l-0.4-0.2l-0.6-0.6l0-0.1l2.9-0.2L347.2,193.2z	"
        >
          <title id="t125">Randolph, AR</title>
        </path>
        <path
          id="FIPS_05049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.3,193.5l0,1.7l-1.1,1.5l-1.3,0l-4.8,0.1l-0.1-3.1l0.3,0l4.6-0.2L340.3,193.5z	"
        >
          <title id="t126">Fulton, AR</title>
        </path>
        <path
          id="FIPS_05005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.2,194l3.9-0.2l0.1,3.1l0,0.9l-0.6,0.2l0,0.5h0.2l0,1l-1.1,1.2l-1.1,0l0-1.1l0-0.8
		l-0.3-0.6l-0.6-1.1l-0.5-0.6l-0.2-0.1l0-1L329.2,194z	"
        >
          <title id="t127">Baxter, AR</title>
        </path>
        <path
          id="FIPS_05089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.7,194.1l2.5-0.1l0,1.4l0,1l0.2,0.1l0.5,0.6l0.6,1.1l0.3,0.6l0,0.8l-4.4,0.1l-0.6-0.6
		l0.2-5L326.7,194.1z	"
        >
          <title id="t128">Marion, AR</title>
        </path>
        <path
          id="FIPS_05009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.9,194.1l-0.2,5l-0.6,0l-3.7,0l-0.1-4.9L325.9,194.1z	"
        >
          <title id="t129">Boone, AR</title>
        </path>
        <path
          id="FIPS_05015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.3,194.2l0.1,4.9l-1.9,0h-0.7l-0.4-0.4l-0.3-0.4l-0.1-0.2v-0.5l-0.1-0.5l-0.3-0.3l-1.6,0
		l-0.6-2.5l2.9-0.1l2.8-0.1L321.3,194.2z	"
        >
          <title id="t130">Carroll, AR</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22220"
              ? `metroArea clickedArea state-ar state-mo`
              : `metroArea ${colorCode[22220]} state-ar state-mo`
          }
          id="FIPS_22220"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_05007"
            className="FIPS_22220 st0 state-ar state-mo"
            d="M313.3,194.4l2.2,0l0.6,2.5l-0.7,0.9l-1.3,0l-1.1,0.3l-2.2,0.1l-0.5,0.9l-0.1,0.6l-1.7,0
		l-0.1-0.8l-0.6-4.4L313.3,194.4z	"
          >
            <title id="t131">Benton, AR</title>
          </path>
          <path
            id="FIPS_05087"
            className="FIPS_22220 st0 state-ar state-mo"
            d="M316,196.9l1.6,0l0.3,0.3l0.1,0.5v0.5l0.1,0.2l0.3,0.4l0.4,0.4h0.7l0.2,2l-0.3,0.6l-0.2,0.6
		l0,0.8l0.1,0.8l-1.8,0l-2.2,0.2h-0.5V203l0.1-3.4l0.5-1.9L316,196.9z	"
          >
            <title id="t98">Madison, AR</title>
          </path>
          <path
            id="FIPS_05143"
            className="FIPS_22220 st0 state-ar state-mo"
            d="M308.5,199.7l1.7,0l0.1-0.6l0.5-0.9l2.2-0.1l1.1-0.3l1.3,0l-0.5,1.9l-0.1,3.4v0.9l-1.7,0
		l-1.3,0.2l-2.5,0L308.5,199.7z	"
          >
            <title id="t132">Washington, AR</title>
          </path>
          <path
            id="FIPS_29119"
            className="FIPS_22220 st0 state-ar state-mo"
            d="M313.3,191.2l0,3.2l-5.6,0.1l0-2.2l0-1.3L313.3,191.2z	"
          >
            <title id="t1432">McDonald, MO</title>
          </path>
        </g>
        <path
          id="FIPS_05033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M314.7,204h0.7l0,0.2l-0.2,0.2l-1.1,0.9l0,1.4l-0.1,0.7l-0.2,0.6l-0.2,0.1L313,208l-0.1,0
		l-0.1,0l-0.1,0.1l0,0.1l0,0.1l0.2,0.1l0,0.1l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.7,0.3l-0.2,0.1l-0.7,0.1l-0.3-0.1l-0.2-0.3l0-0.2l0-0.2
		v0l-0.1-0.1l-0.3-0.3l-0.2-0.1l-0.1,0l0,0l-0.2,0.7l-0.5-3.1l-0.2-1.6l2.5,0l1.3-0.2L314.7,204z	"
        >
          <title id="t133">Crawford, AR</title>
        </path>
        <path
          id="FIPS_05131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.9,208.8l0.2-0.7l0,0l0.1,0l0.2,0.1l0.3,0.3l0.1,0.1v0l0,0.2l0,0.2l0.2,0.3l0.3,0.1
		l0.7-0.1l0.2-0.1l0.7-0.3l0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l-0.2-0.1l0-0.1l0-0.1l0.1-0.1l0.1,0l0.1,0l0.6,0.1l0.5,3l0,0.9l-1.1,0
		l0,0.6l-0.2,0l-0.7,0.3l-0.3,0.2v0.1l0.2,0v1.2l-0.4,0.1l-1.7,0.4l-0.2,0l0.1-5.8L309.9,208.8z	"
        >
          <title id="t134">Sebastian, AR</title>
        </path>
        <path
          id="FIPS_05127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313,212.6v0.6l0.7,0.4l1.7,0l2.2,0l0,3.6l-0.4,0l-0.9,0.5l-0.5,0.6l-0.5,0V218l-0.9-0.1
		l-3.2,0l-0.5-0.3l-1-0.1l0-2.7l0.2,0l1.7-0.4l0.4-0.1v-1.2l-0.2,0v-0.1l0.3-0.2l0.7-0.3L313,212.6z	"
        >
          <title id="t135">Scott, AR</title>
        </path>
        <path
          id="FIPS_05097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.9,217l0,4.5l0,0.7h-5.6l0-4.1l0.5,0l0.5-0.6l0.9-0.5l0.4,0L320.9,217z	"
        >
          <title id="t136">Montgomery, AR</title>
        </path>
        <path
          id="FIPS_05051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.3,216.6l1.1,0l0,1.1l0.7,0.6l1.1,0.6l0.2,0.4l0,0.8l-1.3,0l-0.3,0.8l0,0.8l-4.9,0l0-4.5
		l1.1-0.4L324.3,216.6z	"
        >
          <title id="t137">Garland, AR</title>
        </path>

        <path
          id="FIPS_05117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.5,212.7l3.5-0.9l0,0.3l0.1,0.1l1,0l0,1.8l0.1,4.5l-2.3,0.1l0,1.1l-0.3,0h-0.6l0.4-0.9
		l0-0.2l-0.1-0.8l-0.8-3.8l-1.2,0L337.5,212.7z	"
        >
          <title id="t141">Prairie, AR</title>
        </path>
        <path
          id="FIPS_05095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.1,214l0.8,0l0-0.5l0.1-0.4l0.5-0.3l0.9,0l0.6,1.7l0.1,1.7l0.6,0l0,1.1l0.1,2.3l0.6,0
		l0,0.2l0.1,1.5l-0.6,0l-0.1,0l-0.3-0.1l-0.2-0.1l-1-1l-0.7-1.1l-0.3-0.4l-0.9,0L342.1,214z	"
        >
          <title id="t142">Monroe, AR</title>
        </path>
        <path
          id="FIPS_05077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345,214.5l0-0.6l0.6,0l1.1,0l5.6-0.3l0.1,0.9l-1.6,2.6l-5,0.2l0-1.1l-0.6,0L345,214.5z	"
        >
          <title id="t143">Lee, AR</title>
        </path>
        <path
          id="FIPS_05107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M350.7,217.1l0.1,1.5l0.1,1.2l-0.1,0.2l0,0l0,0l-0.4,0.3l-0.5,0.2l-0.6,0.1l-0.6,0.1l-1,1.8
		l-0.5,1l-0.2,0.3l0,0.1l0,0l-2,0.1l0.5-2.8l0.6,0l-0.1-1.5l0-0.2l-0.6,0l-0.1-2.3L350.7,217.1z	"
        >
          <title id="t144">Phillips, AR</title>
        </path>
        <path
          id="FIPS_05069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335.4,219.8l3.4-0.1l0.1,3.2l1.3,0l0.6,0l0.1,0.1l1,1.2l0.1,0.5l-0.1,0.1l-0.1,0l-0.6,0.1
		l-0.8-0.3l-1.6-0.8l-0.2,0.9l-2.1,0.1l0,0.4l-3,0.1l0-1.4l0.2-0.8l-0.1-3.4L335.4,219.8z	"
        >
          <title id="t145">Jefferson, AR</title>
        </path>

        <path
          id="FIPS_05059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M327.4,220l1.4,1.1l0,3.4l-2.2,0l-1.1,0l-0.4-0.6l-3.5-0.8l-0.6-0.8l0-0.7l4.9,0l0-0.8
		l0.3-0.8L327.4,220z	"
        >
          <title id="t147">Hot Spring, AR</title>
        </path>
        <path
          id="FIPS_05039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.5,224.5l2.2,0h1.9l0.7,0.2l1,0.8l-1.4,0.1l0,1l0.2,0l0.4,0.3l0.2,0.4l0.7,1.3l0,0.2
		l-2.7,0l-3.3,0l-0.2-1.1l0.2-1.2L326.5,224.5z	"
        >
          <title id="t148">Dallas, AR</title>
        </path>
        <path
          id="FIPS_05025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.5,225.5l3-0.1l-0.1,3.5l0,1.1l-3.8,0.1l-0.1-1.1l0-0.2l-0.7-1.3l-0.2-0.4l-0.4-0.3
		l-0.2,0l0-1l1.4-0.1L333.5,225.5z	"
        >
          <title id="t149">Cleveland, AR</title>
        </path>
        <path
          id="FIPS_05079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M341.9,224.9l0.3,0.8l0,0.2l-0.4,0.3l-0.9,0l0,1.9l0,0.6l-4.5,0.1l0.1-3.5l0-0.4l2.1-0.1
		l0.2-0.9l1.6,0.8l0.8,0.3L341.9,224.9z	"
        >
          <title id="t150">Lincoln, AR</title>
        </path>
        <path
          id="FIPS_05001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.9,219.8h0.8l0.3,0l0-1.1l2.3-0.1l0.9,0l0.3,0.4l0.7,1.1l1,1l0.2,0.1l0.3,0.1l0.1,0
		l-0.5,2.8l-0.5,0.4l-0.2,0.2l-0.1,0.1l0,0.3l0,0.2l0.2,0.2l0.5,0.8l-0.2,0.3l-1.3-0.4l-0.6-0.4l-1-0.1l-0.3-0.8l0.1,0l0.1-0.1
		l-0.1-0.5l-1-1.2l-0.1-0.1l-0.6,0l-1.3,0L338.9,219.8z	"
        >
          <title id="t151">Arkansas, AR</title>
        </path>
        <path
          id="FIPS_05041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.3,224.1l0.5,0.4l0.1,0.3l-0.1,0.4l-2.1,1l-0.9,3.7l-0.1,0.3l0,0l0.1,0.1l0.3,0.2l0.3,0.2
		v0l0,0.1l-0.2,0.2l-0.8,0.3l-0.2,0.6l-0.8,0l-0.3-0.2l-0.1-0.4l-1.1,0.1l-1.2-2.8l0-0.6l0-1.9l0.9,0l0.4-0.3l0-0.2l1,0.1l0.6,0.4
		l1.3,0.4l0.2-0.3l-0.5-0.8l-0.2-0.2l0-0.2l0-0.3l0.1-0.1l0.2-0.2l0.5-0.4L347.3,224.1z	"
        >
          <title id="t152">Desha, AR</title>
        </path>
        <path
          id="FIPS_05043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.4,228.9l4.5-0.1l1.2,2.8l0.1,2.3l-5.7,0.1l-0.1-0.2l-0.2-0.5l0-0.1l0-0.9l0,0l0.3,0
		l-0.1-2.3L336.4,228.9z	"
        >
          <title id="t153">Drew, AR</title>
        </path>
        <path
          id="FIPS_05011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M332.6,230.1l3.8-0.1l0.1,2.3l-0.3,0l0,0l0,0.9l0,0.1l0.2,0.5l0.1,0.2l0.3,0.2l-0.1,1
		l-0.3,0.3l-0.2,0.1l-0.5,0.4l-0.4,0.5l-0.3,0.6l-0.9-0.7l-1.4-0.7l0-0.1l0-0.1l-0.3-0.2l-0.1-0.4l0-0.4l0.1-0.1l0,0l0.2-0.5
		l0.2-0.7l0.1-0.4l-0.2-1.8L332.6,230.1z	"
        >
          <title id="t154">Bradley, AR</title>
        </path>
        <path
          id="FIPS_05013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.9,229l2.7,0l0.1,1.1l0.1,0.9l0.2,1.8l-0.1,0.4l-0.2,0.7l-0.2,0.5l0,0l-0.1,0.1l0,0.4
		l0.1,0.4l0.3,0.2l-0.3,0.3l-0.5,0.1l-0.2,0l-0.3-0.3l0,0l-0.1-0.4l-0.8-0.4l-0.2,0l-1.5-0.8l-0.7-0.8l-0.1-0.2l0-0.5l0.5-1.4
		l0.1-0.1l0.7-0.1l0,0l0.3-0.5L329.9,229z	"
        >
          <title id="t155">Calhoun, AR</title>
        </path>
        <path
          id="FIPS_05103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.6,229l3.3,0l-0.3,1.3l-0.3,0.5l0,0l-0.7,0.1l-0.1,0.1l-0.5,1.4l0,0.5l0.1,0.2l0.7,0.8
		l1.5,0.8l-4.4,0l-1.5-0.9v-4.2L326.6,229z	"
        >
          <title id="t156">Ouachita, AR</title>
        </path>
        <path
          id="FIPS_05099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.4,227.2l0.8,1.1l1.7,0.7l0.2,0.1l0.3,0.3v4.2l-2.7,0.2l-1.3-0.4l0-2.6l0.1-2v-1.7
		L321.4,227.2z	"
        >
          <title id="t157">Nevada, AR</title>
        </path>
        <path
          id="FIPS_05057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.6,226.7l3.9,0.6v1.7l-0.1,2l0,2.6l-2.6,0l-1.1-1.6l-1.4-1.8l1.3,0L316.6,226.7z	"
        >
          <title id="t158">Hempstead, AR</title>
        </path>
        <path
          id="FIPS_05019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.2,222.3h0.7l0.6,0.8l3.5,0.8l0.4,0.6l1.1,0v2.2l-0.2,1.2l0.2,1.1l-2.2,0.5l-0.3-0.3
		l-0.2-0.1l-1.7-0.7l-0.8-1.1l-0.6-1.2l-0.2-0.4l-0.5-2.2L320.2,222.3z	"
        >
          <title id="t159">Clark, AR</title>
        </path>
        <path
          id="FIPS_05109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.4,222.3h4.8l0,1.1l0.5,2.2l0.2,0.4l0.6,1.2l-0.9,0l-3.9-0.6l0-2.3l-1.1,0l-0.1-1
		L315.4,222.3z	"
        >
          <title id="t160">Pike, AR</title>
        </path>
        <path
          id="FIPS_05061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.4,222.3l0,1.1l0.1,1l1.1,0l0,2.3l0,3.4l-1.3,0h0l-1.2-2.1l0-0.1l-0.2-1.4l-0.1-0.6l0-1
		l0-0.4l-0.1-0.1l-1.5,0l-0.1-1l0-1.1L315.4,222.3z	"
        >
          <title id="t161">Howard, AR</title>
        </path>
        <path
          id="FIPS_05113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.8,217.5l1,0.1l0.5,0.3l3.2,0l0.9,0.1v0.2l0,4.1l-3.4,0l0,1.1l0.1,1l-2.4,0.1L309.8,217.5
		z	"
        >
          <title id="t162">Polk, AR</title>
        </path>
        <path
          id="FIPS_05133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.1,224.4l1.5,0l0.1,0.1l0,0.4l0,1l0.1,0.6l0.2,1.4l0,0.1l1.2,2.1l-0.9,0l-2.8-0.8
		l-1.9-1.5l0-3.2L312.1,224.4z	"
        >
          <title id="t163">Sevier, AR</title>
        </path>
        <path
          id="FIPS_05081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.7,227.7l1.9,1.5l2.8,0.8l0.9,0h0l1.4,1.8l-2.3,0.8l-0.3-0.2l-0.2-0.1l-1-0.2l-0.6,0.1
		l-0.2,0l-0.1,0l-1,0.5l-0.6-0.3l-0.2-0.1l-0.4-0.3l-0.1-0.1l-0.1-0.2l-0.1-0.2L309.7,227.7z	"
        >
          <title id="t164">Little River, AR</title>
        </path>
        <path
          id="FIPS_05091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.7,231.9l1.1,1.6l-0.1,0.8l0.7,1.1v0.1l-0.2,0.6l-0.8,1.4l-0.1,0.1l-0.1,0.1l-0.1,0
		l-0.6,1.1l0.5,0.8H317l-2.5,0.1l-0.1-6.9L316.7,231.9z	"
        >
          <title id="t165">Miller, AR</title>
        </path>
        <path
          id="FIPS_05073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.9,233.5l2.6,0l1.3,0.4l-0.1,0.1l-1.1,2.3l0,3.1l-0.3,0l-3.1,0.1l-0.5-0.8l0.6-1.1l0.1,0
		l0.1-0.1l0.1-0.1l0.8-1.4l0.2-0.6v-0.1l-0.7-1.1L317.9,233.5z	"
        >
          <title id="t166">Lafayette, AR</title>
        </path>
        <path
          id="FIPS_05027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.7,233.9l2.7-0.2l1.5,0.9l0,4.7l-2.7,0.1l-2.7,0.1l0-3.1l1.1-2.3L321.7,233.9z	"
        >
          <title id="t167">Columbia, AR</title>
        </path>
        <path
          id="FIPS_05139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.9,234.6l4.4,0l0.2,0l0.8,0.4l0.1,0.4l0,0l0.3,0.3l0.2,0l0.5-0.1l0.3-0.3l0,0.1l0,0.1
		l1.4,0.7l0.9,0.7l0.8,2l-7.1,0.2l-2.8,0.1L325.9,234.6z	"
        >
          <title id="t168">Union, AR</title>
        </path>
        <path
          id="FIPS_04015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M110,170.6l11.6,2.2l3.6,0.6l-1,2.2l-0.7,1.7l0,0.1l-0.5,1.7l0,0.2v0.2l0.1,0.4l0.1,0.2
		l-0.1,0.8l-0.1,0.2l-0.3,0.4l-0.1,0.1l-0.2,0l-2.4,0.7l-0.4,0.1l-0.5,0.1l-0.1,0l-0.6,0.1l-1.1,0.4l-1.6,0.7l-0.7,1.5l-1.2,5.7
		l-2.8,15.4l-0.2,0.2l-0.1,0l-0.1,0l-3.8,0.2l-4.2-1.9L102,204l-0.6-0.6l-0.7-0.8l-0.7-2.8l0-0.5l-0.7-1.1l-0.6-1.5l0-0.1l0-0.2
		l0.3-1.4l1-1.6l0.1-0.3l0.1-0.3l0-0.3l0.1-1.6l0-0.4l-0.1-0.8l-0.1-1.6l0.1-2.3l0.3-3.7l0.1-1.3l0-0.1l0.1-0.1l0.1-0.1l1.2-0.3h0.6
		l0.6,0.1l1.3,0.4l0.1,0.1l0.3,0.4l0.1,0.3l0,0.1l0,0l0,0.1l0.1,0.2l0.2,0.4l0.1,0.1l0.1,0.1l0.1,0l0.2,0l0.6,0l0,0l0,0l0.1-0.2
		l1.3-1.8l0.4-2.3l0.2-1.3l0.4-2.3l0.1-0.3l0.4-2.1L110,170.6z	"
        >
          <title id="t169">Mohave, AZ</title>
        </path>
        <path
          id="FIPS_04012"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M102.5,204.9l4.2,1.9l3.8-0.2l0.1,0l0.1,0l0.2-0.2l-0.8,4.1l-1.5,7.9l-6.6-1.2l0.2-1.1
		l-3.3-0.6l-1.1,5.5l-1.1-0.2l-1.6-0.3l-0.9-0.2l-0.2-0.1l-0.5-0.3l-0.2-0.6l0,0l0.6-3.9l1.1-0.3l1.3-1.5l0.4-1.5l0.3-1.5l0.1-0.4
		l0.3-1l0.3-0.5l1-1.4l1.3-0.5l0.9-0.4l1.4-0.8l0,0L102.5,204.9z	"
        >
          <title id="t170">La Paz, AZ</title>
        </path>
        <path
          id="FIPS_04003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M151.7,237.6l0.7,0.1l-2,14l-4.1-0.6l-11.2-1.6l0.9-5.1l1.4-8.9l3,0.5l7.9,1.1L151.7,237.6z	"
        >
          <title id="t171">Cochise, AZ</title>
        </path>
        <path
          id="FIPS_04023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M125.4,246.7l0.2-1.2l2.2,0.4l0.4-2.6l3.3,0.5l4.4,0.7l-0.9,5.1l-5.6-0.9l-1.3-0.3
		L125.4,246.7z	"
        >
          <title id="t172">Santa Cruz, AZ</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "46060"
              ? `metroArea clickedArea state-az`
              : `metroArea ${colorCode[46060]} state-az`
          }
          id="FIPS_46060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_04019"
            className="FIPS_46060 st0 state-az"
            d="M118.7,231.5l4.4,0.7l2.4,0.5l4.1,0.7l0.4,0.1l1.7,0.2l3.4,0.5l2.5,0.4l-0.2,1.1l-1.4,8.9
		l-4.4-0.7l-3.3-0.5l-0.4,2.6l-2.2-0.4l-0.2,1.2l-0.5-0.3l-1.6-1l-13-7.5l-2.6-1.5l-2.1-1.2l1.1-5.9L118.7,231.5z	"
          >
            <title id="t173">Pima, AZ</title>
          </path>
        </g>
        <path
          id="FIPS_04011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M149.8,221.3l0.2-0.5l0.1-0.1l1.5-0.9l3.2,0.4l-2.4,17.3l-0.7-0.1l-1-1.5l0-0.2l0.2-0.5
		l0.1-0.6v-0.6l-0.2-0.9l-0.6-1.3l-0.2,0l-1.3-3.3L149.8,221.3z	"
        >
          <title id="t174">Greenlee, AZ</title>
        </path>
        <path
          id="FIPS_04009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M145.4,221.8l0.6,0.6l1.1,0.2l1.1-0.7l1.6-0.7l-1.1,7.4l1.3,3.3l0.2,0l0.6,1.3l0.2,0.9v0.6
		l-0.1,0.6l-0.2,0.5l0,0.2l1,1.5l-3.4-0.5l-7.9-1.1l-3-0.5l0.2-1.1l0,0l0.2-1.4l0.7-4.6l0.4-2.6l0.1-1.2l0.2-0.9l0.1-0.2l0.4-0.2
		l0.8-0.2l0.3,0l1.6-0.2l1.8,0.3l0.2-1.4L145.4,221.8z	"
        >
          <title id="t175">Graham, AZ</title>
        </path>
        <path
          id="FIPS_04001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M160.5,179l-1.8,12.8l-2.5,18.3l-1.4,10.3l-3.2-0.4l-1.5,0.9l-0.1,0.1l-0.2,0.5l-1.6,0.7
		l-1.1,0.7l-1.1-0.2l-0.6-0.6l0.3-2.1l0.4-0.5l0.9-4.8l1.4-9l0.9-5.6l0.5-2.8l0.3-1.9l-1.8-0.3l2.5-17.2L160.5,179z	"
        >
          <title id="t176">Apache, AZ</title>
        </path>
        <path
          id="FIPS_04017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M150.8,177.6l-2.5,17.2l1.8,0.3l-0.3,1.9l-0.5,2.8l-0.9,5.6l-1.4,9l-0.9,4.8l-0.4,0.5
		l-0.3,2.1l-1.1-0.3l0.8-5.4l-7.9-1.2l6-38.5l2.6,0.4l1.6,0.3L150.8,177.6z	"
        >
          <title id="t177">Navajo, AZ</title>
        </path>
        <path
          id="FIPS_04007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M137.8,211.5l-0.5,3.4l7.9,1.2l-1,6.8l-1.8-0.3l-1.6,0.2l-0.3,0l-0.8,0.2l-0.4,0.2l-0.1,0.2
		l-0.2,0.9l-0.1,1.2l-0.2,0l-1.9,0.4l-1.1,0.8l0,0.1l0.1,0.3l0,0.1l-0.6,0.6l-0.2,0l0,0l-1.2-3.7l-0.1-1l-0.2-1l-0.2-0.8l-0.8-2.9
		l-0.3,0.2l-0.3,0.2l-1.6-2.5L130,214l-0.1-0.2l0,0l-0.2-0.1l-0.3,0l0.5-0.8v-0.6l-0.1-0.2l-0.2-0.3l-2.2-0.4l-0.1-0.1l0,0l0.4-0.9
		l0.7-1.8l0.1-0.1l0.8-0.2l0.3-0.2l0,0l0.1-0.4l3,0.9l2.3,1.6l1.7,1.4L137.8,211.5z	"
        >
          <title id="t178">Gila, AZ</title>
        </path>

        <path
          id="FIPS_04027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M108.7,218.2l-2.1,11.1l-1.1,5.9l-0.2-0.1l-14.5-8.7l0.4-1.6l0,0l0.1,0l0.2,0l0.5-0.4l0.4-0.6
		l1.1,0.1l1.5-0.9l0.5-0.7v0l0.1-0.3l0.1-0.8l-0.3-0.7l0,0l0,0l1.6,0.3l1.1,0.2l1.1-5.5l3.3,0.6l-0.2,1.1L108.7,218.2z	"
        >
          <title id="t180">Yuma, AZ</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "38060"
              ? `metroArea clickedArea state-az`
              : `metroArea ${colorCode[38060]} state-az`
          }
          id="FIPS_38060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_04013"
            className="FIPS_38060 st0 state-az"
            d="M110.2,210.3l6.2,1.1l4.6,2.4l0.4-0.3l0.6-0.8l0-0.2l0.4-0.7l0.2,0l4.3,1.3l2.4,0.4l0.3,0
		l0.2,0.1l0,0l0.1,0.2l0.1,2.3l1.6,2.5l0.3-0.2l0.3-0.2l0.8,2.9l-2.2-0.3l-3.5-0.6l-0.2,1.1l-0.3,2.2l-2.7-0.4l-1.5-0.3l-1.2-0.3
		l-1-1.2l0,0l-0.1,0.6l-1.3,7.2l-0.4,2.2l-12.1-2.1L110.2,210.3z	"
          >
            <title id="t181">Maricopa, AZ</title>
          </path>
          <path
            id="FIPS_04021"
            className="FIPS_38060 st0 state-az"
            d="M133.1,221.3l0.2,0.8l0.2,1l0.1,1l1.2,3.7l0,0l0.2,0l0.6-0.6l0-0.1l-0.1-0.3l0-0.1l1.1-0.8
		l1.9-0.4l0.2,0l-0.4,2.6l-0.7,4.6l-0.2,1.4l0,0l-2.5-0.4l-3.4-0.5l-1.7-0.2l-0.4-0.1l-4.1-0.7l-2.4-0.5l-4.4-0.7l0.4-2.2l1.3-7.2
		l0.1-0.6l0,0l1,1.2l1.2,0.3l1.5,0.3l2.7,0.4l0.3-2.2l0.2-1.1l3.5,0.6L133.1,221.3z	"
          >
            <title id="t179">Pinal, AZ</title>
          </path>
        </g>
        <path
          id="FIPS_04005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M136.6,175.3l6.7,1.1l-5.5,35.1l-1-0.3l-1.7-1.4l-2.3-1.6l-3-0.9l0.4-2.1l0.3-2.1l-0.4-0.1
		l-1.8-0.3l0-0.5l0.3-1.8l-2.5-0.4l-0.4,0l-2.9-0.5l0.4-2.2l-0.9-1.1l-5.1-3.2l-1.8-1.8l-0.9-0.5l-0.4-0.1l-0.2,0l-0.1,0l1.2-5.7
		l0.7-1.5l1.6-0.7l1.1-0.4l0.6-0.1l0.1,0l0.5-0.1l0.4-0.1l2.4-0.7l0.2,0l0.1-0.1l0.3-0.4l0.1-0.2l0.1-0.8l-0.1-0.2l-0.1-0.4v-0.2
		l0-0.2l0.5-1.7l0-0.1l0.7-1.7l1-2.2L136.6,175.3z	"
        >
          <title id="t182">Coconino, AZ</title>
        </path>
        <path
          id="FIPS_04025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M113.8,190.8l0.1,0l0.2,0l0.4,0.1l0.9,0.5l1.8,1.8l5.1,3.2l0.9,1.1l-0.4,2.2l2.9,0.5l0.4,0
		l2.5,0.4l-0.3,1.8l0,0.5l1.8,0.3l0.4,0.1l-0.3,2.1l-0.4,2.1l-0.1,0.4l0,0l-0.3,0.2l-0.8,0.2l-0.1,0.1l-0.7,1.8l-0.4,0.9l0,0
		l0.1,0.1l2.2,0.4l0.2,0.3l0.1,0.2v0.6l-0.5,0.8l-2.4-0.4l-4.3-1.3l-0.2,0l-0.4,0.7l0,0.2l-0.6,0.8l-0.4,0.3l-4.6-2.4l-6.2-1.1
		l0.8-4.1L113.8,190.8z	"
        >
          <title id="t183">Yavapai, AZ</title>
        </path>
        <path
          id="FIPS_06015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M28.2,83.5l3.6,1.1l2.8,0.8l-0.3,0.5l-0.4,0.6l-0.7,0.1l-0.9,0.8l-0.7,3.4l0.1,0.3l0.1,0.8
		L31.7,92l-0.5,0.5L31,92.7l-0.5-0.2L30.1,92l0.2-0.7L29.2,91l-1.7-0.5l0.2-1.1l0-0.7l0-1.4l0-0.1l0-0.2l0-0.2l0.2-2.1L28.2,83.5z	"
        >
          <title id="t184">Del Norte, CA</title>
        </path>
        <path
          id="FIPS_06093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M34.6,85.4l2.6,0.7l0,0l0.7,0.1l1,0.4l0.4,0.1l0.2,0.1l3.1,0.9l1.2,0.3l1.1,0.3l0.3,0.1
		l0.5,0.2l7.7,2.3l-0.2,0.6l-0.1,0.3l-0.5,1.8l0,0l0,0L51.6,98l-0.8,3.1l-5.2-1.4l-2.7-0.8L41,98.3l0.2-1.3l-1.1-0.7l-2,0.8
		l-1.4,1.5l0.1,0.6l-0.1,0.2l-0.2,0.2l-0.2,0l-0.8-0.4l-1.3-1.4l-0.7-1.1L33,96.3l-0.5-0.4l0.1-2.5l-0.2-0.3L31,92.7l0.2-0.2
		l0.5-0.5l0.1-0.2L31.6,91l-0.1-0.3l0.7-3.4l0.9-0.8l0.7-0.1l0.4-0.6L34.6,85.4z	"
        >
          <title id="t185">Siskiyou, CA</title>
        </path>
        <path
          id="FIPS_06025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M79.9,211.8l6.5,1.4l5.3,1l1.4,0.2l2.1,0.4l-1.1,0.3l-0.6,3.9l0,0l0.2,0.6l0.5,0.3l0.2,0.1
		l0.9,0.2l0,0l0,0l0.3,0.7l-0.1,0.8l-0.1,0.3v0l-0.5,0.7l-1.5,0.9l-1.1-0.1l-0.1,0l-8-0.9l-0.2,0l-0.9-0.1l-3.4-0.4l-1.4-0.2
		l-1.1-0.1l0.5-2.1l1-3.6l0.3-1.5L79.9,211.8z	"
        >
          <title id="t186">Imperial, CA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "40140"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[40140]} state-ca`
          }
          id="FIPS_40140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06065"
            className="FIPS_40140 st0 state-ca"
            d="M98.8,207.1l-1,1.4l-0.3,0.5l-0.3,1l-0.1,0.4l-0.3,1.5l-0.4,1.5l-1.3,1.5l-2.1-0.4l-1.4-0.2
		l-5.3-1l-6.5-1.4l-2.2-0.5l-3.3-0.7l-2.3-0.5l-4.2-1l0.1-0.2l-1.1-1l-1.5-0.3l0.1-0.4l1.4-1.3l-0.5-0.7l-0.6-0.2l-0.3-0.8l-0.7-1.5
		l0.4-0.6l1.3-1.1l1.5,0.3l0.4,0.1l0.1,0.2l1.4,0.5l3.1,0.7l1.3,0.1l2.6,0.5l7.6,1.6l5.3,1.1l0.7-0.2l1.4,0.1L98.8,207.1z	"
          >
            <title id="t187">Riverside, CA</title>
          </path>
          <path
            id="FIPS_06071"
            className="FIPS_40140 st0 state-ca"
            d="M70.7,178.3l2.6,0.6l16.6,3.7l0.9,0l2.1,3.1l0.7,1.1l0.3,0.4l3.8,5.7l1.4,2.1l-0.3,1.4l0,0.2
		l0,0.1l0.6,1.5l0.7,1.1l0,0.5l0.7,2.8l0.7,0.8l0.6,0.6l0.5,0.9l0,0.6l0,0l-1.4,0.8l-0.9,0.4l-1.3,0.5l-7.2-1.4l-1.4-0.1l-0.7,0.2
		l-5.3-1.1l-7.6-1.6l-2.6-0.5l-1.3-0.1l-3.1-0.7l-1.4-0.5l-0.1-0.2l-0.4-0.1l-1.5-0.3l-1.3,1.1l-0.4,0.6l-0.9-1.2l-0.1-0.1l0-0.2
		l0-0.1l0.3-0.3l0.7-0.4l0.2-0.4l0.6-1l0.7-1.5l0.1-0.6l0.2-1.5l0.3-1.7l0.7-3l0.4,0.1l2.2-9.4l0.1-1.5l0.1-0.4L70.7,178.3z	"
          >
            <title id="t195">San Bernardino, CA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41740"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[41740]} state-ca`
          }
          id="FIPS_41740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06073"
            className="FIPS_41740 st0 state-ca"
            d="M65.2,207.5l1.5,0.3l1.1,1l-0.1,0.2l4.2,1l2.3,0.5l3.3,0.7l2.2,0.5l-0.6,3l-0.3,1.5l-1,3.6
		l-0.5,2.1l-1-0.1l-2.1-0.2l-2.1-0.2l-3-0.3l-2.8-0.3l-0.1,0l-0.5-2.1l0.2-3.2v-0.1h0l0-0.7l0-0.3l-0.1-1.1l-0.1-0.4l-0.2-0.6l0-0.1
		l-0.6-1.5l-0.2-0.4l0-0.1l-0.2-0.5l-0.3-0.5l-0.2-0.2l-0.2-0.2L65.2,207.5z	"
          >
            <title id="t188">San Diego, CA</title>
          </path>
        </g>
        <path
          id="FIPS_06059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M63.7,201.3l0.9,1.2l0.7,1.5l0.3,0.8l0.6,0.2l0.5,0.7l-1.4,1.3l-0.1,0.4l-1.2,1.3l-0.1-0.3
		l-0.2-0.4l-0.1-0.2l-2-2.5l-1.6-1.9l-0.4-0.5l0.3-0.5l0.6-0.7l1.1-1l0.5,0l0.1,0L63.7,201.3z	"
        >
          <title id="t189">Orange, CA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "31084"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[31084]} state-ca`
          }
          id="FIPS_31084"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06037"
            className="FIPS_31084 st0 state-ca"
            d="M54.3,214.1l-0.8,0l-0.5-0.6l-0.1-0.1l-0.2-0.8l-0.2-1.4l0.3,0.1l1.5,2.6L54.3,214.1
		L54.3,214.1z M53.8,205.3L53.8,205.3l-0.1-0.1l0,0l0,0l0.6,0.2l0.6,0.5l0.5,0.4l0.4,0.3l0.5,1l0,0.1l0,0.2l0,0.1l-0.1,0.1l0,0h-0.1
		l-1.3-0.6l-0.1-0.1L53.8,205.3z M67.5,190.5l-0.7,3l-0.3,1.7l-0.2,1.5l-0.1,0.6l-0.7,1.5l-0.6,1l-0.2,0.4l-0.7,0.4l-0.3,0.3l0,0.1
		l0,0.2l0.1,0.1l-1.4-0.3l-0.1,0l-0.5,0l-1.1,1l-0.6,0.7l-0.3,0.5l-0.8,0.1l-0.8,0l-0.4-0.2l-0.2-0.1l-0.8-0.5l-0.1-0.1l-0.1-0.5
		l0.1-0.1l0.2-0.2l0.1,0l0.1-0.1l0.1-0.3l-0.1-0.6l0-0.3l0-0.2l-0.1-0.3l-0.1-0.4l-0.1-0.4l0,0l0,0l0,0l-0.1-0.2l0,0l-0.1-0.1l0,0
		l0,0l-0.2-0.2l-0.3-0.1l-1-0.2l-0.8-0.1l-0.4,0l-1.6-0.7l0.1-0.4l1-0.4L54,196l1.2,0.3l0.6-1l0.1-0.5l-1-6.9l0-0.4L67.5,190.5z	"
          >
            <title id="t190">Los Angeles, CA</title>
          </path>
        </g>
        <path
          id="FIPS_06111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M49.5,185.1l0.6,0.2l1,0.5l0.1,0.3l0,0.4l2.6,1.2l1,0.2l1,6.9l-0.1,0.5l-0.6,1L54,196
		l-0.8,0.3l-1,0.4l-0.1,0.4l-1.4-1.1l-1.6-2.7l-1.1-1.4l-0.2-0.3l-0.1-0.1l0.3-0.2l0.1-0.1l0.2-0.6L49.5,185.1z	"
        >
          <title id="t191">Ventura, CA</title>
        </path>
        <path
          id="FIPS_06083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M38.4,194.4l1.9,0.2l0.8,0.8l0,0.4l0,0.1l0,0l-1.5,0.2l-0.1,0l-0.4-0.4l-0.1-0.1L38.4,194.4z
		 M43.6,194.9l0.4,0.3l1,0.3l0,0l0,0l0,0l0,0l0.1,0l0,0l0.3,0l0.3,0.3l0.1,0.1l0,0l0,0l0,0l-0.3,0.3l-0.1,0.1l-0.1,0l-1.8,0
		l-0.4-0.1l-0.4-0.1h0l-0.1-0.1l-0.3-0.1l-0.3-0.2l0-0.1l-0.2-1.2l0.1-0.1l0.1,0l0.6,0.2L43.6,194.9z M37.5,181l1.6,0.2l0.6,0.2
		l0.5,0.5l0.7-0.1l0.7-0.4l2.1-0.6l0.2,0.2l0.6,0.6l1.8,1.5l2.3,1.8l0.5,0.1h0.2l0.3,0.1l-1.4,5.6l-0.2,0.6l-0.1,0.1l-0.3,0.2
		l-0.8-0.7l-0.6-0.2l-0.6-0.1l-0.2,0h0l-0.6,0l-1.3-0.4l-0.4-0.5l-0.8-0.6l-0.3-0.1l-0.8-0.3l-0.7-0.2l-0.8-0.2l-0.9-0.1l-1-0.2
		l-1.4-1.8l0.1-1l0.7-3.4L37.5,181z	"
        >
          <title id="t192">Santa Barbara, CA</title>
        </path>
        <path
          id="FIPS_06079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M33.2,168.9l11.3,3.1l0.2,0.1l-0.6,2.2l1.1,1.6l1.2,2.5l0.4,1.3l1.1,0.3l1.2,1.4l0.5,1.5
		l-0.6,2.2H49l-0.5-0.1l-2.3-1.8l-1.8-1.5l-0.6-0.6l-0.2-0.2l-2.1,0.6l-0.7,0.4l-0.7,0.1l-0.5-0.5l-0.6-0.2l-1.6-0.2l0.2-0.3l0,0
		l0.2-0.4L38,180l0.1-0.2l0-0.2l0-0.1l0,0l0-0.3v0l0-0.2l0-0.1l-0.1-0.1l-0.3-0.3l0,0l-0.1-0.1l-0.9-2.5l-1.7-3.2l-1.1-1.8l-0.2-0.2
		l-0.1-0.1l-0.2-0.6L33.2,168.9z	"
        >
          <title id="t193">San Luis Obispo, CA</title>
        </path>
        <path
          id="FIPS_06029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M51.4,173.7l4.9,1.2l5.5,1.4l4.4,1l0.6,0.2l3.8,0.8l-0.4,1.1l-0.1,0.4l-0.1,1.5l-2.2,9.4
		l-0.4-0.1l-12.6-2.9l0,0.4l-1-0.2l-2.6-1.2l0-0.4l-0.1-0.3l-1-0.5l-0.6-0.2l-0.3-0.1l0.6-2.2l-0.5-1.5l-1.2-1.4l-1.1-0.3l-0.4-1.3
		l-1.2-2.5l-1.1-1.6l0.6-2.2L51.4,173.7z	"
        >
          <title id="t194">Kern, CA</title>
        </path>

        <path
          id="FIPS_06027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M64.2,154.5l9.3,2.2l5.2,7.8l0.2,0.3l1.1,1.6l0.6,1l3.4,5.1l2.8,4.1l0.4,0.5l1.5,2.2l0.1,0.2
		l2,3l-0.9,0l-16.6-3.7l-2.6-0.6l-3.8-0.8l0.5-1.1l0.2-0.6l0-0.9l-0.3-4.2l-0.8-4.3l-0.2-1.9l0.3-1.3l0.1-0.7l0-0.5l-0.2-1.6
		l-0.1-0.3l-0.8-0.8l-0.2,0l-0.8-0.6l0,0l-0.1-0.2l-0.5-2.5l0-0.8L64.2,154.5z	"
        >
          <title id="t196">Inyo, CA</title>
        </path>
        <path
          id="FIPS_06107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M66.2,164.6l0.2,1.9l0.8,4.3l0.3,4.2l0,0.9l-0.2,0.6l-0.5,1.1l-0.6-0.2l-4.4-1l-5.5-1.4
		l-4.9-1.2l1.1-4.2l0.5-1.7l0.3-0.1l0.3,0.1l0.4-1.7l-0.3-1.2l-0.4-0.1l1.3-0.8l1.9-0.7l1.3,0.3l1.9,0.5l0.3-1.1l4.4,1L66.2,164.6z	
		"
        >
          <title id="t197">Tulare, CA</title>
        </path>
        <path
          id="FIPS_06031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M53.3,164.8l0.4,0.1l0.3,1.2l-0.4,1.7l-0.3-0.1l-0.3,0.1l-0.5,1.7l-1.1,4.2l-6.6-1.7l-0.2-0.1
		l-0.6-1.7l4.5-2.5l0.7-2.8l1.5,0.4l1.5,0.1L53.3,164.8z	"
        >
          <title id="t198">Kings, CA</title>
        </path>
        <path
          id="FIPS_06039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M60.2,149.8L61,150l0.6,0.2l0.1,0.2l0.3,0.6l0.1,1.3l-3.1,1.9l-0.4,0.3l-0.2,0.2l-0.1,0.2
		l-0.1,0.6l0,0.2l0,0.1l-0.2,0.5l-0.1,0.2l-0.3,0.3l-0.3,0.2l-1.5-0.1l-0.4,0.1l-1.6,1l-0.4,0.3l-0.1,0.1l-0.7,0.8l-0.2,0.3
		l-0.3,0.3l0,0l-4.3-0.1l-0.6-0.1l-0.7-0.6l-0.4-0.6l-0.1-0.2l0-0.2l0-0.2l-0.3-2.2l0.8-0.5l2-0.2l1.5,0.2h1l3.6-2.2l1.1,0.3
		l0.9-0.8l0.2-0.8l3.4-2.1L60.2,149.8z	"
        >
          <title id="t199">Madera, CA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "23420"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[23420]} state-ca`
          }
          id="FIPS_23420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06019"
            className="FIPS_23420 st0 state-ca"
            d="M64.2,154.5l-0.4,0.8l0,0.8l0.5,2.5l0.1,0.2l0,0l0.8,0.6l0.2,0l0.8,0.8l0.1,0.3l0.2,1.6l0,0.5
		l-0.1,0.7l-0.3,1.3l-1.8-0.4l-4.4-1l-0.3,1.1l-1.9-0.5l-1.3-0.3l-1.9,0.7l-1.3,0.8l-1.2,0.6l-1.5-0.1l-1.5-0.4l-0.7,2.8l-4.5,2.5
		l-2-2.5l-0.6-0.9l0-0.7l0.3-1.3l0.5-0.6l1-2l-2.3-4l4.7-2.8l0.3,2.2l0,0.2l0,0.2l0.1,0.2l0.4,0.6l0.7,0.6l0.6,0.1l4.3,0.1l0,0
		l0.3-0.3l0.2-0.3l0.7-0.8l0.1-0.1l0.4-0.3l1.6-1l0.4-0.1l1.5,0.1l0.3-0.2l0.3-0.3l0.1-0.2l0.2-0.5l0-0.1l0-0.2l0.1-0.6l0.1-0.2
		l0.2-0.2l0.4-0.3l3.1-1.9L64.2,154.5z	"
          >
            <title id="t200">Fresno, CA</title>
          </path>
        </g>
        <path
          id="FIPS_06053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M34.1,154.3l-0.1,0.3l0.1,0.4l0.8,1.4l0.9,1.7l0.9,2.3l1.4,2.7l0.6,0.8l1.9,1.6l0.3,0.1l0.1,0
		l0.1,0l0.5-0.7l-0.3,1.3l0,0.7l0.6,0.9l2,2.5l0.6,1.7l-11.3-3.1l-0.3-0.5l-0.5-1l0-0.5l0-0.2l0-0.4l-0.1-0.4l0-0.1l-1.2-2.6
		l-0.3-0.5l-0.5-0.6l-0.1-0.1h0l-0.1,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.3-0.6l-0.1-0.2l0-0.2l0.3-3.3l0.7-0.3l0,0l0.2,0l0.1-0.1
		l0.2-0.2l0.2-0.2l0.1-0.1l0.2-0.3l0.2-0.4l0.5-1.1l0-0.1l-0.1-0.5l0,0L34.1,154.3z	"
        >
          <title id="t201">Monterey, CA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41940"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[41940]} state-ca`
          }
          id="FIPS_41940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06069"
            className="FIPS_41940 st0 state-ca"
            d="M34.1,154.3l0.6,0.1l0.9-0.5l0.9,0.2l2,0.5l-0.2,0.2l-0.1,0.1l0,0.1l0.1,0.2l0.5,1.2l1.8,1.6
		l0.1,0.2l2.3,4l-1,2l-0.5,0.6l-0.5,0.7l-0.1,0l-0.1,0l-0.3-0.1l-1.9-1.6l-0.6-0.8l-1.4-2.7l-0.9-2.3l-0.9-1.7l-0.8-1.4l-0.1-0.4
		L34.1,154.3z	"
          >
            <title id="t202">San Benito, CA</title>
          </path>
          <path
            id="FIPS_06085"
            className="FIPS_41940 st0 state-ca"
            d="M31.8,145.8L32,146l1.2,0.4l0.2,0l0.4,0l0.1,0l0.1-0.1l0.1,0l3.7,1.1l-0.2,0.1l0,0.7l0.3,3.3
		l1.1,1l0.1,0.2l-0.1,0.7l-0.2,0.3l-0.3,0.1l-0.1,0.5l0,0.1l0.1,0.2l0.1,0.1l-2-0.5l-0.9-0.2l-0.9,0.5l0.1-0.2l-0.1-0.1l-1.2-2
		l-0.9-0.9l-0.4-0.3l-0.7-0.6l-0.3-0.4l-0.5-1.1l-0.3-0.6l0-0.1l0-0.1L31.8,145.8z	"
          >
            <title id="t207">Santa Clara, CA</title>
          </path>
        </g>
        <path
          id="FIPS_06047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M48.9,148.3l0.5,2.5l0,0.2l0,0l0,0l0.4,2.4l0.3,0.4l0.7,0.9h-1l-1.5-0.2l-2,0.2l-0.8,0.5
		l-4.7,2.8l-0.1-0.2l-1.8-1.6l-0.5-1.2l-0.1-0.2l0-0.1l0.1-0.1l0.2-0.2l-0.1-0.1l-0.1-0.2l0-0.1l0.1-0.5l0.3-0.1l0.2-0.3l0.1-0.7
		l-0.1-0.2l3.3-1.9l0-0.4l-0.1-0.1l-0.1,0l1.5-0.4L48.9,148.3z	"
        >
          <title id="t203">Merced, CA</title>
        </path>

        <path
          id="FIPS_06087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M30.4,148l0,0.1l0,0.1l0.3,0.6l0.5,1.1l0.3,0.4l0.7,0.6l0.4,0.3l0.9,0.9l1.2,2l0.1,0.1
		l-0.1,0.2l-0.6-0.1l-1.8,0.1l-0.1-0.4l-0.2-0.7l-0.1-0.3l-0.1-0.2l-0.1-0.1l-0.2-0.2l-0.1,0l-0.5,0.1l-0.5,0l-0.2,0l-0.2,0l-0.1,0
		l0,0l-0.1-0.1l-0.1-0.1l-0.4-0.4l-0.4-0.6l-0.3-0.7l-0.2-0.7l0-0.5l0.1-0.5l0.8-0.1l0.9,0.2l0.1-0.2L30.4,148z	"
        >
          <title id="t204">Santa Cruz, CA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41860"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[41860]} state-ca`
          }
          id="FIPS_41860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06001"
            className="FIPS_41860 st0 state-ca"
            d="M31,139.9l0.4,0l0.1,0l0.3,0.4L32,141l0,0.3l1.8,1.8l3.6-0.1l0.7-0.1l-0.4,1.5l-0.6,2l0.1,0.2
		l0.5,0.8l0,0l-3.7-1.1l-0.1,0l-0.1,0.1l-0.1,0l-0.4,0l-0.2,0L32,146l-0.2-0.2l-0.2-0.5l0-2.3l-0.8-2.3L31,139.9z	"
          >
            <title id="t206">Alameda, CA</title>
          </path>
          <path
            id="FIPS_06013"
            className="FIPS_41860 st0 state-ca"
            d="M32.1,138l0.9,0.5l0.5,0.1l2.1,0.5l0.1,0l0.1,0l0.1-0.1L36,139l0.2,0.6l0.1,0.1l0.3,0.1l0.1,0
		l0.4,0l0.4-0.1l0.2-0.1l0-0.1l0-0.2l0-0.1l0.1,0H38l0.6,0.1l0.2,0.1l0,0l-0.7,3.5l-0.7,0.1l-3.6,0.1l-1.8-1.8l0-0.3l-0.2-0.6
		l-0.3-0.4l-0.1,0l-0.4,0l-0.4-0.3l-0.4-0.8l1.3-0.3l0.2-0.1l0.3-0.2l0-0.1L32.1,138z	"
          >
            <title id="t216">Contra Costa, CA</title>
          </path>
          <path
            id="FIPS_06075"
            className="FIPS_41860 st0 state-ca"
            d="M29.6,142l-1.1-0.3v0l0-0.2l0.1-0.7l0.1-0.1l0.5-0.1l0.4,0l0.2,0l0.1,0.1L30,141l-0.1,0.8
		l-0.1,0.2L29.6,142z	"
          >
            <title id="t220">San Francisco, CA</title>
          </path>
          <path
            id="FIPS_06041"
            className="FIPS_41860 st0 state-ca"
            d="M25.8,133l0.1-0.1l0.8,0l0.1,0l2.1,2.5l1.1,1.3l-0.4,0.9l-0.4,1.2l0,0.1l0.1,0.1l0.2,0.2
		l0.2,0.3l0.1,0.1l0,0l-0.6,0.6l-0.3,0l-0.2-0.1l-0.1-0.1l-3.2-3.6l0.5-2.8l0-0.2l-0.1-0.3L25.8,133z	"
          >
            <title id="t221">Marin, CA</title>
          </path>
          <path
            id="FIPS_06081"
            className="FIPS_41860 st0 state-ca"
            d="M29.6,142L29.6,142l-0.2,1.3l0.1,0.2l1.6,1.6l0.1,0.1l0.3,0.1l0.2,0l0,0l0.2,0.5l-1.4,2.2
		l-0.2,0.7l-0.1,0.2l-0.9-0.2l-0.8,0.1l-0.1,0.5l0,0.5l-0.1-0.1l-0.3-0.5l-0.4-0.7l0-0.1l0-0.6l0.2-3.3l0.3-1.4l0.4-1.4L29.6,142z	"
          >
            <title id="t205">San Mateo, CA</title>
          </path>
        </g>

        <path
          id="FIPS_06099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M45.1,141.4l1.8,3.8l2,3.2l0,0l-5.3,1.1l-1.5,0.4l0.1,0l0.1,0.1l0,0.4l-3.3,1.9l-1.1-1
		l-0.3-3.3l0-0.7l0.2-0.1l0,0l2.7-1.6l0.5-0.3l0.2-0.1l1.1-0.3l0.3,0.1l0.5,0.1l0.6,0.1l0.6-0.1l0.4-1.5L45.1,141.4z	"
        >
          <title id="t208">Stanislaus, CA</title>
        </path>
        <path
          id="FIPS_06043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M48.9,148.3l0-0.5l0.1-0.1l0.6-0.4l2.9-0.6l0.2,0.1l0.8,0.9l0.1,0.1l0.1,0L54,148l0.9,0.3
		l0.3,0l1.2-0.2l0.2-0.1l0.9-0.7l0.6-0.1l1,0.7l0.6,0.7l0.3,0.7l-3.4,2.1l-0.2,0.8l-0.9,0.8l-1.1-0.3l-3.6,2.2l-0.7-0.9l-0.3-0.4
		l-0.4-2.4l0,0l0,0l0-0.2L48.9,148.3L48.9,148.3z	"
        >
          <title id="t209">Mariposa, CA</title>
        </path>
        <path
          id="FIPS_06109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M58.5,141.5L58.5,141.5l-0.2,0.4l-0.2,1.2l0.4,0.7l0.3,0.3l0.2,0.2l0.4,0.2l0.4,0.3l0.2,0.2
		l0.4,0.4l0.3,0.6l0.5,2.3l-0.4,1.1l-0.5,0.4l-0.2,0.1l-0.3-0.6l-0.3-0.7l-0.6-0.7l-1-0.7l-0.6,0.1l-0.9,0.7l-0.2,0.1l-1.2,0.2
		l-0.3,0L54,148l-0.3-0.1l-0.1,0l-0.1-0.1l-0.8-0.9l-0.2-0.1l-2.9,0.6l-0.6,0.4l-0.1,0.1l0,0.5l-2-3.2l1.8-1.2l0.7-0.7l1.2-1.3
		l1.2-1.1l1.5-1.3l0.2-0.1l0.2-0.1l1.2-0.2l1.1,1.3l0.1-0.1l0.8-0.3l0.6-0.1l0.4,0.1l0,0l0,0.1L58.5,141.5z	"
        >
          <title id="t210">Tuolumne, CA</title>
        </path>
        <path
          id="FIPS_06051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M60.3,136.8l1.9,2.9l1.3,1.9l5.5,8.3l4.6,6.9l-9.3-2.2l-2.1-2.1l-0.1-1.3l-0.3-0.6l-0.1-0.2
		L61,150l-0.7-0.2l0.2-0.1l0.5-0.4l0.4-1.1l-0.5-2.3l-0.3-0.6l-0.4-0.4l-0.2-0.2l-0.4-0.3l-0.4-0.2l-0.2-0.2l-0.3-0.3l-0.4-0.7
		l0.2-1.2l0.1-0.4l0.1-0.1l1-0.9l0.5-1.1l-0.4-1.5l0-0.1l0.2-0.6L60.3,136.8z	"
        >
          <title id="t211">Mono, CA</title>
        </path>
        <path
          id="FIPS_06003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M57.9,133.2l2.4,3.6l-0.4,0.6l-0.2,0.6l0,0.1l0.4,1.5l-0.5,1.1l-1,0.9l-0.3-1.2l0-0.1l0,0
		l-0.4-0.1l-0.6,0.1l-0.8,0.3l-0.1,0.1l-1.1-1.3l-0.3-1.1l0.6-2.4l1.3-0.7l0.2-0.2l0.8-0.7l0-0.1l0.1-0.4l0-0.2L57.9,133.2z	"
        >
          <title id="t212">Alpine, CA</title>
        </path>
        <path
          id="FIPS_06009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M55.1,139.2l-1.2,0.2l-0.2,0.1l-0.2,0.1l-1.5,1.3l-1.2,1.1l-1.2,1.3l-0.7,0.7l-1.8,1.2
		l-1.8-3.8l-0.2-2l0.1,0.1l0.1,0.1l0.8,0.2l2.4-0.8l1.8-0.8l0.5-0.2l0.4,0l3.8,0.2L55.1,139.2z	"
        >
          <title id="t213">Calaveras, CA</title>
        </path>
        <path
          id="FIPS_06005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M55.5,135.7l-0.6,2.4l-3.8-0.2l-0.4,0l-0.5,0.2l-1.8,0.8l-2.4,0.8l-0.8-0.2l-0.1-0.1l-0.1-0.1
		l-0.1-1l0.7-2.6l0.9,0.1l2.9,1l0.4,0.1l0.7,0.1l2,0.1l0.6-0.1L55.5,135.7z	"
        >
          <title id="t214">Amador, CA</title>
        </path>
        <path
          id="FIPS_06077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M45,139.3l0.2,2l-0.6,2.4l-0.4,1.5l-0.6,0.1l-0.6-0.1l-0.5-0.1l-0.3-0.1l-1.1,0.3l-0.2,0.1
		l-0.5,0.3l-2.7,1.6l-0.5-0.8l-0.1-0.2l0.6-2l0.4-1.5l0.7-3.5l0.4-0.6l1.1-1.2h0.2l0.2,0.1l0.1,0.3l0.2,0.2l0.5,0.1l1.8,0.2l0.1,0
		l0.7-0.2l0.8,0L45,139.3z	"
        >
          <title id="t215">San Joaquin, CA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "40900"
              ? `metroArea clickedArea state-ca`
              : `metroArea ${colorCode[40900]} state-ca`
          }
          id="FIPS_40900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_06017"
            className="FIPS_40900 st0 state-ca"
            d="M57.4,131.3l0.5,1.9l0.1,0.2l0,0.2l-0.1,0.4l0,0.1l-0.8,0.7l-0.2,0.2l-1.3,0.7l-2.3,1.3
		l-0.6,0.1l-2-0.1l-0.7-0.1l-0.4-0.1l-2.9-1l-0.9-0.1l-0.4-2.9l1.2-1.5l0.3-0.6l0.2-0.2l1.1-0.3l1.4-0.2l0.4,0l0.1,0l0.2,0.1
		l0.3,0.3l0.1,0.3l0.1,0.1l0.1,0.2l0.6,0.6l0.1,0.1h0.1l0.5-0.1l0.2-0.1l0.5-0.4l2.2,0.1l0.6,0l0.2,0l0.1-0.1l0-0.2l0.1-0.1
		L57.4,131.3z	"
          >
            <title id="t217">El Dorado, CA</title>
          </path>
          <path
            id="FIPS_06061"
            className="FIPS_40900 st0 state-ca"
            d="M43.5,128.5l1.4-0.1l0.5,0.4l0.1,0.1l1.4,0.5l0.3-0.1l0.6-0.6l0.1-0.1l0.1-0.2l0.1-0.1
		l0.5-0.4l0.5-0.2l0.7-0.4l1.4-0.6l0.5-0.1l0.4,0l6.1,1.6l-0.5,1.9l-0.2,0.7l-0.1,0.6l-1.4-0.3l-0.1,0.1l0,0.2l-0.1,0.1l-0.2,0
		l-0.6,0l-2.2-0.1l-0.5,0.4l-0.2,0.1l-0.5,0.1h-0.1l-0.1-0.1l-0.6-0.6l-0.1-0.2l-0.1-0.1l-0.1-0.3l-0.3-0.3l-0.2-0.1l-0.1,0l-0.4,0
		l-1.4,0.2l-1.1,0.3l-0.2,0.2l-0.3,0.6l-1.2,1.5l-3.2-1.2l0.8-2.4l0.5,0.1L43.5,128.5z	"
          >
            <title id="t225">Placer, CA</title>
          </path>
          <path
            id="FIPS_06067"
            className="FIPS_40900 st0 state-ca"
            d="M42,131.6l3.2,1.2l0.4,2.9l-0.7,2.6l-0.8,0l-0.7,0.2l-0.1,0l-1.8-0.2l-0.5-0.1l-0.2-0.2
		l-0.1-0.3l-0.2-0.1h-0.2l-1.1,1.2l-0.4,0.6l0,0l-0.2-0.1l-0.6-0.1h-0.1l-0.1,0l0,0.1l0,0.2l0,0.1l-0.2,0.1l-0.4,0.1l-0.4,0l-0.1,0
		l-0.3-0.1l-0.1-0.1L36,139l0.6,0.2l1-0.1l1.1-1.1l0.8-1.4l0.7-0.3l0.2-0.1l0.5-1l0.4-1.8l0-0.1l0-0.1l-0.4-0.7l0-1.3L42,131.6z	"
          >
            <title id="t218">Sacramento, CA</title>
          </path>
          <path
            id="FIPS_06113"
            className="FIPS_40900 st0 state-ca"
            d="M34.4,127l4.8,1.4l1.6,3l0,1.3l0.4,0.7l0,0.1l0,0.1l-0.4,1.8l-0.5,1l-0.2,0.1l-0.7,0.3l-1-0.3
		l0.6-2.2l0.1-0.5v0l-0.1-0.2l-3.4-0.7l-0.5-0.1l0-0.9l0-0.3l-0.1-0.7l-0.5-2.6l-0.9-0.6L34.4,127z	"
          >
            <title id="t224">Yolo, CA</title>
          </path>
        </g>
        <path
          id="FIPS_06095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M31,136.4l2,0.6l0-0.1l0-0.1l0,0l-0.1-0.1l0-0.1l0-0.1l0.5-1.6l1.4,0.4l0-0.1l0-0.1l0-0.2
		l0-0.1l0-0.3l-0.2-0.7l0-0.1l0-0.1l0.5-0.9l0-0.1l0.5,0.1l3.4,0.7l0.1,0.2v0l-0.1,0.5l-0.6,2.2l1,0.3l-0.8,1.4l-1.1,1.1l-1,0.1
		L36,139l-0.1,0.1l-0.1,0.1l-0.1,0l-0.1,0l-2.1-0.5l-0.5-0.1l-0.9-0.5L31,136.4L31,136.4	"
        >
          <title id="t219">Solano, CA</title>
        </path>

        <path
          id="FIPS_06055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M33.7,127.6l0.9,0.6l0.5,2.6l0.1,0.7l0,0.3l0,0.9l0,0.1l-0.5,0.9l0,0.1l0,0.1l0.2,0.7l0,0.3
		l0,0.1l0,0.2l0,0.1l0,0.1l-1.4-0.4l-0.5,1.6l0,0.1l0,0.1l0.1,0.1l0,0l0,0.1l0,0.1l-2-0.6l0.4,0.1l0.3-0.5l0-0.3l0-0.3l-0.1-1
		l-0.7-2.4l-0.4-1.1l0-0.8l0.2-0.6l1.7,0l1.2-1l0.1-0.2L33.7,127.6z	"
        >
          <title id="t222">Napa, CA</title>
        </path>
        <path
          id="FIPS_06097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M22.4,125.6l0.4,0l1.3,0l2.9,0.2l2.5,0.8l1.2,2.8l-0.2,0.6l0,0.8l0.4,1.1l0.7,2.4l0.1,1l0,0.3
		l0,0.3l-0.3,0.5l-0.4-0.1l0,0.1l-1,0.3l-1.1-1.3l-2.1-2.5l-0.1,0l-0.8,0l-0.1,0.1l-0.6-2.3l-2.1-4L22.4,125.6z	"
        >
          <title id="t223">Sonoma, CA</title>
        </path>

        <path
          id="FIPS_06057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M58.6,126.5l-0.4,1.6l-6.1-1.6l-0.4,0l-0.5,0.1l-1.4,0.6l-0.7,0.4l-0.5,0.2l-0.5,0.4l-0.1,0.1
		l-0.1,0.2l-0.1,0.1l-0.6,0.6l-0.3,0.1l-1.4-0.5l-0.1-0.1l-0.5-0.4l0.7-2.5l0.3-0.4l0.9-0.6l0.8-0.4l0.5-0.1l0.2,0l0.3,0.1l0.1-0.2
		l0.2-0.1l1.6,0.1l1.3-0.3l0,0l0.1-0.1l0.3-0.2l0.2,0l0.7,0.2l0.2,0.3l0.1,0.6l0.2,0.2l0.1,0.1L58.6,126.5z	"
        >
          <title id="t226">Nevada, CA</title>
        </path>
        <path
          id="FIPS_06091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M49.6,121.5l0.9-0.6l0.1-0.5l0.3-0.2l0.5-0.1l1.8,1.4l2,0.5l2.9,0.8l1.4,0.2l-0.9,3.5
		l-4.7-1.2l-0.1-0.1l-0.2-0.2l-0.1-0.6l-0.2-0.3l-0.7-0.2l-0.2,0l-0.3,0.2l-0.1,0.1l0,0l-1.3,0.3l-1.6-0.1l-0.2,0.1l-0.1,0.2
		L49.6,121.5z	"
        >
          <title id="t227">Sierra, CA</title>
        </path>
        <path
          id="FIPS_06115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M48.8,121.9l0.8-0.4l-1,3.1l-0.3-0.1l-0.2,0l-0.5,0.1l-0.8,0.4l-0.9,0.6l-0.3,0.4l-0.7,2.5
		l-1.4,0.1l-0.4-0.1l-0.2,0l-0.7,0.1l-0.2,0.2l-0.1,0.1l0-1.3l0.4-2.7l0.1-0.2l0.2-0.4l0.1,0l1.3,0.1l1-0.1l0.4-0.2L48.8,121.9z	"
        >
          <title id="t228">Yuba, CA</title>
        </path>
        <path
          id="FIPS_06101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M42.6,124.2L42.6,124.2l-0.2,0.4l-0.1,0.2l-0.4,2.7l0,1.3l0.1-0.1l0.2-0.2l0.7-0.1l0.2,0
		l0.4,0.1l-0.2,0.9l-0.5-0.1l-0.8,2.4l-1.1-0.3l-1.6-3l0.4-0.8l-0.3-1.5l-0.3-0.6l0.1-0.6l0.8-1.4L42.6,124.2z	"
        >
          <title id="t229">Sutter, CA</title>
        </path>
        <path
          id="FIPS_06011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M40.3,122.4l-0.5,0.9l-0.8,1.4l-0.1,0.6l0.3,0.6l0.3,1.5l-0.4,0.8l-4.8-1.4l-0.5-0.6l0-0.1
		l-0.3-1.3l0-0.9l-1-1.6l-0.3-0.3l-0.5-0.8l-0.1-0.4l0.2-0.3l0.4-0.4L40.3,122.4z	"
        >
          <title id="t230">Colusa, CA</title>
        </path>
        <path
          id="FIPS_06033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M32.3,120.1l-0.4,0.4l-0.2,0.3l0.1,0.4l0.5,0.8l0.3,0.3l1,1.6l0,0.9l0.3,1.3l0,0.1l0.5,0.6
		l-0.7,0.6l0,0.7l-0.1,0.2l-1.2,1l-1.7,0l-1.2-2.8l-0.8-0.9l-0.2-0.4l-0.6-1.5l-0.2-0.7l0-0.1l0.1-0.2l0.2-0.5l0.2-0.4l0.4-0.1
		l0.4-0.5l0.1-0.5l-0.1-1.8l0.1-0.4l0.1-0.2l0.3-0.6l0.4-0.1l0.8,0.3l0.5,0l0.2-0.4l0.1-0.2l1.4,0.4l-0.3,1.3l-0.1,0.4L32.3,120.1z	
		"
        >
          <title id="t231">Lake, CA</title>
        </path>
        <path
          id="FIPS_06007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M40.3,116.8l-0.1-0.2l0.1-0.4l0.4-0.5l2.3,0.6l0.3,0l0.3-0.2l0.1-0.2l0.1-0.2l0.1-0.2l0.4-0.3
		l1.7-1.1l0.5,0.1l0.6-0.1l0.1-0.1l0.1-0.3l0.3,0.1l0.1,0.6l0,0.3l0,0.2l-0.2,0.2l-0.8,2.3l1.4,2.6l0.7,1.6l-3.6,2.1l-0.4,0.2
		l-1,0.1l-1.3-0.1l-2.7-0.9l0.5-0.9l0.8-1.8l0-0.1l-0.4-2.6L40.3,116.8z	"
        >
          <title id="t232">Butte, CA</title>
        </path>
        <path
          id="FIPS_06021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M31.9,114.4l8.4,2.4l0.5,1.2l0.4,2.6l0,0.1l-0.8,1.8l-8.1-2.3l0.3-0.8l0.1-0.4l0.3-1.3
		l-1.4-0.4L31.9,114.4z	"
        >
          <title id="t233">Glenn, CA</title>
        </path>
        <path
          id="FIPS_06063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.8,110.2l1.6,0.4l2.5,0.7l-0.6,2.4l0.1,0.3l0.9,0.8l0.4,0.1l0.2,0l0.1-0.3l1-0.8l0.3-0.1
		l0.4,0.1l1.7,1.2l2.2,2.6l0.3,0.4l0.5,2.1l0,0.4l-0.1,0.4l-0.5,1.4l-0.5,0.6l-2.9-0.8l-2-0.5l-1.8-1.4l-0.5,0.1l-0.3,0.2l-0.1,0.5
		l-0.9,0.6l-0.8,0.4l-0.7-1.6l-1.4-2.6l0.8-2.3l0.2-0.2l0-0.2l0-0.3l-0.1-0.6l-0.3-0.1l0.9-0.6l0,0l0.1-0.1l0.3-0.9l-0.1-0.6l-0.1,0
		l-0.7-0.3l0,0l0-0.1l0-0.1l0.1-0.9L47.8,110.2z	"
        >
          <title id="t234">Plumas, CA</title>
        </path>
        <path
          id="FIPS_06103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.8,110.2l0,0.2l-0.1,0.9l0,0.1l0,0.1l0,0l0.7,0.3l0.1,0l0.1,0.6l-0.3,0.9l-0.1,0.1l0,0
		l-0.9,0.6l-0.1,0.3l-0.1,0.1l-0.6,0.1l-0.5-0.1l-1.7,1.1l-0.4,0.3l-0.1,0.2l-0.1,0.2l-0.1,0.2l-0.3,0.2l-0.3,0l-2.3-0.6l-0.4,0.5
		l-0.1,0.4l0.1,0.2l-8.4-2.4l0-0.1v-0.6l0.3-0.6l0.3-0.2l0.1-0.2l0-0.4l0-0.1l0-0.2l0.2-1.8l0.2-0.7l0,0l0.1-0.6l0-0.1l0-0.1
		l-0.6-0.7l0.8-0.1l1.4,0l1.1,0l2.3,0.3l0.6,0.4l0.9,0.3l0.3,0.1l1.2,0.1l0.9,0l0.8,0l1.5,0.2l1.4,0.3L47.8,110.2z	"
        >
          <title id="t235">Tehama, CA</title>
        </path>
        <path
          id="FIPS_06045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M22.4,108.8l4.5,1.3l-0.1,0.3l5.8,1.7l0,0.1l0,0.4l-0.1,0.2l-0.3,0.2l-0.3,0.6v0.6l0,0.1
		l-0.3,2.9l-0.1,0.2l-0.2,0.4l-0.5,0l-0.8-0.3l-0.4,0.1l-0.3,0.6l-0.1,0.2l-0.1,0.4l0.1,1.8l-0.1,0.5l-0.4,0.5l-0.4,0.1l-0.2,0.4
		l-0.2,0.5l-0.1,0.2l0,0.1l0.2,0.7l0.6,1.5l0.2,0.4l0.8,0.9l-2.5-0.8l-2.9-0.2l-1.3,0l-0.4,0l-0.5-0.8l-0.7-1.5l0.5-5.7l0-0.2l0-0.1
		l0.2-0.5l0.2-0.5l0.2-0.3l0.1-0.2l0.2-0.2l0.1-0.1l0-0.1l0,0l0.2-0.3l0-0.1l0.2-1.3l0-0.3l0-2l0,0l-0.4-1.2l-0.2-0.6L22.4,108.8z	"
        >
          <title id="t236">Mendocino, CA</title>
        </path>
        <path
          id="FIPS_06023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M31,92.7l1.5,0.4l0.2,0.3l-0.1,2.5L32.4,96l-0.2,0.2l-0.3,0.6l0,0.4l0,0.1l0,0.6l-0.7,0.7
		L30.9,99l-1,0.8l-0.3,1.5l-2.6,8.9l-4.5-1.3l-0.2-0.4l-1.9-3.7l-0.1-0.2l0.2-2.3l0-0.1l0.8-1.2l0.6-0.7l0.2-0.2l0.4-0.4l0.6-0.6
		l0.7-0.7l0.4-0.4l0.3-0.4l0.4-0.6l0.4-0.7l0.2-0.5l0-0.3l1.2-2.9l0.9-2.1l1.7,0.5l1.1,0.3L30.1,92l0.4,0.5L31,92.7z	"
        >
          <title id="t237">Humboldt, CA</title>
        </path>
        <path
          id="FIPS_06105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M32.5,95.9l0.5,0.4l0.4,0.4l0.7,1.1l1.3,1.4l0.8,0.4l0.2,0l0.2-0.2l0.1-0.2l-0.1-0.6l1.4-1.5
		l2-0.8l1.1,0.7L41,98.3l0.2,0.1l0.2,0.2l0,0.1l-0.1,0.5l-0.1,0.1l-0.1,0.1l-1.1,1l-0.4,0.1l-0.1,0l-2.6,3.1l-1.7,2.1l-1.5,0.7
		l-1.2,1l-0.1,0.5l0.6,0.7l0,0.1l0,0.1l-0.1,0.6l0,0l-0.2,0.7l-0.2,1.8l0,0.2l-5.8-1.7l0.1-0.3l2.6-8.9l0.3-1.5l1-0.8l0.3-0.3
		l0.7-0.7l0-0.6l0-0.1l0-0.4l0.3-0.6l0.2-0.2L32.5,95.9z	"
        >
          <title id="t238">Trinity, CA</title>
        </path>
        <path
          id="FIPS_06089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M50.8,101l1.1,0.3l-0.9,3.3l0,0.4l-1.2,4.4l-0.4,1.2l-1.6-0.4l-2-0.6l-1.4-0.3l-1.5-0.2
		l-0.8,0l-0.9,0l-1.2-0.1l-0.3-0.1l-0.9-0.3l-0.6-0.4l-2.3-0.3l-1.1,0l-1.4,0l-0.8,0.1l0.1-0.5l1.2-1l1.5-0.7l1.7-2.1l2.6-3.1l0.1,0
		l0.4-0.1l1.1-1l0.1-0.1l0.1-0.1l0.1-0.5l0-0.1l-0.2-0.2L41,98.3l1.9,0.5l2.7,0.8L50.8,101z	"
        >
          <title id="t239">Shasta, CA</title>
        </path>
        <path
          id="FIPS_06035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M64.3,104.6l-1,4l-1.2,4.6l-0.6,2.2l-0.2,0.7l0,0l-0.6,2.4l-1,3.7l-0.2,0.7l-1.4-0.2l0.5-0.6
		l0.5-1.4l0.1-0.4l0-0.4l-0.5-2.1l-0.3-0.4l-2.2-2.6l-1.7-1.2l-0.4-0.1l-0.3,0.1l-1,0.8l-0.1,0.3l-0.2,0l-0.4-0.1l-0.9-0.8l-0.1-0.3
		l0.6-2.4l-2.5-0.7l0.4-1.2l1.2-4.4l0-0.4l0.9-3.3L64.3,104.6z	"
        >
          <title id="t240">Lassen, CA</title>
        </path>
        <path
          id="FIPS_06049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M53.6,90.9l5.2,1.5l1.7,0.5l0,0l3.4,0.9l0.4,0.1l2.7,0.7l-2.6,10.2l-12.4-3.3l-1.1-0.3
		l0.8-3.1l1.2-4.4l0,0l0,0l0.5-1.8l0.1-0.3L53.6,90.9z	"
        >
          <title id="t241">Modoc, CA</title>
        </path>
        <path
          id="FIPS_08083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M172.4,172.2l-0.4,0.4l-2.3,3l-0.1,0.1l-0.9,1.4l-1.4,2.5l-0.1,0.4l-6.7-0.9l0.9-6.3l1.5-1.7
		l6.1,0.8l1.2,0.1l0.9,0L172.4,172.2z	"
        >
          <title id="t242">Montezuma, CO</title>
        </path>
        <path
          id="FIPS_08067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M172.4,172.2l4.9,0.6l-1,8.3l-9.1-1.1l0.1-0.4l1.4-2.5l0.9-1.4l0.1-0.1l2.3-3L172.4,172.2z	"
        >
          <title id="t243">La Plata, CO</title>
        </path>
        <path
          id="FIPS_08099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M225.8,169.2l7,0.4l0,0.1l-0.4,6.8l-0.1,1.2l-7.1-0.5l0.2-2.3h0.1l0-0.2L225.8,169.2z	"
        >
          <title id="t244">Prowers, CO</title>
        </path>
        <path
          id="FIPS_08011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M225.8,169.2l-0.4,5.6l0,0.2h-0.1l-0.2,2.3l-3.3-0.2l-3.3-0.3l0.7-8.1L225.8,169.2z	"
        >
          <title id="t245">Bent, CO</title>
        </path>
        <path
          id="FIPS_08061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M221.8,164.4l1.1,0l4.5,0.3l2.5,0.1l3.2,0.2l-0.3,4.5l-7-0.4l-6.6-0.5l-1-0.1l0.2-3.3l0.4-0.1
		l2.1,0.2l0.8,0L221.8,164.4z	"
        >
          <title id="t246">Kiowa, CO</title>
        </path>
        <path
          id="FIPS_08017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M233.4,159.6l-0.3,4.5l-0.1,1.1l-3.2-0.2l-2.5-0.1l-4.5-0.3l-1.1,0l0.5-5.5l1.1,0.1l3.3,0.3
		l2.1,0.1l1.5,0L233.4,159.6z	"
        >
          <title id="t247">Cheyenne, CO</title>
        </path>
        <path
          id="FIPS_08063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,152.1l3.5,0.2l7.4,0.4l0,0.1l-0.3,5.6l-0.1,1.1l-3.1-0.2l-1.5,0l-2.1-0.1l-3.3-0.3
		l-1.1-0.1l0.1-1.1l0.2-2.1L222.9,152.1z	"
        >
          <title id="t248">Kit Carson, CO</title>
        </path>
        <path
          id="FIPS_08125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M228.5,141.1l6,0.4l-0.1,1.2l-0.3,4.5l-0.3,5.6l-7.4-0.4l0.3-3.9l0.1-1.8l0.4-4.5l0.2-1.1
		L228.5,141.1z	"
        >
          <title id="t249">Yuma, CO</title>
        </path>
        <path
          id="FIPS_08121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M217.9,146l2.3,0.2l0.2-2.1l0.2-2.4l0.1-1.1l6.7,0.5l-0.2,1.1l-0.4,4.5l-0.1,1.8l-0.3,3.9
		l-3.5-0.2l-5.4-0.4L217.9,146z	"
        >
          <title id="t250">Washington, CO</title>
        </path>
        <path
          id="FIPS_08095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234.8,137.5l0,0.7l-0.2,3.3l-6-0.4l0.4-4L234.8,137.5z	"
        >
          <title id="t251">Phillips, CO</title>
        </path>
        <path
          id="FIPS_08115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.5,133.9l5.5,0.4l-0.2,3.3l-5.8-0.4l0.2-3.3L229.5,133.9z	"
        >
          <title id="t252">Sedgwick, CO</title>
        </path>
        <path
          id="FIPS_08075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M220.3,133.2l1.9,0.1l7,0.5l-0.2,3.3l-0.4,4l-1.1-0.1l-6.7-0.5l-1-1.2l0.2-2.3l0.1,0l0.3-3.6
		L220.3,133.2z	"
        >
          <title id="t253">Logan, CO</title>
        </path>
        <path
          id="FIPS_08087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M217.9,146l-4.3-0.4l0.6-6.8l3.2,0.3l1.2,0.1l1.1,0.1l1,1.2l-0.1,1.1l-0.2,2.4l-0.2,2.1
		L217.9,146z	"
        >
          <title id="t254">Morgan, CO</title>
        </path>
        <path
          id="FIPS_08009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M221.8,177.1l3.3,0.2l7.1,0.5l-0.2,3.3l-0.3,5.1l-3.2-0.2l-5.3-0.4l-1.3-0.1l-0.9-0.1l0.1-1.6
		l0.3-3.3l0.1,0L221.8,177.1z	"
        >
          <title id="t255">Baca, CO</title>
        </path>
        <path
          id="FIPS_08089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.2,168.8l-0.7,8.1l-6.6-0.5l0.1-1.2l0.5-5.3l0.2,0.1l1,0.3l1,0.2l2.1,0.2l1.2-0.7l0.2-1.2
		L219.2,168.8z	"
        >
          <title id="t256">Otero, CO</title>
        </path>
        <path
          id="FIPS_08025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M212.9,164.9l5.5,0.5l-0.2,3.3l-0.2,1.2l-1.2,0.7l-2.1-0.2l-1-0.2l-1-0.3l-0.2-0.1
		L212.9,164.9z	"
        >
          <title id="t257">Crowley, CO</title>
        </path>
        <path
          id="FIPS_08073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,152.1l-0.3,3.6l-0.2,2.1l-0.1,1.1l-0.5,5.5l-0.1,1.1l-0.8,0l-2.1-0.2l-0.4,0.1
		l-5.5-0.5l0.4-4.5l3.3,0.3l0.3-3.4l0.5-5.7l0.1,0L222.9,152.1z	"
        >
          <title id="t258">Lincoln, CO</title>
        </path>

        <path
          id="FIPS_08123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M215.6,132.8l4.6,0.4l0,0.3l-0.3,3.6l-0.1,0l-0.2,2.3l-1.1-0.1l-1.2-0.1l-3.2-0.3l-0.6,6.8
		l-8.1-0.7l0-0.3l-0.4,0l-0.1,0.3l-0.3,0l0.3-3.4l0.1-1.1l1.1,0.1l0.1-1.1l0.7-7.3L215.6,132.8z	"
        >
          <title id="t261">Weld, CO</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19740"
              ? `metroArea clickedArea state-co`
              : `metroArea ${colorCode[19740]} state-co`
          }
          id="FIPS_19740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_08001"
            className="FIPS_19740 st0 state-co"
            d="M205.3,144.9l8.3,0.7l4.3,0.4l-0.3,3.4l-2.1-0.2l-5.4-0.4l-2.6-0.3l-0.6-0.1l-0.8-0.1l0.9-0.9
		l0.7,0l0.1-0.7l-0.5-0.1l-1.2,0.9l-1.6-0.1l0.2-1.6l0.3-0.1l0.1-0.7l0.2,0	"
          >
            <title id="t262">Adams, CO</title>
          </path>
          <path
            id="FIPS_08005"
            className="FIPS_19740 st0 state-co"
            d="M206.1,148.4l0.8,0.1l0.6,0.1l2.6,0.3l5.4,0.4l2.1,0.2l-0.2,2.2l-0.1,0l-9.3-0.8l-3.8-0.4
		l0-0.7l0-0.1v0h0l1.7,0l0.2-0.4l-0.1-0.7L206.1,148.4	"
          >
            <title id="t260">Arapahoe, CO</title>
          </path>

          <path
            id="FIPS_08014"
            className="FIPS_19740 st0 state-co"
            d="M204,146.1l0-0.1l0.3-0.4l0.4,0l0.1-0.7l0.3,0l0.1-0.3l0.4,0l0,0.3l-0.2,0l0,0.3l-0.2,0
		l-0.1,0.7l-0.5,0.2L204,146.1z	"
          >
            <title id="t305">Broomfield, CO</title>
          </path>
          <path
            id="FIPS_08019"
            className="FIPS_19740 st0 state-co"
            d="M198.3,146.2l0.6,0.2l0.5,0.5l0.3,0.3l1.4,0.6l-0.2,2.3l-4.2-0.4l0.6-0.5l0-0.1l0-0.3
		l-0.1-0.1l-0.2,0l-0.9-0.5l-0.1-0.2l0.1-0.3l0.2-0.3l0.9-0.7l0.6-0.1l0.2-0.1l0.5-0.4L198.3,146.2z	"
          >
            <title id="t284">Clear Creek, CO</title>
          </path>
          <path
            id="FIPS_08031"
            className="FIPS_19740 st0 state-co"
            d="M204.5,147.6l1.5,0.1l1.2-0.9l0.5,0.1l-0.1,0.7l-0.7,0l-0.9,0.9l0,0.2l0.1,0.7l-0.2,0.4
		l-1.7,0l0-0.5l0-0.2L204.5,147.6z	"
          >
            <title id="t263">Denver, CO</title>
          </path>

          <path
            id="FIPS_08035"
            className="FIPS_19740 st0 state-co"
            d="M204.3,150.5l3.8,0.4l-0.5,5.6l-3.7-0.3l-2.9-0.3L204.3,150.5z	"
          >
            <title id="t264">Douglas, CO</title>
          </path>
          <path
            id="FIPS_08039"
            className="FIPS_19740 st0 state-co"
            d="M213.3,160.4l0.3-3.4l-6-0.5l0.5-5.6l9.3,0.8l-0.5,5.7l-0.3,3.4L213.3,160.4z	"
          >
            <title id="t259">Elbert, CO</title>
          </path>
          <path
            id="FIPS_08093"
            className="FIPS_19740 st0 state-co"
            d="M200.8,150.2l-0.6,5.6l0.7,0.1l-0.5,5.6l-1.2-0.1l-2.9-0.3l-2.3-0.2l0.3-0.3l0.3-0.9l-0.1-1.2
		l-0.2-0.3l-0.5-0.5l-0.2,0l-0.1,0l0,0.1l-0.1,0.1l-0.1,0l-0.4-0.2l-0.6-1.3l-0.1-0.2l0.1-0.3l0.2-0.8l0-0.9l0.1-0.9l0.1-0.4
		l0.4-0.7l0.2-0.2l1.1,0.3l1.7-1.7l0.4-0.6L200.8,150.2z	"
          >
            <title id="t281">Park, CO</title>
          </path>
          <path
            id="FIPS_08059"
            className="FIPS_19740 st0 state-co"
            d="M204.7,146l-0.2,1.6l-0.1,1.4l0,0.2l0,0.5h0v0l0,0.1l0,0.7l-3.3,5.4h0l-0.7-0.1l0.6-5.6
		l0.2-2.3l0.2-2.1l2.8,0.3l0,0.1l0.4,0	"
          >
            <title id="t282">Jefferson, CO</title>
          </path>
          <path
            id="FIPS_08047"
            className="FIPS_19740 st0 state-co"
            d="M198.6,145.2l1.7,0.2l0.6,0l0.4,0.1l0,0.3l-0.2,2.1l-1.4-0.6l-0.3-0.3l-0.5-0.5l-0.6-0.2
		L198.6,145.2z	"
          >
            <title id="t283">Gilpin, CO</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "17820"
              ? `metroArea clickedArea state-co`
              : `metroArea ${colorCode[17820]} state-co`
          }
          id="FIPS_17820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_08041"
            className="FIPS_17820 st0 state-co"
            d="M213.3,160.4l-0.4,4.5l-8.9-0.8l0.2-1.7l0.1-0.8l0.1-1.1l-0.8-1l0.2-2.1l0.1-1.3l3.7,0.3
		l6,0.5L213.3,160.4z	"
          >
            <title id="t265">El Paso, CO</title>
          </path>
          <path
            id="FIPS_08119"
            className="FIPS_17820 st0 state-co"
            d="M200.9,155.9L200.9,155.9l2.9,0.3l-0.1,1.3l-0.2,2.1l0.8,1l-0.1,1.1l-0.1,0.8l-1.7-0.1
		l-1.3-0.1l0-0.3l-0.4-0.4l-0.4,0L200.9,155.9z	"
          >
            <title id="t266">Teller, CO</title>
          </path>
        </g>
        <path
          id="FIPS_08101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.1,164.1l8.9,0.8l-0.5,4.9l-0.5,5.3l-2.8-1.3l-2.9-1.3l-3.5-0.1l-0.4-0.3l-0.2-0.2
		l0.4-4.4l1.1,0.1L204.1,164.1z	"
        >
          <title id="t267">Pueblo, CO</title>
        </path>
        <path
          id="FIPS_08071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M209.1,173.8l2.8,1.3l-0.1,1.2l6.6,0.5l3.3,0.3l-0.2,3.4l-0.1,0l-0.3,3.3l-0.1,1.6l-9.4-0.7
		l-7.4-0.6l-2.7-0.3l-1.6-0.2l0.4-3.9h0.4l3.9-1.1l0.4-0.3l1.8-2.1l1.2-1.8L209.1,173.8z	"
        >
          <title id="t268">Las Animas, CO</title>
        </path>
        <path
          id="FIPS_08055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M197.9,171.7l0.5,0.1l0.1,0l1.2-0.3l1.6-0.7l0.9,1.1l0.2,0.2l0.4,0.3l3.5,0.1l2.9,1.3l-1,0.7
		l-1.2,1.8l-1.8,2.1l-0.4,0.3l-3.9,1.1h-0.4l0.3-1.5l-0.4-2.6l-0.9-0.7l-0.1,0l-0.7,0.1l-0.8,0.3l-0.5,0.4l0.5-2.2L197.9,171.7z	"
        >
          <title id="t269">Huerfano, CO</title>
        </path>
        <path
          id="FIPS_08023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M194.5,178.4l2.9-2.6l0.5-0.4l0.8-0.3l0.7-0.1l0.1,0l0.9,0.7l0.4,2.6l-0.3,1.5l-0.4,3.9
		l-0.7-0.1l-5.1-0.5l-0.4-0.4l-0.1-0.1l0-0.1l0.1-0.3l0.3-0.5l0.2-0.6l0.2-1.6L194.5,178.4z	"
        >
          <title id="t270">Costilla, CO</title>
        </path>
        <path
          id="FIPS_08021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M191.6,177.5l2.9,0.9l0.1,1.1l-0.2,1.6l-0.2,0.6l-0.3,0.5l-0.1,0.3l0,0.1l0.1,0.1l0.4,0.4
		l-2.9-0.3l-4.8-0.5l-0.1-0.3l-1.3-2.8l-0.3-0.2l0.3-2.3L191.6,177.5z	"
        >
          <title id="t271">Conejos, CO</title>
        </path>
        <path
          id="FIPS_08003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M197.9,173.6l-0.5,2.2l-2.9,2.6l-2.9-0.9l0.5-4.5L197.9,173.6z	"
        >
          <title id="t272">Alamosa, CO</title>
        </path>
        <path
          id="FIPS_08105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M185.6,171.2l1.1,0.1l-0.1,1.1l5.5,0.6l-0.5,4.5l-6.5-0.7l-0.3,0l0.2-1.5l0.4-1.8L185.6,171.2
		z	"
        >
          <title id="t273">Rio Grande, CO</title>
        </path>
        <path
          id="FIPS_08027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M195.2,166.6l2.5,0.3l2.1,0.3l2.9,0.3l-0.4,4.4l-0.9-1.1l-1.6,0.7l-1.2,0.3l-0.1,0l-0.5-0.1
		l-0.3-0.4l-0.9-1.5l-0.5-1.5l-0.1-0.3L195.2,166.6z	"
        >
          <title id="t274">Custer, CO</title>
        </path>
        <path
          id="FIPS_08043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M200.4,161.5l0.4,0l0.4,0.4l0,0.3l1.3,0.1l1.7,0.1l-0.5,5.1l-1.1-0.1l-2.9-0.3l-2.1-0.3
		l-2.5-0.3l-1.9-2.6l1.1-0.8l0.3-0.6l0.1-0.5l0-0.1l0-0.2l-0.3-0.8l0,0l-0.2-0.1l-0.2-0.1l2.3,0.2l2.9,0.3L200.4,161.5z	"
        >
          <title id="t275">Fremont, CO</title>
        </path>
        <path
          id="FIPS_08109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M190.9,164.1l2.4-0.1l1.9,2.6l0.9,1.4l0.1,0.3l0.5,1.5l0.9,1.5l0.3,0.4l0,1.9L192,173
		l-5.5-0.6l0.1-1.1l-1.1-0.1l-0.1-0.5l-1.6-1.3l-0.1-0.1l-0.7-0.2l-0.3,0.2l0,0.1l0.3-2.5l0.4-3.6L190.9,164.1z	"
        >
          <title id="t276">Saguache, CO</title>
        </path>
        <path
          id="FIPS_08015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M188.5,155.5l3.8,0.4l0.1,0.2l0.6,1.3l0.4,0.2l0.1,0l0.1-0.1l0-0.1l0.1,0l0.2,0l0.5,0.5
		l0.2,0.3l0.1,1.2l-0.3,0.9l-0.3,0.3l0.2,0.1l0.2,0.1l0,0l0.3,0.8l0,0.2l0,0.1l-0.1,0.5l-0.3,0.6l-1.1,0.8l-2.4,0.1l-0.7-1l-0.8-2.1
		l-0.1-0.5l0.3-1.6l0.1-0.2l0.1-0.1l0-1.2l-1.7-1.2L188.5,155.5z	"
        >
          <title id="t277">Chaffee, CO</title>
        </path>
        <path
          id="FIPS_08051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M180.8,152l0.1,0.8l0.2,0.4l0.6,0.8l2,0.2l0.1,0l0.6,0.7l0,0.2l0.2,0.3l0.6,0.5l0.8,0.3l0.3,0
		l0.2-0.1l0.4-0.5l0.1-0.2l0.5-0.1l0.1,0l0.9,0.8l1.7,1.2l0,1.2l-0.1,0.1l-0.1,0.2l-0.3,1.6l0.1,0.5l0.8,2.1l0.7,1l-7.5-0.9
		l-0.4,3.6l-5.7-0.7l-0.4-2.1l1.3,0.2l0.6-4.7l0.9-7.1L180.8,152z	"
        >
          <title id="t278">Gunnison, CO</title>
        </path>
        <path
          id="FIPS_08097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M183.7,150.9l6.8,0.8l-1.9,3.8l-0.3,0.7l-0.9-0.8l-0.1,0l-0.5,0.1l-0.1,0.2l-0.4,0.5l-0.2,0.1
		l-0.3,0l-0.8-0.3l-0.6-0.5l-0.2-0.3l0-0.2l-0.6-0.7l-0.1,0l-2-0.2l-0.6-0.8l-0.2-0.4l-0.1-0.8l-0.2-1.5L183.7,150.9z	"
        >
          <title id="t279">Pitkin, CO</title>
        </path>
        <path
          id="FIPS_08065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M192.6,151.8l0.7,0.1l-0.2,0.2l-0.4,0.7l-0.1,0.4l-0.1,0.9l0,0.9l-0.2,0.8l-0.1,0.3l-3.8-0.4
		l1.9-3.8L192.6,151.8z	"
        >
          <title id="t280">Lake, CO</title>
        </path>

        <path
          id="FIPS_08117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M191.2,144.5l0.4,0l1.6,0.6l0.9,0.8l0.4,0.5l0.1,0.6l0,0.5l0.3,0.5l0.3,0.1l0.5,0l0.2-0.1
		l-0.1,0.3l0.1,0.2l0.9,0.5l0.2,0l0.1,0.1l0,0.3l0,0.1l-0.6,0.5l-0.4,0.6l-1.7,1.7l-1.1-0.3l-0.7-0.1l-0.3-1.9l-1.2-4.4l-0.1-0.4
		L191.2,144.5z	"
        >
          <title id="t285">Summit, CO</title>
        </path>
        <path
          id="FIPS_08037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M189.3,144.3l1.9,0.2l-0.1,0.7l0.1,0.4l1.2,4.4l0.3,1.9l-2.2,0l-6.8-0.8l0.8-7.1l0.8,0.1
		L189.3,144.3z	"
        >
          <title id="t286">Eagle, CO</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14500"
              ? `metroArea clickedArea state-co`
              : `metroArea ${colorCode[14500]} state-co`
          }
          id="FIPS_14500"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_08013"
            className="FIPS_14500 st0 state-co"
            d="M198.6,145.2l0.7-4.2l1,0.1l1.4,0.2l3.4,0.3l-0.3,3.4l-0.1,0.7l-0.3,0l-0.3,0.4l-2.8-0.3
		l0-0.3l-0.4-0.1l-0.6,0L198.6,145.2z	"
          >
            <title id="t287">Boulder, CO</title>
          </path>
        </g>
        <path
          id="FIPS_08049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M189.3,144.3l0.1-1l0.4-4.4l0-1.4l0.3,0.8l0.1,0.1l1.5,0.6l2,0.5l0.4,0l2.1-0.1l0.7-0.5
		l0.6-1.1l1.7,3.1l-0.7,4.2l-0.2,1l-0.1,0.2l-0.5,0.4l-0.2,0.1l-0.6,0.1l-0.9,0.7l-0.2,0.3l-0.2,0.1l-0.5,0l-0.3-0.1l-0.3-0.5l0-0.5
		l-0.1-0.6l-0.4-0.5l-0.9-0.8l-1.6-0.6l-0.4,0L189.3,144.3z	"
        >
          <title id="t288">Grand, CO</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22660"
              ? `metroArea clickedArea state-co`
              : `metroArea ${colorCode[22660]} state-co`
          }
          id="FIPS_22660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_08069"
            className="FIPS_22660 st0 state-co"
            d="M195.1,130.9l8.8,0.9l3.2,0.3l-0.7,7.3l-0.1,1.1l-1.1-0.1l-0.1,1.1l-3.4-0.3l-1.4-0.2l-1-0.1
		l-1.7-3.1l-0.5-1.1l-0.4-1.7l-0.4-1.2l-0.1-0.2l-0.9-1.6L195.1,130.9z	"
          >
            <title id="t289">Larimer, CO</title>
          </path>
        </g>
        <path
          id="FIPS_08057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M188.6,130.1l5.2,0.6l1.3,0.1l0.2,1.2l0.9,1.6l0.1,0.2l0.4,1.2l0.4,1.7l0.5,1.1l-0.6,1.1
		l-0.7,0.5l-2.1,0.1l-0.4,0l-2-0.5l-1.5-0.6l-0.1-0.1l-0.3-0.8l-0.1-0.4l-0.2-1.4l0-0.5l0.7-2l0.1,0l0.2-0.2l0-0.2l0-0.2l-0.2-0.6
		l-0.1-0.2l-0.2-0.2l-0.7-0.4l-0.1,0l-0.1,0l-0.1,0.1l-0.5-0.4l-0.1-0.4l0-0.2L188.6,130.1L188.6,130.1z	"
        >
          <title id="t290">Jackson, CO</title>
        </path>
        <path
          id="FIPS_08107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M184.2,129.6l4.4,0.5l0,0l-0.2,0.3l0,0.2l0.1,0.4l0.5,0.4l0.1-0.1l0.1,0l0.1,0l0.7,0.4
		l0.2,0.2l0.1,0.2l0.2,0.6l0,0.2l0,0.2l-0.2,0.2l-0.1,0l-0.7,2l0,0.5l0.2,1.4l0.1,0.4l0,1.4l-0.4,4.4l-0.1,1l-4-0.4l0.2-2.2l0.2-1.7
		l-3.9-0.4l0.1-1.4l0.5-2.7l0.6-0.6l0.3,0l0.2,0l0.1-1.2L184.2,129.6z	"
        >
          <title id="t291">Routt, CO</title>
        </path>
        <path
          id="FIPS_08081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M178.4,128.9l5.8,0.7l-0.4,4l-0.1,1.2l-0.2,0l-0.3,0l-0.6,0.6L182,138l-0.1,1.4l0,0l-0.1,0
		l-2.6-0.4l-3.9-0.5l-9-1.2l0.8-5.5l0.6-4.5l7.7,1L178.4,128.9z	"
        >
          <title id="t292">Moffat, CO</title>
        </path>
        <path
          id="FIPS_08103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M181.8,139.5l3.9,0.4l-0.2,1.7l-2.7-0.3l-0.2,1.2l-0.1,1.1l-1.2,1l-2.9-0.4l-2.1-0.2l-0.2,1.7
		l-2.7-0.4l-2.2-0.1l-1.1,0.2l-3.3-0.4l0-0.1l-1.5-0.2l1-7.2l9,1.2l3.9,0.5L181.8,139.5L181.8,139.5L181.8,139.5z	"
        >
          <title id="t293">Rio Blanco, CO</title>
        </path>
        <path
          id="FIPS_08045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M185.5,141.6l-0.2,2.2l-0.8-0.1l-0.8,7.1l-3.1-0.4l-15.9-2.1l0.2-1.7l0.3-2.1l1.5,0.2l0,0.1
		l3.3,0.4l1.1-0.2l2.2,0.1l2.7,0.4l0.2-1.7l2.1,0.2l2.9,0.4l1.2-1l0.1-1.1l0.2-1.2L185.5,141.6z	"
        >
          <title id="t294">Garfield, CO</title>
        </path>
        <path
          id="FIPS_08029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M179.6,152.4l-0.9,7.1l-8.7-1.1l0.3-2.1l4.3-2.5l1.2-0.1l1.9-0.1l0.5-0.5l0.3-0.2L179.6,152.4
		z	"
        >
          <title id="t295">Delta, CO</title>
        </path>
        <path
          id="FIPS_08077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M164.7,148.5l15.9,2.1l0.2,1.5l-1.1,0.4l-1.1,0.6l-0.3,0.2l-0.5,0.5l-1.9,0.1l-1.2,0.1
		l-4.3,2.5l-0.3,2.1l-0.3,2.2l-6.8-0.9l0.4-2.8l0.4-2.4l0.1-0.5l0.3-2.3L164.7,148.5z	"
        >
          <title id="t296">Mesa, CO</title>
        </path>
        <path
          id="FIPS_08085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M170.1,158.4l8.7,1.1l-0.6,4.7l-1.3-0.2l0.1-0.3l0-0.1L172,163l0,0.1l0.3,0.9l0.7,0.1l0.3,0.1
		l0.3,0.3l0.1,0.1l-0.1,0.6l-0.1,0.3l-0.2,0l-10.7-1.4l0.4-4.5l6.8,0.9L170.1,158.4z	"
        >
          <title id="t297">Montrose, CO</title>
        </path>
        <path
          id="FIPS_08111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M175.2,169l0.1,0.1l0.2,0.1h0.1l0.3-0.1l0.2-0.1l0.1-0.1l0,0l0-0.1v-0.1l0.1-0.4l0.7,0.1
		l0.4,4.3l-4.9-0.6l0.1-0.4l0.4-0.4l0.6-0.1l0.3-0.5l0-0.2L175.2,169z	"
        >
          <title id="t298">San Juan, CO</title>
        </path>
        <path
          id="FIPS_08033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M173.8,170.6l0,0.2l-0.3,0.5l-0.6,0.1l-0.4,0.4l-0.1,0.4l-1.4-0.2l-0.9,0l-1.2-0.1l-6.1-0.8
		l-1.5,1.7l0.7-5.1l2.2,0.3l0-0.1l0.2,0l5.4,0.7l0.2,0.3l0.1,0.2v0.2l0.1,0.3l1.6-0.1l0.4-0.1l0.2,0.1l0.6,0.5L173.8,170.6z	"
        >
          <title id="t299">Dolores, CO</title>
        </path>
        <path
          id="FIPS_08113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M162.6,164.1l10.7,1.4l0,0.1l0.1,0.4l0.4,1.2l0.1,0.2l0.1,0.1l0.3,0.2l0.3,0.1l0.3,0.2
		l0.3,0.4l0.1,0.3l-0.1,0.2l0,0.1l-1.4,1.5l-0.5-0.6l-0.6-0.5l-0.2-0.1l-0.4,0.1l-1.6,0.1l-0.1-0.3V169l-0.1-0.2l-0.2-0.3l-5.4-0.7
		l-0.2,0l0,0.1l-2.2-0.3L162.6,164.1z	"
        >
          <title id="t300">San Miguel, CO</title>
        </path>
        <path
          id="FIPS_08091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M176.9,164l0.4,2.1l-0.3,2.4l-0.7-0.1l-0.1,0.4v0.1l0,0.1l0,0l-0.1,0.1l-0.2,0.1l-0.3,0.1
		h-0.1l-0.2-0.1l-0.1-0.1l0-0.1l0.1-0.2l-0.1-0.3l-0.3-0.4l-0.3-0.2l-0.3-0.1l-0.3-0.2l-0.1-0.1l-0.1-0.2l-0.4-1.2l-0.1-0.4l0-0.1
		l0.2,0l0.1-0.3l0.1-0.6l-0.1-0.1l-0.3-0.3l-0.3-0.1l-0.7-0.1l-0.3-0.9l0-0.1l4.9,0.6l0,0.1L176.9,164z	"
        >
          <title id="t301">Ouray, CO</title>
        </path>
        <path
          id="FIPS_08053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177.3,166.1l5.7,0.7l-0.3,2.5l-0.7-0.1l-0.7,0.1l-0.4,2.9l0,1.6l-0.3,2.2l-3.6-0.4l0.3-2.8
		l-0.4-4.3L177.3,166.1z	"
        >
          <title id="t302">Hinsdale, CO</title>
        </path>
        <path
          id="FIPS_08079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M182.7,169.3L182.7,169.3l0.4-0.2l0.7,0.2l0.1,0.1l1.6,1.3l0.1,0.5l-0.3,2.2l-0.4,1.8
		l-0.2,1.5l0,0.1l-4.2-0.4l0.1-0.4l0.3-2.2l0-1.6l0.4-2.9l0.7-0.1L182.7,169.3z	"
        >
          <title id="t303">Mineral, CO</title>
        </path>
        <path
          id="FIPS_08007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177,175.6l3.6,0.4l-0.1,0.4l4.2,0.4l0-0.1l0.3,0l-0.3,2.3l0.3,0.2l1.3,2.8l0.1,0.3l-1.4-0.2
		l-2.6-0.3l-1.3-0.3l-4.3-0.5l-0.6-0.1L177,175.6z	"
        >
          <title id="t304">Archuleta, CO</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "25540"
              ? `metroArea clickedArea state-ct`
              : `metroArea ${colorCode[25540]} state-ct`
          }
          id="FIPS_25540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_09003"
            className="FIPS_25540 st0 state-ct"
            d="M510.6,96.2l4.6-1.1l0.4,1.1l1.8,3.8l0,0.1l0.1,0.3l-0.5,0.4l-0.6-0.7l-1.1,0.4l-0.8,0.4
		l-0.2,0.7l-2.3-0.2l-0.8-1.9l0.6-0.3l0.1-2.2l-1.3,0.4L510.6,96.2z	"
          >
            <title id="t306">Hartford, CT</title>
          </path>
          <path
            id="FIPS_09007"
            className="FIPS_25540 st0 state-ct"
            d="M517.1,100.7l2.2,3.5l-1.8,0.7l-1.1-1.4l-0.4-0.5l-0.1-0.1l-0.3,0.2l-0.7-0.7l-0.3-1l0.2-0.7
		l0.8-0.4l1.1-0.4L517.1,100.7z	"
          >
            <title id="t310">Middlesex, CT</title>
          </path>
          <path
            id="FIPS_09013"
            className="FIPS_25540 st0 state-ct"
            d="M519,94.3l0.3,0.9l-0.9,0.2l-0.2,0.1l0.4,1.6l0.4,0.3l0.4,0.6l-0.3,0.3l-0.4,0.4l-1.2,1.8
		l-0.1-0.3l0-0.1l-1.8-3.8l-0.4-1.1l3.5-0.8L519,94.3z	"
          >
            <title id="t312">Tolland, CT</title>
          </path>
        </g>

        <path
          id="FIPS_09005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M510.2,96.3l0.4-0.1l0,1l1.3-0.4l-0.1,2.2l-0.6,0.3l0.8,1.9l-1,1.2l-1.7,1.2l0,0.2l0,0.1
		l0.1,0.1l0.1,0.1l0,0l-0.1,0l-0.5-0.1l-0.8-0.3l-0.1-0.1l-0.2-0.3l-0.5-1.1l-0.1-0.1l-0.3-0.1l-0.9-4.9L510.2,96.3z	"
        >
          <title id="t307">Litchfield, CT</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14860"
              ? `metroArea clickedArea state-ct`
              : `metroArea ${colorCode[14860]} state-ct`
          }
          id="FIPS_14860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_09001"
            className="FIPS_14860 st0 state-ct"
            d="M507.4,103.9l-0.3-1.8l0.3,0.1l0.1,0.1l0.5,1.1l0.2,0.3l0.1,0.1l0.8,0.3l0.5,0.1l0.1,0l0,0
		l0.4,0.1l0.8,0.2l1.7,1.2l0,0.6l-0.1,0.3l0,0.1l0,0.6l0,0.1l0.2,0.1l-0.6,0.2l-1.6,1.2l-2.2,1.9l-0.1,0.1l0,0.1l-1-1.3l0.7-0.7
		l0.1-0.1l0.3-2.1l-0.2-0.9L507.4,103.9z	"
          >
            <title id="t308">Fairfield, CT</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "35300"
              ? `metroArea clickedArea state-ct`
              : `metroArea ${colorCode[35300]} state-ct`
          }
          id="FIPS_35300"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_09009"
            className="FIPS_35300 st0 state-ct"
            d="M514.4,101.4l0.3,1l0.7,0.7l0.3-0.2l0.1,0.1l0.4,0.5l1.1,1.4l-0.5,0l-0.3,0.1l-1.3,0.4
		l-0.8,0.3l-0.4,0.1l-0.2-0.3l-0.1,0l-1.1,1.3l-0.1,0.2l-0.2,0.3l0,0v0l-0.2-0.1l0-0.1l0-0.6l0-0.1l0.1-0.3l0-0.6l-1.7-1.2l-0.8-0.2
		l-0.4-0.1l-0.1-0.1l-0.1-0.1l0-0.1l0-0.2l1.7-1.2l1-1.2L514.4,101.4z	"
          >
            <title id="t309">New Haven, CT</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "35980"
              ? `metroArea clickedArea state-ct`
              : `metroArea ${colorCode[35980]} state-ct`
          }
          id="FIPS_35980"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_09011"
            className="FIPS_35980 st0 state-ct"
            d="M523.3,98.9l0.2,3.6l-1.2,0.3L520,104l-0.5,0.2l-0.1,0l-0.1,0l-2.2-3.5l0.5-0.4l1.2-1.8
		l0.6,0.4l0.3,0.2l2-0.2l0.8-0.3l0.7-0.1L523.3,98.9z	"
          >
            <title id="t311">New London, CT</title>
          </path>
        </g>
        <path
          id="FIPS_09015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M521.9,93.8l1,3.5l0.3,1.1l-0.7,0.1l-0.8,0.3l-2,0.2l-0.3-0.2l-0.6-0.4l0.4-0.4l0.3-0.3
		l-0.4-0.6l-0.4-0.3l-0.4-1.6l0.2-0.1l0.9-0.2l-0.3-0.9l0.4-0.1l2.4-0.6L521.9,93.8z	"
        >
          <title id="t313">Windham, CT</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "37980"
              ? `metroArea clickedArea state-pa state-nj state-de state-md`
              : `metroArea ${colorCode[37980]} state-pa state-nj state-de state-md`
          }
          id="FIPS_37980"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_10003"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M494.3,130.3l-0.4,1.2l-0.2,0l-0.4,0.6l-0.2,0.4v0.1l0,0.1l0,0.1l0.5,1.2l1.1,1.5l-2.2,1.4
		l-0.3-1l-1.2-4.3l1.5-1.9l1.8,0.1L494.3,130.3z	"
          >
            <title id="t314">New Castle, DE</title>
          </path>
          <path
            id="FIPS_24015"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M487.8,132.4l3.3-0.7l1.2,4.3l-2.3,0.5l-1.2-2l-2-1.9L487.8,132.4z	"
          >
            <title id="t1205">Cecil, MD</title>
          </path>
          <path
            id="FIPS_34005"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M500.2,124l1.3-0.2l0.5,0.7l0.2,0.3l2.3,3.3l0.5,2.2l0,0.3l-0.1,0.2l-0.6,0.1l-0.4-0.1
		l-0.2-0.1l-0.9-0.4l-0.7-0.7l-0.6-0.3l-0.1-0.1l-3.8-2.6l0.6-0.9L500.2,124z	"
          >
            <title id="t1928">Burlington, NJ</title>
          </path>
          <path
            id="FIPS_34007"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M496.7,128l0.7-1.4l3.8,2.6l-1,1.8l-1.2-1l-1.4-1.5l-0.5-0.4L496.7,128z	"
          >
            <title id="t1922">Camden, NJ</title>
          </path>
          <path
            id="FIPS_34015"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M496.3,128.6l0.4-0.6l0.4,0.2l0.5,0.4l1.4,1.5l1.2,1l-0.8,1.4l-0.9-0.5l-4.3-1.8l0.2-0.4
		L496.3,128.6z	"
          >
            <title id="t1923">Gloucester, NJ</title>
          </path>
          <path
            id="FIPS_34033"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M494.3,130.3l4.3,1.8l0.1,1.1v0.3l0,0.1l-1.8-1l-1,1.6l-0.2,1l-2.1-2.5l-0.1-0.3l0.3-0.8
		L494.3,130.3z	"
          >
            <title id="t1924">Salem, NJ</title>
          </path>
          <path
            id="FIPS_42017"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M494.4,119.3l1.4,0.6l0.7,1.5l0.9,0.6l0.1,0l2.6,2l-2.1,1.8l-0.6-1l-5.3-2.6l1.1-1.8l1.1-1.2
		L494.4,119.3z	"
          >
            <title id="t2242">Bucks, PA</title>
          </path>
          <path
            id="FIPS_42045"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M494.3,126.4l1,1l0.9,1.3l-1.8,1.2l-1.8-0.1L494.3,126.4z	"
          >
            <title id="t2305">Delaware, PA</title>
          </path>
          <path
            id="FIPS_42091"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M492.1,122.1l5.3,2.6l-1,1.1l-0.5-0.4l-0.6,0.9l0.5,0.4l-0.5,0.6l-1-1l-1.1-0.2l-1-0.8
		l-0.1-0.1l0,0l-1-0.4l-0.5,0.1l1-3L492.1,122.1z	"
          >
            <title id="t2306">Montgomery, PA</title>
          </path>
          <path
            id="FIPS_42029"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M490.6,124.8l0.5-0.1l1,0.4l0,0l0.1,0.1l1,0.8l1.1,0.2l-1.6,3.4l-1.5,1.9l-3.3,0.7l0.6-0.7
		l0.1-0.3l0.2-0.6l0.1-0.7l-0.1-0.3l0-0.2l0-0.3l0.1-2.1l0.6-0.5L490.6,124.8z	"
          >
            <title id="t2307">Chester, PA</title>
          </path>
          <path
            id="FIPS_42101"
            className="FIPS_37980 st0 state-pa state-nj state-de state-md"
            d="M498,125.8l-0.6,0.9l-0.7,1.4l-0.4,0.6l-0.9-1.3l0.5-0.6l-0.5-0.4l0.6-0.9l0.5,0.4l1-1.1
		L498,125.8z	"
          >
            <title id="t2241">Philadelphia, PA</title>
          </path>
        </g>
        <path
          id="FIPS_10005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M494.9,145.3l-0.7-2.4l1.4-0.4l0.6-0.5l0-0.2l0.2-0.4l0.8-0.6l0.8-0.4l0.1,0.3l0.1,0.1
		l0.9,0.7l0.5,0.4l0.4,0.1l0.3,0.1l0.2-0.1l0.1-0.1l0-0.1l0.3,0.5l0.6,1.8l0.4,1.5l0.1,0.4l-2.9,0.6l-0.1,0l-0.4,0.1l-0.2,0l-0.1,0
		l0,0l-0.5,0.1l-0.2,0l-0.6,0.1l-0.3,0.1l0,0l-0.7,0.1l-0.3,0.1l-0.1-0.4l-0.1-0.4l-0.1-0.5L494.9,145.3z	"
        >
          <title id="t315">Sussex, DE</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "20100"
              ? `metroArea clickedArea state-de`
              : `metroArea ${colorCode[20100]} state-de`
          }
          id="FIPS_20100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_10001"
            className="FIPS_20100 st0 state-de"
            d="M492.6,137l2.2-1.4l0.9,0.5l0.4,0.6l0.1,0.1l0.2,0.6l0,0.2l1,2l0.5,0.8l-0.8,0.4l-0.8,0.6
		l-0.2,0.4l0,0.2l-0.6,0.5l-1.4,0.4l-1.5-5.2L492.6,137z	"
          >
            <title id="t316">Kent, DE</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "37460"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[37460]} state-fl`
          }
          id="FIPS_37460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12005"
            className="FIPS_37460 st0 state-fl"
            d="M411.1,264.9l0.5,4.7l0.4,3.5l-1.2-0.4l-0.3-0.1l-0.1-0.1l-0.3-0.2l-0.4-0.4l-2.4-1.4
		l-0.2-0.1l-0.1-0.1l-0.1-0.1l-0.2-0.1l-0.4-0.2l-0.2-0.1l-0.1-0.1l-0.2-0.1l-0.2-0.1l-0.2-0.1l-0.7-0.2l-0.1-1.5l0.3-0.3l1.2-0.5
		l3.4-0.3l0.7-0.1L410,265l0.6-0.1L411.1,264.9z	"
          >
            <title id="t317">Bay, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.4,259.5l5.3-0.6l1.9,3.5l-0.6,1.4l-1.8,0.2l-0.8,0.6l-0.8,0.1l-1.5,0.2l-0.6,0.1
		l-0.3-2.8l-0.9-0.5l-1.1,0.1l0.9-2.3L409.4,259.5z	"
        >
          <title id="t318">Jackson, FL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "39460"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[39460]} state-fl`
          }
          id="FIPS_39460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12015"
            className="FIPS_39460 st0 state-fl"
            d="M454.4,305l5.7-0.9l0.5,3.3l-5.7,0.8l0-0.4l-0.1-0.7l-0.2-1l0-0.1l-0.2-0.1l-0.4,0.1l-0.1,0.1
		l-0.5,0.5l-0.1,0.1l0.3,1.8l0,0.1l-0.5,0.1l-0.1-0.1h0l-0.1,0.1l-0.1,0.2l-0.2,0l-0.1-0.2l-0.1-0.2l0,0l0,0l-1.5-1.8l1.4-0.2
		l-0.1-0.8l-0.1-0.4L454.4,305z	"
          >
            <title id="t319">Charlotte, FL</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "15980"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[15980]} state-fl`
          }
          id="FIPS_15980"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12071"
            className="FIPS_15980 st0 state-fl"
            d="M452.7,309.5l1.3,2.4l0.2,0.1l0.2,0.1l0.7,0.2l0.1-0.2l0.2-0.1l0.6,0.1v0l-0.5,0.4l-0.1,0.1
		l-0.1,0l-0.2,0l-0.4-0.1l-0.6-0.3l-0.1,0l-0.1,0l-0.1-0.2l-1.2-2.2L452.7,309.5z M454.8,308.3l5.7-0.8l0.5,3.2l0.2,1.1l-0.9,1.5
		l-1.9,0.3l-0.3-0.1l-0.4-0.6l-0.6-0.5l-1.3-0.8l-1.3-1.9L454.8,308.3z	"
          >
            <title id="t320">Lee, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.5,307.5l4.5-0.7l2.6-0.4l0.3-2.5l1.3,7.9l0.2,0.9l-4.5,0.8l-0.4-2.1l-0.2-1.2l-3.4,0.6
		L460.5,307.5z	"
        >
          <title id="t321">Hendry, FL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "34940"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[34940]} state-fl`
          }
          id="FIPS_34940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12021"
            className="FIPS_34940 st0 state-fl"
            d="M469.4,312.6l0.6,3.5l0.4,2.2l-5.5,0.9l-0.1-0.2l-0.1-0.1l-0.5-0.3l-0.3-0.1l-0.1,0l-1.1-0.2
		h-0.1l-1.3,0.3l-0.1,0.1l-0.1,0.1l0,0.1l0,0.2l0,0.2l-0.1,0l-0.1-0.1l-0.7-1l-1-1.7L459,316l-0.1-0.3l-0.3-1l-0.3-0.7l-0.2-0.4l0,0
		l0.3,0.1l1.9-0.3l0.9-1.5l-0.2-1.1l3.4-0.6l0.2,1.2l0.4,2.1L469.4,312.6z	"
          >
            <title id="t322">Collier, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M474.4,329.5l-0.1,0.3l-0.5,0.4l-0.5,0.4l-0.6,0.2l0,0v0l0,0l0-0.1l0.6-0.6L474.4,329.5
		L474.4,329.5z M478.7,322.9L478.7,322.9l-0.2,0.4l-0.7,1.8l0,0.1l0.1,0.2l-0.1,0.2l-0.2,0.3l-1.8,2.5l-0.1,0.1l-0.9,0.9l0,0v0
		l0-0.1l0.4-0.6l0.3-0.2l0.5-0.6l0.4-0.4l0.6-0.9l0.1-0.2l0.7-1.4l0.8-2L478.7,322.9z M471.4,331.8l-0.5,0.5l-0.7,0.5l-0.3,0.1
		l-0.2-0.1l0,0l0,0l1-0.6l1.4-0.8l0,0l0.1,0.1l-0.1,0.1L471.4,331.8z M464.4,334l0-0.1l0.2-0.3l1.6-0.8l0.4,0.1l0.8,0.2l0.3,0.5v0
		l0,0l-0.1,0.1l-0.2,0.1l-0.7,0.3l-4.5,1.6l-0.3,0.1l0,0l-0.1-0.2l0-0.1l0.2-0.2l0.5-0.1l0.1,0l0.1,0.1l0.1,0l0.4-0.2l0.2-0.1
		l0.4-0.4L464.4,334z M470.4,318.3l0.9,5.5l0.5,2.1l0.1,0.2l0,0l-0.7,0.6l-0.9,0.4l-0.9,0.2l-0.2-0.1l-0.5-0.3l-0.1-0.1l-0.5-0.7
		l0-0.3l0-0.6l0-0.5l0-0.1l0.1-0.1l0.1,0l0.2,0l0-0.1l0-0.1l-0.8-1.3l-1.3-2l-1.4-1.9L470.4,318.3z	"
        >
          <title id="t323">Monroe, FL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "33100"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[33100]} state-fl`
          }
          id="FIPS_33100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12011"
            className="FIPS_33100 st0 state-fl"
            d="M469.2,311.7l6.7-1.1l0.5-0.1l2-0.2l0.2,4.4l-0.8,0.2l-0.5,0.1l-0.4,0.1l-0.4,0.2l-1.7,0.4
		l-2.8,0.5l-1.2-0.1l-1.1,0.2l-0.6-3.5L469.2,311.7z	"
          >
            <title id="t325">Broward, FL</title>
          </path>
          <path
            id="FIPS_12086"
            className="FIPS_33100 st0 state-fl"
            d="M478.7,322.9l-0.3-0.1l0.1-0.6l0.4-1.5l0.1-0.2h0.1l0.1,0.4L479,322L478.7,322.9z
		 M470.1,316.2l1.1-0.2l1.2,0.1l2.8-0.5l1.7-0.4l0.4-0.2l0.4-0.1l0.5-0.1l0.8-0.2l0,0l0.1,0.7l0.1,0.9l0,0.3l0,0.6l-0.1,0.3
		l-0.1,0.1l-0.2,0.2l-0.1-0.1l-0.2-0.1l-0.1,0L478,318l-0.1,0.1l0,0.1l-0.6,2.5l-0.1,0.4l0,0.3l0.3,1l0.1,0.1h0.1l0.1,0.1l0,0.1
		l-0.2,0.5l-0.5,0.7l0,0l-0.3,0.3l-0.6,0.7l-1.5,0.8l-0.3,0.2l-0.5,0.1l-0.7,0.1l-1.2,0l0,0l-0.1-0.2l-0.5-2.1l-0.9-5.5L470.1,316.2
		z	"
          >
            <title id="t324">Miami-Dade, FL</title>
          </path>
          <path
            id="FIPS_12099"
            className="FIPS_33100 st0 state-fl"
            d="M467.9,303.8l5.7-0.9l0.1,0l2.7-0.4l0.7-0.3l0.2,0.4l0.2,0.5l0.2,0.4l0.3,0.8l0.2,1.2l0.2,1.1
		l0.1,0.5l0.1,3l0,0.2l-2,0.2l-0.5,0.1l-6.7,1.1L467.9,303.8z	"
          >
            <title id="t326">Palm Beach, FL</title>
          </path>
        </g>

        <path
          id="FIPS_12027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M459.4,300.2l0.6,3.9l-5.7,0.9l-0.5-3.9l2.2-0.3l1.2-0.2L459.4,300.2z	"
        >
          <title id="t328">DeSoto, FL</title>
        </path>
        <path
          id="FIPS_12043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.8,300.8l1.2,3.1l-0.3,2.5l-2.6,0.4l-4.5,0.7l-0.5-3.3l3.4-0.5l-0.2-1.1l1-1.3
		L466.8,300.8z	"
        >
          <title id="t329">Glades, FL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "38940"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[38940]} state-fl`
          }
          id="FIPS_38940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12085"
            className="FIPS_38940 st0 state-fl"
            d="M475.1,298.7l2,3.5l-0.7,0.3l-2.7,0.4l-0.1,0l-5.7,0.9l1.9-3.5l3-0.5l1.5-0.2l-0.1-0.7
		L475.1,298.7z	"
          >
            <title id="t330">Martin, FL</title>
          </path>
          <path
            id="FIPS_12111"
            className="FIPS_38940 st0 state-fl"
            d="M469.1,295.9l4.1-0.7l2,3.5l-1,0.2l0.1,0.7l-1.5,0.2l-3,0.5L469.1,295.9z	"
          >
            <title id="t331">St. Lucie, FL</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "42680"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[42680]} state-fl`
          }
          id="FIPS_42680"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12061"
            className="FIPS_42680 st0 state-fl"
            d="M466.4,292.9l4.1-0.7l0.6-0.5l0.1-0.1l2.1,3.6l-4.1,0.7l-1.1,0.2l-0.2-1.1l-1.1,0.2
		L466.4,292.9z	"
          >
            <title id="t332">Indian River, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.6,295.7l3.1-0.5l1.1-0.2l0.2,1.1l1.1-0.2l0.7,4.4l-1.9,3.5l-1.2-3.1l-1-1l-1.1-0.9
		l-1.2-2.1L463.6,295.7z	"
        >
          <title id="t333">Okeechobee, FL</title>
        </path>
        <path
          id="FIPS_12055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.8,296.4l4.8-0.7l-0.2,1.1l1.2,2.1l1.1,0.9l1,1l-2.6,0.4l-1,1.3l0.2,1.1l-3.4,0.5
		l-0.6-3.9L458.8,296.4z	"
        >
          <title id="t334">Highlands, FL</title>
        </path>
        <path
          id="FIPS_12049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.3,297.2l5.6-0.8l0.6,3.9l-2.1,0.3l-1.2,0.2l-2.2,0.3L453.3,297.2z	"
        >
          <title id="t335">Hardee, FL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "35840"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[35840]} state-fl`
          }
          id="FIPS_35840"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12081"
            className="FIPS_35840 st0 state-fl"
            d="M447.6,298.1l5.7-0.8l0.6,3.9l0.2,1.6l-2.3,0.3l-0.3-2.2l-4.5,0.6l-0.6-0.6l-0.4-0.7l0.3-0.1
		l0.4-0.3l0.8-1.2l0-0.1L447.6,298.1z	"
          >
            <title id="t336">Manatee, FL</title>
          </path>
          <path
            id="FIPS_12115"
            className="FIPS_35840 st0 state-fl"
            d="M454,302.8l0.3,2.2l-2.3,0.3l0.1,0.4l0.1,0.8l-1.4,0.2l-2-3.1l-0.1-0.2l-0.2-0.2l-0.1-0.2
		l-0.5-0.6l-0.3-0.3l-0.6-0.6l4.5-0.6l0.3,2.2L454,302.8z	"
          >
            <title id="t327">Sarasota, FL</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45300"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[45300]} state-fl`
          }
          id="FIPS_45300"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12053"
            className="FIPS_45300 st0 state-fl"
            d="M444.6,284.9l2.6-0.4l0.1,0.4l1.7-0.3l0,0.3l0.2,0.2l0.5,0.5l0.2,0.1l1.4,0.4l0.4,0.6
		l-2.2,0.3l0.1,0.6l-4.4,0.6l-0.4,0.1L444.6,284.9z	"
          >
            <title id="t339">Hernando, FL</title>
          </path>
          <path
            id="FIPS_12057"
            className="FIPS_45300 st0 state-fl"
            d="M445.5,291.5l6.2-0.9l0.6-0.1l0.6,3.9l0.4,2.8l-5.7,0.8l1.1-1.7l0,0l0.3-0.6l0.1-0.3l-0.2-0.6
		l-0.2-0.2L447,294l-0.4,0l-0.3,0.1l-0.3,0.1L445.5,291.5z	"
          >
            <title id="t338">Hillsborough, FL</title>
          </path>
          <path
            id="FIPS_12101"
            className="FIPS_45300 st0 state-fl"
            d="M451.7,286.7l0.3,2.1l-0.3,1.9l-6.2,0.9l-1.7,0.3l1-3.5l0.4-0.1l4.4-0.6l-0.1-0.6L451.7,286.7
		z	"
          >
            <title id="t340">Pasco, FL</title>
          </path>
          <path
            id="FIPS_12103"
            className="FIPS_45300 st0 state-fl"
            d="M445.5,291.5l0.4,2.6l-0.8,0.2l0,0l0,0.1l0.1,0.1l0.1,0.1l1.2,0.5l0.5-0.2l0.1,0.3l-0.1,0.6
		l-1,2.4l-0.6-0.8l-1.2-3.1l0,0l0.1-0.7l0-0.6l-0.1-0.9l-0.1-0.2L444,292l-0.2-0.2L445.5,291.5	"
          >
            <title id="t337">Pinellas, FL</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "29460"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[29460]} state-fl`
          }
          id="FIPS_29460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12105"
            className="FIPS_29460 st0 state-fl"
            d="M456.4,287.7l0.2,1.1l2.6,1.9l0.8,0.6l2.5,2.3l0.3,0.5l0.6,0.9l0.1,0.3l0.1,0.5l-4.8,0.7
		l-5.6,0.8l-0.4-2.8l-0.6-3.9l-0.6,0.1l0.3-1.9l1-0.6L456.4,287.7z	"
          >
            <title id="t342">Polk, FL</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36740"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[36740]} state-fl`
          }
          id="FIPS_36740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12069"
            className="FIPS_36740 st0 state-fl"
            d="M454.8,275.8l2.1,2.1l0.8,0.5l0.5,0.3l0.5,0.4l0,0l0.1,0.7l-0.1,0.7l-0.3,1.3l-2.4,0.4l-0.2,0
		l-0.1,0l-0.1,0.1l0.8,5.5l-3.4,0.5l-1.1-7.8l3.3-0.5l0-1.3L454.8,275.8z	"
          >
            <title id="t345">Lake, FL</title>
          </path>
          <path
            id="FIPS_12095"
            className="FIPS_36740 st0 state-fl"
            d="M458.3,281.7l-0.4,1l0,0.3l0.6,0.5l1.1,0.2l3.8-0.6l1.9,3.1l-8.9,1.4l-0.8-5.5l0.1-0.1l0.1,0
		l0.2,0L458.3,281.7z	"
          >
            <title id="t343">Orange, FL</title>
          </path>
          <path
            id="FIPS_12117"
            className="FIPS_36740 st0 state-fl"
            d="M458.3,281.7l0.3-1.3l0.6,0.5l1.5,0.3l0.2,0l0.1,0l0.4-0.2l0.1-0.3l0.8,0.7l0.4,0.5l0.7,1.1
		l-3.8,0.6l-1.1-0.2L458,283l0-0.3L458.3,281.7z	"
          >
            <title id="t344">Seminole, FL</title>
          </path>
          <path
            id="FIPS_12097"
            className="FIPS_36740 st0 state-fl"
            d="M456.4,287.7l8.9-1.4l0.2,1.3l0.3,2l-0.1,0l0.5,3.3l0.3,2.3l-3.1,0.5l-0.1-0.5l-0.1-0.3
		l-0.6-0.9l-0.3-0.5l-2.5-2.3l-0.8-0.6l-2.6-1.9L456.4,287.7z	"
          >
            <title id="t341">Osceola, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.9,281l4-0.6l1.1,7.8l-1,0.6l-0.3-2.1l-0.4-0.6l-1.4-0.4l-0.2-0.1l-0.5-0.5l-0.2-0.2
		l0-0.3l0-0.6l0-0.1l0.1-0.2l0.2-0.3l0.2-0.1l0,0l0.1-0.4l0-0.1l-1.4-1.3L447.9,281z	"
        >
          <title id="t346">Sumter, FL</title>
        </path>
        <path
          id="FIPS_12017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.2,280.3l2.7,0.7l0.5,0.6l1.4,1.3l0,0.1l-0.1,0.4l0,0l-0.2,0.1l-0.2,0.3l-0.1,0.2l0,0.1
		l0,0.6l-1.7,0.3l-0.1-0.4l-2.6,0.4l-0.2-1.9l-0.1-0.4l-0.1-0.2l-1.5-1.1l0.1-0.1l0.1-0.1l0.3-0.3l0.2-0.1l0.2,0l0.7,0.2l0.7-0.4
		L445.2,280.3L445.2,280.3z	"
        >
          <title id="t347">Citrus, FL</title>
        </path>
        <path
          id="FIPS_12075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443,273.8l2.9,0.6l0.5,3.4l-1.5,0.2l0.3,2.2l0,0l-0.2,0.1l-0.7,0.4l-0.7-0.2l-0.2,0l-0.2,0.1
		L443,281l-0.1,0.1l-0.1,0.1l0-0.4l-0.1-0.3l-0.7-1.1l-0.3-0.1l-4-1.1l0.9-0.8l0.5-0.9l0.2-0.8l0.4-1.7L443,273.8z	"
        >
          <title id="t348">Levy, FL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36100"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[36100]} state-fl`
          }
          id="FIPS_36100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12083"
            className="FIPS_36100 st0 state-fl"
            d="M445.9,274.5l2-0.3l0.2,0.2l0,0.1l0.8,0.4l0.8-0.3l0.1-0.1l0,0l-0.1-0.4l0.3-0.3l0.2-0.1
		l0.8-0.3l1.8,0.1l0.3,0.7l0.6,0.7l0.5,0.5l0.5,0.5l0.4,2.7l0,1.3l-3.3,0.5l-4,0.6l-2.7-0.7l-0.3-2.2l1.5-0.2L445.9,274.5z	"
          >
            <title id="t349">Marion, FL</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19660"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[19660]} state-fl`
          }
          id="FIPS_19660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12127"
            className="FIPS_19660 st0 state-fl"
            d="M454.3,275.3l2.6-1.4l0.2,0.3l0.3,1.4l0.9-0.2l0,0l2-0.4l-0.3-1.4l0.5-0.7l0.9,1.4l0.7,1.1
		l0.5,0.8l0.3,0.4l0.9,1.2l2.1,2.5l-2.6,0.4l0.4,2.2l-0.3,0l-0.7-1.1l-0.4-0.5l-0.8-0.7l-0.1,0.3l-0.4,0.2l-0.1,0l-0.2,0l-1.5-0.3
		l-0.6-0.5l0.1-0.7l-0.1-0.7l0,0l-0.5-0.4l-0.5-0.3l-0.8-0.5l-2.1-2.1L454.3,275.3z	"
          >
            <title id="t350">Volusia, FL</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "37340"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[37340]} state-fl`
          }
          id="FIPS_37340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12009"
            className="FIPS_37340 st0 state-fl"
            d="M463.4,283.1l0.3,0l-0.4-2.2l2.6-0.4l2.1,2.2l0,0l0.1,0.1l0,0l0.8,1.5v0.1l-0.4,0.2l-0.1,0.1
		l-0.1,0.2l0,0.1l0,0l0,0.2l0,0.4l0,0.4l0,0.3l0.2,0.7l0.3,1l0.4,1l0.3,0.6l0.2,0.4l0.3,0.5l0,0l0.9,1.3l-0.1,0.1l-0.6,0.5l-4.1,0.7
		l-0.5-3.3l0.1,0l-0.3-2l-0.2-1.3L463.4,283.1z	"
          >
            <title id="t351">Brevard, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.8,263.7l0.1-0.9l0.1-0.3l0.8-0.1l0.2,0.2l0,0.4l1.3-0.1l0.1-0.9v-0.1l0-0.1l1.1-0.1
		l0.9,0.5l0.3,2.8L410,265l0.2,1.7l-0.7,0.1l-3.4,0.3l-1.2,0.5l-0.3,0.3l0.4-0.8l0.4-1.9l-0.2-0.2l-0.1-0.4l0.5-0.9L405.8,263.7z	"
        >
          <title id="t352">Washington, FL</title>
        </path>
        <path
          id="FIPS_12059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.4,260.2l5.9-0.7l-0.9,2.3l0,0.1v0.1l-0.1,0.9L407,263l0-0.4l-0.2-0.2l-0.8,0.1l-0.1,0.3
		l-0.1,0.9l-2.1,0.2L403.4,260.2z	"
        >
          <title id="t353">Holmes, FL</title>
        </path>
        <path
          id="FIPS_12131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.7,260.4l1.7-0.2l0.4,3.7l2.1-0.2l-0.1,0.1l-0.5,0.9l0.1,0.4l0.2,0.2l-0.4,1.9l-0.4,0.8
		l0.1,1.5l-4.6-0.9l-0.7-7.9L401.7,260.4z	"
        >
          <title id="t354">Walton, FL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "18880"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[18880]} state-fl`
          }
          id="FIPS_18880"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12091"
            className="FIPS_18880 st0 state-fl"
            d="M399.5,260.6l0.7,7.9l-4.5,0.3l-0.6-7.8l1.1-0.1L399.5,260.6z	"
          >
            <title id="t355">Okaloosa, FL</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "37860"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[37860]} state-fl`
          }
          id="FIPS_37860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12033"
            className="FIPS_37860 st0 state-fl"
            d="M386.2,261.8l4.8-0.5l-0.7,0.6l-0.5,0.4l-0.1,0.1l-0.2,0.8l0,0.2l0.1,1l0,0.2l0.2,0.5l0.6,1.4
		l1.4,2.5l0.8,0.5l1.8-0.3l-2.6,0.8l-0.1,0l-0.1,0l-0.4,0.1l-0.3,0l-0.4,0.1l-1.7,0.4l-1,0.3l0.7-0.3l0.1-1.4l0.1-2.8l0-0.2l0-0.2
		l-0.1-0.2l-0.5-0.3l-0.4-0.2l-0.2,0l-0.1,0l-0.4-0.2l-1.1-1.2l-0.1-0.2L386.2,261.8z	"
          >
            <title id="t357">Escambia, FL</title>
          </path>
          <path
            id="FIPS_12113"
            className="FIPS_37860 st0 state-fl"
            d="M391,261.3l4.1-0.4l0.6,7.8l-1.3,0.3l-1.8,0.3l-0.8-0.5l-1.4-2.5l-0.6-1.4l-0.2-0.5l0-0.2
		l-0.1-1l0-0.2l0.2-0.8l0.1-0.1l0.5-0.4L391,261.3z	"
          >
            <title id="t356">Santa Rosa, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.1,264.9l1.5-0.2l0.8-0.1l0.8-0.6l1.8-0.2l-0.5,1.2l-0.4,2.4l-0.5,1.9l-3,0.3L411.1,264.9
		z	"
        >
          <title id="t358">Calhoun, FL</title>
        </path>
        <path
          id="FIPS_12045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.6,269.6l3-0.3l1.3,2.8l0.1,1.8l-0.6,0.9l-0.2,0l-1,1l-0.1,0.2l-1,0.1l0-1.3l0-0.1
		l-0.2-0.3l-0.6-0.8l-0.3-0.3l0,0L411.6,269.6z	"
        >
          <title id="t359">Gulf, FL</title>
        </path>
        <path
          id="FIPS_12037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.2,270.9l2.3,0.4l0.1,0.2l0,0.1l0,0.1l0,0l0,0.1l-0.1,0.2l-0.1,0l-0.3,0.1l-0.5-0.1
		l-0.1,0l-0.1-0.1l-0.1-0.2l-0.6,0.2l-0.3,0.1l-1.6,1.2l-0.7,0.6l-0.6,0.5l-0.6,0.4l-1.2,0.4l-0.5,0.1l-0.4-0.1l-0.3,0l-0.2,0.1
		l-1,0.4l0.1-0.2l1-1l0.2,0l0.6-0.9L416,272l0.1-0.6L421.2,270.9z	"
        >
          <title id="t360">Franklin, FL</title>
        </path>
        <path
          id="FIPS_12029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.6,270.9l0.2,3l-0.4,1.7l-0.2,0.8l-0.5,0.9l-0.9,0.8l-0.2-0.7l-0.4-0.6l-0.2-0.3l-0.3-0.1
		h-0.3l-0.5-0.2l-0.9-0.5l-0.3-0.1l0-0.1l-0.4-1.8l0.8-2.1L439.6,270.9z	"
        >
          <title id="t361">Dixie, FL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "23540"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[23540]} state-fl`
          }
          id="FIPS_23540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12001"
            className="FIPS_23540 st0 state-fl"
            d="M443.7,268.8l1.3,0.1l0.3,0.4l0.1,0l1.4,0.2l0.6,0l0.1-0.1l0.1,0l0.5,0.1l0.2,0l1,0.9l0.1,0.3
		l0,0.1l0.4,3.1l0.1,0.4l0,0l-0.1,0.1l-0.8,0.3l-0.8-0.4l0-0.1l-0.2-0.2l-2,0.3l-2.9-0.6l-0.5-3.4L443.7,268.8z	"
          >
            <title id="t363">Alachua, FL</title>
          </path>
          <path
            id="FIPS_12041"
            className="FIPS_23540 st0 state-fl"
            d="M439.9,270.1l0.8-0.7l1.8,1.1l0.5,3.4l-3.2,0.1l-0.2-3L439.9,270.1z	"
          >
            <title id="t362">Gilchrist, FL</title>
          </path>
        </g>
        <path
          id="FIPS_12107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.4,268.6l1.1,2.7l1.4,2.7l-2.6,1.4l-0.5-0.5l-0.6-0.7l-0.3-0.7l-1.8-0.1l-0.8,0.3
		l-0.2,0.1l-0.3,0.3l-0.4-3.1l0.1,0l0.3-0.1l1-0.7l0-0.2l0.1-0.1l1-0.7l0.2,0L454.4,268.6z	"
        >
          <title id="t364">Putnam, FL</title>
        </path>

        <path
          id="FIPS_12035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.4,271.2l3.4-1.1l1.7,2.9l-0.5,0.7l0.3,1.4l-2,0.4l0,0l-0.9,0.2l-0.3-1.4l-0.2-0.3
		L455.4,271.2z	"
        >
          <title id="t365">Flagler, FL</title>
        </path>

        <path
          id="FIPS_12007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.6,265.6l1-0.2l0.8,5.4l-0.1,0l0-0.1l-0.1-0.3l-1-0.9l-0.2,0l-0.5-0.1l-0.1,0l-0.1,0.1
		l-0.6,0l-1.4-0.2l-0.1,0l-0.3-0.4l0.5-0.2l0.7-0.4l1.2-1.7l0.3-0.6l0-0.1L447.6,265.6z	"
        >
          <title id="t368">Bradford, FL</title>
        </path>
        <path
          id="FIPS_12125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.6,265.6l0.1,0.2l0,0.1l-0.3,0.6l-1.2,1.7l-0.7,0.4l-0.5,0.2l-1.3-0.1l0.4-2.6
		L447.6,265.6z	"
        >
          <title id="t369">Union, FL</title>
        </path>
        <path
          id="FIPS_12121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440,264.2l0.7,5.2l-0.8,0.7l-0.7-0.8l-0.4-0.4l-0.2-0.1l-1.1-0.7l-0.5-0.2l-0.6-0.1l0,0.1
		l-0.2,0.1l-0.3-0.1l-0.1-0.1l-0.4-0.9l-0.2-0.8l0-0.1l0,0l0.6-1.7l0.1-0.4l0,0l0.3-0.2l0.4-0.1l0.9,0l0.6,0.1L440,264.2z	"
        >
          <title id="t370">Suwannee, FL</title>
        </path>
        <path
          id="FIPS_12067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.2,265.9L435.2,265.9l-0.1,0.1l0.2,0.8l0.4,0.9l0.1,0.1l0.3,0.1l0.2-0.1l0-0.1l0.6,0.1
		l0.5,0.2l1.1,0.7l0.2,0.1l0.4,0.4l0.7,0.8l-0.3,0.9l-4.4,0.6l-0.4,0.1l-0.3-0.9l-0.6-4.7L435.2,265.9z	"
        >
          <title id="t371">Lafayette, FL</title>
        </path>
        <path
          id="FIPS_12123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.9,266l0.6,4.7l0.3,0.9l0.4-0.1l-0.8,2.1l-0.4-0.1l-1.1-0.4l-0.1-0.1l-0.1-0.1l-0.4-0.5
		l0-0.1l-0.1-0.2l-0.1-0.2l-0.6-0.7l-0.5-0.4l-0.1-0.1l-1.2-0.5l-0.7-0.2l-1-0.5l-0.7-0.4l1.5-3l3.9-0.5l0.1,0.6L433.9,266z	"
        >
          <title id="t372">Taylor, FL</title>
        </path>

        <path
          id="FIPS_12077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.5,266.2l-0.6,1.2l-0.1,0.2l-0.1,0.3l1,1.7l0.5,0.6l0.4,0.2l0.7,0.4l-5.1,0.6l-0.1,0.6
		l-1.3-2.8l0.5-1.9l0.4-2.4l0.5-1.2L419.5,266.2z	"
        >
          <title id="t374">Liberty, FL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45220"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[45220]} state-fl`
          }
          id="FIPS_45220"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12039"
            className="FIPS_45220 st0 state-fl"
            d="M422,262l1.1-0.1l-0.5,1.2l-0.5,1.5l-0.1,0.1l-0.2,0.1l-0.2,0.1l-1.5,0.7l-0.7,0.5l-3.5-2.4
		l0.6-1.4h0L422,262z	"
          >
            <title id="t375">Gadsden, FL</title>
          </path>
          <path
            id="FIPS_12073"
            className="FIPS_45220 st0 state-fl"
            d="M426.1,261.7l-0.1,2l-0.2,1.2l0.3,2.1l-1.8,0.2l-0.1-0.4l-5.1,0.7l0.6-1.2l0.7-0.5l1.5-0.7
		l0.2-0.1l0.2-0.1l0.1-0.1l0.5-1.5l0.5-1.2l2.2-0.2L426.1,261.7z	"
          >
            <title id="t376">Leon, FL</title>
          </path>
          <path
            id="FIPS_12065"
            className="FIPS_45220 st0 state-fl"
            d="M429,261.5l1.5-0.1l0.1,0.2l0.1,0.7l-0.3,0.4l-0.9,1l-0.6,1.9l-0.1,0.6l-1.5,3l-1,0l-0.5-4.3
		l0.2-1.2l0.1-2L429,261.5z	"
          >
            <title id="t377">Jefferson, FL</title>
          </path>
          <path
            id="FIPS_12129"
            className="FIPS_45220 st0 state-fl"
            d="M418.9,267.4l5.1-0.7l0.1,0.4l1.8-0.2l0.3,2.3l-1.9,0.3l-1,0.5l-0.2,0.1l0,0.4l0.1,0.5l0,0
		l0.2,0.3l-2.3-0.4l-0.7-0.4l-0.4-0.2l-0.5-0.6l-1-1.7l0.1-0.3L418.9,267.4z	"
          >
            <title id="t373">Wakulla, FL</title>
          </path>
        </g>

        <path
          id="FIPS_12079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.3,261.2l0.5,0l0.5,0.2l0.5,1.7l0.3,0.6l0.1,0.1l0.6,0.4l-0.6,1.7l-1.3,0.2l-1.1,0.2
		l-0.1-0.6l-3.9,0.5l0.1-0.6l0.6-1.9l0.9-1l0.3-0.4l-0.1-0.7l-0.1-0.2L433.3,261.2z	"
        >
          <title id="t378">Madison, FL</title>
        </path>
        <path
          id="FIPS_12047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.8,261.1l5-0.3l-0.3,0.5l0,0.2l0,0.4l0.2,0.3l0.6,0.7l0.1,0.1l0.1,0.3l0,0.1l-0.3,0.8
		l-0.1,0.1l-0.6,0.3l-0.5,0l0-0.1l-1.9-0.7l-0.6-0.1l-0.9,0l-0.4,0.1l-0.3,0.2l0,0l-0.1,0.4l-0.6-0.4l-0.1-0.1l-0.3-0.6l-0.5-1.7
		l-0.5-0.2L435.8,261.1z	"
        >
          <title id="t379">Hamilton, FL</title>
        </path>
        <path
          id="FIPS_12023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.9,260.6l1.4-0.1l0.8,5.7l-0.4,2.6l-1.2,1.6l-1.8-1.1l-0.7-5.2l0,0.1l0.5,0l0.6-0.3
		l0.1-0.1l0.3-0.8l0-0.1l-0.1-0.3l-0.1-0.1l-0.6-0.7l-0.2-0.3l0-0.4l0-0.2l0.3-0.5L441.9,260.6z	"
        >
          <title id="t380">Columbia, FL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "27260"
              ? `metroArea clickedArea state-fl`
              : `metroArea ${colorCode[27260]} state-fl`
          }
          id="FIPS_27260"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_12003"
            className="FIPS_27260 st0 state-fl"
            d="M443.7,260.5l2.3-0.1l0.3,1.8l0.1,0.3l0.2,0.3l0.2,0.2l0.1,0l1.3-0.2l0.2,1.1l0.2,1.7l-1,0.2
		l-3.5,0.6l-0.8-5.7L443.7,260.5z	"
          >
            <title id="t381">Baker, FL</title>
          </path>
          <path
            id="FIPS_12109"
            className="FIPS_27260 st0 state-fl"
            d="M452.7,265.2l0.6-0.3h0.3l0.7,0.2l1.2-0.2l-0.3-1.9l0.6-0.1l1.3,3.5l0.9,2.3l0,0l0.1,0.3
		l0.1,0.2l0.5,0.8l-3.4,1.1l-1.1-2.7L452.7,265.2z	"
          >
            <title id="t366">St. Johns, FL</title>
          </path>
          <path
            id="FIPS_12019"
            className="FIPS_27260 st0 state-fl"
            d="M452.7,265.2l1.6,3.4L452,269l-0.2,0l-1,0.7l-0.1,0.1l0,0.2l-1,0.7l-0.3,0.1l-0.8-5.4
		l-0.1-0.6l1.1-0.2l2.3-0.4l0.3-0.1l0.3,0L452.7,265.2z	"
          >
            <title id="t367">Clay, FL</title>
          </path>
          <path
            id="FIPS_12031"
            className="FIPS_27260 st0 state-fl"
            d="M448.4,263.8l2-2.8l0.9-1.3l0.2-0.2l0.1-0.1l0.8-0.3l1.3,0l0.2,0l0.7,0.6l0.2,0.1l0.2,0.2
		l0.3,1l0.1,0.8l0.1,0.5l0.1,0.4l0.1,0.3l-0.6,0.1l0.3,1.9l-1.2,0.2l-0.7-0.2h-0.3l-0.6,0.3l-0.1-0.9l-0.3,0l-0.3,0.1l-2.3,0.4
		l-1.1,0.2L448.4,263.8z	"
          >
            <title id="t382">Duval, FL</title>
          </path>
          <path
            id="FIPS_12089"
            className="FIPS_27260 st0 state-fl"
            d="M454.2,257.3l0.4,2.5l-0.7-0.6l-0.2,0l-1.3,0l-0.8,0.3l-0.1,0.1l-0.2,0.2l-0.9,1.3l-2,2.8
		l-0.2-1.1l0.1-0.9l0.1-0.9l0-0.9l-0.1-0.4l-0.3-0.4l-0.2-0.3l0-0.3l0.1-1.4l1.2-0.7l0.5,0.3l1.7,0.4l1.3,0.1l0.7,0l0.9-0.1
		L454.2,257.3z	"
          >
            <title id="t383">Nassau, FL</title>
          </path>
        </g>

        <path
          id="FIPS_13241"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.4,204.9l-0.2,1l-1,0.7l-0.7,1.3l-0.2,1l-3.3-1l0.8-2.3l0.7-0.1L428.4,204.9z	"
        >
          <title id="t384">Rabun, GA</title>
        </path>
        <path
          id="FIPS_13281"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.8,206.2l4-0.6l-0.8,2.3l-0.3,0.3l-1,0.2l0-0.3l-0.4-0.9l-0.3-0.2l-0.3,0l-0.6-0.4
		l-0.3-0.3L419.8,206.2z	"
        >
          <title id="t385">Towns, GA</title>
        </path>
        <path
          id="FIPS_13205"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425,251.8l0.5,4.7l-1.2,0.1l-2.8,0.3l-1.4,0.2l0-0.5l0.2-0.4l0.1-0.1l1.3-1.9l1.3-1l0.6-1.1
		L425,251.8z	"
        >
          <title id="t386">Mitchell, GA</title>
        </path>
        <path
          id="FIPS_13007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M420.3,252.5l3.1-0.4l-0.6,1.1l-1.3,1l-1.3,1.9l-0.1,0.1l-0.2,0.4l0,0.5l-0.4,0l-1.4-2.2
		l-0.2-2.2L420.3,252.5z	"
        >
          <title id="t387">Baker, GA</title>
        </path>
        <path
          id="FIPS_13201"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M418.2,255.1l1.4,2.2l-2,0.4l-2.1,0.2l-0.2-2.4l2.3-0.2L418.2,255.1L418.2,255.1z	"
        >
          <title id="t388">Miller, GA</title>
        </path>
        <path
          id="FIPS_13099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M415.9,252.2l2.1,0.6l0.2,2.2v0l-0.7,0.1l-2.3,0.2l0.2,2.4l-1.1,0.1l-0.1-0.3l-0.1-0.1
		l-0.5-0.6l-0.1,0h-0.1l-0.1-0.1l-0.1-0.3l-0.2-0.9l0.1-0.3l0.1-0.3l0.1-2.7l0.2,0.4l0.2,0l0.2-0.1l0.3-0.1L415.9,252.2z	"
        >
          <title id="t389">Early, GA</title>
        </path>
        <path
          id="FIPS_13253"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M415.5,257.8l2.1-0.2l-0.2,0.5l0.2,1.9l-0.1,0.7l-0.3,0.6l-0.4,0.3l-0.2,0.3l0,0.2l0.1,0.3h0
		l-1.9-3.5l-0.3-0.9L415.5,257.8z	"
        >
          <title id="t390">Seminole, GA</title>
        </path>
        <path
          id="FIPS_13087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.4,257l0.6,5l-5.3,0.4l-0.1-0.3l0-0.2l0.2-0.3l0.4-0.3l0.3-0.6l0.1-0.7l-0.2-1.9l0.2-0.5
		l2-0.4l0.4,0L421.4,257z	"
        >
          <title id="t391">Decatur, GA</title>
        </path>
        <path
          id="FIPS_13131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.3,256.7l0.1,1.3l0.2,0.4l0.1,0.2l0.2,0.2l0.3,3.1l-2.2,0.2L422,262l-0.6-5L424.3,256.7z	
		"
        >
          <title id="t392">Grady, GA</title>
        </path>
        <path
          id="FIPS_13275"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.5,256.5l3,0.1l0.6,4.9l-2.9,0.2l-0.8,0.1l-0.3-3.1l-0.2-0.2l-0.1-0.2l-0.2-0.4l-0.1-1.3
		L425.5,256.5z	"
        >
          <title id="t393">Thomas, GA</title>
        </path>
        <path
          id="FIPS_13027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.4,256.4l1,2.5l-0.3,0.3l-0.3,0.7l0,0l0.4,0.6l0.2,0.1l1,0.5l-2.8,0.2l-1.5,0.1l-0.6-4.9
		l1.7-0.7L431.4,256.4z	"
        >
          <title id="t394">Brooks, GA</title>
        </path>
        <path
          id="FIPS_13071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.5,252.6l-0.3,3.3l-1.7,0.7l-3-0.1l-0.4-3.3l3.8-0.4L430.5,252.6z	"
        >
          <title id="t395">Colquitt, GA</title>
        </path>
        <path
          id="FIPS_13075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.3,252.2v0.4l0.1,0.2l0.1,0.1l0.6,0.4l0.2,0.1l0.9,1.9l0.3,0.8l-2,0.2l-1.2-0.4l0.3-3.3
		L431.3,252.2z	"
        >
          <title id="t396">Cook, GA</title>
        </path>
        <path
          id="FIPS_13173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.8,253.8l0.8-0.1l0.6,4l-0.5,0.3l-0.1-0.7l-0.3-0.5l-1.5,0.2l-0.3-0.9l0-0.4l0.2-1.2
		l1.4-0.2l0-0.1l-0.1-0.2L435.8,253.8z	"
        >
          <title id="t397">Lanier, GA</title>
        </path>
        <path
          id="FIPS_13185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.3,256.1l1.1-0.1l0.3,0.9l1.5-0.2l0.3,0.5l0.1,0.7l-0.9,3l-1.9,0.1l-0.5,0l-1-0.5
		l-0.2-0.1l-0.4-0.6l0,0l0.3-0.7l0.3-0.3l-1-2.5L433.3,256.1z	"
        >
          <title id="t398">Lowndes, GA</title>
        </path>
        <path
          id="FIPS_13101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.2,257.7l1.4,0.3l0.1,0.2l0.2,0.5l0.3,0.4l0.2,0.1l0.3,0.1l0.4,0l0.2,0l0.4,0l0.7,0
		l0.2,0.1l0.1,0.1l0,0.1l0.1,1.3l-1.2,0.1l-5,0.3l0.9-3L437.2,257.7z	"
        >
          <title id="t399">Echols, GA</title>
        </path>
        <path
          id="FIPS_13065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.6,253.7l3.3-0.4l1,1.7l0.4,0.4l0.7,0.5l1.2,1.7l0.2,1.5l0.2,1.1l0.2,0.4l-0.5,0l-1.4,0.1
		l-0.1-1.3l0-0.1l-0.1-0.1l-0.2-0.1l-0.7,0l-0.4,0l-0.2,0l-0.4,0l-0.3-0.1l-0.2-0.1l-0.3-0.4l-0.2-0.5l-0.1-0.2l-1.4-0.3
		L436.6,253.7z	"
        >
          <title id="t400">Clinch, GA</title>
        </path>
        <path
          id="FIPS_13003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440,250.8l-0.1,2.4l-3.3,0.4l-0.8,0.1l-0.1-0.5l-0.3-1.2l-0.5-0.4l-0.5-0.5l0,0l0-0.2l2-0.2
		l1.5,0.3l0.2,0.2L440,250.8z	"
        >
          <title id="t401">Atkinson, GA</title>
        </path>
        <path
          id="FIPS_13019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M434.2,250.2l0.2,0.6l0,0.2l0,0l0.5,0.5l0.5,0.4l0.3,1.2l0.1,0.5l0.1,0.2l0.1,0.2l0,0.1
		l-1.4,0.2l-0.2,1.2l0,0.4l-1.1,0.1l-0.3-0.8l-0.9-1.9l-0.2-0.1l-0.6-0.4l-0.1-0.1l-0.1-0.2v-0.4l0.8-1.8L434.2,250.2z	"
        >
          <title id="t402">Berrien, GA</title>
        </path>
        <path
          id="FIPS_13155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.4,247.4l-1.2,2.8l-2.1,0.2l-2-1.3l0.2-2.2l0.9-0.1l0.6,0.9l0.7,0.3l1-0.1l0.6-0.3
		L435.4,247.4z	"
        >
          <title id="t403">Irwin, GA</title>
        </path>
        <path
          id="FIPS_13277"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.5,249.7l1.6-0.5l2,1.3l-0.8,1.8l-0.8,0.4l-1.5,0.2L428.5,249.7z	"
        >
          <title id="t404">Tift, GA</title>
        </path>
        <path
          id="FIPS_13321"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.9,246.6l1.6,0.4l0,0l0.1,0.5l0.2,1.8l0.9-0.1l0.1,0l0.3,0.2l0.4,0.3l0.3,3l-3.8,0.4
		l-0.2-1.4l-0.6-2.6L424.9,246.6z	"
        >
          <title id="t405">Worth, GA</title>
        </path>
        <path
          id="FIPS_13095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.4,249.9l3-0.7l0.6,2.6l-1.6,0.2l-3.1,0.4l-0.5-2.3L421.4,249.9z	"
        >
          <title id="t406">Dougherty, GA</title>
        </path>
        <path
          id="FIPS_13037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M418.7,250.3l1.1-0.1l0.5,2.3l-2.3,0.3l-2.1-0.6l-0.2-1.5L418.7,250.3z	"
        >
          <title id="t407">Calhoun, GA</title>
        </path>
        <path
          id="FIPS_13061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412,249l2-0.2l0.3,2l1.4-0.1l0.2,1.5l-1.5,0.2l-0.3,0.1l-0.2,0.1l-0.2,0l-0.2-0.4l-1.2-3
		L412,249z	"
        >
          <title id="t408">Clay, GA</title>
        </path>
        <path
          id="FIPS_13239"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.5,246.2l1.8,0.6l-0.3,1.9l-2,0.2L412.5,246.2z	"
        >
          <title id="t409">Quitman, GA</title>
        </path>
        <path
          id="FIPS_13243"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M417.1,246.6l0.6-0.1l0.2,1.9l0.4,0.2l0.5,0.9l0,0.4l0,0.3l0,0.1l-2.9,0.4l-1.4,0.1l-0.3-2
		l0.3-1.9L417.1,246.6z	"
        >
          <title id="t410">Randolph, GA</title>
        </path>
        <path
          id="FIPS_13273"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.2,249.1l0.2,0.9l-1.7,0.2l-1.1,0.1l0-0.1l0-0.3l0-0.4l-0.5-0.9l-0.4-0.2l-0.2-1.9
		l1.6-0.8l1.3,1.1L421.2,249.1z	"
        >
          <title id="t411">Terrell, GA</title>
        </path>
        <path
          id="FIPS_13177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425,245.7l-0.1,0.8l-0.5,2.6l-3,0.7l-0.2-0.9l-0.7-2.3l-0.1-0.6L425,245.7z	"
        >
          <title id="t412">Lee, GA</title>
        </path>
        <path
          id="FIPS_13081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.4,244.2l3.8-0.5l0.3,2.2l-2,0.9l-1.6-0.4l0.1-0.8L424.4,244.2z	"
        >
          <title id="t413">Crisp, GA</title>
        </path>
        <path
          id="FIPS_13287"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.5,246l1.4-0.1l0.4,1.1l-0.2,2.2l-1.6,0.5l-0.4-0.3l-0.3-0.2l-0.1,0l-0.9,0.1l-0.2-1.8
		l-0.1-0.5l0,0L428.5,246z	"
        >
          <title id="t414">Turner, GA</title>
        </path>
        <path
          id="FIPS_13017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.9,245.9l3.3-0.4l2.1,0.6l0.2,1.4l-1.3,0.2l-0.6,0.3l-1,0.1l-0.7-0.3l-0.6-0.9l-0.9,0.1
		L429.9,245.9z	"
        >
          <title id="t415">Ben Hill, GA</title>
        </path>
        <path
          id="FIPS_13069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.3,246.1l1.7-0.7l0.3,1.9l2.3-0.3l0.2,1.5l0.4,0l0.1,1.1l-0.2,1.4l-2.1,0.3l-0.2-0.2
		l-1.5-0.3l-2,0.2l-0.2-0.6l1.2-2.8L435.3,246.1z	"
        >
          <title id="t416">Coffee, GA</title>
        </path>
        <path
          id="FIPS_13005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.5,246.2l0.8,0.5l0.5,0.3l0.7,0.2l1.2,0.6l0.1,0.1l0.1,0.2l-0.1,0l-0.6,0.6l0,0.3
		l-0.4,0.6l-0.8,0.3l-2-0.4l-0.1-1.1l-0.4,0l-0.2-1.5L440.5,246.2z	"
        >
          <title id="t417">Bacon, GA</title>
        </path>
        <path
          id="FIPS_13305"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.5,244l0.9,0.4l3.8,2.7l0.6,1l-0.9,1.7l-0.4-0.2l-0.4-0.1l-0.5,0.2l-0.8,0.2l-1.2-0.1
		l-0.1-0.1l-1.2-1.1l-0.6-3.9l0.4-0.7L445.5,244z	"
        >
          <title id="t418">Wayne, GA</title>
        </path>
        <path
          id="FIPS_13229"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.1,248.1l1.1,0.6l1.2,1.1l0.6,0.8l0,0.3l-0.1,0.2l-1.8,1.2h0l-1-0.1l-1.8-2.2l0.8-0.3
		l0.4-0.6l0-0.3l0.6-0.6L444.1,248.1z	"
        >
          <title id="t419">Pierce, GA</title>
        </path>
        <path
          id="FIPS_13025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.9,249.8l-0.1,2.1l-0.6,0.9l-0.7,0.2l-0.2,0.1l-0.1,0.1l-0.1,0.5l-1.4-0.2l-0.1,0.9
		l-0.6,0.1l-2.1-2.5l1,0.1h0l1.8-1.2l0.1-0.2l0-0.3l-0.6-0.8l0.1,0.1l1.2,0.1l0.8-0.2l0.5-0.2l0.4,0.1L449.9,249.8z	"
        >
          <title id="t420">Brantley, GA</title>
        </path>
        <path
          id="FIPS_13299"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.2,249.4l2,0.4l1.8,2.2l2.1,2.5L443,255l0.4,2.8l2.7-0.3l0.3,0l-0.3,2.9l-2.3,0.1
		l-0.2-0.4l-0.2-1.1l-0.2-1.5l-1.2-1.7l-0.7-0.5l-0.4-0.4l-1-1.7l0.1-2.4L440.2,249.4z	"
        >
          <title id="t421">Ware, GA</title>
        </path>
        <path
          id="FIPS_13049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448.2,253.8l0.8,2.8l-1.2,0.7l-0.1,1.4l0,0.3l0.2,0.3l0.3,0.4l0.1,0.4l0,0.9l-0.1,0.9
		l-0.1,0.9l-1.3,0.2l-0.1,0l-0.2-0.2l-0.2-0.3l-0.1-0.3l-0.3-1.8l0.3-2.9l-0.3,0l-2.7,0.3L443,255l3.1-0.4l0.6-0.1l0.1-0.9
		L448.2,253.8z	"
        >
          <title id="t422">Charlton, GA</title>
        </path>
        <path
          id="FIPS_13039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.5,253.4l0.7,3.9l-0.2,0l-0.9,0.1l-0.7,0l-1.3-0.1l-1.7-0.4l-0.5-0.3l-0.8-2.8l0.1-0.5
		l0.1-0.1l0.2-0.1l0.7-0.2l0.6-0.9l0,0.2l0,0l0.9,0.3l0.5,0L453.5,253.4z	"
        >
          <title id="t423">Camden, GA</title>
        </path>
        <path
          id="FIPS_13127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.9,249.5l-1.4,3.8l-2.3-0.9l-0.5,0l-0.9-0.3l0,0l0-0.2l0.1-2.1l0.9-1.7l0,0l0.6,0.6
		l0.8,0.5l1.5,0.3l1.1,0.1L454.9,249.5z	"
        >
          <title id="t424">Glynn, GA</title>
        </path>
        <path
          id="FIPS_13191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.7,244.7l0.4,0.1l0.5,0.4l0.3,0.1l0.8-0.3l0.6,0l0.3,0.1l0.2,0.1l0.4,0.3l0,0.1l0,0.4
		l-0.3,3.6l-0.2,0l-1.1-0.1l-1.5-0.3l-0.8-0.5l-0.6-0.6l0,0l-0.6-1L451.7,244.7z	"
        >
          <title id="t425">McIntosh, GA</title>
        </path>

        <path
          id="FIPS_13233"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.6,219.1l1.3,0l-0.4,1.8l-0.8,0.1l0.1,0.6l-1.7,0.2l-0.6,0.1l-1.2,0.1l-0.2-0.8l-0.4-1.5
		l1.7-0.2l0-0.2L409.6,219.1z	"
        >
          <title id="t428">Polk, GA</title>
        </path>
        <path
          id="FIPS_13115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.6,212.8l1,2.4l0.1,0.6l0,1.7l-0.2,0l0.1,1.5l-2.2,0.3l0,0.2l-1.7,0.2l-0.7-2.6l0.8-0.1
		l0.6-1.2l0.6-0.3l0.8-0.6l0.1-0.3l0.5-1.8L408.6,212.8z	"
        >
          <title id="t429">Floyd, GA</title>
        </path>
        <path
          id="FIPS_13055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.2,212.9l-0.5,1.8l-0.1,0.3l-0.8,0.6l-0.6,0.3l-0.6,1.2l-0.8,0.1l-0.9-3l-0.2-0.8
		L408.2,212.9z	"
        >
          <title id="t430">Chattooga, GA</title>
        </path>
        <path
          id="FIPS_13313"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409,207.5l1.7-0.2l-0.2,0.8l-0.7,2.9l0,0.4l0.4,0.5l-1.4,0.3l-0.1-1.3l-1.2,0.1l0-0.1
		l0.2-0.5l0.1-0.7l0.7-0.2l0.2-0.5l0.4-1.4L409,207.5L409,207.5z	"
        >
          <title id="t431">Whitfield, GA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16860"
              ? `metroArea clickedArea state-tn state-ga`
              : `metroArea ${colorCode[16860]} state-tn state-ga`
          }
          id="FIPS_16860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_13047"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M406,207.9l3-0.4l0,0.2l-0.4,1.4l-0.2,0.5l-0.7,0.2l-0.1,0.7L406,207.9z	"
          >
            <title id="t432">Catoosa, GA</title>
          </path>
          <path
            id="FIPS_13083"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M405,208.1l-0.4,1l-0.2,1.5l0.1,0.5l-0.3,1.2l-0.4,0.6l-0.8-3l-0.4-1.6l1.4-0.1L405,208.1z	"
          >
            <title id="t434">Dade, GA</title>
          </path>
          <path
            id="FIPS_13295"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M406,207.9l1.6,2.7l-0.2,0.5l0,0.1l1.2-0.1l0.1,1.3l-0.1,0.5l-0.4,0l-4.4,0.5l-0.1-0.4
		l0.4-0.6l0.3-1.2l-0.1-0.5l0.2-1.5l0.4-1L406,207.9z	"
          >
            <title id="t433">Walker, GA</title>
          </path>
          <path
            id="FIPS_47065"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M407.9,202.2l0.9,1.5l-0.4,1.2l-0.1,0.2l-0.1,0.8l0.4,1l0.3,0.7l0,0l-3,0.4l-1,0.1l-1.1,0.1
		l0.6-2.2l1.4-2.9l0.8-1.4L407.9,202.2z	"
          >
            <title id="t2494">Hamilton, TN</title>
          </path>
          <path
            id="FIPS_47115"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M399.3,205.6l3.1-1.6l0.1,0.2l0.9,0.4l0.3,0.1l0.4,0.4l0.2,0.2l0.2,0.7l0,0.1l-0.6,2.2
		l-1.4,0.1l-2.7,0.2L399.3,205.6z	"
          >
            <title id="t2474">Marion, TN</title>
          </path>
          <path
            id="FIPS_47153"
            className="FIPS_16860 st0 state-tn state-ga"
            d="M403.5,200.6l2.4,2.5l-1.4,2.9l0-0.1l-0.2-0.7l-0.2-0.2l-0.4-0.4l-0.3-0.1l-0.9-0.4l-0.1-0.2
		l-0.8-2.7l0.5-0.1L403.5,200.6z	"
          >
            <title id="t2475">Sequatchie, TN</title>
          </path>
        </g>

        <path
          id="FIPS_13183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.5,241.2l0.3,0.3l0.6,1.2l0,0.1l1.5,1.2l1.7,0.6l0.1,0l-1.5,2.3l-3.8-2.7L447.5,241.2z	"
        >
          <title id="t435">Long, GA</title>
        </path>
        <path
          id="FIPS_13001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.4,243.2l2.1,0.8l-0.4,0.1l-0.4,0.7l0.6,3.9l-1.1-0.6l-0.1-0.2l-0.1-0.1l-1.2-0.6
		l-0.7-0.2l-0.5-0.3l-0.8-0.5l-0.2-1.6l1-0.1l-0.2-1.3l-0.1-0.4L443.4,243.2z	"
        >
          <title id="t436">Appling, GA</title>
        </path>
        <path
          id="FIPS_13161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.1,242.8l0.1,0.4l0.2,1.3l-1,0.1l0.2,1.6l-1.1,0.6l-2.3,0.3l-0.3-1.9l1.9-1.6l1-0.7
		l0.7-0.2L441.1,242.8z	"
        >
          <title id="t437">Jeff Davis, GA</title>
        </path>
        <path
          id="FIPS_13259"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.5,242.6l0.1,0l0.1,0.1l0.1,0.7l0.1,0.9l0,0.9l0.1,1.4l-2.7,0.3l-1.8-0.6l0-1l1.2-2.3
		L416.5,242.6z	"
        >
          <title id="t438">Stewart, GA</title>
        </path>
        <path
          id="FIPS_13307"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.7,242.6l0.3,0l0.9,0.6l0.2,0.3l0.5,0.2l0.6-0.1l0.1,2.2l-1.6,0.8l-0.6,0.1l-0.1-1.4
		l0-0.9l-0.1-0.9l-0.1-0.7L416.7,242.6z	"
        >
          <title id="t439">Webster, GA</title>
        </path>
        <path
          id="FIPS_13261"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.7,242l1.8,0.5l1,1.7l0.6,1.5l-4.5,0.5l0.1,0.6l-1.3-1.1l-0.1-2.2l0-0.4L421.7,242z	"
        >
          <title id="t440">Sumter, GA</title>
        </path>
        <path
          id="FIPS_13315"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431,242.4l1.8,2.4l0.4,0.6l-3.3,0.4l-1.4,0.1l-0.3-2.2l-0.1-1.2l1.3-0.2l0.6-0.2l0.2-0.1
		l0.5,0l0.1,0L431,242.4z	"
        >
          <title id="t441">Wilcox, GA</title>
        </path>
        <path
          id="FIPS_13271"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.4,241.4l3.4,2.3l-1.9,1.6l-1.7,0.7l-2.1-0.6l-0.4-0.6L435.4,241.4z	"
        >
          <title id="t442">Telfair, GA</title>
        </path>
        <path
          id="FIPS_13309"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.3,238.9l0.7,0l0.1,0l0.1,0.3l0.4,1.3l0.1,0.7l0.3,1l0.1,0.2l0,0.1l0.7,0.6l-1,0.7
		l-3.4-2.3l0.4-0.8L437.3,238.9z	"
        >
          <title id="t443">Wheeler, GA</title>
        </path>
        <path
          id="FIPS_13091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.6,240.3l2-2.2l2.1,3.3l1.1-0.8l-0.4,0.8l-2.6,3.4l-1.8-2.4l0.3-0.3l0-0.1l0.1-0.6l-1-0.8
		L430.6,240.3z	"
        >
          <title id="t444">Dodge, GA</title>
        </path>
        <path
          id="FIPS_13235"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.6,240.3l-0.3,0.3l1,0.8l-0.1,0.6l0,0.1l-0.3,0.3l-0.3-0.3l-0.1,0l-0.5,0l-0.2,0.1
		l-0.6,0.2l-1.3,0.2l-0.4-2.2l1.1-1.6L430.6,240.3z	"
        >
          <title id="t445">Pulaski, GA</title>
        </path>
        <path
          id="FIPS_13093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.7,240.5l0.4,2.2l0.1,1.2l-3.8,0.5l-1-1.7l1.7-1.8L427.7,240.5z	"
        >
          <title id="t446">Dooly, GA</title>
        </path>
        <path
          id="FIPS_13193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M423,238.2l1.9,0.3l0.3,2.3l-1.7,1.8l-1.8-0.5l-1-1.7l1.9-2.2L423,238.2z	"
        >
          <title id="t447">Macon, GA</title>
        </path>
        <path
          id="FIPS_13249"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.5,240.1l1.2,0.2l1,1.7l-2.6,1.1l-0.1-0.8l0.1-0.6l0.2-0.3l-0.2-1.5L419.5,240.1z	"
        >
          <title id="t448">Schley, GA</title>
        </path>
        <path
          id="FIPS_13197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.3,238.7l2-0.6l0.8,1.8l0.2,1.5l-0.2,0.3l-0.1,0.6l0.1,0.8l0,0.4l-0.6,0.1l-0.5-0.2
		l-0.2-0.3l-0.9-0.6l-0.3,0l-0.1,0L416.3,238.7z	"
        >
          <title id="t449">Marion, GA</title>
        </path>
        <path
          id="FIPS_13053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.3,238.7l0.2,3.9l-2.9,0.4l0,0l0.1-0.4l-0.1-0.2l-0.3-0.2l-0.7-0.2l-0.1-0.1l0-0.1
		l0.1-0.5l1.1-0.6l1.2-0.3l0.7-1.3L416.3,238.7z	"
        >
          <title id="t450">Chattahoochee, GA</title>
        </path>
        <path
          id="FIPS_13215"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.4,238.3l1.9-0.2l0,0.3l2.3-0.3l0.1,0.8l-0.7,1.3l-1.2,0.3l-1.1,0.6l-0.3-1.8L411.4,238.3
		z	"
        >
          <title id="t451">Muscogee, GA</title>
        </path>
        <path
          id="FIPS_13269"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.8,235.5l1,0.6l2.4,1.8l-0.5,0.2l-1.9,2.2l-1.2-0.2l-0.3-0.2l-0.8-1.8L419.8,235.5z	"
        >
          <title id="t452">Taylor, GA</title>
        </path>
        <path
          id="FIPS_13263"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M417.2,234.1L417.2,234.1l0.3,0l0.7,0.5l0.2,0.2l0.1,0.3l0,0.1l0.1,0.1l0.5,0.2l0.5,0.1
		l-1.4,2.6l-2,0.6l-0.6,0.3l-0.1-0.8l-0.5-3.3L417.2,234.1z	"
        >
          <title id="t453">Talbot, GA</title>
        </path>
        <path
          id="FIPS_13145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.4,234.6l1.8,0.2l0.5,3.3l-2.3,0.3l0-0.3l-1.9,0.2l-0.8-1.7l-0.7-1.5L413.4,234.6z	"
        >
          <title id="t454">Harris, GA</title>
        </path>
        <path
          id="FIPS_13285"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412,230.2l0.9,0.3l0.5,4.1l-3.5,0.4l-0.9-3l-0.1-0.3L412,230.2z	"
        >
          <title id="t455">Troup, GA</title>
        </path>

        <path
          id="FIPS_13213"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.7,207.1l0.2,1.7l0.4,0.3l0,0l0,0l-0.2,0.4l-0.3,0.3l-0.1,0.6l0.3,1.9l-2.8-0.3l-0.4-0.5
		l0-0.4l0.7-2.9l0.2-0.8l0.4,0L412.7,207.1z	"
        >
          <title id="t458">Murray, GA</title>
        </path>
        <path
          id="FIPS_13129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.2,212l2.8,0.3l0.1,0.4l0.2,1.8l-3.7,0.7l-1-2.4l0.1-0.5L410.2,212z	"
        >
          <title id="t459">Gordon, GA</title>
        </path>

        <path
          id="FIPS_13293"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.5,232.3l1.7,0.6l0.1,1.1l-0.6,2.2l-1-0.6l-0.5-0.1l-0.5-0.2l-0.1-0.1l0-0.1l-0.1-0.3
		l-0.2-0.2l-0.7-0.5l-0.2-0.1l-0.1,0l-0.4-1.1L419.5,232.3z	"
        >
          <title id="t466">Upson, GA</title>
        </path>
        <path
          id="FIPS_13079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.3,234l2.5-0.3l2.3,1.7v0l-3,2.5l-2.4-1.8L421.3,234z	"
        >
          <title id="t467">Crawford, GA</title>
        </path>
        <path
          id="FIPS_13225"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M423.1,237.9l3-2.5l0.1,2.1l0,0.1l-0.7,1.1l-0.2,0.1l-0.1,0l-0.3-0.3l-1.9-0.3l-0.4-0.2
		L423.1,237.9z	"
        >
          <title id="t468">Peach, GA</title>
        </path>
        <path
          id="FIPS_13153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.1,235.4L426.1,235.4l1.2,0.2l1.4,2.6l0.1,0.6l-1.1,1.6l-2.5,0.3l-0.3-2.3l0.3,0.3l0.1,0
		l0.2-0.1l0.7-1.1l0-0.1L426.1,235.4z	"
        >
          <title id="t469">Houston, GA</title>
        </path>
        <path
          id="FIPS_13023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M432.6,238.1l-2,2.2l-1.9-1.4l-0.1-0.6l2.7-2.1L432.6,238.1z	"
        >
          <title id="t470">Bleckley, GA</title>
        </path>
        <path
          id="FIPS_13175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.4,236.1l2.7-2l1-0.2l0.9,0.3l1.4,0.8l0.1,1.1l0.3,0.1l-0.4,2.7l-1.6,1.7l-1.1,0.8
		l-2.1-3.3L431.4,236.1z	"
        >
          <title id="t471">Laurens, GA</title>
        </path>
        <path
          id="FIPS_13319"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.4,231.9l1.9-1.2l0.2-0.1l0.2,0l0.7,0.7l0.6,1l0.5,0.2l0.2,0.1l0.3,0.5l0.2,0.5l0,0.7
		l-2.7,2l-2.5-3.8L429.4,231.9z	"
        >
          <title id="t472">Wilkinson, GA</title>
        </path>
        <path
          id="FIPS_13289"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.9,233.2l1-0.8l2.5,3.8l-2.7,2.1l-1.4-2.6l0.1-1l0.7-0.9l0.1-0.3L427.9,233.2z	"
        >
          <title id="t473">Twiggs, GA</title>
        </path>
        <path
          id="FIPS_13021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.6,232.1l0.2,0.4l0.5,0.3l0.6-0.1l0.4,0.1l0.6,0.3l0.3,0.2l-0.1,0.3l-0.7,0.9l-0.1,1
		l-1.2-0.2l-2.3-1.7L425.6,232.1z	"
        >
          <title id="t474">Bibb, GA</title>
        </path>
        <path
          id="FIPS_13009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.8,228.4l0.2,0l1.7,0.2l0,0.1l0,0.1l0,0.1l-0.1,0l0,0.1l0,0.5l0,0.1l0.2,0.3l0.3-0.2
		l0.2-0.2l0,1.8l-0.7-0.7l-0.2,0l-0.2,0.1l-1.9,1.2l-1.2-3.2L429.8,228.4z	"
        >
          <title id="t475">Baldwin, GA</title>
        </path>
        <path
          id="FIPS_13169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.2,228.7l1.2,3.2l-0.5,0.4l-1,0.8l-0.6-0.3l-0.4-0.1l-0.6,0.1l-0.5-0.3l-0.2-0.4l-1.4-2.2
		l2.8-0.9L428.2,228.7z	"
        >
          <title id="t476">Jones, GA</title>
        </path>
        <path
          id="FIPS_13207"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.6,229.3l2.4,0l0.1,0.6l1.4,2.2l-1.8,1.6l-2.5,0.3l-0.1-1.1l0.7-0.1l0.1-0.2L421.6,229.3z
			"
        >
          <title id="t477">Monroe, GA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12060"
              ? `metroArea clickedArea state-ga`
              : `metroArea ${colorCode[12060]} state-ga`
          }
          id="FIPS_12060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_13045"
            className="FIPS_12060 st0 state-ga"
            d="M410.1,222.8l1.5,0.2l1.3,2.5l-0.4,0.9l-1.6,1.3l-3,0.3l-0.2-0.7l-0.6-2.1l0.5,0l1.6-0.8
		l0.8-0.8L410.1,222.8z	"
          >
            <title id="t456">Carroll, GA</title>
          </path>
          <path
            id="FIPS_13015"
            className="FIPS_12060 st0 state-ga"
            d="M413.2,214.6l0.5,4.3l-2.8,0.3l-1.3,0l-0.1-1.5l0.2,0l0-1.7l-0.1-0.6L413.2,214.6z	"
          >
            <title id="t460">Bartow, GA</title>
          </path>
          <path
            id="FIPS_13035"
            className="FIPS_12060 st0 state-ga"
            d="M422.5,226l0.8,1l0.7,2.4l-2.4,0l-0.9,0.1l0.1-1.3L422.5,226z	"
          >
            <title id="t482">Butts, GA</title>
          </path>
          <path
            id="FIPS_13013"
            className="FIPS_12060 st0 state-ga"
            d="M422.5,217.1l0.4,0.5l0.2,0.1l1,0.2l0.3,0l0.9,0l0.1,0.1l0.4,0.8l-1.1,0.9l-1.6-0.1
		L422.5,217.1z	"
          >
            <title id="t495">Barrow, GA</title>
          </path>
          <path
            id="FIPS_13057"
            className="FIPS_12060 st0 state-ga"
            d="M417.5,214.4l0.1,0.6l0.2,1.9l-1.5,1.7l-2.5,0.2l-0.5-4.3L417.5,214.4z	"
          >
            <title id="t486">Cherokee, GA</title>
          </path>
          <path
            id="FIPS_13063"
            className="FIPS_12060 st0 state-ga"
            d="M418.4,223.9l0.2,0.2l0.1,0.6l0,0.4l-0.1,1.5l-0.1,0.1L418,227l0.1,0.8l-0.4,0l-1.1-2.5l1-1.4
		L418.4,223.9z	"
          >
            <title id="t481">Clayton, GA</title>
          </path>
          <path
            id="FIPS_13067"
            className="FIPS_12060 st0 state-ga"
            d="M413.7,218.9l2.5-0.2l0.4,1l-0.4,1.6l-0.1,0.5l-0.1,0.2l-0.7,0.8l-0.4,0.4l-1.7-0.6l-0.2-1.8
		l-0.2,0l-0.2-1.7L413.7,218.9z	"
          >
            <title id="t461">Cobb, GA</title>
          </path>
          <path
            id="FIPS_13077"
            className="FIPS_12060 st0 state-ga"
            d="M412.5,226.4l2.6-0.2l0.2,1.3l0.7,0.7l0.5,0.6l0.2,0.4l0,0.5l-3.8,0.8l-0.9-0.3l-1.1-2.5
		L412.5,226.4z	"
          >
            <title id="t463">Coweta, GA</title>
          </path>
          <path
            id="FIPS_13085"
            className="FIPS_12060 st0 state-ga"
            d="M417.7,211.3l0.1,0.2l2.5,2.1l0.4,1.1l-3.2,0.4l-0.1-0.6l-0.1-1.1l-0.7,0.1l-0.4-1l0-0.2
		L417.7,211.3z	"
          >
            <title id="t488">Dawson, GA</title>
          </path>
          <path
            id="FIPS_13089"
            className="FIPS_12060 st0 state-ga"
            d="M417.9,219.9l3,2.3l-0.3,0.4l-0.6,1.3l-0.6-0.1l-1,0.1l-0.7,0.1l-0.1-1l-0.1-0.8l0-0.1
		l-0.3-2.2L417.9,219.9z	"
          >
            <title id="t484">DeKalb, GA</title>
          </path>
          <path
            id="FIPS_13097"
            className="FIPS_12060 st0 state-ga"
            d="M411.6,223l1.8-0.5l1.7,0.6l-0.7,1.1l-1,0.6l-0.4,0.5l-0.1,0.1l0,0.2L411.6,223z	"
          >
            <title id="t462">Douglas, GA</title>
          </path>
          <path
            id="FIPS_13113"
            className="FIPS_12060 st0 state-ga"
            d="M415.1,226.2l1.5-0.8l1.1,2.5l-1,1.4l-0.2-0.4l-0.5-0.6l-0.7-0.7L415.1,226.2z	"
          >
            <title id="t480">Fayette, GA</title>
          </path>
          <path
            id="FIPS_13117"
            className="FIPS_12060 st0 state-ga"
            d="M417.5,215l3.2-0.4l-0.8,2.3l-0.2,1.6l-1.9-1.5L417.5,215z	"
          >
            <title id="t489">Forsyth, GA</title>
          </path>
          <path
            id="FIPS_13121"
            className="FIPS_12060 st0 state-ga"
            d="M417.8,217l1.9,1.5l-1.7,1.4l-0.8,0.1l0.3,2.2l0,0.1l0.1,0.8l0.1,1l-1,1.4l-1.5,0.8l-2.6,0.2
		l0.4-0.9l0-0.2l0.1-0.1l0.4-0.5l1-0.6l0.7-1.1l0.4-0.4l0.7-0.8l0.1-0.2l0.1-0.5l0.4-1.6l-0.4-1L417.8,217z	"
          >
            <title id="t485">Fulton, GA</title>
          </path>
          <path
            id="FIPS_13135"
            className="FIPS_12060 st0 state-ga"
            d="M422.5,217.1l0.5,2.5l-1.7,2.1l-0.4,0.5l-3-2.3l1.7-1.4l0.2-1.6L422.5,217.1z	"
          >
            <title id="t490">Gwinnett, GA</title>
          </path>
          <path
            id="FIPS_13143"
            className="FIPS_12060 st0 state-ga"
            d="M406.3,222l1.2-0.1l0.6-0.1l1.7-0.2l0.3,1.2l0,0.7l-0.8,0.8l-1.6,0.8l-0.5,0L406.3,222z	"
          >
            <title id="t427">Haralson, GA</title>
          </path>
          <path
            id="FIPS_13149"
            className="FIPS_12060 st0 state-ga"
            d="M410.9,227.7l1.1,2.5l-3,1.6l-1-3.8L410.9,227.7z	"
          >
            <title id="t426">Heard, GA</title>
          </path>
          <path
            id="FIPS_13151"
            className="FIPS_12060 st0 state-ga"
            d="M418.4,223.9l1-0.1l1.7,1.3l1.4,0.8l-1.7,2.2l-2.8-0.4L418,227l0.5-0.2l0.1-0.1l0.1-1.5l0-0.4
		l-0.1-0.6L418.4,223.9z	"
          >
            <title id="t483">Henry, GA</title>
          </path>
          <path
            id="FIPS_13159"
            className="FIPS_12060 st0 state-ga"
            d="M426.7,225.6l0.3,3.4l-2.8,0.9l-0.1-0.6l-0.7-2.4l1.7-2.3L426.7,225.6z	"
          >
            <title id="t492">Jasper, GA</title>
          </path>
          <path
            id="FIPS_13171"
            className="FIPS_12060 st0 state-ga"
            d="M421.6,229.3l0.4,3.3l-0.1,0.2l-0.7,0.1l-1.7-0.6l-0.1-2.6l1.3-0.3L421.6,229.3z	"
          >
            <title id="t478">Lamar, GA</title>
          </path>
          <path
            id="FIPS_13199"
            className="FIPS_12060 st0 state-ga"
            d="M416.8,230.2l0,2.8l0.4,1.1l-2,0.7l-1.8-0.2l-0.5-4.1l3.8-0.8L416.8,230.2z	"
          >
            <title id="t464">Meriwether, GA</title>
          </path>
          <path
            id="FIPS_13217"
            className="FIPS_12060 st0 state-ga"
            d="M422.1,222.2l2.7,1.6l0.1,0.9l-1.7,2.3l-0.8-1l-1.4-0.8L422.1,222.2z	"
          >
            <title id="t493">Newton, GA</title>
          </path>
          <path
            id="FIPS_13223"
            className="FIPS_12060 st0 state-ga"
            d="M410.9,219.1l2-0.2l0.2,1.7l0.2,0l0.2,1.8l-1.8,0.5l-1.5-0.2l-0.3-1.2l-0.1-0.6l0.8-0.1
		L410.9,219.1z	"
          >
            <title id="t457">Paulding, GA</title>
          </path>
          <path
            id="FIPS_13227"
            className="FIPS_12060 st0 state-ga"
            d="M413,212.8l1-0.1l2-0.2l0.2-0.2l0,0.2l0.4,1l0.7-0.1l0.1,1.1l-4.2,0.1L413,212.8z	"
          >
            <title id="t487">Pickens, GA</title>
          </path>
          <path
            id="FIPS_13231"
            className="FIPS_12060 st0 state-ga"
            d="M416.8,230.2l0.4-0.4l0.6-0.1l0.2,0.2l1.3-0.2l0.1,2.6l-2.7,0.6L416.8,230.2z	"
          >
            <title id="t465">Pike, GA</title>
          </path>
          <path
            id="FIPS_13247"
            className="FIPS_12060 st0 state-ga"
            d="M422.1,222.2l-1,3l-1.7-1.3l0.6,0.1l0.6-1.3l0.3-0.4l0.4-0.5L422.1,222.2z	"
          >
            <title id="t491">Rockdale, GA</title>
          </path>
          <path
            id="FIPS_13255"
            className="FIPS_12060 st0 state-ga"
            d="M417.7,227.9l0.4,0l2.8,0.4l-0.1,1.3l-1.3,0.3l-1.3,0.2l-0.2-0.2l-0.6,0.1l-0.4,0.4l-0.1-0.5
		l0-0.5L417.7,227.9z	"
          >
            <title id="t479">Spalding, GA</title>
          </path>
          <path
            id="FIPS_13297"
            className="FIPS_12060 st0 state-ga"
            d="M423,219.6l1.6,0.1l1.6,0.9l-1.5,3.1l-2.7-1.6l-0.8-0.4L423,219.6z	"
          >
            <title id="t494">Walton, GA</title>
          </path>
        </g>
        <path
          id="FIPS_13157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.7,215.7l0.7,2l-1.7,1.2l-0.4-0.8l-0.1-0.1l-0.9,0l-0.3,0l-1-0.2l-0.2-0.1l-0.4-0.5
		l1.8-2.4l0.3,0.3l0.2,0.1l0.1,0l0.5-0.1l0.4-0.1l0.7,0.5L426.7,215.7z	"
        >
          <title id="t496">Jackson, GA</title>
        </path>
        <path
          id="FIPS_13059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.5,217.6l1.1,0.4l-0.1,0l-0.1,0.6l0,0l0,0.1l0.4,0.4l-0.3,0.8l-3-1.1L427.5,217.6z	"
        >
          <title id="t497">Clarke, GA</title>
        </path>
        <path
          id="FIPS_13219"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.7,219.7l1.1-0.9l3,1.1l0.1,1.1l-1.2,1l-1.3-1.4L424.7,219.7z	"
        >
          <title id="t498">Oconee, GA</title>
        </path>
        <path
          id="FIPS_13211"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.6,222.1l1.7,2.6l-2.6,1l-1.7-1l-0.1-0.9l1.5-3.1L427.6,222.1z	"
        >
          <title id="t499">Morgan, GA</title>
        </path>
        <path
          id="FIPS_13237"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.7,225.6l2.6-1l1.5,1.5l0.2,0.1l0.1,0.1l0,0l-0.1,0.4l-0.4,0.3l-0.3,0.2l-0.2,0.2
		l-0.1,0.8l0,0.1l0,0.1l-1.6,0.2L427,229L426.7,225.6z	"
        >
          <title id="t500">Putnam, GA</title>
        </path>
        <path
          id="FIPS_13141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.9,224.6l0.3,0.2l0.6,1.4l0.5,0.7l0.1,0.2l-0.3,0l-0.7,0.6l-0.1,0.2l-0.1,0.4l-0.1,0.2
		l-0.1,0.1l-1.1,0.8l-0.5,0.1l-0.2,0.2l-0.3,0.2l-0.2-0.3l0-0.1l0-0.5l0-0.1l0.1,0l0-0.1l0-0.1l0-0.1l-1.7-0.2l-0.2,0l0-0.1l0-0.1
		l0.1-0.8l0.2-0.2l0.3-0.2l0.4-0.3l0.1-0.4l0,0l-0.1-0.1l-0.2-0.1l1.4-1.7L433.9,224.6z	"
        >
          <title id="t501">Hancock, GA</title>
        </path>
        <path
          id="FIPS_13265"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M432.3,221l0.8,1.2l0.2,0.2h0l1.3-0.1l0.8,0.1l-0.3,0.5l-1,0.9l-0.4,0.5l0,0.1l0.2,0.3
		l-1.8-0.1l-0.2-2.9L432.3,221z	"
        >
          <title id="t502">Taliaferro, GA</title>
        </path>
        <path
          id="FIPS_13133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.9,221.6l0.2,2.9l-1.4,1.7l-1.5-1.5l-1.7-2.6l1.2-1L431.9,221.6z	"
        >
          <title id="t503">Greene, GA</title>
        </path>
        <path
          id="FIPS_13221"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.5,217l2.2,0.6l-0.7,0.5l-0.2,0.3l-0.6,1l-0.4,0.9l0,0.1l0.5,0.6l-0.4,0.6l-3.1-0.5
		l-0.1-1.1l0.3-0.8l-0.4-0.4l0-0.1l0,0l0.1-0.6l0.1,0l1.2-0.8l0.1,0l0.2,0.1l0.6,0.2l0.1,0L431.5,217z	"
        >
          <title id="t504">Oglethorpe, GA</title>
        </path>
        <path
          id="FIPS_13317"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.7,217.7l1.4-0.4l2.4,4.2l-1.7,0.6l-0.3,0.2l-0.8-0.1l-1.3,0.1h0l-0.2-0.2l-0.8-1.2
		l-0.5-0.6l0-0.1l0.4-0.9l0.6-1l0.2-0.3L433.7,217.7z	"
        >
          <title id="t505">Wilkes, GA</title>
        </path>
        <path
          id="FIPS_13301"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.7,222.1l0.6,1.3l1,1.8l0.5,0.1l1.3,0.2l-0.4,0.6l-0.8-0.3l-0.7-0.2l-0.3,0.1l-1.6,1.1
		l-0.5-0.7l-0.6-1.4l-0.3-0.2l-0.2-0.3l0-0.1l0.4-0.5l1-0.9l0.3-0.5L435.7,222.1z	"
        >
          <title id="t506">Warren, GA</title>
        </path>
        <path
          id="FIPS_13189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438,221.2l-0.1,0.1l0,0.2l0.2,1l0.7,1l1,1.2l0.2,0.1l-0.6,0.6l-0.3,0.1l-1.3-0.2l-0.5-0.1
		l-1-1.8l-0.6-1.3l1.7-0.6L438,221.2z	"
        >
          <title id="t507">McDuffie, GA</title>
        </path>
        <path
          id="FIPS_13125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.2,226.8l1.6-1.1l0.3-0.1l0.7,0.2l0.8,0.3l-0.4,0.4l-1.1,1.2l0,0.1l0.1,0.5l-0.9,0
		l-1.1-1.3L435.2,226.8z	"
        >
          <title id="t508">Glascock, GA</title>
        </path>
        <path
          id="FIPS_13163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.1,225.5l0.3-0.1l1,0.4l0.1,0l0.1,0.1l0.3,0.3l-0.2,1.1l-0.1,0.6l0,0.6l0.1,0.3l0.1,0.4
		l0.2,0.9l-0.1,0.8l-0.1,0.6l-1.1,1.1l-1-0.6l-0.2-1.4l-0.5-1l0,0l-0.4-0.2l-0.4-0.3l-0.2-0.2l-0.3-0.5l0.9,0l-0.1-0.5l0-0.1
		l1.1-1.2l0.4-0.4L439.1,225.5z	"
        >
          <title id="t509">Jefferson, GA</title>
        </path>
        <path
          id="FIPS_13303"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.5,228.3l0.3,0.5l0.2,0.2l0.4,0.3l0.4,0.2l0,0l0.5,1l0.2,1.4l-0.9,0.5l-0.6,0.3l-1.2,0
		l-0.3-0.2l-1.5,0.9l-0.2-0.5l-0.3-0.5l-0.2-0.1l-0.5-0.2l-0.6-1l0-1.8l0.5-0.1l1.1-0.8l0.1-0.1l0.1-0.2l0.1-0.4l0.1-0.2l0.7-0.6
		l0.3,0L436.5,228.3z	"
        >
          <title id="t510">Washington, GA</title>
        </path>
        <path
          id="FIPS_13167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.6,232.6l-1.8,3.5l-0.3-0.1l-0.1-1.1l-1.4-0.8l-0.9-0.3l-1,0.2l0-0.7l1.5-0.9l0.3,0.2
		l1.2,0l0.6-0.3l0.9-0.5L439.6,232.6z	"
        >
          <title id="t511">Johnson, GA</title>
        </path>
        <path
          id="FIPS_13283"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.7,236.2l1.6,0l0.3,0.1l1,0.4l0.1,0.1l0,0.6l-0.1,0.5l-2.5,1.1l-0.7,0L437.7,236.2z	"
        >
          <title id="t512">Treutlen, GA</title>
        </path>
        <path
          id="FIPS_13209"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.6,237.8l-0.1,5l-0.7,0.2l-0.7-0.6l0-0.1l-0.1-0.2l-0.3-1l-0.1-0.7l-0.4-1.3l-0.1-0.3
		l-0.1,0L440.6,237.8z	"
        >
          <title id="t513">Montgomery, GA</title>
        </path>
        <path
          id="FIPS_13279"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.6,237.8l2,0.2l0.7,2.2l0.1,3l-2.3-0.4l-0.5,0L440.6,237.8z	"
        >
          <title id="t514">Toombs, GA</title>
        </path>
        <path
          id="FIPS_13179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448.1,240.7l0.4-0.6l0.9,0.4l1.9,0.6l0.8,0.3l0.1,0.2l0.3,0.8l0,0.1l0,0l0.1,0.1l0.8,0.6
		l1.2,0.6l0.1,0l0,0.1l0.2,0.2l0.3,0.1l0.1,0l0-0.1l0,0l0.1,0l0.1,0l0.1,0.5l0,0.4l-0.2,0.7l-0.1,0.2l-0.1,0l-0.2-0.1l0-0.4l0-0.1
		l-0.4-0.3l-0.2-0.1l-0.3-0.1l-0.6,0l-0.8,0.3l-0.3-0.1l-0.5-0.4l-0.4-0.1l-0.1,0l-1.7-0.6l-1.5-1.2l0-0.1l-0.6-1.2l-0.3-0.3
		L448.1,240.7z	"
        >
          <title id="t515">Liberty, GA</title>
        </path>
        <path
          id="FIPS_13109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.9,238.2l0.6,0l2.2,1.2l0.8,0.7l-0.4,0.6l-1.4,0.2l-1-0.3L444.9,238.2z	"
        >
          <title id="t516">Evans, GA</title>
        </path>
        <path
          id="FIPS_13267"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.5,238l2.3,0.2l0.9,2.5l1,0.3l1.4-0.2l-0.6,0.5l-1.1,3.1l-0.9-0.4l-2.1-0.8l-0.1-3
		L442.5,238z	"
        >
          <title id="t517">Tattnall, GA</title>
        </path>
        <path
          id="FIPS_13043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.3,234.9l0.7,0.2l0.7,1.2l-0.2,1.6l-0.1,0.3l-0.6,0l-2.3-0.2l-0.2-0.5l0.5-1.5l0.3-0.6
		l0.7-0.6L444.3,234.9z	"
        >
          <title id="t518">Candler, GA</title>
        </path>
        <path
          id="FIPS_13107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.6,231.6l1.9,2.4l-0.2,0.9l-0.6-0.2l-0.7,0.6l-0.3,0.6l-0.5,1.5l0.2,0.5l-2-0.2l0.1-0.5
		l0-0.6l-0.1-0.1l-1-0.4l-0.3-0.1l-1.6,0l1.8-3.5l1.1-1.1L442.6,231.6z	"
        >
          <title id="t519">Emanuel, GA</title>
        </path>
        <path
          id="FIPS_13051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.6,237.4l0.1,0.3l0.1,0.5l0.1,0.6l0,0l0.6,0.2l2,0.4l0.4,0l0.1,0l0.1,0.2v0.1l0,0.2
		l-0.1,0.3l-1.8,2.9l-0.1,0.1l-0.5,0.6l-0.1,0l-0.2-0.1l-0.4-1.1l-0.5-1.3l-1.2-0.8l-0.9-0.8l-0.2-0.3L454.6,237.4z	"
        >
          <title id="t520">Chatham, GA</title>
        </path>
        <path
          id="FIPS_13029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.7,239.4l3.5-1.7l0.8,1.8l0.2,0.3l0.9,0.8l1.2,0.8l0.5,1.3l0.4,1.1l-0.4,0.1l-0.1,0
		l-1.2-0.6l-0.8-0.6l-0.1-0.1l0,0l0-0.1l-0.3-0.8l-0.1-0.2l-0.8-0.3l-1.9-0.6l-0.9-0.4L447.7,239.4z	"
        >
          <title id="t521">Bryan, GA</title>
        </path>
        <path
          id="FIPS_13031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.1,233.2l3.5,1.6l1.7,3l-3.5,1.7l-2.2-1.2l0.1-0.3l0.2-1.6l-0.7-1.2l-0.7-0.2l0.2-0.9
		L446.1,233.2z	"
        >
          <title id="t522">Bulloch, GA</title>
        </path>
        <path
          id="FIPS_13165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.6,231.6L442.6,231.6l0.1-0.9l0.4-0.5l2.3-0.8l0.4,0.1l0.5,0.1l0.1,0.1l0.1,0.1l-0.3,3.4
		l-1.6,0.8L442.6,231.6z	"
        >
          <title id="t523">Jenkins, GA</title>
        </path>
        <path
          id="FIPS_13103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.1,233.1l1.1,0.5l0.2,0.1l1,0.8l1.1,2.3l0.1,0.7l-2.6,2.1l-0.8-1.8l-1.7-3L451.1,233.1z	"
        >
          <title id="t524">Effingham, GA</title>
        </path>
        <path
          id="FIPS_13251"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.4,229.7l2.1-2.1l2,3.6l0.5,1.9l-1.5,1.6l-3.5-1.6L446.4,229.7z	"
        >
          <title id="t525">Screven, GA</title>
        </path>
        <path
          id="FIPS_13033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.4,225.9l1-0.5l0.1,0l0.4,0.2l0.1,0.2l0.6,0.2l1,0l0.9-0.6l0.4,0.1l1,0.8l1.8,0.8l0.9,0.5
		l-2.1,2.1l-0.1-0.1l-0.1-0.1l-0.5-0.1l-0.4-0.1l-2.3,0.8l-0.4,0.5l-0.1,0.9l0,0.1l-1.9,0l0.1-0.6l0.1-0.8l-0.2-0.9l-0.1-0.4
		l-0.1-0.3l0-0.6l0.1-0.6l0.2-1.1l-0.3-0.3L440.4,225.9L440.4,225.9z	"
        >
          <title id="t526">Burke, GA</title>
        </path>
        <path
          id="FIPS_13245"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.4,222l0.2,0.2l0.1,0.1l0.5,0.5l0.7,0.8l0.3,1l0.7,1l-0.4-0.1l-0.9,0.6l-1,0l-0.6-0.2
		l-0.1-0.2l-0.4-0.2l-0.1,0l-1,0.5l-1-0.4l0.6-0.6L442.4,222z	"
        >
          <title id="t527">Augusta-Richmond, GA</title>
        </path>
        <path
          id="FIPS_13073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.1,220.5l1.2,1.1l1,0.4l-2.5,2.8l-0.2-0.1l-1-1.2l-0.7-1l-0.2-1l0-0.2l0.1-0.1
		L440.1,220.5z	"
        >
          <title id="t528">Columbia, GA</title>
        </path>
        <path
          id="FIPS_13181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.1,217.3l0.9,0.2l1.6,0.9l0.1,0l0.1-0.1l0,0l0.9,0.5l0.3,0.2l0.7,0.5l0.4,0.8l-2.1,0.8
		l-0.6,0.2L435.1,217.3z	"
        >
          <title id="t529">Lincoln, GA</title>
        </path>
        <path
          id="FIPS_13105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.3,213.5l0.4,1l1.9,2.3l0.4,0.7l-0.9-0.2l-1.4,0.4l-2.2-0.6l-1.4-2.2L433.3,213.5z	"
        >
          <title id="t530">Elbert, GA</title>
        </path>
        <path
          id="FIPS_13195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.6,214.3l0.5,0.5l1.4,2.2l-0.7,0.5l-0.1,0l-0.6-0.2l-0.2-0.1l-0.1,0l-1.2,0.8l-1.1-0.4
		l-0.7-2l0.5-0.4L429.6,214.3z	"
        >
          <title id="t531">Madison, GA</title>
        </path>
        <path
          id="FIPS_13011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.3,212.3l0.9,3l-0.5,0.4l-0.3-0.2l-0.7-0.5l-0.4,0.1l-0.5,0.1l-0.1,0l-0.2-0.1l-0.3-0.3
		l-0.2-1.8l1.5-0.9L426.3,212.3z	"
        >
          <title id="t532">Banks, GA</title>
        </path>
        <path
          id="FIPS_13139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M423.5,212.1l0.7,0.9l0.2,1.8l-1.8,2.4l-2.6-0.2l0.8-2.3l-0.4-1.1l1.3-1.3L423.5,212.1z	"
        >
          <title id="t533">Hall, GA</title>
        </path>
        <path
          id="FIPS_13187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.1,209.5l0.5,2.8l-1.3,1.3l-2.5-2.1l0.2-0.6l0.8-0.2l0.9-0.8L421.1,209.5z	"
        >
          <title id="t534">Lumpkin, GA</title>
        </path>
        <path
          id="FIPS_13123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.9,208.8l2-0.2l0.6,0.1l0.5,0.3l0.2,0.2l0.7,1l0.6,0.9l0.1,0.3l-1.5,0.9l-0.2,0.2l-2,0.2
		l-1,0.1l-0.1-0.4l-0.3-1.9l0.1-0.6l0.3-0.3l0.2-0.4l0,0l0,0L412.9,208.8z	"
        >
          <title id="t535">Gilmer, GA</title>
        </path>
        <path
          id="FIPS_13111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M415.8,206.7l2-0.2l-0.4,0.4l0,0.1l0,0.1l0.6,1.7l0.2,0.1l0.2-0.1l0,1.4l-0.3,0.6l-0.2,0.6
		l-0.1-0.2l-0.1-0.3l-0.6-0.9l-0.7-1l-0.2-0.2l-0.5-0.3l-0.6-0.1l-2,0.2l-0.2-1.7L415.8,206.7z	"
        >
          <title id="t536">Fannin, GA</title>
        </path>
        <path
          id="FIPS_13291"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.1,206.3l0.7-0.1l-0.1,0.2l0.3,0.3l0.6,0.4l0.3,0l0.3,0.2l0.4,0.9l0,0.3l-0.7,1l-1.4,0.4
		l-0.9,0.8l-0.8,0.2l0.3-0.6l0-1.4l-0.2,0.1l-0.2-0.1l-0.6-1.7l0-0.1l0-0.1l0.4-0.4L419.1,206.3z	"
        >
          <title id="t537">Union, GA</title>
        </path>
        <path
          id="FIPS_13311"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.8,208.5l1-0.2l0.6,0.3l0.1,0.1l0.1,0.3l0.4,2.5l-0.5,0.6l-1.9,0.2l-0.5-2.8L421.8,208.5z
			"
        >
          <title id="t538">White, GA</title>
        </path>
        <path
          id="FIPS_13137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M423.1,208l3.3,1l0.2,0.3l-0.9,2.8l-1.5,0.9l-0.7-0.9l0.5-0.6l-0.4-2.5l-0.1-0.3l-0.1-0.1
		l-0.6-0.3L423.1,208z	"
        >
          <title id="t539">Habersham, GA</title>
        </path>
        <path
          id="FIPS_13147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.9,211.4l0.7,0.1l0.1-0.1l0,0l0.4-0.1l0.4-0.1l0.2,0.1l0.1,0.1l0,0l0.4,0.5l1.1,1.6
		l-3.2,1.3l-0.5-0.5L429.9,211.4z	"
        >
          <title id="t540">Hart, GA</title>
        </path>
        <path
          id="FIPS_13119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.3,210.9l0.6,0.4l-0.3,2.9l-2.5,1l-0.9-3l0.2-0.1l0.1,0l2-0.4L429.3,210.9z	"
        >
          <title id="t541">Franklin, GA</title>
        </path>
        <path
          id="FIPS_13257"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.6,209.3l2.7,1.6l-0.6,0.8l-2,0.4l-0.1,0l-0.2,0.1l-0.7-0.2L426.6,209.3z	"
        >
          <title id="t542">Stephens, GA</title>
        </path>
        <path
          id="FIPS_15007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M173.7,308.5h1.3l0.6,0.4l0.2,0.6v0.4l-0.4,0.9v1.1l-0.8,0.8l-0.6,0.4l-1.9-0.2l-0.8-0.8
		l-1.1-0.4l-0.4-0.4v-0.6l0.6-0.8l1.9-1.5H173.7z M164.9,314.5l-0.2-0.2l0.2-1.1l1.1-0.8l0.2-0.6h0.6l-0.2,1.3l-0.9,0.4l-0.6,0.9
		H164.9z	"
        >
          <title id="t543">Kauai, HI</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "46520"
              ? `metroArea clickedArea state-hi`
              : `metroArea ${colorCode[46520]} state-hi`
          }
          id="FIPS_46520"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_15003"
            className="FIPS_46520 st0 state-hi"
            d="M196.1,319l-0.8,0.6v-0.2l-1.1,0.4l-0.9-0.6l-1.9,0.2l-0.8,0.2l-0.4-0.9l-0.6-0.4l-0.2-0.6
		l-0.6-0.6v-0.6l-0.6-0.4l1.9-0.4l0.9-1.3l0.6-0.4l0.6,0.2l0.9,1.7h0.2l0.2,0.4l-0.2,0.4l0.2,0.6l0.8,0.6l0.2-0.6h0.4v0.6l0.4,0.2
		l0.2,0.8L196.1,319z	"
          >
            <title id="t544">Honolulu, HI</title>
          </path>
        </g>
        <path
          id="FIPS_15009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.6,320.5h0.2l0.4,0.2h0.2l-0.2-0.4l1.7-0.4l0.8,0.2l-0.4,0.8l-1.1,0.8h-0.6l-2.3-0.4
		l-2.6,0.2h-0.2l0.6-1.5h0.2l2.6,0.2l0.6,0.2L204.6,320.5z M209.1,321.8l0.6,0.2l0.9,1.5l1.9-0.9l1.1,0.2v0.2l1.5,0.9l1.3,0.4
		l0.2,0.4v0.8l-0.8,0.8l-0.9,0.4l-1.9,0.8h-1.3l-0.4-0.2l-0.4-2.3l-0.6-0.2l-0.4,0.4l-1.1-0.6l-0.8-0.8l-0.2-0.8l0.4-0.8l0.2-0.4
		L209.1,321.8z M204.2,323.5h1.3l0.8,0.6l0.4,0.6l-0.2,0.8l-1.7,0.6l-0.2-0.8l-0.2-0.6l-0.8-0.8v-0.2L204.2,323.5z M209.9,327.3
		l0.2,0.2l0.2,0.8l-1.5,0.4l-0.6-0.2l0.4-0.6L209.9,327.3z	"
        >
          <title id="t545">Maui, HI</title>
        </path>
        <path
          id="FIPS_15001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.7,347.6l-0.4,0.4l-0.8-0.6l-1.9-0.8l-0.4-0.6l-0.2-0.4l0.2-3l-1.3-3.2l-0.8-0.8l-0.6-0.8
		l0.2-0.6l1.1-1.1l1.3-1.7v-0.8l-0.9-1.3l-0.2-0.8l0.2-0.8l0.4-0.2l1.1,0.2l0.4,0.6l1.7,0.8l2.1,0.4l2.3,0.9l1.5,0.9l0.8,0.9
		l0.2,1.5l0.9-0.2l0.4,0.6v0.8l0.9,0.8l1.3,0.6l-0.4,0.8l-2.1,1.9l-1.7,0.9l-1.5,0.2l-1.7,1.3l-0.9,0.6L222.7,347.6z	"
        >
          <title id="t546">Hawaii, HI</title>
        </path>
        <path
          id="FIPS_15005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.4,320.3l-0.6-0.2l1.3,0.2l0.2,0.4h-0.2l-0.4-0.2h-0.2L204.4,320.3z	"
        >
          <title id="t547">Kalawao, HI</title>
        </path>

        <path
          id="FIPS_19045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.1,121.4l7.1-0.4l0.1,1.3l-0.7,1.9l-0.7,0.8l-1.3-0.4l-3.2,0.1l-1.1,0.1l-0.1-2.3
		L342.1,121.4z	"
        >
          <title id="t549">Clinton, IA</title>
        </path>
        <path
          id="FIPS_19119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M287.9,103.7l1.4,0l3.7,0l1.8,0l0,3.1l-6.7-0.1L287.9,103.7z	"
        >
          <title id="t550">Lyon, IA</title>
        </path>
        <path
          id="FIPS_19167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.1,106.8l6.7,0.1l0,4.5l-6.3,0l0.7-2.3l0.1-0.4l0-0.1l-0.4-1.3l-0.1,0l-0.7,0L288.1,106.8
		z	"
        >
          <title id="t551">Sioux, IA</title>
        </path>
        <path
          id="FIPS_19149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M294.8,111.3v4.5l-5.9,0l-0.3-0.9l-0.2-0.4l-0.3-0.3l-0.2-0.2l0.4-1.7l0.4-1L294.8,111.3z	"
        >
          <title id="t552">Plymouth, IA</title>
        </path>
        <path
          id="FIPS_19035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.3,111.3l0,4.5l-3.3,0l-1.1,0v-4.5L299.3,111.3z	"
        >
          <title id="t553">Cherokee, IA</title>
        </path>
        <path
          id="FIPS_19141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M294.8,106.8l4.4,0l0,4.5l-4.4,0L294.8,106.8z	"
        >
          <title id="t554">O&apos;Brien, IA</title>
        </path>
        <path
          id="FIPS_19143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.6,103.7h0.6l0,3.2l-4.4,0l0-3.1L298.6,103.7z	"
        >
          <title id="t555">Osceola, IA</title>
        </path>
        <path
          id="FIPS_19059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.2,103.7l4.4,0l0,3.2l-4.4,0L299.2,103.7z	"
        >
          <title id="t556">Dickinson, IA</title>
        </path>
        <path
          id="FIPS_19041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.2,106.8l4.4,0l0,4.5l-4.5,0L299.2,106.8z	"
        >
          <title id="t557">Clay, IA</title>
        </path>
        <path
          id="FIPS_19021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.7,111.3l0,4.5l-4.5,0l0-4.5L303.7,111.3z	"
        >
          <title id="t558">Buena Vista, IA</title>
        </path>
        <path
          id="FIPS_19151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.7,111.3l4.4,0l0.1,3.4l0,1.1l-4.5,0L303.7,111.3z	"
        >
          <title id="t559">Pocahontas, IA</title>
        </path>
        <path
          id="FIPS_19147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.1,106.7l0.1,4.5l-4.4,0l0-4.5L308.1,106.7z	"
        >
          <title id="t560">Palo Alto, IA</title>
        </path>
        <path
          id="FIPS_19063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308,103.6l0,3.2l-4.4,0.1l0-3.2l0.6,0L308,103.6z	"
        >
          <title id="t561">Emmet, IA</title>
        </path>
        <path
          id="FIPS_19109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.4,103.5l0.1,3.2l0.1,4.5l-4.4,0.1l-0.1-4.5l0-3.2l1.8,0L312.4,103.5z	"
        >
          <title id="t562">Kossuth, IA</title>
        </path>
        <path
          id="FIPS_19091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.2,111.2l4.4-0.1l0.1,3.4l-4.5,0.1L308.2,111.2z	"
        >
          <title id="t563">Humboldt, IA</title>
        </path>
        <path
          id="FIPS_19193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M294.8,115.9l1.1,0l0,0.9l0.4,0.2h0.3v3.4l-6.5,0l0.1-0.8l-0.3-0.5l-0.1-1.5l0.1-0.2l0-0.2
		l0-0.1l-0.1-0.1l-0.1,0l-0.3,0l-0.3-0.9L294.8,115.9z	"
        >
          <title id="t564">Woodbury, IA</title>
        </path>
        <path
          id="FIPS_19093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.3,115.8l0,1.1l0.6,0l0,3.4l-3.3,0V117h-0.3l-0.4-0.2l0-0.9L299.3,115.8z	"
        >
          <title id="t565">Ida, IA</title>
        </path>
        <path
          id="FIPS_19161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.3,115.8l4.5,0l0,1.1h0.5l0,3.4l-4.4,0l0-3.4l-0.6,0L299.3,115.8z	"
        >
          <title id="t566">Sac, IA</title>
        </path>
        <path
          id="FIPS_19025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.8,115.8l4.5,0l0,1.1l0.4,0l0.1,3.4l-2.2,0l-2.2,0l0-3.4h-0.5L303.8,115.8z	"
        >
          <title id="t567">Calhoun, IA</title>
        </path>
        <path
          id="FIPS_19187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.7,114.6l0,2.2l0.4,0l0.1,3.4l-2.2,0.1l-2.2,0l-0.1-3.4l-0.4,0l0-1.1l0-1.1L312.7,114.6z	
		"
        >
          <title id="t568">Webster, IA</title>
        </path>
        <path
          id="FIPS_19073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.7,120.3l2.2,0l0.1,4.5l-1.1,0l-3.3,0.1l-0.1-4.5L308.7,120.3z	"
        >
          <title id="t569">Greene, IA</title>
        </path>
        <path
          id="FIPS_19027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.4,120.4l2.2,0l0.1,4.5l-1.1,0l-3.3,0l0-4.5L304.4,120.4z	"
        >
          <title id="t570">Carroll, IA</title>
        </path>
        <path
          id="FIPS_19047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.1,120.4l0,4.5l-4.4,0l-1.1,0v-4.5l3.3,0L302.1,120.4z	"
        >
          <title id="t571">Crawford, IA</title>
        </path>
        <path
          id="FIPS_19133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M296.6,120.4v4.5l-4.5,0l-1.3-2.4l-0.8-2.2L296.6,120.4z	"
        >
          <title id="t572">Monona, IA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36540"
              ? `metroArea clickedArea state-ne state-ia`
              : `metroArea ${colorCode[36540]} state-ne state-ia`
          }
          id="FIPS_36540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_19085"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M297.7,124.9l0,3.4l0.6,0l0,1.2h-4.6l-1.3-2.3l-0.2-2.4l4.5,0L297.7,124.9z	"
          >
            <title id="t573">Harrison, IA</title>
          </path>
          <path
            id="FIPS_19129"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M299.5,134l0,3.3l-4.2,0l-0.4-1.9l0.1-1.5L299.5,134z	"
          >
            <title id="t581">Mills, IA</title>
          </path>
          <path
            id="FIPS_19155"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M298.3,129.5l3.3,0l0,4.5l-2.2,0l-4.5,0l-0.7-0.4l-0.1-2.6l-0.4-1.5H298.3z	"
          >
            <title id="t579">Pottawattamie, IA</title>
          </path>
          <path
            id="FIPS_31025"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M290.4,135.5l0.1,0.1l0.1,0.1l0.7,0.4l0.1,0l0.3-0.1l0.3-0.1l0.1-0.1l0.1-0.1l0.2-0.2l0.1-0.1
		l0.4-0.2l0.2,0l1.3,0.1l0.1,0l0.2,0.2l0.4,1.9l-0.3,1.5l-5.9,0l0-3L290.4,135.5z	"
          >
            <title id="t1811">Cass, NE</title>
          </path>
          <path
            id="FIPS_31055"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M289,131l1.4,0l3.8,0l0.1,2.6l-3.9,0L289,131z	"
          >
            <title id="t1813">Douglas, NE</title>
          </path>
          <path
            id="FIPS_31155"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M284.8,130.2l4.2,0.8l1.4,2.6l0.1,1.9l-1.4,0.4l0-0.4l-4.3,0L284.8,130.2z	"
          >
            <title id="t1831">Saunders, NE</title>
          </path>
          <path
            id="FIPS_31177"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M289.2,127.2l3.1,0l1.3,2.3l0.4,1.5l-3.8,0l-0.9-1.2l-0.1-0.2l-0.1-0.3L289.2,127.2z	"
          >
            <title id="t1814">Washington, NE</title>
          </path>
          <path
            id="FIPS_31153"
            className="FIPS_36540 st0 state-ne state-ia"
            d="M290.3,133.6l3.9,0l0.7,0.4l-0.1,1.5l-0.2-0.2l-0.1,0l-1.3-0.1l-0.2,0l-0.4,0.2l-0.1,0.1
		l-0.2,0.2l-0.1,0.1l-0.1,0.1l-0.3,0.1l-0.3,0.1l-0.1,0l-0.7-0.4l-0.1-0.1l-0.1-0.1L290.3,133.6z	"
          >
            <title id="t1812">Sarpy, NE</title>
          </path>
        </g>
        <path
          id="FIPS_19165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.7,124.9l4.4,0l0,3.4l0.5,0l0,1.3l-1.1,0l-3.3,0l0-1.2l-0.6,0L297.7,124.9z	"
        >
          <title id="t574">Shelby, IA</title>
        </path>
        <path
          id="FIPS_19009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.2,124.9l3.3,0l0,2.8l0.4,0.6l0,1.3l-3.3,0l0-1.3l-0.5,0L302.2,124.9z	"
        >
          <title id="t575">Audubon, IA</title>
        </path>

        <path
          id="FIPS_19001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M310.4,129.4l0.1,4.5l-2.2,0l-2.2,0l-0.1-4.5L310.4,129.4z	"
        >
          <title id="t577">Adair, IA</title>
        </path>
        <path
          id="FIPS_19029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M306,129.5l0.1,4.5l-2.2,0l-2.2,0l0-4.5l1.1,0L306,129.5z	"
        >
          <title id="t578">Cass, IA</title>
        </path>

        <path
          id="FIPS_19071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.2,137.4l4.2,0l0,1.7l0.1,1.5l0,1l-3.8,0l-0.9-2.6L295.2,137.4z	"
        >
          <title id="t580">Fremont, IA</title>
        </path>

        <path
          id="FIPS_19137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M301.6,134l2.2,0l0,3.3l-4.4,0l0-3.3L301.6,134z	"
        >
          <title id="t582">Montgomery, IA</title>
        </path>
        <path
          id="FIPS_19145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.9,137.4l0,2.2h0.1l0,2l-2.8,0l-1.7,0l0-1l-0.1-1.5l0-1.7L303.9,137.4z	"
        >
          <title id="t583">Page, IA</title>
        </path>
        <path
          id="FIPS_19173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.3,137.3l0.1,4.3l-1.6,0l-2.8,0l0-2h-0.1l0-2.2L308.3,137.3z	"
        >
          <title id="t584">Taylor, IA</title>
        </path>
        <path
          id="FIPS_19003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.3,134l0.1,3.4l-4.4,0l0-3.3l2.2,0L308.3,134z	"
        >
          <title id="t585">Adams, IA</title>
        </path>
        <path
          id="FIPS_19175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M310.5,133.9l2.2,0l0.1,3.4l-4.4,0l-0.1-3.4L310.5,133.9z	"
        >
          <title id="t586">Union, IA</title>
        </path>
        <path
          id="FIPS_19159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.3,137.3l4.4,0l0.1,4.2l-2.1,0.1l-2.3,0.1L308.3,137.3z	"
        >
          <title id="t587">Ringgold, IA</title>
        </path>
        <path
          id="FIPS_19053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.7,137.3l4.4-0.1l0.1,4.1l-2.1,0.1l-2.3,0.1L312.7,137.3z	"
        >
          <title id="t588">Decatur, IA</title>
        </path>
        <path
          id="FIPS_19039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.1,133.7l0.1,3.4l-4.4,0.1l-0.1-3.4l2.2-0.1L317.1,133.7z	"
        >
          <title id="t589">Clarke, IA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19780"
              ? `metroArea clickedArea state-ia`
              : `metroArea ${colorCode[19780]} state-ia`
          }
          id="FIPS_19780"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_19049"
            className="FIPS_19780 st0 state-ia"
            d="M314.4,124.7l0.1,2.8l0.2,0.6l0,1.1l-4.3,0.2l0-1.3H310l-0.1-3.4l1.1,0L314.4,124.7z	"
          >
            <title id="t591">Dallas, IA</title>
          </path>
          <path
            id="FIPS_19077"
            className="FIPS_19780 st0 state-ia"
            d="M306.6,124.8l3.3-0.1l0.1,3.4h0.4l0,1.3l-4.4,0.1l0-1.3l-0.4-0.6l0-2.8L306.6,124.8z	"
          >
            <title id="t576">Guthrie, IA</title>
          </path>
          <path
            id="FIPS_19121"
            className="FIPS_19780 st0 state-ia"
            d="M314.7,129.2l0.1,4.5l-2.2,0.1l-2.2,0l-0.1-4.5L314.7,129.2z	"
          >
            <title id="t590">Madison, IA</title>
          </path>
          <path
            id="FIPS_19153"
            className="FIPS_19780 st0 state-ia"
            d="M318.9,124.6l0.3,4.6l0,0.2l-4.4-0.1l0-1.1l-0.2-0.6l-0.1-2.8l1.1,0L318.9,124.6z	"
          >
            <title id="t602">Polk, IA</title>
          </path>
          <path
            id="FIPS_19181"
            className="FIPS_19780 st0 state-ia"
            d="M319.2,129.4l0.1,4.3l-2.2,0.1l-2.2,0l-0.1-4.5L319.2,129.4z	"
          >
            <title id="t603">Warren, IA</title>
          </path>
        </g>
        <path
          id="FIPS_19015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.4,120.2l0.1,4.5l-1.1,0l-3.3,0.1l-0.1-4.5l2.2-0.1L315.4,120.2z	"
        >
          <title id="t592">Boone, IA</title>
        </path>
        <path
          id="FIPS_19079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.2,115.6l0.5,4.5l-2.2,0.1l-2.2,0l-0.1-3.4l-0.4,0l0-1.1L317.2,115.6z	"
        >
          <title id="t593">Hamilton, IA</title>
        </path>
        <path
          id="FIPS_19197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.6,111.2l4.5-0.1l0.1,4.5l-4.5,0.1l0-1.1L312.6,111.2z	"
        >
          <title id="t594">Wright, IA</title>
        </path>
        <path
          id="FIPS_19081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.9,106.6l0.1,4.5l-4.5,0.1l-0.1-4.5L316.9,106.6z	"
        >
          <title id="t595">Hancock, IA</title>
        </path>
        <path
          id="FIPS_19189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.9,103.4l0.1,3.2l-4.4,0.1l-0.1-3.2l3-0.1L316.9,103.4z	"
        >
          <title id="t596">Winnebago, IA</title>
        </path>
        <path
          id="FIPS_19195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.3,103.3l0.1,3.2l-4.4,0.1l-0.1-3.2l4.2-0.1L321.3,103.3z	"
        >
          <title id="t597">Worth, IA</title>
        </path>
        <path
          id="FIPS_19033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.9,106.6l4.4-0.1l0,0.6l0.1,3.9l-4.5,0.1L316.9,106.6z	"
        >
          <title id="t598">Cerro Gordo, IA</title>
        </path>
        <path
          id="FIPS_19069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317,111l4.5-0.1l0.1,4.6l-4.5,0.1L317,111z	"
        >
          <title id="t599">Franklin, IA</title>
        </path>
        <path
          id="FIPS_19083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.6,115.5l0.4,4.5l-2.2,0.1l-2.2,0.1l-0.5-4.5L321.6,115.5z	"
        >
          <title id="t600">Hardin, IA</title>
        </path>
        <path
          id="FIPS_19169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.8,120l0.1,4.5l-1.1,0l-3.3,0.1l-0.1-4.5l2.2-0.1L319.8,120z	"
        >
          <title id="t601">Story, IA</title>
        </path>

        <path
          id="FIPS_19117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.3,133.7l2.2-0.1l0.1,3.4l-4.4,0.1l-0.1-3.4L319.3,133.7z	"
        >
          <title id="t604">Lucas, IA</title>
        </path>
        <path
          id="FIPS_19185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.6,137l0.1,4.1l-2.7,0.1l-1.8,0l-0.1-4.1L321.6,137z	"
        >
          <title id="t605">Wayne, IA</title>
        </path>
        <path
          id="FIPS_19007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.1,136.9l0.2,4l-0.7,0l-3.7,0.2l-0.1-4.1L326.1,136.9z	"
        >
          <title id="t606">Appanoose, IA</title>
        </path>
        <path
          id="FIPS_19135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.9,133.5l0.1,3.4l-4.4,0.2l-0.1-3.4l2.2-0.1L325.9,133.5z	"
        >
          <title id="t607">Monroe, IA</title>
        </path>
        <path
          id="FIPS_19125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M323.5,129l0.2,4.5l-2.2,0.1l-2.2,0.1l-0.1-4.3l0-0.2L323.5,129z	"
        >
          <title id="t608">Marion, IA</title>
        </path>
        <path
          id="FIPS_19099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320,124.5l4.4-0.1l0.2,4.6l-1.1,0l-4.4,0.1l-0.3-4.6L320,124.5z	"
        >
          <title id="t609">Jasper, IA</title>
        </path>
        <path
          id="FIPS_19127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M322,120l2.2-0.1l0.2,4.5l-4.4,0.1l-0.1-4.5L322,120z	"
        >
          <title id="t610">Marshall, IA</title>
        </path>

        <path
          id="FIPS_19023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.5,110.9l4.4-0.1l0.1,3.4l0.1,1.1l-4.5,0.1L321.5,110.9z	"
        >
          <title id="t612">Butler, IA</title>
        </path>
        <path
          id="FIPS_19067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321.4,107l4.4-0.1l0.1,4l-4.4,0.1L321.4,107z	"
        >
          <title id="t613">Floyd, IA</title>
        </path>
        <path
          id="FIPS_19131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.7,103.1l0.1,3.7l-4.4,0.1l-0.1-3.7L325.7,103.1z	"
        >
          <title id="t614">Mitchell, IA</title>
        </path>
        <path
          id="FIPS_19089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.6,103.1l3.4-0.1l0.1,3.7l-4.4,0.2l-0.1-3.7L326.6,103.1z	"
        >
          <title id="t615">Howard, IA</title>
        </path>
        <path
          id="FIPS_19037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.2,106.7l0.1,1.7l0.1,2.3l-4.4,0.2l-0.1-4L330.2,106.7z	"
        >
          <title id="t616">Chickasaw, IA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "47940"
              ? `metroArea clickedArea state-ia`
              : `metroArea ${colorCode[47940]} state-ia`
          }
          id="FIPS_47940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_19013"
            className="FIPS_47940 st0 state-ia"
            d="M330.5,114l0.1,2.3l0.2,0.3l0.1,1.9l-2.2,0.1l-2.2,0.1l-0.3-3.3l-0.1-1.1L330.5,114z	"
          >
            <title id="t618">Black Hawk, IA</title>
          </path>
          <path
            id="FIPS_19017"
            className="FIPS_47940 st0 state-ia"
            d="M325.9,110.8l4.4-0.2l0.1,3.4l-4.5,0.2L325.9,110.8z	"
          >
            <title id="t617">Bremer, IA</title>
          </path>
          <path
            id="FIPS_19075"
            className="FIPS_47940 st0 state-ia"
            d="M326.1,115.3l0.3,3.3l-2.2,0.1l0,1.1L322,120l-0.4-4.5L326.1,115.3z	"
          >
            <title id="t611">Grundy, IA</title>
          </path>
        </g>
        <path
          id="FIPS_19171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.6,118.6l0.2,5.6l-4.5,0.2l-0.2-5.6L328.6,118.6z	"
        >
          <title id="t619">Tama, IA</title>
        </path>
        <path
          id="FIPS_19157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.4,124.4l4.5-0.2l0.2,4.6l-1.1,0l-3.3,0.1L324.4,124.4z	"
        >
          <title id="t620">Poweshiek, IA</title>
        </path>
        <path
          id="FIPS_19123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.6,129l3.3-0.1l0.2,4.5l-2.2,0.1l-2.2,0.1l-0.2-4.5L324.6,129z	"
        >
          <title id="t621">Mahaska, IA</title>
        </path>
        <path
          id="FIPS_19179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.1,133.4l2.2-0.1l0.1,3.4l-4.5,0.2l-0.1-3.4L328.1,133.4z	"
        >
          <title id="t622">Wapello, IA</title>
        </path>
        <path
          id="FIPS_19051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.5,136.7l0.1,3.9l-1.7,0.1l-2.8,0.2l-0.2-4L330.5,136.7z	"
        >
          <title id="t623">Davis, IA</title>
        </path>
        <path
          id="FIPS_19177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.5,136.7l4.5-0.2l0,1.1l0.1,2.8l-2.2,0l-2.3,0.2L330.5,136.7z	"
        >
          <title id="t624">Van Buren, IA</title>
        </path>
        <path
          id="FIPS_19101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M334.9,133.1l0.1,3.4l-4.5,0.2l-0.1-3.4l2.3-0.1L334.9,133.1z	"
        >
          <title id="t625">Jefferson, IA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16300"
              ? `metroArea clickedArea state-ia`
              : `metroArea ${colorCode[16300]} state-ia`
          }
          id="FIPS_16300"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_19011"
            className="FIPS_16300 st0 state-ia"
            d="M333.1,118.4l0.2,5.7l-4.5,0.2l-0.2-5.6l2.2-0.1L333.1,118.4z	"
          >
            <title id="t626">Benton, IA</title>
          </path>
          <path
            id="FIPS_19105"
            className="FIPS_16300 st0 state-ia"
            d="M339.8,118.1l2.2-0.1l0.2,3.4l0.1,1.1l-4.5,0.2l-0.2-4.5L339.8,118.1z	"
          >
            <title id="t638">Jones, IA</title>
          </path>
          <path
            id="FIPS_19113"
            className="FIPS_16300 st0 state-ia"
            d="M337.5,118.2l0.2,4.5l0.1,1.1l-4.4,0.2l-0.2-5.7l2.2-0.1L337.5,118.2z	"
          >
            <title id="t636">Linn, IA</title>
          </path>
        </g>

        <path
          id="FIPS_19095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.9,124.2l4.5-0.2l0.2,4.5l-1.1,0.1l-3.4,0.2L328.9,124.2z	"
        >
          <title id="t627">Iowa, IA</title>
        </path>
        <path
          id="FIPS_19107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.1,128.8l3.4-0.2l0.2,4.5l-2.3,0.1l-2.2,0.1l-0.2-4.5L329.1,128.8z	"
        >
          <title id="t628">Keokuk, IA</title>
        </path>
        <path
          id="FIPS_19183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.5,128.6l3-0.1l0.2,0.2l0.2,0.9l0.1,3.4l-2.2,0.1l-2.2,0.1l-0.2-4.5L333.5,128.6z	"
        >
          <title id="t629">Washington, IA</title>
        </path>
        <path
          id="FIPS_19087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.1,133l1.2,1.1l-0.2,3.4l-3,0.1l0-1.1l-0.1-3.4L337.1,133z	"
        >
          <title id="t630">Henry, IA</title>
        </path>
        <path
          id="FIPS_19111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335,137.6l3-0.1l3,1.4l-0.7,0.8l-0.3,0l-0.3,0l-0.1,0h0l-0.5,0.2l0,0l-0.1,0l-0.2,0.1
		l-0.1,0.1l0,0l0,0l0,0l-0.4,0.6l0,0.1l0,0.1l0.2,0.1l0.2,0.2l0.1,0.2l0,0.1l0,1.2l0,0l0,0.1l-0.1,0.1l0,0l-0.3,0.1l-0.6,0l-0.4-0.3
		l-1-1.2l0-0.1l0-0.3l0-0.1l-0.8-0.6l-0.2-0.1L335,137.6	"
        >
          <title id="t631">Lee, IA</title>
        </path>
        <path
          id="FIPS_19057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.3,133.9L342.3,133.9l0,0.1l0,0.3l0,1.1l-0.1,0.4l-0.1,0.1l-0.3,0.2l-0.1,0.1l-0.8,1.1
		l0,0.2l-0.1,1.5l-3-1.4l0.2-3.4L342.3,133.9z	"
        >
          <title id="t632">Des Moines, IA</title>
        </path>
        <path
          id="FIPS_19115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.9,129.6l1.1,0l0,1.1l2.8-0.1v0l-0.3,1.1l0,0.1l0,0l0.7,0.8l0.3,0.2l0.1,0l0.1,0l0.1,0.1
		l0.5,0.7l0,0.3l-4.1,0.2l-1.2-1.1L336.9,129.6z	"
        >
          <title id="t633">Louisa, IA</title>
        </path>
        <path
          id="FIPS_19139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.4,127.1l1.2,1.8l-0.6,0l-1.4,0.4l-0.4,0.1l-0.1,0.1l0,0v0l-0.1,0.1l0,0l-0.1,0.6
		l-0.1,0.4l-2.8,0.1l0-1.1l-0.1-2.3L342.4,127.1z	"
        >
          <title id="t634">Muscatine, IA</title>
        </path>
        <path
          id="FIPS_19103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.8,123.9l0.2,3.4l0.1,2.3l-1.1,0l-0.2-0.9l-0.2-0.2l-3,0.1l-0.2-4.5L337.8,123.9z	"
        >
          <title id="t635">Johnson, IA</title>
        </path>

        <path
          id="FIPS_19031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.2,122.5l0.1,2.3l0.1,2.3l-4.5,0.2l-0.2-4.5L342.2,122.5z	"
        >
          <title id="t637">Cedar, IA</title>
        </path>

        <path
          id="FIPS_19019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335,113.8l0,1l0.1,1.3l0.2,1.2l0.1,1l-2.2,0.1l-2.2,0.1l-0.1-1.9l-0.2-0.3l-0.1-2.3
		L335,113.8z	"
        >
          <title id="t639">Buchanan, IA</title>
        </path>
        <path
          id="FIPS_19065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.3,108.3l4.5-0.2l0.2,5.7l-4.5,0.2l-0.1-3.4L330.3,108.3z	"
        >
          <title id="t640">Fayette, IA</title>
        </path>
        <path
          id="FIPS_19191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M334.5,102.7l0.1,2.1l0.1,0l0.1,3.4l-4.5,0.2l-0.1-1.7l-0.1-3.7l3.3-0.1L334.5,102.7z	"
        >
          <title id="t641">Winneshiek, IA</title>
        </path>
        <path
          id="FIPS_19005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.1,102.6l0.2,1l0,0.7l1,0.7l0.2,0.3l0.3,0.5l0,0.2L339,107l-0.2,1l-4,0.2l-0.1-3.4l-0.1,0
		l-0.1-2.1L338.1,102.6z	"
        >
          <title id="t642">Allamakee, IA</title>
        </path>
        <path
          id="FIPS_19043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.8,108l0.2,1.2l0.2,1l0.9,1.9l0.1,0.2l0.8,0.5l0.3,0.1l0.5,0.1l-2.2,0.5l-4.5,0.2
		l-0.2-5.7L338.8,108z	"
        >
          <title id="t643">Clayton, IA</title>
        </path>
        <path
          id="FIPS_19055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335,113.8l4.5-0.2l0.3,4.5l-2.2,0.1l-2.2,0.1l-0.1-1l-0.2-1.2l-0.1-1.3L335,113.8z	"
        >
          <title id="t644">Delaware, IA</title>
        </path>
        <path
          id="FIPS_19061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M339.5,113.6l2.2-0.5l1.2,0.2l0.5,0.1l0.1,0.1l0.1,0.1l0.6,1.1l0.1,0.3l0,0.1l0,0.1l-0.1,0.2
		l0,0l0,0.1l0,0.1l0.1,0.1l0.2,0.2l0.6,0.3l0.8,0.6l0,0l0,0l-1.8,0.1l0.1,1.1l-2.2,0.1l-2.2,0.1L339.5,113.6z	"
        >
          <title id="t645">Dubuque, IA</title>
        </path>
        <path
          id="FIPS_19097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345.9,116.7l0.6,0.7l0,0l0,0l-0.1,0.4l-0.1,0.1v0.1l0.1,0.3l0,0l0.3,0.3l0,0l0.2,0.1l0.2,0.1
		l0.4,0.1l1.7,2l-7.1,0.4l-0.2-3.4l2.2-0.1l-0.1-1.1L345.9,116.7z	"
        >
          <title id="t646">Jackson, IA</title>
        </path>
        <path
          id="FIPS_16043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153.1,76.1l0.4,0.4l0.7,1.5l0.4,1.2l0.1,0.3l0.7,0.7l-1,6.3l-3.3,0.3l0,0l0,0l-1.5,0.2
		l-1.3-0.2l-1.2-0.8l-1.3-0.2l0.1-0.6l-1.6-0.3l0.2-1.1l1.1,0.2l1.3-0.9l0.6-0.5l0.2-0.8l0.1-0.8l0.7-0.6l0.8-0.2l0.8,0.1l0.3-1.9
		l1.6-1.8L153.1,76.1z	"
        >
          <title id="t647">Fremont, ID</title>
        </path>
        <path
          id="FIPS_16033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M150.6,78.3l-0.3,1.9l-0.8-0.1l-0.8,0.2l-0.7,0.6l-0.1,0.8l-0.2,0.8l-0.6,0.5l-1.3,0.9
		l-1.1-0.2l-4.9-0.9l-0.2,1.1l-2.7-0.5l0.6-3.3l0.5,0.1l1.1,0.2l0.3-1.9l-0.1-0.3l0.1-0.5l0.1-0.2l0.4-0.4l0.6-0.1l3.2,0.8l1.4-0.5
		l2.5,0.3l1.8,0.5L150.6,78.3z	"
        >
          <title id="t648">Clark, ID</title>
        </path>
        <path
          id="FIPS_16009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M109.6,33.4l1.2,0.3l2.4,0.4l0.1-0.3l0.3-0.1l2.2,0.5l-1.1,4.9l-1.1-0.2l-2.7-0.8l-2.1-1.6
		l0.4-1.7L109.6,33.4z	"
        >
          <title id="t649">Benewah, ID</title>
        </path>
        <path
          id="FIPS_16055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M111.3,25.8l2.3,0.5l1.2,0.1l1.1,0.2l-0.3,1.3l1.6,0.3l-1.4,6l-2.2-0.5l-0.3,0.1l-0.1,0.3
		l-2.4-0.4l-1.2-0.3L111.3,25.8z	"
        >
          <title id="t650">Kootenai, ID</title>
        </path>
        <path
          id="FIPS_16017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M113.8,15l2.1,0.5l-0.5,2.2l-0.5,2.2l6.2,1.3l-0.8,3.6l-0.6,3l-0.1-0.2l-0.4-0.6l-0.8-0.6
		l-0.1-0.1l-0.4,0l-0.5,0.4l0,0.2l-0.3,1.4l-1.6-0.3l0.3-1.3l-1.1-0.2l-1.2-0.1l-2.3-0.5l0.2-0.9L113.8,15z	"
        >
          <title id="t651">Bonner, ID</title>
        </path>
        <path
          id="FIPS_16021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M114.2,13.1l8.3,1.8l-1.3,6.2l-6.2-1.3l0.5-2.2l0.5-2.2l-2.1-0.5L114.2,13.1z	"
        >
          <title id="t652">Boundary, ID</title>
        </path>
        <path
          id="FIPS_16057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M108.9,36.4l2.1,1.6l2.7,0.8l1.1,0.2l-0.2,1.1l-0.7,3.3l-0.5,0.4l-0.7-0.2l-1.3-0.3h-0.1
		l-0.4,0.1l-0.4,0.2l-0.1,0.1l0,0l-0.2,0.3l-2.8-0.6L108.9,36.4z	"
        >
          <title id="t653">Latah, ID</title>
        </path>
        <path
          id="FIPS_16069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M107.2,43.7l2.8,0.6l0.2-0.3l0,0l0.1-0.1l0.4-0.2l0.4-0.1h0.1l1.3,0.3l-0.2,0.9l-0.1,0.8
		l0.5,0l0.2,0.1l-0.1,0.4l-0.1,0l-0.1,0l-0.2,0l-0.1,0l0,0.2l0,0.2l0.2,0.7l-0.1,0.4l0,0.1l-0.1,0.1l-1.1,0l-2-0.4l-0.1,0.3l0,0.1
		l-0.8,3.8l-0.2,0.1l-0.3,0.2l-0.1,0.1l-0.1,0.2l0,0.2l0,0.2l0.1,0.1l0,0.1l0,0.1l-0.2,0.2l-0.1,0.1l-0.4,0.1l-0.1,0l-0.6-2
		l-0.1-0.9l0.4-1.2l-0.1-1.1L107,47l0,0l-0.3-1.1l0.2-0.6L107.2,43.7z	"
        >
          <title id="t654">Nez Perce, ID</title>
        </path>
        <path
          id="FIPS_16061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M114.4,47.6l0.5,1.6l-1.6,0.9l-1.7-0.9l-0.2,0l0,0l-1.8,1.7l-0.9,0.3l0.8-3.8l0-0.1l0.1-0.3
		l2,0.4l1.1,0l0.1-0.1l0-0.1l0.1-0.4l-0.2-0.7l0-0.2l0-0.2l0.1,0l0.2,0l0.1,0l0.1,0l0.3,0.4l1,0.6l0.1,0.2l0,0.2L114.4,47.6z	"
        >
          <title id="t655">Lewis, ID</title>
        </path>
        <path
          id="FIPS_16003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M106.7,60.4l3.1,0.7l0,0.2l0.1,0.8l0,0.6l-0.1,0.3l-0.1,0l0,0.1l1.4,0.3l0.4,0.7l-0.5,1.2
		l-0.2,0.2h-0.1l-0.1-0.1l-0.4,0.7l-0.1,0.3l-0.4,1l-0.3,2.5v1.2l-1.4,0.4l-0.8-0.2l-0.3-0.2l-0.8-0.7l-0.3-1.7l-0.1-0.7l0.5-2.2
		l-2.4-0.6l0.3-0.3l0.2-0.2l0.3-0.5l0,0l0-0.1l-0.1-0.1l0-0.1l0-0.3l0.2-0.5L105,63l0.4-0.4L106.7,60.4z	"
        >
          <title id="t656">Adams, ID</title>
        </path>
        <path
          id="FIPS_16087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M103.8,65.4l2.4,0.6l-0.5,2.2l0.1,0.7l0.3,1.7l0.8,0.7l0.3,0.2l0.8,0.2l-0.5,0.9l-0.2,0.5
		l-0.2,0.8l-0.3,1l-0.1,0.3l-0.8-0.2l-4-0.9l0,0l0,0l0,0l0,0v0l0-0.1l0-0.1l0,0l-0.5-0.9l-0.1-0.1l-0.4-0.1h0l-0.1,0l-1.1-0.5
		L99.5,72l0-0.2l0-0.1l0-0.1l0.3-2.1l0.1-0.2l2-2.7l0.2-0.2l0.1,0l0.2,0l0.9-0.3L103.8,65.4z	"
        >
          <title id="t657">Washington, ID</title>
        </path>
        <path
          id="FIPS_16075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M101.8,74.1l4,0.9l-0.2,1.1l-1.3,0.8l-1.3-0.3l-0.5,2.2l-2.2-1.5l0.3-0.5l0.4-0.8l0.4-1.4
		L101.8,74.1z	"
        >
          <title id="t658">Payette, ID</title>
        </path>

        <path
          id="FIPS_16027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M100.3,77.4l2.2,1.5l1.8,0.4l-0.5,2.2l0.1,0.5l-0.1,1l-0.2,0.7l-0.4,0.7l-0.4,1.4l-0.6-0.4
		l-1.3-2.5l0-0.1l0.1-0.5l0-0.2l-0.1-0.4l-0.1-0.2l-0.2-0.3L99.6,80l-0.3-0.2L100.3,77.4z	"
        >
          <title id="t661">Canyon, ID</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14260"
              ? `metroArea clickedArea state-id`
              : `metroArea ${colorCode[14260]} state-id`
          }
          id="FIPS_14260"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_16001"
            className="FIPS_14260 st0 state-id"
            d="M104.3,79.2l2.1,0.5l1.1,1.8l1,1.6l0.1-0.1l-0.6,2.9l-0.2,1l-0.5,2.2l-2.6-0.6l-0.1-0.1
		l-0.2-0.3l-0.3-0.5l-0.2-0.4l0,0l0.1-0.3l0.1-0.2l0-0.1l-0.2-0.6l-0.1-0.1l-0.1-0.1l-0.7-0.1l0.4-1.4l0.4-0.7l0.2-0.7l0.1-1
		l-0.1-0.5L104.3,79.2z	"
          >
            <title id="t662">Ada, ID</title>
          </path>
          <path
            id="FIPS_16015"
            className="FIPS_14260 st0 state-id"
            d="M116.8,74.8l0.5,0.5l1.5,2.2l0,0.2l0,2.1l0,0.1l-0.3,0.3l-0.7,0l-1.9-0.4l-2.1,0.2l-0.2,0.1
		l-1,1l-0.4,0.5l-0.4,0.6l-0.3,0.2l-0.2,0.1l-1.3,0.5l-0.7,0l-0.5-0.1l-0.1,0l-0.1,0.1l-1-1.6l-1.1-1.8l0.1,0l0-0.1l0.9-4.3l0.6,0.1
		l0.9-0.1l0.3-0.8l5.4,1.2l0.4,0l0.5-0.2L116.8,74.8z	"
          >
            <title id="t659">Boise, ID</title>
          </path>
          <path
            id="FIPS_16027"
            className="FIPS_14260 st0 state-id"
            d="M100.3,77.4l2.2,1.5l1.8,0.4l-0.5,2.2l0.1,0.5l-0.1,1l-0.2,0.7l-0.4,0.7l-0.4,1.4l-0.6-0.4
		l-1.3-2.5l0-0.1l0.1-0.5l0-0.2l-0.1-0.4l-0.1-0.2l-0.2-0.3L99.6,80l-0.3-0.2L100.3,77.4z	"
          >
            <title id="t661">Canyon, ID</title>
          </path>
          <path
            id="FIPS_16045"
            className="FIPS_14260 st0 state-id"
            d="M109.4,71.2L109.4,71.2l-0.4,2.2l-0.5-0.1l-0.5,2.2l-0.6-0.1l-0.9,4.3l0,0.1l-0.1,0l-2.1-0.5
		l-1.8-0.4l0.5-2.2l1.3,0.3l1.3-0.8l0.2-1.1l0.8,0.2l0.1-0.3l0.3-1l0.2-0.8l0.2-0.5l0.5-0.9L109.4,71.2z	"
          >
            <title id="t660">Gem, ID</title>
          </path>
          <path
            id="FIPS_16073"
            className="FIPS_14260 st0 state-id"
            d="M99.3,79.8l0.3,0.2l1.1,1.3l0.2,0.3l0.1,0.2l0.1,0.4l0,0.2l-0.1,0.5l0,0.1l1.3,2.5l0.6,0.4
		l0.7,0.1l0.1,0.1l0.1,0.1l0.2,0.6l0,0.1l-0.1,0.2l-0.1,0.3l0,0l0.2,0.4l0.3,0.5l0.2,0.3l0.1,0.1l0,0.1l0.4,0.8l0.9,1l0.6,0.6l0.1,0
		l1.9,0.4l3.2,0.9l-0.2,0.7l-0.1,0.3l-0.2,1.1l3.9,0.8l-2,9.8l-13.7-2.9l-1.1-0.2l-3.6-0.8l-0.1,0L99.3,79.8z	"
          >
            <title id="t664">Owyhee, ID</title>
          </path>
        </g>
        <path
          id="FIPS_16039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M118.5,80.3l0.1,0.2l-0.4,1l-0.1,0.1l-0.3,0.4l-0.1,0.2l-1,2.3l-0.6,3l-0.4,2.2l-0.3,3.7
		l-0.4,1.8l-3.9-0.8l0.2-1.1l0.1-0.3l0.2-0.7l-3.2-0.9l-1.9-0.4l-0.1,0l-0.6-0.6l-0.9-1l-0.4-0.8l0-0.1l2.6,0.6l0.5-2.2l0.2-1
		l0.6-2.9l0.1,0l0.5,0.1l0.7,0l1.3-0.5l0.2-0.1l0.3-0.2l0.4-0.6l0.4-0.5l1-1l0.2-0.1l2.1-0.2l1.9,0.4L118.5,80.3z	"
        >
          <title id="t663">Elmore, ID</title>
        </path>

        <path
          id="FIPS_16025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M118.3,81.5l0.9,0.7l1.5,0.4l0.1,0.1l0,0.1l0,0.2l0,0.6l-0.1,1l0,0.9l1.4,3.7l0.3,0.2l0,1.1
		l-0.1,0.6l-2-0.4l-4.5-0.9l0.4-2.2l0.6-3l1-2.3l0.1-0.2l0.3-0.4L118.3,81.5z	"
        >
          <title id="t665">Camas, ID</title>
        </path>
        <path
          id="FIPS_16047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M115.7,89.7l4.5,0.9l-0.9,4.4l-0.7,2.5l-1.2-0.6l-0.6-0.6l-0.5-0.9l0.3-1.1l0-0.1l-0.4-0.8
		l-0.3-0.1l-0.3-0.1l-0.1,0.1L115.7,89.7z	"
        >
          <title id="t666">Gooding, ID</title>
        </path>
        <path
          id="FIPS_16053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M119.3,95l2.1,0.4l-0.1,0.3l0.1,0.2l1.8,0.5l0.8,0.5l1.1,0.2l-0.6,2.9l-0.7,0l-1.2,0.1
		l-0.4-0.4l-0.1-0.1l-0.4-0.4l-1.5-0.8l-0.6-0.2l-1.1-0.7l-0.1-0.1L119.3,95z	"
        >
          <title id="t667">Jerome, ID</title>
        </path>
        <path
          id="FIPS_16083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M115.4,93.4l0.1-0.1l0.3,0.1l0.3,0.1l0.4,0.8l0,0.1l-0.3,1.1l0.5,0.9l0.6,0.6l1.2,0.6l0.1,0.1
		l1.1,0.7l0.6,0.2l1.5,0.8l0.4,0.4l0.1,0.1l0.4,0.4l1.2-0.1l-0.4,0.1l-0.5,0.9l-2.1-0.1l-0.1,0.8l0,0.3l-0.8,4.3l-2-0.4l-2.5-0.6
		l-1.4-0.3l-1.2-0.2l2-9.8L115.4,93.4z	"
        >
          <title id="t668">Twin Falls, ID</title>
        </path>
        <path
          id="FIPS_16031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M124.7,100.2l2,0.6l0.1,0l0.1,0l0.4-0.1l0.1-0.1l0.1-0.2l0.7-0.9l0.1-0.1l0.1-0.1l0.4-0.1
		l0.4,0l0.6,0l0.5,0.1l0.2,0.4l0.1,0.2l0.5,0.3l0.1,0l0.1-0.1l0.4,0l1.7,0.9l-0.6,3.3l-0.8,4.2l-3.8-0.6l-0.3,0l-3.1-0.5l-0.3,0
		l-0.8-0.1l-0.1,0l-0.8-0.2l-0.6-0.2l-2.2-0.4l0.8-4.3l0-0.3l0.1-0.8l2.1,0.1l0.5-0.9l0.4-0.1L124.7,100.2z	"
        >
          <title id="t669">Cassia, ID</title>
        </path>
        <path
          id="FIPS_16071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M138.7,103.2l0.8,0.8v0.9l0.4,0.4l0.9,0.9l0.2,0.2l0.2,0.3l0.2,0.4l-0.1,0.9l-0.4-0.1
		l-0.4,2.2l-0.5-0.1l-0.7-0.2h0l-2-0.3l-2.4-0.4l-2.7-0.5l0.8-4.2l3.2,0.6l0.2-1.1l1.5,0.3l0.2-1.1L138.7,103.2z	"
        >
          <title id="t670">Oneida, ID</title>
        </path>
        <path
          id="FIPS_16077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M134.6,94.5l-0.6,3.2l1.8,0.3l0.8-1l0.4,0.4l1.1-0.4l0.1,0l0.3,0.3l0.2,0.6l0.7,3.6l0,0.3
		l-0.2,0.7l-0.5,0.8l-0.7-0.1l-0.2,1.1l-1.5-0.3l-0.2,1.1l-3.2-0.6l0.6-3.3l-1.7-0.9l-0.4,0l0.3-1.7l0.1-1.1l0.6-3.3L134.6,94.5z	"
        >
          <title id="t671">Power, ID</title>
        </path>
        <path
          id="FIPS_16005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M143.2,97.2l-0.8,0.9l0,0.1l-0.2,0.4l-0.3,1.4l0,0.4l0,0.1l0.2,0.7l0.1,0.1l0.1,0l0.2-0.1
		l0-0.1l0.1,0l0.8,0.1l0.3,1.2l0,0.2l0,1.7l0,0.6l-0.1,0.4l-0.2,0l-0.4,2l-0.8-0.1l-0.4-0.3l-0.9-0.3l-0.2-0.2l-0.9-0.9l-0.4-0.4
		v-0.9l-0.8-0.8l0.5-0.8l0.2-0.7l0-0.3l-0.7-3.6l-0.2-0.6l-0.3-0.3l-0.1,0l-1.1,0.4l-0.4-0.4v-0.1l0-0.1l0.1-0.3l0.8-0.3l0.1,0
		L143.2,97.2z	"
        >
          <title id="t672">Bannock, ID</title>
        </path>
        <path
          id="FIPS_16041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M143.6,105.2l2.6,0.4l-0.1,1.3l-0.4,0.9l-0.2,0.5l0,0.2l0.1,1.2l0,0.1l0.6,1.3l-5.7-0.9
		l0.4-2.2l0.4,0.1l0.1-0.9l-0.2-0.4l-0.2-0.3l0.9,0.3l0.4,0.3l0.8,0.1l0.4-2L143.6,105.2z	"
        >
          <title id="t673">Franklin, ID</title>
        </path>
        <path
          id="FIPS_16007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M151.6,105.2l-1.1,6.6l-4.3-0.7l-0.6-1.3l0-0.1l-0.1-1.2l0-0.2l0.2-0.5l0.4-0.9l0.1-1.3l0-1.7
		l0-0.3l0.3-0.2l3.4,0.5l0.1,0.3l0,0.1l-0.1,0.3l-0.1,0.2l-0.1,0.2l0.8,0.4L151.6,105.2z	"
        >
          <title id="t674">Bear Lake, ID</title>
        </path>
        <path
          id="FIPS_16029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M147.6,97.9l5.1,0.8l-1.1,6.5l-1.1,0.2l-0.8-0.4l0.1-0.2l0.1-0.2l0.1-0.3l0-0.1l-0.1-0.3
		l-3.4-0.5l-0.3,0.2l0,0.3l0,1.7l-2.6-0.4l0.1-0.4l0-0.6l0-1.7l0-0.2l-0.3-1.2l-0.8-0.1l-0.1,0l0,0.1l-0.2,0.1l-0.1,0l-0.1-0.1
		l-0.2-0.7l0-0.1l0-0.4l0.3-1.4l0.2-0.4l0-0.1l0.8-0.9L147.6,97.9z	"
        >
          <title id="t675">Caribou, ID</title>
        </path>
        <path
          id="FIPS_16067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M128.3,92.1l2.8,0.5l-0.8,4.5l-0.5-0.1l-0.4,2.3l-0.4,0l-0.4,0.1l-0.1,0.1l-0.1,0.1l-0.7,0.9
		l-0.1,0.2l-0.1,0.1l-0.4,0.1l-0.1,0l-0.1,0l-2-0.6l0.6-2.9l1.6,0.3l0.7-1L128.3,92.1z	"
        >
          <title id="t676">Minidoka, ID</title>
        </path>
        <path
          id="FIPS_16063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M120.2,90.6l2,0.4l6.1,1.2l-0.8,4.5l-0.7,1l-2.6-0.5l-0.8-0.5l-1.8-0.5l-0.1-0.2l0.1-0.3
		l-2.1-0.4L120.2,90.6z	"
        >
          <title id="t677">Lincoln, ID</title>
        </path>
        <path
          id="FIPS_16019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M148.5,90.1l2.1,0.4l1.4,0.2l0.1,0.2l0,0.1l0.8,1l0.7,0.5l-0.4,2.4l-0.6,3.8l-5.1-0.8l0.4-2.3
		l0.2-1l-2-1.4l-2.5-1.2l-3.8-0.7l0.5-2.6L148.5,90.1z	"
        >
          <title id="t678">Bonneville, ID</title>
        </path>
        <path
          id="FIPS_16011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M140.3,88.7l-0.5,2.6l3.8,0.7l2.5,1.2l2,1.4l-0.2,1l-0.4,2.3l-4.4-0.8l-5.5-0.9l-0.1,0
		l-0.8,0.3l-0.1,0.3l0,0.1v0.1l-0.8,1l-1.8-0.3l0.6-3.2l0.4-2.2l0.6,0.1l0.3-1l0.2-1l1.1,0.2l1.3-1l0.2-1.1L140.3,88.7z	"
        >
          <title id="t679">Bingham, ID</title>
        </path>
        <path
          id="FIPS_16013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M118.7,80.5l0.4-0.3l0.1-0.1l0.3-0.1l0.1,0l0.5,0.1l1,1.1L122,82l1-0.1l1.3,0.4l0.4,0.3
		l2.4,2.6l0.7,0.9l0.1,0.2l0.3,0.5l0.1,0.2l0.1,0.3l0.5-0.2l0.2,0l0.2,0.1l0,0.1l0.4,1.1l0.1,0.5l-0.2,0.1l-0.2,1l2.5,0.5l-0.2,1.1
		l3.3,0.6l-0.4,2.2l-2.2-0.4l-0.6,3.3l-0.1,1.1l-0.3,1.7l-0.1,0.1l-0.1,0l-0.5-0.3l-0.1-0.2l-0.2-0.4l-0.5-0.1l-0.6,0l0.4-2.3
		l0.5,0.1l0.8-4.5l-2.8-0.5l-6.1-1.2l0.1-0.6l0-1.1l-0.3-0.2l-1.4-3.7l0-0.9l0.1-1l0-0.6l0-0.2l0-0.1l-0.1-0.1l-1.5-0.4l-0.9-0.7
		L118.7,80.5	"
        >
          <title id="t680">Blaine, ID</title>
        </path>
        <path
          id="FIPS_16085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M111.2,63.5L111.2,63.5l0.2-0.4l0.2-0.2l1.4-0.2l11.4,2.3l-0.2,0.1l-0.1,0.1l-0.1,0.4
		l-0.1,0.7l-0.1,0.6l-0.3,1.2l-0.5,1l-0.5,0.6l-1.4,0.8l-0.1,0l-0.4-0.1l-0.3-0.4l-0.3-0.2l-0.2,0l-0.4,0.2l-1.6,1.4l-0.3,0.4l0,0.4
		l0,0.2l0.1,0.2l0.2,0.1l0.1,0l0,0l0.1,0.1l0,0.4l-0.2,0.7l-0.1,0.1l-0.2,0.3l-0.2,0.2l-0.3,0.3l-0.1,0.1l-1.2,0.7l-0.5,0.2l-0.4,0
		l-5.4-1.2l-0.3,0.8l-0.9,0.1l0.5-2.2l0.5,0.1l0.5-2.2l0,0V70l0.3-2.5l0.4-1l0.1-0.3l0.4-0.7l0.1,0.1h0.1l0.2-0.2l0.5-1.2
		L111.2,63.5	"
        >
          <title id="t681">Valley, ID</title>
        </path>
        <path
          id="FIPS_16079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M117.2,28.2l0.3-1.4l0-0.2l0.5-0.4l0.4,0l0.1,0.1l0.8,0.6l0.4,0.6l0.1,0.2l0.3,0.5l1.7,3.5
		l0,0l0,0l0,0v0l0,0.7l-0.3,0.7l-0.2,0.6l-0.2,1v0l0,0.3l1.4,1.9l0.2,0.2l0.1,0.1l0.5,0.2l0.7,0.3l0.1,0.1l0.8,1.8l0.7,1.7l0.4,0.8
		l0.2,0.4l-11.7-2.5l0.2-1.1l1.1-4.9L117.2,28.2z	"
        >
          <title id="t682">Shoshone, ID</title>
        </path>
        <path
          id="FIPS_16035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M114.5,40.2l11.7,2.5l0.2,1.3v0l0,0.1l1.3,1.7l0.1,0l0.1,0l0.4,0l0.5,1.2l-5.6,0.1l-3.8,0.1
		l0,0l-1.2,1.5l-0.3,0.5l-0.2,0.2l-0.2,0.2l-0.1,0l-0.2-0.1l-1.3-0.6l-0.1,0l-0.2-0.3l-0.2-0.3l-0.9-0.5l-0.2-0.1l0-0.2l0-0.2
		l-0.1-0.2l-1-0.6l-0.3-0.4l0.1-0.4l-0.2-0.1l-0.5,0l0.1-0.8l0.2-0.9l0.7,0.2l0.5-0.4L114.5,40.2z	"
        >
          <title id="t683">Clearwater, ID</title>
        </path>
        <path
          id="FIPS_16049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M131.1,47.4L131.1,47.4l0.1,0.2l-0.1,0.3l-0.3,0.9l-0.5,1.2l-0.8,1.8l-2.5,6.3l-0.3,1.7
		l-0.2,0.9l0,0l0,0l-0.4,0.3l-0.9,0.6l-0.5-0.2l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1,0l-0.1,0l-0.1,0.1l-0.1,0.3l-0.1,0.5l0,0l0.3,0.5
		l0.5,0.6l0.4,0.8l-0.9,1.3l-11.4-2.3l-1.4,0.2l-0.2,0.2l-0.1,0.3l0,0.1l-1.4-0.3l0-0.1l0.1,0l0.1-0.3l0-0.6l-0.1-0.8l0-0.2
		l-3.1-0.7l0.3-0.6l1.6-2l0.9-0.9l0.2-0.2l0-0.2l-0.3-1.6l-0.1-0.2v0l-0.2-0.2l-0.2-0.2l0,0l-0.3-0.1l-0.8-0.7l-0.4-0.4l0,0l0-0.1
		l0.1,0l0.4-0.1l0.1-0.1l0.2-0.2l0-0.1l0-0.1l-0.1-0.1l0-0.2l0-0.2l0.1-0.2l0.1-0.1l0.3-0.2l0.2-0.1l0.9-0.3l1.8-1.7l0,0l0.2,0
		l1.7,0.9l1.6-0.9l-0.5-1.6l0.2,0.1l0.9,0.5l0.2,0.3l0.2,0.3l0.1,0l1.3,0.6l0.2,0.1l0.1,0l0.2-0.2l0.2-0.2l0.3-0.5l1.2-1.5l0,0
		l3.8-0.1l5.6-0.1l0,0l1,0.2l0.2-0.1l0.1-0.1l0.2,0l0.5,0.1L131.1,47.4L131.1,47.4z	"
        >
          <title id="t684">Idaho, ID</title>
        </path>
        <path
          id="FIPS_16037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M116.8,74.8l0.1-0.1l0.3-0.3l0.2-0.2l0.2-0.3l0.1-0.1l0.2-0.7l0-0.4l-0.1-0.1l0,0l-0.1,0
		l-0.2-0.1l-0.1-0.2l0-0.2l0-0.4l0.3-0.4l1.6-1.4l0.4-0.2l0.2,0l0.3,0.2l0.3,0.4l0.4,0.1l0.1,0l1.4-0.8l-0.2,0.8l0,0.2l0.1,0.2
		l1.5,1.9l0.3,0.3l0.1,0l0.8-0.1l0.3-0.2l0.7-0.6l0,0l0.2-0.4l0.2-0.5l0.3-0.4l0.4-0.3l0.9-0.7l0.2,0.3l0,0.5l0,1.1l2.5,3.7l1.3,0.8
		l1,0.5l0.1,0l0.3,0.1l0.1,0l0.1-0.1l0.1-0.2l0.1-0.1l0.1,0l0,0.1l0.1,0.2l0.5,1.3l0.1,0.4l0,0.5l-0.1,0.5l-0.9-0.2l-0.8,2.1
		l-0.1,0.4l-0.2,1.5l-0.2,1.4l-1,1l-1.5,0.5l-0.9,0.5l-0.4,0.4l0,0.1l-0.1-0.3l-0.1-0.2l-0.3-0.5l-0.1-0.2l-0.7-0.9l-2.4-2.6
		l-0.4-0.3l-1.3-0.4l-1,0.1l-0.8-0.8l-1-1.1l-0.5-0.1l-0.1,0l-0.3,0.1l-0.1,0.1l-0.4,0.3l-0.1-0.2l0.3-0.3l0-0.1l0-2.1l0-0.2
		l-1.5-2.2L116.8,74.8z	"
        >
          <title id="t685">Custer, ID</title>
        </path>
        <path
          id="FIPS_16059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M132.1,60.1l0.2,0.2l0.9,1.2l0.1,0.2l0.1,1l0,0.4l-0.1,0.2l0,0.8l0,1l1.4,5.2l1.5,2.1l0.3-0.1
		l0.3,0.3l0.4,0.4l0.2,0.3l0.2,0.6l0.3,1.1v0.1l-0.1,0.1l0,0l0,1.6l0.1,0.6l0.2,0.4l0.7,0.8l0.2,0.1l0.2-0.1l0.1-0.1l0,0l0.1,0.3
		l-0.3,1.9l-1.1-0.2l-0.5-0.1l-3-0.5l0.1-0.5l0-0.5l-0.1-0.4l-0.5-1.3l-0.1-0.2l0-0.1l-0.1,0l-0.1,0.1l-0.1,0.2l-0.1,0.1l-0.1,0
		l-0.3-0.1l-0.1,0l-1-0.5l-1.3-0.8l-2.5-3.7l0-1.1l0-0.5l-0.2-0.3l-0.9,0.7l-0.4,0.3l-0.3,0.4l-0.2,0.5l-0.2,0.4l0,0l-0.7,0.6
		l-0.3,0.2l-0.8,0.1l-0.1,0l-0.3-0.3l-1.5-1.9l-0.1-0.2l0-0.2l0.2-0.8l0.5-0.6l0.5-1l0.3-1.2l0.1-0.6l0.1-0.7l0.1-0.4l0.1-0.1
		l0.2-0.1l0.9-1.3l-0.4-0.8l-0.5-0.6l-0.3-0.5l0,0l0.1-0.5l0.1-0.3l0.1-0.1l0.1,0l0.1,0l0.1,0.1l0.1,0.1l0.1,0.1l0.5,0.2l0.9-0.6
		l0.4-0.3l0.4,0.1l0.4,0.1l0.1,0l0.7,1l0.1,0.3v0l0.4,0.1l1.8-0.8l1.1-1L132.1,60.1z	"
        >
          <title id="t686">Lemhi, ID</title>
        </path>
        <path
          id="FIPS_16023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M137.3,80.2l-0.6,3.3l2.7,0.5l-0.8,4.4l-0.2,1.1l-1.3,1l-1.1-0.2l-0.2,1l-0.3,1l-0.6-0.1
		l-3.3-0.6l0.2-1.1l-2.5-0.5l0.2-1l0.2-0.1l-0.1-0.5l-0.4-1.1l0-0.1l-0.2-0.1l-0.2,0l-0.5,0.2l0-0.1l0.4-0.4l0.9-0.5l1.5-0.5l1-1
		l0.2-1.4l0.2-1.5l0.1-0.4l0.8-2.1l0.9,0.2L137.3,80.2z	"
        >
          <title id="t687">Butte, ID</title>
        </path>
        <path
          id="FIPS_16051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M139.5,84l0.2-1.1l4.9,0.9l-0.2,1.1l1.6,0.3l-0.1,0.6l-0.3,1.6l-0.1,0.6l0.1,0.1l0.2,0l0,0
		l2.7,1.7l-0.1,0.4l-8.2-1.4l-1.6-0.2L139.5,84z	"
        >
          <title id="t688">Jefferson, ID</title>
        </path>
        <path
          id="FIPS_16065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M145.9,85.7l1.3,0.2l1.2,0.8l1.3,0.2l1.5-0.2l0,0l0,0l-0.6,3.8l-2.1-0.4l0.1-0.4l-2.7-1.7l0,0
		l-0.2,0l-0.1-0.1l0.1-0.6L145.9,85.7z	"
        >
          <title id="t689">Madison, ID</title>
        </path>
        <path
          id="FIPS_16081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M154.6,86.4l-1,6.2l-0.7-0.5l-0.8-1l0-0.1l-0.1-0.2l-1.4-0.2l0.6-3.8L154.6,86.4z	"
        >
          <title id="t690">Teton, ID</title>
        </path>
        <path
          id="FIPS_17183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376,139.2l0.3,4.3l0.3,3.4l-4,0.4l-0.4-4.5l0.1,0l-0.2-2.2l-0.1-1.1l4-0.4L376,139.2z	"
        >
          <title id="t691">Vermilion, IL</title>
        </path>
        <path
          id="FIPS_17075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M369.6,133l5.8-0.7l0.6,6.7l-4,0.4l-1.8,0.1L369.6,133z	"
        >
          <title id="t692">Iroquois, IL</title>
        </path>
        {/* <g
          className={`metroArea colorKey ${colorCode[16020]}`}
          id="FIPS_16020"
          // ref={f16020}
          data-color-code={colorCode[16020] ? colorCode[16020] : null}
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        > */}
        <path
          id="FIPS_17003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.8,181.5l2.4-0.2l0,1.4l0,1.3l0.1,0.2l0.1,0.1l0.2,0.1l0.7,0.3l0.5,1.1l-2-0.2L361,185
		l-0.4-0.9L360,183l-0.3-0.4L359.8,181.5z	"
        >
          <title id="t693">Alexander, IL</title>
        </path>
        <path
          id="FIPS_29017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.7,178.3l0.3,6.1l-0.9,0l0.1,0.9l-0.6,0.2l-0.9,0.1l0-0.6l-1.1,0.1l-0.1-3l0.7,0l-0.1-3
		l-0.1-0.7L355.7,178.3z	"
        >
          <title id="t1508">Bollinger, MO</title>
        </path>
        <path
          id="FIPS_29031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.7,178.3l3.5,0.2l0,0.1l0.1,0.3l0,0l0.3,0.5l0.2,0.3l0.3,0.3l0.1,0.2l0.2,0.4l0,0l0,0
		l0.1,0.2l0,0l0,0l0,0.4l0,0.1l0,0l0,0l0,0l-0.1,0.1l-0.4,0.1l0,1.1l-2.7,1.8l-1,0.1L355.7,178.3z	"
        >
          <title id="t1510">Cape Girardeau, MO</title>
        </path>
        {/* </g> */}
        <path
          id="FIPS_17153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.2,181.3l2.1-0.1l1.2,0.3l0.1,1l-0.1,0l-2.3,2.2l-0.7-0.3l-0.2-0.1l-0.1-0.1l-0.1-0.2
		l0-1.3L362.2,181.3z	"
        >
          <title id="t694">Pulaski, IL</title>
        </path>
        <path
          id="FIPS_17127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.4,181.5l2.2-0.6l2.4,2.1l0.1,1.2l-0.7-0.1l-3.9-1.6L365.4,181.5z	"
        >
          <title id="t695">Massac, IL</title>
        </path>
        <path
          id="FIPS_17069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.8,177.2l2.5,0.1l0.8,0.8v0.2l-0.2,0.2l-0.1,0l-1.4,0.3l-0.2,0l-0.2,0l-0.1,0l0,0
		l-0.2,0.1l0,0l0,0l-0.2,0.2l-0.3,0.3l-0.6-0.2l-0.2-2.3L370.8,177.2z	"
        >
          <title id="t696">Hardin, IL</title>
        </path>
        <path
          id="FIPS_17151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.4,177.2l0.2,2.3l-0.1,0l-0.2,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.2l-0.1,0.1l-0.3,1.3v0l0,0.1
		l0.1,0.3l0.4,0.5l0.1,0.1l0.1,0.1l0.3,0.6l-0.1,0.7l-0.1,0.3l-0.2,0.1l-0.1,0L370,183l-2.4-2.1l-0.2-3.4L370.4,177.2z	"
        >
          <title id="t697">Pope, IL</title>
        </path>
        <path
          id="FIPS_17087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.4,177.5l0.2,3.4l-2.2,0.6l-1.2-0.3l-0.2-3.5L367.4,177.5z	"
        >
          <title id="t698">Johnson, IL</title>
        </path>
        <path
          id="FIPS_17181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364,177.8l0.2,3.5l-2.1,0.1l-2.4,0.2l0.4-0.1l0.1-0.1l0,0l0,0l0,0l0-0.1l0-0.4l0,0l0,0
		l-0.1-0.2l0,0l0,0l-0.2-0.4L360,180l-0.3-0.3l-0.2-0.3l-0.3-0.5l0,0l-0.1-0.3l0-0.1v-0.1l3.7-0.6L364,177.8z	"
        >
          <title id="t699">Union, IL</title>
        </path>
        <path
          id="FIPS_17059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.5,173.2l0.5,1.1l-0.1,0.5l0,0.1l-0.1,0.1l-0.1,0.1l-0.5,0.3l0,0l-0.2,0.3l-0.1,0.1l0,0
		l-0.1,0.1l0,0.1l0,0l0.1,0.3l0,0l0.2,0.6l0.1,0.1l-2.5-0.1l-0.3-4v0L373.5,173.2z	"
        >
          <title id="t700">Gallatin, IL</title>
        </path>
        <path
          id="FIPS_17165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.4,173.2l0.3,4l-0.4,0l-3,0.2l-0.2-3.4l0-0.6L370.4,173.2z	"
        >
          <title id="t701">Saline, IL</title>
        </path>
        <path
          id="FIPS_17199"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.1,174.1l0.2,3.4l-3.4,0.3l-1.1,0l-0.2-3.4L367.1,174.1z	"
        >
          <title id="t702">Williamson, IL</title>
        </path>
        <path
          id="FIPS_17077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.1,173.5l4.2-0.2l0.4,1.1l0.2,3.4l-3.7,0.6l-1.7-2.9L358.1,173.5z	"
        >
          <title id="t703">Jackson, IL</title>
        </path>

        <path
          id="FIPS_17157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.9,170.1l0.2,3.4l-0.7,2l-2.7-0.8l-2.9-2.6l1.7-0.7l-0.1-1.1l1.4-0.1l2-0.1L357.9,170.1z	
		"
        >
          <title id="t705">Randolph, IL</title>
        </path>
        <path
          id="FIPS_17145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.9,170.1l4.5-0.2l0.3,1.1l-0.3,2.3l-4.2,0.2L357.9,170.1z	"
        >
          <title id="t706">Perry, IL</title>
        </path>
        <path
          id="FIPS_17055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.9,170.7l0.2,3.4l-4.5,0.4l-0.4-1.1l0.3-2.3L366.9,170.7z	"
        >
          <title id="t707">Franklin, IL</title>
        </path>
        <path
          id="FIPS_17065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.1,168.7l0.3,4.5v0l-3.3,0.3l-0.2-2.8l-0.1-1.7L370.1,168.7z	"
        >
          <title id="t708">Hamilton, IL</title>
        </path>
        <path
          id="FIPS_17193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.9,168.3l0.4,0.4l-0.1,1.4l-0.1,3l0,0.1l0,0l0,0l0,0l-0.5,0l-3.1,0l-0.3-4.5l2.2-0.2
		L373.9,168.3z	"
        >
          <title id="t709">White, IL</title>
        </path>
        <path
          id="FIPS_17081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.6,166.1l0.2,2.8l0.1,1.7l-4.3,0.3l-0.3-1.1l-0.2-3.4L366.6,166.1z	"
        >
          <title id="t710">Jefferson, IL</title>
        </path>
        <path
          id="FIPS_17189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.1,166.1l0,0.4l0.2,3.4l-4.5,0.2l-1.1,0.1l-0.2-2.6l0.3-0.3l0.5-0.4l0.4-0.2l3-0.5
		L362.1,166.1z	"
        >
          <title id="t711">Washington, IL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41180"
              ? `metroArea clickedArea state-il state-mo`
              : `metroArea ${colorCode[41180]} state-il state-mo`
          }
          id="FIPS_41180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17005"
            className="FIPS_41180 st0 state-il state-mo"
            d="M360.6,159.4l0.2,3.7l-3.4,0.2l-0.1-0.9l-0.3-0.8l-0.2-0.6l-0.1-1L360.6,159.4z	"
          >
            <title id="t715">Bond, IL</title>
          </path>
          <path
            id="FIPS_17013"
            className="FIPS_41180 st0 state-il state-mo"
            d="M343.4,155.6l3.3-0.1l0.3,3.6l1.6,1.9l-2.1,0.6l-0.5-1.4v0l0-0.1l0,0l0.3-0.4l0-0.2l-0.5-1.6
		L343.4,155.6z	"
          >
            <title id="t733">Calhoun, IL</title>
          </path>
          <path
            id="FIPS_17027"
            className="FIPS_41180 st0 state-il state-mo"
            d="M360.8,163.1l1.2,0l0.2,3l-1.3,0l-3,0.5l-0.4,0.2l-0.5,0.4l-0.3,0.3l-0.2-3.1l1-1.2
		L360.8,163.1z	"
          >
            <title id="t712">Clinton, IL</title>
          </path>
          <path
            id="FIPS_17083"
            className="FIPS_41180 st0 state-il state-mo"
            d="M351.5,156.9l0.2,3.4l-1.2,1l-1.8-0.4l-1.6-1.9l0.2-0.9l0.4-0.1l0.3,0l0.1,0.1l0,0l0.2,0.1
		l1.7-0.1l0-0.7l1.2-0.6L351.5,156.9z	"
          >
            <title id="t731">Jersey, IL</title>
          </path>
          <path
            id="FIPS_17117"
            className="FIPS_41180 st0 state-il state-mo"
            d="M353.5,153.4l2.2-0.2l0.5,6.8l-4.4,0.3l-0.2-3.4l-0.3-3.3L353.5,153.4z	"
          >
            <title id="t732">Macoupin, IL</title>
          </path>
          <path
            id="FIPS_17119"
            className="FIPS_41180 st0 state-il state-mo"
            d="M356.8,160l0.1,1l0.2,0.6l0.3,0.8l0.1,0.9l-1,1.2l-4.7,0.2l-0.2-1l0.7-0.9l0-0.1l0-0.3l0-0.1
		l0-0.1l-1-0.6l-0.2-0.1l-0.3-0.1l-0.3-0.1l1.2-1l4.4-0.3L356.8,160z	"
          >
            <title id="t714">Madison, IL</title>
          </path>
          <path
            id="FIPS_17133"
            className="FIPS_41180 st0 state-il state-mo"
            d="M350.9,166.6l1.3,1.1l2.4,1.9l0.3,0.6l-1.4,0.1l0.1,1.1l-1.7,0.7l-0.5-0.4l-0.8-0.8l0,0l0,0
		l-0.2-0.3l-0.1-0.3l-0.1-0.6l0-0.5l0-0.1l0-0.1l0.1-0.5l0-0.1l0,0L350.9,166.6z	"
          >
            <title id="t704">Monroe, IL</title>
          </path>
          <path
            id="FIPS_17163"
            className="FIPS_41180 st0 state-il state-mo"
            d="M351.6,164.8l4.7-0.2l0.2,3.1l0.2,2.6l-2,0.1l-0.3-0.6l-2.4-1.9l-1.3-1.1l0-0.2L351.6,164.8z	
		"
          >
            <title id="t713">St. Clair, IL</title>
          </path>
          <path
            id="FIPS_29071"
            className="FIPS_41180 st0 state-il state-mo"
            d="M343.9,166.7l2.3-1.3l0.1,2.2L346,171l-3.2,0.2l-2.7,0.1l-0.1-1.6l-0.1-2.3l-0.1-2.5l0.4-0.1
		l0.1,0l0.8,0.7l0.1,0.1L343.9,166.7z	"
          >
            <title id="t1496">Franklin, MO</title>
          </path>
          <path
            id="FIPS_29099"
            className="FIPS_41180 st0 state-il state-mo"
            d="M346.2,167.6l0.1-0.2l1.3-0.3l1.9-0.1l0.6,1.2l0.1,0.3l0,0l0,0.1l-0.1,0.5l0,0.1l0,0.1l0,0.5
		l0.1,0.6l0.1,0.3l0.2,0.3l0,0l0,0l0.8,0.8l-1.6,1.1l-2.3-0.3L346,171L346.2,167.6z	"
          >
            <title id="t1500">Jefferson, MO</title>
          </path>
          <path
            id="FIPS_29113"
            className="FIPS_41180 st0 state-il state-mo"
            d="M345.9,157.7l0.5,1.6l0,0.2l-0.3,0.4l0,0l0,0.1v0l0.5,1.4l-2.9,1l-1,0l-0.7-0.7l-0.6-0.7
		l-0.8,0l-0.1-1.9l0.7,0l0-1.1l1.8-0.1L345.9,157.7z	"
          >
            <title id="t1484">Lincoln, MO</title>
          </path>
          <path
            id="FIPS_29183"
            className="FIPS_41180 st0 state-il state-mo"
            d="M348.7,160.9l1.8,0.4l0.3,0.1l0.3,0.1l0.2,0.1l1,0.6l0,0.1l0,0.1l0,0.3l0,0.1l-0.1-0.2
		l-0.2-0.1l-0.2,0l-0.2,0.2l-0.2-0.1l-0.6-0.4l-0.1-0.1l-0.7,0.1l0,0.2l-0.1,0.2l-0.1,0.1l-0.1,0.1l-0.1,0l-0.4-0.1H349l-0.1,0
		l-0.1,0.1l-0.2,0.4l-0.5,1.1l0,0.1l-0.1,0.1l-0.2,0.1l-0.1,0l-0.9-0.1l-0.1,0l-0.1,0.1l-0.3,0.5l-0.2,0.1l-2.3,1.3l-0.2-4.2l2.9-1
		L348.7,160.9z	"
          >
            <title id="t1498">St. Charles, MO</title>
          </path>
          <path
            id="FIPS_29189"
            className="FIPS_41180 st0 state-il state-mo"
            d="M352.2,162.8l-0.7,0.9l-0.5,0l-0.4,0.3l-0.2,0.5l0.2,1l0.1,0.7l0.4,0.2l0,0.2l-0.7,1.8
		l-0.1-0.3l-0.6-1.2l-1.9,0.1l-1.3,0.3l-0.1,0.2l-0.1-2.2l0.2-0.1l0.3-0.5l0.1-0.1l0.1,0l0.9,0.1l0.1,0l0.2-0.1l0.1-0.1l0-0.1
		l0.5-1.1l0.2-0.4l0.1-0.1l0.1,0h0.1l0.4,0.1l0.1,0l0.1-0.1l0.1-0.1l0.1-0.2l0-0.2l0.7-0.1l0.1,0.1l0.6,0.4l0.2,0.1l0.2-0.2l0.2,0
		l0.2,0.1L352.2,162.8z	"
          >
            <title id="t1499">St. Louis Co., MO</title>
          </path>
          <path
            id="FIPS_29219"
            className="FIPS_41180 st0 state-il state-mo"
            d="M340.6,161l0.8,0l0.6,0.7l0.7,0.7l1,0l0.2,4.2l-2.7-1.1l-0.1-0.1l-0.8-0.7l-0.1,0l-0.4,0.1
		l-0.5-0.1l-0.1-1.8l1.5-0.1L340.6,161z	"
          >
            <title id="t1485">Warren, MO</title>
          </path>
          <path
            id="FIPS_29221"
            className="FIPS_41180 st0 state-il state-mo"
            d="M346,171l1.5,1.6l0.2,4.4l-4.6,0.2l-0.3-6L346,171z	"
          >
            <title id="t1495">Washington, MO</title>
          </path>

          <path
            id="FIPS_29510"
            className="FIPS_41180 st0 state-il state-mo"
            d="M351.4,163.7l0.2,1l-0.7,1.7l-0.4-0.2l-0.1-0.7l-0.2-1l0.2-0.5l0.4-0.3L351.4,163.7z	"
          >
            <title id="t1497">St. Louis, MO</title>
          </path>
        </g>
        <path
          id="FIPS_17121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362,163.1l-0.1-1.1l1.4-0.1l3-0.3l0.2,2.9l0.1,1.7l-4.4,0.3l0-0.4L362,163.1z	"
        >
          <title id="t716">Marion, IL</title>
        </path>
        <path
          id="FIPS_17191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.9,164.2l1.1,0.3l0.3,4.1l-2.2,0.2l-3.3,0.2l-0.2-2.8l-0.1-1.7L370.9,164.2z	"
        >
          <title id="t717">Wayne, IL</title>
        </path>
        <path
          id="FIPS_17185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374.4,164.2l2.6-0.2l-0.7,2.1l-1.9,2.6l0,0.1l-0.4-0.4l0-4.1L374.4,164.2z	"
        >
          <title id="t718">Wabash, IL</title>
        </path>
        <path
          id="FIPS_17047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.9,164.3l0,4.1l-1.6,0.2l-0.3-4.1L373.9,164.3z	"
        >
          <title id="t719">Edwards, IL</title>
        </path>
        <path
          id="FIPS_17101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M377.8,160.3L377.8,160.3L377.8,160.3l0.4,0.9l0,0.3l-0.1,0.8l-0.1,0.2l-0.1,0.1l-0.8,1
		l-0.2,0.5l-2.6,0.2l-0.3-3.6L377.8,160.3z	"
        >
          <title id="t720">Lawrence, IL</title>
        </path>
        <path
          id="FIPS_17159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374.1,160.6l0.3,3.6l-0.4,0l-1.9,0.2l-1.1-0.3l-0.4-1.1l0-0.2l0-0.4l0.3,0l-0.1-1.5l3.1-0.3
		L374.1,160.6z	"
        >
          <title id="t721">Richland, IL</title>
        </path>
        <path
          id="FIPS_17025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.2,160.4l3.3-0.2l0.1,0.8l1-0.1l0.1,1.5l-0.3,0l0,0.4l0,0.2l0.4,1.1l-4.4,0.3l-0.2-2.9
		L366.2,160.4z	"
        >
          <title id="t722">Clay, IL</title>
        </path>
        <path
          id="FIPS_17079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.8,156.5l0.6-0.1l0.4,4.2l-4.1,0.4l-0.3-4.2L372.8,156.5z	"
        >
          <title id="t723">Jasper, IL</title>
        </path>
        <path
          id="FIPS_17033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.3,156.5l3.2,0l0.2,0.7l0.5,0.6l0.7,1.3l0,0.4l-0.1,0.2l-0.1,0.1l0.1,0.6l-3.7,0.4l-0.4,0
		L373.3,156.5z	"
        >
          <title id="t724">Crawford, IL</title>
        </path>
        <path
          id="FIPS_17023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.9,152.5l2.7-0.3l0,0.1l1.5-0.1l-0.5,2.9l-0.1,1.3l-3.2,0l-0.6,0.1l-0.3-2.6L372.9,152.5z
			"
        >
          <title id="t725">Clark, IL</title>
        </path>
        <path
          id="FIPS_17035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.5,153.9l0.3,2.6l-4.6,0.4l-0.2-2.6L372.5,153.9z	"
        >
          <title id="t726">Cumberland, IL</title>
        </path>
        <path
          id="FIPS_17049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M368.1,156.4l0,0.6l1.1-0.1l0.3,3.4l-3.3,0.2l-1.1,0.1l-0.3-3.9	"
        >
          <title id="t727">Effingham, IL</title>
        </path>
        <path
          id="FIPS_17051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364.8,156.6l0.3,3.9l1.1-0.1l0.1,1.1l-3,0.3l-1.4,0.1l0.1,1.1l-1.2,0l-0.2-3.7l0.9-2.5
		L364.8,156.6z	"
        >
          <title id="t728">Fayette, IL</title>
        </path>
        <path
          id="FIPS_17173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.2,151.1l2.1-0.1l0.1,0.9l2.3,1.3l0.5,0.2l0.7,0l0.1,0.9l0.2,2.1l-3.3,0.2l-3.3,0.2
		l-0.1-1.7l1.1,0l-0.2-2.3L362.2,151.1z	"
        >
          <title id="t729">Shelby, IL</title>
        </path>
        <path
          id="FIPS_17135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.7,153.2l1.7-0.1l0.2,2.3l2.8-0.2l1.1-0.1l0.1,1.7l-0.9,2.5l-3.8,0.6l-0.6,0L355.7,153.2z
			"
        >
          <title id="t730">Montgomery, IL</title>
        </path>

        <path
          id="FIPS_17061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.2,153.6l0.3,3.3l-0.5,0l-1.2,0.6l0,0.7l-1.7,0.1l-0.2-0.1l0,0l-0.1-0.1l-0.3,0l-0.4,0.1
		l-0.2,0.9l-0.3-3.6l0.2-1.7l2.8-0.1L351.2,153.6z	"
        >
          <title id="t734">Greene, IL</title>
        </path>
        <path
          id="FIPS_17021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M360.2,149.2l0.8,0.1l0.2,1.9l1.1-0.1l0.1,1.7l0.2,2.3l-1.1,0l-1.1,0.1l-2.8,0.2l-0.2-2.3
		l-0.1-1.5l1.3-1.4l1.3-1L360.2,149.2z	"
        >
          <title id="t735">Christian, IL</title>
        </path>
        <path
          id="FIPS_17029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.7,150.7l4-0.3l0-0.4l0.4-0.1l0.6-0.1l0.3,2.6l-0.4,1.4l-4.5,0.4l-0.1-0.9L367.7,150.7z	"
        >
          <title id="t736">Coles, IL</title>
        </path>
        <path
          id="FIPS_17045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.7,147.3l4-0.4l0.3,3.6l0.2,1.7l-1.5,0.1l0-0.1l-2.7,0.3l-0.3-2.6l-0.1-0.9l0.2-0.5
		L372.7,147.3z	"
        >
          <title id="t737">Edgar, IL</title>
        </path>
        <path
          id="FIPS_17041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.5,147.8l5.1-0.4l0.1,1.1l-0.2,0.5l0.1,0.9l-0.6,0.1l-0.4,0.1l0,0.4l-4,0.3l-0.2-1.8
		L367.5,147.8z	"
        >
          <title id="t738">Douglas, IL</title>
        </path>
        <path
          id="FIPS_17139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.5,148.9l0.2,1.8l0.2,2.6l-0.7,0l-0.5-0.2l-2.3-1.3l-0.1-0.9l0.5-1.8L367.5,148.9z	"
        >
          <title id="t739">Moultrie, IL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19500"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[19500]} state-il`
          }
          id="FIPS_19500"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17115"
            className="FIPS_19500 st0 state-il"
            d="M364.6,145.7l0.3,3.4l-0.5,1.8l-2.1,0.1l-1.1,0.1l-0.2-1.9l-0.8-0.1l-0.1-1.3l0.6-1.8l1.1-0.1
		l2.2-0.2L364.6,145.7z	"
          >
            <title id="t740">Macon, IL</title>
          </path>
        </g>

        <path
          id="FIPS_17137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.7,149.2l5.8-0.3l0.1,1.1l0.1,0.9l0.7,1.8l0.1,0.3l0,0.4l-2.2,0.2l-1.5,0.1l-0.1-1.5
		l-0.8-1.5l-1.1-0.4l-1.1,0.1l0.2-0.7L346.7,149.2z	"
        >
          <title id="t742">Morgan, IL</title>
        </path>
        <path
          id="FIPS_17171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349.8,153.7l-2.8,0.1l0.1-0.2l0,0l-0.1-0.3l-0.3-1l-0.2-1.4l0.2-0.6l1.1-0.1l1.1,0.4l0.8,1.5
		L349.8,153.7z	"
        >
          <title id="t743">Scott, IL</title>
        </path>
        <path
          id="FIPS_17149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.9,149.7l-0.2,0.7l-0.2,0.6l0.2,1.4l0.3,1l0.1,0.3l0,0l-0.1,0.2l-0.2,1.7l-3.3,0.1
		l-2.4-2.5l-1.4-1.1l-0.6-0.9l1.6-0.1l2.8-0.1l-0.1-1.1L346.9,149.7z	"
        >
          <title id="t744">Pike, IL</title>
        </path>
        <path
          id="FIPS_17009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.3,146.4l1.1-0.1l1,0l0.7,1l0.2,0.4l0.9,0l-0.6,1.5l0.1,0.5l-3.4,0.1L343.3,146.4z	"
        >
          <title id="t745">Brown, IL</title>
        </path>
        <path
          id="FIPS_17001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.3,145.3l0,1.1l0.2,3.4l0.1,1.1l-2.8,0.1l-1.6,0.1l-1-2.4l-0.7-3.3L343.3,145.3z	"
        >
          <title id="t746">Adams, IL</title>
        </path>
        <path
          id="FIPS_17067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.3,139.6l2.7-0.2l0.2,4.6l0,1.2l-5.9,0.2l0.1-0.6l0.7-1.7l0.3-0.1l0,0l0.1-0.1l0-0.1l0,0
		l0-1.2l0-0.1l-0.1-0.2l-0.2-0.2l-0.2-0.1l0-0.1l0-0.1l0.4-0.6l0,0l0,0l0,0l0.1-0.1l0.2-0.1l0.1,0l0,0l0.5-0.2h0l0.1,0l0.3,0
		L340.3,139.6z	"
        >
          <title id="t747">Hancock, IL</title>
        </path>
        <path
          id="FIPS_17109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.2,139.5l3.3-0.1l0.2,4.6l-4.5,0.1l-0.2-4.6L344.2,139.5z	"
        >
          <title id="t748">McDonough, IL</title>
        </path>
        <path
          id="FIPS_17169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.2,144.1l4.5-0.1l2.5,1.1l-1.5,0.9l-1.4,1.9l-0.9,0l-0.2-0.4l-0.7-1l-1,0l-1.1,0.1
		L343.2,144.1z	"
        >
          <title id="t749">Schuyler, IL</title>
        </path>
        <path
          id="FIPS_17017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M348.8,145.9l0.7,0.9l0.9,0l0,0l1-0.4l0.9-0.4l0-0.1l0.2,2.7l0,0.4l-5.8,0.3l0.6-1.5
		L348.8,145.9z	"
        >
          <title id="t750">Cass, IL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "44100"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[44100]} state-il`
          }
          id="FIPS_44100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17129"
            className="FIPS_44100 st0 state-il"
            d="M352.3,145.9l0.4-0.3l2.7-0.5l0.4,0.1l0.3,0.4l0.4,1.9l-1.2,0.1l0,0.5l0,0.3l-0.6,0.3
		l-2.2,0.1L352.3,145.9z	"
          >
            <title id="t751">Menard, IL</title>
          </path>
          <path
            id="FIPS_17167"
            className="FIPS_44100 st0 state-il"
            d="M356.5,147.3l0.9-0.1l0,0.6l0.8,0.1l1.8-0.1l0.1,1.3h-0.4l-1.3,1l-1.3,1.4l0.1,1.5l-1.7,0.1
		l-2.2,0.2l0-0.4l-0.1-0.3l-0.7-1.8l-0.1-0.9l-0.1-1.1l0-0.4l2.2-0.1l0.6-0.3l0-0.3l0-0.5L356.5,147.3z	"
          >
            <title id="t741">Sangamon, IL</title>
          </path>
        </g>
        <path
          id="FIPS_17125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.7,141.6l2-0.1l0.1,1.5l1.1-0.1l0.2,2.6l-0.3-0.4l-0.4-0.1l-2.7,0.5l-0.4,0.3l0,0.1
		l-0.9,0.4l-1,0.4l0,0l-0.9,0l-0.7-0.9l1.5-0.9l0.7-0.6l0.1-0.1l0.5-0.9l0.1-0.7l0.1-0.2l0.1-0.1l0.9-0.8L352.7,141.6z	"
        >
          <title id="t752">Mason, IL</title>
        </path>
        <path
          id="FIPS_17107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.3,142.6l1.2,0.5l0.3,3l-0.6,1.8l-1.8,0.1l-0.8-0.1l0-0.6l-0.9,0.1l-0.4-1.9l-0.2-2.6
		L359.3,142.6z	"
        >
          <title id="t753">Logan, IL</title>
        </path>
        <path
          id="FIPS_17039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366,142.6l-1.4,3.1l-0.6,0l-2.2,0.2l-1.1,0.1l-0.3-3L366,142.6z	"
        >
          <title id="t754">De Witt, IL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16580"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[16580]} state-il`
          }
          id="FIPS_16580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17147"
            className="FIPS_16580 st0 state-il"
            d="M366,142.6l1.1-0.1l0.4,5.2l0,1.1l-2.7,0.2l-0.3-3.4L366,142.6z	"
          >
            <title id="t755">Piatt, IL</title>
          </path>
          <path
            id="FIPS_17019"
            className="FIPS_16580 st0 state-il"
            d="M367,141l5.1-0.4l0.2,2.2l-0.1,0l0.4,4.5l-5.1,0.4l-0.4-5.2L367,141z	"
          >
            <title id="t756">Champaign, IL</title>
          </path>
          <path
            id="FIPS_17053"
            className="FIPS_16580 st0 state-il"
            d="M368.5,133.1l1.1-0.1l0.7,6.6l1.8-0.1l0.1,1.1L367,141l-0.2-2.8l2.2-0.2L368.5,133.1z	"
          >
            <title id="t757">Ford, IL</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14010"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[14010]} state-il`
          }
          id="FIPS_14010"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17113"
            className="FIPS_14010 st0 state-il"
            d="M362.1,136.8l3.3-0.3l0.1,1.1l0.1,0.7l1.1-0.1l0.2,2.8l0.1,1.5l-1.1,0.1l-5.6,0.4l-1.2-0.5
		l-0.3-3.5l1.3-0.1l0.8-0.5l0.5-0.5L362.1,136.8z	"
          >
            <title id="t758">McLean, IL</title>
          </path>
        </g>

        <path
          id="FIPS_17057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.9,138l0,1.1l1.1-0.1l0.1,0.6l0,0.9l-0.4,1l-0.1,0.1l-0.9,0.8l-0.1,0.1l-0.1,0.2l-0.1,0.7
		l-0.5,0.9l-0.1,0.1l-0.7,0.6l-2.5-1.1l-0.2-4.6l-0.1-1.1L351.9,138z	"
        >
          <title id="t762">Fulton, IL</title>
        </path>
        <path
          id="FIPS_17187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.9,133.9l3.3-0.1l0.3,5.7l-3.3,0.1L343.9,133.9z	"
        >
          <title id="t763">Warren, IL</title>
        </path>
        <path
          id="FIPS_17071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.3,133.9l1.6-0.1l0.3,5.6l-1.1,0l-2.7,0.2l0.7-0.8l0.1-1.5l0-0.2l0.8-1.1l0.1-0.1l0.3-0.2
		l0.1-0.1l0.1-0.4l0-1.1l0-0.3L342.3,133.9z	"
        >
          <title id="t764">Henderson, IL</title>
        </path>

        <path
          id="FIPS_17095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.5,132.3l0.1,2.3l0.2,3.4l-4.4,0.2l-0.2-4.5l0-1.1L351.5,132.3z	"
        >
          <title id="t766">Knox, IL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "37900"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[37900]} state-il`
          }
          id="FIPS_37900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17123"
            className="FIPS_37900 st0 state-il"
            d="M354.9,132.1l1.7-0.1l1.3-0.1l0,0.3l0,0.1l-0.1,0.1l-0.1,0.1l-0.1,0.1l1.9-0.1l1.3,2.2
		l-4.1,0.4l-1.7-0.6L354.9,132.1z	"
          >
            <title id="t768">Marshall, IL</title>
          </path>
          <path
            id="FIPS_17143"
            className="FIPS_37900 st0 state-il"
            d="M355,134.4l1.7,0.6l-0.6,2.3l0.1,0.1l0.1,0.2l-0.1,0.2l-0.9,1.4l-2,1.3l0-0.9l-0.1-0.6
		l-1.1,0.1l0-1.1l-0.2-3.4L355,134.4z	"
          >
            <title id="t761">Peoria, IL</title>
          </path>
          <path
            id="FIPS_17175"
            className="FIPS_37900 st0 state-il"
            d="M352.7,131.2l2.2,1l0.2,2.3l-3.4,0.2l-0.1-2.3L352.7,131.2z	"
          >
            <title id="t767">Stark, IL</title>
          </path>
          <path
            id="FIPS_17179"
            className="FIPS_37900 st0 state-il"
            d="M356,137.3l2.2-0.2l0.1,0.8l0.1,1l0.6,0.2l0.3,3.5l-3.3,0.3l-1.1,0.1l-0.1-1.5l-2,0.1l0.4-1
		l2-1.3l0.9-1.4l0.1-0.2l-0.1-0.2L356,137.3z	"
          >
            <title id="t759">Tazewell, IL</title>
          </path>
          <path
            id="FIPS_17203"
            className="FIPS_37900 st0 state-il"
            d="M360.8,134.6l1.1-0.1l0.2,2.3l-0.5,1.2l-0.5,0.5l-0.8,0.5l-1.3,0.1l-0.6-0.2l-0.1-1l-0.1-0.8
		l-2.2,0.2l0.6-2.3L360.8,134.6z	"
          >
            <title id="t760">Woodford, IL</title>
          </path>
        </g>
        <path
          id="FIPS_17155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.3,129.7l0.2,2.7l-1.9,0.1l0.1-0.1l0.1-0.1l0.1-0.1l0-0.1l0-0.3l-1.3,0.1l-0.1-1.1l1.3-1
		l0.5-0.3l0.1,0L359.3,129.7z	"
        >
          <title id="t769">Putnam, IL</title>
        </path>
        <path
          id="FIPS_17105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.1,131.9l3.2-0.3l0.2,1.5l0.5,4.9l-2.2,0.2l-1.1,0.1l-0.1-0.7l-0.1-1.1l-3.3,0.3l-0.2-2.3
		l-0.2-2.3L365.1,131.9z	"
        >
          <title id="t770">Livingston, IL</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "28100"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[28100]} state-il`
          }
          id="FIPS_28100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17091"
            className="FIPS_28100 st0 state-il"
            d="M375.2,130.3l0.2,2l-5.8,0.7l-1.1,0.1l-0.2-1.5l0-1.1l1.7-0.2l0.5-0.7l0-0.4l4.7-0.5
		L375.2,130.3z	"
          >
            <title id="t771">Kankakee, IL</title>
          </path>
        </g>
        <path
          id="FIPS_17099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.2,125.4l3.2-0.3l0.2,2.3l0.4,4.5l-3.3,0.3l0.2,2.3l-1.1,0.1l-1.3-2.2l-0.2-2.7l-0.3-4.1
		l1.1-0.1L361.2,125.4z	"
        >
          <title id="t775">LaSalle, IL</title>
        </path>
        <path
          id="FIPS_17011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359,126.2l0.3,3.6l-0.9-0.1l-0.1,0l-0.5,0.3l-1.3,1l0.1,1.1l-1.7,0.1l-2.2-1l-0.3-4.5
		l2.2-0.2L359,126.2z	"
        >
          <title id="t776">Bureau, IL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19340"
              ? `metroArea clickedArea state-il state-ia`
              : `metroArea ${colorCode[19340]} state-il state-ia`
          }
          id="FIPS_19340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17073"
            className="FIPS_19340 st0 state-il state-ia"
            d="M352.4,126.6l0.3,4.5l-1.2,1.2l-4.4,0.2l-0.1-2.3l-0.1-1.7l0.6-0.6l0.1-0.1l0.2-0.1l0.5-0.1
		l0.4-0.1l0.5-0.3l0.1-0.2l0-0.2l0-0.1l-0.1-0.1L352.4,126.6z	"
          >
            <title id="t777">Henry, IL</title>
          </path>
          <path
            id="FIPS_17131"
            className="FIPS_19340 st0 state-il state-ia"
            d="M340.9,130.6l6.2-0.3l0.1,3.4l-3.3,0.1l-1.6,0.1l0,0l0-0.3l-0.5-0.7l-0.1-0.1l-0.1,0l-0.1,0
		l-0.3-0.2l-0.7-0.8l0,0l0-0.1L340.9,130.6z	"
          >
            <title id="t765">Mercer, IL</title>
          </path>
          <path
            id="FIPS_17161"
            className="FIPS_19340 st0 state-il state-ia"
            d="M348.6,124.3l0,0.2l0,0.2l0.1,0.5l0.1,0.3l0.2,0.2l0.2,0.1l0.2,0.1l0.1,0.1l0,0.2l0,0.2l0,0.3
		l0,0l-0.2,0.1l0.1,0.1l0,0.1l0,0.2l-0.1,0.2l-0.5,0.3l-0.4,0.1l-0.5,0.1l-0.2,0.1l-0.1,0.1l-0.6,0.6l0.1,1.7l-6.2,0.3v0l0.1-0.4
		l0.1-0.6l0,0l0.1-0.1v0l0,0l0.1-0.1l0.4-0.1l1.4-0.4l0.6,0l0.1,0l0.3,0l0.8-0.2l1.8-0.9l0.6-0.7l0.5-0.7l0.1-1.4L348.6,124.3z	"
          >
            <title id="t778">Rock Island, IL</title>
          </path>
          <path
            id="FIPS_19163"
            className="FIPS_19340 st0 state-il state-ia"
            d="M342.3,124.8l1.1-0.1l3.2-0.1l1.3,0.4l-0.1,1.4l-0.5,0.7l-0.6,0.7l-1.8,0.9l-0.8,0.2l-0.3,0
		l-0.1,0l-1.2-1.8L342.3,124.8z	"
          >
            <title id="t548">Scott, IA</title>
          </path>
        </g>

        <path
          id="FIPS_17103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.3,122.4l0.6,0l1.9-0.1l0,0.2l4-0.3l0.3,3.4l-1.1,0.1l-1.1,0.1l0,0.6l-4.5,0.3
		L354.3,122.4z	"
        >
          <title id="t779">Lee, IL</title>
        </path>
        <path
          id="FIPS_17195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.8,122l0.6,0.3l0.3,4.1l-2.2,0.2l-3.1,0.2l0.2-0.1l0,0l0-0.3l0-0.2l0-0.2l-0.1-0.1
		l-0.2-0.1l-0.2-0.1l-0.2-0.2l-0.1-0.3l-0.1-0.5l0-0.2l0-0.2l0.7-1.9L353.8,122z	"
        >
          <title id="t780">Whiteside, IL</title>
        </path>
        <path
          id="FIPS_17015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.5,118.6l0.2,3.5l-4.4,0.3l-0.1-1.3l-1.7-2l3.8-0.3L353.5,118.6z	"
        >
          <title id="t781">Carroll, IL</title>
        </path>
        <path
          id="FIPS_17141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.3,118.3l2.1-0.2l0,0.7l2.2-0.2l0.2,3.4l-4,0.3l0-0.2l-1.9,0.1l-0.6,0l-0.6-0.3l-0.2-3.5
		L356.3,118.3z	"
        >
          <title id="t782">Ogle, IL</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16980"
              ? `metroArea clickedArea state-il state-in state-wi`
              : `metroArea ${colorCode[16980]} state-il state-in state-wi`
          }
          id="FIPS_16980"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17031"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.7,118.1l4.2-0.3l1,1.3l0.5,1.5l0.1,0.4l0.1,0.4l0.1,0.3l0,0.1l0.1,0.1l0.3,0.5l0.6,1
		l0.3,3.1l-2.5,0.2l-2.5-2l-0.1-0.6l1.1-0.5l-0.3-3.1l-0.1-0.5l-1,0.1l-2.2,0.3l0.1-2.2L367.7,118.1z	"
          >
            <title id="t786">Cook, IL</title>
          </path>
          <path
            id="FIPS_17037"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M364,118.4l0.3,5.6l0.1,1.1l-3.2,0.3l-0.3-3.4l-0.2-3.4l2.2-0.2L364,118.4z	"
          >
            <title id="t783">DeKalb, IL</title>
          </path>
          <path
            id="FIPS_17043"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.5,123.7l-0.3-3.4l2.2-0.3l1-0.1l0.1,0.5l0.3,3.1l-1.1,0.5L367.5,123.7L367.5,123.7z	"
          >
            <title id="t785">DuPage, IL</title>
          </path>
          <path
            id="FIPS_17063"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.9,127.1l0.4,3.4l0,1.1l-3.2,0.3l-0.4-4.5L367.9,127.1z	"
          >
            <title id="t772">Grundy, IL</title>
          </path>
          <path
            id="FIPS_17089"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.3,118.1l-0.1,2.2l0.3,3.4l-3.2,0.3l-0.3-5.6L367.3,118.1z	"
          >
            <title id="t784">Kane, IL</title>
          </path>

          <path
            id="FIPS_17093"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.5,123.7L367.5,123.7l0.4,3.4l-3.3,0.3l-0.2-2.3l-0.1-1.1L367.5,123.7z	"
          >
            <title id="t774">Kendall, IL</title>
          </path>

          <path
            id="FIPS_17097"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.3,113.7l3.8-0.3h0l0,0.3l0,1.1l-0.1,0.3l0,0l-0.1,0.4v0.4l0.1,0.4l0.2,0.5l0.1,0.3
		l0.4,0.7l-4.2,0.3L367.3,113.7z	"
          >
            <title id="t787">Lake, IL</title>
          </path>
          <path
            id="FIPS_17111"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M366.3,113.8l1-0.1l0.4,4.4l-0.4,0l-3.3,0.3l-1.1,0.1l-0.4-4.4L366.3,113.8z	"
          >
            <title id="t788">McHenry, IL</title>
          </path>
          <path
            id="FIPS_17197"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M367.5,123.7l2.3,0.3l0.1,0.6l2.5,2l2.5-0.2l0.2,2.2l-4.7,0.5l0,0.4l-0.5,0.7l-1.7,0.2
		l-0.4-3.4L367.5,123.7z	"
          >
            <title id="t773">Will, IL</title>
          </path>
          <path
            id="FIPS_18073"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M380.9,128.9l0.1,0.8l0.3,3.4l-1.4,2.4l-1.6,0.2l-0.2-2.3l-0.1,0l0-0.1l-0.4-3.9l0.5-0.4
		l0.2-0.3l0.5-0.3l0.1,0l0.2,0l0.5,0.2l0.7,0.5l0.1,0l0.3-0.2L380.9,128.9z	"
          >
            <title id="t878">Jasper, IN</title>
          </path>
          <path
            id="FIPS_18089"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M374.6,123.3l3,0.8l0.5,4.9l-0.5,0.4l-2.3,0.9l-0.2-1.7L374.6,123.3z	"
          >
            <title id="t794">Lake, IN</title>
          </path>
          <path
            id="FIPS_18111"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M375.2,130.3l2.3-0.9l0.4,3.9l0,0.1l0.1,0l0.2,2.3l-2.5,0.2l-0.3-3.5L375.2,130.3z	"
          >
            <title id="t879">Newton, IN</title>
          </path>
          <path
            id="FIPS_18127"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M380.2,122.7l0.6,6.1l-0.1,0.1l-0.3,0.2l-0.1,0l-0.7-0.5l-0.5-0.2l-0.2,0l-0.1,0l-0.5,0.3
		l-0.2,0.3l-0.5-4.9L380.2,122.7z	"
          >
            <title id="t793">Porter, IN</title>
          </path>
          <path
            id="FIPS_55059"
            className="FIPS_16980 st0 state-il state-in state-wi"
            d="M366.2,112.3l1.1-0.1l-0.1-0.8l1.7-0.1l1.9-0.1l0.2,2.3l-3.8,0.3l-1,0.1L366.2,112.3z	"
          >
            <title id="t3040">Kenosha, WI</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19460"
              ? `metroArea clickedArea state-il`
              : `metroArea ${colorCode[19460]} state-il`
          }
          id="FIPS_40420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_17007"
            className="FIPS_40420 st0 state-il"
            d="M361.9,114.1l0.7,0l0.4,4.4l-2.2,0.2l-0.3-4.4L361.9,114.1z	"
          >
            <title id="t789">Boone, IL</title>
          </path>
          <path
            id="FIPS_17201"
            className="FIPS_40420 st0 state-il"
            d="M360.3,114.2l0.3,4.4l-2.2,0.2l0-0.7l-2.1,0.2l-0.3-3.9l0.3,0L360.3,114.2z	"
          >
            <title id="t790">Winnebago, IL</title>
          </path>
        </g>
        <path
          id="FIPS_17177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.8,114.7l4.1-0.2l0.3,3.9l-2.8,0.2l-2.2,0.2l-0.3-4L351.8,114.7z	"
        >
          <title id="t791">Stephenson, IL</title>
        </path>
        <path
          id="FIPS_17085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351,114.7l0.3,4l-3.8,0.3l-0.4-0.1l-0.2-0.1l-0.2-0.1l0,0l-0.3-0.3l0,0l-0.1-0.3v-0.1
		l0.1-0.1l0.1-0.4l0,0l0,0l-0.6-0.7l0,0l0,0l-0.8-0.6l-0.6-0.3l-0.2-0.2l-0.1-0.1l0-0.1l0-0.1l0,0l0.1-0.2l2-0.1L351,114.7z	"
        >
          <title id="t792">Jo Daviess, IL</title>
        </path>

        <path
          id="FIPS_18123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387,167.1l1.1-0.2l1.2,0.7l0.2,1.4l-0.2,0.7l-0.1,0l-0.2,0l-0.1,0l0,0.1l0,0.1l0.1,0.8
		l-0.7,1.5l-0.3,0.2l-0.1,0l-0.1,0l-1.8-1.9l0-2.7l-0.1-0.6l1.1-0.1L387,167.1z	"
        >
          <title id="t795">Perry, IN</title>
        </path>
        <path
          id="FIPS_18147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386,168l0,2.7l-1.6,1l-0.6,0.6l-0.8,1.4l-1.5-1l0-0.6l0,0l1.7-2.6l0.5-1.2L386,168z	"
        >
          <title id="t796">Spencer, IN</title>
        </path>
        <path
          id="FIPS_18173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.7,167.9l2.5-0.1l0.6,0.3l-0.5,1.2l-1.7,2.6l0,0l0,0.6l-0.4-0.3l-1.5-0.4l-0.1-1.2l-0.2,0
		l-0.1-1.1l0-0.6l0-0.5l1.5-0.1L380.7,167.9z	"
        >
          <title id="t797">Warrick, IN</title>
        </path>
        <path
          id="FIPS_18163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M377,169.3l2.2-0.2l0,0.6l0.1,1.1l0.2,0l0.1,1.2l-2.5,0.7L377,169.3z	"
        >
          <title id="t798">Vanderburgh, IN</title>
        </path>
        <path
          id="FIPS_18129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374.3,168.7l2.7,0.6l0.2,3.5l-2.3,0.2l-0.9,1.4l-0.5-1.1l0.5,0l0,0l0,0l0,0l0-0.1l0.1-3
		L374.3,168.7L374.3,168.7z	"
        >
          <title id="t799">Posey, IN</title>
        </path>
        <path
          id="FIPS_18051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.2,166.1l2.6-1.8l0.1,0.9l0.2,0.4l0.6,0.7l0.1-0.1l0.5-0.1l0.1,0l0.2,2.3l-1.5,0.1l0,0.5
		l-2.2,0.2l-2.7-0.6L376.2,166.1z	"
        >
          <title id="t800">Gibson, IN</title>
        </path>
        <path
          id="FIPS_18125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M381.1,164l1.7,0.2l0.3,3.7l-2.5,0.1l-0.2-1.7l-0.1,0l-0.5,0.1l-0.1,0.1l-0.6-0.7l-0.2-0.4
		l-0.1-0.9l0.4-0.1l0.7-0.1l0.1,0l0.5,0.4l0.1,0l0.2-0.2l0.1-0.1L381.1,164z	"
        >
          <title id="t801">Pike, IN</title>
        </path>
        <path
          id="FIPS_18037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.7,163.7l0.2,1.7l0.2,1.7l0,0.2l-1.1,0.1l0.1,0.6l-2.3,0.2l-0.6-0.3l-0.3-3.7l1.5,0
		L386.7,163.7z	"
        >
          <title id="t802">Dubois, IN</title>
        </path>
        <path
          id="FIPS_18025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.5,164.7l0.5-0.1l0.2,3.8l-2,1.3l0.2-0.7l-0.2-1.4l-1.2-0.7l-1.1,0.2l-0.2-1.7l2.3-0.3
		l1.4-0.1L390.5,164.7z	"
        >
          <title id="t803">Crawford, IN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "31140"
              ? `metroArea clickedArea state-ky state-in`
              : `metroArea ${colorCode[31140]} state-ky state-in`
          }
          id="FIPS_31140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_18019"
            className="FIPS_31140 st0 state-ky state-in"
            d="M397.6,161.5l1.5,0.1l0,0.8l-1.8,2.1l-1.4,1.4l0.2-0.8l-0.5-0.6l-1.6,0.2l-0.3-0.1l0-0.1
		l-0.1-0.9l0.4-0.2l0.6-0.1l0.2-0.2l0.1-0.4l0-0.2L397.6,161.5z	"
          >
            <title id="t806">Clark, IN</title>
          </path>
          <path
            id="FIPS_18043"
            className="FIPS_31140 st0 state-ky state-in"
            d="M393.7,164.4L393.7,164.4l0.3,0.2l1.6-0.2l0.5,0.6l-0.2,0.8l-0.9,1.5l0-0.1l-0.6-0.9l-0.2-0.2
		l-0.4-0.3h0l-0.2-0.4l-0.1-1.1L393.7,164.4z	"
          >
            <title id="t805">Floyd, IN</title>
          </path>
          <path
            id="FIPS_18061"
            className="FIPS_31140 st0 state-ky state-in"
            d="M393.3,164.4l0.1,1.1l0.2,0.4h0l0.4,0.3l0.2,0.2l0.6,0.9l0,0.1l-0.2,2.3l-0.5,0.2l-0.3,0.1
		l-1.5-0.1l-0.1,0l-0.4-0.2l-0.5-0.3l0,0l0,0l-0.1-0.1l-0.1-0.3l0,0l0-0.1l0-0.1v0l0-0.4l-0.2-3.8L393.3,164.4z	"
          >
            <title id="t804">Harrison, IN</title>
          </path>
          <path
            id="FIPS_18175"
            className="FIPS_31140 st0 state-ky state-in"
            d="M390.4,160.2l3.9,0l0.6,2.2l0,0.2l-0.1,0.4l-0.2,0.2l-0.6,0.1l-0.4,0.2l0.1,0.9l-0.4,0
		l-2.2,0.2l-0.5,0.1l-0.4-3.4L390.4,160.2z	"
          >
            <title id="t811">Washington, IN</title>
          </path>
          <path
            id="FIPS_21029"
            className="FIPS_31140 st0 state-ky state-in"
            d="M399.8,167.7l-0.4,1.7l-0.8,1.4l0.1,0.1l0,0l-0.6,0.7l-0.3,0.2l-0.4,0.2l-0.2,0l-2.3-2.2
		l0.3-0.4l0.3-0.2l1.5-0.7h1.6L399.8,167.7z	"
          >
            <title id="t1070">Bullitt, KY</title>
          </path>
          <path
            id="FIPS_21211"
            className="FIPS_31140 st0 state-ky state-in"
            d="M400.9,164.4l2.9,0l0,2.7l-0.6,1.3l-3.4-1.1l-0.6-1.7l0.1-0.1l0.1-0.1l0.2-0.1l0.4-0.1l0.4,0
		l0.3-0.1L400.9,164.4z	"
          >
            <title id="t1057">Shelby, KY</title>
          </path>
          <path
            id="FIPS_21103"
            className="FIPS_31140 st0 state-ky state-in"
            d="M401.7,161.3l0.9-0.3l2.4,2.9l-1.2,0.4l-2.9,0l-0.5-1.7L401.7,161.3z	"
          >
            <title id="t1058">Henry, KY</title>
          </path>
          <path
            id="FIPS_21111"
            className="FIPS_31140 st0 state-ky state-in"
            d="M397.3,164.5l1.8,1l0.6,1.7l0,0.4l-1.2,0.7H397l-1.5,0.7l-0.3,0.2l-0.3,0.4l-0.1-0.1l0.2-2.3
		l0.9-1.5L397.3,164.5z	"
          >
            <title id="t1069">Jefferson, KY</title>
          </path>
          <path
            id="FIPS_21163"
            className="FIPS_31140 st0 state-ky state-in"
            d="M389.3,169.7l2-1.3l0,0.4v0l0,0.1l0,0.1l0,0l0.1,0.3l0.1,0.1l0,0l0,0l0.5,0.3l0.4,0.2l0.1,0
		l1.5,0.1l0.3-0.1l0.4,1.6l-0.2,0.8l-1.4,0.4L389.3,169.7L389.3,169.7z	"
          >
            <title id="t1081">Meade, KY</title>
          </path>
          <path
            id="FIPS_21179"
            className="FIPS_31140 st0 state-ky state-in"
            d="M402.6,169.3l0.3,0.9l-2.3,2.4l-1,2.4l-0.3,0.4l0,0l-0.5-0.2l0-0.2l0-0.4l0-0.2l0.2-0.2
		l-0.2-0.9l-0.1-0.1l-0.7-0.3l-0.1,0l-0.7-1l0.2,0l0.4-0.2l0.3-0.2l0.6-0.7l0,0l-0.1-0.1l0.8-1.4L402.6,169.3z	"
          >
            <title id="t1071">Nelson, KY</title>
          </path>
          <path
            id="FIPS_21185"
            className="FIPS_31140 st0 state-ky state-in"
            d="M400.4,162.7l0.5,1.7l-0.3,0.7l-0.3,0.1l-0.4,0l-0.4,0.1l-0.2,0.1l-0.1,0.1l-0.1,0.1l-1.8-1
		l1.8-2.1L400.4,162.7z	"
          >
            <title id="t1068">Oldham, KY</title>
          </path>
          <path
            id="FIPS_21215"
            className="FIPS_31140 st0 state-ky state-in"
            d="M399.8,167.3l3.4,1.1l-0.6,0.9l-3.2,0.1l0.4-1.7L399.8,167.3z	"
          >
            <title id="t1056">Spencer, KY</title>
          </path>
          <path
            id="FIPS_21223"
            className="FIPS_31140 st0 state-ky state-in"
            d="M399.8,159.5l1.9,1.8l-1.3,1.4l-1.2-0.3l0-0.8L399.8,159.5z	"
          >
            <title id="t1067">Trimble, KY</title>
          </path>
        </g>
        <path
          id="FIPS_18155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.5,156.9l3.4,0l0.1,0.6l-2.2,1.5l-1.6,1.1l-0.3-2.9L401.5,156.9z	"
        >
          <title id="t808">Switzerland, IN</title>
        </path>
        <path
          id="FIPS_18077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.5,157.4l2.4-0.3l0.3,2.9l-1.4-0.5l-0.7,2.1l-1.5-0.1l-0.1-0.9l-0.4-0.1l-0.3-0.2
		l-0.3-0.3l-0.2-0.3l-0.1-0.7l0.7-0.2l0.3-0.5l0.1-0.3l0.2-0.4L398.5,157.4z	"
        >
          <title id="t809">Jefferson, IN</title>
        </path>
        <path
          id="FIPS_18143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M396.2,158.9l0.1,0.7l0.2,0.3l0.3,0.3l0.3,0.2l0.4,0.1l0.1,0.9l-2.7,0.9l-0.6-2.2l0.8-1
		L396.2,158.9z	"
        >
          <title id="t810">Scott, IN</title>
        </path>

        <path
          id="FIPS_18117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.2,161.2l0.4,3.4l0,0.4l-1.4,0.1l-2.3,0.3l-0.2-1.7l-0.2-2.1L390.2,161.2z	"
        >
          <title id="t812">Orange, IN</title>
        </path>
        <path
          id="FIPS_18101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384,159l2.2-0.2l0.3,2.8l0.2,2.1l-2.4,0.5L384,159z	"
        >
          <title id="t813">Martin, IN</title>
        </path>
        <path
          id="FIPS_18027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.1,159.2l1.9-0.2l0.3,5.2l-1.5,0l-1.7-0.2l-0.5-2l0.1-1.1l0.2-0.3l0.8-1.2L382.1,159.2z	"
        >
          <title id="t814">Daviess, IN</title>
        </path>
        <path
          id="FIPS_18083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.6,159.3l1.4-0.1l-0.3,0.2l-0.8,1.2l-0.2,0.3l-0.1,1.1l0.5,2l-0.1,0.2l-0.1,0.1l-0.2,0.2
		l-0.1,0l-0.5-0.4l-0.1,0l-0.7,0.1l-0.4,0.1l-2.6,1.8l0.7-2.1l0.2-0.5l0.8-1l0.1-0.1l0.1-0.2l0.1-0.8l0-0.3l-0.4-0.8l0,0l0,0
		l-0.1-0.6L380.6,159.3z	"
        >
          <title id="t815">Knox, IN</title>
        </path>
        <path
          id="FIPS_18153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.2,154.8l0.1,1.1l0.3,3.4l-2.9,0.3l0.1-0.1l0.1-0.2l0-0.4l-0.7-1.3l-0.5-0.6l-0.2-0.7
		l0.1-1.3L380.2,154.8z	"
        >
          <title id="t816">Sullivan, IN</title>
        </path>
        <path
          id="FIPS_18055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.2,155.8l3.7-0.3l0.2,2.2l0.1,1.1L384,159l-1.9,0.2l-1.4,0.1l-0.3-3.4L382.2,155.8z	"
        >
          <title id="t817">Greene, IN</title>
        </path>
        <path
          id="FIPS_18093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.1,157.7l3.6-0.3l0.7,2.9l-0.2,1l-3.7,0.4l-0.3-2.8L386.1,157.7z	"
        >
          <title id="t818">Lawrence, IN</title>
        </path>
        <path
          id="FIPS_18071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392,156.3l2.8-0.5l0.4,3.4l-0.8,1l-3.9,0l-0.7-2.9l-0.1-0.7L392,156.3z	"
        >
          <title id="t819">Jackson, IN</title>
        </path>
        <path
          id="FIPS_18079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.1,153.8l0.4,3.7l-0.9,0.1l-0.2,0.4l-0.1,0.3l-0.3,0.5l-0.7,0.2l-1.1,0.2l-0.4-3.4l1-0.9
		L398.1,153.8z	"
        >
          <title id="t820">Jennings, IN</title>
        </path>
        <path
          id="FIPS_18137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.6,151.9l-0.1,4.7l0,0.2l-0.6,0.3l-2.4,0.3l-0.4-3.7l1.3-1.1L401.6,151.9z	"
        >
          <title id="t821">Ripley, IN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "17140"
              ? `metroArea clickedArea state-ky state-in state-oh`
              : `metroArea ${colorCode[17140]} state-ky state-in state-oh`
          }
          id="FIPS_17140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_18029"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M401.6,151.9l2.4-0.3l0.3,2.6l-0.5,1l-2.4,1.4L401.6,151.9z	"
          >
            <title id="t822">Dearborn, IN</title>
          </path>
          <path
            id="FIPS_18047"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M403.8,148.8l0.3,2.8l-2.4,0.3l-2.2,0.8l-0.3-2.4l-0.1-0.9l2.6-0.3L403.8,148.8z	"
          >
            <title id="t823">Franklin, IN</title>
          </path>
          <path
            id="FIPS_18115"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M401.5,156.6l2.4-1.4l1,1.6l-3.4,0L401.5,156.6z	"
          >
            <title id="t807">Ohio, IN</title>
          </path>
          <path
            id="FIPS_21015"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M406.3,154.4l0.5,3.5l-0.4,0.4l-1.4-0.9l-0.1-0.6l-1-1.6l0.5-1L406.3,154.4z	"
          >
            <title id="t1064">Boone, KY</title>
          </path>
          <path
            id="FIPS_21023"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M413.9,157.4l-0.6,2.4l-1.6,0.7l-0.5-0.3l-0.6-3.1l1.9,0.5L413.9,157.4z	"
          >
            <title id="t1022">Bracken, KY</title>
          </path>
          <path
            id="FIPS_21037"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M409.4,154.7l1.1,1.8l-1.7,1.1l-1.3-3.6L409.4,154.7z	"
          >
            <title id="t1062">Campbell, KY</title>
          </path>
          <path
            id="FIPS_21077"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M405,157.4l1.4,0.9l-1.2,0.9l-1.4,0.9l-1.1-1.2L405,157.4z	"
          >
            <title id="t1065">Gallatin, KY</title>
          </path>
          <path
            id="FIPS_21081"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M406.8,157.9l0.9,0l0.9,3.1l-0.7,0.7l-0.2,0.3l-0.3-0.1l-0.2-0.1l-1.7-1.5l-0.3-1.3l1.2-0.9
		L406.8,157.9z	"
          >
            <title id="t1060">Grant, KY</title>
          </path>
          <path
            id="FIPS_21117"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M407.5,154l1.3,3.6l-1.1,0.3l-0.9,0l-0.5-3.5L407.5,154z	"
          >
            <title id="t1063">Kenton, KY</title>
          </path>
          <path
            id="FIPS_21191"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M410.6,157.1l0.6,3.1l-2.6,0.8l-0.9-3.1l1.1-0.3l1.7-1.1L410.6,157.1z	"
          >
            <title id="t1061">Pendleton, KY</title>
          </path>
          <path
            id="FIPS_39015"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M412.2,151.3l1.3-0.1l0.3,2.9l2-0.2l0.3,5l-0.8-0.4l-0.9-0.9l-0.1-0.1l-0.1,0l-0.3,0l-1.5,0.2
		L412.2,151.3z	"
          >
            <title id="t2055">Brown, OH</title>
          </path>
          <path
            id="FIPS_39017"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M407,147.6l1.1-0.1l0.6,3.8l-0.4,0l-1.9,0.1l-0.7,0.1l-1.6,0.2l-0.3-2.8l-0.1-0.6L407,147.6z	
		"
          >
            <title id="t2060">Butler, OH</title>
          </path>
          <path
            id="FIPS_39025"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M412.1,151.3h0.1l0.2,6.3l-1.9-0.5l-0.1-0.6l-1.1-1.8l0-2l-0.2-0.4l0.4-0.9L412.1,151.3z	"
          >
            <title id="t2056">Clermont, OH</title>
          </path>
          <path
            id="FIPS_39061"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M408.6,151.2l1,0.2l-0.4,0.9l0.2,0.4l0,2l-2-0.7l-1.1,0.4l-2-0.2l-0.3-2.6l1.6-0.2l0.7-0.1
		l1.9-0.1L408.6,151.2z	"
          >
            <title id="t2057">Hamilton, OH</title>
          </path>
          <path
            id="FIPS_39165"
            className="FIPS_17140 st0 state-ky state-in state-oh"
            d="M410.5,147.3l1.4-0.1l0.2,4.1l-2.5,0.1l-1-0.2l-0.6-3.8L410.5,147.3z	"
          >
            <title id="t2059">Warren, OH</title>
          </path>
        </g>

        <path
          id="FIPS_18031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.9,150.6l3.3-0.4l0.3,2.4l-1.3,1.1l-2.3,1.1l-0.3-2.8L395.9,150.6z	"
        >
          <title id="t824">Decatur, IN</title>
        </path>
        <path
          id="FIPS_18005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.5,152l0.3,2.8l-1,0.9l-2.8,0.5l-0.5-3.8l1.3-0.2L395.5,152z	"
        >
          <title id="t825">Bartholomew, IN</title>
        </path>

        <path
          id="FIPS_18105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.1,153l2.5-0.1l1,3.7l0.1,0.7l-3.6,0.3l-0.2-2.2L386.1,153z	"
        >
          <title id="t827">Monroe, IN</title>
        </path>
        <path
          id="FIPS_18119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.9,151.7l2.5-0.2l0.7,1.5l-0.3,2.4l-3.7,0.3l-0.2-2.3l1.1-0.1L382.9,151.7z	"
        >
          <title id="t828">Owen, IN</title>
        </path>
        <path
          id="FIPS_18021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.2,150.2l1.8-0.1l0.9,1.6l0.1,1.7l-1.1,0.1l0.2,2.3l-1.8,0.1l-0.1-1.1l-0.3-3.4l0.4,0
		L380.2,150.2z	"
        >
          <title id="t829">Clay, IN</title>
        </path>
        <path
          id="FIPS_18167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.2,150.2l0.1,1.1l-0.4,0l0.3,3.4l-3.6,0.3l0.5-2.9l-0.2-1.7l1.5-0.1L380.2,150.2z	"
        >
          <title id="t830">Vigo, IN</title>
        </path>
        <path
          id="FIPS_18165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M377.6,143.6l0.1,2.3l0.5,0.6l0.1,0.2l0.2,0.4l-0.1,2.3l0.1,1l-1.5,0.1l-0.3-3.6l-0.3-3.4
		L377.6,143.6z	"
        >
          <title id="t831">Vermillion, IN</title>
        </path>
        <path
          id="FIPS_18121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.9,145.6l0.9,1l0.3,3.4l-1.8,0.1l-1.8,0.2l-0.1-1l0.1-2.3l-0.2-0.4l-0.1-0.2l-0.5-0.6
		L380.9,145.6z	"
        >
          <title id="t832">Parke, IN</title>
        </path>

        <path
          id="FIPS_18139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.7,146.3l2.9-0.3l0.5,4.3l-3.3,0.4l-0.4-3.2L395.7,146.3z	"
        >
          <title id="t837">Rush, IN</title>
        </path>
        <path
          id="FIPS_18041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.6,145.9l0.8-0.1l0.4,0l0.1,0.9l1.5-0.2l0.3,2.4l-2.6,0.3L398.6,145.9z	"
        >
          <title id="t838">Fayette, IN</title>
        </path>
        <path
          id="FIPS_18161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.3,146.6l2.1-0.4l0.2,2.1l0.1,0.6l-2.2,0.2L401.3,146.6z	"
        >
          <title id="t839">Union, IN</title>
        </path>
        <path
          id="FIPS_18177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.1,142.6l0.1,1.1l0.3,2.5l-2.1,0.4l-1.5,0.2l-0.1-0.9l-0.4,0l-0.1-2.8L403.1,142.6z	"
        >
          <title id="t840">Wayne, IN</title>
        </path>
        <path
          id="FIPS_18065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.5,142.5l3.5-0.4l0.2,0.9l0.1,2.8l-0.8,0.1l-2.9,0.3l0-2.1L395.5,142.5z	"
        >
          <title id="t841">Henry, IN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "26900"
              ? `metroArea clickedArea state-in`
              : `metroArea ${colorCode[26900]} state-in`
          }
          id="FIPS_26900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_18011"
            className="FIPS_26900 st0 state-in"
            d="M388.9,141.9l0.4,3.3l-0.8,0.1l-3.6,0.4l-0.3-3.3L388.9,141.9z	"
          >
            <title id="t845">Boone, IN</title>
          </path>
          <path
            id="FIPS_18013"
            className="FIPS_26900 st0 state-in"
            d="M389.9,152.7l1.6-0.2l0.5,3.8l-2.4,0.3l-1-3.7L389.9,152.7z	"
          >
            <title id="t826">Brown, IN</title>
          </path>
          <path
            id="FIPS_18057"
            className="FIPS_26900 st0 state-in"
            d="M388.8,141.4l3.7-0.4l0.4,3.6l-0.7,0.3l-3,0.3l-0.4-3.3L388.8,141.4z	"
          >
            <title id="t846">Hamilton, IN</title>
          </path>
          <path
            id="FIPS_18059"
            className="FIPS_26900 st0 state-in"
            d="M395.7,144.2l0,2.1l-0.2,1.2l-3.1,0.4l-0.2-3l0.7-0.3L395.7,144.2z	"
          >
            <title id="t842">Hancock, IN</title>
          </path>
          <path
            id="FIPS_18097"
            className="FIPS_26900 st0 state-in"
            d="M392.2,144.8l0.2,3l0.1,0.8l-2.9,0.4l-0.7,0.1l-0.4-3.8l0.8-0.1L392.2,144.8z	"
          >
            <title id="t843">Marion, IN</title>
          </path>
          <path
            id="FIPS_18063"
            className="FIPS_26900 st0 state-in"
            d="M388.4,145.3l0.4,3.8l-0.1,0l-1.3,0.2l0,0.4l-1.9,0.2l-0.2-0.4l-0.3-1.2l-0.2-1.8l-0.1,0
		l-0.1-0.7L388.4,145.3z	"
          >
            <title id="t844">Hendricks, IN</title>
          </path>
          <path
            id="FIPS_18133"
            className="FIPS_26900 st0 state-in"
            d="M381.8,146.7l3.1-0.3l0.1,0l0.2,1.8l0.3,1.2l0.2,0.4l-0.1,1.7l-2.5,0.2l-0.9-1.6L381.8,146.7z
			"
          >
            <title id="t833">Putnam, IN</title>
          </path>
          <path
            id="FIPS_18109"
            className="FIPS_26900 st0 state-in"
            d="M389.5,148.9l0.4,3.8l-1.3,0.2l-2.5,0.1l-0.7-1.5l0.1-1.7l1.9-0.2l0-0.4l1.3-0.2l0.1,0
		L389.5,148.9z	"
          >
            <title id="t834">Morgan, IN</title>
          </path>
          <path
            id="FIPS_18081"
            className="FIPS_26900 st0 state-in"
            d="M392.4,148.6l0.4,3.8l-1.3,0.2l-1.6,0.2l-0.4-3.8L392.4,148.6z	"
          >
            <title id="t835">Johnson, IN</title>
          </path>
          <path
            id="FIPS_18145"
            className="FIPS_26900 st0 state-in"
            d="M392.4,147.8l3.1-0.4l0.4,3.2l-0.4,1.4l-2.6,0.3l-0.4-3.8L392.4,147.8z	"
          >
            <title id="t836">Shelby, IN</title>
          </path>
        </g>

        <path
          id="FIPS_18135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.6,139.2l4-0.5l0.4,3.9l-3.8,0.5l-0.2-0.9L398.6,139.2z	"
        >
          <title id="t847">Randolph, IN</title>
        </path>
        <path
          id="FIPS_18035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.5,138.2l0.1,0.9l0.4,3l-3.5,0.4l-0.5-3.9l1.3-0.1L398.5,138.2z	"
        >
          <title id="t848">Delaware, IN</title>
        </path>
        <path
          id="FIPS_18095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395,138.6l0.5,3.9l0.2,1.7l-2.8,0.3l-0.4-3.6l-0.2-2.1L395,138.6z	"
        >
          <title id="t849">Madison, IN</title>
        </path>
        <path
          id="FIPS_18159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.3,138.9l0.2,2.1l-3.7,0.4l-0.2-2l3.7-0.8L392.3,138.9z	"
        >
          <title id="t850">Tipton, IN</title>
        </path>
        <path
          id="FIPS_18023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.1,139.1l3.1-0.3l0.6-0.1l0.1,0.6l0.3,0.2l0.4,0l0.2,2l0,0.5l-4.4,0.5l0-0.5L384.1,139.1z
			"
        >
          <title id="t851">Clinton, IN</title>
        </path>
        <path
          id="FIPS_18107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.4,141.9l0,0.5l0.3,3.3l0.1,0.7l-3.1,0.3l-0.9-1l-0.3-3.4L384.4,141.9z	"
        >
          <title id="t852">Montgomery, IN</title>
        </path>
        <path
          id="FIPS_18045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.5,142.2l0.3,3.4l-3.2,0.3l-0.1-2.3l-0.3-0.3l0-0.1l0-0.1l0.1-0.3l1.6-1.6l0.2-0.2
		l1.2-0.8L380.5,142.2z	"
        >
          <title id="t853">Fountain, IN</title>
        </path>
        <path
          id="FIPS_18075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.3,135.3l0.3,2.8l0.1,0.5l-4,0.5l-0.1-0.9l-0.1-2.4l1.3-0.2L402.3,135.3z	"
        >
          <title id="t854">Jay, IN</title>
        </path>
        <path
          id="FIPS_18009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M396,136.1l2.4-0.3l0.1,2.4l-2.2,0.2L396,136.1z	"
        >
          <title id="t855">Blackford, IN</title>
        </path>
        <path
          id="FIPS_18053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M394.1,135.1l1.8-0.2l0.1,1.1l0.3,2.4l-1.3,0.1l-2.8,0.3l0-0.4l-0.2-2.1l-0.1-1.1L394.1,135.1
		z	"
        >
          <title id="t856">Grant, IN</title>
        </path>
        <path
          id="FIPS_18067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.1,136.9l2.9-0.3l0.2,2.1l-3.7,0.8l-0.4,0l-0.3-0.2l-0.1-0.6l-0.6,0.1l-0.2-1.7
		L389.1,136.9z	"
        >
          <title id="t857">Howard, IN</title>
        </path>
        <path
          id="FIPS_18015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387.1,137.1l0.2,1.7l-3.1,0.3l-0.2-1.7l-0.7,0.1l-0.1-1.1l0-1.1l0-0.1l0-0.1l1.6-0.1l0.5,0
		l1.5,0.4L387.1,137.1z	"
        >
          <title id="t858">Carroll, IN</title>
        </path>
        <path
          id="FIPS_18157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.1,137.7l3.1-0.3l0.7-0.1l0.2,1.7l0.3,2.8l-3.9,0.4l-0.2-2l-0.1-1.4L380.1,137.7z	"
        >
          <title id="t859">Tippecanoe, IN</title>
        </path>
        <path
          id="FIPS_18171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376,139.2l4.2-0.4l0.1,1.4l-1.2,0.8l-0.2,0.2l-1.6,1.6l-0.1,0.3l0,0.1l0,0.1l0.3,0.3
		l-1.2-0.2L376,139.2z	"
        >
          <title id="t860">Warren, IN</title>
        </path>
        <path
          id="FIPS_18007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M378.2,135.6l1.6-0.2l0.4,3.4l-4.2,0.4l0-0.2l-0.3-3.2L378.2,135.6z	"
        >
          <title id="t861">Benton, IN</title>
        </path>
        <path
          id="FIPS_18001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.7,130.8l0.3,2.5l0.2,2l-2.6,0.4l-0.6-4.5L401.7,130.8z	"
        >
          <title id="t862">Adams, IN</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "23060"
              ? `metroArea clickedArea state-in`
              : `metroArea ${colorCode[23060]} state-in`
          }
          id="FIPS_23060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_18179"
            className="FIPS_23060 st0 state-in"
            d="M396.6,131.4l2.5-0.3l0.6,4.5l-1.3,0.2l-2.4,0.3l-0.1-1.1l1.1-0.1L396.6,131.4z	"
          >
            <title id="t863">Wells, IN</title>
          </path>
          <path
            id="FIPS_18003"
            className="FIPS_23060 st0 state-in"
            d="M401.2,126.5l0.4,3.4l0.1,0.9l-2.6,0.4l-2.5,0.3l-0.1-1.1l-0.1-3.4l1.1-0.1l3.7-0.5
		L401.2,126.5z	"
          >
            <title id="t869">Allen, IN</title>
          </path>
          <path
            id="FIPS_18183"
            className="FIPS_23060 st0 state-in"
            d="M393,126.9l1.1-0.1l0,0.4l2.2-0.2l0.1,3.4l-3,0.4l-0.5-0.5l-0.2-1.7l0.3,0l-0.1-1L393,126.9z	
		"
          >
            <title id="t870">Whitley, IN</title>
          </path>
        </g>
        <path
          id="FIPS_18069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M393.5,130.6l3-0.4l0.1,1.1l0.4,3.4l-1.1,0.1l-1.8,0.2L393.5,130.6z	"
        >
          <title id="t864">Huntington, IN</title>
        </path>
        <path
          id="FIPS_18169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M393.1,130.1l0.5,0.5l0.5,4.5l-2.2,0.3l-0.7,0.1l-0.5-4.5l-0.1-0.6L393.1,130.1z	"
        >
          <title id="t865">Wabash, IN</title>
        </path>
        <path
          id="FIPS_18103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.6,131l0.5,4.5l0.7-0.1l0.1,1.1l-2.9,0.3l-0.5-4.5L390.6,131z	"
        >
          <title id="t866">Miami, IN</title>
        </path>
        <path
          id="FIPS_18017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.7,132.7l2.9-0.3l0.5,4.5l-2,0.2l-0.2-1.7l-1.5-0.4l-0.5,0l-0.2-2.3L385.7,132.7z	"
        >
          <title id="t867">Cass, IN</title>
        </path>
        <path
          id="FIPS_18181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.6,132.8l0.2,2.3l-1.6,0.1l0,0.1l0,0.1l0,1.1l0.1,1.1l-3.1,0.3l-0.2-2.2l1.4-2.4
		L384.6,132.8z	"
        >
          <title id="t868">White, IN</title>
        </path>

        <path
          id="FIPS_18049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.4,129.3l3.7-0.4l1.4,1.5l0.1,0.6l-2,1.4l-2.9,0.3L385.4,129.3z	"
        >
          <title id="t871">Fulton, IN</title>
        </path>
        <path
          id="FIPS_18131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.4,129.3l0.3,3.4l-1.1,0.1l-3.4,0.3l-0.3-3.4L385.4,129.3z	"
        >
          <title id="t872">Pulaski, IN</title>
        </path>
        <path
          id="FIPS_18033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.1,123.4l3.7-0.5l0.2,1.3l0.2,2l-3.7,0.5L397.1,123.4z	"
        >
          <title id="t873">DeKalb, IN</title>
        </path>
        <path
          id="FIPS_18113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.1,123.4l0.4,3.4l-1.1,0.1l-2.2,0.2l0-0.4l-1.1,0.1l-0.2-1.8l-0.1-1.1L397.1,123.4z	"
        >
          <title id="t874">Noble, IN</title>
        </path>
        <path
          id="FIPS_18085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M388.9,125.5l3.9-0.4l0.2,1.8l0.1,0.5l0.1,1l-0.3,0l0.2,1.7l-2.5,0.3l-1.4-1.5L388.9,125.5z	"
        >
          <title id="t875">Kosciusko, IN</title>
        </path>
        <path
          id="FIPS_18099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M388.9,125.5l0.2,3.4l-3.7,0.4l-0.3-3.4l-0.1-0.6l1.7-0.2l2.2-0.2L388.9,125.5z	"
        >
          <title id="t876">Marshall, IN</title>
        </path>
        <path
          id="FIPS_18149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385,125.9l0.3,3.4l-4.5,0.4l-0.1-0.8l1.1-0.6l0.3-0.2l0.2-0.3l0.2-0.3l0.1-0.2l0.2-0.8
		l0.5-0.4l1.1-0.1L385,125.9z	"
        >
          <title id="t877">Starke, IN</title>
        </path>

        <path
          id="FIPS_18151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.2,120l0.3,0.8l0.3,2.1l-3.7,0.5l-0.4-3L400.2,120z	"
        >
          <title id="t880">Steuben, IN</title>
        </path>
        <path
          id="FIPS_18087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.8,120.5l0.9-0.1l0.4,3l-4.4,0.5l-0.4-3L395.8,120.5z	"
        >
          <title id="t881">LaGrange, IN</title>
        </path>
        <path
          id="FIPS_18039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.3,120.9l0.4,3l0.1,1.1l-3.9,0.4l-0.5-4.2l2.6-0.3L392.3,120.9z	"
        >
          <title id="t882">Elkhart, IN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "43780"
              ? `metroArea clickedArea state-in state-mi`
              : `metroArea ${colorCode[43780]} state-in state-mi`
          }
          id="FIPS_43780"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_18141"
            className="FIPS_43780 st0 state-in state-mi"
            d="M388.5,121.3l0.4,3.6l-2.2,0.2l-1.7,0.2l0.1,0.6l-0.6,0.1l-0.4-4.2l2.8-0.3L388.5,121.3z	"
          >
            <title id="t883">St. Joseph, IN</title>
          </path>
          <path
            id="FIPS_26027"
            className="FIPS_43780 st0 state-in state-mi"
            d="M386.5,117.4l4.4-0.4l0.2,4l-2.6,0.3l-1.6,0.2L386.5,117.4z	"
          >
            <title id="t1235">Cass, MI</title>
          </path>
        </g>
        <path
          id="FIPS_18091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M381.2,122l2.9-0.3l0.4,4.2l-1.1,0.1l-0.5,0.4l-0.2,0.8l-0.1,0.2l-0.2,0.3l-0.2,0.3l-0.3,0.2
		l-1.1,0.6l-0.6-6.1L381.2,122z	"
        >
          <title id="t884">LaPorte, IN</title>
        </path>
        <path
          id="FIPS_20043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M300,149.1h0.3l0,0.1l0.1,0.1l1.2,1.1l0.5,0.3l0.2,0.1l0.2,0.1l0,0l0,0l0.4,0l0.1,0l0.1-0.1
		l0,0l0.3-0.4l0.8,1l0.1,0.4l0.1,0.4l-0.2,0.5l-0.2,0l-0.7,0.6l0,0l-0.3,0.5l-0.1,0.2l-2.7-0.4L300,149.1z	"
        >
          <title id="t885">Doniphan, KS</title>
        </path>
        <path
          id="FIPS_20013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.6,149.1l4.4,0l0,4.5l-2.2,0l-2.2,0V149.1z	"
        >
          <title id="t886">Brown, KS</title>
        </path>
        <path
          id="FIPS_20187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M232.4,176.6l5.2,0.3l-0.2,4.5l-0.3,0l-4.9-0.3l0.2-3.3L232.4,176.6z	"
        >
          <title id="t887">Stanton, KS</title>
        </path>
        <path
          id="FIPS_20129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M232.1,181.1l4.9,0.3l-0.3,5.1l-4.8-0.3l-0.1,0L232.1,181.1z	"
        >
          <title id="t888">Morton, KS</title>
        </path>
        <path
          id="FIPS_20189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237,181.4l0.3,0l4.4,0.3l0.2,0l-0.3,5.1l-5-0.2L237,181.4z	"
        >
          <title id="t889">Stevens, KS</title>
        </path>
        <path
          id="FIPS_20067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.6,176.9l4.4,0.2l-0.2,4.5l-4.4-0.3L237.6,176.9z	"
        >
          <title id="t890">Grant, KS</title>
        </path>
        <path
          id="FIPS_20081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.4,177.4l-0.2,3.4l-0.1,1.1l-4.2-0.2l-0.2,0l0.2-4.5L246.4,177.4z	"
        >
          <title id="t891">Haskell, KS</title>
        </path>
        <path
          id="FIPS_20175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.2,181.9l0,5l-3.2-0.1l-1.2-0.1l0.3-5.1L246.2,181.9z	"
        >
          <title id="t892">Seward, KS</title>
        </path>
        <path
          id="FIPS_20119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250.7,181l1.1,0.1l-0.1,6.1l-5.6-0.2l0-5l0.1-1.1L250.7,181z	"
        >
          <title id="t893">Meade, KS</title>
        </path>
        <path
          id="FIPS_20069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250.8,175.3l-0.1,5.7l-4.4-0.2l0.2-3.4l-0.1-1.2l0.1-2.3l4.4,0.2L250.8,175.3z	"
        >
          <title id="t894">Gray, KS</title>
        </path>
        <path
          id="FIPS_20057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250.8,175.3l6.6,0.3l0,2.3l-0.1,3.5l-5.6-0.3l-1.1-0.1L250.8,175.3z	"
        >
          <title id="t895">Ford, KS</title>
        </path>
        <path
          id="FIPS_20025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.4,181.4l0.1,1.1l-0.2,5l-4.7-0.2l-0.9,0l0.1-6.1L257.4,181.4z	"
        >
          <title id="t896">Clark, KS</title>
        </path>
        <path
          id="FIPS_20033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.9,182.6l0,5l-4.7-0.2l-0.9,0l0.2-5L262.9,182.6z	"
        >
          <title id="t897">Comanche, KS</title>
        </path>
        <path
          id="FIPS_20097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.5,177.9l5.5,0.2l-0.1,3.4l0,1.1l-5.4-0.1l-0.1-1.1L257.5,177.9z	"
        >
          <title id="t898">Kiowa, KS</title>
        </path>
        <path
          id="FIPS_20047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.5,173.3l2.2,0.1l0,1.1l3.3,0.1l0,2.3l0,1.2l-5.5-0.2l0-2.3L257.5,173.3z	"
        >
          <title id="t899">Edwards, KS</title>
        </path>
        <path
          id="FIPS_20151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.5,177.1l0,1.2l-0.1,3.4l-5.6-0.1l0.1-3.4l0-1.2L268.5,177.1z	"
        >
          <title id="t900">Pratt, KS</title>
        </path>
        <path
          id="FIPS_20007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.9,181.5l5.6,0.1l1.1,1.2l-0.1,5l-2-0.1l-4.7-0.1l0-5L262.9,181.5z	"
        >
          <title id="t901">Barber, KS</title>
        </path>
        <path
          id="FIPS_20077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269.6,182.8l5.5,0.1l0,5l-3.2-0.1l-2.4-0.1L269.6,182.8z	"
        >
          <title id="t902">Harper, KS</title>
        </path>
        <path
          id="FIPS_20095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.5,178.3l6.6,0.1l-0.1,3.4l0,1.1l-5.5-0.1l-1.1-1.2L268.5,178.3z	"
        >
          <title id="t903">Kingman, KS</title>
        </path>
        <path
          id="FIPS_20155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274.1,172.7l2.2,0l-0.1,3.4l-1.1,2.3l-6.6-0.1l0-1.2l0.1-4.5L274.1,172.7z	"
        >
          <title id="t904">Reno, KS</title>
        </path>

        <path
          id="FIPS_20035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M281.8,181.9l6.4,0v2.3l0,3.9l-2.3,0l-4.1,0L281.8,181.9z	"
        >
          <title id="t908">Cowley, KS</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "48620"
              ? `metroArea clickedArea state-ks`
              : `metroArea ${colorCode[48620]} state-ks`
          }
          id="FIPS_48620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_20015"
            className="FIPS_48620 st0 state-ks"
            d="M285,174l3.2,0l-0.1,6.2l0,1.7l-6.4,0l0.1-5.7l0-2.3L285,174z	"
          >
            <title id="t909">Butler, KS</title>
          </path>
          <path
            id="FIPS_20079"
            className="FIPS_48620 st0 state-ks"
            d="M279.7,172.8l2.2,1.1l0,2.3l-5.6-0.1l0.1-3.4L279.7,172.8z	"
          >
            <title id="t905">Harvey, KS</title>
          </path>
          <path
            id="FIPS_20173"
            className="FIPS_48620 st0 state-ks"
            d="M276.3,176.1l5.6,0.1l-0.1,5.7l-6.6-0.1l0.1-3.4L276.3,176.1z	"
          >
            <title id="t906">Sedgwick, KS</title>
          </path>
          <path
            id="FIPS_20191"
            className="FIPS_48620 st0 state-ks"
            d="M275.1,181.8l6.6,0.1l0,6.2l-3.2,0l-3.5-0.1l0-5L275.1,181.8z	"
          >
            <title id="t907">Sumner, KS</title>
          </path>
        </g>
        <path
          id="FIPS_20019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.1,184.2l5.7,0.1l0,3.9h-0.4l-5.4,0L288.1,184.2z	"
        >
          <title id="t910">Chautauqua, KS</title>
        </path>
        <path
          id="FIPS_20049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,180.3v2.8l0,1.1l-5.7-0.1v-2.3l0-1.7L293.9,180.3z	"
        >
          <title id="t911">Elk, KS</title>
        </path>
        <path
          id="FIPS_20073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,172.9l0,1.7l0,4v1.7l-5.7-0.1l0.1-6.2l1.7-1.1L293.9,172.9z	"
        >
          <title id="t912">Greenwood, KS</title>
        </path>
        <path
          id="FIPS_20125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,183.1l4.4,0h0l0,1.5l0,2.7l0,0.8l-2.7,0l-1.8,0l0-3.9L293.9,183.1z	"
        >
          <title id="t913">Montgomery, KS</title>
        </path>
        <path
          id="FIPS_20205"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,178.6l4.4,0l0,4.5l-4.4,0V178.6z	"
        >
          <title id="t914">Wilson, KS</title>
        </path>
        <path
          id="FIPS_20207"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,174.6l4.4,0l0,4l-4.4,0L293.9,174.6z	"
        >
          <title id="t915">Woodson, KS</title>
        </path>
        <path
          id="FIPS_20099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.4,183.1l4.4,0l0.1,0.6l0.1,4.4l-3.4,0l-1.2,0l0-0.8l0-2.7L298.4,183.1z	"
        >
          <title id="t916">Labette, KS</title>
        </path>
        <path
          id="FIPS_20133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.7,178.6l0,0.8l0,3.8l-4.4,0h0l0-4.5L302.7,178.6z	"
        >
          <title id="t917">Neosho, KS</title>
        </path>
        <path
          id="FIPS_20001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.8,174.6l-0.1,4l-4.4,0l0-4L302.8,174.6z	"
        >
          <title id="t918">Allen, KS</title>
        </path>
        <path
          id="FIPS_20021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.9,183.6l4.7,0l0.1,4.4l-4,0l-0.7,0L302.9,183.6z	"
        >
          <title id="t919">Cherokee, KS</title>
        </path>
        <path
          id="FIPS_20037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.5,179.3l0.1,4l0,0.3l-4.7,0l-0.1-0.6l0-3.8L307.5,179.3z	"
        >
          <title id="t920">Crawford, KS</title>
        </path>
        <path
          id="FIPS_20011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.8,174.6l4.7,0l0,4.7l-4.8,0l0-0.8L302.8,174.6z	"
        >
          <title id="t921">Bourbon, KS</title>
        </path>
        <path
          id="FIPS_20075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M232.8,169.8l4.8,0.3l0.3,0l-0.2,3.8l0,1.9l-0.1,1.2l-5.2-0.3L232.8,169.8z	"
        >
          <title id="t922">Hamilton, KS</title>
        </path>
        <path
          id="FIPS_20071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M233.1,164.1l4.8,0.3l-0.3,5.7l-4.8-0.3l0.3-4.6L233.1,164.1z	"
        >
          <title id="t923">Greeley, KS</title>
        </path>
        <path
          id="FIPS_20199"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.1,158.8l-0.4,5.6l-0.8,0l-4.8-0.3l0.3-4.5l0.1-1.1L239.1,158.8z	"
        >
          <title id="t924">Wallace, KS</title>
        </path>
        <path
          id="FIPS_20181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M233.8,152.8l6.3,0.4l0.2,0l-0.3,5.6l-0.9,0l-5.6-0.3L233.8,152.8z	"
        >
          <title id="t925">Sherman, KS</title>
        </path>
        <path
          id="FIPS_20023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234.1,147.2l6.3,0.4l-0.3,5.6l-6.3-0.4l0-0.1L234.1,147.2z	"
        >
          <title id="t926">Cheyenne, KS</title>
        </path>
        <path
          id="FIPS_20185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M264.2,171.3l4.4,0.1l0,1.1l-0.1,4.5l-5.5-0.2l0-2.3l1.1,0L264.2,171.3z	"
        >
          <title id="t927">Stafford, KS</title>
        </path>
        <path
          id="FIPS_20093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.8,170.1l4.2,0.2l0.2,0l-0.1,2.2l-0.2,3.5l0.1,1.2l-4.4-0.2l0.1-1.2l0-1.9L237.8,170.1z	"
        >
          <title id="t928">Kearny, KS</title>
        </path>
        <path
          id="FIPS_20055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.4,170.5l4.4,0.2l0.2,0l-0.1,3.4l-4.4-0.2l-0.1,2.3l0.1,1.2l-4.4-0.2l-0.1-1.2l0.2-3.5
		l0.1-2.2L246.4,170.5z	"
        >
          <title id="t929">Finney, KS</title>
        </path>
        <path
          id="FIPS_20083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.5,171l0.1,2.3l-0.1,2.3l-6.6-0.3l0.1-1.1l0.1-3.4L257.5,171z	"
        >
          <title id="t930">Hodgeman, KS</title>
        </path>
        <path
          id="FIPS_20145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.5,169.9l5.5,0.2l1.2,1.2l-0.1,3.4l-1.1,0l-3.3-0.1l0-1.1l-2.2-0.1l-0.1-2.3L257.5,169.9z
			"
        >
          <title id="t931">Pawnee, KS</title>
        </path>
        <path
          id="FIPS_20031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.4,169.4v0.6l0,1.7h-0.1l0,2.9l-4.4,0l0-1.7l0.1-3.4L298.4,169.4z	"
        >
          <title id="t932">Coffey, KS</title>
        </path>
        <path
          id="FIPS_20003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.4,170l4.4,0l0,1.7l-0.1,1.7v1.1l-4.5,0l0-2.9h0.1L298.4,170z	"
        >
          <title id="t933">Anderson, KS</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "28140"
              ? `metroArea clickedArea state-ks state-mo`
              : `metroArea ${colorCode[28140]} state-ks state-mo`
          }
          id="FIPS_28140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_20059"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M298.5,165.5l4.4,0l0,4.5l-4.4,0v-0.6L298.5,165.5z	"
          >
            <title id="t936">Franklin, KS</title>
          </path>
          <path
            id="FIPS_20091"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M304.4,162.2l0.3-0.8l0.1-0.1l0.1,0l0.2,0l0.9,0.2l1.5,0l0,2.6l0,1.4l-4.5,0.1l0-3.2
		L304.4,162.2z	"
          >
            <title id="t964">Johnson, KS</title>
          </path>
          <path
            id="FIPS_20103"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M301.6,156.6l2.1,0l1.8,2.8h-1.1l-0.1,1l0,1.8l-1.5,0.1l-1.3-0.8l0-1.1l0.1-1.3L301.6,156.6z	
		"
          >
            <title id="t966">Leavenworth, KS</title>
          </path>
          <path
            id="FIPS_20107"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.4,170l0.1,4.3l0,0.3l-4.7,0v-1.1l0.1-1.7l0-1.7L307.4,170z	"
          >
            <title id="t934">Linn, KS</title>
          </path>
          <path
            id="FIPS_20121"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.4,165.4l0,3.4l0,1.2l-4.5,0l0-4.5L307.4,165.4z	"
          >
            <title id="t935">Miami, KS</title>
          </path>
          <path
            id="FIPS_20209"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.4,159.9l0,0.6l0,0.9l-1.5,0l-0.9-0.2l-0.2,0l-0.1,0l-0.1,0.1l-0.3,0.8l0-1.8l0.1-1h1.1
		L307.4,159.9z	"
          >
            <title id="t965">Wyandotte, KS</title>
          </path>
          <path
            id="FIPS_29013"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.4,168.8l2.9,0l0.6,0.2l0.6,0.1l1.4,0l0.2,3l0,2.3l-0.8-0.3l-0.7,0.1l-0.4,0.1l-3.8-0.1
		l-0.1-4.3L307.4,168.8z	"
          >
            <title id="t1425">Bates, MO</title>
          </path>
          <path
            id="FIPS_29025"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M311.1,151.7l1.1,0l2,0l1.3,0l0.1,2.2l0,1.1l-4.4,0.1l0-2.8L311.1,151.7z	"
          >
            <title id="t1411">Caldwell, MO</title>
          </path>
          <path
            id="FIPS_29037"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.4,164l4.9,0.1l0.6,3.4l0,1.6l-1.4,0l-0.6-0.1l-0.6-0.2l-2.9,0l0-3.4L307.4,164z	"
          >
            <title id="t1423">Cass, MO</title>
          </path>
          <path
            id="FIPS_29049"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M311.2,152.2l0,2.8v0.9l-3.9,0l0-1l0-2.8L311.2,152.2z	"
          >
            <title id="t1409">Clinton, MO</title>
          </path>
          <path
            id="FIPS_29047"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M307.3,156.1l3.9,0l0,3.2l-0.3-0.3l-0.1,0l-0.1,0l-0.3,0l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0.2
		l-0.1,0.2l-0.3,0.3l-1,0.5l-1.4,0.2l0-0.6L307.3,156.1z	"
          >
            <title id="t1410">Clay, MO</title>
          </path>
          <path
            id="FIPS_29107"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M315.7,159.2l1-0.6l0.7,0.1l1.1-0.7l-0.1,4.6v0.2l-3.4,0l0,0.4l-2.8-0.1l0-2.9l0.2,0.1l0.1,0
		l0.1,0l0.1-0.1l0.2-0.2l0-0.1l0,0l0.5-0.4l1.4-0.2L315.7,159.2z	"
          >
            <title id="t1419">Lafayette, MO</title>
          </path>
          <path
            id="FIPS_29095"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M312.3,160.1l0,2.9l0,1.1l-4.9-0.1l0-2.6l0-0.9l1.4-0.2l1-0.5l0.3-0.3l0.1-0.2l0-0.2l0.1-0.1
		l0.1-0.1l0.1-0.1l0.3,0l0.1,0l0.1,0l0.3,0.3L312.3,160.1z	"
          >
            <title id="t1420">Jackson, MO</title>
          </path>
          <path
            id="FIPS_29165"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M302.4,155.1l5,0l0,1l0,3.8l-1.9-0.5l-1.8-2.8L302.4,155.1z	"
          >
            <title id="t1402">Platte, MO</title>
          </path>
          <path
            id="FIPS_29177"
            className="FIPS_28140 st0 state-ks state-mo"
            d="M315.6,155l0.1,4.1l-0.7-0.1l-1.4,0.2l-0.5,0.4l0,0l0,0.1l-0.2,0.2l-0.1,0.1l-0.1,0l-0.1,0
		l-0.2-0.1l-1.1-0.8l0-3.2v-0.9L315.6,155z	"
          >
            <title id="t1418">Ray, MO</title>
          </path>
        </g>

        <path
          id="FIPS_20111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M290,165.5l4.1,0l0,4l-0.1,3.4l-4,0l0-4.5L290,165.5z	"
        >
          <title id="t938">Lyon, KS</title>
        </path>
        <path
          id="FIPS_20017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M285.3,168.3l4.7,0l0,4.5l-1.7,1.1l-3.2,0l0-2.1l0-1.3l0.2,0L285.3,168.3z	"
        >
          <title id="t939">Chase, KS</title>
        </path>
        <path
          id="FIPS_20127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.5,163.8l1.5,1.7l0,2.8l-4.7,0l-1.1-1.1l0.4-3.4L288.5,163.8z	"
        >
          <title id="t940">Morris, KS</title>
        </path>
        <path
          id="FIPS_20115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.2,167.1l1.1,1.1l0,2.3l-0.2,0l0,1.3l0,2.1l-3.1-0.1l-2.2-1.1l0.1-5.7L284.2,167.1z	"
        >
          <title id="t941">Marion, KS</title>
        </path>
        <path
          id="FIPS_20113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.8,167.1l-0.1,5.7l-3.3-0.1l-2.2,0l0.1-5.7L279.8,167.1z	"
        >
          <title id="t942">McPherson, KS</title>
        </path>
        <path
          id="FIPS_20159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.6,168l5.6,0.1l-0.1,4.5l-5.5-0.1l0-1.1L268.6,168z	"
        >
          <title id="t943">Rice, KS</title>
        </path>
        <path
          id="FIPS_20169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.8,162.6l-0.1,4.5l-5.5-0.1l0-3.4l0-1.1L279.8,162.6z	"
        >
          <title id="t944">Saline, KS</title>
        </path>
        <path
          id="FIPS_20053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.7,163.5l5.5,0.1l0,3.4l0,1.1l-5.6-0.1l0-2.3L268.7,163.5z	"
        >
          <title id="t945">Ellsworth, KS</title>
        </path>
        <path
          id="FIPS_20009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.6,165.7l0,2.3l-0.1,3.4l-4.4-0.1l-1.2-1.2l0.1-4.5L268.6,165.7z	"
        >
          <title id="t946">Barton, KS</title>
        </path>
        <path
          id="FIPS_20165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.7,165.4l5.4,0.2l0.1,0l-0.1,4.5l-5.5-0.2L257.7,165.4z	"
        >
          <title id="t947">Rush, KS</title>
        </path>
        <path
          id="FIPS_20135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M251.1,165.1l0.9,0l5.5,0.2l0.1,0l-0.2,4.5l0,1.1l-6.5-0.3l-0.2,0L251.1,165.1z	"
        >
          <title id="t948">Ness, KS</title>
        </path>
        <path
          id="FIPS_20101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.7,164.9l4.4,0.2l-0.2,5.7l-4.4-0.2L246.7,164.9z	"
        >
          <title id="t949">Lane, KS</title>
        </path>
        <path
          id="FIPS_20171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M242.3,164.6l3.1,0.2l1.3,0.1l-0.2,5.7l-4.2-0.2l-0.2,0L242.3,164.6z	"
        >
          <title id="t950">Scott, KS</title>
        </path>
        <path
          id="FIPS_20203"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M238.7,164.4l3.6,0.2l-0.3,5.7l-4.2-0.2l-0.3,0l0.3-5.7L238.7,164.4z	"
        >
          <title id="t951">Wichita, KS</title>
        </path>
        <path
          id="FIPS_20109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240,158.8l1.5,0.1l1.5,0.1l2.8,0.1l-0.4,5.6l-3.1-0.2l-3.6-0.2l0.4-5.6L240,158.8z	"
        >
          <title id="t952">Logan, KS</title>
        </path>
        <path
          id="FIPS_20063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.6,159.2l5.5,0.3l0.2,0l-0.3,5.6l-0.9,0l-4.4-0.2l-1.3-0.1l0.4-5.6L246.6,159.2z	"
        >
          <title id="t953">Gove, KS</title>
        </path>
        <path
          id="FIPS_20195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.3,159.5l5.4,0.2l0.1,0l-0.3,5.7l-5.5-0.2L252.3,159.5z	"
        >
          <title id="t954">Trego, KS</title>
        </path>
        <path
          id="FIPS_20051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.8,159.7l5.4,0.2l0.1,0l-0.2,5.7l-5.4-0.2l-0.1,0L257.8,159.7z	"
        >
          <title id="t955">Ellis, KS</title>
        </path>
        <path
          id="FIPS_20167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.3,159.9l5.4,0.2l0,3.4l-0.1,2.3l-5.5-0.2l-0.1,0L263.3,159.9z	"
        >
          <title id="t956">Russell, KS</title>
        </path>
        <path
          id="FIPS_20105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274.3,159.1l-0.1,3.4l0,1.1l-5.5-0.1l0-3.4l0-1.1L274.3,159.1z	"
        >
          <title id="t957">Lincoln, KS</title>
        </path>
        <path
          id="FIPS_20143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274.4,157.9l5.5,0.1l0,2.3l0,2.3l-5.5-0.1l0.1-3.4L274.4,157.9z	"
        >
          <title id="t958">Ottawa, KS</title>
        </path>
        <path
          id="FIPS_20041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.9,160.3l0.7,3.4l-0.4,3.4l-4.4-0.1l0.1-4.5l0-2.3L283.9,160.3z	"
        >
          <title id="t959">Dickinson, KS</title>
        </path>
        <path
          id="FIPS_20061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.9,160.3l0-1.1l1.1,0l0,1.7l2.7,0.2l0.8,0v0.4l0,2.3l-3.9,0L283.9,160.3z	"
        >
          <title id="t960">Geary, KS</title>
        </path>

        <path
          id="FIPS_20045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M301.6,161.5l1.3,0.8l0,3.2l-4.4,0l0-1.7l0-2.4l0.4-0.2l0.2,0l0.1,0l0.2,0.1l0.1,0.1l0.3,0.2
		l0.2,0l0.1,0L301.6,161.5z	"
        >
          <title id="t963">Douglas, KS</title>
        </path>

        <path
          id="FIPS_20005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.4,155.1l1.3,1.5l-2.1,0l-3.9,0l0-3l2.2,0l2.7,0.4L302.4,155.1z	"
        >
          <title id="t968">Atchison, KS</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45820"
              ? `metroArea clickedArea state-ks`
              : `metroArea ${colorCode[45820]} state-ks`
          }
          id="FIPS_45820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_20085"
            className="FIPS_45820 st0 state-ks"
            d="M297.7,156.6l-0.2,2.6l-4.4,0v-4.5l2.4-1.1l2.2,0L297.7,156.6z	"
          >
            <title id="t969">Jackson, KS</title>
          </path>
          <path
            id="FIPS_20087"
            className="FIPS_45820 st0 state-ks"
            d="M297.7,156.6l3.9,0l0,2.5l-0.1,1.3l0,1.1l-1.4,0.2l-0.1,0l-0.2,0l-0.3-0.2l-0.1-0.1l-0.2-0.1
		l-0.1,0l-0.2,0l-0.4,0.2l-0.9-2.1L297.7,156.6z	"
          >
            <title id="t967">Jefferson, KS</title>
          </path>
          <path
            id="FIPS_20139"
            className="FIPS_45820 st0 state-ks"
            d="M298.5,163.8l0,1.7l0,4l-4.4,0l0-4l0-1.7L298.5,163.8z	"
          >
            <title id="t937">Osage, KS</title>
          </path>
          <path
            id="FIPS_20197"
            className="FIPS_45820 st0 state-ks"
            d="M293.1,160.5l0.9,3.3l0,1.7l-4.1,0l-1.5-1.7l0-2.3l1.1-1.7l0.1,0.1l0.3,0.2l0.1,0l0.5-0.5
		l0.7-0.2l1.2,0.1l0.2,0.1l0.1,0.2l0.3,0.6L293.1,160.5z	"
          >
            <title id="t961">Wabaunsee, KS</title>
          </path>
          <path
            id="FIPS_20177"
            className="FIPS_45820 st0 state-ks"
            d="M293.1,159.3l4.4,0l0.9,2.1l0,2.4l-4.4,0l-0.9-3.3L293.1,159.3z	"
          >
            <title id="t962">Shawnee, KS</title>
          </path>
        </g>
        <path
          id="FIPS_20149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.1,159.3l0,1.2l0-0.1l-0.3-0.6l-0.1-0.2l-0.2-0.1l-1.2-0.1l-0.7,0.2l-0.5,0.5l-0.1,0
		l-0.3-0.2l-0.1-0.1l-0.7-0.2l-0.7-0.3l-0.9-0.9l-0.5-0.8l-0.5-0.9l0-0.5l0.1-0.2l1.3-1.4l3.4,0l2,0V159.3z	"
        >
          <title id="t970">Pottawatomie, KS</title>
        </path>
        <path
          id="FIPS_20161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284,159.2l0.1-4.5l1.5,0l2.2,0l-1.3,1.4l-0.1,0.2l0,0.5l0.5,0.9l0.5,0.8l0.9,0.9l0.7,0.3
		l0.7,0.2l-1.1,1.7v-0.4l-0.8,0l-2.7-0.2l0-1.7L284,159.2z	"
        >
          <title id="t971">Riley, KS</title>
        </path>
        <path
          id="FIPS_20027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.9,158l0.1-3.4l4,0.1l-0.1,4.5l0,1.1l-4.1,0L279.9,158z	"
        >
          <title id="t972">Clay, KS</title>
        </path>
        <path
          id="FIPS_20029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274.4,154.6l0-1.1l5.5,0.1l0,1.1l-0.1,3.4l-5.5-0.1L274.4,154.6z	"
        >
          <title id="t973">Cloud, KS</title>
        </path>
        <path
          id="FIPS_20123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274.4,154.6l0,3.4l0,1.1l-5.6-0.1l0.1-4.5L274.4,154.6z	"
        >
          <title id="t974">Mitchell, KS</title>
        </path>
        <path
          id="FIPS_20141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.8,158.9l0,1.1l-5.4-0.2l-0.1,0l0.1-1.9l0.1-1.5l0.1-2.3l5.3,0.2l0.2,0L268.8,158.9z	"
        >
          <title id="t975">Osborne, KS</title>
        </path>
        <path
          id="FIPS_20163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.9,154.1l5.3,0.2l0.2,0l-0.1,2.3l-0.1,1.5l-0.1,1.9l-5.4-0.2l-0.1,0L257.9,154.1z	"
        >
          <title id="t976">Rooks, KS</title>
        </path>
        <path
          id="FIPS_20065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.1,159.5l0.3-5.7l5.3,0.2l0.3,0l-0.2,5.6l-5.4-0.2L252.1,159.5z	"
        >
          <title id="t977">Graham, KS</title>
        </path>
        <path
          id="FIPS_20179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.9,153.6l5.3,0.3l0.2,0l-0.3,5.7l-5.5-0.3L246.9,153.6z	"
        >
          <title id="t978">Sheridan, KS</title>
        </path>
        <path
          id="FIPS_20193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240,158.8l0.3-5.6l6.4,0.3l0.2,0l-0.3,5.6l-0.9,0l-2.8-0.1l-1.5-0.1L240,158.8z	"
        >
          <title id="t979">Thomas, KS</title>
        </path>
        <path
          id="FIPS_20153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.4,147.6l0.9,0l5.5,0.3l0.2,0l-0.3,5.6l-6.6-0.4L240.4,147.6z	"
        >
          <title id="t980">Rawlins, KS</title>
        </path>
        <path
          id="FIPS_20039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247,147.9l5.3,0.3l0.2,0l-0.3,5.6l-5.3-0.3l-0.2,0L247,147.9z	"
        >
          <title id="t981">Decatur, KS</title>
        </path>
        <path
          id="FIPS_20147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.3,148.6l1.1,0l-0.2,5.6l-5.3-0.2l-0.3,0l0.2-5.6L262.3,148.6z	"
        >
          <title id="t982">Phillips, KS</title>
        </path>
        <path
          id="FIPS_20137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.9,148.4L257.9,148.4l-0.2,5.6l-5.3-0.2l-0.2,0l0.3-5.6L257.9,148.4z	"
        >
          <title id="t983">Norton, KS</title>
        </path>
        <path
          id="FIPS_20183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.4,148.6l3.3,0.1l2.2,0.1l-0.2,5.6l-5.3-0.2l-0.2,0L263.4,148.6z	"
        >
          <title id="t984">Smith, KS</title>
        </path>
        <path
          id="FIPS_20089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.2,148.8l3.4,0.1l-0.1,4.5l0,1.1l-5.5-0.1l-0.2,0l0.2-5.6L271.2,148.8z	"
        >
          <title id="t985">Jewell, KS</title>
        </path>
        <path
          id="FIPS_20157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.6,148.9l4.4,0.1l-0.1,4.5l-5.5-0.1l0.1-4.5L275.6,148.9z	"
        >
          <title id="t986">Republic, KS</title>
        </path>
        <path
          id="FIPS_20201"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280,149l4.4,0.1l1.1,0l-0.1,5.7l-1.5,0l-4-0.1l0-1.1L280,149z	"
        >
          <title id="t987">Washington, KS</title>
        </path>
        <path
          id="FIPS_20117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.9,149.1l2.2,0l0,5.6l-3.4,0l-2.2,0l0.1-5.7L288.9,149.1z	"
        >
          <title id="t988">Marshall, KS</title>
        </path>
        <path
          id="FIPS_20131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.4,149.1h2.2v4.5l-2.4,1.1l-2,0l0-5.6L293.4,149.1z	"
        >
          <title id="t989">Nemaha, KS</title>
        </path>
        <path
          id="FIPS_21105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364,188.4l3.2-0.1l0.2,3.5l-0.1,0l-0.1,0l-0.8-0.9l-0.4-0.2l-2.4-0.6L364,188.4z	"
        >
          <title id="t990">Hickman, KY</title>
        </path>
        <path
          id="FIPS_21075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M363.5,190.1l2.4,0.6l0.4,0.2l0.8,0.9l-5.3,0.4l-0.7,0.1l0.8-1.8L363.5,190.1z M359.9,192.4
		l-0.2-0.3l0,0l-0.1-0.2l0,0l0-0.1l0,0l0,0l0-0.1l0,0l0,0l0.1-0.2l0.1,0l0.2,0l0.3,0l0.2,0l0,0l0,0l0,0l0.1,0.1l0,0l0.1,0.1l0,0.1v0
		l0,0v0.1l0,0l0,0.1l0,0l0,0l-0.1,0.2L359.9,192.4z	"
        >
          <title id="t991">Fulton, KY</title>
        </path>
        <path
          id="FIPS_21013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421,180.5l0.3,0.5l0.7,2.9l-2.1,1.1l-2.6,0.5l0.4-1.3l0.7-1.2l1-1l0.4-0.4l0.6-0.7l0.1-0.3
		l0-0.1l-0.2-0.2L421,180.5z	"
        >
          <title id="t992">Bell, KY</title>
        </path>
        <path
          id="FIPS_21121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M417.1,179.5l0.1,0l0.9,0.1l0.3,0.1l0.1,0.1l0.1,0.2l0,0.1l0.3,0.1l0.4,0.1l0.4,0.1h0.2
		l0.2,0.2l0,0.1l-0.1,0.3l-0.6,0.7l-0.4,0.4l-1,1l-0.7,1.2l-0.9-0.4l-1.3-1.5l-0.4-1.3L417.1,179.5z	"
        >
          <title id="t993">Knox, KY</title>
        </path>
        <path
          id="FIPS_21235"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.9,181.4l2.1-0.4l0.4,1.3l1.3,1.5l0.9,0.4l-0.4,1.3l-0.6,0.1l-2.4,0.3l-0.7-0.6l-0.3-0.4
		l-0.6-1.3l0-0.2L412.9,181.4z	"
        >
          <title id="t994">Whitley, KY</title>
        </path>
        <path
          id="FIPS_21125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414,176.4l2.1,0.6l-0.1,1l0.3,0.3l0.5,0.3l0.3,0.4l0.1,0.3l-2.1,1.6l-2.1,0.4l-0.6-0.1
		l0.4-2.6L414,176.4z	"
        >
          <title id="t995">Laurel, KY</title>
        </path>
        <path
          id="FIPS_21051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M417.5,175.6l0.8,0l1.5,0.8l0.4,0l0.2,0.3l0.5,3.8l-0.8-0.1h-0.2l-0.4-0.1l-0.4-0.1l-0.3-0.1
		l0-0.1l-0.1-0.2l-0.1-0.1l-0.3-0.1l-0.9-0.1l-0.1,0l-0.1-0.3l-0.3-0.4l-0.5-0.3l-0.3-0.3l0.1-1L417.5,175.6z	"
        >
          <title id="t996">Clay, KY</title>
        </path>
        <path
          id="FIPS_21131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M420.5,176.7l0.8-1l0.9,0.5l1.1,0.7l0.4,0.3l0.4,0.7l0.2,0.5l0,0.6l-2.9,2l-0.3-0.5
		L420.5,176.7z	"
        >
          <title id="t997">Leslie, KY</title>
        </path>
        <path
          id="FIPS_21095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.1,179l0.6,0.2l0.3,0.4l1.5-0.8l0.8,0.4l0,1l-0.2,0.4l-2,1.7l-2.1,1.2l-1,0.6l-0.7-2.9
		L424.1,179z	"
        >
          <title id="t998">Harlan, KY</title>
        </path>
        <path
          id="FIPS_21133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.2,175.2l0.5,0.4l0.3,0l0.3-0.2h0.1l0.3,0.2l0.4,0.4l-2.7,3.3l-0.8-0.4l-1.5,0.8l-0.3-0.4
		l0.1,0.1l0,0l0.5-0.4l0,0l0-0.1l0-0.6l-0.3-0.5l0-0.1l0.2-0.5l0.3-0.5l0.2,0.1l0.2,0l0.4-0.3l0.2-0.2l0.2-0.2l0.7-0.5L428.2,175.2z
			"
        >
          <title id="t999">Letcher, KY</title>
        </path>
        <path
          id="FIPS_21119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.9,172.7l1,0.1l0.7,0.4l0.1,0.1l0,0.4l0,0.4l0.2,0.5l0.1,0.1l0.2,0.1l0.2,0.1l-0.2,0.2
		l-0.7,0.2l-0.7,0.5l-0.2,0.2l-0.2,0.2l-0.4,0.3l-0.2,0l-0.2-0.1L424,174l1.6-1.5L425.9,172.7z	"
        >
          <title id="t1000">Knott, KY</title>
        </path>
        <path
          id="FIPS_21193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424,174l1.6,2.5l-0.3,0.5l-0.2,0.5l0,0.1l0.3,0.5l0,0.6l0,0.1l0,0l-0.5,0.4l0,0l-0.1-0.1
		l-0.6-0.2l0-0.6l-0.2-0.5l-0.4-0.7l-0.4-0.3l-1.1-0.7l-0.9-0.5l-0.8,1l-0.2-0.3l-0.3-1l1.2-0.4l2.2-1.1L424,174z	"
        >
          <title id="t1001">Perry, KY</title>
        </path>
        <path
          id="FIPS_21189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.3,173.3l0.6,2.2l0.3,1l-0.4,0l-1.5-0.8l-0.8,0l-1.3-2.1l0.2,0.2l0.2,0.1l0.2,0l0.8-0.2
		l0.6-0.3l0.1-0.2l0.5,0L419.3,173.3z	"
        >
          <title id="t1002">Owsley, KY</title>
        </path>
        <path
          id="FIPS_21109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414,173.2l1.9,0.1l0.2,0.3l1.3,2.1l-1.4,1.5l-2.1-0.6l-0.2-0.6l-0.3-0.7l-0.3-0.4l-0.2-0.3
		l0-0.3l0-0.1L414,173.2z	"
        >
          <title id="t1003">Jackson, KY</title>
        </path>
        <path
          id="FIPS_21065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.7,169.5l0.8,0.1l0.4,0.4l0.7,0.5l0.8,0.1l1.1,0.3l-1.6,2.5l-1.9-0.1L413.7,169.5z	"
        >
          <title id="t1004">Estill, KY</title>
        </path>
        <path
          id="FIPS_21129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M417.6,170.8l2,0.8l-0.3,1.8l-0.4-0.1l-0.5,0l-0.1,0.2l-0.6,0.3l-0.8,0.2l-0.2,0l-0.2-0.1
		l-0.2-0.2l-0.2-0.3l1.6-2.5L417.6,170.8z	"
        >
          <title id="t1005">Lee, KY</title>
        </path>
        <path
          id="FIPS_21025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.6,171.5l0.3,0.2l0.3-0.2l0.1-0.1l0.1-0.3l0-0.2l0-0.1l0-0.1l0.1-0.1l0.3-0.2l1.5,0.2
		l3.3,1.7L424,174l-0.8,0l-2.2,1.1l-1.2,0.4l-0.6-2.2L419.6,171.5z	"
        >
          <title id="t1006">Breathitt, KY</title>
        </path>
        <path
          id="FIPS_21071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.3,169.3l0.8,0.3l-0.3,0.1l-0.2,0.1l0,0.1l0.2,1.9l0.3,0.3l0.2,0.4l0,0.3l-0.2,0.8
		l-0.5,1.1l-0.2,0.2l-0.1,0.1l-0.2-0.1l-0.2-0.1l-0.1-0.1l-0.2-0.5l0-0.4l0-0.4l-0.1-0.1l-0.7-0.4l-1-0.1l-0.6-2.9l0.3,0l1.2-0.6
		l0.3-0.1l0.3,0L428.3,169.3L428.3,169.3z	"
        >
          <title id="t1007">Floyd, KY</title>
        </path>
        <path
          id="FIPS_21115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.3,167.2l0,2.1l0,0l-0.8-0.2l-0.3,0l-0.3,0.1l-1.2,0.6l-0.3,0l-0.9-1.7l0-1.4l0.1-0.3
		l0-0.1l0.2-0.1l0,0l1.2,0.3l1,0.5l0.6,0.2L428.3,167.2z	"
        >
          <title id="t1008">Johnson, KY</title>
        </path>
        <path
          id="FIPS_21153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.4,168l0.9,1.7l0.6,2.9l-0.3-0.2l-3.3-1.7l-0.2-0.5l-0.2-0.7l1.2-1.8l0,0h0.4l0.5,0.1
		L424.4,168z	"
        >
          <title id="t1009">Magoffin, KY</title>
        </path>
        <path
          id="FIPS_21237"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.5,168.6l0.1,0.2l0.6,0.3l1.1,0.4l0.8,0.8l0.2,0.5l-1.5-0.2l-0.3,0.2l-0.1,0.1l0,0.1
		l0,0.1l0,0.2l-0.1,0.3l-0.1,0.1l-0.3,0.2l-0.3-0.2l-2-0.8l0.6-1.5L419.5,168.6z	"
        >
          <title id="t1010">Wolfe, KY</title>
        </path>
        <path
          id="FIPS_21197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.7,168.3l2-0.1l1.5,1l-0.6,1.5l-0.1,0l-1.1-0.3l-0.8-0.1l-0.7-0.5l-0.4-0.4L414.7,168.3z	
		"
        >
          <title id="t1011">Powell, KY</title>
        </path>

        <path
          id="FIPS_21173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.1,165l0.5,0.5l0.5,0.1l0.1,0.1l0.6,0.5l0.7,0.8l0.1,0.2l0,1.1l-2,0.1l-1.4-2.2L414.1,165
		z	"
        >
          <title id="t1013">Montgomery, KY</title>
        </path>
        <path
          id="FIPS_21165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.2,166.2l0.7,0.1l-0.3,2.3l-1.3,0.6l-1.5-1l0-1.1L419.2,166.2z	"
        >
          <title id="t1014">Menifee, KY</title>
        </path>
        <path
          id="FIPS_21175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424,166.1l0.4,0.5l0,1.4l-0.4-0.2l-0.5-0.1h-0.4l0,0l-1.2,1.8l0.2,0.7l-0.8-0.8l-1.1-0.4
		l-0.6-0.3l-0.1-0.2l0.3-2.3l1.6-1.3L424,166.1z	"
        >
          <title id="t1015">Morgan, KY</title>
        </path>
        <path
          id="FIPS_21063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.7,163.8l-0.7,2.3l-2.6-1.1l0.1-1l0.5-1.1l0.2,0.1l0.8,0.4l0.4,0.3l0.8,0.2l0.3,0
		L424.7,163.8z	"
        >
          <title id="t1016">Elliott, KY</title>
        </path>
        <path
          id="FIPS_21205"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M420.3,162.5l1.2,1.5l-0.1,1l-1.6,1.3l-0.7-0.1l-1.6-1.6l0.5-0.4l0.2-0.2l0.4-0.7l-0.1-0.2
		l0.1-0.6l0.4-0.7L420.3,162.5z	"
        >
          <title id="t1017">Rowan, KY</title>
        </path>
        <path
          id="FIPS_21011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M415.3,163.5L415.3,163.5l0.1-0.1l1,0l0.1,0.1l0.2,0.2l0.3,0.6l0.4,0.5l0.1-0.1l0-0.1l1.6,1.6
		l-2.5,1l-0.1-0.2l-0.7-0.8l-0.6-0.5l-0.1-0.1l-0.5-0.1l-0.5-0.5L415.3,163.5z	"
        >
          <title id="t1018">Bath, KY</title>
        </path>
        <path
          id="FIPS_21181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.7,161.8l1.5,1.7l-1.1,1.5l-2.4-2l0.8-1.2L413.7,161.8z	"
        >
          <title id="t1019">Nicholas, KY</title>
        </path>
        <path
          id="FIPS_21069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.9,160.2l2.1,1.6l-0.4,0.7l-0.1,0.6l0.1,0.2l-0.4,0.7l-0.2,0.2l-0.5,0.4l0,0.1l-0.1,0.1
		l-0.4-0.5l-0.3-0.6l-0.2-0.2l-0.1-0.1l-1,0l0,0l-0.1,0.1l-1.5-1.7l0.4-0.7l0.8,0.4l1.3-0.8L416.9,160.2z	"
        >
          <title id="t1020">Fleming, KY</title>
        </path>
        <path
          id="FIPS_21201"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.4,159.8l0.8,1.2l-0.4,0.7l-1.3-0.1l-0.7-1.1L413.4,159.8z	"
        >
          <title id="t1021">Robertson, KY</title>
        </path>

        <path
          id="FIPS_21161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.7,158.8l0.2,1.4l-0.8,0.4l-1.3,0.8l-0.8-0.4l-0.8-1.2l0.6-2.4l0.3,0l0.1,0l0.1,0.1
		l0.9,0.9l0.8,0.4L416.7,158.8z	"
        >
          <title id="t1023">Mason, KY</title>
        </path>
        <path
          id="FIPS_21135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M422.6,156.9l-1,3l-0.5,1.6l0.1,0.5l0,0.1l-0.4,0.2l-0.6,0.1l-1.2-0.7l-2.1-1.6l-0.2-1.4
		l0.1-0.5l0.1-0.1l0.1-0.1l0.8-0.3l0.1,0l0.1,0h0l0.4,0.1l1.1,0.3l0,0l0.3,0.2l0,0l0.6,0.4L422.6,156.9z	"
        >
          <title id="t1024">Lewis, KY</title>
        </path>
        <path
          id="FIPS_21019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.5,160.2l0.2,2.3l-1.9,0.3l-0.5-1.6l1.3-1.9L427.5,160.2z	"
        >
          <title id="t1025">Boyd, KY</title>
        </path>
        <path
          id="FIPS_21089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425,158.6l1.6,0.6l-1.3,1.9l-1-0.2l-1.5-0.7l-0.4-0.1l-0.8-0.2l1-3v0l0.2-0.1l0.8-0.4
		l0.3-0.1l0,0h0.1l0.1,0l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1v0l0,0l0,0.2l0.1,0.4l0.3,0.8l0,0.1l0.1,0.1l0.1,0.1l0,0L425,158.6
		L425,158.6z	"
        >
          <title id="t1026">Greenup, KY</title>
        </path>
        <path
          id="FIPS_21043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.7,159.9l0.8,0.2l0.4,0.1l1.5,0.7l1,0.2l0.5,1.6l-1.2,1.1l-0.2,0.1l-0.3,0l-0.8-0.2
		l-0.4-0.3l-0.8-0.4L422,163l-0.5,1.1l-1.2-1.5l0.6-0.1l0.4-0.2l0-0.1l-0.1-0.5L421.7,159.9z	"
        >
          <title id="t1027">Carter, KY</title>
        </path>
        <path
          id="FIPS_21127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.9,162.7l1.9-0.3l-0.3,1.1v0l0,0.1l0.1,0.2v0l0.2,0.2l0.2,0l0,0l1.6,1.5l0,0l0,0v0.1
		l-0.3,0.5l-1,1l-0.7-0.1l-0.6-0.2l-1-0.5l-1.2-0.3l0,0l-0.2,0.1l0,0.1l-0.1,0.3l-0.4-0.5l0.7-2.3L425.9,162.7z	"
        >
          <title id="t1028">Lawrence, KY</title>
        </path>
        <path
          id="FIPS_21159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.4,167.1l1,1.4l-2.3,1.1l-0.8-0.3l0-2.1l1-1L430.4,167.1z	"
        >
          <title id="t1029">Martin, KY</title>
        </path>
        <path
          id="FIPS_21195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.2,169.6l2.3-1.1l0,0l0,0.1l0.4,0.6l2.1,1.4h0l0.7,0.3l0.4-0.1l0.4-0.1l-3,3.6l-0.4,0.5
		l-1.5,0.9l-0.4,0.3l-0.1,0.1l-0.4-0.4l-0.3-0.2h-0.1l-0.3,0.2l-0.3,0l-0.5-0.4l0.2-0.2l0.1-0.1l0.2-0.2l0.5-1.1l0.2-0.8l0-0.3
		l-0.2-0.4l-0.3-0.3l-0.2-1.9l0-0.1l0.2-0.1L429.2,169.6z	"
        >
          <title id="t1030">Pike, KY</title>
        </path>
        <path
          id="FIPS_21097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.7,160.5l0.7,1.1l-0.8,1.2l-2.3,1.4l-1.5-2.6l0.7-0.7l2.6-0.8L411.7,160.5z	"
        >
          <title id="t1031">Harrison, KY</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "30460"
              ? `metroArea clickedArea state-ky`
              : `metroArea ${colorCode[30460]} state-ky`
          }
          id="FIPS_30460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_21017"
            className="FIPS_30460 st0 state-ky"
            d="M409.4,164.4l2.3-1.4l2.4,2l-0.9,1.1l-2,0.9l-1.4-1.7L409.4,164.4z	"
          >
            <title id="t1032">Bourbon, KY</title>
          </path>
          <path
            id="FIPS_21049"
            className="FIPS_30460 st0 state-ky"
            d="M413.2,166.1l1.4,2.2l-0.2,1.2l-0.8-0.1l-2.6-0.2l0.2-2.3L413.2,166.1z	"
          >
            <title id="t1012">Clark, KY</title>
          </path>
          <path
            id="FIPS_21113"
            className="FIPS_30460 st0 state-ky"
            d="M407.6,168.2l2.5,1.7l-0.8,1.1l-0.4,0.6l0,0l-0.2-0.1l-0.3-0.4l0-0.3l-0.7-0.4l-0.1,0.1
		l-0.2,0.2l0-0.6L407.6,168.2z	"
          >
            <title id="t1038">Jessamine, KY</title>
          </path>
          <path
            id="FIPS_21067"
            className="FIPS_30460 st0 state-ky"
            d="M409.9,165.3l1.4,1.7l-0.2,2.3l-0.9,0.7l-2.5-1.7l0.2-1.5L409.9,165.3z	"
          >
            <title id="t1039">Fayette, KY</title>
          </path>
          <path
            id="FIPS_21239"
            className="FIPS_30460 st0 state-ky"
            d="M406.7,165.9l1.1,0.9l-0.2,1.5l-0.3,1.9l-1-1.3l-0.9-1.8L406.7,165.9z	"
          >
            <title id="t1040">Woodford, KY</title>
          </path>
          <path
            id="FIPS_21209"
            className="FIPS_30460 st0 state-ky"
            d="M407.9,161.8l1.5,2.6l0.5,0.9l-2.1,1.4l-1.1-0.9l-0.4-2l1.4-1.7L407.9,161.8z	"
          >
            <title id="t1041">Scott, KY</title>
          </path>
        </g>
        <path
          id="FIPS_21151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411,169.3l2.6,0.2l0.4,3.7l-1,0.7l-1.5,0l-2.2-2.8l0.8-1.1L411,169.3z	"
        >
          <title id="t1033">Madison, KY</title>
        </path>
        <path
          id="FIPS_21203"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413,173.9l0,0.1l0,0.3l0.2,0.3l0.3,0.4l0.3,0.7l0.2,0.6l-1.3,2.4l-2.4-2l0.3-2.1l0.9-0.8
		L413,173.9z	"
        >
          <title id="t1034">Rockcastle, KY</title>
        </path>
        <path
          id="FIPS_21147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.3,181.4l0.6,0.1l-0.3,2l0,0.2l0.6,1.3l0.3,0.4l0.7,0.6l-0.4,0l-5.3,0.5l0.8-1.8l0.6-1
		l0.2-0.8L412.3,181.4z	"
        >
          <title id="t1035">McCreary, KY</title>
        </path>
        <path
          id="FIPS_21137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.2,173l2.4,1.7l-0.3,2.1l-2.1,1.4l0-0.8l-0.3-0.8l-0.8-0.3l-0.6-0.4l-0.2-0.5l0-1.1
		L408.2,173z	"
        >
          <title id="t1036">Lincoln, KY</title>
        </path>
        <path
          id="FIPS_21079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M407.4,170.8l0.2-0.2l0.1-0.1l0.7,0.4l0,0.3l0.3,0.4l0.2,0.1l0,0l0.4-0.6l2.2,2.8l-0.9,0.8
		l-2.4-1.7l-1-0.9L407.4,170.8z	"
        >
          <title id="t1037">Garrard, KY</title>
        </path>

        <path
          id="FIPS_21073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405,163.9l1.3-0.1l0.4,2l-1.3,1.2l-1.6,0l0-2.7L405,163.9z	"
        >
          <title id="t1042">Franklin, KY</title>
        </path>
        <path
          id="FIPS_21005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.8,167.1l1.6,0l0.9,1.8l-0.8,0.5l-1.2,0.8l-0.1,0.1l-0.1,0l0,0l-1.2,0.1l-0.3-0.9l0.6-0.9
		L403.8,167.1z	"
        >
          <title id="t1043">Anderson, KY</title>
        </path>
        <path
          id="FIPS_21167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.3,168.8l1,1.3l0,0.6l-0.1,1.4l-2.8,0.8l-0.4-2.7l0,0l0.1,0l0.1-0.1l1.2-0.8L406.3,168.8z
			"
        >
          <title id="t1044">Mercer, KY</title>
        </path>
        <path
          id="FIPS_21021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M407.2,172.1l1,0.9l-1.8,1.3l-1.9,0.3l0-1.1l0-0.6L407.2,172.1z	"
        >
          <title id="t1045">Boyle, KY</title>
        </path>
        <path
          id="FIPS_21045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.5,174.6l1.9-0.3l0,1.1l0.2,0.5l0.6,0.4l0.8,0.3l0.3,0.8l0,0.8l-1.6,1.8l-1.5-0.7
		l-1.4-1.5l0.8-1.4L404.5,174.6z	"
        >
          <title id="t1046">Casey, KY</title>
        </path>
        <path
          id="FIPS_21199"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.2,178.2l2.1-1.4l2.4,2l-0.4,2.6l-2.1,1.5l-2.8-1.4l-0.8-1.5L408.2,178.2z	"
        >
          <title id="t1047">Pulaski, KY</title>
        </path>
        <path
          id="FIPS_21231"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.2,182.8l-0.2,0.8l-0.6,1l-0.8,1.8l-0.1,0l-1.9,0.1l-0.2,0l-0.1-0.1l0-0.1l-0.3-0.8l0-0.1
		l0-0.2l0-0.2l-0.4-1.1l-0.3-0.5l2.1-2.1L410.2,182.8z	"
        >
          <title id="t1048">Wayne, KY</title>
        </path>
        <path
          id="FIPS_21207"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405,179.3l1.5,0.7l0.8,1.5l-2.1,2.1l-0.5,0.5l-0.8-0.5l-0.4-0.2l-0.1,0l0,0.1l0.2,0.3
		l-0.1,0.1l-0.1,0l-0.1,0l-0.4-0.5l0.4-0.4l0.2-1l0.3-0.5l0.6-1.3L405,179.3z	"
        >
          <title id="t1049">Russell, KY</title>
        </path>
        <path
          id="FIPS_21053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.8,183.7l-0.2-0.3l0-0.1l0.1,0l0.4,0.2l0.8,0.5l0.5-0.5l0.3,0.5l0.4,1.1l0,0.2l0,0.2
		l0,0.1l0.3,0.8l0,0.1l0.1,0.1l0.2,0l-3.2,0.2l-0.2,0L403.8,183.7z	"
        >
          <title id="t1050">Clinton, KY</title>
        </path>
        <path
          id="FIPS_21057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.5,182.9l-0.4,0.4l0.4,0.5l0.1,0l0.1,0l0.1-0.1l-0.5,3.1l-1.4,0.3l-1.9-2.4l1.3-1.7
		L403.5,182.9z	"
        >
          <title id="t1051">Cumberland, KY</title>
        </path>
        <path
          id="FIPS_21001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.6,177.8l1.4,1.5l-0.4,0.8l-0.6,1.3l-0.3,0.5l-0.2,1l-2.3,0.1l-1-2.1l1.6-1.3L403.6,177.8
		z	"
        >
          <title id="t1052">Adair, KY</title>
        </path>
        <path
          id="FIPS_21217"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.3,176.1L400.3,176.1l0.2-0.1l0.9-0.1l2.3,0l0.6,0.4l-0.8,1.4l-1.7,1.7l-0.9-1.3l-0.6-0.7
		l-1.2-0.8l0-0.1l0-0.4L400.3,176.1z	"
        >
          <title id="t1053">Taylor, KY</title>
        </path>
        <path
          id="FIPS_21155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.6,172.6l0.4,0.5l0.4,0.4l0.8,0.2l2.3-0.3l0,1.1l-0.1,1.7l-0.6-0.4l-2.3,0l-0.9,0.1
		l-0.2,0.1l0,0l-0.7-1.1L400.6,172.6z	"
        >
          <title id="t1054">Marion, KY</title>
        </path>
        <path
          id="FIPS_21229"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.1,170.1l0.4,2.7l0,0.6l-2.3,0.3l-0.8-0.2l-0.4-0.4l-0.4-0.5l2.3-2.4L404.1,170.1z	"
        >
          <title id="t1055">Washington, KY</title>
        </path>

        <path
          id="FIPS_21187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.9,160.1l1.4-0.9l0.3,1.3l1.7,1.5l0.2,0.1l0.3,0.1l-1.4,1.7l-1.3,0.1l-2.4-2.9
		L403.9,160.1z	"
        >
          <title id="t1059">Owen, KY</title>
        </path>

        <path
          id="FIPS_21041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.2,160l1.6-1.1l1.1,1.2l-1.3,1l-0.9,0.3l-1.9-1.8L401.2,160z	"
        >
          <title id="t1066">Carroll, KY</title>
        </path>

        <path
          id="FIPS_21123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.8,172.9l0.1,0l0.7,0.3l0.1,0.1l0.2,0.9l-0.2,0.2l0,0.2l0,0.4l0,0.2l0.5,0.2l0,0l0.3-0.4
		l0.7,1.1l-1.2,0.1l-0.7,0.7l-2.4,0l0-1.4l0.7-0.9l0.4-0.5L397.8,172.9z	"
        >
          <title id="t1072">Larue, KY</title>
        </path>
        <path
          id="FIPS_21087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.5,176.9l0.7-0.7l0,0.4l0,0.1l1.2,0.8l0.6,0.7l0.9,1.3l-1.6,1.3l-1.7-0.8L398.5,176.9z	"
        >
          <title id="t1073">Green, KY</title>
        </path>
        <path
          id="FIPS_21169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.5,180l1.7,0.8l1,2.1l-1.3,1.7l-1.5-0.1l-0.3-2.1l-0.2-0.8l-0.2-0.5l-0.1-0.4l0.3-0.4
		L398.5,180z	"
        >
          <title id="t1074">Metcalfe, KY</title>
        </path>
        <path
          id="FIPS_21171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.4,184.5l1.5,0.1l1.9,2.4l-3.6,0.3l-1.9,0.1l-0.1-1.2L398.4,184.5z	"
        >
          <title id="t1075">Monroe, KY</title>
        </path>
        <path
          id="FIPS_21213"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.5,184.9l0.4,0.7l1.9,0.1l0,0.4l0.1,1.6l-1.5,0.4h-2.1L389.5,184.9z	"
        >
          <title id="t1076">Simpson, KY</title>
        </path>
        <path
          id="FIPS_21003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M394,183.8l2.2,2.5l0.1,1.2l-2.3,0.1l-2.1,0.1l-0.1-1.6l1-1.1l0.3-0.5l0.6-0.7L394,183.8z	"
        >
          <title id="t1077">Allen, KY</title>
        </path>
        <path
          id="FIPS_21009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.9,180.3l-0.3,0.4l0.1,0.4l0.2,0.5l0.2,0.8l0.3,2.1l-2.3,1.8l-2.2-2.5l0.4-1.7l0.4-1.4
		L397.9,180.3z	"
        >
          <title id="t1078">Barren, KY</title>
        </path>
        <path
          id="FIPS_21099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M396,176.9l2.4,0l0,3.1l-0.6,0.2l-3.2,0.4l-1.3-2.1l1-1.6L396,176.9z	"
        >
          <title id="t1079">Hart, KY</title>
        </path>
        <path
          id="FIPS_21093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M394.7,169.7l0.1,0.1l2.3,2.2l0.7,1l-0.6,1.2l-0.4,0.5l-0.7,0.9l0,1.4l-1.6,0l-0.2-0.6
		l-0.6-0.8l-0.2,0l-0.2,0.1l-0.3,0.1l-1-0.4l1-2.8l1.4-0.4l0.2-0.8l-0.4-1.6L394.7,169.7z	"
        >
          <title id="t1080">Hardin, KY</title>
        </path>

        <path
          id="FIPS_21091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.5,171.7l1.6-1l1.8,1.9l-0.1,0.1l-0.1,0.6l0.7,1.7l-0.2-0.1l-2-0.8l0-0.7l-0.4-0.6
		l-0.6-0.6l-0.8,0L384.5,171.7z	"
        >
          <title id="t1082">Hancock, KY</title>
        </path>
        <path
          id="FIPS_21027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387.8,172.5L387.8,172.5l0.2,0l0.3-0.2l0.7-1.5l-0.1-0.8l0-0.1l0-0.1l0.1,0l0.2,0l3.7,2.8
		l-1,2.8l-0.1,0.1l-0.8,0.5l-1-0.4l0-0.1l-0.1-0.1l-0.3-0.1l0,0l-0.2,0.1l-0.2,0.2l-0.3,0.5l-0.6-1.2l0.2,0.1l-0.7-1.7l0.1-0.6
		L387.8,172.5z	"
        >
          <title id="t1083">Breckinridge, KY</title>
        </path>
        <path
          id="FIPS_21085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M388.8,176.1l0.3-0.5l0.2-0.2l0.2-0.1l0,0l0.3,0.1l0.1,0.1l0,0.1l1,0.4l0.8-0.5l0.1-0.1l1,0.4
		l0.3-0.1l0.2-0.1l0.2,0l0.6,0.8l0.2,0.6l-1,1.6l-3.1,0.5l-1.5-0.8L388.8,176.1z	"
        >
          <title id="t1084">Grayson, KY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14540"
              ? `metroArea clickedArea state-ky`
              : `metroArea ${colorCode[14540]} state-ky`
          }
          id="FIPS_14540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_21061"
            className="FIPS_14540 st0 state-ky"
            d="M390.4,179.1l3.1-0.5l1.3,2.1l-0.4,1.4l-3-1.1L390.4,179.1z	"
          >
            <title id="t1085">Edmonson, KY</title>
          </path>
          <path
            id="FIPS_21227"
            className="FIPS_14540 st0 state-ky"
            d="M391.3,181l3,1.1l-0.4,1.7l-0.3,0.1l-0.6,0.7l-0.3,0.5l-1,1.1l0-0.4l-1.9-0.1l-0.4-0.7
		l-0.8-1.4l0.4-2.2l1.5,0L391.3,181z	"
          >
            <title id="t1086">Warren, KY</title>
          </path>
        </g>
        <path
          id="FIPS_21031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M388.8,178.3l1.5,0.8l0.9,1.9l-0.7,0.2l-1.5,0l-0.4,2.2l-2.8-0.6l0.2-1.9l0.8-1.1l0.6-0.3
		L388.8,178.3z	"
        >
          <title id="t1087">Butler, KY</title>
        </path>
        <path
          id="FIPS_21141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.9,182.8l2.8,0.6l0.8,1.4l-1.3,3.2l-3,0.4l-0.4-5.4L385.9,182.8z	"
        >
          <title id="t1088">Logan, KY</title>
        </path>
        <path
          id="FIPS_21219"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.7,183.1l2.1-0.1l0.4,5.4l-0.6,0.1l-2.3,0.2L382.7,183.1z	"
        >
          <title id="t1089">Todd, KY</title>
        </path>
        <path
          id="FIPS_21177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.9,178.5l2.3,2.4l-0.2,1.9l-1.1,0.2l-2.1,0.1l-0.9-1l0.2-0.4l-0.7-0.8l-0.1-0.7l0.7-1.2
		L383.9,178.5z	"
        >
          <title id="t1090">Muhlenberg, KY</title>
        </path>
        <path
          id="FIPS_21183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.3,174l2,0.8l0.6,1.2l0,2.2l-1.3,1.2l-0.6,0.3l-0.8,1.1l-2.3-2.4l0.4-1.9l1-0.9l0.6-1.2
		L386.3,174z	"
        >
          <title id="t1091">Ohio, KY</title>
        </path>
        <path
          id="FIPS_21059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M381.2,172.4l0.4,0.3l1.5,1l0.8-1.4l0.6-0.6l0,0.4l0.8,0l0.6,0.6l0.4,0.6l0,0.7l-0.4,0.4
		l-0.6,1.2l-1,0.9l-3.9-1.2L381.2,172.4z	"
        >
          <title id="t1092">Daviess, KY</title>
        </path>
        <path
          id="FIPS_21149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.4,175.3l3.9,1.2l-0.4,1.9l-2,0.5l-1-2.2l-1.3-0.9L380.4,175.3z	"
        >
          <title id="t1093">McLean, KY</title>
        </path>
        <path
          id="FIPS_21107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.9,176.7l1,2.2l-0.7,1.2l0.1,0.7l0.7,0.8l-0.2,0.4l-0.7,0.4l-1.2,0.5l-1.7-0.4l-1.6-2.5
		l1.8-1.4l1.2-0.7L380.9,176.7z	"
        >
          <title id="t1094">Hopkins, KY</title>
        </path>
        <path
          id="FIPS_21047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M381.8,182.1l0.9,1l-0.3,5.6l-3.1,0.3l-0.5,0.1l0-1.1l-0.1-3.2l-0.8-0.4l0.4-2l1.7,0.4
		l1.2-0.5L381.8,182.1z	"
        >
          <title id="t1095">Christian, KY</title>
        </path>
        <path
          id="FIPS_21221"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M377.9,184.4l0.8,0.4l0.1,3.2l0,1.1l-1.6,0.2l0-0.4l-1.7,0l-0.6,0l-0.5-0.9l-0.6-1.5l2.8-1.4
		L377.9,184.4z	"
        >
          <title id="t1096">Trigg, KY</title>
        </path>
        <path
          id="FIPS_21143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.1,182.9l1-0.5l0.6,0l0.8,1.3l1.1,1.3l-2.8,1.4l-1-1.4L373.1,182.9z	"
        >
          <title id="t1097">Lyon, KY</title>
        </path>
        <path
          id="FIPS_21033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.7,180l1.6,2.5l-0.4,2l-1.4,0.7l-1.1-1.3l-0.8-1.3l-0.6,0l2.8-2.8L376.7,180z	"
        >
          <title id="t1098">Caldwell, KY</title>
        </path>
        <path
          id="FIPS_21233"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M379.6,175.8l1.3,0.9l-1.1,1.2l-1.2,0.7l-1.8,1.4l0.1-0.4l-1.4-1.2l1.8-2.2L379.6,175.8z	"
        >
          <title id="t1099">Webster, KY</title>
        </path>
        <path
          id="FIPS_21101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M379.7,172l1.5,0.4l-0.8,2.9l-0.8,0.5l-2.4,0.3l-2.2-3.2l2.3-0.2L379.7,172z	"
        >
          <title id="t1100">Henderson, KY</title>
        </path>
        <path
          id="FIPS_21225"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374,174.3l0.9-1.4l2.2,3.2l-1.8,2.2l-1.3-0.2l-0.8-0.8l-0.1-0.1l-0.2-0.6l0,0l-0.1-0.3l0,0
		l0-0.1l0.1-0.1l0,0l0.1-0.1l0.2-0.3l0,0l0.5-0.3l0.1-0.1l0.1-0.1l0-0.1L374,174.3z	"
        >
          <title id="t1101">Union, KY</title>
        </path>
        <path
          id="FIPS_21055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.4,178.4l1.4,1.2l-2.8,2.8l-1,0.5l-2-3.2l0.3-0.3l0.2-0.2l0,0l0,0l0.2-0.1l0,0l0.1,0
		l0.2,0l0.2,0l1.4-0.3l0.1,0l0.2-0.2v-0.2L375.4,178.4z	"
        >
          <title id="t1102">Crittenden, KY</title>
        </path>
        <path
          id="FIPS_21139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M371.1,179.7l2,3.2l-0.3,2.2l-2.5-0.3l-0.9-0.6l0.7,0.1l0.1,0l0.2-0.1l0.1-0.3l0.1-0.7
		l-0.3-0.6l-0.1-0.1l-0.1-0.1l-0.4-0.5l-0.1-0.3l0-0.1v0l0.3-1.3l0.1-0.1l0.1-0.2l0.1-0.1l0.1-0.1l0.2-0.1l0.1,0L371.1,179.7z	"
        >
          <title id="t1103">Livingston, KY</title>
        </path>
        <path
          id="FIPS_21035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.5,188.3l3.8-0.3l0.5,0.9l0.4,2.3l-4.5,0.3L370.5,188.3z	"
        >
          <title id="t1104">Calloway, KY</title>
        </path>
        <path
          id="FIPS_21157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.3,184.8l2.5,0.3l1,1.4l0.6,1.5l-3.8,0.3l-0.2-2.5L370.3,184.8z	"
        >
          <title id="t1105">Marshall, KY</title>
        </path>
        <path
          id="FIPS_21083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.3,185.8l0.2,2.5l0.2,3.2l-0.3,0l-3.1,0.2l-0.2-3.5L367,186L370.3,185.8z	"
        >
          <title id="t1106">Graves, KY</title>
        </path>
        <path
          id="FIPS_21145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.5,182.5l3.9,1.6l0.9,0.6l0.1,1L367,186l0-0.1L365.5,182.5L365.5,182.5z	"
        >
          <title id="t1107">McCracken, KY</title>
        </path>
        <path
          id="FIPS_21039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367,186l0.2,2.2l-3.2,0.1l-0.6-0.3l0,0v-0.3l0,0l0.3-0.2l0,0l0.4-1.3L367,186L367,186z	"
        >
          <title id="t1108">Carlisle, KY</title>
        </path>
        <path
          id="FIPS_21007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.5,182.5l1.5,3.4l-2.9,0.3l-0.4-0.5l-0.5-1.1L365.5,182.5z	"
        >
          <title id="t1109">Ballard, KY</title>
        </path>

        <path
          id="FIPS_22117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.5,263.6l1.2-0.1l0,0.4l-0.1,0.7l-0.1,0.2l-0.1,0l-0.1,0l0,0l-0.1,0.6l-0.2,0.8l-0.1,0.7
		l-0.1,0.9l-4.6-0.3l0-0.2l-0.8-1.9l-0.3-0.3l-0.1-1.2l1-0.1L361.5,263.6z	"
        >
          <title id="t1111">Washington, LA</title>
        </path>
        <path
          id="FIPS_22081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M321,249.5l0.5,0l2.6,1.1l0.1,0.1l0.3,0.4l0.2,0.6l0,0.1l-0.1,0.7l-1,1.2l-0.5,0.2h-0.4
		l-0.3-0.1l-0.1-0.4l-1-0.7l-0.1-0.1l-0.7-1.1l-0.4-1.4l-0.7-0.5L321,249.5z	"
        >
          <title id="t1112">Red River, LA</title>
        </path>
        <path
          id="FIPS_22013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M327.3,244.8l1.2,1.7l-0.3,4l-1.3,0l-2.7,0.1l-2.6-1.1l0.5-2.3l1.5,0l1-0.6l0-0.3l-0.4-1.3
		L327.3,244.8z	"
        >
          <title id="t1113">Bienville, LA</title>
        </path>
        <path
          id="FIPS_22061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.9,242.5l0.9,0l0.5,0.1l0.4,0.1l1.7,0.9l0,1.1l0,1.1l-2.2,0.1l0,0.6l-1.7,0.1l-1.2-1.7
		L328.9,242.5z	"
        >
          <title id="t1114">Lincoln, LA</title>
        </path>
        <path
          id="FIPS_22049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.4,246.5l1.7-0.1l0-0.6l2.2-0.1l0,1l0.1,0.2l1.1,1l0,0.6l0.1,1.7l-5.5,0.2L328.4,246.5z	"
        >
          <title id="t1115">Jackson, LA</title>
        </path>
        <path
          id="FIPS_22127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.2,250.5l5.5-0.2l0.1,2.8l-0.5,1.7l-2.8,0.1l0,0.6l0,0.5l-3.8,0.1l0.7-2.1l0.2-0.9l0-0.2
		l-0.1-1l-0.2-0.8l-0.4-0.7L328.2,250.5z	"
        >
          <title id="t1116">Winn, LA</title>
        </path>
        <path
          id="FIPS_22021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.6,248.6l3-0.1l1.6,1.6l0.2,0.3l0.1,0.1l0,0.3l-0.6,0.4l0.3,0.9l0.1,0.3l-1.2,0.6
		l-3.3,0.1l-0.1-2.8L333.6,248.6z	"
        >
          <title id="t1117">Caldwell, LA</title>
        </path>
        <path
          id="FIPS_22073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336,242.7l1.8,2.7l-1.2,3l-3,0.1l0-0.6l-1.1-1l-0.1-0.2l0-1l0-1.1l1.7-0.1l0.3-0.1l0.1-0.1
		l1.4-1.4L336,242.7z	"
        >
          <title id="t1118">Ouachita, LA</title>
        </path>
        <path
          id="FIPS_22083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.8,244.2l-0.1,0.6l-0.1,1.7l-1.7,0.1l-0.4,0.2l-0.9,1.1l-0.5,1.1l-0.9,0.9l-1.6-1.6l1.2-3
		l0.4-0.4l0.8-0.5l0.7-0.2l0.7-0.3l0.1-0.1l0.1-0.3l0.1-0.3l0-0.1l0.5,0.1l0.5,0.9L342.8,244.2z	"
        >
          <title id="t1119">Richland, LA</title>
        </path>
        <path
          id="FIPS_22041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.5,249.2l-0.7,4.2l-0.3-0.7l-0.5-0.3l0,0.1l-0.2,0.3l-0.4,0.4l-0.3,0.2l-0.5,0.1l-0.2-0.2
		l-0.3-0.4l-0.4-0.4l-0.3-0.2l-0.2,0l-0.1-0.3l-0.3-0.9l0.6-0.4l0-0.3l-0.1-0.1l-0.2-0.3l0.9-0.9l0.5-1.1l0.9-1.1l0.4-0.2l1.7-0.1
		L342.5,249.2z	"
        >
          <title id="t1120">Franklin, LA</title>
        </path>
        <path
          id="FIPS_22107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.5,249.2l1.9-0.1l0.1-0.1l0.2-0.1l1.2-0.4l0.5-0.1h0.1l0.1,0.1l0,0.3v0l1.1,1.3l-2.2,3.3
		l-1.2,1.6l-0.1,0.2l-1.8-0.2l-0.4-1.7L342.5,249.2z	"
        >
          <title id="t1121">Tensas, LA</title>
        </path>
        <path
          id="FIPS_22065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.6,244.3l-0.2,0.8l0,0.2v0l0,0l0,0.1l0,0l1.2,1.3l0.1,1.9l-1.3,0.2v0l0-0.3l-0.1-0.1h-0.1
		l-0.5,0.1l-1.2,0.4l-0.2,0.1l-0.1,0.1l-1.9,0.1l0-2.6l0.1-1.7L346.6,244.3z	"
        >
          <title id="t1122">Madison, LA</title>
        </path>
        <path
          id="FIPS_22035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345.5,238.6l-0.4,0.6l-0.1,0.4l0,0.1l0.9,3.9l0.1,0.2l0,0l0,0l0,0l0,0l0.1,0.1l0,0l0.3,0.1
		l0.1,0.2l-4,0.5l0.1-0.6l0.3-0.3l0.1-0.3l0.3-1.2l0.2-1.4l0-0.4l0.4-1.2l0.3-0.8L345.5,238.6z	"
        >
          <title id="t1123">East Carroll, LA</title>
        </path>
        <path
          id="FIPS_22123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.5,238.7l-0.3,0.8l-0.4,1.2l0,0.4l-0.2,1.4l-0.3,1.2l-0.1,0.3l-0.3,0.3l-1.2,0l-0.5-0.9
		l-0.5-0.1l0.4-1.1l1.5-3.1l0.1-0.3L344.5,238.7z	"
        >
          <title id="t1124">West Carroll, LA</title>
        </path>
        <path
          id="FIPS_22067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.4,238.8l0.3,0l-0.1,0.3l-1.5,3.1l-0.4,1.1l0,0.1l-0.1,0.3l-0.1,0.3l-0.1,0.1l-0.7,0.3
		l-0.7,0.2l-0.8,0.5l-0.4,0.4l-1.8-2.7l0,0l0.1-0.2l0-0.7l-0.4-1.1l0.1-1.7L342.4,238.8z	"
        >
          <title id="t1125">Morehouse, LA</title>
        </path>
        <path
          id="FIPS_22111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335.8,239l-0.1,1.7l0.4,1.1l0,0.7l-0.1,0.2l0,0l-0.2,0.4l-1.4,1.4l-0.1,0.1l-0.3,0.1
		l-1.7,0.1l0-1.1l-1.7-0.9l-0.4-0.1l-0.5-0.1l-0.9,0l-0.1-3.3L335.8,239z	"
        >
          <title id="t1126">Union, LA</title>
        </path>
        <path
          id="FIPS_22027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.9,239.3l2.8-0.1l0.1,3.3l-1.6,2.3l-3.2,0.1l0-0.6l-0.2-1.1l-0.5,0l-0.1-3.9L325.9,239.3z
			"
        >
          <title id="t1127">Claiborne, LA</title>
        </path>
        <path
          id="FIPS_22119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.5,239.4l2.7-0.1l0.1,3.9l0.5,0l0.2,1.1l0,0.6l0.4,1.3l0,0.3l-1,0.6l-1.5,0l-0.7,0
		l-0.1-1.1l-0.1-3.4l-0.1-1.4l-0.3-0.3l-0.4-0.6l-0.2-0.4v-0.2l0.1-0.5L320.5,239.4z	"
        >
          <title id="t1128">Webster, LA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea[43340]
              ? `metroArea clickedArea colorKey ${colorCode[43340]} state-la`
              : `metroArea colorKey ${colorCode[43340]} state-la`
          }
          id="FIPS_43340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_22015"
            className="FIPS_43340 st0 state-la"
            d="M320.2,239.4l-0.1,0.5v0.2l0.2,0.4l0.4,0.6l0.3,0.3l0.1,1.4l0.1,3.4l0.1,1.1l0.7,0l-0.5,2.3
		l-0.5,0l-1-1.2l-1.2-0.6l-1.4-4.2l-0.1-0.6l-0.5-3.2l0,0l0.1-0.1h0.1L320.2,239.4z	"
          >
            <title id="t1129">Bossier, LA</title>
          </path>
          <path
            id="FIPS_22017"
            className="FIPS_43340 st0 state-la"
            d="M317,239.5l-0.1,0.1l0,0l0.5,3.2l0.1,0.6l1.4,4.2l1.2,0.6l1,1.2l-1.6,0l0-0.4l-0.1-0.2
		l-0.3-0.3l-0.2-0.2l-0.9-0.3l-0.2,0l-0.2,0l-0.2,0.1l-0.1,0l-0.5,0.6l0,0.2l0,0.1l0,0.1l-0.4,0.4l-0.6,0.4l-1,0l-0.1-6.4l0-2.4
		l0-1.8L317,239.5z	"
          >
            <title id="t1130">Caddo, LA</title>
          </path>
          <path
            id="FIPS_22031"
            className="FIPS_43340 st0 state-la"
            d="M319.4,249.6l0.7,0.5l0.4,1.4l0.7,1.1l0.1,0.1l1,0.7l-0.9,1.1l-4.8,0.1l-1.5-1.7l-0.4-2.8l1,0
		l0.6-0.4l0.4-0.4l0-0.1l0-0.1l0-0.2l0.5-0.6l0.1,0l0.2-0.1l0.2,0l0.2,0l0.9,0.3l0.2,0.2l0.3,0.3l0.1,0.2L319.4,249.6z	"
          >
            <title id="t1131">De Soto, LA</title>
          </path>
        </g>

        <path
          id="FIPS_22085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.7,254.7l4.8-0.1l0,1.7l1.1,0l0.1,2.3l1.1,0l0.1,2.2l-1.7,0l-1.6,1.2l-0.1,0.4l-0.1,0.7
		l0,0l-0.5,0.1l-0.1-0.7l-0.1-0.4l-0.3-1.4l-1-1.5l-1.2-1.2L316.7,254.7z	"
        >
          <title id="t1132">Sabine, LA</title>
        </path>
        <path
          id="FIPS_22069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.1,250.6l2.7-0.1l0.4,0.7l0.2,0.8l0.1,1l0,0.2l-0.2,0.9l-0.7,2.1l2.9,2.4l-2.8,2.3
		l-2.8-0.1l-0.1-2.2l-1.1,0l-0.1-2.3l-1.1,0l0-1.7l0.9-1.1l0.1,0.4l0.3,0.1h0.4l0.5-0.2l1-1.2l0.1-0.7l0-0.1l-0.2-0.6l-0.3-0.4
		L324.1,250.6z	"
        >
          <title id="t1133">Natchitoches, LA</title>
        </path>
        <path
          id="FIPS_22043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.6,256.2l3.8-0.1l0-0.5l0-0.6l2.8-0.1l0.1,1.6l0.4,1l0.5,0.7l0.5,0.5l0.5,0.1l-1.2,0.3
		l-3.6,1l-0.3,0l-0.3-0.1l-0.1-0.1l-0.1-0.7l-0.2-0.8L326.6,256.2z	"
        >
          <title id="t1134">Grant, LA</title>
        </path>
        <path
          id="FIPS_22059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.7,253.1l3.3-0.1l0.3,7.8l-0.9-0.1l-1.3-1.8l-0.5-0.1l-0.5-0.5l-0.5-0.7l-0.4-1l-0.1-1.6
		L333.7,253.1z	"
        >
          <title id="t1135">LaSalle, LA</title>
        </path>
        <path
          id="FIPS_22025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.1,253l1.2-0.6l0.2,0l0.3,0.2l0.4,0.4l0.3,0.4l0.2,0.2l0.5-0.1l0.3-0.2l0.4-0.4l0.2-0.3
		l0-0.1l0.5,0.3l0.3,0.7l0.4,1.7l-1.5,0.2l-0.1,0.1l-1.2,1.4l-0.1,0.1l-0.4,1.7l-0.1,0.4l0,2l0,0.1l0.4,0.5l-0.6-0.3l-0.2-0.1
		l-0.2,0l-0.1,0.1l-0.1,0.2l0.1,0.3l0.1,0.2l0,0.1l-0.2,0.1l-0.5,0l0-0.1l-0.2-0.8v-0.4L337.1,253	"
        >
          <title id="t1136">Catahoula, LA</title>
        </path>
        <path
          id="FIPS_22029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.2,255l1.8,0.2l-0.2,0.3l0,0l-1.2,2.4l0,0.1l0,0.1l0,0l-0.4,3.4l-0.3,1.4l-0.3,2l-0.3,0.4
		l0-0.3l-0.8-0.6l0.1-0.2l0.1-0.2l0.3-1.5l-0.1-0.2l-0.2-0.1l-0.1,0l-0.4-0.1l-0.5-0.1l-0.2-0.2l-0.2-0.3l-0.4-0.5l0-0.1l0-2
		l0.1-0.4l0.4-1.7l0.1-0.1l1.2-1.4l0.1-0.1L342.2,255	"
        >
          <title id="t1137">Concordia, LA</title>
        </path>
        <path
          id="FIPS_22009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.5,260.6l0.9,0.1v0.4l0.2,0.8l0,0.1l0.5,0l0.2-0.1l0-0.1l-0.1-0.2l-0.1-0.3l0.1-0.2
		l0.1-0.1l0.2,0l0.2,0.1l0.6,0.3l0.2,0.3l0.2,0.2l0.5,0.1l0.4,0.1l0.1,0l0.2,0.1l0.1,0.2l-0.3,1.5l-0.1,0.2l-0.1,0.2l-0.3,0.3
		l-0.6,2.2l-4.4,0.2l-0.8-1.5l0.7-0.4l-0.3-1.8l-0.1-2.5l0.1-0.1l0.1,0l0,0l0.7,0.3L336.5,260.6z	"
        >
          <title id="t1138">Avoyelles, LA</title>
        </path>
        <path
          id="FIPS_22079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.5,258.6l0.2,0.8l0.1,0.7l0.1,0.1l0.3,0.1l0.3,0l3.6-1l1.2-0.3l1.3,1.8l-0.7,0.4l-0.7-0.3
		l0,0l-0.1,0l-0.1,0.1l0.1,2.5l0.3,1.8l-0.7,0.4l-1.1-0.4l-2.4,1.4l-2.5,0.2l-0.1-1.6l-0.1-3.1l-0.6-0.8l-0.2-0.1l-0.9-0.3
		L329.5,258.6z	"
        >
          <title id="t1139">Rapides, LA</title>
        </path>
        <path
          id="FIPS_22115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M323.9,260.7l2.8,0.1l0.9,0.3l0.2,0.1l0.6,0.8l0.1,3.1l0.1,1.6l-1.7,0.2l-1.7,0L322,267
		l-1.5,0.2l0-4.1l0,0l0.1-0.7l0.1-0.4l1.6-1.2L323.9,260.7z	"
        >
          <title id="t1140">Vernon, LA</title>
        </path>
        <path
          id="FIPS_22039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M331.1,266.5l2.4-1.4l1.1,0.4l0.8,1.5l0.5,1l0,0.7l0,0.5l-0.5,1.4L335,271l-1.7,0.1l-0.4,0.1
		l-0.1,0.1l-0.4,0.6l-1.5,0l0-0.1l0.1-0.1l0.1-0.2l0.3-0.8l0-0.1l-0.1-0.1l-0.1-2.4l0-0.5L331.1,266.5z	"
        >
          <title id="t1141">Evangeline, LA</title>
        </path>
        <path
          id="FIPS_22003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.6,266.7l2.5-0.2l0,1.2l0,0.5l0.1,2.4l0.1,0.1l0,0.1l-0.3,0.8l-0.1,0.2l-0.1,0.1l-1.6,0
		l-0.9,0.5l-1.8,0.3l-1.3,0.2l-0.1-2.2l0.9,0l0.8,0l-0.1-2.6l-0.1-1L328.6,266.7z	"
        >
          <title id="t1142">Allen, LA</title>
        </path>
        <path
          id="FIPS_22011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.9,266.9l0.1,1l0.1,2.6l-0.8,0l-0.9,0l0.1,2.2l0,0.3l-2.8,0.1l0-1.1l-1.1,0l0,1.1
		l-2.9,0.1l0,0l0.4-0.4l0-0.1l0-0.1l-0.2-0.8l-0.3-0.4l0,0v0l0.1-0.5l1.6-3l0.2-0.9l1.5-0.2l3.2-0.1L326.9,266.9z	"
        >
          <title id="t1143">Beauregard, LA</title>
        </path>
        <path
          id="FIPS_22053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.9,271.9l0.3,5l-1.2,0.8l-2.9,0.1l0-0.6l1.2-0.1l-0.2-0.6l-0.3-0.3l-1.2-1.3l-1.2-1.5
		l0-0.3l0-0.3l1.3-0.2l1.8-0.3l0.9-0.5L330.9,271.9L330.9,271.9z	"
        >
          <title id="t1144">Jefferson Davis, LA</title>
        </path>
        <path
          id="FIPS_22019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.4,273.1l0,0.3l1.2,1.5l1.2,1.3l0.3,0.3l0.2,0.6l-1.2,0.1l0,0.6l-1.5,0l0-0.2l-6.6,0.2
		l0,0l0-2.5l-0.3-2l2.9-0.1l0-1.1l1.1,0l0,1.1L325.4,273.1z	"
        >
          <title id="t1145">Calcasieu, LA</title>
        </path>
        <path
          id="FIPS_22023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.9,277.6l1.4-0.1l0.2,4.4l0,1.5l-0.4-0.1l-1-0.3l-0.9-0.4l-0.5-0.2l-0.8-0.4l-0.4-0.1l0,0
		l-1.3-0.4l-1-0.2l-0.6-0.1l-0.5,0l-2.3,0.2l-0.7,0.1l-1.1,0.2l-0.5,0.1l-0.6,0.2l0,0l-0.1,0l-0.2,0.1l-0.4,0.2l-0.2,0.1l-0.2,0.2
		l-0.1-2.9l1.3-1.8l0,0l6.6-0.2l0,0.2l1.5,0L329.9,277.6z	"
        >
          <title id="t1146">Cameron, LA</title>
        </path>
        <path
          id="FIPS_22001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330.9,271.9l1.5,0l2.8-0.1l0.8,0.5l0.5,1.5v0.3l-1.5,2l-0.9,1l-0.2,0.2l-0.2,0.1l-0.2,0.1
		l-2.1-0.4l-0.1,0L330.9,271.9z	"
        >
          <title id="t1147">Acadia, LA</title>
        </path>
        <path
          id="FIPS_22097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M339.8,266.8l0.2,0.1l0.4,0.7l0.4,1l0,0.4l-0.1,1.8l-0.1,0.5l0.4,0.6l0.5,0.7l-1.5,0.1
		l-0.1-0.1l-0.6-0.2l-0.7,0.3l-0.6,0.4l-1.7,1v-0.3l-0.5-1.5l-0.8-0.5l-2.8,0.1l0.4-0.6l0.1-0.1l0.4-0.1l1.7-0.1l0.5-0.4l0.5-1.4
		l0-0.5l0-0.7l-0.5-1L339.8,266.8z	"
        >
          <title id="t1148">St. Landry, LA</title>
        </path>

        <path
          id="FIPS_22055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.5,274l1.7-1l0.6,3.8l-0.1,0.5l-1.2-0.5l-0.7-0.5l-0.9-0.3l-0.8,0L336.5,274z	"
        >
          <title id="t1151">Lafayette, LA</title>
        </path>
        <path
          id="FIPS_22113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.6,277.3l0.1,3l-0.7,0.3l-0.2,0.1l-0.6,0.4l-0.4,0.4l0,0.3l0.2,0.5l0.3,0.5l0.2,0l1.1,0
		l-0.5,0.4l-0.1,0h-0.7l-0.6,0.1h0l-0.6,0.3l-0.4,0.3l-0.3,0.1l0,0l-0.1,0l-0.2,0H335l-2.8-0.4l-0.6-0.1h0l0-1.5l-0.2-4.4l-1.4,0.1
		l1.2-0.8l0.1,0l2.1,0.4l0.2-0.1l0.2-0.1l0.2-0.2l0.9-1l0.8,0l0.9,0.3l0.7,0.5L338.6,277.3z	"
        >
          <title id="t1152">Vermilion, LA</title>
        </path>
        <path
          id="FIPS_22045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.4,282.8l0.8-0.3l0.3-0.1l0.4,0.1l1.8,0.8l0,0l0,0.1l-0.6,0.9l-0.1,0.1l-0.4,0.1l-0.2-0.1
		l-2.2-1l-0.2-0.2L338.4,282.8z M345.2,276.7l1.6,0.4l-0.3,0.7l-2.4,0.3l-1.7,0.2l-0.9,1.3l-1.8,1.7l-1.1-1l-0.1-3l0.1-0.5l0.5,0
		l1.6-0.5l0.2-0.1l0.1,0l0.3,0l0.4,0.1l0.1,0l1.9,0.6L345.2,276.7z	"
        >
          <title id="t1153">Iberia, LA</title>
        </path>

        <path
          id="FIPS_22007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349.7,276.4l1,2l-1.2,2.5l-0.8,1.2l-0.2-0.9l0-0.8l0-0.5l-0.1-0.2l-0.1-0.1l-0.2-0.1h-0.1
		l-0.5-0.1l-0.2-0.2l-0.6-1.2l-0.1-0.2l0.3-0.7l1.3-0.5L349.7,276.4z	"
        >
          <title id="t1155">Assumption, LA</title>
        </path>
        <path
          id="FIPS_22099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.6,271.3l0.6,0l0.7,0.7l0.2,0.4l0,0.3l0,0.7l0,0.2l0,0.1l0.1,0.2l0.4,0.7l0.1,0.1l0.1,0.1
		l0.2,0l0.4,0l0.2,0l0.2,0.1l1.2,1.7l0.1,0.3l0,0.2l-1.3,0.1l-1.9-0.6l-0.1,0l-0.4-0.1l-0.3,0l-0.1,0l-0.2,0.1l-1.6,0.5l-0.5,0
		l-0.6-3.8l0.6-0.4l0.7-0.3l0.6,0.2l0.1,0.1l1.5-0.1l-0.5-0.7L340.6,271.3z M344.1,278.1l2.4-0.3l0.1,0.2l0.6,1.2l0.2,0.2l0.5,0.1
		h0.1l0.2,0.1l0.1,0.1l0.1,0.2l0,0.5l0,0.8l-1.3-0.6l-1.9-0.9L344.1,278.1z	"
        >
          <title id="t1156">St. Martin, LA</title>
        </path>
        <path
          id="FIPS_22101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.1,278.1l1.2,1.6l1.9,0.9l1.3,0.6l0.2,0.9l-2,2h-0.2l-0.5-0.1l-2.2-0.5l-0.1-0.4l-0.1-0.4
		l-0.2-0.5l-0.8-1.3l-0.1-0.1l-1.2,0l-0.2,0l-1.4,0.4l1.8-1.7l0.9-1.3L344.1,278.1z	"
        >
          <title id="t1157">St. Mary, LA</title>
        </path>
        <path
          id="FIPS_22109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349.5,280.9l2-0.9l0.1,0l0.1,0l2.8,2.6l2.1,2.2l0.2,0.2l0.1,0.2l0.1,0.6l-0.3,1.4l-1.7,0
		l-0.9,1l0.1,0.7l-2.3,0.5l-5.1-2.4l-0.3-0.2l-0.4-0.4l0-0.1l0.6-0.3l0.8-0.4l0.1-0.1l0-0.3l-0.2-0.4l-0.1-0.1l0,0l-0.6-0.5l2-2
		L349.5,280.9z	"
        >
          <title id="t1158">Terrebonne, LA</title>
        </path>
        <path
          id="FIPS_22057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.6,278.4l0.6,0.4l1,1l0.6,0.7l0,0.1l0.1,0.1l0.1,0l1.2-0.1l0.3,0l0.4,0.1l0.1,0.1l0,0.1
		l0.1,0.9l0,0.1l-0.1,0.2l0.9,1.3l0.7,0.3l0,1.5l-0.7,0.8l0.3,0.7l-0.2,0.6l-0.1,0.1l0,0l-0.7,0.6l0,0l0,0l-0.5,0.3l-1.3,0.4l-0.1,0
		v0l0-0.1l0.3-0.2l0.2,0l0.1,0l0.1-0.1l0.3-0.1l0.1,0l0.2-0.2l0-0.2l-0.5-0.9l-0.2-0.3l-0.4-0.5l-0.2-0.1l-0.4,0.1l-0.2,0.3
		l-0.2,0.7l0.3-1.4l-0.1-0.6l-0.1-0.2l-0.2-0.2l-2.1-2.2l-2.8-2.6l-0.1,0l-0.1,0l-2,0.9l1.2-2.5l2.6,0.1L354.6,278.4	"
        >
          <title id="t1159">Lafourche, LA</title>
        </path>
        <path
          id="FIPS_22093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.2,274.9l-0.1,1.5l-0.3,0.2l0.2,1.1l0.2,0.6l0.1,0.2l-2.6-0.1l-1-2L353.2,274.9z	"
        >
          <title id="t1160">St. James, LA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12940"
              ? `metroArea clickedArea state-la`
              : `metroArea ${colorCode[12940]} state-la`
          }
          id="FIPS_12940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_22005"
            className="FIPS_12940 st0 state-la"
            d="M350.3,272.8l2,1.9l0.2,0.2l0.1,0l0,0l0.6-0.6l-0.1,0.7l-3.5,1.5l-1.6,0.1l0.8-3.4
		L350.3,272.8z	"
          >
            <title id="t1161">Ascension, LA</title>
          </path>
          <path
            id="FIPS_22033"
            className="FIPS_12940 st0 state-la"
            d="M350.5,267.9l-0.6,0.9l-0.7,0.9l0,1.8l0.2,0.5l0.9,0.7l-1.4,0.4l-1.3,0l-1.9-4.1l0.3-0.7
		l0.1-0.1L350.5,267.9z	"
          >
            <title id="t1162">East Baton Rouge, LA</title>
          </path>
          <path
            id="FIPS_22037"
            className="FIPS_12940 st0 state-la"
            d="M348,264.5l2.6-0.1l-0.3,0.8l0.2,1.1l0.1,0.7v0.9l-4.5,0.4l-0.1,0.1l-0.3,0.7l-0.1,0l0-0.3
		l0-0.4l0.2-0.5l0.1-0.2l0.4-0.8l0.3-1.5l0.2-0.9L348,264.5z	"
          >
            <title id="t1163">East Feliciana, LA</title>
          </path>
          <path
            id="FIPS_22047"
            className="FIPS_12940 st0 state-la"
            d="M343.6,271.1l0.4,0.3l1.2,1.3l0.4,0.5l1.9-0.1l1.3,0l-0.8,3.4l-1.3,0.5l-1.6-0.4l0-0.2
		l-0.1-0.3l-1.2-1.7l-0.2-0.1l-0.2,0l-0.4,0l-0.2,0l-0.1-0.1l-0.1-0.1l-0.4-0.7l-0.1-0.2l0-0.1l0-0.2l0-0.7l0-0.3l-0.2-0.4l-0.7-0.7
		L343.6,271.1z	"
          >
            <title id="t1154">Iberville, LA</title>
          </path>
          <path
            id="FIPS_22063"
            className="FIPS_12940 st0 state-la"
            d="M349.9,268.9l3.8-0.2l0.1,2.1l0.3,0.7l0.9,1.2l0.4,0.4l0.1,0.1l0.1,0.1l0.2,0l-0.7,0.3
		l-0.3,0.1l-0.1,0.1l-0.2,0.4l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.1,0l-0.1,0l-0.6-0.3l-0.6,0.6l0,0l-0.1,0l-0.2-0.2l-2-1.9l-0.9-0.7
		l-0.2-0.5l0-1.8L349.9,268.9z	"
          >
            <title id="t1165">Livingston, LA</title>
          </path>
          <path
            id="FIPS_22077"
            className="FIPS_12940 st0 state-la"
            d="M340.4,264.6l1,0.3l0,0.3l0.1,1.4l0,0.1l0.1,0.1l0.1,0l1.2,0.6l1.8,0.3l0.1,0l0.2,0.3l0.3,0.9
		l-1.6,2.2l-2.4,0.1l-0.6,0l0.1-0.5l0.1-1.8l0-0.4l-0.4-1l-0.4-0.7l-0.2-0.1L340.4,264.6z	"
          >
            <title id="t1149">Pointe Coupee, LA</title>
          </path>
          <path
            id="FIPS_22091"
            className="FIPS_12940 st0 state-la"
            d="M353.5,264.1l0.3,4.5l-3.8,0.2l0.6-0.9V267l-0.1-0.7l-0.2-1.1l0.3-0.8L353.5,264.1z	"
          >
            <title id="t1164">St. Helena, LA</title>
          </path>
          <path
            id="FIPS_22121"
            className="FIPS_12940 st0 state-la"
            d="M345.2,269l0.3,0.1l0.1,0l1.9,4.1l-1.9,0.1l-0.4-0.5l-1.2-1.3l-0.4-0.3L345.2,269z	"
          >
            <title id="t1150">West Baton Rouge, LA</title>
          </path>
          <path
            id="FIPS_22125"
            className="FIPS_12940 st0 state-la"
            d="M341.7,264.8l5.1-0.2l-0.2,0.9l-0.3,1.5l-0.4,0.8l-0.1,0.2l-0.2,0.5l0,0.4l0,0.3l-0.3-0.1
		l-0.3-0.9l-0.2-0.3l-0.1,0l-1.8-0.3l-1.2-0.6l-0.1,0l-0.1-0.1l0-0.1l-0.1-1.4L341.7,264.8z M340.7,264.2l0.8,0.6l-1-0.3
		L340.7,264.2z	"
          >
            <title id="t1172">West Feliciana, LA</title>
          </path>
        </g>

        <path
          id="FIPS_22105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.7,264.1l2.2-0.1l0.1,1.2l0.3,0.3l0.8,1.9l0,0.2l0.5,6.3l-0.4-0.1l-1.4-0.6l-0.2,0
		l-0.1-0.1l-0.1-0.1l-0.4-0.4l-0.9-1.2l-0.3-0.7l-0.1-2.1l-0.3-4.5L353.7,264.1z	"
        >
          <title id="t1168">Tangipahoa, LA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "35380"
              ? `metroArea clickedArea state-la`
              : `metroArea ${colorCode[35380]} state-la`
          }
          id="FIPS_35380"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_22051"
            className="FIPS_35380 st0 state-la"
            d="M357.2,273.9l0.4,0.1l1.6,0.3l0,2.1l0.8,1l0.6,0.6l-0.4,0.8l-0.2,0.9l0.1,0.4l0.4,0.5l0.2,0.3
		l0.4,0.8l0.1,0.2l0.2,1.9l-0.6,0.2l-0.7-0.3l-0.9-1.3l0.1-0.2l0-0.1L359,281l0-0.1l-0.1-0.1l-0.4-0.1l-0.3,0l0.2-0.5l0.1-0.2
		l0.2-1.1l-0.7-0.4l-0.3-0.5l-0.1-0.2l-0.1-0.6l0-0.4L357.2,273.9z M360.4,286.8L360.4,286.8l0.3,0l0.2-0.3l0.6-0.5l0.1,0l0,0l0,0
		l-0.1,0.1l-0.7,0.5l-0.6,0.6l-0.1,0.1l0,0L360.4,286.8z	"
          >
            <title id="t1173">Jefferson, LA</title>
          </path>
          <path
            id="FIPS_22071"
            className="FIPS_35380 st0 state-la"
            d="M359.2,274.2l1.2,0.5l1-0.6l0.3-0.1l2.2,0.2l0.6,0.2l0.1,0l-0.5,0.6l-1.5,1l-0.5,0.6l-0.5,1.7
		l-1.1-0.3l-0.6-0.6l-0.8-1L359.2,274.2z	"
          >
            <title id="t1169">Orleans, LA</title>
          </path>
          <path
            id="FIPS_22087"
            className="FIPS_35380 st0 state-la"
            d="M362.1,276.5l0.1,0.3l0.1,0.3l0.1,0.1l0.1,0.1l1.6,0.8l0.4,0l0.3,0l0.3-0.1l0.2-0.1l0.1-0.2
		l0.1-0.8l0-0.3l0.8-0.9l0.4-0.2l0.5,0.1l0.3,0.2l-0.2,0.1l-0.1,0.1l-0.1,0.1l0,0.2l0,0.2l0.7,0.7l0.1,0.1l0.5,0.3l0.1,0.1l-0.7,1.2
		l-0.4,0.6l-0.6,0.2l-0.5-0.2l-1.2,0l-0.2,0.1l0,0.4l0.1,0.1l0.6,0.3l0.3,0.1l0.2,0l0.3,0l0.5,0.5l0,0.1l0,0l-0.1-0.1l-0.3-0.2
		l-1.2-0.3l-0.8-0.7l-0.2-0.2l-1.7-0.4l-0.1,0l-0.1,0L362,279l-0.2-0.4l-0.2-0.3L362.1,276.5	"
          >
            <title id="t1170">St. Bernard, LA</title>
          </path>
          <path
            id="FIPS_22075"
            className="FIPS_35380 st0 state-la"
            d="M360.5,278l1.1,0.3l0.2,0.3l0.2,0.4l0.1,0.2l0.1,0l0.1,0l1.7,0.4l0.2,0.2l0.8,0.7l1.2,0.3
		l0.3,0.2l0.1,0.1l-0.2-0.1l-0.4-0.2l-1,0l-0.2,0.1l-0.4,0.3l-0.1,0.3l-0.1,1.1l0,0.1l0.1,0.1l0.3,0.2l2.1,1.1l0.3,0l0.9,0l2.3,0.7
		l0.6,0.7l0.3,0.4l0.5,0.3l0.4-0.2l0.1,0l0.1,0.1l0.2,0.4v0l0,0.2v0l-0.2,0.5l-0.4,0.8l-1,0.6l-0.7-0.4l-1.6,0l-1.2-1.4l0,0
		l-0.2-0.1l0,0l-0.1-0.1v0l0,0l-0.3-0.1l-0.2-0.1l-1.6-0.6l-0.2-0.1l0,0l-0.2,0l-0.1,0h0l0,0l-0.2,0l-0.3,0l-0.6-0.6l0.1-0.2l0-0.1
		v-0.1l0-0.1l-0.2-0.9l0,0l-0.1,0l-0.1-0.1l-0.1,0l-0.1,0.1l-0.3,0.2l-0.2,0.2l-0.1,0.2l-0.3,0l-0.1-0.1l-0.1-0.2l-0.2-1.9l-0.1-0.2
		l-0.4-0.8l-0.2-0.3L360,280l-0.1-0.4l0.2-0.9L360.5,278	"
          >
            <title id="t1171">Plaquemines, LA</title>
          </path>
          <path
            id="FIPS_22095"
            className="FIPS_35380 st0 state-la"
            d="M355.8,273.2l1.4,0.6l-1.3,2l-0.9,0.7l-0.5,0.2l-0.1,0.2l0,0.2l0.2,1.2l-1.3,0.1l-0.1-0.2
		l-0.2-0.6l-0.2-1.1l0.3-0.2l0.2-2.2l0.6,0.3l0.1,0l0.1,0l0.1-0.1l0.1-0.2l0.1-0.2l0.2-0.4l0.1-0.1l0.3-0.1L355.8,273.2z	"
          >
            <title id="t1166">St. John the Baptist, LA</title>
          </path>
          <path
            id="FIPS_22089"
            className="FIPS_35380 st0 state-la"
            d="M354.6,278.4l-0.2-1.2l0-0.2l0.1-0.2l0.5-0.2l0.9-0.7l1.3-2l0.1,2.9l0,0.4l0.1,0.6l0.1,0.2
		l0.3,0.5l0.7,0.4l-0.2,1.1l-0.1,0.2l-0.2,0.5l-1.2,0.1l-0.1,0l-0.1-0.1l0-0.1l-0.6-0.7l-1-1L354.6,278.4z	"
          >
            <title id="t1167">St. Charles, LA</title>
          </path>
          <path
            id="FIPS_22103"
            className="FIPS_35380 st0 state-la"
            d="M357.1,267.6l4.6,0.3l1.9,2.6l0,0l0.1,0.1l0.7,1.4l0,0.2l-0.1,0.3l0,0.1l0,0.1l0.4,0.7
		l0.1,0.2l0.2,0.3l0.1,0.1l0,0l0,0l0,0l0,0l0.5,0l-1.1,0.4l-0.1,0l-0.6-0.2l-2.2-0.2l-0.3,0.1l-1,0.6l-1.2-0.5l-1.6-0.3L357.1,267.6
		z	"
          >
            <title id="t1110">St. Tammany, LA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "49340"
              ? `metroArea clickedArea state-ma`
              : `metroArea ${colorCode[49340]} state-ma`
          }
          id="FIPS_49340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25027"
            className="FIPS_49340 st0 state-ma"
            d="M518.7,85.2L518.7,85.2l0.7,0.8l0.5-0.1l0.2-0.1l0.8,0.1l0.4,0l1.4,0.6l0.1,0.3l0.1,0.7l0,0.7
		l-0.1,0.4l-0.3,0.6l0.6,1.6l0.3,0.2l0.3,0.1l0.8,0.1l0.3,1.8l-2.7,0.8l-0.1-0.2l-2.4,0.6l-0.4,0.1l-0.3,0.1l-0.4-1.7l-0.6,0.2
		l-0.7-0.1l0-0.2l0-0.1l0.2-0.6l-1.2-1l-0.2-0.7l-0.1-1.1l0.1-0.7l-0.2-1.1l-0.6-1.3l3.3-0.7L518.7,85.2z	"
          >
            <title id="t1174">Worcester, MA</title>
          </path>
        </g>
        <path
          id="FIPS_25019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M540.1,98.4L540.1,98.4l0.2-0.2l0.1-0.2l0.1-0.3l0-0.3l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1,0l0,0
		l0.2,0l0.2,0.2l0.9,1l0.1,0.2l0,0.1l0,0l-0.1,0.1l-0.2,0.2L541,99l-0.8,0.2l-0.2,0l-0.5,0l-0.9-0.2l-0.1-0.1l-0.1-0.1l0-0.1l0.1,0
		l0.1,0l0.1,0l0.5,0l0.7-0.2L540.1,98.4z	"
        >
          <title id="t1176">Nantucket, MA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12700"
              ? `metroArea clickedArea state-ma`
              : `metroArea ${colorCode[12700]} state-ma`
          }
          id="FIPS_12700"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25001"
            className="FIPS_12700 st0 state-ma"
            d="M534.2,93.1L534.2,93.1l0.3,0.2l0.3,0.2l0.2,0.1l0.6,0.1l0.4,0l1-0.1l1.3-0.8l0.5-0.3l0.3-0.3
		l0.1-0.2l0-0.1l-0.1-0.4l-0.2-0.5l-0.1-0.2l-0.3-0.4l-1-1.1l-0.2-0.1l-0.2-0.1l-0.3-0.1l-0.1,0l-0.1,0.1l-0.1,0.1l-0.1,0.1l0,0.2
		l0,0.1l-0.5-0.2l0,0l0-0.1l0.1-0.1l0.2-0.1l0.2-0.1l0.3,0l0.4,0l0.4,0.1l0.3,0.1l0.3,0.2l0.3,0.3l0.4,0.4l0.3,0.4l0.4,0.8l0.2,0.4
		l0.3,0.8l0.2,0.6l0,0.3l-0.1,1.2l-0.1,0.1l0-0.9l0-0.1l0-0.1l-0.2-0.1l-0.1,0l-0.1,0l-2.9,1.3l-0.1,0.1l-2.1,1.8l-0.3,0.4l-0.4,0
		l-0.2-2.5L534.2,93.1z	"
          >
            <title id="t1177">Barnstable, MA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "39300"
              ? `metroArea clickedArea state-ma state-ri`
              : `metroArea ${colorCode[39300]} state-ma state-ri`
          }
          id="FIPS_39300"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25005"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M525.8,93.1l2.4-2.1l0.7,1.6l0.8,1.5l1,0.4l0.4,0.3l1,1.5l-0.2,0l-0.4,0.1l-0.2,0.2l-0.1,0.1
		l0,0l0,0.4l0,0.2l0.1,0.3l-0.8,0.8l-0.8,0.2l-1.3-2l-0.4-0.4l-1.1-0.6L525.8,93.1z	"
          >
            <title id="t1179">Bristol, MA</title>
          </path>
          <path
            id="FIPS_44003"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M526.9,96.3l-0.3,1l-0.5,0.8l-2.8,0.8l-0.1-0.5l-0.3-1.1l3.1-0.9l0,0l0.1-0.1l0-0.1l0-0.1l0,0
		l0.3-0.2l0.1,0l0.1,0.1l0.2,0.2L526.9,96.3z	"
          >
            <title id="t2308">Kent, RI</title>
          </path>
          <path
            id="FIPS_44007"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M524.7,92.9l1.2,0.1l1.3,2.5l-0.3,0.6l-0.2-0.2l-0.1-0.1l-0.1,0l-0.3,0.2l0,0l0,0.1l0,0.1
		l-0.1,0.1l0,0l-3.1,0.9l-1-3.5L524.7,92.9z	"
          >
            <title id="t2309">Providence, RI</title>
          </path>
          <path
            id="FIPS_44001"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M526.9,96.3l-0.1-0.1l0.3-0.6l1.1,0.6l0.4,0.4l-0.4,0.6l-0.1,0.2l0,0.1l-0.7-0.2L526.9,96.3z	
		"
          >
            <title id="t2310">Bristol, RI</title>
          </path>
          <path
            id="FIPS_44005"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M528.6,96.5l1.3,2l-0.3,0.4l-1.3,0.6l-0.4,0.1l-0.1-0.1l0-0.1l0.3-2.2l0,0l0-0.1l0.1-0.2
		L528.6,96.5z	"
          >
            <title id="t2311">Newport, RI</title>
          </path>
          <path
            id="FIPS_44009"
            className="FIPS_39300 st0 state-ma state-ri"
            d="M523.3,98.9l2.8-0.8l0.5-0.8l0.3,0.8l0.1,0.9l0.1,0.4l0,0.2l0,0.2l0,0.1l-0.1,0.5l-0.1,0.5
		l-3.1,1.6l-0.3,0L523.3,98.9z	"
          >
            <title id="t2312">Washington, RI</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "14460"
              ? `metroArea clickedArea state-ma state-nh`
              : `metroArea ${colorCode[14460]} state-ma state-nh`
          }
          id="FIPS_14460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25009"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M528,80.6l0.1,0.3l0.3,0.8l0.5,1l0.6,0.2l-0.9,1.9l-0.6,1.8l-0.5-0.2l-0.7-1l-1-0.6l-0.9-0.6
		l-0.4-0.9l0.1-0.1l0.5-1l0.1-0.1l0.2-0.2l0.7-0.6l0.9-0.6h0l0.1,0l0.1,0l0.3,0L528,80.6z	"
          >
            <title id="t1182">Essex, MA</title>
          </path>
          <path
            id="FIPS_25017"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M524.5,83.4l0.4,0.9l0.9,0.6l1,0.6l0.7,1l-0.1,0.3l-0.2,0.5l-0.4,0.3l-0.4,0.2l0,1l-0.5-0.4
		l0,0l-0.2,0l-0.2,0l-0.5,0.3l0.1,0.2l0.2,0.3l0.1,0.3l-0.2,0.7l-0.5,0.4l-0.6,0.5l-0.8-0.1l-0.3-0.1l-0.3-0.2l-0.6-1.6l0.3-0.6
		l0.1-0.4l0-0.7l-0.1-0.7l-0.1-0.3l-1.4-0.6l-0.4,0l-0.8-0.1l-0.2,0.1l-0.5,0.1l-0.7-0.7l0-0.1l2.3-0.5l0.1,0l0,0l3.1-0.7
		L524.5,83.4z	"
          >
            <title id="t1175">Middlesex, MA</title>
          </path>
          <path
            id="FIPS_25021"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M528.2,88.1l0.9,0.3l-0.9,2.5l-2.4,2.1l-1.2-0.1l-0.3-1.8l0.6-0.5l0.5-0.4l0.2-0.7l-0.1-0.3
		l-0.2-0.3l-0.1-0.2l0.5-0.3l0.2,0l0.2,0l0,0l0.5,0.4L528.2,88.1z	"
          >
            <title id="t1181">Norfolk, MA</title>
          </path>
          <path
            id="FIPS_25023"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M529.1,88.4l0.9-0.3l0.5,0.1l0.1,0l0.1,0.1l0.5,0.3l1.2,1.3l1.7,2.2l0.2,0.4l0.1,0.6l-0.7,1.4
		l-1.4,1.6l-1-1.5l-0.4-0.3l-1-0.4l-0.8-1.5l-0.7-1.6L529.1,88.4z	"
          >
            <title id="t1180">Plymouth, MA</title>
          </path>
          <path
            id="FIPS_25025"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M527.6,86.4l0.5,0.2l0.2,1.5l-1.6,0.7l0-1l0.4-0.2l0.4-0.3l0.2-0.5L527.6,86.4z	"
          >
            <title id="t1178">Suffolk, MA</title>
          </path>
          <path
            id="FIPS_33015"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M528.4,77.9l-0.4,2.6l-0.7,0l-0.3,0l-0.1,0l-0.1,0h0l-0.9,0.6l-0.7,0.6l-0.2,0.2l-0.1,0.1
		l-0.5,1l-1.1-0.1l-0.9-0.6l-0.3-0.7l-0.2-0.5l0.3-1.1l0.4-3.7l2.5,1.2l-0.2,0.8l1.8-0.5l0.1-0.1l0.3-0.6L528.4,77.9z	"
          >
            <title id="t1900">Rockingham, NH</title>
          </path>
          <path
            id="FIPS_33017"
            className="FIPS_14460 st0 state-ma state-nh"
            d="M522.6,73.1l0.2-0.5l0.4,0.8l1-0.3l0.3-0.6l0.2,1.8l0.1,0.3l0.1,0.2l0.3,0.4l0.2,0.1l0.5,0.2
		l1.1,0.7l0,0l0.3,1.4l-0.3,0.6l-0.1,0.1l-1.8,0.5l0.2-0.8l-2.5-1.2l0.1-0.2l0.4-1.1l-0.4-1l-0.4-0.9L522.6,73.1z	"
          >
            <title id="t1899">Strafford, NH</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "38340"
              ? `metroArea clickedArea state-ma`
              : `metroArea ${colorCode[38340]} state-ma`
          }
          id="FIPS_38340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25003"
            className="FIPS_38340 st0 state-ma"
            d="M506.1,87.9l2.2-0.5l1,2.2l0.1,0.2l0.1,1l0,1.1l-0.5,0v0.1l0.2,0.6l0.4,0.2l0.2,0l0-0.1
		l0.2,0.8l0,1.4l-0.4,0l0.1,0.6l0,0.1l0.4,0.6l-4.1,0.9l-0.1,0l-0.2-0.4l0.1-5.7L506.1,87.9z	"
          >
            <title id="t1185">Berkshire, MA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "44140"
              ? `metroArea clickedArea state-ma`
              : `metroArea ${colorCode[44140]} state-ma`
          }
          id="FIPS_44140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_25011"
            className="FIPS_44140 st0 state-ma"
            d="M513.5,86.3l1.6-0.3l0.6,1.3l0.2,1.1l-0.1,0.7l0.1,1.1l0.2,0.7l-0.8-0.8l-1.1,0.1l-0.5,0.2
		l-1.6,0.1l-1.6,0l-1.2-0.7l-1-2.2l0.9-0.2L513.5,86.3z	"
          >
            <title id="t1186">Franklin, MA</title>
          </path>
          <path
            id="FIPS_25013"
            className="FIPS_44140 st0 state-ma"
            d="M517.2,91.8l-0.2,0.6l0,0.1l0,0.2l0.7,0.1l0.6-0.2l0.4,1.7l-3.5,0.8l-4.6,1.1l-0.4,0.1
		l-0.4-0.6l0-0.1l-0.1-0.6l0.4,0l0-1.4l-0.2-0.8l0.3-0.5l0.5-0.1l0.1,0.1l0.3,0.8l-0.1,0.3l0.4,0.2l0.9,0.1l0.9,0l0.8-0.6l1.7-0.7
		L517.2,91.8z	"
          >
            <title id="t1183">Hampden, MA</title>
          </path>
          <path
            id="FIPS_25015"
            className="FIPS_44140 st0 state-ma"
            d="M516.1,90.8l1.2,1l-1.6,0.6l-1.7,0.7l-0.8,0.6l-0.9,0l-0.9-0.1l-0.4-0.2l0.1-0.3l-0.3-0.8
		l-0.1-0.1l-0.5,0.1l-0.3,0.5l0,0.1l-0.2,0l-0.4-0.2l-0.2-0.6V92l0.5,0l0-1.1l-0.1-1l-0.1-0.2l1.2,0.7l1.6,0l1.6-0.1l0.5-0.2
		l1.1-0.1L516.1,90.8z	"
          >
            <title id="t1184">Hampshire, MA</title>
          </path>
        </g>
        <path
          id="FIPS_25007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M534.8,97.5l1.5,0.3l0.1,0.3l0.1,0.5l0,0.1l-2.7,1l-0.3-0.2l0.4-1.1l0.1-0.2l0.3-0.3l0.3-0.4
		l0.1,0L534.8,97.5z M534.1,97.1l-0.8,1l-0.2,0.3l-0.6,0.5l-0.3,0.1l-0.1,0l0.4-0.4l0.8-0.9l0.4-0.5L534.1,97.1z	"
        >
          <title id="t1187">Dukes, MA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19060"
              ? `metroArea clickedArea state-md state-wv`
              : `metroArea ${colorCode[19060]} state-md state-wv`
          }
          id="FIPS_19060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_24001"
            className="FIPS_19060 st0 state-md state-wv"
            d="M466.1,136.7l0.4-0.1l0.3,1.1l-1,1.8l-1.9,0.1l-1.2-0.5l-1.6,2.2l-1.1-0.2l0.8-3.4l1.2-0.2
		L466.1,136.7z	"
          >
            <title id="t1188">Allegany, MD</title>
          </path>
          <path
            id="FIPS_54057"
            className="FIPS_19060 st0 state-md state-wv"
            d="M463.9,139.6l-2.4,4.4l-3.3-0.7l1.8-2.2l1.1,0.2l1.6-2.2L463.9,139.6z	"
          >
            <title id="t3114">Mineral, WV</title>
          </path>
        </g>

        <path
          id="FIPS_24023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.8,137.7l-0.8,3.4l-1.8,2.2l-1.6,1.9l-1.1-6.6l0.8-0.1L460.8,137.7z	"
        >
          <title id="t1189">Garrett, MD</title>
        </path>
        <path
          id="FIPS_24037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488.9,150.8l0.5,1.2l-0.5,1.1l-3.7-0.7l-0.4-0.5l-0.5-0.9l0-0.2l0.5-1.6l0.1-0.1l0.3,0l0.2,0
		l0.4,0.1L488.9,150.8z	"
        >
          <title id="t1190">St. Mary&apos;s, MD</title>
        </path>

        <path
          id="FIPS_24047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M499,146.8l2.9-0.6l0,0.5l0,0.3l0,0.5l0,0.4l-0.4,3l0,0.2l0,0.1l-0.1,0.2l0,0.1l-0.2,0.5
		l-3.7,1.2l0.6-1.4l-0.3-1.2l-0.9-1.1l2.4-0.7l0.3-0.7l0-0.3l-0.2-0.6L499,146.8z	"
        >
          <title id="t1192">Worcester, MD</title>
        </path>
        <path
          id="FIPS_24045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M495.2,146.2l0.1,0.5l0.1,0.4l0.1,0.4l0.3-0.1l0.7-0.1l0,0l0.3-0.1l0.6-0.1l0.2,0l0.5-0.1l0,0
		l0.1,0l0.2,0l0.4-0.1l0.1,0l0.4,0.5l0.2,0.6l0,0.3l-0.3,0.7l-2.4,0.7l-2.4,1l-0.6-0.2l0-1l0.3-2l0.1-0.1l0.2-0.1l0.2-0.2
		L495.2,146.2z	"
        >
          <title id="t1193">Wicomico, MD</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "25180"
              ? `metroArea clickedArea state-md state-wv`
              : `metroArea ${colorCode[25180]} state-md state-wv`
          }
          id="FIPS_25180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_24043"
            className="FIPS_25180 st0 state-md state-wv"
            d="M468.8,136.2l6.1-1.2l-0.1,0.7l-0.1,0.4l-0.1,0.1l-0.4,0.2l0,0.1l-0.1,0.9l0,1.2l-0.2,1.8
		l-0.4,0l-1.5-2l-2.2-1.2l-0.2-0.2l-0.5-0.3l-0.4-0.1l-0.4,0l-0.3,0l-0.1,0l-0.1,0.1l-0.3,0.4l-0.3,0.6l-0.1,0l-0.5-0.1l-0.3-1.1
		L468.8,136.2z	"
          >
            <title id="t1194">Washington, MD</title>
          </path>
          <path
            id="FIPS_54003"
            className="FIPS_25180 st0 state-md state-wv"
            d="M469.8,137.3l2.2,1.2l-0.1,0.6l-0.1,0.2l-0.5,0.8l-0.2,0.1l-0.1,0.1l-0.5,1.2l0,0.1l0,0.2
		l-2.2-1.3l0.4-2.7l0-0.1L469.8,137.3z	"
          >
            <title id="t3062">Berkeley, WV</title>
          </path>
          <path
            id="FIPS_54065"
            className="FIPS_25180 st0 state-md state-wv"
            d="M466.8,137.7l0.5,0.1l0.1,0l0.3-0.6l0.3-0.4l0.1-0.1l0.1,0l0.3,0l0.4,0l0.4,0.1l0.5,0.3
		l0.2,0.2l-1.1,0.5l0,0.1l-0.4,2.7l-1.3-0.7l-1.3-0.4L466.8,137.7z	"
          >
            <title id="t3116">Morgan, WV</title>
          </path>
        </g>

        <path
          id="FIPS_24041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.8,142.2l0.1,0.3l-0.1,1.8l-0.1,0.4l0,0l0.5,0.4l0.3,0.1l-1.9,1l0-0.1l-0.1-0.3l-1-0.8
		l-0.2,0l-0.5,0.2l0,0l-0.1,0.2v0.1l0.2,0.1l0,0.1l-0.2,0.1l-0.1-0.2l-0.1-0.9l0-0.3l0.2-0.7l0,0l0.3-0.3l0.7-0.1L491.8,142.2z	"
        >
          <title id="t1196">Talbot, MD</title>
        </path>
        <path
          id="FIPS_24011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.8,142.2l1.3-3.3l1.8,6.4l-2.4,0l-0.3-0.1l-0.5-0.4l0,0l0.1-0.4l0.1-1.8L491.8,142.2z	"
        >
          <title id="t1197">Caroline, MD</title>
        </path>
        <path
          id="FIPS_24029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M490,136.5l2.3-0.5l0.3,1l0.2,0.6l-1.3,0.2l-0.8,0.2l-0.3,0.1l-0.4,0.5l-0.7,1.7l-0.4,0.2
		l-0.3,0L488,140l0-0.3l0-0.2l0.4-1.9l0.1-0.2l0.5-0.6L490,136.5z	"
        >
          <title id="t1198">Kent, MD</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12580"
              ? `metroArea clickedArea state-md`
              : `metroArea ${colorCode[12580]} state-md`
          }
          id="FIPS_12580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_24003"
            className="FIPS_12580 st0 state-md"
            d="M485.3,139.6L485.3,139.6l1.2,1.1l0.6,1.1l0.1,0.1l-0.4,1l-0.2,0.8l-0.4,1.6l0.1,0.3l0.1,0.1
		l0.3,0.2l-0.7,0l-0.4-0.5l-0.2,0l-0.3,0.2l0,0.1l-0.4-2.1l-0.4-0.8l-1.7-1.2l1.1-1.7l0.7-0.5L485.3,139.6z	"
          >
            <title id="t1201">Anne Arundel, MD</title>
          </path>
          <path
            id="FIPS_24005"
            className="FIPS_12580 st0 state-md"
            d="M481.5,133.7l2.1-0.4l0.3,1.3l0.1,0.2l0.4,0.6l0.3,0.2l0.2,0l0.6,0.2l0.6,0.4l0.9,1.1l0,0.1h0
		l-0.2,0.1l-0.2,0.8l-0.1,0.6l0.2,0.1l0.1,0l0,0.1l0,0.1l-0.3,0.4l-0.1,0.2l-0.6-0.1l-0.3-0.1l0,0l0-1.5h-1.9l0.2,1.2l0.8,0.3
		l-0.7,0.5l-2.1-1.4l-0.4-1.3l0.2-1L481.5,133.7z	"
          >
            <title id="t1207">Baltimore Co., MD</title>
          </path>
          <path
            id="FIPS_24013"
            className="FIPS_12580 st0 state-md"
            d="M481.5,133.7l-0.2,2.5l-0.2,1l0.4,1.3l-2.8,0.5l0.2-1.5l0-0.4l0,0l-1.2-0.9l-0.8-0.7l0.4-1
		l2.1-0.4L481.5,133.7z	"
          >
            <title id="t1208">Carroll, MD</title>
          </path>
          <path
            id="FIPS_24025"
            className="FIPS_12580 st0 state-md"
            d="M486.8,132.6L486.8,132.6l2.1,1.9l0.4,1.1l0,0.1l-1,1.1l-0.4,0.4l-0.4,0.4l-0.3-0.2l-0.2-0.2
		l0-0.1l-0.9-1.1l-0.6-0.4l-0.6-0.2l-0.2,0l-0.3-0.2l-0.4-0.6l-0.1-0.2l-0.3-1.3L486.8,132.6z	"
          >
            <title id="t1206">Harford, MD</title>
          </path>
          <path
            id="FIPS_24027"
            className="FIPS_12580 st0 state-md"
            d="M481.6,138.6l2.1,1.4l-1.1,1.7l-0.5-0.3l-0.2,0.1l-0.4,0l-0.1,0l-2.1-1.4l-0.5-0.5l-0.2-0.3
		l0,0l0-0.1l0.1-0.1l0,0L481.6,138.6z	"
          >
            <title id="t1202">Howard, MD</title>
          </path>
          <path
            id="FIPS_24035"
            className="FIPS_12580 st0 state-md"
            d="M491.8,142.2l-2.2,1.5l-0.3-3.3l0.7-1.7l0.4-0.5l0.3-0.1l0.8-0.2l1.3-0.2l0.4,1.3L491.8,142.2
		z	"
          >
            <title id="t1204">Queen Anne&apos;s, MD</title>
          </path>
          <path
            id="FIPS_24510"
            className="FIPS_12580 st0 state-md"
            d="M485.3,139.6l-0.9-0.1l-0.8-0.3l-0.2-1.2h1.9L485.3,139.6z	"
          >
            <title id="t1199">Baltimore, MD</title>
          </path>
        </g>

        <path
          id="FIPS_24039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M494.5,150.6l2.4-1l0.9,1.1l0.3,1.2l-0.6,1.4l-0.3,0.6l-1.2,0l-0.9-2L494.5,150.6z
		 M492.7,152.6l0.3-0.1l0.1-0.3l0.1-0.3l0.1,0.3l0.1,0.4l0.1,0.2l0,0.1l-0.1,0l-0.1,0l-0.3-0.2L492.7,152.6z M493.5,154.6l-0.1-0.4
		l-0.1-0.4l0-0.1l0-0.1l0.2-0.1l0.1,0l0.1,0l0.3,0.1l0.1,0.1l0,0.1l-0.1,0.1l0,0.4l0.1,0.3l0,0.2l0,0.2l-0.3,0.1l-0.2-0.2
		L493.5,154.6z	"
        >
          <title id="t1210">Somerset, MD</title>
        </path>
        <path
          id="FIPS_24019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.5,145.3l2.4,0l0.3,0.9l-0.5,0.8l-0.2,0.2l-0.2,0.1l-0.1,0.1l-0.3,2l0,1l-1.2,0.4
		l-1.4,0.2l-0.1,0l-0.8-0.5l0,0l-0.1-0.3l-0.6-1.2l-0.3-0.7l0.1-1.5l0.1-0.1l0.2-0.2l0.1-0.1l0.8-0.2L492.5,145.3z M492.7,152.6
		L492.7,152.6L492.7,152.6l-0.1-0.2l-0.1-0.3l-0.1-0.5l0.1-0.2l0.2-0.1l0.3,0.3l0,0.1l0.1,0.2l-0.1,0.3l-0.1,0.3L492.7,152.6z	"
        >
          <title id="t1211">Dorchester, MD</title>
        </path>
        <path
          id="FIPS_23003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M533.3,31.8l-0.7-2.2l-7.7,2.2l-2.6,0.7l-0.2-1.5l0,0l0,0l0.2-0.7l0.7-1.9l1.3-3.7l1.7-5
		l0.7-0.1l0.8,0l0.1,0l0.2,0.2l0,0.1l-0.1,0.1l0,0l0,0.3l0.5,1.5l0.1,0.1l0.1,0l1.3,0.4l0.3-0.3l0.9-0.9l1-0.9l1.6-1.4l0.2-0.1
		l0.4-0.1l0.4,0l0.2,0l0.7,0.2l2.1,0.9l1.9,1.2l0,0.1l3,9.6l1.8,5.7l-0.1,0.2l0,0.1l0.3,1.3l0.2,0.1l-1.9,1.1l-1.7,1l0,0l0,0.1
		l-0.6,0.3l-0.6,0.4l-0.2,0l-0.6-2.1l-0.1-0.6l-0.3-1l-0.3-0.9l-1.7-5.4l-2.3,0.5L533.3,31.8z	"
        >
          <title id="t1212">Aroostook, ME</title>
        </path>
        <path
          id="FIPS_23021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M533.3,31.8l0.5,1.8l0.9,3.1l1.1,3.9l-1.1,0.6l0.5,1.9l0.9-0.5l1.8,3.3l-0.3,1.4l-2.4,1.3
		l-1.7,0.9l-1.2,1l-0.9,0.4l-0.6-1l-2.7-5.2l-0.3-2.8l0.4-1.6l-0.7-1.4l-0.6-0.7l-1.3-4.3l-0.5-2.3l7.7-2.2L533.3,31.8z	"
        >
          <title id="t1213">Piscataquis, ME</title>
        </path>
        <path
          id="FIPS_23013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M542.1,60.7L542,61l-0.1,0.1l-0.4,0.2l-0.1,0l-0.2,0l-0.8-0.8l0,0l0-0.2l0.1-0.3l0.5-0.6
		l0.2-0.1l0.1,0.1l0.8,1.1l0,0.1L542.1,60.7L542.1,60.7z M535.6,58.9l0.1-0.2l1-0.6l2.1,0.8l0.5,0.2l-0.1,0.9l0,0.1l0,0.1l0.1,0.5
		l0.1,0.3l0.3,0.3l-1,1.5l-0.7,0.5l-0.9,0.2l0.1-0.7l0.4-0.6l-0.4-0.9l-0.6-0.9l-0.3,0.1l-0.3,0l-0.3-0.1l-0.3-0.4l-0.2-0.6l0.1-0.2
		L535.6,58.9z	"
        >
          <title id="t1214">Knox, ME</title>
        </path>
        <path
          id="FIPS_23015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M533.2,62.1l1,0l-0.5-1.3l0-0.7l1,0l0.1-0.1l0.1-0.2l-0.1-0.8l0.9-0.1l-0.2,0.1l-0.1,0.2
		l0.2,0.6l0.3,0.4l0.3,0.1l0.3,0l0.3-0.1l0.6,0.9l0.4,0.9l-0.4,0.6l-0.1,0.7l-0.2,0l-0.2,0l-0.1,0.2l0,0l0,0.3l0.1,0.5l-0.2,0.9
		l-0.1,0.1l-1.2,0.5L535,66h-0.2L533.2,62.1z	"
        >
          <title id="t1215">Lincoln, ME</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "38860"
              ? `metroArea clickedArea state-me`
              : `metroArea ${colorCode[38860]} state-me`
          }
          id="FIPS_38860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_23005"
            className="FIPS_38860 st0 state-me"
            d="M527.1,65.3L527.1,65.3L527.1,65.3l0.4,0.2l0.5,0.1l2.8,0.4l0.2-0.3l0.2-0.7l0.2,0.3l0.4,0.2
		l0.5,0l0.2-0.3l0.5,0.9l0.2,1l-0.6,0.3l-0.5-0.3l-0.2-0.7l-0.1-0.1l-0.1,0l-0.9,1.1l-0.4,0.6l-0.2,1v0.1l0.2,0.2l0,1.3l-0.6,0.5
		l-0.4-0.1l-1.1-0.4l0.2-0.5l-1.1-0.7l-2.4-0.7l0.1-2l0.6-1.5l0.1,0.2l0.2,0.2l0.1,0l0.4,0.1L527.1,65.3z	"
          >
            <title id="t1217">Cumberland, ME</title>
          </path>
          <path
            id="FIPS_23023"
            className="FIPS_38860 st0 state-me"
            d="M533.2,62.1l1.6,3.8l-1.5,1l-0.2-1l-0.5-0.9l-0.2,0.3l-0.5,0l-0.4-0.2l-0.2-0.3l-0.3-1.9
		l0.7,0l0.3-0.2l0-0.3l0-0.1l0.1-0.1l0.1-0.1l0.9,0L533.2,62.1L533.2,62.1z	"
          >
            <title id="t1216">Sagadahoc, ME</title>
          </path>
          <path
            id="FIPS_23031"
            className="FIPS_38860 st0 state-me"
            d="M525.1,68.7l2.4,0.7l1.1,0.7l-0.2,0.5l1.1,0.4l0.4,0.1l0,0.9l-1.1,5.1l-0.1,0.5l0,0.1
		l-0.2,0.2l-1.3-0.5l-0.3-1.4l0,0l-1.1-0.7l-0.5-0.2l-0.2-0.1l-0.3-0.4l-0.1-0.2l-0.1-0.3l-0.2-1.8l-1.1-3L525.1,68.7z	"
          >
            <title id="t1218">York, ME</title>
          </path>
        </g>
        <path
          id="FIPS_23001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M527.8,59.3l0.9-0.6l0.6,1.2l0.9,2.2l0.9,0.8l0.3,1.9l-0.2,0.7l-0.2,0.3l-2.8-0.4l-0.5-0.1
		l-0.3-0.1l0,0l0,0l-0.1-0.3l0.8-2.2l0.1-0.4v-1.7l-0.3-0.6l0-0.3L527.8,59.3z	"
        >
          <title id="t1219">Androscoggin, ME</title>
        </path>
        <path
          id="FIPS_23017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M519.8,50.8l0.7,1.6l0.2,1.4l1.4,3.4l1.1-1.2l1.5,1.8l2.2,0.2l0.5,0.7l0.3,0.5l-0.3,0.3l0,0.3
		l0.3,0.6v1.7l-0.1,0.4l-0.8,2.2l0.1,0.3l-0.5,0.5l-0.4-0.1l-0.1,0l-0.2-0.2l-0.1-0.2l-0.6,1.5l-0.1,2l-1.8,0.8l-1.8-6.1l-1.7-5.4
		l-0.1-0.4l-1.9-5.8l-0.3-1l0.6-0.3l1.2,0.7l0.1,0.1l0.3,0h0l0.1-0.1l0,0L519.8,50.8z	"
        >
          <title id="t1220">Oxford, ME</title>
        </path>
        <path
          id="FIPS_23011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M530,56.7l1-0.2l2-0.2l0.1-0.1l0-0.6l-0.3-0.2l-0.1,0l-0.2-0.2l-0.1-0.2l0-0.1l1.2-0.6l0.1,0
		l0.1,0.1l0,0.2l0.3,0.5l0.6-0.1l0.5,1.1l0.1,1.1l-0.5,0l-0.1,1.7l0.1,0.8l-0.1,0.2l-0.1,0.1l-1,0l0,0.7l0.5,1.3l-1,0l0-0.1
		l-0.1-0.1l-0.9,0l-0.1,0.1l-0.1,0.1l0,0.1l0,0.3l-0.3,0.2l-0.7,0l-0.9-0.8l-0.9-2.2l-0.6-1.2L530,56.7z	"
        >
          <title id="t1221">Kennebec, ME</title>
        </path>
        <path
          id="FIPS_23027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M535.5,53.6l0.5-0.3l0.5,1l2.8-1.6l0.3,0.2l-0.1,0.8l0,0.1l0.1,0.1l0.2,0.1l0.3,0.3l0.3,0.9
		l0,0.2l0,0.1l-0.1,0.1l-1,0.7l-0.4,0.3l0,0.2l0.1,0.2l0.1,0.1l0.1,0l0.1,0.1l0.2,0.2l0.1,0.4v0.1l-0.4,1.3l-0.5-0.2l-2.1-0.8
		l-1,0.6l-0.1,0.2l-0.9,0.1l0.1-1.7l0.5,0l-0.1-1.1l-0.5-1.1l-0.6,0.1l-0.3-0.5L535.5,53.6z	"
        >
          <title id="t1222">Waldo, ME</title>
        </path>
        <path
          id="FIPS_23009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M542.2,57.6L542.2,57.6l0.1,0l0.5,0.1l0.1,0.1l0.1,0.2l0.1,0.6L543,59l-0.2,0.3l0,0l-0.1,0
		l-0.4-0.2l-0.1-0.1l-0.2-0.6l0,0l0-0.1l0.1,0l0.1-0.1l0.1-0.4v-0.1L542.2,57.6L542.2,57.6z M544.7,55.6l0.5-0.4l0.4-0.2l0.5,0l0,0
		l0.2,0.2l0.2,0.3l0.1,0.2l-0.1,0.3l0,0l0,0l-0.3,0.3l-0.4,0.1l-0.1,0.1l0,0.1l0,0.1l0,0l0,0l0.1,0.2l-0.2,0.4l-0.2,0.1l-0.7-0.2
		l-0.2-0.2l-0.2-0.3l0-0.2l0.1-0.4l0.2-0.4L544.7,55.6z M539.6,53l0.3-0.1l0.5-0.3l0.2-0.4l0.6-0.4l1.4-0.7l-1-1.9l-0.3-0.6l1-0.5
		l0.5-1.5l-0.7-1.4l2-1.1l0.8,1.5l0.7,1.4l0.2,0.6l-0.9,0.5l1.1,2l0.6,1l0.3,0.7l0,0.4l0.6,1l0.3,0.5l0.2,0.4l0.1,0.1l0,0.2
		l-0.1,0.2l-0.1,0l0,0l-0.1-0.1l-0.1,0.2l0,0.2l0,0.2l0,0.2l0,0.1v0.1l-0.1,0h0l-0.1,0l-0.5-0.5l-0.1-0.2l-0.2-0.5l0-0.2l0-0.1
		l0-0.1l-0.1,0l-0.3,0l-0.3,0.1l-0.3,0.1l-0.3,0.1l0,0.5l-0.3,0.3l-0.3,0.2l-0.2,0.2l-0.2,0.3l0,0l-0.1,0l-0.1,0l-0.1-0.3l0-0.2
		l-0.1-0.1l-0.1,0l-0.1,0l0,0.1l0,0.1l0.1,0.3l0.1,0.4l0,0l-0.1,0l-0.1-0.1l0-0.1l-0.2-0.2l-0.2,0.3l-0.1,0.4l0.1,0.7l0,0.1l0,0.1
		l0.1,0.1l0.2,0l0.1,0.1l0.2,0.3l0,0.1l0.1,0.3l0,0.1h-0.1l-0.2,0l0,0l-0.1-0.1l-0.5-0.2l-0.3-0.1l-1-0.2l-0.4,0.1l-0.2,0.2l-0.3,0
		l0-0.1l-0.3-1.2l0-0.3l0,0l0.1-0.1l0-0.4l0-0.1l-0.1,0.1l0-0.1l0-0.2l-0.3-0.9l-0.3-0.3l-0.2-0.1l-0.1-0.1l0-0.1L539.6,53z	"
        >
          <title id="t1223">Hancock, ME</title>
        </path>
        <path
          id="FIPS_23029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M544.7,38l3,0.1l0.1-0.1L548,38l0.1,0l0.3,0.2l0,0.1l0.7,2.4l0.1,0.5l-0.1,0.6l0,0.1l-0.2,0.1
		l0,0.1l0.4,0.4l0.8,0.8l0.5,0.3l0,0l0,0l0.1,0l0,0l0.2-0.3l0-0.2v-0.4l0-0.1l0.1,0l1.1,0h0l0.4,0.3l0.2,0.2l1.9,2.3l0.2,0.4
		l0.2,0.6l0,0.1l-0.2,0.6l-0.8,1.6l-0.2,0.4l-0.6,0.7l-0.3,0.1l-1.2,0.6l-3,3.2l-0.4,0.2l-0.3,0.1l-0.1,0l-0.1-0.1l-0.2-0.4
		l-0.3-0.5l-0.6-1l0-0.4l-0.3-0.7l-0.6-1l-1.1-2l0.9-0.5l-0.2-0.6l-0.7-1.4l-0.8-1.5l0.3-0.1l0.7-0.4l-0.5-1l-1.9-3.3L544.7,38z	"
        >
          <title id="t1224">Washington, ME</title>
        </path>
        <path
          id="FIPS_23019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M542.7,39.1l1.9,3.3l0.5,1l-0.7,0.4l-0.3,0.1l-2,1.1l0.7,1.4l-0.5,1.5l-1,0.5l0.3,0.6l1,1.9
		l-1.4,0.7l-0.6,0.4l-0.2,0.4l-0.5,0.3l-0.3,0.1l-0.3-0.2l-2.8,1.6l-0.5-1l-0.5,0.3l-2-4.1l1.7-0.9l2.4-1.3l0.3-1.4l-1.8-3.3
		l-0.9,0.5l-0.5-1.9l1.1-0.6l-1.1-3.9l-0.9-3.1l-0.5-1.8l1.1-0.3l2.3-0.5l1.7,5.4l0.3,0.9l0.3,1l0.1,0.6l0.6,2.1l0.2,0l0.6-0.4
		l0.6-0.3l0-0.1l0,0L542.7,39.1z	"
        >
          <title id="t1225">Penobscot, ME</title>
        </path>
        <path
          id="FIPS_23007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M520.9,45.1l1.2,2.6l1.7,3.5l1.1,0l1-0.3l0.2-0.1l3.3,5.1l0.5,0.8l-1.3,2l-0.9,0.6l-0.3-0.5
		l-0.5-0.7l-2.2-0.2l-1.5-1.8l-1.1,1.2l-1.4-3.4l-0.2-1.4l-0.7-1.6l0-0.4l0-0.4l0.1-2.6l0.1-0.7l0.1-0.2l0.1-0.2l0.2-0.4l0.3-0.6
		l0,0L520.9,45.1z	"
        >
          <title id="t1226">Franklin, ME</title>
        </path>
        <path
          id="FIPS_23025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M524.9,31.8l0.5,2.3l1.3,4.3l0.6,0.7l0.7,1.4l-0.4,1.6l0.3,2.8l2.7,5.2l0.6,1l0.9-0.4l1.2-1
		l2,4.1l-1.7,0.9l0-0.2l-0.1-0.1l-0.1,0l-1.2,0.6l0,0.1l0.1,0.2l0.2,0.2l0.1,0l0.3,0.2l0,0.6l-0.1,0.1l-2,0.2l-1,0.2l-0.5-0.8
		l-3.3-5.1l-0.2,0.1l-1,0.3l-1.1,0l-1.7-3.5l-1.2-2.6L521,45l0.5-0.6l1.2-2.8l0-0.2l0-0.5l-0.1-0.1l-0.1-0.1h-0.4l-0.2-0.6l-0.1-0.6
		l-0.3-1.6l0.1-0.9l0.1-1l0,0l0.1-0.3l0.1-0.1l0,0l0,0l0.3-0.2l0.5-0.8l-0.1-0.8l-0.2-1.2L524.9,31.8z	"
        >
          <title id="t1227">Somerset, ME</title>
        </path>
        <path
          id="FIPS_26053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.8,59.8l0.2,0l0.1,2.2l1.2,1.1l3.3-0.2l0.2,2.2l3.3-0.2l0.2,3l-0.6-0.3l-0.6-0.2l-0.4-0.1
		l-0.5-0.1l-6.5-1.3l-0.9-0.2l-0.8-0.2l-1.8-2.2l-1-0.6l0.6-0.5l0.2-0.1l1.4-0.6l0.6-0.2l0.5-0.2l0.1-0.1l0.3-0.3l0.6-0.6
		L347.8,59.8z	"
        >
          <title id="t1228">Gogebic, MI</title>
        </path>
        <path
          id="FIPS_26131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356,55.8l0.3,3.4l0.6,0l0.1,1.1l-1.1,0.1l0.1,1.5l0.1,1.9l0.1,1.1l-3.3,0.2l-0.2-2.2
		l-3.3,0.2l-1.2-1.1l-0.1-2.2l-0.2,0l0.3-0.4l0.1-0.1l0.4-0.2l0.6-0.2l0.4-0.1l0.1,0l0.2,0.1l1.8-0.3l0.2-0.1l0.4-0.2l3.2-2
		L356,55.8z	"
        >
          <title id="t1229">Ontonagon, MI</title>
        </path>
        <path
          id="FIPS_26115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.9,114.3l1.1-0.2l1.2-0.2l0.1,0l1.1,0.7l-1.1,1.4l-0.5,0.9l-0.4,0.7l0,0.1l0,0.1l0,1
		l-2.9,0.5l-0.7-4.6L411.9,114.3z	"
        >
          <title id="t1230">Monroe, MI</title>
        </path>
        <path
          id="FIPS_26091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.7,114.6l0.7,4.6l-1.1,0.2l-4.5,0.7l-0.6-4.7l2.2-0.3L409.7,114.6z	"
        >
          <title id="t1231">Lenawee, MI</title>
        </path>
        <path
          id="FIPS_26059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.1,115.4l0.6,4.7l-0.4,0.1l-3.9,0.6l-0.3-0.8l-0.5-4l1.1-0.1L404.1,115.4z	"
        >
          <title id="t1232">Hillsdale, MI</title>
        </path>
        <path
          id="FIPS_26023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.3,116.5l4.4-0.5l0.5,4l-3.5,0.4l-0.9,0.1L395.3,116.5z	"
        >
          <title id="t1233">Branch, MI</title>
        </path>
        <path
          id="FIPS_26149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.9,117l4.4-0.5l0.5,4l-3.5,0.4L391,121L390.9,117z	"
        >
          <title id="t1234">St. Joseph, MI</title>
        </path>

        <path
          id="FIPS_26021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385,115.3l1.6,2.1l0.4,4l-2.8,0.3l-2.9,0.3l0,0l0.4-0.4l0.5-0.5l0.3-0.4l0.5-0.7l0.2-0.3
		l0.1-0.3l0.2-0.8l0.5-1.4l0.2-0.4L385,115.3z	"
        >
          <title id="t1236">Berrien, MI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "11460"
              ? `metroArea clickedArea state-mi`
              : `metroArea ${colorCode[11460]} state-mi`
          }
          id="FIPS_11460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_26161"
            className="FIPS_11460 st0 state-mi"
            d="M411.2,109.8l0.7,4.5l-2.2,0.3l-3.4,0.6l-0.6-4.5l4.4-0.7L411.2,109.8z	"
          >
            <title id="t1238">Washtenaw, MI</title>
          </path>
        </g>
        <path
          id="FIPS_26075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.7,110.6L405.7,110.6l0.7,4.5l-2.2,0.3l-3.3,0.4l-0.6-4.5l1.1-0.1L405.7,110.6z	"
        >
          <title id="t1239">Jackson, MI</title>
        </path>
        <path
          id="FIPS_26025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M396.9,111.7l3.3-0.4l0.6,4.5l-1.1,0.1l-4.4,0.5l-0.6-4.5L396.9,111.7z	"
        >
          <title id="t1240">Calhoun, MI</title>
        </path>
        <path
          id="FIPS_26077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.5,112.2l2.3-0.2l0.6,4.5l-4.4,0.5l-0.5-4.5L392.5,112.2z	"
        >
          <title id="t1241">Kalamazoo, MI</title>
        </path>
        <path
          id="FIPS_26159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.6,113l4.8-0.5l0.5,4.5l-4.4,0.4l-1.6-2.1L385.6,113z	"
        >
          <title id="t1242">Van Buren, MI</title>
        </path>
        <path
          id="FIPS_26005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.7,108l2.2-0.2l0.5,4.5l-2.1,0.2l-4.8,0.5l0.1-4.6L389.7,108z	"
        >
          <title id="t1243">Allegan, MI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "24340"
              ? `metroArea clickedArea state-mi`
              : `metroArea ${colorCode[24340]} state-mi`
          }
          id="FIPS_24340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_26015"
            className="FIPS_24340 st0 state-mi"
            d="M396.4,107.2l0.5,4.5l-2.1,0.3l-2.3,0.2l-0.5-4.5l2.2-0.3L396.4,107.2z	"
          >
            <title id="t1244">Barry, MI</title>
          </path>
          <path
            id="FIPS_26067"
            className="FIPS_24340 st0 state-mi"
            d="M393.6,103l4.4-0.5l0.5,4.5l-2.2,0.3l-2.2,0.3L393.6,103z	"
          >
            <title id="t1255">Ionia, MI</title>
          </path>
          <path
            id="FIPS_26081"
            className="FIPS_24340 st0 state-mi"
            d="M388.9,101.2l2.1-0.3l2.3-0.3l0.3,2.3l0.5,4.5l-2.2,0.3l-2.2,0.2l-0.2-1.9l-0.2-1.5l-0.3-2.2
		L388.9,101.2z	"
          >
            <title id="t1258">Kent, MI</title>
          </path>
          <path
            id="FIPS_26123"
            className="FIPS_24340 st0 state-mi"
            d="M390.3,94.3l0.5,4.5l0.2,2.2l-2.1,0.3l-2.3,0.2l-0.2-2.2l-0.5-4.5L390.3,94.3z	"
          >
            <title id="t1269">Newaygo, MI</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19820"
              ? `metroArea clickedArea state-mi`
              : `metroArea ${colorCode[19820]} state-mi`
          }
          id="FIPS_19820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_26087"
            className="FIPS_19820 st0 state-mi"
            d="M410.7,99.5l0-0.1l0.8-1.3l2.2-0.4l0.1,0.6l1.1-0.2l0.3,1.7l0.6,3.3l-1.1,0.2l-3.3,0.6
		L410.7,99.5z	"
          >
            <title id="t1251">Lapeer, MI</title>
          </path>
          <path
            id="FIPS_26093"
            className="FIPS_19820 st0 state-mi"
            d="M409.4,105.5l0.8,4.5l-4.4,0.7l-0.1,0l-0.7-4.5l2.2-0.3L409.4,105.5z	"
          >
            <title id="t1247">Livingston, MI</title>
          </path>
          <path
            id="FIPS_26125"
            className="FIPS_19820 st0 state-mi"
            d="M414.6,103.4l0.9,5.6l-4.4,0.7l-1,0.2l-0.8-4.5l-0.2-1.1l1.1-0.2l1.1-0.2L414.6,103.4z	"
          >
            <title id="t1248">Oakland, MI</title>
          </path>
          <path
            id="FIPS_26099"
            className="FIPS_19820 st0 state-mi"
            d="M415.7,103.2l2.3-0.4l0.4,2.4l0,0.3l-0.9,3.2l-2,0.3l-0.9-5.6L415.7,103.2z	"
          >
            <title id="t1249">Macomb, MI</title>
          </path>
          <path
            id="FIPS_26147"
            className="FIPS_19820 st0 state-mi"
            d="M415.1,99.8l4.6-0.8l0,0.1l0.2,0.5l0.1,0.2l0.8,1.1l-0.1,3.6l-0.1,1.3l0,0.3l0,0.1l-0.5,0.8
		l0,0.1l-0.2,0l-0.5,0.1l-0.5-0.5l0-0.1l0.2-0.4l0.2-0.2l0.2,0.1l0.1-0.2l0-0.1l0-0.1l0-0.1l-0.1-0.1l0,0l-0.4-0.1l-0.1,0l-0.1,0
		l-0.2,0.1l0,0l0-0.3l-0.4-2.4l-2.3,0.4L415.1,99.8z	"
          >
            <title id="t1250">St. Clair, MI</title>
          </path>
          <path
            id="FIPS_26163"
            className="FIPS_19820 st0 state-mi"
            d="M415.6,109l2-0.3l-0.1,0.7l0,0.1l-0.2,0.5l-0.3,0.2l-0.3,0.1l-0.2,0.1l0,0l-0.4,0.2l-0.1,0.1
		l-0.1,0.3l-0.2,0.7l0,0v0l0.1,0.7l-0.1,1.2l-0.2,0.8l-1.1-0.7l-0.1,0L413,114l-1.1,0.2l-0.7-4.5L415.6,109z	"
          >
            <title id="t1237">Wayne, MI</title>
          </path>
        </g>
        <path
          id="FIPS_26049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.5,99.8l2.2-0.3l0.7,4.4l-1.1,0.2l-1.1,0.2l0.2,1.1l-2.2,0.3l-0.6-4.5L408.5,99.8z	"
        >
          <title id="t1252">Genesee, MI</title>
        </path>
        <path
          id="FIPS_26155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.5,101.3l0.6,4.5l-2.2,0.3l-1.9,0.2l-0.6-4.4l0-0.1L406.5,101.3z	"
        >
          <title id="t1253">Shiawassee, MI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "29620"
              ? `metroArea clickedArea state-mi`
              : `metroArea ${colorCode[29620]} state-mi`
          }
          id="FIPS_29620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_26037"
            className="FIPS_29620 st0 state-mi"
            d="M402.4,102l0.6,4.4l-2.2,0.4l-2.2,0.3l-0.5-4.5L402.4,102z	"
          >
            <title id="t1254">Clinton, MI</title>
          </path>
          <path
            id="FIPS_26045"
            className="FIPS_29620 st0 state-mi"
            d="M398.6,107l2.2-0.3l0.6,4.5l-1.1,0.1l-3.3,0.4l-0.5-4.5L398.6,107z	"
          >
            <title id="t1245">Eaton, MI</title>
          </path>
          <path
            id="FIPS_26065"
            className="FIPS_29620 st0 state-mi"
            d="M403,106.4l1.9-0.2l0.7,4.5l-4.3,0.6l-0.6-4.5L403,106.4z	"
          >
            <title id="t1246">Ingham, MI</title>
          </path>
        </g>
        <path
          id="FIPS_26139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389,102.4l0.3,2.2l0.2,1.5l0.2,1.9l-4,0.4l-1.1-4.5l1.4-0.1l2-0.2l-0.1-1.1L389,102.4z	"
        >
          <title id="t1256">Ottawa, MI</title>
        </path>
        <path
          id="FIPS_26121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.4,99.6l3.9-0.3l0.2,2.2l2.3-0.2l0.1,1.1l-1.1,0.1l0.1,1.1l-2,0.2l-1.4,0.1l-0.1-0.2
		l-0.4-0.7l-0.9-1.5l-0.1-0.3l-0.3-0.7l-0.2-0.4L382.4,99.6z	"
        >
          <title id="t1257">Muskegon, MI</title>
        </path>

        <path
          id="FIPS_26117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.5,98l0.6,4.5l-4.4,0.5l-0.3-2.3l-2.3,0.3l-0.2-2.2l4.4-0.5L397.5,98z	"
        >
          <title id="t1259">Montcalm, MI</title>
        </path>
        <path
          id="FIPS_26057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M399.7,97.8l2.2-0.3l0.6,4.3l0,0.1l-4.4,0.5l-0.6-4.5L399.7,97.8z	"
        >
          <title id="t1260">Gratiot, MI</title>
        </path>
        <path
          id="FIPS_26145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.1,96.5l0.5,3.3l-2,1.4l-4.1,0.6l-0.6-4.3l0-0.2l1.8-0.2l-0.1-1.1l1.1-0.1l0.4,0.3
		l0.7,0.1l1.2-0.1l0.4,0.3L408.1,96.5z	"
        >
          <title id="t1261">Saginaw, MI</title>
        </path>
        <path
          id="FIPS_26151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.1,93.3l4.7-0.8l0,0.3l0.2,0.8l0,0.2l1.4,4.6l0.1,0.2l0.2,0.6l-4.6,0.8l-0.3-1.7l-1.1,0.2
		l-0.1-0.6L413.1,93.3z	"
        >
          <title id="t1262">Sanilac, MI</title>
        </path>
        <path
          id="FIPS_26157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.8,93.1l0.1,0.8l3.2-0.5l0.6,4.5l-2.2,0.4l-0.8,1.3l0,0.1l-2.2,0.3l-0.5-3.3l-0.2-1.5
		L409.8,93.1z	"
        >
          <title id="t1263">Tuscola, MI</title>
        </path>
        <path
          id="FIPS_26063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.1,93.3l-3.2,0.5l-0.1-0.8l0-0.1l0.1-0.5l0.3-0.8l1.1-1.9l2.5-1.6l0.5-0.1l1.2,0.5
		l0.5,0.3l0.1,0.1l0.3,0.5l0.8,1.1l0.1,0.3l0.3,0.8l0.1,0.4l0.1,0.6L413.1,93.3z	"
        >
          <title id="t1264">Huron, MI</title>
        </path>
        <path
          id="FIPS_26017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.9,90.4l1.1-0.1l0.1,1.1l1.2-0.1l-0.1,2l1.4,1.3l1.1,0.5l0.2,1.5l-0.8-0.1l-0.4-0.3
		l-1.2,0.1l-0.7-0.1l-0.4-0.3l-1.1,0.1l-0.4-3.3L402.9,90.4z	"
        >
          <title id="t1265">Bay, MI</title>
        </path>
        <path
          id="FIPS_26111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M399.1,93.3l2.2-0.3l0-0.2l1.8-0.2l0.4,3.3l0.1,1.1l-1.8,0.2l0,0.2l-2.2,0.3L399.1,93.3z	"
        >
          <title id="t1266">Midland, MI</title>
        </path>
        <path
          id="FIPS_26073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M399.1,93.3l0.5,4.5l-2.2,0.3l-2.2,0.3l-0.5-4.5L399.1,93.3z	"
        >
          <title id="t1267">Isabella, MI</title>
        </path>
        <path
          id="FIPS_26107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390.3,94.3l4.4-0.5l0.5,4.5l-4.4,0.5L390.3,94.3z	"
        >
          <title id="t1268">Mecosta, MI</title>
        </path>

        <path
          id="FIPS_26127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.3,95.1l3.6-0.3l0.5,4.5l-3.9,0.3l-0.7-1.3l-0.1-0.2l-0.1-0.3l0-0.2l0-0.1l0-0.2l0.1-0.3
		l0.1-0.3l0.2-0.4l0.2-0.3l0.1-0.3l0-0.2L382.3,95.1L382.3,95.1z	"
        >
          <title id="t1270">Oceana, MI</title>
        </path>
        <path
          id="FIPS_26011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.1,87.6l0,0.5l0,0.3l0,0.6l-0.8,0.9l-0.8,0.2l-0.2,0H406l-0.2,0.1l-0.1,0.1l-0.2,0.3
		l-0.2,0.6l0,0.1l-1.2,0.1l-0.1-1.1l-1.1,0.1l-0.3-2.1l2.6-0.3L408.1,87.6z	"
        >
          <title id="t1271">Arenac, MI</title>
        </path>
        <path
          id="FIPS_26051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M402.6,88.3l0.5,4.3l-1.8,0.2l0,0.2l-2.2,0.3l-0.6-4.4l2.2-0.3L402.6,88.3z	"
        >
          <title id="t1272">Gladwin, MI</title>
        </path>
        <path
          id="FIPS_26035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M396.4,89.1l2.2-0.3l0.6,4.4l-4.5,0.5l-0.5-4.5L396.4,89.1z	"
        >
          <title id="t1273">Clare, MI</title>
        </path>
        <path
          id="FIPS_26133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M394.2,89.3l0.5,4.5l-4.4,0.5l-0.5-4.5l2.1-0.2L394.2,89.3z	"
        >
          <title id="t1274">Osceola, MI</title>
        </path>
        <path
          id="FIPS_26085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.8,89.8l0.5,4.5l-4.4,0.5l-0.5-4.5l2-0.2L389.8,89.8z	"
        >
          <title id="t1275">Lake, MI</title>
        </path>
        <path
          id="FIPS_26105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M382.2,90.4l3.2-0.2l0.5,4.5l-3.6,0.3l-0.5-1.9l0.1-1.9L382.2,90.4z	"
        >
          <title id="t1276">Mason, MI</title>
        </path>
        <path
          id="FIPS_26069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.6,83.6l5.2-0.7l0,0.3l0.1,0.9l-0.1,1.1l-0.8,0.9l-0.2-0.1l-0.1,0l-0.2,0.1l-0.1,0
		l-0.1,0.2l-0.1,0.2l-0.1,0.3l0,0.8l-2.9,0.4L404.6,83.6z	"
        >
          <title id="t1277">Iosco, MI</title>
        </path>
        <path
          id="FIPS_26129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.6,83.6l0.6,4.4l-2.6,0.3l-1.9,0.2l-0.6-4.4L404.6,83.6z	"
        >
          <title id="t1278">Ogemaw, MI</title>
        </path>
        <path
          id="FIPS_26143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.8,84.6l4.4-0.5l0.6,4.4l-2.2,0.3l-2.2,0.3L395.8,84.6z	"
        >
          <title id="t1279">Roscommon, MI</title>
        </path>
        <path
          id="FIPS_26113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.8,84.6l0.5,4.5l-2.2,0.2l-2.3,0.3l-0.5-4.5L395.8,84.6z	"
        >
          <title id="t1280">Missaukee, MI</title>
        </path>
        <path
          id="FIPS_26165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387,85.6l4.4-0.5l0.5,4.5l-2.1,0.2l-2.4,0.3L387,85.6z	"
        >
          <title id="t1281">Wexford, MI</title>
        </path>
        <path
          id="FIPS_26101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M387,85.6l0.4,4.5l-2,0.2l-3.2,0.2l0.9-2.3l0.1-0.7l0-0.3l0-1.3L387,85.6z	"
        >
          <title id="t1282">Manistee, MI</title>
        </path>
        <path
          id="FIPS_26001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404,79.1l5.1-0.7l0.2,0.3l0.4,1.5l0,0.3l-0.1,2.3l-5.2,0.7L404,79.1z	"
        >
          <title id="t1283">Alcona, MI</title>
        </path>
        <path
          id="FIPS_26135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M399.7,79.7l4.4-0.6l0.6,4.5l-4.4,0.6L399.7,79.7z	"
        >
          <title id="t1284">Oscoda, MI</title>
        </path>
        <path
          id="FIPS_26039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.3,80.1l4.3-0.5l0.6,4.5l-4.4,0.5L395.3,80.1z	"
        >
          <title id="t1285">Crawford, MI</title>
        </path>
        <path
          id="FIPS_26079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.3,80.1l0.5,4.5l-4.4,0.5l-0.4-3.9l0-0.4l0-0.1l0.3-0.1L395.3,80.1z	"
        >
          <title id="t1286">Kalkaska, MI</title>
        </path>
        <path
          id="FIPS_26055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M390,80.6l1,0.6l0.4,3.9l-4.4,0.5l-0.3-3.4l1.6-0.2L390,80.6z	"
        >
          <title id="t1287">Grand Traverse, MI</title>
        </path>
        <path
          id="FIPS_26019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M386.6,82.2l0.3,3.4l-3.8,0.3l0-0.4l0-0.2l-0.1-0.4l-0.1-0.2l-0.3-0.5l-0.1-0.2l0-0.3l0-0.1
		l0-0.1l0.1-0.1l0.5-0.2l0.6-0.2l0.1-0.2l0.1-0.2l0-0.2l0-0.1L386.6,82.2z	"
        >
          <title id="t1288">Benzie, MI</title>
        </path>
        <path
          id="FIPS_26089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M388.2,82l-1.6,0.2l-2.4,0.2l-0.1-1.1l0.3-0.6l0.7-0.7l1.5-0.9l0.2-0.5l1-1.9l0.6-0.4l0.1,0
		l0.2,0.3l-0.5,3.5l0,0l-0.1,0.5l0,0.1l0,0.3l0,0.2L388.2,82z	"
        >
          <title id="t1289">Leelanau, MI</title>
        </path>
        <path
          id="FIPS_26007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408,74l0.7,0.8l0.7,1.4l0,0l-0.2,0l-0.5-0.1l-0.2-0.1l-0.1-0.1l-0.3-0.1l-0.3,0.2l-0.1,0.1
		l-0.1,0.2l0,0l0.1,0.5l0.1,0.5l0.1,0.1l0.1,0.1l0.1,0.1l0.3,0.3l0.7,0.5l-5.1,0.7l-0.3-2l0-0.2l0-0.1l-0.3-2.2L408,74z	"
        >
          <title id="t1290">Alpena, MI</title>
        </path>
        <path
          id="FIPS_26119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.5,74.7l0.3,2.2l0,0.1l0,0.2l0.3,2l-4.4,0.6l-0.5-4.4l1.1-0.1L403.5,74.7z	"
        >
          <title id="t1291">Montmorency, MI</title>
        </path>
        <path
          id="FIPS_26137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.8,75.6l3.3-0.4l0.5,4.4l-4.3,0.5l-0.5-3.3L395.8,75.6z	"
        >
          <title id="t1292">Otsego, MI</title>
        </path>
        <path
          id="FIPS_26009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.9,76.2l0.1,0l1.4-0.1l0.1,0.9l0.4,0.2l1.7-0.2l1.3-0.1l0.5,3.3l-4,0.5l-0.3,0.1l0,0.1
		l0,0.4l-1-0.6l0.1-0.2l0.1-0.4l0.1-0.3l0.1-0.9l0-0.9l-0.1-0.6L389.9,76.2z	"
        >
          <title id="t1293">Antrim, MI</title>
        </path>
        <path
          id="FIPS_26029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.5,73.9l0.6,0.8l0.5,0l2.1-0.2l0.1,1.1l-1,1.2l-1.3,0.1l-1.7,0.2l-0.4-0.2l-0.1-0.9
		l-1.4,0.1l-0.1,0l-0.1-0.4l0.1-0.5l0.1-0.2l0.3-0.3l0.1-0.1l0.8-0.7l0.1-0.1l0.5-0.2L392.5,73.9z	"
        >
          <title id="t1294">Charlevoix, MI</title>
        </path>
        <path
          id="FIPS_26141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408,74l-4.5,0.6l-3.3,0.5l-0.4-3l-0.3-2.5l0.4-0.1l0.8,1l3.1,1.2l2,0.6l0.3,0l0.5-0.1
		l0.1-0.2l0.1,0l0.5,0.5L408,74z	"
        >
          <title id="t1295">Presque Isle, MI</title>
        </path>
        <path
          id="FIPS_26031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.7,74.5l-0.8-6.4l0.2,0.3l2.5,1.2l0.8-0.1l0.4-0.2l1.1,0.3l0.1,0.1l-0.4,0.1l0.3,2.5
		l0.4,3l-1.1,0.1l-3.3,0.4L395.7,74.5z	"
        >
          <title id="t1296">Cheboygan, MI</title>
        </path>
        <path
          id="FIPS_26047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.7,74.5l-2.1,0.2l-0.5,0l-0.6-0.8l0.5-0.1l0.6-0.2l0.4-0.3l0-0.1l0-0.1l0-0.1l-0.1,0
		l-0.5,0l-0.1,0.1l-0.5-0.1l-0.3-0.3l-0.2-0.2l-0.3-0.5l-0.1-0.2l-0.1-0.4v-0.1l0-0.1l0.3-0.6l0.1-0.1l1-1l1.2-0.6l0.1-0.1l0.5-0.5
		L395.7,74.5z	"
        >
          <title id="t1297">Emmet, MI</title>
        </path>
        <path
          id="FIPS_26097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.2,63.4l5.6-0.6l1.1-0.1l0.1,1.1l6.7-0.8l1,1l0.3,1l1.1,0l-1.9,0.5l-1.9-0.4l-1.7,1
		l-2.6-0.5l-1.1-0.3l-1.9-0.4l-0.7,0l-0.1,0l-0.6,0.1l-0.1,0l-0.1,0.1l-0.2,0.2l-0.5,0.7l-0.1,0.3l-0.3,0.5l-0.1,0.1l-0.3,0.1
		l-1.5,0.1L384.2,63.4z	"
        >
          <title id="t1298">Mackinac, MI</title>
        </path>
        <path
          id="FIPS_26033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.1,64.3L403.1,64.3l0.1-0.2l0-0.2l-0.1-0.2l-0.2,0l-0.2-0.2l-0.2-0.4l0.1-0.1l0,0l1.6-0.1
		l0.1,0l0.4,0.1l1.1,1.1l0.1,0.1l0,0.1l-0.2,0.7l0,0.1l-0.1,0.1l-0.3,0.1l-1.5,0l-0.3-0.2l-0.1-0.2l-0.1-0.2l0-0.2L403.1,64.3z
		 M389.8,62.8l-0.7-6.5l0.6-0.2l1.2-0.1l0.3,0.4l-0.1,0.2l0,0.2l0,0.2l0,2l0,0.2l0.1,0.1l0.2,0.2l0.1,0.1l0.1,0l1.7,0.3l1.9-0.4
		l1.4-0.6l0.2-0.2l1.9-0.7l0.5,0l0.1,0l0.1,0.1l0.1,0.2l0,1.7l0,2.5l1.1,1.1l0.4,0.4l0.4,0.2l0.9,0.3l0.2,0l0.1,0.4l-0.1,0.3l-1.2,0
		l-0.7,0l-0.1-0.1l-0.1-0.1l-1.1,0l-0.3-1l-1-1l-6.7,0.8l-0.1-1.1L389.8,62.8z	"
        >
          <title id="t1299">Chippewa, MI</title>
        </path>
        <path
          id="FIPS_26095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.8,60.1l-0.2-2.4l0.6,0l0.4,0l1.5-0.1l0.4,0l0.3-0.1l0.2-0.1l0.9-0.5l1.1-0.7l0.7,6.5
		l-5.6,0.6L383.8,60.1z	"
        >
          <title id="t1300">Luce, MI</title>
        </path>
        <path
          id="FIPS_26153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.8,60.1l0.4,3.3l0.4,3.5l-0.5,0.3l-1.4-0.1l-0.2,0l-0.9,0.1l-0.2,0.1l-0.5,0.3l-0.3,0.4
		l-0.1,0.1l0,0.7l-0.1,0.7l-0.1,0.1l-0.6,0.4l-0.1,0.1l0,0l-0.2-1.8l-0.3-1.1l-0.3-2.2l-1.1,0.1l-0.2-2.2l2.2-0.2l-0.2-2.2
		L383.8,60.1z	"
        >
          <title id="t1301">Schoolcraft, MI</title>
        </path>
        <path
          id="FIPS_26003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.8,60.1l-4.4,0.5l0.2,2.2l-2.2,0.2l0.2,2.2l-4.5,0.4l-0.4-4.3L373,61l0.5-0.3l0.1,0l0.3,0
		l0.1,0.1l0.2,0.4l0.6,0.5l0.1,0l0.2,0l2.3-0.6l1.6-1.5l1.7-1.3l2.3-0.6l0.5-0.1L383.8,60.1z	"
        >
          <title id="t1302">Alger, MI</title>
        </path>
        <path
          id="FIPS_26041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.1,65.6l4.5-0.4l1.1-0.1l0.3,2.2l0.3,1.1l0.2,1.8l-0.5,0.1l-0.3-1.3l-2.2,1l-1.7,0.7
		l-0.1-0.5l-0.1-0.2l-0.2-0.3l-0.1-0.1l-0.1,0l-0.1,0l-0.1,0.2l-1.4,3.1l-0.2,0.5l0,0l-0.6,0.1l-0.4-4.5l-0.3-0.4l-0.2-0.7l1.1-0.1
		l-0.2-2.2L373.1,65.6z	"
        >
          <title id="t1303">Delta, MI</title>
        </path>
        <path
          id="FIPS_26109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M368.8,68.3l2.2-0.2l0.2,0.7l0.3,0.4l0.4,4.5l0.6-0.1l-0.2,0.6l-0.3,0.9l-0.8,1.9l-0.6,0.9
		l-0.6,1.7l-0.4-0.1l-0.2,0l0,0l-0.7-0.8l0-0.1l-0.1-0.3l0,0l-0.8-3.8l-0.1-2.3l-0.3-0.3l0,0l0,0l-0.2-0.1l1.2-0.1l-0.2-2.3l0.7-0.1
		L368.8,68.3z	"
        >
          <title id="t1304">Menominee, MI</title>
        </path>
        <path
          id="FIPS_26043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364.1,65.3l4.5-0.4l0.3,3.3l0.1,1.1l-0.7,0.1l0.2,2.3l-1.2,0.1l-2.1-0.6l-0.1,0l0,0l-0.1,0
		l-0.1,0l-0.3-0.3l0,0l-0.1-0.1l0,0l0,0l0.2-0.2l0.1-0.1l0.1-0.2l0.1-0.2l0,0l0,0l-0.3-0.4l-0.1-0.1L364.1,65.3z	"
        >
          <title id="t1305">Dickinson, MI</title>
        </path>
        <path
          id="FIPS_26103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364,56.7l1.3-0.1l0.8,0.2l0.3,0.1l1.4,0.8l0.4,0.3l0.1,0.4l0.1,0.3l2,2.5l0.1,0.1l0.1,0.1
		l0.1,0.1l0.4,0.1l0.5,0l1.2-0.2l0.1,0l0.4,4.3l-1.1,0.1l0.2,2.2l-1.1,0.1l-2.2,0.2l-0.3-3.3l-4.5,0.4l-0.2-2.2l-0.3-3.3l1.1-0.1
		l-0.1-1.1l0,0l-0.5,0L364,56.7z	"
        >
          <title id="t1306">Marquette, MI</title>
        </path>
        <path
          id="FIPS_26071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.9,63.5l5-0.4l0.2,2.2l0.4,4.2l-0.2-0.1l-0.3-0.2l-0.2,0l0,0l-2.6-0.3l-1.6,0.2l-0.2-0.3
		l-2.3-0.6l-0.5-0.3l-0.2-3l-0.1-1.1L358.9,63.5z	"
        >
          <title id="t1307">Iron, MI</title>
        </path>
        <path
          id="FIPS_26083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.2,41.8l0.1-0.1l0,0l0.1-0.2l0.4-0.2l0.6-0.3l1.1-0.3l0,0.1l0,0.1l-1.3,1.5l-0.7,0.7
		l-2,1.7l-1.8,0.9l-0.3,0.1l-0.3-0.1l-0.4-0.2l-0.2-0.3l0.1-0.2l0.3-0.3l0.3-0.3l0.7-0.5l0.8-0.5l1.9-1.2L357.2,41.8z M359.5,52.3
		l0.4-0.7l0.3-0.4l0.2-0.2l1.4-0.9l0.3-0.1l1.2-0.3l0.5-0.1l0.4,0l1.1,0l0.4,0.1l0.2,0.1l0.1,0.1l0.1,0.4l0,0.1l-0.9,0.3l-0.1,0
		l-1.2,0.3l-1.3,1.8l-0.2,0.3l-0.6,0.3l-0.6,0.1l-0.1-1.1L359.5,52.3z	"
        >
          <title id="t1308">Keweenaw, MI</title>
        </path>
        <path
          id="FIPS_26061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.5,52.3l1.9-0.2l0.1,1.1l0.6-0.1l-1.7,3.4l-0.9,0.2l-1,1.2l0.4,5.5l-2.8,0.2l-0.1-1.9
		l-0.1-1.5l1.1-0.1l-0.1-1.1l-0.6,0l-0.3-3.4l0.2-0.7l0.1-0.2l0.6-0.6l1-0.9l0.2-0.2L359.5,52.3z	"
        >
          <title id="t1309">Houghton, MI</title>
        </path>
        <path
          id="FIPS_26013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364,56.7l0.2,1.9l0.5,0l0,0l0.1,1.1l-1.1,0.1l0.3,3.3l-5,0.4l-0.4-5.5l1-1.2l0.9-0.2
		l-0.2,0.8l0,0.7l0,0.1l0.1,0.2l0.1,0.2l0.2,0l0-0.1l0.1-0.2l0.4-0.6l1-1l0.8-0.5l0.1,0l0.1,0L364,56.7z	"
        >
          <title id="t1310">Baraga, MI</title>
        </path>
        <path
          id="FIPS_27055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.3,98.1l0.2,1.6l0.6,2.9l-3.7,0.2l-1.1,0.1l-0.2-4.5L337.3,98.1z	"
        >
          <title id="t1311">Houston, MN</title>
        </path>
        <path
          id="FIPS_27045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.9,98.5l3.2-0.1l0.2,4.5l-3.3,0.1l-3.4,0.1l-0.2-4.3L329.9,98.5z	"
        >
          <title id="t1312">Fillmore, MN</title>
        </path>
        <path
          id="FIPS_27071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.1,40.9l-0.1-4.3l0.1,0l0.2,0l0.7,0l0.2,0l0.3,0.1l0.1,0.2l0,0.1l0,0.3v0l0.1,0l0.2,0
		l0.8,0l0.6,0l1.8,0.2l0.1,0l0.1,0.2l0.1,0.4l0,0.1l0,0.3l-0.1,0.1v0.1l0,0l0.2,0.1h0.3l0.8,0l1-0.2l0.7-0.2l0.1-0.1l0-0.1l0-0.1
		l0-0.1l0-0.2l0-0.1l1-0.5l0.8-0.2l0.4,0l0.2,0.2l0.3,0h0l0.5,0l0,2.7l0,2.2l0.1,2.2l0.1,0.6l0.1,1.2l0,0.5l-6.1,0.1l0,0.7l-5.6,0.1
		L307.1,40.9z	"
        >
          <title id="t1313">Koochiching, MN</title>
        </path>
        <path
          id="FIPS_27077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.3,33l1.5,0l0-2.4l0-0.8l0-1.3l0-0.4v0l1.7,0.2l0.4,0.2l0.7,0.5l0.5,2.4l0.2,1.5l0.5,2.8
		l0.4,0.4l0.1,0.1l0.6,0.3l0.2,0.1l0,0l0.1,0l0.4,0l0.3-0.1l0.1,4.3l-6.8,0.1l0-2.2l-1.1,0l0-2.2l2.2,0l0-2.6l-0.2,0.2l-0.2,0.1
		l-0.1,0l-0.7,0.1h-0.1l-0.1,0l-0.4-0.2l-0.2-0.4l0-0.6L299.3,33z	"
        >
          <title id="t1314">Lake of the Woods, MN</title>
        </path>
        <path
          id="FIPS_27135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.3,33l0,0.2l0,0.6l0.2,0.4l0.4,0.2l0.1,0h0.1l0.7-0.1l0.1,0l0.2-0.1l0.2-0.2l0,2.6l-2.2,0
		l0,2.2l-2.2,0l-6.8-0.1l0-1l-0.1-1.2l0-3.6L299.3,33z	"
        >
          <title id="t1315">Roseau, MN</title>
        </path>
        <path
          id="FIPS_27069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M282.9,32.9L290,33l0,3.6l0.1,1.2l0,1l-6.7,0l0.6-1.8l-0.4-0.9l-0.2-0.5l-0.6-2l0-0.3l0-0.2
		L282.9,32.9L282.9,32.9z	"
        >
          <title id="t1316">Kittson, MN</title>
        </path>
        <path
          id="FIPS_27125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M296,46.6l0,1.1l-1.1,1.1h-4.5l-1.1-1.1v-1.5l6.8,0L296,46.6z	"
        >
          <title id="t1317">Red Lake, MN</title>
        </path>
        <path
          id="FIPS_27113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297,43.5l0.1,2l0,1.1l-1.1,0l0-0.4l-6.8,0l-0.1-2.7l2.1,0l0.6,0l1.6,0L297,43.5z	"
        >
          <title id="t1318">Pennington, MN</title>
        </path>
        <path
          id="FIPS_27089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.4,38.7l6.7,0l6.8,0.1v1.7l0,0.5l0.1,0l0,2.5l-3.5,0l-1.6,0l-0.6,0l-2.1,0l-5.6,0l0-0.3
		l0.3-1.1l-0.1-3.1l-0.2-0.2L283.4,38.7L283.4,38.7z	"
        >
          <title id="t1319">Marshall, MN</title>
        </path>
        <path
          id="FIPS_27119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.1,43.5l0.1,2.7v1.5l1.1,1.1h4.5l1.1-1.1l0-1.1l1.1,0l0,3.1l0.1,0.2h0.1v2.2l-4.5,0
		l-6.9,0l-0.3-2.2l-1.1-2.6l-0.8-3l-0.2-0.8v0L289.1,43.5z	"
        >
          <title id="t1320">Polk, MN</title>
        </path>
        <path
          id="FIPS_27107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.9,52.2v4.5l-1.1,0l-5.6,0l0-1.1l-0.2-3.4L292.9,52.2z	"
        >
          <title id="t1321">Norman, MN</title>
        </path>
        <path
          id="FIPS_27087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.4,52.1l0,4.5l-4.6,0v-4.5L297.4,52.1z	"
        >
          <title id="t1322">Mahnomen, MN</title>
        </path>
        <path
          id="FIPS_27029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.1,46.6l0-1.1l3.1,0l0.3,1.9l0.1,2.5l0,3.3l0.2,3.3l-3.4,0l0-4.5v-2.2h-0.1l-0.1-0.2
		L297.1,46.6z	"
        >
          <title id="t1323">Clearwater, MN</title>
        </path>
        <path
          id="FIPS_27007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.2,38.8l1.1,0l0,2.2l6.8-0.1l0.2,6.7l0,2.1l0.1,1.6l0,1.4l-2.2,0.5l-4.5,0l0-3.3l-0.1-2.5
		l-0.3-1.9l-3.1,0l-0.1-2l0-2.5l-0.1,0l0-0.5v-1.7L299.2,38.8z	"
        >
          <title id="t1324">Beltrami, MN</title>
        </path>
        <path
          id="FIPS_27031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.7,42.2l0.5-0.4l0.8-0.4h0.3l0,0l0,0l0.3,0.8l0.1,0.4v0l0.3,0.6l0.1,0.1l1.6-0.3l3.4-0.3
		l0.4,0l0.4,0.1l0.2,0l0.5,0.2l0.2,0.3l0,0.1l0,0.2l0,0.1l0.2,0.2l0.6,0.3l0.2,0l0.2-0.1l1.7-0.3l1.4-0.2l0,0.1l0,0l-0.5,0.4
		l-0.1,0.1l-1.9,1.1l-1.2,0.7l-0.7,0.4l-0.6,0.3l-0.8,0.3l-0.6,0.2l-1.7,0.7l-0.8,0.3l-1.7,1.1l-1.1,0.9l-1.3,1.2l-0.3-5.2l-0.2-2.4
		L336.7,42.2z	"
        >
          <title id="t1325">Cook, MN</title>
        </path>
        <path
          id="FIPS_27075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M336.7,42.2l0.1,1.6l0.2,2.4l0.3,5.2l-0.2,0.1l-0.7,0.8l-0.2,0.3l-1.1,1.5l-1.4,1.7l-0.2,0.2
		l-0.4,0.2l-0.5,0.3l-1.1,1.1l-0.3,0.3l-0.5,0.6l-0.3-7.4l-0.2-2.7l-0.1-1.1l-0.2-4.9l0.5-0.1l0.2,0.1l0,0l0,0.1l0.1,0.6l-0.1,0.3
		l0,0.1l0,0l0.6,0.2l1.3,0.3l1.4-0.1l0.3-0.1l0.2-0.1l0.1-0.1h0L336.7,42.2z	"
        >
          <title id="t1326">Lake, MN</title>
        </path>
        <path
          id="FIPS_27061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319,46.7l0,0.9l0.1,1.3l0.2,1.5l0.1,3l0.1,1.6l0.1,1.8l0,1.1l-6.4,0.1l-0.1-3.5l-0.1,0
		l-0.6-0.1l-0.2,0l0,0l-0.2,0.2l-0.1,0.1l-0.2-0.1l-0.8-0.5l-0.1-0.1l-0.1-0.2v-0.3l0,0l0-0.2l-0.3-0.6l-0.1-0.1l-0.2,0l-1.6,0.7
		l-0.2,0.1l-0.5-0.2l-0.3-0.2l0-1.4l-0.1-1.6l0-2.1l5.6-0.1l0-0.7L319,46.7z	"
        >
          <title id="t1327">Itasca, MN</title>
        </path>
        <path
          id="FIPS_27057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M300.7,53.2l4.5,0l0.1,1.1l0.1,4.4l0,2.2l-1.1,0l-3.3,0l0-2.2l-0.1-0.1l0-0.9v-1.2L300.7,53.2
		z	"
        >
          <title id="t1328">Hubbard, MN</title>
        </path>
        <path
          id="FIPS_27021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.2,53.2l2.2-0.5l0.3,0.2l0.5,0.2l0.2-0.1l1.6-0.7l0.2,0l0.1,0.1l0.3,0.6l0,0.2l0,0v0.3
		l0.1,0.2l0.1,0.1l0.8,0.5l0.2,0.1l0.1-0.1l0.2-0.2l0,0l0.2,0l0.6,0.1l0.1,0l0.1,6.4l-5,0.1l0,1.5l0,0.8l0.1,0.6l0.1,3.2l0,0.5
		l0,0.1l-0.1,0l0-0.1l-0.1-0.1l-0.7-0.5l-0.3,0l-0.1,0.1l-0.2,0.1l-0.4,0.2l-0.1,0l-0.7-0.3l-0.3-0.2l-0.7-0.3l-0.4-0.3l-0.1-3
		l0-2.2l1.1,0l0-2.2l-0.1-4.4L305.2,53.2z	"
        >
          <title id="t1329">Cass, MN</title>
        </path>
        <path
          id="FIPS_27159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.3,61l0,2.2l0.1,3l0.4,0.3l-3.8,0l-0.1-4.5V61L304.3,61z	"
        >
          <title id="t1330">Wadena, MN</title>
        </path>
        <path
          id="FIPS_27005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M300.8,56.6v1.2l0,0.9l0.1,0.1l0,2.2v1.1l-4.2,0.1l-4.8,0l-0.2-5.6l1.1,0l4.6,0L300.8,56.6z	"
        >
          <title id="t1331">Becker, MN</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22020"
              ? `metroArea clickedArea state-mn state-nd`
              : `metroArea ${colorCode[22020]} state-mn state-nd`
          }
          id="FIPS_22020"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_27027"
            className="FIPS_22020 st0 state-mn state-nd"
            d="M291.8,56.6l0.2,5.6l-1,1.1l-4.5,0l0-0.7l0.2-2.8l-0.1-0.3l-0.4-1.2l0-1.6L291.8,56.6z	"
          >
            <title id="t1332">Clay, MN</title>
          </path>
          <path
            id="FIPS_38017"
            className="FIPS_22020 st0 state-mn state-nd"
            d="M280.7,55.4l5.5,0.1l0,1.1l0,1.6l0.4,1.2l0.1,0.3l-0.2,2.8l0,0.7v0l-4.4,0l-3.6-0.1l0.1-4.5
		l-0.2-1.3l0-2.1L280.7,55.4z	"
          >
            <title id="t1751">Cass, ND</title>
          </path>
        </g>
        <path
          id="FIPS_27167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.5,63.3l4.5,0l0,4.5h0.1l0,2.2l0,1.1l-2.8,0l0.2-0.5l0-0.1l0-0.3l0-0.2l-0.3-2.7l-1.2-3
		L286.5,63.3L286.5,63.3z	"
        >
          <title id="t1333">Wilkin, MN</title>
        </path>
        <path
          id="FIPS_27111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M291.9,62.2l4.8,0l4.2-0.1l0.1,4.5l0.1,3.4l-5.6,0l-4.4,0l0-2.2H291l0-4.5L291.9,62.2z	"
        >
          <title id="t1334">Otter Tail, MN</title>
        </path>
        <path
          id="FIPS_27137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.6,37.3l0.9,0l6.1,3.4l0.2-0.2l1.8-0.1l0.2,0.4l0.4,0.8l0,0.1l0.1,0.1l1.6,0.5l0.2,4.9
		l0.1,1.1l0.2,2.7l0.3,7.4l-0.4,0.2L330,59l-1.5,1.3l-0.2,0.2l-0.1,0.1l0.1,0.2l0.2,0.4l0.4,0.4l0.1,0.1l0,0l-0.1-0.1l-0.5-0.5
		l-0.2,0l-0.6,0.4l0,0.1l0,0.1l0,0.1v0l0,0l0,0l0,0.1l-0.1,0.3l0,0l0,0l-0.3,0l-0.2,0l-0.2-0.1l-0.1-1.3l-2.1,0.1l-4.7,0.1l-0.1-3.3
		l0-1.1l-0.1-1.8l-0.1-1.6l-0.1-3l-0.2-1.5l-0.1-1.3l0-0.9l0-0.5l-0.1-1.2l-0.1-0.6l-0.1-2.2l0-2.2L318.6,37.3z	"
        >
          <title id="t1335">St. Louis, MN</title>
        </path>
        <path
          id="FIPS_27017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.6,61.2l4.7-0.1l2.1-0.1l0.1,1.3l0.1,3.2l-6.8,0.2l-0.1-1.9l-0.1-0.3l0-0.5l0-0.6
		L319.6,61.2z	"
        >
          <title id="t1336">Carlton, MN</title>
        </path>
        <path
          id="FIPS_27115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.8,65.6l6.8-0.2l0.1,3.3l0,0.6l0,0.5l-1.3,0.8l-1.9,1.2l0,0l-0.4,0.4l-0.1,0.1l-0.1,0.2
		l-0.9,1.8l-2.7,0.1l-0.1-3.2l0.8,0l-0.1-2.3L319.8,65.6z	"
        >
          <title id="t1337">Pine, MN</title>
        </path>
        <path
          id="FIPS_27065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.5,69.1l3.4-0.2l0.1,2.3l-0.8,0l0.1,3.2l-3.4,0l-0.1-1.8l0-1.4l0.4,0l0.4-0.4L316.5,69.1z
			"
        >
          <title id="t1338">Kanabec, MN</title>
        </path>
        <path
          id="FIPS_27001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.6,57.8l0.1,3.3l0,1.1l0,0.6l0,0.5l0.1,0.3l0.1,1.9l0.1,3.4l-3.4,0.2l0-0.3l0-0.8l-0.9,0
		l-2.3,0.1l-0.1-0.1l0,0l0,0l-0.1-4.3l0.3-0.9l0-1.9l-0.1-2.9L319.6,57.8z	"
        >
          <title id="t1339">Aitkin, MN</title>
        </path>
        <path
          id="FIPS_27035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.4,67.7L308.4,67.7l0.1-0.2l0-0.5l-0.1-3.2l-0.1-0.6l0-0.8l0-1.5l5-0.1l0,1.9l-0.3,0.9
		l0.1,4.3l0,0l0,0l0.1,0.1l-0.1,1.1l-5.1,0.1l0-0.4l0-0.7L308.4,67.7z	"
        >
          <title id="t1340">Crow Wing, MN</title>
        </path>
        <path
          id="FIPS_27097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.5,66.8l0.3,0.2l0.7,0.3l0.1,0l0.4-0.2l0.2-0.1l0.1-0.1l0.3,0l0.7,0.5l0.1,0.1l0,0.1
		l-0.3,0.4l0,0.7l0,0.4l5.1-0.1l0.1,2.2h0l0.3,0.8l0.1,1.3l-2.2,0l-3.1,0.1l0.7,0.6l-3.4,0.1L305.5,66.8z	"
        >
          <title id="t1341">Morrison, MN</title>
        </path>
        <path
          id="FIPS_27153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.8,66.6l0.7,0.3l0.2,7.4l-4.5,0.1l-0.1-4.3l-0.1-3.4L304.8,66.6z	"
        >
          <title id="t1342">Todd, MN</title>
        </path>
        <path
          id="FIPS_27041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M301.2,70l0.1,4.3v0.2l-5.6,0l0-2.2h-0.1l0-2.2L301.2,70z	"
        >
          <title id="t1343">Douglas, MN</title>
        </path>
        <path
          id="FIPS_27051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M291.1,70l4.4,0l0,2.2h0.1l0,2.2l-4.5,0l-0.1-3.4L291.1,70z	"
        >
          <title id="t1344">Grant, MN</title>
        </path>
        <path
          id="FIPS_27155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.3,71.1l2.8,0l0.1,3.4v2.2l-5.3,0l-0.2-0.2l0-0.1l0.1-0.4l0-0.1l0,0l0,0l0,0l0.8-0.7
		l0.3-0.2l0.3-0.2l0.2-0.2l0.6-0.9l0,0l0,0l0,0l0-0.1l0-0.1l0-0.3l0-0.3l0,0v0l0-0.6L288.3,71.1z	"
        >
          <title id="t1345">Traverse, MN</title>
        </path>
        <path
          id="FIPS_27011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M285.9,76.7l5.3,0h0.1l0,2.2l1.1,0l0.1,3l-0.6-0.2l-0.9-0.4l-0.1-0.2l-0.4-0.2l-1.1-0.2
		l-0.1-0.7l-0.2-0.4l-0.3-0.2l-0.9-0.4l-1.3-1.5L285.9,76.7z	"
        >
          <title id="t1346">Big Stone, MN</title>
        </path>
        <path
          id="FIPS_27151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.8,79l4.5,0l0.1,3.4l-7.2,0l-0.6-0.3l-0.1-3L295.8,79z	"
        >
          <title id="t1347">Swift, MN</title>
        </path>
        <path
          id="FIPS_27149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.7,74.5l0,2.2h0.1l0,2.2l-3.4,0l-1.1,0l0-2.2h-0.1v-2.2L295.7,74.5z	"
        >
          <title id="t1348">Stevens, MN</title>
        </path>
        <path
          id="FIPS_27121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M301.3,74.5l0,2.2h0.1l0,2.2l-1.1,0l-4.5,0l0-2.2h-0.1l0-2.2L301.3,74.5z	"
        >
          <title id="t1349">Pope, MN</title>
        </path>
        <path
          id="FIPS_27145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.7,74.2l3.4-0.1l1.2,2.8l1,1.7l-1.9,1.8l-1.1,0l-0.5-0.6l-0.9,0l-2.1,0l0-1.1l-3.3,0
		l0-2.2h-0.1l0-2.2v-0.2L305.7,74.2z	"
        >
          <title id="t1350">Stearns, MN</title>
        </path>
        <path
          id="FIPS_27009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.1,74.2l-0.7-0.6l3.1-0.1l2.2,0l0.1,3.4l-3.5,0.1L309.1,74.2z	"
        >
          <title id="t1351">Benton, MN</title>
        </path>
        <path
          id="FIPS_27095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313.2,68.1l2.3-0.1l0.9,0l0,0.8l0,0.3l0,1.8l-0.4,0.4l-0.4,0l0,1.4l0.1,1.8l0.1,2.3l-2.3,0
		l-0.1-3.4l-0.1-1.3l-0.3-0.8h0l-0.1-2.2L313.2,68.1z	"
        >
          <title id="t1352">Mille Lacs, MN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "33460"
              ? `metroArea clickedArea state-mn state-wi`
              : `metroArea ${colorCode[33460]} state-mn state-wi`
          }
          id="FIPS_33460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_27003"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M316.1,78.7h0.5l2.6-0.1l1.3,0l0,1.5l0.1,2.2l-1.8,1.2l-2.7-2.6L316.1,78.7z	"
          >
            <title id="t1356">Anoka, MN</title>
          </path>
          <path
            id="FIPS_27019"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M311.6,84.4l2.2,0l0,1.1l2.3-0.1l0,1.1H316l-0.3,0.1l-0.5,0.7l0,0.2l0.1,0.1L315,88l-0.8,0.6
		l-0.2,0.1l0,0l-2.2-0.9L311.6,84.4z	"
          >
            <title id="t1366">Carver, MN</title>
          </path>
          <path
            id="FIPS_27025"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M322,74.4l-0.4,1.1l0,0.2l0,0.1l0,0.3l0,0.3l0.1,0.1l0.4,0.1l0.2,0l0.7,0.4l0.4,0.8l0.2,0.9
		l-0.3,0.9l-0.2,0.3l0,0l-0.1,0.1l-2.5,0.1l0-1.5l-0.1-1.7l-1.1-0.2l-0.1-2.2L322,74.4z	"
          >
            <title id="t1354">Chisago, MN</title>
          </path>
          <path
            id="FIPS_27037"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M319.3,85.4l1.4-0.1l2,1.8l0.7,0.4l0,1.1l-0.5,1.1l-1.2,0l-1.1,0.4l0,0.6l-2.3-0.9l0-1.1
		l-0.4,0l-0.1-1.1l0-0.9L319.3,85.4z	"
          >
            <title id="t1363">Dakota, MN</title>
          </path>
          <path
            id="FIPS_27053"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M316.1,80.8l2.7,2.6l0.5,1.9l-1.4,1.3l-1.8-0.1l0-1.1l-2.3,0.1l0-1.1L314,83l0.8-1.6l0.1-0.1
		L316.1,80.8L316.1,80.8z	"
          >
            <title id="t1364">Hennepin, MN</title>
          </path>
          <path
            id="FIPS_27059"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M319.3,74.5l0.1,2.2l1.1,0.2l0.1,1.7l-1.3,0l-2.6,0.1h-0.5l-0.1-1.9l-0.1-2.3L319.3,74.5z	"
          >
            <title id="t1353">Isanti, MN</title>
          </path>

          <path
            id="FIPS_27123"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M318.8,83.5l1.8-1.2l0.1,3l-1.4,0.1L318.8,83.5z	"
          >
            <title id="t1355">Ramsey, MN</title>
          </path>
          <path
            id="FIPS_27139"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M316.2,86.5l1.8,0.1l0,0.9l0.1,1.1l0.4,0l0,1.1l-2.2,0.1l-3.6,0.1l1.3-1.3l0,0l0.2-0.1L315,88
		l0.2-0.3l-0.1-0.1l0-0.2l0.5-0.7l0.3-0.1L316.2,86.5z	"
          >
            <title id="t1365">Scott, MN</title>
          </path>
          <path
            id="FIPS_27141"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M316,76.8l0.1,1.9l0,2.2l-0.1,0l-0.6-0.6l-0.8,0l-0.8,0l-0.1,0l-0.9-0.5l-1.7-1l-1-1.7
		l3.5-0.1L316,76.8z	"
          >
            <title id="t1357">Sherburne, MN</title>
          </path>
          <path
            id="FIPS_27163"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M320.6,80.1l2.5-0.1l-0.1,1.1l-0.2,1.7l0,0.4l0.2,0.5l0.2,0.9l-0.1,1l-0.3,1.5l-2-1.8l-0.1-3
		L320.6,80.1z	"
          >
            <title id="t1362">Washington, MN</title>
          </path>
          <path
            id="FIPS_27171"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M309.3,80.5l1.9-1.8l1.7,1l0.9,0.5l0.1,0l0.8,0l0.8,0l0.6,0.6l-1.1,0.6l-0.1,0.1L314,83
		l-0.1,1.3l-2.2,0l-2.2,0L309.3,80.5z	"
          >
            <title id="t1358">Wright, MN</title>
          </path>
          <path
            id="FIPS_55093"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M323.1,85.6l5.7-0.2l0.1,2.2l-1.6,1.9l0,0l-0.1-0.1l-0.1-0.1l-0.2,0l-1.2,0l-0.4,0l-0.1-0.1
		l-0.7-0.7l0-0.1l-0.1-0.1l-1-0.8l-0.7-0.4L323.1,85.6z	"
          >
            <title id="t2992">Pierce, WI</title>
          </path>
          <path
            id="FIPS_55109"
            className="FIPS_33460 st0 state-mn state-wi"
            d="M328.5,80.9l0.4,4.5l-5.7,0.2l0.1-1l-0.2-0.9l-0.2-0.5l0-0.4l0.2-1.7L328.5,80.9z	"
          >
            <title id="t3001">St. Croix, WI</title>
          </path>
        </g>

        <path
          id="FIPS_27093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.7,80l2.1,0l0.9,0l0.5,0.6l1.1,0l0.1,3.9l-2.2,1.2l-2.3,0L304.7,80z	"
        >
          <title id="t1359">Meeker, MN</title>
        </path>
        <path
          id="FIPS_27067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M300.3,79l1.1,0l3.3,0l0,1.1l0.1,5.6l-4.5,0.1l0-3.4L300.3,79z	"
        >
          <title id="t1360">Kandiyohi, MN</title>
        </path>
        <path
          id="FIPS_27023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.2,82.3l7.2,0l0,3.4l-2.1,0l0,1.8l-2.3-2.4L293.2,82.3z	"
        >
          <title id="t1361">Chippewa, MN</title>
        </path>

        <path
          id="FIPS_27085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.4,84.4l2.2,0l0.1,3.4l-1.1,0l-1.1,0.1l0,1l-1.9,0l-0.3,0l0-1.1l-0.1-2.3L309.4,84.4z	"
        >
          <title id="t1367">McLeod, MN</title>
        </path>
        <path
          id="FIPS_27143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M311.7,87.8l2.2,0.9l-1.3,1.3l-0.1,1.1l-6.4,0.1l-0.1-1.1l0-2.3l1.2,0l0,1.1l0.3,0l1.9,0l0-1
		l1.1-0.1L311.7,87.8z	"
        >
          <title id="t1368">Sibley, MN</title>
        </path>
        <path
          id="FIPS_27129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.2,85.6l0.1,2.3l-1.2,0l0,2.3l0.1,1.1l-1.4,0l-0.8-0.5l-4.6-2.5l-1.1-0.7l0-1.8l2.1,0
		l4.5-0.1L307.2,85.6z	"
        >
          <title id="t1369">Renville, MN</title>
        </path>
        <path
          id="FIPS_27073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.5,82l0.6,0.3l2.7,2.8v0.6l-1,1.1l-5.5,0l0-6l1.1,0.2l0.4,0.2l0.1,0.2l0.9,0.4L292.5,82z	
		"
        >
          <title id="t1370">Lac qui Parle, MN</title>
        </path>
        <path
          id="FIPS_27173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.4,86.8l5.5,0l1-1.1v-0.6l2.3,2.4l1.1,0.7l0,2l-2.2,0l-0.1-1.1h-4.5l-3.3,0L289.4,86.8z	"
        >
          <title id="t1371">Yellow Medicine, MN</title>
        </path>
        <path
          id="FIPS_27081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.6,89.1l0.1,5.6l-3.5,0l0-4.5l0-1.1L292.6,89.1z	"
        >
          <title id="t1372">Lincoln, MN</title>
        </path>
        <path
          id="FIPS_27083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.2,94.7l-4.3,0h-0.1l-0.1-5.6h4.5l0.1,1.1L297.2,94.7z	"
        >
          <title id="t1373">Lyon, MN</title>
        </path>
        <path
          id="FIPS_27127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.9,90.7l0,2.8l-2.2,0l0,1.1l-3.3,0l-1.2,0l0-4.5l2.2,0l0-2L303.9,90.7z	"
        >
          <title id="t1374">Redwood, MN</title>
        </path>
        <path
          id="FIPS_27015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.7,91.3l0.3,0.1l0.4,0.2l2,1l0.1,0.1l0.2,0.2l0.8,0.9l0.1,2l-4.5,0.1l-2.3-1.1l0-1.1
		l2.2,0l0-2.8L304.7,91.3z	"
        >
          <title id="t1375">Brown, MN</title>
        </path>
        <path
          id="FIPS_27103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.6,91.1l-0.3,1.1l-0.4,1.3l0,0.4l0.1,0.8l0,0.1l-0.4,0.2l-0.1,0l-0.3-0.1l-0.3-0.2
		l-0.1-0.1l-1.9-0.9l-0.4-0.1l-0.8-0.9l-0.2-0.2l-0.1-0.1l-2-1l-0.4-0.2l-0.3-0.1l1.4,0L312.6,91.1z	"
        >
          <title id="t1376">Nicollet, MN</title>
        </path>
        <path
          id="FIPS_27079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M312.7,90l3.6-0.1l0.1,4.5l-2.2,0.1l-2.3-0.5l0-0.4l0.4-1.3l0.3-1.1L312.7,90z	"
        >
          <title id="t1377">Le Sueur, MN</title>
        </path>
        <path
          id="FIPS_27131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.3,89.9l2.2-0.1l2.3,0.9l0.1,3.6h0l-3.3,0.1l-1.1,0L316.3,89.9z	"
        >
          <title id="t1378">Rice, MN</title>
        </path>
        <path
          id="FIPS_27049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M323.5,87.5l1,0.8l0.1,0.1l0,0.1l0.7,0.7l0.1,0.1l0.4,0l1.2,0l0.2,0l0.1,0.1l0.1,0.1l0,0
		l0.7,1.1l-1.7,0.1l-1.1,1.2l0.1,2.2l-1.2,0l-3.3,0.1l-0.1-3.6l0-0.6l1.1-0.4l1.2,0l0.5-1.1L323.5,87.5z	"
        >
          <title id="t1379">Goodhue, MN</title>
        </path>
        <path
          id="FIPS_27157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.1,90.7l1.5,0.6l2.2,2.7l-2,1.2l-2.2,0.1l0-1.1l-2.1,0.1l-0.1-2.2l1.1-1.2L328.1,90.7z	"
        >
          <title id="t1380">Wabasha, MN</title>
        </path>
        <path
          id="FIPS_27169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M331.7,93.9l2.9,2.1l1.3,0.5l1.3,1.7l-4.1,0.2l-3.2,0.1l-0.1-3.4L331.7,93.9z	"
        >
          <title id="t1381">Winona, MN</title>
        </path>
        <path
          id="FIPS_27109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.2,94.2l1.2,0l2.1-0.1l0,1.1l2.2-0.1l0.1,3.4l-3.4,0.3l-2.2-0.1L324.2,94.2z	"
        >
          <title id="t1382">Olmsted, MN</title>
        </path>
        <path
          id="FIPS_27039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.8,94.3l3.3-0.1l0.1,4.5l-3.3,0.1L320.8,94.3L320.8,94.3z	"
        >
          <title id="t1383">Dodge, MN</title>
        </path>
        <path
          id="FIPS_27147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.8,94.3l0.1,4.5h0l-3.3,0.1l-0.1-4.5L320.8,94.3z	"
        >
          <title id="t1384">Steele, MN</title>
        </path>
        <path
          id="FIPS_27161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M316.4,94.4l1.1,0l0.1,4.5l-2.2,0.1l-1.1,0l-0.1-4.5L316.4,94.4z	"
        >
          <title id="t1385">Waseca, MN</title>
        </path>
        <path
          id="FIPS_27013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M314.1,94.5l0.1,4.5l-4.5,0.1l-1.1,0l-0.1-3.4l-0.1-2l0.4,0.1l1.9,0.9l0.1,0.1l0.3,0.2
		l0.3,0.1l0.1,0l0.4-0.2l0-0.1l-0.1-0.8L314.1,94.5z	"
        >
          <title id="t1386">Blue Earth, MN</title>
        </path>
        <path
          id="FIPS_27165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304,95.8l4.5-0.1l0.1,3.4l-4.5,0.1h0L304,95.8z	"
        >
          <title id="t1387">Watonwan, MN</title>
        </path>
        <path
          id="FIPS_27033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.5,94.7l3.3,0l2.3,1.1l0,3.4l-5.5,0.1h-0.1L298.5,94.7z	"
        >
          <title id="t1388">Cottonwood, MN</title>
        </path>
        <path
          id="FIPS_27101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.2,94.7l1.2,0l0,4.5l-5.5,0h-0.1l0-4.5L297.2,94.7z	"
        >
          <title id="t1389">Murray, MN</title>
        </path>
        <path
          id="FIPS_27117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.3,94.7l3.5,0h0.1l0,4.5l-3.6,0L289.3,94.7z	"
        >
          <title id="t1390">Pipestone, MN</title>
        </path>
        <path
          id="FIPS_27133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.3,99.2l3.6,0h0.1l0,4.5l-3.7,0L289.3,99.2z	"
        >
          <title id="t1391">Rock, MN</title>
        </path>
        <path
          id="FIPS_27105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293,99.2l5.5,0h0.1l0,4.5l-3.8,0l-1.8,0L293,99.2z	"
        >
          <title id="t1392">Nobles, MN</title>
        </path>
        <path
          id="FIPS_27063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.1,99.1L304.1,99.1l0.1,4.5l-0.6,0l-4.4,0h-0.6l0-4.5L304.1,99.1z	"
        >
          <title id="t1393">Jackson, MN</title>
        </path>
        <path
          id="FIPS_27091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.8,99l0.1,4.5l-1.8,0l-3.8,0.1l-0.1-4.5l4.5-0.1L309.8,99z	"
        >
          <title id="t1394">Martin, MN</title>
        </path>
        <path
          id="FIPS_27043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.3,98.9l0.1,4.5l-3,0.1l-2.6,0l-0.1-4.5l4.5-0.1L315.3,98.9z	"
        >
          <title id="t1395">Faribault, MN</title>
        </path>
        <path
          id="FIPS_27047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M320.9,98.8l0.1,4.5l-4.2,0.1l-1.4,0l-0.1-4.5l2.2-0.1L320.9,98.8z	"
        >
          <title id="t1396">Freeborn, MN</title>
        </path>
        <path
          id="FIPS_27099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.2,98.7l2.2,0.1l0.2,4.3l-1,0l-4.4,0.2l-0.2,0l-0.1-4.5h0L324.2,98.7z	"
        >
          <title id="t1397">Mower, MN</title>
        </path>
        <path
          id="FIPS_29143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.1,187.8l1.7-0.2l2.2,2.9l-0.8,1.8l-0.7,0.1l0.1-0.2l0,0l0,0l0-0.1l0,0v-0.1l0,0v0l0-0.1
		l-0.1-0.1l0,0l-0.1-0.1l0,0l0,0l0,0l-0.2,0l-0.3,0l-0.2,0l-0.1,0l-0.1,0.2l0,0l0,0l0,0.1l0,0l0,0l0,0.1l0,0l0.1,0.2l0,0l0.2,0.3
		l0.1,2.1l-0.5-0.8l-0.2-0.1l-0.7,0.1l-0.8,0.3l-1.6,0.1h-0.5l-0.2-3.1l2.7-0.1l-0.2-3L358.1,187.8z	"
        >
          <title id="t1398">New Madrid, MO</title>
        </path>
        <path
          id="FIPS_29155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M360,194.5l-0.7,2l-0.9,2.5l-2.3,0.2l-0.3-5.1h0.5l1.6-0.1l0.8-0.3l0.7-0.1l0.2,0.1L360,194.5
		z	"
        >
          <title id="t1399">Pemiscot, MO</title>
        </path>
        <path
          id="FIPS_29005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.8,141.5l3.8,0l1.7,0l0,1.3h0.2l0,1.2l0,1.6l-3.6,0l0-0.2v0l0,0l0-0.1l-0.7-0.7l-0.6-1.6
		l-0.1-0.2l0.1-0.1l0.2-0.4l-0.4-0.3l-0.1,0.3L295.8,141.5z	"
        >
          <title id="t1400">Atchison, MO</title>
        </path>
        <path
          id="FIPS_29087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M301.5,145.7l0.9,0l0.2,0.4l0,0l0,0.4l0.1,0.7l0.1,0.1l0.1,0.1l0.5,3l-0.3,0.4l0,0l-0.1,0.1
		l-0.1,0l-0.4,0l0,0l0,0l-0.2-0.1l-0.2-0.1l-0.5-0.3l-1.2-1.1l-0.1-0.1l0-0.1l-2.4-3.4v0L301.5,145.7z	"
        >
          <title id="t1401">Holt, MO</title>
        </path>

        <path
          id="FIPS_29021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.2,151.4l0,0.9l0,2.8l-5,0l0.4-1.2l0.1-0.2l0.3-0.5l0,0l0.7-0.6l0.2,0l0.2-0.5l-0.1-0.4
		l-0.1-0.4L307.2,151.4z	"
        >
          <title id="t1403">Buchanan, MO</title>
        </path>
        <path
          id="FIPS_29003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.1,147.4l0,1.1l0.1,2.9l-3,0l-0.8-1l-0.5-3H307.1z	"
        >
          <title id="t1404">Andrew, MO</title>
        </path>
        <path
          id="FIPS_29147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.1,141.6l2.8,0l0.4,2.4l0,3.4h-4.3l-0.1-0.1l-0.1-0.1l-0.1-0.7l0-0.4l0,0l-0.2-0.4l-0.9,0
		l0-1.6l0-1.2h-0.2l0-1.3L304.1,141.6z	"
        >
          <title id="t1405">Nodaway, MO</title>
        </path>
        <path
          id="FIPS_29227"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.4,141.6l2.3-0.1l0.2,2.4l-3.8,0l-0.4-2.4L308.4,141.6z	"
        >
          <title id="t1406">Worth, MO</title>
        </path>
        <path
          id="FIPS_29075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.2,144l3.8,0l0,3.2v1.3l-3.8,0l0-1.1L307.2,144z	"
        >
          <title id="t1407">Gentry, MO</title>
        </path>
        <path
          id="FIPS_29063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M311,148.5l0.2,3.2l0,0.6l-3.9,0l0-0.9l-0.1-2.9L311,148.5z	"
        >
          <title id="t1408">DeKalb, MO</title>
        </path>

        <path
          id="FIPS_29061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.4,147.1l0.1,2.3l0.1,2.3l-1.3,0l-2,0l-1.1,0l-0.2-3.2v-1.3L315.4,147.1z	"
        >
          <title id="t1412">Daviess, MO</title>
        </path>
        <path
          id="FIPS_29081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.2,141.4l0.2,4.1l0,1.7l-4.4,0.1l0-3.2l-0.2-2.4l2.1-0.1L315.2,141.4z	"
        >
          <title id="t1413">Harrison, MO</title>
        </path>
        <path
          id="FIPS_29129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.3,141.3l1.8,0l0.1,2.6l0,1.5l-3.9,0.1l-0.2-4.1L317.3,141.3z	"
        >
          <title id="t1414">Mercer, MO</title>
        </path>
        <path
          id="FIPS_29079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.2,145.3l0.1,3l0,0.9l-3.9,0.2l-0.1-2.3l0-1.7L319.2,145.3z	"
        >
          <title id="t1415">Grundy, MO</title>
        </path>
        <path
          id="FIPS_29117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.4,149.2l0,1.1l0,2.3l1,0l-0.1,1.1l-4.7,0.2l-0.1-2.2l-0.1-2.3L319.4,149.2z	"
        >
          <title id="t1416">Livingston, MO</title>
        </path>
        <path
          id="FIPS_29033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.6,153.9l4.7-0.2l1.8,3l-0.4,0l-0.4,0.2l-0.9,0.8l-0.6,0.9l-0.1,0.1l-0.4,0.1l-0.1,0
		l-0.1-0.1l-0.6-0.8l-1.1,0.7l-0.7-0.1l-1,0.6l-0.1-4.1L315.6,153.9z	"
        >
          <title id="t1417">Carroll, MO</title>
        </path>

        <path
          id="FIPS_29101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.4,162.7l0,4.8l-5.5,0l-0.6-3.4l0-1.1l2.8,0.1l0-0.4L318.4,162.7z	"
        >
          <title id="t1421">Johnson, MO</title>
        </path>
        <path
          id="FIPS_29083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.4,167.6v0.6l0,4l-5.3,0l-0.2-3l0-1.6L318.4,167.6z	"
        >
          <title id="t1422">Henry, MO</title>
        </path>

        <path
          id="FIPS_29185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313.1,172.1l5.3,0l0.2,1.7l0,2.1h-0.3l-0.3,0.6l0,0.6l-0.6,0l-1.9,0l0-0.8l-2.6-0.1l0-1.8
		L313.1,172.1z	"
        >
          <title id="t1424">St. Clair, MO</title>
        </path>

        <path
          id="FIPS_29039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313,176.2l2.6,0.1l0,0.8l1.9,0l0.2,3.3l-4.7,0v-0.8L313,176.2z	"
        >
          <title id="t1426">Cedar, MO</title>
        </path>
        <path
          id="FIPS_29217"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313.1,174.4l0,1.8l0,3.4l-5.5-0.1l0-0.3l0-4.7l0-0.3l3.8,0.1l0.4-0.1l0.7-0.1L313.1,174.4z	"
        >
          <title id="t1427">Vernon, MO</title>
        </path>
        <path
          id="FIPS_29057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313,180.4l4.7,0l0,1.9v1.9l-4.3,0l-0.3-0.8L313,180.4z	"
        >
          <title id="t1428">Dade, MO</title>
        </path>
        <path
          id="FIPS_29011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313,179.6v0.8l0,3l-5.5-0.1l-0.1-3.8L313,179.6z	"
        >
          <title id="t1429">Barton, MO</title>
        </path>
        <path
          id="FIPS_29097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313,183.4l0.3,0.8l0,3.1l-5.7,0l0-3.7l0-0.3L313,183.4z	"
        >
          <title id="t1430">Jasper, MO</title>
        </path>
        <path
          id="FIPS_29145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.6,187.3l5.7,0l0,3.9l-5.6-0.1L307.6,187.3z	"
        >
          <title id="t1431">Newton, MO</title>
        </path>

        <path
          id="FIPS_29109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.7,184.1l0.2,2.4l0,1.3l0,0.9l-4.6,0l0-1.5l0-3.1L317.7,184.1z	"
        >
          <title id="t1433">Lawrence, MO</title>
        </path>
        <path
          id="FIPS_29009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M313.3,188.8l4.6,0l0,1.3h0.4l0,4.2l-2.9,0.1l-2.2,0L313.3,188.8z	"
        >
          <title id="t1434">Barry, MO</title>
        </path>

        <path
          id="FIPS_29209"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.9,187.9l2.8,0l0,2.3l0.4,0l0,4.1l-2.8,0.1l0-4.2H318l0-1.3L317.9,187.9z	"
        >
          <title id="t1436">Stone, MO</title>
        </path>

        <path
          id="FIPS_29213"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.2,190.1l1.5,0l0.1,4l-0.8,0l-4.5,0.1l-0.2,0l0-4.1L325.2,190.1z	"
        >
          <title id="t1438">Taney, MO</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "44180"
              ? `metroArea clickedArea state-mo`
              : `metroArea ${colorCode[44180]} state-mo`
          }
          id="FIPS_44180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_29043"
            className="FIPS_44180 st0 state-mo"
            d="M323.5,186.5l1.7,0.2l0,3.4l-4,0l-0.4,0l0-2.3l-2.8,0l0-1.3L323.5,186.5z	"
          >
            <title id="t1439">Christian, MO</title>
          </path>
          <path
            id="FIPS_29059"
            className="FIPS_44180 st0 state-mo"
            d="M323.1,175.9l2.2,0l0,2.3l0.1,0l0,3.1l-2.2,1l-1.1,0l-0.2-5L323.1,175.9z	"
          >
            <title id="t1441">Dallas, MO</title>
          </path>
          <path
            id="FIPS_29077"
            className="FIPS_44180 st0 state-mo"
            d="M322.1,182.3l1.1,0l0,1.9h0.2l0,2.4l-5.6,0l-0.2-2.4v-1.9L322.1,182.3z	"
          >
            <title id="t1437">Greene, MO</title>
          </path>
          <path
            id="FIPS_29167"
            className="FIPS_44180 st0 state-mo"
            d="M318,177l3.9,0.2l0.2,5l-4.5,0l0-1.9l-0.2-3.3L318,177z	"
          >
            <title id="t1435">Polk, MO</title>
          </path>
          <path
            id="FIPS_29225"
            className="FIPS_44180 st0 state-mo"
            d="M325.5,181.3l1.7,0l0,2.8h0.1l0,2.6l-2.2,0l-1.7-0.2l0-2.4h-0.2l0-1.9L325.5,181.3z	"
          >
            <title id="t1440">Webster, MO</title>
          </path>
        </g>

        <path
          id="FIPS_29085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.6,173.8l4.4,0l0,2.1l-1.1,1.3L318,177l0-0.6l0.3-0.6h0.3L318.6,173.8z	"
        >
          <title id="t1442">Hickory, MO</title>
        </path>
        <path
          id="FIPS_29015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.4,168.1l2.2,0l0-0.4l1,0l1.2,0l0,3.5l0.2,2.6l-4.4,0l-0.2-1.7L318.4,168.1z	"
        >
          <title id="t1443">Benton, MO</title>
        </path>
        <path
          id="FIPS_29159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M318.4,162.5l1.9,0h2.1l0.5,0v3.1l0,2.1l-1.2,0l-1,0l0,0.4l-2.2,0v-0.6l0-4.8L318.4,162.5z	"
        >
          <title id="t1444">Pettis, MO</title>
        </path>
        <path
          id="FIPS_29195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M322.1,156.7l2.6,2l-0.8,2.1l-1.1,1.8l-0.5,0h-2.1l-1.9,0l0.1-4.6l0.6,0.8l0.1,0.1l0.1,0
		l0.4-0.1l0.1-0.1l0.6-0.9l0.9-0.8l0.4-0.2L322.1,156.7z	"
        >
          <title id="t1445">Saline, MO</title>
        </path>
        <path
          id="FIPS_29041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.5,152.5l1.7,1.1l0,3.8l-1.4,1.3l-2.6-2l-1.8-3l0.1-1.1L324.5,152.5z	"
        >
          <title id="t1446">Chariton, MO</title>
        </path>
        <path
          id="FIPS_29115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324.3,148.1L324.3,148.1l0.1,4.4l-4,0.1l-1,0l0-2.3l0-1.1l0-0.9L324.3,148.1z	"
        >
          <title id="t1447">Linn, MO</title>
        </path>
        <path
          id="FIPS_29211"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.2,143.8l2.7-0.1l2.3-0.1l0,0.6l0.1,4l-5,0.2l-0.1-3L319.2,143.8z	"
        >
          <title id="t1448">Sullivan, MO</title>
        </path>
        <path
          id="FIPS_29171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.5,140.9l0.2,0.6l-0.1,1.2l0.3,1.3l-1.7,0.1l0-0.6l-2.3,0.1l-2.7,0.1l-0.1-2.6l2.7-0.1
		L325.5,140.9z	"
        >
          <title id="t1449">Putnam, MO</title>
        </path>
        <path
          id="FIPS_29197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329,140.7l0.1,3.3l-3.3,0.2l-0.3-1.3l0.1-1.2l-0.2-0.6l0.7,0L329,140.7z	"
        >
          <title id="t1450">Schuyler, MO</title>
        </path>
        <path
          id="FIPS_29001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.1,143.9l0,0.6l0.2,3.4l-4.9,0.2l-0.1,0l-0.1-4l1.7-0.1L329.1,143.9z	"
        >
          <title id="t1451">Adair, MO</title>
        </path>
        <path
          id="FIPS_29121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.3,147.9l0.6,1.1l0.1,4.5h0l-3.9,0.1l-1.7-1.1l0-4.4L329.3,147.9z	"
        >
          <title id="t1452">Macon, MO</title>
        </path>
        <path
          id="FIPS_29175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330,153.5l0,3.3l0,1.3l-1.1,0l-2.8-0.8l0-3.8L330,153.5z	"
        >
          <title id="t1453">Randolph, MO</title>
        </path>

        <path
          id="FIPS_29053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M324,160.8L324,160.8l0.2,0.6l0.1,0.1l0.5,0.3l0.1,0l0.6,0.1l2.3-0.1l0.6,0.6l-0.8,2.2
		l-0.2,0.6l-0.1,0.3l-1.3,0.1l-0.9,0l-2.2-0.1v-3.1L324,160.8z	"
        >
          <title id="t1455">Cooper, MO</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "17860"
              ? `metroArea clickedArea state-mo`
              : `metroArea ${colorCode[17860]} state-mo`
          }
          id="FIPS_17860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_29019"
            className="FIPS_17860 st0 state-mo"
            d="M330,158.2l2.1,0l0,2.3l-0.1,0l-0.1,0.1l-0.2,1.9l-0.1,1.9l-0.5,0.9l0.1,0.7l-1.8-1.2
		l-1.1-2.3l-0.6-0.6l1.1-3.7L330,158.2z	"
          >
            <title id="t1456">Boone, MO</title>
          </path>
          <path
            id="FIPS_29089"
            className="FIPS_17860 st0 state-mo"
            d="M326.1,157.4l2.8,0.8l-1.1,3.7l-2.3,0.1l-0.6-0.1l-0.1,0l-0.5-0.3l-0.1-0.1l-0.2-0.5v-0.1
		l0.8-2.1L326.1,157.4z	"
          >
            <title id="t1454">Howard, MO</title>
          </path>
        </g>
        <path
          id="FIPS_29051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.5,164.8l1.8,1.2l2.2,0.9l-1.7,3.1l-0.6,0.2l-1.6-0.2l0-1.1h-0.9L329.5,164.8z	"
        >
          <title id="t1457">Cole, MO</title>
        </path>
        <path
          id="FIPS_29135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.4,162.5l1.1,2.3l-0.9,4.1l-1.3,0l-2.2-2.1l0-1.1l0.9,0l1.3-0.1l0.1-0.3l0.2-0.6
		L328.4,162.5z	"
        >
          <title id="t1458">Moniteau, MO</title>
        </path>
        <path
          id="FIPS_29141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M322.9,165.6l2.2,0.1l0,1.1l2.2,2.1l-0.6,2.7L326,172l-2,0.1l-1.2-0.8l0-3.5L322.9,165.6z	"
        >
          <title id="t1459">Morgan, MO</title>
        </path>
        <path
          id="FIPS_29131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.6,168.9h0.9l0,1.1l1.6,0.2l0.6-0.2l0,0.6l0,1.7h0.2l0,1.9l-2.2,0l-0.9,0l-0.6-0.4
		l-0.2-0.2l-0.3-0.6l0-0.4l-0.1-0.4l-0.4-0.5l-0.6-0.1l0.6-2.7L328.6,168.9z	"
        >
          <title id="t1460">Miller, MO</title>
        </path>
        <path
          id="FIPS_29029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.7,171.6l0.6,0.1l0.4,0.5l0.1,0.4l0,0.4l0.3,0.6l0.2,0.2l0.6,0.4l0.9,0l0,2.1l-0.6,0.4
		l-0.7,0.4l-0.1,0l-0.2-0.1l-0.4-0.4l-0.2-0.3l-0.1-0.3l0,0l0,0l-2.4,0l-2.2,0l0-2.1l-0.2-2.6l1.2,0.8l2-0.1L326.7,171.6z	"
        >
          <title id="t1461">Camden, MO</title>
        </path>
        <path
          id="FIPS_29169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M332,174.1l1.7,0l0.1,5.3l-2.2,0.1l0-0.6l-1.7-0.8l0-1.9l0-2.1L332,174.1z	"
        >
          <title id="t1462">Pulaski, MO</title>
        </path>
        <path
          id="FIPS_29105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M325.3,175.9l2.4,0l0,0l0,0l0.1,0.3l0.2,0.3l0.4,0.4l0.2,0.1l0.1,0l0.7-0.4l0.6-0.4l0,1.9
		l1.7,0.8l0,0.6l0,1.7l-4.4,0l-1.7,0l0-3.1l-0.1,0L325.3,175.9z	"
        >
          <title id="t1463">Laclede, MO</title>
        </path>
        <path
          id="FIPS_29229"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M327.1,181.3l4.4,0l0.1,2.8l0.1,0.5l0,2.1l-4.4,0.1l0-2.6h-0.1L327.1,181.3z	"
        >
          <title id="t1464">Wright, MO</title>
        </path>
        <path
          id="FIPS_29067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.4,186.6l-0.1,3.4l-6.7,0.1l-1.5,0l0-3.4l2.2,0l4.4-0.1L333.4,186.6z	"
        >
          <title id="t1465">Douglas, MO</title>
        </path>
        <path
          id="FIPS_29153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.6,190.1l6.7-0.1l0.1,3.8l-0.3,0l-3.9,0.2l-2.5,0.1L326.6,190.1z	"
        >
          <title id="t1466">Ozark, MO</title>
        </path>
        <path
          id="FIPS_29091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.9,186.5l0.1,2.1l0,1.3l0,2.4l0.1,1.4l-4.6,0.2l-0.1-3.8l0.1-3.4l1.1,0l1.3,0L337.9,186.5
		z	"
        >
          <title id="t1467">Howell, MO</title>
        </path>
        <path
          id="FIPS_29215"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.8,179.4l2.2-0.1l0.6,0l0.1,2.3l1.1,0l0.1,4.9l-2.1,0.1l-1.3,0l-1.1,0l-1.7,0l0-2.1
		l-0.1-0.5l-0.1-2.8l0-1.7L333.8,179.4z	"
        >
          <title id="t1468">Texas, MO</title>
        </path>
        <path
          id="FIPS_29161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.5,172.1l1,0l0.3,4.7l-2.8,0.1l0.1,2.5l-2.2,0.1l-0.1-5.3l0.8-0.4l0.4-0.2l1.2-0.1l1.4,0
		L337.5,172.1z	"
        >
          <title id="t1469">Phelps, MO</title>
        </path>
        <path
          id="FIPS_29125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.2,170.4l0.2,1.8l0,1.3l-1.4,0l-1.2,0.1l-0.4,0.2l-0.8,0.4l-1.7,0l0-1.9h-0.2l0-1.7l1.7,0
		l1.4-0.1L337.2,170.4z	"
        >
          <title id="t1470">Maries, MO</title>
        </path>
        <path
          id="FIPS_29151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337,165L337,165l0.3,5.4l-2.4,0.1l-1.4,0.1l-1.7,0l0-0.6l1.7-3.1l0.4-0.3l0.8-0.8l0.1-0.1
		l0.1-0.1l0.1-0.1l1.3-0.6l0.3,0L337,165z	"
        >
          <title id="t1471">Osage, MO</title>
        </path>
        <path
          id="FIPS_29027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M332.2,160.5l4.7-0.1l0.1,4.6l-0.5,0l-0.3,0l-1.3,0.6l-0.1,0.1l-0.1,0.1l-0.1,0.1l-0.8,0.8
		l-0.4,0.3l-2.2-0.9l-0.1-0.7l0.5-0.9l0.1-1.9l0.2-1.9l0.1-0.1L332.2,160.5z	"
        >
          <title id="t1472">Callaway, MO</title>
        </path>
        <path
          id="FIPS_29137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335.7,152.6l0.2,4.1l-5.9,0.1l0-3.3h0l1.1,0l0-0.8l3.3-0.1L335.7,152.6z	"
        >
          <title id="t1473">Monroe, MO</title>
        </path>
        <path
          id="FIPS_29205"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.2,148.9l1.1,0l0.1,3.8l-3.3,0.1l0,0.8l-1.1,0l-0.1-4.5L333.2,148.9z	"
        >
          <title id="t1474">Shelby, MO</title>
        </path>
        <path
          id="FIPS_29103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.2,144.5l3.9-0.1l0,0.6l0.1,4l-3.3,0.1l-0.6-1.1L329.2,144.5z	"
        >
          <title id="t1475">Knox, MO</title>
        </path>
        <path
          id="FIPS_29199"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333,140.4l0.1,4l-3.9,0.1l0-0.6l-0.1-3.3l1.7-0.1L333,140.4z	"
        >
          <title id="t1476">Scotland, MO</title>
        </path>
        <path
          id="FIPS_29045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335.2,140.4l0.2,0.1l0.8,0.6l0,0.1l0,0.3l0,0.1l1,1.2l0.4,0.3l0.6,0l-0.7,1.7l-4.4,0.1l0-0.6
		l-0.1-4L335.2,140.4z	"
        >
          <title id="t1477">Clark, MO</title>
        </path>
        <path
          id="FIPS_29111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.5,144.8l-0.1,0.6l0.7,3.3l-3.8,0.1l-1.1,0l-0.1-4L337.5,144.8z	"
        >
          <title id="t1478">Lewis, MO</title>
        </path>
        <path
          id="FIPS_29127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.1,148.8l1,2.4l0.6,0.9l-3.9,0.5l-1.3,0.1l-0.1-3.8L338.1,148.8z	"
        >
          <title id="t1479">Marion, MO</title>
        </path>
        <path
          id="FIPS_29173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M335.7,152.6l3.9-0.5l1.4,1.1l-0.3,0l-2.4,2l0.3,1.7l-1.3,0l-1.5,0v-0.2L335.7,152.6z	"
        >
          <title id="t1480">Ralls, MO</title>
        </path>
        <path
          id="FIPS_29007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M330,156.9l5.9-0.1v0.2l1.5,0l1.3,0l0.4,2.3l-2.2,1.2l-4.7,0.1l0-2.3l-2.1,0L330,156.9z	"
        >
          <title id="t1481">Audrain, MO</title>
        </path>
        <path
          id="FIPS_29139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.5,159.1l0.1,1.9l0.1,1.9l-1.5,0.1l0.1,1.8L337,165l-0.1,0l-0.1-4.6l2.2-1.2L340.5,159.1z
			"
        >
          <title id="t1482">Montgomery, MO</title>
        </path>
        <path
          id="FIPS_29163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M341.1,153.1l2.4,2.5l2.4,2.1l-2.8,0.1l-1.8,0.1l0,1.1l-0.7,0l-1.5,0l-0.4-2.3l-0.3-1.7l2.4-2
		L341.1,153.1z	"
        >
          <title id="t1483">Pike, MO</title>
        </path>

        <path
          id="FIPS_29073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M339.8,164.9l0.1,2.5l0.1,2.3l0.1,1.6l-1.6,0.8l-1,0l-0.2-1.8L337,165l2.2-0.2L339.8,164.9z	"
        >
          <title id="t1486">Gasconade, MO</title>
        </path>
        <path
          id="FIPS_29055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340.1,171.2l2.7-0.1l0.3,6l-0.5,0.6l-1.6,0l0-1.1l-2.2,0.1l-0.3-4.7L340.1,171.2z	"
        >
          <title id="t1487">Crawford, MO</title>
        </path>
        <path
          id="FIPS_29065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.6,177.8l0.1,1.4l-1.6,0l0,1.1l1,0l0,1.1l-4.4,0.1l-1.1,0l-0.1-2.3l-0.6,0l-0.1-2.5
		l2.8-0.1l2.2-0.1l0,1.1L342.6,177.8z	"
        >
          <title id="t1488">Dent, MO</title>
        </path>
        <path
          id="FIPS_29203"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.7,181.6l4.4-0.1l0.4,0l1.1,3.1l0.7,1l-0.9,0.2l-1.1,0.1l0.1,2.6l-4.5,0.2l-0.1-2.1
		L337.7,181.6z	"
        >
          <title id="t1489">Shannon, MO</title>
        </path>
        <path
          id="FIPS_29149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.9,188.5l4.5-0.2l1.1,0.7l0.1,4.2l-2.9,0.2l-0.4,0l-2.3,0.1l-0.1-1.4l0-2.4L337.9,188.5z	
		"
        >
          <title id="t1490">Oregon, MO</title>
        </path>
        <path
          id="FIPS_29181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.5,189.1l0.7,0l1.6,0l2.3-0.1l1.1,4l-2.1,0.1l-3.5,0.2L343.5,189.1z	"
        >
          <title id="t1491">Ripley, MO</title>
        </path>
        <path
          id="FIPS_29035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.4,185.5l2.5,0.5l1.1,1.6l0.2,1.5l-2.3,0.1l-1.6,0l-0.7,0l-1.1-0.7l-0.1-2.6l1.1-0.1
		L344.4,185.5z	"
        >
          <title id="t1492">Carter, MO</title>
        </path>
        <path
          id="FIPS_29179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M342.6,179.2l2-0.3l1.9-0.1l0.1,2.4l0.3,1.9l0.2,0l0,0.6l0,0.8l-0.4,0.6l0,0.9l-2.5-0.5
		l-0.7-1l-1.1-3.1l-0.4,0l0-1.1l-1,0l0-1.1L342.6,179.2z	"
        >
          <title id="t1493">Reynolds, MO</title>
        </path>
        <path
          id="FIPS_29093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.7,177l1.2,1.1l0.1,4.2l-1.9,0.7l-0.2,0l-0.3-1.9l-0.1-2.4l-1.9,0.1l-2,0.3l-0.1-1.4
		l0.5-0.6L347.7,177z	"
        >
          <title id="t1494">Iron, MO</title>
        </path>

        <path
          id="FIPS_29187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.5,172.6l2.3,0.3l1,0.7l-1.3,1.4l0.8,0.8l2,1.8l0.4-0.4l0.5,0.3l-0.3,0.4l-3.9,0.2
		l-1.2-1.1L347.5,172.6z	"
        >
          <title id="t1501">St. Francois, MO</title>
        </path>
        <path
          id="FIPS_29186"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.9,172.2l2.9,2.6l-1.6,2.8l-0.5-0.3l-0.4,0.4l-2-1.8l-0.8-0.8l1.3-1.4l-1-0.7l1.6-1.1
		L351.9,172.2z	"
        >
          <title id="t1502">Ste. Genevieve, MO</title>
        </path>
        <path
          id="FIPS_29123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.8,177.9l0,0.6l0.1,0.7l0.1,3l-0.7,0l-3.4,0.2l-0.1-4.2L352.8,177.9z	"
        >
          <title id="t1503">Madison, MO</title>
        </path>
        <path
          id="FIPS_29223"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349,182.4l3.4-0.2l0.1,3l1.1-0.1l0,0.6l-1.4,1.6l-4.3,0.2l-1.1-1.6l0-0.9l0.4-0.6l0-0.8
		l0-0.6L349,182.4z	"
        >
          <title id="t1504">Wayne, MO</title>
        </path>
        <path
          id="FIPS_29023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.2,187.4l0.5,1.3l0.4,0.8l0.1,0l0.1,0.1l0.3,0.6l0.1,0.5l0,0.3l-0.1,0.2l-0.6,1.8
		l-3.7,0.2l-1.1-4l-0.2-1.5L352.2,187.4z	"
        >
          <title id="t1505">Butler, MO</title>
        </path>
        <path
          id="FIPS_29069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.5,191l0.2,3.1l0.3,5.1l-3.4,0.2l-0.8,0.1l1.6-2.8l1.1-1l0.1-0.1l0.1-0.3l-0.1-1l-0.1-0.1
		l-0.9-1.3l-0.4,0l-0.3,0l0.6-1.8L355.5,191z	"
        >
          <title id="t1506">Dunklin, MO</title>
        </path>
        <path
          id="FIPS_29207"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.1,184.4l1-0.1l0.2,1.2l0.2,0.3l0.2,0.3l0.2,0.5l0.2,0.4l0,0.7l-0.1,0l0.2,3l-2.7,0.1
		l-1.9,0.1l0.1-0.2l0-0.3l-0.1-0.5l-0.3-0.6l-0.1-0.1l-0.1,0l-0.4-0.8l-0.5-1.3l1.4-1.6l0.9-0.1l0.6-0.2l-0.1-0.9L356.1,184.4z	"
        >
          <title id="t1507">Stoddard, MO</title>
        </path>

        <path
          id="FIPS_29157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.7,174.8l2.7,0.8l1.7,2.9v0.1l-3.5-0.2l-2.9,0.2l0-0.6l0.3-0.4L354.7,174.8z	"
        >
          <title id="t1509">Perry, MO</title>
        </path>

        <path
          id="FIPS_29201"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.8,182.6l0.3,0.4l0.6,1.2l0.4,0.9l0.7,0.6l-1.9,2l-1.7,0.2l0-0.7l-0.2-0.4l-0.2-0.5
		l-0.2-0.3l-0.2-0.3l-0.2-1.2L359.8,182.6z	"
        >
          <title id="t1511">Scott, MO</title>
        </path>
        <path
          id="FIPS_29133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.7,185.6l2,0.2l0.4,0.5l-0.4,1.3l0,0l-0.3,0.2l0,0v0.3l0,0l0.6,0.3l-0.4,1.8l-1.6,0.3
		l-2.2-2.9L361.7,185.6z	"
        >
          <title id="t1512">Mississippi, MO</title>
        </path>

        <path
          id="FIPS_28059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.3,266.3l5.2-0.4l0.6,4.7l0,0.2l-0.8,0.5l-0.1,0l-2.8-0.1l-0.2,0l-0.8-0.4l-0.4-0.2
		l-0.7-3.5L372.3,266.3z	"
        >
          <title id="t1514">Jackson, MS</title>
        </path>
        <path
          id="FIPS_28043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.1,226.3l1.7-0.1l0,0.4l2.8-0.2l0.2,2.5l-3,0.2l-3.6,0.2l-0.1-0.6l-0.1-1.1l1.1-0.1
		l1.1-0.2l0-0.4L358.1,226.3z	"
        >
          <title id="t1515">Grenada, MS</title>
        </path>
        <path
          id="FIPS_28161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.3,222.6l0.3,3.8l-2.8,0.2l0-0.4l-1.7,0.1l-0.3-3.4l2.2-0.5L362.3,222.6z	"
        >
          <title id="t1516">Yalobusha, MS</title>
        </path>
        <path
          id="FIPS_28025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M371,226.5l0.1,1.7l2.3-0.2l0.1,0.1l-0.2,0.3l-1.5,2l-0.1-0.8l-3.3,0.3l-0.4,0.1l-0.3-2.3
		L371,226.5z	"
        >
          <title id="t1517">Clay, MS</title>
        </path>
        <path
          id="FIPS_28155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.1,227.9l1.7-0.1l0.3,2.3l-0.7,0.4l-3.1,1.2l-1.3,0.1l-0.2-3.4L366.1,227.9z	"
        >
          <title id="t1518">Webster, MS</title>
        </path>
        <path
          id="FIPS_28017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M369.7,223.2l1.1-0.1l0.2,3.4l-3.3,1.2l-1.7,0.1l-0.1-0.9l0.6,0l-0.3-3.4L369.7,223.2z	"
        >
          <title id="t1519">Chickasaw, MS</title>
        </path>
        <path
          id="FIPS_28013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.3,222.6l2.8-0.2l1.2,1l0.3,3.4l-0.6,0l0.1,0.9l-3.3,0.4l-0.1-1.9L362.3,222.6z	"
        >
          <title id="t1520">Calhoun, MS</title>
        </path>
        <path
          id="FIPS_28115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M369.4,219.5l0.3,3.8l-3.3,0.3l-1.2-1l-0.2-2.8L369.4,219.5z	"
        >
          <title id="t1521">Pontotoc, MS</title>
        </path>
        <path
          id="FIPS_28081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.2,217.5l2.1,0.4l0.4,4.9l-1.8,0.3l-1.1,0.1l-0.3-3.8L370.2,217.5z	"
        >
          <title id="t1522">Lee, MS</title>
        </path>
        <path
          id="FIPS_28145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.4,216.6l3.7-0.3l0.1,1.1l-0.8,1.9l-4.5,0.1l-0.1-1.5l-0.1-1.1L366.4,216.6z	"
        >
          <title id="t1523">Union, MS</title>
        </path>
        <path
          id="FIPS_28071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.8,217.7l0.6,0l1.1-0.1l0.9,0l1.4,0.3l1.1,0.3l0.1,1.5l0.2,2.8l-2.8,0.2l-2.3-0.2
		L359.8,217.7z	"
        >
          <title id="t1524">Lafayette, MS</title>
        </path>

        <path
          id="FIPS_28107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.7,218l5-0.3l0.3,4.7l-2.2,0.5l-2.2,0.2l-0.1-1.4l-0.7-0.7l-0.2-2.4L354.7,218z	"
        >
          <title id="t1526">Panola, MS</title>
        </path>
        <path
          id="FIPS_28119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.8,218.6l0.2,2.4l0.7,0.7l0.1,1.4l0.1,1.1l-0.6,0l-2.8,0.2l-0.1-2.5l0.6,0l-0.1-2.1l1-0.1
		l-0.1-1.1L354.8,218.6z	"
        >
          <title id="t1527">Quitman, MS</title>
        </path>
        <path
          id="FIPS_28135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.7,223.1l2.2-0.2l0.3,3.4l0,0.6l0,0.4l-1.1,0.2l-1.1,0.1l0.1,1.1l-0.4-0.8l-0.1-0.3
		l-2.9,0.1l-0.1-2.3l-0.1-1.1l2.8-0.2l0.6,0L355.7,223.1z	"
        >
          <title id="t1528">Tallahatchie, MS</title>
        </path>
        <path
          id="FIPS_28083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.6,227.8l2.9-0.1l0.1,0.3l0.4,0.8l0.1,0.6l0.3,0.2l0,0.1l0.2,2.5l-0.4,0.6l-0.4,0l0.1,1.1
		l-1.7,0.5L353,234L352.6,227.8z	"
        >
          <title id="t1529">Leflore, MS</title>
        </path>
        <path
          id="FIPS_28133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.5,225.5l0.1,2.3l0.4,6.2l-1.1,0.1l0.1,0.8l-1.7,0.1l-0.7-3.3l-0.1-1.1l1.1-0.1l-0.3-4.8
		L352.5,225.5z	"
        >
          <title id="t1530">Sunflower, MS</title>
        </path>
        <path
          id="FIPS_28053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353,234l1.3,0.3l0.1,2.2l-0.3,0.6l-0.1,0l-0.1,0l-0.3-0.2l-0.1-0.2l0,0l0,0l0,0.2l0,0.4
		l0,0.1l0.5,0.4l0.2,0.1l-0.9,0.1l0.1,1.1l-2.2,0.1l-0.6-2.2l-0.3-2.2l1.7-0.1l-0.1-0.8L353,234z	"
        >
          <title id="t1531">Humphreys, MS</title>
        </path>
        <path
          id="FIPS_28051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.3,234.3l1.7-0.5l4.6,1.2l-2,4.5l-4.4-1.4l-0.2-0.1l-0.5-0.4l0-0.1l0-0.4l0-0.2l0,0l0,0
		l0.1,0.2l0.3,0.2l0.1,0l0.1,0l0.3-0.6L354.3,234.3z	"
        >
          <title id="t1532">Holmes, MS</title>
        </path>
        <path
          id="FIPS_28015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.2,229.3l3.6-0.2l0.2,3.4l0.8,0.1l0.7-0.1l0.1,1.5l-1.1,1l-4.6-1.2l-0.1-1.1l0.4,0
		l0.4-0.6l-0.2-2.5l0-0.1L356.2,229.3z	"
        >
          <title id="t1533">Carroll, MS</title>
        </path>
        <path
          id="FIPS_28097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.8,228.9l0.2,2.8l1.3-0.1l-0.6,2.3l-2.1,0.1l-0.1-1.5l-0.7,0.1l-0.8-0.1l-0.2-3.4
		L362.8,228.9z	"
        >
          <title id="t1534">Montgomery, MS</title>
        </path>
        <path
          id="FIPS_28019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.4,230.4l0.2,3.2l-0.2,0l-1,1.2l0.1,1.1l-1.1,0.1l-1.6-2.2l0.6-2.3L367.4,230.4z	"
        >
          <title id="t1535">Choctaw, MS</title>
        </path>
        <path
          id="FIPS_28105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M368.1,230l0.4-0.1l3.3-0.3l0.1,0.8l0.2,2.8l-1.5,0.1l-2.9,0.2l-0.2-3.2L368.1,230z	"
        >
          <title id="t1536">Oktibbeha, MS</title>
        </path>
        <path
          id="FIPS_28087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.4,228.4l2.7-1.5l-0.1,2.7l-0.1,3.2l-3.9,0.3l-0.2-2.8L373.4,228.4z	"
        >
          <title id="t1537">Lowndes, MS</title>
        </path>
        <path
          id="FIPS_28095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.2,222.5l0,0.4l-0.1,4.1l-2.7,1.5l0.2-0.3l-0.1-0.1l-2.3,0.2l-0.1-1.7l-0.2-3.4l1.8-0.3
		L376.2,222.5z	"
        >
          <title id="t1538">Monroe, MS</title>
        </path>
        <path
          id="FIPS_28057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376.3,217.6l-0.1,4.9l-3.6,0.3l-0.4-4.9l2.2-0.2L376.3,217.6z	"
        >
          <title id="t1539">Itawamba, MS</title>
        </path>
        <path
          id="FIPS_28117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.8,214l0.7,3.7l-2.2,0.2l-2.1-0.4l-0.1-1.1l0-2.1L373.8,214z	"
        >
          <title id="t1540">Prentiss, MS</title>
        </path>
        <path
          id="FIPS_28141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.6,210.9l1.7-0.1l1.2,1.2l-0.1,4.1l0,1.5l-1.8,0.1l-0.7-3.7L373.6,210.9z	"
        >
          <title id="t1541">Tishomingo, MS</title>
        </path>
        <path
          id="FIPS_28003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.4,210.9l0.2,0l0.2,3.1l-3.7,0.3l-1.3-3l0.4,0L373.4,210.9z	"
        >
          <title id="t1542">Alcorn, MS</title>
        </path>
        <path
          id="FIPS_28139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.7,211.5l2-0.2l1.3,3l0,2.1l-3.7,0.3l-0.2-2.8l0.6,0l0.1-0.6L366.7,211.5z	"
        >
          <title id="t1543">Tippah, MS</title>
        </path>
        <path
          id="FIPS_28009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364.9,211.6l1.9-0.1l0.1,1.8l-0.1,0.6l-0.6,0l0.2,2.8l-1.6,0.3l-0.6,0l-0.3-3.4l-0.4-0.6
		l-0.3-1.3L364.9,211.6z	"
        >
          <title id="t1544">Benton, MS</title>
        </path>

        <path
          id="FIPS_28027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M350.8,218.6l1.9,1.2l0.1,2.1l-0.6,0l0.1,2.5l0.1,1.1l-2.2,0.1l-0.1-1.7l-1.7,0.1l-1.2,0.1
		l0-0.1l0.2-0.3l0.5-1l1-1.8l0.6-0.1l0.6-0.1l0.5-0.2l0.4-0.3l0,0l0,0l0.1-0.2L350.8,218.6z	"
        >
          <title id="t1548">Coahoma, MS</title>
        </path>
        <path
          id="FIPS_28011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.3,224.1l1.2-0.1l1.7-0.1l0.1,1.7l0.3,4.8l-1.1,0.1l0.1,1.1l-4.8,0.3l-0.1-0.4l0.8-0.3
		l0.2-0.2l0-0.1v0l-0.3-0.2l-0.3-0.2l-0.1-0.1l0,0l0.1-0.3l0.9-3.7l2.1-1l0.1-0.4l-0.1-0.3L347.3,224.1L347.3,224.1z	"
        >
          <title id="t1549">Bolivar, MS</title>
        </path>
        <path
          id="FIPS_28151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.7,231.9l4.8-0.3l0.7,3.3l0.3,2.2l-2.2,1.3l-2.6,0.1l0.3-0.4l0,0l0.3-1.4v0l0-1l-0.3-0.3
		l-0.4-0.7l-0.5-1.5l0.6-0.2l0.1-0.3l-0.1-0.3l-0.4-0.3L344.7,231.9L344.7,231.9z	"
        >
          <title id="t1550">Washington, MS</title>
        </path>
        <path
          id="FIPS_28125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M350.5,237.2l0.6,2.2l-1,1.2l0,0.3l0.2,0.1l0.3,0.2l0.3,0.3l0.3,1l0,0.2l-0.1,0.1l-0.5,0.1
		l-2.6,0.1l-0.1-2.3l0.1-0.2l0.1,0l0.1-0.1l0-0.1l0.2-1l0-0.9L350.5,237.2z	"
        >
          <title id="t1551">Sharkey, MS</title>
        </path>
        <path
          id="FIPS_28055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M348.2,238.4l0,0.9l-0.2,1l0,0.1l-0.1,0.1l-0.1,0l-0.1,0.2l0.1,2.3l2.6-0.1l0.1,0.6l-0.5,0.6
		l-0.9,1.8l-1.1,0.3l-0.1-2l-1.4,0.1l-0.3-0.1l0,0l-0.1-0.1l0,0l0,0l0,0l0,0l-0.1-0.2l-0.9-3.9l0-0.1l0.1-0.4l0.4-0.6l0.1-0.1
		L348.2,238.4z	"
        >
          <title id="t1552">Issaquena, MS</title>
        </path>
        <path
          id="FIPS_28163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M354.2,238.1l4.4,1.4l-0.7,1.8l-0.1,0.2l-0.6,0.4l-3.2,1.8l-0.4,0.1l-1.1,0.9l-1.9-1.3
		l-0.1-0.6l0.5-0.1l0.1-0.1l0-0.2l-0.3-1l-0.3-0.3l-0.3-0.2l-0.2-0.1l0-0.3l1-1.2l2.2-0.1l-0.1-1.1L354.2,238.1z	"
        >
          <title id="t1553">Yazoo, MS</title>
        </path>
        <path
          id="FIPS_28007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M363.7,233.9l1.6,2.2l0.1,2.3l-2.6,0.2l-1.8,0.1l0,0.6l-2.5,0.2l2-4.5l1.1-1L363.7,233.9z	"
        >
          <title id="t1554">Attala, MS</title>
        </path>
        <path
          id="FIPS_28159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.6,233.6l2.9-0.2l0.4,4.7l-1.1,0.1l-4.4,0.2l-0.1-2.3l1.1-0.1l-0.1-1.1l1-1.2L367.6,233.6
		z	"
        >
          <title id="t1555">Winston, MS</title>
        </path>
        <path
          id="FIPS_28103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.1,233.3l3.9-0.3l-0.1,3.9l0,0.8l-5,0.4l-0.4-4.7L372.1,233.3z	"
        >
          <title id="t1556">Noxubee, MS</title>
        </path>
        <path
          id="FIPS_28069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.9,238l5-0.4l-0.1,4.6l-5.7,0.5l-0.3-4.5L370.9,238z	"
        >
          <title id="t1557">Kemper, MS</title>
        </path>
        <path
          id="FIPS_28099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.5,238.4l4.4-0.2l0.3,4.5l-4.4,0.3L365.5,238.4z	"
        >
          <title id="t1558">Neshoba, MS</title>
        </path>
        <path
          id="FIPS_28079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.5,238.4l0.3,4.6l-0.1,0l-4.4,0.3l-0.1-0.7l-0.2-3.2l0-0.6l1.8-0.1L365.5,238.4z	"
        >
          <title id="t1559">Leake, MS</title>
        </path>

        <path
          id="FIPS_28149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.6,244.1l1.4-0.1l0.1,2l1.1-0.3l0.9-1.8l0.5-0.6l1.9,1.3l-1.7,3.8l-0.3,0.3l-0.5,0.6
		l-1.1,1l-0.3,0l-0.9-0.3l-1.1-1.3l1.3-0.2l-0.1-1.9l-1.2-1.3l0,0l0-0.1l0,0v0l0-0.2l0.2-0.8L346.6,244.1z	"
        >
          <title id="t1563">Warren, MS</title>
        </path>
        <path
          id="FIPS_28063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345.4,253.3l2.6,0l1.9,0.4l0,0.2l0,0.1l0.1,0.2l1.1-0.1l0.1,1.1l0.1,1.1l-4.6,0.3l-2.4-1.6
		L345.4,253.3z	"
        >
          <title id="t1564">Jefferson, MS</title>
        </path>
        <path
          id="FIPS_28021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M350.8,248.4l0.2,2.3l0,3.4l-1.1,0.1l-0.1-0.2l0-0.1l0-0.2l-1.9-0.4l-2.6,0l2.2-3.3l0.9,0.3
		l0.3,0l1.1-1l0.5-0.6L350.8,248.4z	"
        >
          <title id="t1565">Claiborne, MS</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "27140"
              ? `metroArea clickedArea state-ms`
              : `metroArea ${colorCode[27140]} state-ms`
          }
          id="FIPS_27140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_28029"
            className="FIPS_27140 st0 state-ms"
            d="M356.4,250.4l1.4,3.8l-1.3,0.5l-5.4,0.6l-0.1-1.1l0-3.4L356.4,250.4z	"
          >
            <title id="t1566">Copiah, MS</title>
          </path>
          <path
            id="FIPS_28089"
            className="FIPS_27140 st0 state-ms"
            d="M358.5,239.5l2.5-0.2l0.2,3.2l-0.5,0.7l-0.2,0l-0.6,0.1l-1.5,1.4l-0.6,0.7l0,0.1l0,0.2
		l0.1,0.2l-1.4,0.1l-0.6-0.1l-0.1-1l-0.4,0l-1.8,0.1l-0.1-1.1l0.4-0.1l3.2-1.8l0.6-0.4l0.1-0.2L358.5,239.5z	"
          >
            <title id="t1560">Madison, MS</title>
          </path>
          <path
            id="FIPS_28121"
            className="FIPS_27140 st0 state-ms"
            d="M360.8,243.2l0.9,4.7l0.2,2.3l-5.4,0.3l-0.3-0.8l0.4-1.8l0.7-1l0.7-1.1l-0.1-0.2l0-0.2l0-0.1
		l0.6-0.7l1.5-1.4l0.6-0.1L360.8,243.2z	"
          >
            <title id="t1561">Rankin, MS</title>
          </path>
          <path
            id="FIPS_28049"
            className="FIPS_27140 st0 state-ms"
            d="M352.5,244.7l1.1-0.9l0.1,1.1l1.8-0.1l0.4,0l0.1,1l0.6,0.1l1.4-0.1l-0.7,1.1l-0.7,1l-0.4,1.8
		l0.3,0.8l-5.3,0.3l-0.2-2.3L352.5,244.7z	"
          >
            <title id="t1562">Hinds, MS</title>
          </path>
          <path
            id="FIPS_28127"
            className="FIPS_27140 st0 state-ms"
            d="M361.8,250.1l1.1,3.4l-1.1,0.2l-2.4,0.3l-1.6,0.2l-1.4-3.8L361.8,250.1z	"
          >
            <title id="t1567">Simpson, MS</title>
          </path>
        </g>

        <path
          id="FIPS_28129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.6,247.8l4.4-0.3l0.4,5.4l-0.9,0.1l-2.7,0.4l-1.1-3.4L361.6,247.8z	"
        >
          <title id="t1568">Smith, MS</title>
        </path>
        <path
          id="FIPS_28123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.3,242.5l0.1,0.7l4.4-0.3l0.3,4.6l-4.4,0.3l-0.9-4.7L361.3,242.5z	"
        >
          <title id="t1569">Scott, MS</title>
        </path>
        <path
          id="FIPS_28101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.8,242.9l4.4-0.3l0.3,4.5l-4.4,0.3L365.8,242.9L365.8,242.9z	"
        >
          <title id="t1570">Newton, MS</title>
        </path>
        <path
          id="FIPS_28075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.2,242.6l5.7-0.5l-0.1,3.5l0,1.1l-5.2,0.4L370.2,242.6z	"
        >
          <title id="t1571">Lauderdale, MS</title>
        </path>
        <path
          id="FIPS_28023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.7,246.7l-0.1,4.3l-4.7,1.2l-0.4-5.1L375.7,246.7z	"
        >
          <title id="t1572">Clarke, MS</title>
        </path>
        <path
          id="FIPS_28061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.5,247.2l0.4,5.1l-0.4,0.1l-4.1,0.6l-0.4-5.4L370.5,247.2z	"
        >
          <title id="t1573">Jasper, MS</title>
        </path>
        <path
          id="FIPS_28067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.6,252.4l0.4,5l-2.2,0.2l-2.8,0.2l-0.4-4.7l0.9-0.1L370.6,252.4z	"
        >
          <title id="t1574">Jones, MS</title>
        </path>
        <path
          id="FIPS_28031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.6,253.1l0.4,4.7l-0.6,0l-1.5,0.1l-0.1-1l-0.2-0.3l-0.4-0.2l-0.4,0l-0.3-0.1l-0.6-0.4
		l-0.1-2.1l1.1-0.2L365.6,253.1z	"
        >
          <title id="t1575">Covington, MS</title>
        </path>
        <path
          id="FIPS_28065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.4,253.9l2.4-0.3l0.1,2.1l0.6,0.4l0.3,0.1l0.4,0l0.4,0.2l0.2,0.3l0.1,1l-0.7,0l-1.9,0.1
		l0,0.6l-1.5,0.1l-0.1-1.7l-0.3-1.3L359.4,253.9z	"
        >
          <title id="t1576">Jefferson Davis, MS</title>
        </path>
        <path
          id="FIPS_28077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.8,254.2l1.6-0.2l0.1,1.7l0.3,1.3l0.1,1.7l-0.8,0.8l-2.2,0l-0.3-4.7L357.8,254.2z	"
        >
          <title id="t1577">Lawrence, MS</title>
        </path>
        <path
          id="FIPS_28085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.5,254.7l0.3,4.7l-0.2,0l-3.2,0.2l-0.9,0.1l-0.2-3.4l-1.1,0.1l-0.1-1.1L356.5,254.7z	"
        >
          <title id="t1578">Lincoln, MS</title>
        </path>
        <path
          id="FIPS_28037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.6,256.6l4.6-0.3l1.1-0.1l0.2,3.4l-3.8,0.2l-1.2,0.4l-0.7-0.3L346.6,256.6z	"
        >
          <title id="t1579">Franklin, MS</title>
        </path>
        <path
          id="FIPS_28001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.1,255l2.4,1.7l0.1,3.4l-0.1,0l-0.8-0.3l-0.5,0.1l-0.4,0.1l-1.5,0.6l-1.4,1.3l-0.1,0.2
		l-0.2,0.7l0.3-1.4l0.4-3.4l0,0l0-0.1l0-0.1l1.2-2.4l0,0l0.2-0.3L344.1,255z	"
        >
          <title id="t1580">Adams, MS</title>
        </path>
        <path
          id="FIPS_28157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.7,260l0.7,0.3l0.6,4.1l-1.3,0.1l-5.1,0.2l0.3-2l0.2-0.7l0.1-0.2l1.4-1.3l1.5-0.6l0.4-0.1
		l0.5-0.1L346.7,260L346.7,260z	"
        >
          <title id="t1581">Wilkinson, MS</title>
        </path>
        <path
          id="FIPS_28005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.4,259.6l0.3,4.5l-0.2,0l-2.9,0.2l-2.6,0.1l-0.6-4.1l1.2-0.4l3.8-0.2L353.4,259.6z	"
        >
          <title id="t1582">Amite, MS</title>
        </path>
        <path
          id="FIPS_28113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.4,259.6l3.2-0.2l0.3,4.5l-1,0.1l-2.2,0.1L353.4,259.6z	"
        >
          <title id="t1583">Pike, MS</title>
        </path>
        <path
          id="FIPS_28147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.8,259.4l2.2,0l0.1,1.3l0.2,0.7l0.4,0.5l0.8,0.5l0.8,0.1l0.2,0.9l-4.7,0.3l-0.3-4.5
		L356.8,259.4z	"
        >
          <title id="t1584">Walthall, MS</title>
        </path>
        <path
          id="FIPS_28091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M363.1,257.9l0.4,5.6l-0.8,0.1l-1.2,0.1l-0.2-0.9l-0.8-0.1l-0.8-0.5l-0.4-0.5l-0.2-0.7
		l-0.1-1.3l0.8-0.8l1.5-0.1l0-0.6L363.1,257.9z	"
        >
          <title id="t1585">Marion, MS</title>
        </path>
        <path
          id="FIPS_28073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.4,257.8l0.1,1.1l1.1-0.1l0.3,4.3l-3.4,0.3l-0.4-5.6l0.7,0L365.4,257.8z	"
        >
          <title id="t1586">Lamar, MS</title>
        </path>
        <path
          id="FIPS_28035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M368.7,257.5l0.3,4l0.2,1.6l0.1,1.2l-2.2,0.2l-0.2-1.3l-0.3-4.3l-1.1,0.1l-0.1-1.1l0.6,0
		L368.7,257.5z	"
        >
          <title id="t1587">Forrest, MS</title>
        </path>
        <path
          id="FIPS_28153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M375.6,251.1l0.3,2.5l0.4,3.4l-4.3,0.4l-1.1,0.1l-0.4-5l0.4-0.1L375.6,251.1z	"
        >
          <title id="t1588">Wayne, MS</title>
        </path>
        <path
          id="FIPS_28041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372,257.3l4.3-0.4l0.5,4.1l0.2,1.5l-4.5,0.4L372,257.3z	"
        >
          <title id="t1589">Greene, MS</title>
        </path>
        <path
          id="FIPS_28111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.9,257.4l1.1-0.1l0.5,5.6l-0.5,1.2l-2.8,0.2l-0.1-1.2l-0.2-1.6l-0.3-4L370.9,257.4z	"
        >
          <title id="t1590">Perry, MS</title>
        </path>

        <path
          id="FIPS_28109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M366.9,263.2l0.2,1.3l0.2,3.4l-1.5,0.1l-0.7,0.4l0.1,1.3l-1.1,0.8l-0.5,0l-1.9-2.6l0.1-0.9
		l0.1-0.7l0.2-0.8l0.1-0.6l0,0l0.1,0l0.1,0l0.1-0.2l0.1-0.7l0-0.4l0.8-0.1L366.9,263.2z	"
        >
          <title id="t1592">Pearl River, MS</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "25060"
              ? `metroArea clickedArea state-ms`
              : `metroArea ${colorCode[25060]} state-ms`
          }
          id="FIPS_25060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_28045"
            className="FIPS_25060 st0 state-ms"
            d="M363.6,270.5l0.5,0l1.1-0.8l-0.1-1.3l0.7-0.4l1.5-0.1l0.3,3.5l-1.9,2.6l-0.5,0l0,0l0,0l0,0
		l0,0l-0.1-0.1l-0.2-0.3l-0.1-0.2l-0.4-0.7l0-0.1l0-0.1l0.1-0.3l0-0.2L363.6,270.5L363.6,270.5L363.6,270.5z	"
          >
            <title id="t1593">Hancock, MS</title>
          </path>
          <path
            id="FIPS_28047"
            className="FIPS_25060 st0 state-ms"
            d="M372.3,267.1l0.7,3.5l-0.8,0.2l-1.8,0.5l-2.2,0.6l-0.7-0.5l-0.3-3.5l1.1-0.1l0.1-0.4
		L372.3,267.1z	"
          >
            <title id="t1513">Harrison, MS</title>
          </path>
          <path
            id="FIPS_28131"
            className="FIPS_25060 st0 state-ms"
            d="M372.1,264.1l0.2,2.3l0.1,0.7l-3.9,0.3l-0.1,0.4l-1.1,0.1l-0.2-3.4l2.2-0.2L372.1,264.1z	"
          >
            <title id="t1591">Stone, MS</title>
          </path>
        </g>
        <path
          id="FIPS_28039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M372.6,262.9l4.5-0.4l0.4,3.4l-5.2,0.4l-0.2-2.3L372.6,262.9z	"
        >
          <title id="t1594">George, MS</title>
        </path>

        <path
          id="FIPS_30091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M224.4,30.1l-0.4,4.7l-0.3,3.1l-5-0.4l0.1-1.1l-1-1.2l-1.9-0.2l0.1-1.1l-0.6-0.1l0.2-3.3
		l0.1-1.1L224.4,30.1z	"
        >
          <title id="t1595">Sheridan, MT</title>
        </path>
        <path
          id="FIPS_30085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M216,34.9l1.9,0.2l1,1.2l-0.1,1.1l5,0.4l-0.4,5l-1.7-0.6l-1.7-1l-3.6-0.9l-0.5,0.2l-0.2,0.3
		l-0.3,0.2l-0.2,0.1l-1.1,0l-0.6-0.1l-0.5-0.4l-0.7-0.1l-0.6,0l-1.6,0l-0.4,0l-0.5,0.3l-1.4,0.4l0.3-2.7l0.3,0l0.5-4.4L216,34.9z	"
        >
          <title id="t1596">Roosevelt, MT</title>
        </path>
        <path
          id="FIPS_30031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M158.9,58.2l2.5,0.4l-0.2,0.6l-0.3,1.8l-0.1,0.7l-0.1,0.9l-0.2,1.1l-0.4,2.5l-0.6,0.4
		l-0.6,0.2l-0.2,1.1l-0.2,1.1l-1.1-0.2l-0.4,2.2l-0.2,1l-0.2,1.3l-0.8,4.3l-0.3,2.5l-0.7-0.7l-0.1-0.3l-0.4-1.2l-0.7-1.5l-0.4-0.4
		l0.3-2l1-5.6l0.3-0.4l0.5-3.3l-1.7-0.3l-0.6-0.9l-0.4-0.6l-0.4-0.5l-0.3-0.2l-0.4-0.2l1.4-0.2l1.9-1.2l0.5-0.5l0.1-0.9l0.3-0.5
		l0.6-0.8l0.4-0.1l1.3,0.1L158.9,58.2z	"
        >
          <title id="t1597">Gallatin, MT</title>
        </path>
        <path
          id="FIPS_30057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M148,62.2L148,62.2l0.2,0l0.3-0.2l0.3-0.5l0-0.2l0.1-0.1l0.2-0.1l0.6,0l0.8,0.2l1,0.7l0,0.1
		l0,0.1l0.4,0.2l0.3,0.2l0.4,0.5l0.4,0.6l0.6,0.9l1.7,0.3l-0.5,3.3l-0.3,0.4l-1,5.6l-0.3,2l-1,0.4l-2.7-0.4l0.2-0.9l-1.1-0.2
		l-1.5-0.3l-0.8-0.7l0-1.1l0.2-1.1l-1.3-0.2l-0.9-1.3l0.6-3.3l0-0.6l-0.3-0.7l-0.3-0.1l-0.2,0.1l-0.1,0.1l-0.2,0l-0.3-0.2l-0.5-0.6
		l0-0.1l0-0.7l0.4-1.1l0.9-0.3l0.4-0.2l0.2-0.2l0.1-0.1l0.6-0.3L148,62.2	"
        >
          <title id="t1598">Madison, MT</title>
        </path>
        <path
          id="FIPS_30007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153.3,52.4l1.3,0l0.3-2l0.3-0.4l0,0l0.1,0l0.7,0.4l2.2,4.5l0.4,2.6l0.1,0.8l-0.9-0.1
		l-1.3-0.1l-0.4,0.1l-0.6,0.8l-0.3,0.5l-0.1,0.9l-0.5,0.5l-1.9,1.2l0.5-2.7l-1.1-0.2L153.3,52.4z	"
        >
          <title id="t1599">Broadwater, MT</title>
        </path>
        <path
          id="FIPS_30043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M148.4,53.5l0.3,0.1l0.3-0.1l0.6-0.3l0,0l0-0.2l1.6-1l2.1,0.4l-1.1,6.6l1.1,0.2l-0.5,2.7
		l-1.4,0.2l0-0.1l0-0.1l-1-0.7l-0.8-0.2l-0.6,0l-0.2,0.1l-0.1,0.1l0,0.2l-0.3,0.5l-0.3,0.2l-0.2,0l-0.1,0l-1.5-1.3l-0.3-0.6l0.1-2.7
		l0-0.2l-0.5-1.2l-0.3-0.1l0.4-1.1l0-0.3l0-0.2l0.3-0.3l1.4-0.4L148.4,53.5z	"
        >
          <title id="t1600">Jefferson, MT</title>
        </path>
        <path
          id="FIPS_30093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M145.5,56.2l0.3,0.1l0.5,1.2l0,0.2l-0.1,2.7l0.3,0.6l1.5,1.3l-2.4-0.3l-0.6,0.3l-0.1,0.1
		l-0.2,0.2l-0.4,0.2l-0.9,0.3l-0.4-1.3l-0.3-0.6l-0.3-0.3l-1.4-0.7l-0.6-0.7l0.6-0.1l0.4-0.2l0.5-0.3l0.1-0.1l0.9-1.3l0.9-1l1.1,0
		L145.5,56.2z	"
        >
          <title id="t1601">Silver Bow, MT</title>
        </path>
        <path
          id="FIPS_30023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M145.9,55.1l-0.4,1.1l-0.8,0.2l-1.1,0l-0.9,1l-0.9,1.3l-0.1,0.1l-0.5,0.3l-0.4,0.2l-0.6,0.1
		l0-0.1l-0.1-0.1l-0.1,0l-0.6-0.2l-0.3,0.1l-1.3,0.6l-0.2,0.2l-0.6-0.4l-0.1-0.7l-0.2-1l0-0.1l0,0l-0.1,0l0,0l0.8-0.4l0.8-0.2l1-1.5
		l0.2-1.1l2.2,0.4l0.1-0.5L145.9,55.1z	"
        >
          <title id="t1602">Deer Lodge, MT</title>
        </path>
        <path
          id="FIPS_30001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M136.6,57.7L136.6,57.7l0.1,0l0,0.1l0.2,1l0.1,0.7l0.6,0.4l0.2-0.2l1.3-0.6l0.3-0.1l0.6,0.2
		l0.1,0l0.1,0.1l0,0.1l0.6,0.7l1.4,0.7l0.3,0.3l0.3,0.6l0.4,1.3l-0.4,1.1l0,0.7l0,0.1l0.5,0.6l0.3,0.2l0.2,0l0.1-0.1l0.2-0.1
		l0.3,0.1l0.3,0.7l0,0.6l-0.6,3.3l0.9,1.3l1.3,0.2l-0.2,1.1l0,1.1l0.8,0.7l1.5,0.3l1.1,0.2l-0.2,0.9l2.7,0.4l-1.6,1.8l-1.2,0
		l-1.8-0.5l-2.5-0.3l-1.4,0.5l-3.2-0.8l-0.6,0.1l-0.4,0.4l-0.1,0.2l-0.1,0.5l0,0l-0.1,0.1l-0.2,0.1l-0.2-0.1l-0.7-0.8l-0.2-0.4
		l-0.1-0.6l0-1.6l0,0l0.1-0.1V75l-0.3-1.1l-0.2-0.6l-0.2-0.3l-0.4-0.4l-0.3-0.3l-0.3,0.1l-1.5-2.1l-1.4-5.2l0-1l0-0.8l0.1-0.2l0-0.4
		l-0.1-1l-0.1-0.2l-0.9-1.2l-0.2-0.2l0.2,0l0.3,0l2.9-1.3l0.6-0.3l0.3-0.2L136.6,57.7	"
        >
          <title id="t1603">Beaverhead, MT</title>
        </path>
        <path
          id="FIPS_30081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M135.6,48.1l-0.5,1.6l0.1,2.1l0,1.3l-0.5,1.2l0.1,1.7l0.7,1.2l0.5,0.5l0.6,0.1l0,0l-0.3,0.5
		l-0.3,0.2l-0.6,0.3l-2.9,1.3l-0.3,0l-0.2,0l-0.8,0.5l-1.1,1l-1.8,0.8l-0.4-0.1v0l-0.1-0.3l-0.7-1l-0.1,0l-0.4-0.1l-0.4-0.1l0,0l0,0
		l0.2-0.9l0.3-1.7l2.5-6.3l0.8-1.8l0.5-1.2l0.3-0.9l0.1-0.3l0-0.1l0,0L135.6,48.1z	"
        >
          <title id="t1604">Ravalli, MT</title>
        </path>
        <path
          id="FIPS_30039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M140.6,46.8l1.1,1.5l0.3,0.3l0.5-0.1l0.1-0.1l0.1,0l-0.6,3.2l-0.5,2.7l-0.1,0.5l-2.2-0.4
		l-0.2,1.1l-1,1.5l-0.8,0.2l-0.8,0.4l-0.6-0.1l-0.5-0.5l-0.7-1.2l-0.1-1.7l0.5-1.2l0-1.3l-0.1-2.1l0.5-1.6l0.3,0.1l1.1,0.2l1.9-0.8
		l0.1-0.7l0.6-0.3L140.6,46.8z	"
        >
          <title id="t1605">Granite, MT</title>
        </path>
        <path
          id="FIPS_30049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M145.9,33.1l0.1,2.4l-0.1,0.9l0,0.1l0.3,0.7l0.3,0.4l0.3,0.2l0.1,0l1-0.1l1-0.2l0,0l1,0.8
		l0.1,0.3l0,0.1l0,0.3l0,0l1,0.7l0.6,0.2l0.9,0.1l0.6,0l-0.7,4.1l0.8,0.8l0.3,0.3l0.2,0l0,0l0.7,0.1l-0.5,2.7l1.2,0.2l1.1,2.1
		l-0.7-0.4l-0.1,0l0,0l-0.3,0.4l-0.3,2l-1.3,0l-2.1-0.4l-1.6,1l0,0.2l0,0l-0.6,0.3l-0.3,0.1l-0.3-0.1l0.1-0.4l0.4-1.8l-0.1-0.8
		l-0.6-0.7l-1.1-0.2l0.3-1.7l-1.2-0.2l-0.1,0l-1-0.2l0.7-4.2l0-0.2l-2.2-0.4l-0.1,0l0.7-3.9h-0.2l-0.2-1l-0.1-0.5l0.1-1.6l0-0.1
		l1.2-1.8l0.5-0.5L145.9,33.1z	"
        >
          <title id="t1606">Lewis and Clark, MT</title>
        </path>
        <path
          id="FIPS_30077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M141,36.8l2.8,0.6l0.1,0.5l0.2,1h0.2l-0.7,3.9l0.1,0l2.2,0.4l0,0.2l-0.7,4.2l1,0.2l0.1,0
		l1.2,0.2l-0.3,1.7l1.1,0.2l0.6,0.7l0.1,0.8l-0.4,1.8l-0.1,0.4l-0.8,0.4l-1.4,0.4l-0.3,0.3l0,0.2l0,0.3l-4.2-0.8l0.5-2.7l0.6-3.2
		l-0.1,0l-0.1,0.1l-0.5,0.1l-0.3-0.3l-1.1-1.5l0.8-4.4l-1.4-0.3L141,36.8z	"
        >
          <title id="t1607">Powell, MT</title>
        </path>
        <path
          id="FIPS_30047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M139.5,36.5l-2.7-0.5l0.3,4.3l0,0.1l-0.2,1.1l-1.1,0.4l-2.2-0.4l0.1-0.5l0.3-2.2l-0.7-0.1
		l-0.2-0.1l-0.1-0.1l-0.2-0.4l0.2-0.6l0.2-0.3l0,0l0.1,0l0.2-0.3l0-1.3l0-0.1l-0.2-0.1l-0.5-0.1l-1.5-0.3l0.2-1.9l0.1-0.5l1.1,0.2
		l0.2-1.1l0-0.4l0.1-0.7l3.9,0.7L137,31l0-0.1l0-0.1l-0.1,0l0-0.3l0.2-0.2l0.2-0.1l1.2,0.2l1.5,2.3l0,0.1l0.1,2.2l0,0.3l0,0.2
		L139.5,36.5z	"
        >
          <title id="t1608">Lake, MT</title>
        </path>
        <path
          id="FIPS_30063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M139.5,36.5l1.4,0.3l-1,5.3l1.4,0.3l-0.8,4.4l-1-0.2l-0.6,0.3l-0.1,0.7l-1.9,0.8l-1.1-0.2
		l-0.3-0.1l-4.6-0.7l0,0l-0.2-0.1l-0.5-0.1l-0.2,0l-0.1,0.1l-0.2,0.1l-1-0.2l0,0l-0.5-1.2l0.1-0.4l1.2-1.1l0.9-1.9l-0.4-0.8
		l-1.6-2.6l0.1-0.4l1,0.1l0.5,0.2l0.6,0.4l1,0.8l0.3,0.3l0.2,0.4l0.5,0.5l0.1,0.1l0.2,0.1l0.6-0.1l2.2,0.4l1.1-0.4l0.2-1.1l0-0.1
		l-0.3-4.3L139.5,36.5z	"
        >
          <title id="t1609">Missoula, MT</title>
        </path>
        <path
          id="FIPS_30061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M121.2,33.8l0.3,0.5l0.2,0.2l0.4,0.1l0.4,0.1l1.2,0.2L124,35l0.1,0l1,0.2l0.3,0.1l1.7,1.2
		l0.4,0.3l0,0.3l-0.2,0.8l1,0.8l0.4,0.1l-0.1,0.4l1.6,2.6l0.4,0.8l-0.9,1.9l-1.2,1.1l-0.1,0.4l-0.4,0l-0.1,0l-0.1,0l-1.3-1.7l0-0.1
		v0l-0.2-1.3l-0.2-0.4l-0.4-0.8l-0.7-1.7l-0.8-1.8l-0.1-0.1l-0.7-0.3l-0.5-0.2l-0.1-0.1l-0.2-0.2l-1.4-1.9l0-0.3v0L121.2,33.8z	"
        >
          <title id="t1610">Mineral, MT</title>
        </path>
        <path
          id="FIPS_30089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M120.4,24.7l0.9,0.6l0.5-0.1l1-0.4l0.7,1.4l0.5,2.6l0.5,0.6l0.1,0.1l1.6,0.6l0.9-0.2l0.4-0.5
		l0.1-0.7l1.2,0.3l0.1,0.2l-0.3,1.6l1.1,0.2l0.7,0.1l1.5,0.3l-0.2,1.1l-0.1,0.5l-0.2,1.9l1.5,0.3l0.5,0.1l0.2,0.1l0,0.1l0,1.3
		l-0.2,0.3l-0.1,0l0,0l-0.2,0.3l-0.2,0.6l0.2,0.4l0.1,0.1l0.2,0.1l0.7,0.1l-0.3,2.2l-0.1,0.5l-0.6,0.1l-0.2-0.1l-0.1-0.1l-0.5-0.5
		l-0.2-0.4l-0.3-0.3l-1-0.8l-0.6-0.4l-0.5-0.2l-1-0.1l-0.4-0.1l-1-0.8l0.2-0.8l0-0.3l-0.4-0.3l-1.7-1.2l-0.3-0.1l-1-0.2l-0.1,0
		l-0.3,0.1l-1.2-0.2l-0.4-0.1l-0.4-0.1l-0.2-0.2l-0.3-0.5l0.2-0.6l0.3-0.7l0-0.7v0l0,0l0,0l0,0l-1.7-3.5l-0.3-0.5L120.4,24.7	"
        >
          <title id="t1611">Sanders, MT</title>
        </path>
        <path
          id="FIPS_30053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M121.2,21.1l1.3-6.2l6.7,1.4l3.7,0.7l0.7,0.1l0,1.8l0.4,1.5v0l-0.5,1.1l-2.1-0.4l0,0.7
		l0.1,0.4l-0.9,4.3l-1.3-0.3l-0.2,0l-0.2,1.1l-0.2,1.5l-1.2-0.3l-0.1,0.7l-0.4,0.5l-0.9,0.2l-1.6-0.6l-0.1-0.1l-0.5-0.6l-0.5-2.6
		l-0.7-1.4l-1,0.4l-0.5,0.1l-0.9-0.6L121.2,21.1z	"
        >
          <title id="t1612">Lincoln, MT</title>
        </path>
        <path
          id="FIPS_30029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M139.1,18.3l0.2,2.2l0.4,0.3l1.8,1.3l1.7,2.9l0,0.2l-0.1,0.1l-0.2,0.7l0.6,1.6l0.2,0.5
		l0.7,1.3l-0.1,0.5l0,0.1l0.8,0.5l0.1,0l0.1,0l0.8,0.2l0.1,0l-0.1,2.3l-0.4,0.3l-0.5,0.5l-1.2,1.8l0,0.1l-0.1,1.6l-2.8-0.6l-1.4-0.3
		l0.5-1l0-0.2l0-0.3l-0.1-2.2l0-0.1l-1.5-2.3l-1.2-0.2l-0.2,0.1l-0.2,0.2l0,0.3l0.1,0l0,0.1l0,0.1l-0.1,0.3l-3.9-0.7l-0.1,0.7l0,0.4
		l-0.2,1.1l-1.1-0.2l0.2-1.1l-1.5-0.3l-0.7-0.1l-1.1-0.2l0.3-1.6l-0.1-0.2l0.2-1.5l0.2-1.1l0.2,0l1.3,0.3l0.9-4.3l-0.1-0.4l0-0.7
		l2.1,0.4l0.5-1.1v0l-0.4-1.5l0-1.8L139.1,18.3z	"
        >
          <title id="t1613">Flathead, MT</title>
        </path>
        <path
          id="FIPS_30035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M154,27.7l-0.2-0.1l-0.3-0.1l-2.8-0.5l-0.4,2.1l0,0l-6.6-1.2l-0.2-0.5l-0.6-1.6l0.2-0.7
		l0.1-0.1l0-0.2l-1.7-2.9l-1.8-1.3l-0.4-0.3l-0.2-2.2l0.8,0.2l2.3,0.5l4.9,0.9l0.9,0.2l6.9,1.2L154,27.7z	"
        >
          <title id="t1614">Glacier, MT</title>
        </path>
        <path
          id="FIPS_30051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M162.8,22.5l4.5,0.7l-0.2,1l-0.7,4.4l-0.3,1.8l-0.4,2.6l-0.6-0.1l-0.2,1.1l-5-0.8l0.2-1.1
		l1.2,0.2l0.7-4.4l0.8-4.4L162.8,22.5z	"
        >
          <title id="t1615">Liberty, MT</title>
        </path>
        <path
          id="FIPS_30101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M154,27.7l1.1-6.6l2.9,0.5l0.8,0.1l2.1,0.4l2,0.3l-0.2,1.1l-0.8,4.4l-0.7,4.4l-1.2-0.2
		l-2.2-0.4l0.3-1.6l-1.1-0.5l-0.8-0.3l-0.8-0.2l-1.4-1.2L154,27.7z	"
        >
          <title id="t1616">Toole, MT</title>
        </path>
        <path
          id="FIPS_30073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M143.6,28.1l6.6,1.2l0,0l0.4-2.1l2.8,0.5l0.3,0.1l0.2,0.1l0.1,0.1l1.4,1.2l0.8,0.2l0.8,0.3
		l1.1,0.5l-0.3,1.6l2.2,0.4l-0.2,1.1l-0.3,1.8l-5-0.8l0.1-0.5l-1.4-1.6l-7.2-1.3l-0.1,0l-0.8-0.2l-0.1,0l-0.1,0l-0.8-0.5l0-0.1
		l0.1-0.5L143.6,28.1z	"
        >
          <title id="t1617">Pondera, MT</title>
        </path>
        <path
          id="FIPS_30099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M146.1,30.8l7.2,1.3l1.4,1.6l-0.1,0.5l5,0.8l-0.6,3.7l-2.2-0.4l-0.2,1.1l-2.2-0.4l-0.4,1.3
		l-0.9-0.3l-0.6,0l-0.9-0.1l-0.6-0.2l-1-0.7l0,0l0-0.3l0-0.1l-0.1-0.3l-1-0.8l0,0l-1,0.2l-1,0.1l-0.1,0l-0.3-0.2l-0.3-0.4l-0.3-0.7
		l0-0.1l0.1-0.9l-0.1-2.4L146.1,30.8z	"
        >
          <title id="t1618">Teton, MT</title>
        </path>
        <path
          id="FIPS_30013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153.1,40.1l0.9,0.3l0.4-1.3l2.2,0.4l0.2-1.1l2.2,0.4l3.7,0.6l-0.3,0.4l-0.2,0.2l-0.3,0.5
		l-0.1,0.2l0,0.1l2.1,2.2l1.1,0.5L165,44l-1.1-0.2l-0.3,0.6l-0.1,0.7l-0.2,2l1.1,0.2l-0.3,2.2l-0.2,1.1l-0.2,0.1l-0.8-0.9l-1.1-1.4
		l-0.1-0.1l-1.2-1l-4.1-0.1l-0.2,1.1l-1-0.2l-1.2-0.2l0.5-2.7l-0.7-0.1l0,0l-0.2,0l-0.3-0.3l-0.8-0.8L153.1,40.1z	"
        >
          <title id="t1619">Cascade, MT</title>
        </path>
        <path
          id="FIPS_30059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M155.2,48.2l1,0.2l0.2-1.1l4.1,0.1l1.2,1l0.1,0.1l1.1,1.4l0.8,0.9l0,0.3l0,0.1l0.1,0.2
		l0.1,0.1l1.3,1.4l0.8,0l0.8-0.1l-0.4,2.4l-0.4,2l-0.3,1.8l-0.1,0.5l-4.4-0.8l-2.5-0.4l-0.1-0.8l-0.4-2.6l-2.2-4.5L155.2,48.2z	"
        >
          <title id="t1620">Meagher, MT</title>
        </path>
        <path
          id="FIPS_30067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M161.4,58.6l4.4,0.8l-0.2,0.6l-0.7,4.4l0.6,0.1l-0.3,2.3l-0.4,2.9l-0.1,0.3l-0.3,2.2l1.5,0.2
		l2.4,0.4l-0.3,2.1l-2.8-0.4l-1,0l-3-0.4l0,0l-1.4-0.2l-0.4-0.1l-1.1-0.2l-1.5-0.2l0.2-1.3l0.2-1l0.4-2.2l1.1,0.2l0.2-1.1l0.2-1.1
		l0.6-0.2l0.6-0.4l0.4-2.5l0.2-1.1l0.1-0.9l0.1-0.7l0.3-1.8L161.4,58.6z	"
        >
          <title id="t1621">Park, MT</title>
        </path>
        <path
          id="FIPS_30041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M167.3,23.2l10.7,1.6l-0.3,1.7l-0.2,1.1l-0.4,2.7l-0.6,3.4l-0.4,2l-0.6,0l-1.1-0.2l0.2-1.1
		l-0.9-1.2l-6.7-1l-0.2,1.1l-1.1-0.2l0.4-2.6l0.3-1.8l0.7-4.4L167.3,23.2z	"
        >
          <title id="t1622">Hill, MT</title>
        </path>
        <path
          id="FIPS_30015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M165.7,33l1.1,0.2l0.2-1.1l6.7,1l0.9,1.2l-0.2,1.1l1.1,0.2l0.6,0l-0.8,5l-0.4-0.2l-0.9,0
		l-1,0.2l-0.5,0.4l0,0.3l-0.3,1.3l0,0.1l-0.2,0.2l-2.8,1l-0.4-0.1l-3.7-0.6l-1.1-0.5l-2.1-2.2l0-0.1l0.1-0.2l0.3-0.5l0.2-0.2
		l0.3-0.4l-3.7-0.6l0.6-3.7l0.3-1.8l5,0.8l0.2-1.1L165.7,33z	"
        >
          <title id="t1623">Chouteau, MT</title>
        </path>
        <path
          id="FIPS_30045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M165.1,43.3l3.7,0.6l-0.1,0.7l0.6,0.8l1,0.9l1.1,0.3l0.9,0.7l-0.5,3.7l-0.3,2.6l-0.6-0.1
		l-0.4-0.3l-0.6-0.4l-0.1-0.1l-0.2-0.1l-0.7-0.1l-0.4,0l-1.6,0.2l-0.8,0.1l-0.8,0l-1.3-1.4l-0.1-0.1l-0.1-0.2l0-0.1l0-0.3l0.2-0.1
		l0.2-1.1l0.3-2.2l-1.1-0.2l0.2-2l0.1-0.7l0.3-0.6L165,44L165.1,43.3z	"
        >
          <title id="t1624">Judith Basin, MT</title>
        </path>
        <path
          id="FIPS_30107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M171.5,53.7l3.1,0.5l-0.2,1.7l-0.7,4.3l-2.2-0.3l-5.6-0.8l0.3-1.8l0.4-2l0.4-2.4l1.6-0.2
		l0.4,0l0.7,0.1l0.2,0.1l0.1,0.1l0.6,0.4l0.4,0.3L171.5,53.7z	"
        >
          <title id="t1625">Wheatland, MT</title>
        </path>
        <path
          id="FIPS_30097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M165.9,59l5.6,0.8l-0.2,1.1l0.3,1.2l1.7,0.2l-0.2,0.7l-0.5,0.3l-0.8,1l-0.3,1.1l-0.3,2.2
		l-1.1-0.2l-1.2,0.4l-1.2,0.4l-0.3,2.2l-1.2-0.2l-0.3,2.3l-1.5-0.2l0.3-2.2l0.1-0.3l0.4-2.9l0.3-2.3l-0.6-0.1l0.7-4.4l0.2-0.6
		L165.9,59z	"
        >
          <title id="t1626">Sweet Grass, MT</title>
        </path>
        <path
          id="FIPS_30009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177.6,68.6l0.4-0.3l0.2,0l0,0.3l-0.1,0.2l-0.1,0.1l0,0l0.2,0.9l0.5,0.8l0.5,0.1l-0.4,0.4
		l-0.3,1.1l-0.2,1.7l5.2,0.6l-0.1,0.2l-1.4,2.5l-3.4-0.5l-2.8-0.4l-1.2-0.2l-0.2,0l-1.7-0.3l-4.8-0.6l0.3-2.1l1,0.1l0.4-1.2l0.8-0.8
		l0.7-0.7l0.4-0.3l1.2-0.4l1.5,0.2l0.7-0.7l0.1-0.4l0.3-0.3l1.2-0.3l0.1,0l0.3,0.2l0.2,0l0.2,0L177.6,68.6z	"
        >
          <title id="t1627">Carbon, MT</title>
        </path>
        <path
          id="FIPS_30095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177.8,61.8l-0.2,1.1l-0.1,1.1l-0.3,3.6l0.1,0.4l0.3,0.6l-0.5,0.1l-0.2,0l-0.2,0l-0.3-0.2
		l-0.1,0l-1.2,0.3l-0.3,0.3l-0.1,0.4l-0.7,0.7l-1.5-0.2l-1.2,0.4l-0.4,0.3l-0.7,0.7l-0.8,0.8l-0.4,1.2l-1-0.1l-2.4-0.4l0.3-2.3
		l1.2,0.2l0.3-2.2l1.2-0.4l1.2-0.4l1.1,0.2l0.3-2.2l0.3-1.1l0.8-1l0.5-0.3l0.2-0.7l0.2-1.1L177.8,61.8	"
        >
          <title id="t1628">Stillwater, MT</title>
        </path>
        <path
          id="FIPS_30037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M178.1,53.9l-0.2,1.6l0.1,0.6l0.6,1.2l0.7,2.9l-0.3,1.8l-1.3-0.2l-4.4-0.6l-0.2,1.1l-1.7-0.2
		l-0.3-1.2l0.2-1.1l2.2,0.3l0.7-4.3l0.2-1.7l0.1-0.7L178.1,53.9z	"
        >
          <title id="t1629">Golden Valley, MT</title>
        </path>
        <path
          id="FIPS_30027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M175.3,40.6l1,0.4l1-0.3l0.2-0.2l2.6,0l0.1,0l0.3,0.2l0.3,0.8l0.4,0.3l0.2,0.2l0.3,0.4l0,0.1
		l0,0.1l0.2,0.4l0.7,0.4l2.7,1l0.1,0l0.1,0l0.1-0.1l-0.3,2.2l-0.1,1.2l-0.2,0.1l-2.2-0.3l-1.2,0.3l-0.3,1.1l-0.1,1.1l1.1,0.2
		l-0.5,3.3l-0.3,1.1l-3.3-0.5l-3.3-0.5l-0.1,0.7l-3.1-0.5l0.3-2.6l0.5-3.7l-0.9-0.7l-1.1-0.3l-1-0.9l-0.6-0.8l0.1-0.7l0.4,0.1l2.8-1
		l0.2-0.2l0-0.1l0.3-1.3l0-0.3l0.5-0.4l1-0.2l0.9,0L175.3,40.6z	"
        >
          <title id="t1630">Fergus, MT</title>
        </path>
        <path
          id="FIPS_30005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M176,35.6l0.4-2l0.6-3.4l0.4-2.7l0.2-1.1l0.3-1.7l0.9,0.1l2.8,0.4l0.5,0.1l0,0l3.8,0.5
		l0.5,0.1l2.1,0.3l0,0.4l-0.1,0.7l-0.5,2.1l-1.4,3.7l-0.1,0l-0.3-0.1l-0.1,0.2l-0.5,2.6l-0.4,3.1l-2,0.4l-0.1,0l-1.9-0.2l-0.1,0.7
		l-0.2,1.7l-0.3-0.8l-0.3-0.2l-0.1,0l-2.6,0l-0.2,0.2l-1,0.3l-1-0.4L176,35.6z	"
        >
          <title id="t1631">Blaine, MT</title>
        </path>
        <path
          id="FIPS_30071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M180.9,41.5l0.2-1.7l0.1-0.7l1.9,0.2l0.1,0l2-0.4l0.4-3.1l0.5-2.6l0.1-0.2l0.3,0.1l0.1,0
		l1.4-3.7l0.5-2.1l0.1-0.7l0-0.4l9,1.1l-0.4,1.1l-0.5,3.9l-0.9,3.8l-0.9-0.1l-0.5,1.2l-0.6,4.2l-0.3,2.3l-0.1,0.4l-0.2,0.4l0,0.1
		l-0.1,0l-0.4-0.1l-0.7-0.4l-0.1,0l-0.4,0l-0.5,0.2l-0.4,0.6l-0.3,0.3l-1,1.1l-0.4,0l-0.1,0l0.1-0.5l-0.1-0.8l0-0.2l-0.3-0.3l-0.1,0
		l-1.1-0.2l-0.3,0l-0.4,0l-0.8-0.1l-0.2,0l-0.1,0l-0.1,0.1l-0.1,0l-0.1,0l-2.7-1l-0.7-0.4l-0.2-0.4l0-0.1l0-0.1l-0.3-0.4l-0.2-0.2
		L180.9,41.5z	"
        >
          <title id="t1632">Phillips, MT</title>
        </path>
        <path
          id="FIPS_30069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M185.6,44.1L185.6,44.1l0.3,0.1l0.8,0.1l0.4,0l0.3,0l1.1,0.2l0.1,0l0.3,0.3l0,0.2l0.1,0.8
		l-0.1,0.5l-0.6,1.2l-0.2,1.3l-0.4,4.7l0,0.1l0,0l0.3,0.3l0,0l0.4,1.3l-3.9-0.5l-1-0.1l-2.2-0.3l0.3-1.1l0.5-3.3l-1.1-0.2l0.1-1.1
		l0.3-1.1l1.2-0.3l2.2,0.3l0.2-0.1l0.1-1.2L185.6,44.1z	"
        >
          <title id="t1633">Petroleum, MT</title>
        </path>
        <path
          id="FIPS_30065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M178.1,53.9l3.3,0.5l2.2,0.3l1,0.1l3.9,0.5l0,3.4l-0.2,1.3l-1.3-0.2l-0.8,0.7l-0.2,0.3
		l-0.1,0.6l-2.6-0.3l-0.8,0.3l-0.2,1.3l-3.3-0.4l0.3-1.8l-0.7-2.9l-0.6-1.2l-0.1-0.6L178.1,53.9z	"
        >
          <title id="t1634">Musselshell, MT</title>
        </path>
        <path
          id="FIPS_30111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M188.6,58.5l0.4,0.2l0.2,0.2l0.7,1.6l0.8,2.4l-0.2,1.1l-0.2,0.6l-1.5-0.2l-1.2,0.6l-0.4,0.3
		l-0.1,0.4l-0.4,0.3l-1.5-0.2l-0.4,1.5l-0.4,3.4l-2.3,0.5l-1.2-0.2l-1.8-0.3l-0.5-0.1l-0.5-0.8l-0.2-0.9l0,0l0.1-0.1l0.1-0.2l0-0.3
		l-0.2,0l-0.4,0.3l-0.3-0.6l-0.1-0.4l0.3-3.6l0.1-1.1l0.2-1.1l1.3,0.2l3.3,0.4l0.2-1.3l0.8-0.3l2.6,0.3l0.1-0.6l0.2-0.3l0.8-0.7
		l1.3,0.2L188.6,58.5z	"
        >
          <title id="t1635">Yellowstone, MT</title>
        </path>
        <path
          id="FIPS_30003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M195.1,67.4l-0.1,0.5l0,1.9l0.6,0.2l0.9,0.1l0.2,0.1l-0.5,4.1l-0.3,0.7l-0.3,1.5l2.2,0.3
		l1.1,0.1l1.1,0.1l-0.1,2.4l-5.7-0.7l-1.7-0.2l-0.5-0.1l-4.3-0.5l-2.7-0.3l-3.1-0.4l1.4-2.5l0.1-0.2l-5.2-0.6l0.2-1.7l0.3-1.1
		l0.4-0.4l1.8,0.3l1.2,0.2l2.3-0.5l0.4-3.4l0.4-1.5l1.5,0.2l0.4-0.3l0.1-0.4l0.4-0.3l1.2-0.6l1.5,0.2l0.8,0.1l-0.1,1.1l2.2,0.3
		l0.4,0.6l0.6,0.6L195.1,67.4z	"
        >
          <title id="t1636">Big Horn, MT</title>
        </path>
        <path
          id="FIPS_30103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M188.9,58.7l5,0.6l1.2,1.3l0.4,3.4l-0.4,3.4l-1-0.1l-0.6-0.6l-0.4-0.6l-2.2-0.3l0.1-1.1
		l-0.8-0.1l0.2-0.6l0.2-1.1l-0.8-2.4l-0.7-1.6L188.9,58.7z	"
        >
          <title id="t1637">Treasure, MT</title>
        </path>
        <path
          id="FIPS_30087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M188.1,53.9l3.8,0.5l0.2,0l0.3,0l0.3,0l5.8,0.7l0.3,0.2l0.6,0.1l4.6,0.5l-0.3,0.2l-0.4,3
		l-0.4,1.5l-0.3,3l0,0.3l-0.2,0.7l-0.3,0.3l-0.5,4.5l-0.4,0l-0.2,2.1l-0.4,2.3l-0.4,1.2l-0.2,2.2l-1.1-0.1l-1.1-0.1l-2.2-0.3
		l0.3-1.5l0.3-0.7l0.5-4.1l-0.2-0.1l-0.9-0.1l-0.6-0.2l0-1.9l0.1-0.5l0.4-3.4l-0.4-3.4l-1.2-1.3l-5-0.6l-0.4-0.2l0-3.4L188.1,53.9z	
		"
        >
          <title id="t1638">Rosebud, MT</title>
        </path>
        <path
          id="FIPS_30033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M202.7,41.3l0.5,0.1l0.7,1.2l-0.5,4.3l-0.3,0.7l-0.3,1.5l1.1,0.1l-0.2,2.2l0.7,0.1l-0.4,4.1
		l0,0.2l-4.6-0.5l-0.6-0.1l-0.3-0.2l-5.8-0.7l-0.3,0l-0.3,0l-0.2,0l-3.8-0.5l0,0l-0.3-0.3l0,0l0-0.1l0.4-4.7l0.2-1.3l0.6-1.2l0.1,0
		l0.4,0l1-1.1l0.3-0.3l0.4-0.6l0.5-0.2l0.4,0l0.1,0l0.7,0.4l0.4,0.1l0.1,0l0-0.1l0.2-0.4l0.1-0.4l1.4,0.6l1.9,0.2l0.1,0l0.8,0l0.2,0
		l0.2,0l2.2-1.2l1.5-2l0.4-0.1L202.7,41.3z	"
        >
          <title id="t1639">Garfield, MT</title>
        </path>
        <path
          id="FIPS_30019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.8,28.4l9,0.9l-0.1,1.1l-0.2,3.3l0.6,0.1l-0.1,1.1l-7.2-0.7l-1.4-0.2l-0.4-0.8l0.3-2.6
		l-1.1-0.1l0.1-1.1l0.3-0.4L206.8,28.4z	"
        >
          <title id="t1640">Daniels, MT</title>
        </path>
        <path
          id="FIPS_30105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.8,28.4l-0.2,0.7l-0.3,0.4l-0.1,1.1l1.1,0.1l-0.3,2.6l0.4,0.8l1.4,0.2l-0.5,4.4l-0.3,0
		l-0.3,2.7l-0.7,0l-2.7-0.6l-0.1-0.1l-0.2-0.2l-1-0.4l-0.1,0l-0.1,0.1l-0.1,0.2l-0.1,0.3l0,0.8l-0.3-0.2l-0.4,0.1l-1.5,2l-2.2,1.2
		l-0.2,0l-0.2,0l-0.8,0l-0.1,0l-1.9-0.2l-1.4-0.6l0.3-2.3l0.6-4.2l0.5-1.2l0.9,0.1l0.9-3.8l0.5-3.9l0.4-1.1L206.8,28.4z	"
        >
          <title id="t1641">Valley, MT</title>
        </path>
        <path
          id="FIPS_30055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M213.4,41l-0.1,0.8l-0.2,1.5l-0.4,0.1l-0.1,1l-1.1-0.1l-0.3,2.2l-0.4,1.1l-0.4,4.4l-3.8-0.4
		l-0.1,1.1l-0.4,0l-0.7-0.1l0.1-1.1l-1.1-0.1l-0.7-0.1l0.2-2.2l-1.1-0.1l0.3-1.5l0.3-0.7l0.5-4.3l-0.7-1.2l-0.5-0.1l0-0.8l0.1-0.3
		l0.1-0.2L203,40l0.1,0l1,0.4l0.2,0.2l0.1,0.1l2.7,0.6l0.7,0l1.4-0.4l0.5-0.3l0.4,0l1.6,0l0.6,0l0.7,0.1L213.4,41z	"
        >
          <title id="t1642">McCone, MT</title>
        </path>
        <path
          id="FIPS_30079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.5,51.5l1.1,0.1l-0.1,1.1l0.7,0.1l0.4,0l0.1-1.1l3.8,0.4l0.7,0.1l-0.3,2.6l1.1,0.1
		l1.1,0.9l0.2,0.2l0.2,0.3l0,0.3l3.8,0.4l-0.2,2.2l0,0.4l-1.1-0.1l0,0.6l-1.1-0.1l-0.2,0.5l-1,0.3l-2.3-0.2l-1.8-0.6l-0.3-0.4
		l-0.4-0.8l-0.1-1.1l-0.3-1.2l-1.9-0.6l-2.2-0.2L204.5,51.5z	"
        >
          <title id="t1643">Prairie, MT</title>
        </path>
        <path
          id="FIPS_30075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M201.7,69.2l10.9,1.1l-0.4,4.4l-0.2,1.2l-0.5,0l-0.4,4.5l-0.5,0l-6.9-0.7l-0.6,0l-1,0
		l-2.2-0.2l0.1-2.4l0.2-2.2l0.4-1.2l0.4-2.3l0.2-2.1L201.7,69.2z	"
        >
          <title id="t1644">Powder River, MT</title>
        </path>
        <path
          id="FIPS_30017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.1,55.6l2.2,0.2l1.9,0.6l0.3,1.2l0.1,1.1l0.4,0.8l0.3,0.4l1.8,0.6l2.3,0.2l1-0.3l0.2-0.5
		l1.1,0.1l-0.2,1.7l-1.5-0.1l-0.1,1.4l0,0.5l0.1,0.3l-0.2,2.3l-0.5,0l-0.4,4.5l-0.4,0l-10.9-1.1l0.5-4.5l0.3-0.3l0.2-0.7l0-0.3
		l0.3-3l0.4-1.5l0.4-3l0.3-0.2L204.1,55.6z	"
        >
          <title id="t1645">Custer, MT</title>
        </path>
        <path
          id="FIPS_30011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M213.8,65.9l2.3,0.2l1,0.2l0.5,1l0.5,1.1l0.8,0.1l1.5,0.1l-0.1,1.1l0.8,0.1l-0.7,8.6l-0.4,2.8
		l-8.9-0.8l0.4-4.5l0.5,0l0.2-1.2l0.4-4.4l0.4,0l0.4-4.5L213.8,65.9z	"
        >
          <title id="t1646">Carter, MT</title>
        </path>
        <path
          id="FIPS_30025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M215.8,60l0-0.6l1.1,0.1l0-0.4l1.7,0.1l0.6,0.2l0,0.4l2.7,0.2l-0.1,1.3l-0.3,3.3l-0.4,4.3
		l-0.1,0.8l-0.8-0.1l0.1-1.1l-1.5-0.1l-0.8-0.1l-0.5-1.1l-0.5-1l-1-0.2l-2.3-0.2l0.2-2.3l-0.1-0.3l0-0.5l0.1-1.4l1.5,0.1L215.8,60z	
		"
        >
          <title id="t1647">Fallon, MT</title>
        </path>
        <path
          id="FIPS_30109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.7,50.5l-0.1,0.9l-0.7,8.8l-2.7-0.2l0-0.4l-0.6-0.2l-1.7-0.1l0.2-2.2l0.9,0.1l0.6-0.3
		l0.2-0.2l0.9-1.2l0.2-0.5l0.1-1l0-0.7l0-0.2l-0.1-0.3l-0.6-1.8l2.5,0.2l0-0.6L222.7,50.5z	"
        >
          <title id="t1648">Wibaux, MT</title>
        </path>
        <path
          id="FIPS_30021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M212.8,44.5l-0.1,1.1l2.2,0.2l-0.1,1.1l3.4,0.3l0.6,1.2l-0.2,2.2l0.8,0.1l0.6,1.8l0.1,0.3
		l0,0.2l0,0.7l-0.1,1l-0.2,0.5l-0.9,1.2l-0.2,0.2l-0.6,0.3l-0.9-0.1l-3.8-0.4l0-0.3l-0.2-0.3l-0.2-0.2l-1.1-0.9l-1.1-0.1l0.3-2.6
		l-0.7-0.1l0.4-4.4l0.4-1.1l0.3-2.2L212.8,44.5z	"
        >
          <title id="t1649">Dawson, MT</title>
        </path>
        <path
          id="FIPS_30083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223.4,42.8l-0.7,7.6l-0.8-0.1l0,0.6l-2.5-0.2l-0.8-0.1l0.2-2.2l-0.6-1.2l-3.4-0.3l0.1-1.1
		l-2.2-0.2l0.1-1.1l0.1-1l0.4-0.1l0.2-1.5l0.1-0.8l0.6,0.1l1.1,0l0.2-0.1l0.3-0.2l0.2-0.3l0.5-0.2l3.6,0.9l1.7,1L223.4,42.8z	"
        >
          <title id="t1650">Richland, MT</title>
        </path>
        <path
          id="FIPS_37043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.6,203.8l2.9,1.7l-0.7,0.1l-4,0.6l-0.7,0.1L421.6,203.8z	"
        >
          <title id="t1651">Clay, NC</title>
        </path>
        <path
          id="FIPS_37113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.5,201l3,3.9l-3.9,0.6l-2.9-1.7l0.2-1.2l0.2-0.4l0.1-0.1l2.2-0.7L425.5,201z	"
        >
          <title id="t1652">Macon, NC</title>
        </path>
        <path
          id="FIPS_37175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.4,199l1.4,1.2l0.3,0.3l0.1,0.4l0.1,0.5l0.2,0.8l0.1,0.1l0.1,0.1l-1.8,1.3l-1.4,0.3
		l-1.1,0.5l0.4-3.5L431.4,199z	"
        >
          <title id="t1653">Transylvania, NC</title>
        </path>
        <path
          id="FIPS_37099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.7,198.4l3.1,2.5l-0.4,3.5l-1,0.5l-3-3.9L426.7,198.4z	"
        >
          <title id="t1654">Jackson, NC</title>
        </path>
        <path
          id="FIPS_37087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.5,194.5l1,1.4l1.9,3.1l-1.6,1.9l-3.1-2.5l-1-2.2l0-0.2L428.5,194.5z	"
        >
          <title id="t1655">Haywood, NC</title>
        </path>
        <path
          id="FIPS_37173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.7,196.2l1,2.2l-1.3,2.6l-1.1,0.4l-2.2,0.7l-0.1,0.1l-0.2-0.2l0-0.1l0.1-0.2l0.1-0.1
		l0.2-0.1l0.2-0.1l0.1-0.1l0.2-0.5l0-0.3l0-0.1l0-0.2l-0.6,0l-3.3,0.2l2.8-1.8l0,0l0.2,0l1.5-0.2l0.1-0.1l1.8-1.4L425.7,196.2z	"
        >
          <title id="t1656">Swain, NC</title>
        </path>
        <path
          id="FIPS_37075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M418.9,200.1l3.3-0.2l0.6,0l0,0.2l0,0.1l0,0.3l-0.2,0.5l-0.1,0.1l-0.2,0.1l-0.2,0.1l-0.1,0.1
		l-0.1,0.2l0,0.1l0.2,0.2l-0.2,0.4l-1.9,0.4l-0.7,0.3h-0.1l-0.4-0.2l-0.4-0.7L418.9,200.1L418.9,200.1z	"
        >
          <title id="t1657">Graham, NC</title>
        </path>
        <path
          id="FIPS_37039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.8,202.6l-0.2,1.2l-2.5,2.5l-1.3,0.2l-2,0.2l0-2.8l0.9-0.7l1.1,0l0.4-0.3l0.2-0.3l0.4,0.7
		l0.4,0.2h0.1l0.7-0.3L421.8,202.6z	"
        >
          <title id="t1658">Cherokee, NC</title>
        </path>
        <path
          id="FIPS_37121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437,189.2l1.4,2.3l-1.4,1.4l-0.3-1.1l-0.1-0.2l-0.6-1l0-0.1l-1.7-0.7l-0.6,0.2l1.8-1.4
		L437,189.2z	"
        >
          <title id="t1659">Mitchell, NC</title>
        </path>
        <path
          id="FIPS_37199"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.6,190.1l0.6-0.2l1.7,0.7l0,0.1l0.6,1l0.1,0.2l0.3,1.1l-1.2,1.8l-1.6-1.3l-1.3-1.9
		L433.6,190.1z	"
        >
          <title id="t1660">Yancey, NC</title>
        </path>
        <path
          id="FIPS_37115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.8,190.8l1.1,0.6l1.3,1.9l-1,0.4l-0.6,0.4l-0.3,0.2l-0.6,0.5l-1.3,0.9l-0.8,0.2l-1-1.4
		l0.4-2l0.5-0.1l0.9-0.9l0.6-0.6l0.2-0.1l0.3-0.2l0,0l0.2,0.1v0L431.8,190.8z	"
        >
          <title id="t1661">Madison, NC</title>
        </path>
        <path
          id="FIPS_37021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.8,194.6l1.4,2.1l-0.9,0.9l-0.8-0.3l-0.7,0.5l-0.9,0.5l-0.8,0.3l-0.5,0l-0.3-0.1l-0.1-0.1
		l-0.2,0l-0.3,0.1l-0.1,0.1l-0.3,0.4l-1.9-3.1l0.8-0.2l1.3-0.9l0.6-0.5l0.3-0.2l0.6-0.4l1-0.4L435.8,194.6z	"
        >
          <title id="t1662">Buncombe, NC</title>
        </path>
        <path
          id="FIPS_37089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.3,197.7l0.2,1l-0.6,2.5l-2.1,1.1l-0.1-0.1l-0.1-0.1l-0.2-0.8l-0.1-0.5l-0.1-0.4l-0.3-0.3
		l-1.4-1.2l0.3-0.4l0.1-0.1l0.3-0.1l0.2,0l0.1,0.1l0.3,0.1l0.5,0l0.8-0.3l0.9-0.5l0.7-0.5L436.3,197.7z	"
        >
          <title id="t1663">Henderson, NC</title>
        </path>
        <path
          id="FIPS_37149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.9,200.8l-2.6,0.3l-1.5,0.1l0.6-2.5l0.6-0.2l0.4-0.1l0.1,0l0.3,0.1l0.2,0.1l1.6,1.4
		l0.1,0.2L439.9,200.8z	"
        >
          <title id="t1664">Polk, NC</title>
        </path>
        <path
          id="FIPS_37161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442,195.4l0.3,2.9l-0.3,1.8l0,0.6l-1.1,0.1l-1,0.1l-0.1-0.7l-0.1-0.2l-1.6-1.4l-0.2-0.1
		l-0.3-0.1l-0.1,0l-0.4,0.1l-0.6,0.2l-0.2-1l0.9-0.9l3.5-1.1L442,195.4z	"
        >
          <title id="t1665">Rutherford, NC</title>
        </path>
        <path
          id="FIPS_37111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.4,191.6l0.3-0.7l0.1,0l0.1,0.1l0.2,0.4l0.1,0.1l0.1,0.3l-0.1,0.5l0.8,1.6l0.7,1.8
		l-3.5,1.1l-1.4-2.1l1.2-1.8L438.4,191.6z	"
        >
          <title id="t1666">McDowell, NC</title>
        </path>
        <path
          id="FIPS_37011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.2,186.9l0.1-0.3l1.4,2.1l0.3,1.9l-1.4,0.2l-0.3,0.7l-1.4-2.3L438.2,186.9z	"
        >
          <title id="t1667">Avery, NC</title>
        </path>
        <path
          id="FIPS_37189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.1,185l0.9,0.4l0.6,0.5l0.4,0.3l0.9,0.3l-0.5,1.7l-2.7,0.5l-1.4-2.1l0.1-0.2l0.5-0.5
		l0.5-0.4l0,0l0.1,0l0.1,0.1l0.3,0.1l0.2,0h0l0.2-0.1L440.1,185z	"
        >
          <title id="t1668">Watauga, NC</title>
        </path>
        <path
          id="FIPS_37003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.9,188.3l-0.3,3.5l-2.3,0.1l-0.3-2.6l0.6-0.5l0.3-0.1l0.5-0.1l0.2,0l0.7-0.2l0.6-0.2
		L447.9,188.3z	"
        >
          <title id="t1669">Alexander, NC</title>
        </path>
        <path
          id="FIPS_37009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.2,182.4l3.3-0.3l0,0.3l0.7,1l0.4,0.3l0.1,0.2l0.2,0.5l0.1,0.4l-2.1,1.9l-0.9-0.3
		l-0.4-0.3l-0.6-0.5l-0.9-0.4L440.2,182.4z	"
        >
          <title id="t1670">Ashe, NC</title>
        </path>
        <path
          id="FIPS_37005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448.1,181.5l-0.3,2.2l-0.1,0.4l-0.5,0.1l-0.2-0.2l0-0.2l-0.5-0.2l-0.1,0l-0.7,0.2l-0.8,1
		l-0.1-0.4l-0.2-0.5l-0.1-0.2l-0.4-0.3l-0.7-1l0-0.3L448.1,181.5z	"
        >
          <title id="t1671">Alleghany, NC</title>
        </path>
        <path
          id="FIPS_37193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445,184.6l0.8-1l0.7-0.2l0.1,0l0.5,0.2l0,0.2l0.2,0.2l0.5-0.1l0.1-0.4l1.3,2l0.3,2.3
		l-1.5,0.4l-0.2,0.1l-0.6,0.2l-0.7,0.2l-0.2,0l-0.5,0.1l-0.3,0.1l-0.6,0.5l-2.5-1.2l0.5-1.7L445,184.6z	"
        >
          <title id="t1672">Wilkes, NC</title>
        </path>
        <path
          id="FIPS_37027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.8,188.7l2.7-0.5l2.5,1.2l0.3,2.6l-0.2,0.4l-0.1,0.2l-0.2,0l-1.6,0l-2-1.2l-0.9-0.6
		l-0.1-0.1L439.8,188.7z	"
        >
          <title id="t1673">Caldwell, NC</title>
        </path>
        <path
          id="FIPS_37023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.1,190.6l0.1,0.1l0.9,0.6l2,1.2l1.6,0l0.2,0l0.1-0.2l-1.4,2.8l0,0.1l-1.6,0l-1.4,0.3
		l-0.7-1.8l-0.8-1.6l0.1-0.5l-0.1-0.3l-0.1-0.1l-0.2-0.4l-0.1-0.1l-0.1,0L440.1,190.6z	"
        >
          <title id="t1674">Burke, NC</title>
        </path>
        <path
          id="FIPS_37045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.6,195.3l1.1,1.7l1.8,3.1l-0.4,0l-4.2,0.4l0-0.6l0.3-1.8l-0.3-2.9L443.6,195.3z	"
        >
          <title id="t1675">Cleveland, NC</title>
        </path>

        <path
          id="FIPS_37109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.6,194.6l0.3,0.7l0.1,1.1l-5.2,0.6l-1.1-1.7l0-0.1L449.6,194.6z	"
        >
          <title id="t1677">Lincoln, NC</title>
        </path>
        <path
          id="FIPS_37035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.3,192l2.3-0.1l1.3,0.8l0.4,0.4l0.5,0.6l-0.2,0.9l-6,0.7l1.4-2.8L445.3,192z	"
        >
          <title id="t1678">Catawba, NC</title>
        </path>
        <path
          id="FIPS_37097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.4,188l1.9-0.3l0.3,2.6l-0.2,1.7l-0.1,0.7l0.6,1.6l0.1,0.2l0,0.2l-0.5,0.1l-1.6,0.5
		l-0.3-0.7l0.2-0.9l-0.5-0.6l-0.4-0.4l-1.3-0.8l0.3-3.5L449.4,188z	"
        >
          <title id="t1679">Iredell, NC</title>
        </path>

        <path
          id="FIPS_37159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.6,190.3l2.8,1l1.3,0.1l1.6,1.6l0.4,0.9l-1.2,0.2l-4.6,0.7l0-0.2l-0.1-0.2l-0.6-1.6
		l0.1-0.7L451.6,190.3z	"
        >
          <title id="t1681">Rowan, NC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "49180"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[49180]} state-nc`
          }
          id="FIPS_49180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37059"
            className="FIPS_49180 st0 state-nc"
            d="M451.3,187.7l2-0.3l1.2,0.8l0.2,0.1l0.1,0.1l0.1,0.3l0.1,0.4l-0.1,0.8l-0.4,0.3l-0.1,1.1
		l-2.8-1L451.3,187.7z	"
          >
            <title id="t1682">Davie, NC</title>
          </path>
          <path
            id="FIPS_37169"
            className="FIPS_49180 st0 state-nc"
            d="M457,180.3l0.5,3.7l-4.2,0.7l-0.5-3.7l3.9-0.6L457,180.3z	"
          >
            <title id="t1685">Stokes, NC</title>
          </path>
          <path
            id="FIPS_37067"
            className="FIPS_49180 st0 state-nc"
            d="M453.3,184.6l4.2-0.7l0.5,3.2l-3.5,1.1l-1.2-0.8l0-2.6L453.3,184.6z	"
          >
            <title id="t1686">Forsyth, NC</title>
          </path>
          <path
            id="FIPS_37197"
            className="FIPS_49180 st0 state-nc"
            d="M453.4,184.9l0,2.6l-2,0.3l-1.9,0.3l-0.3-2.3l0.9-0.6l1.5-0.5l0.6,0l1,0.2l0.2,0.1
   L453.4,184.9z	"
          >
            <title id="t1683">Yadkin, NC</title>
          </path>
        </g>

        <path
          id="FIPS_37171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.1,181.1l1.8-0.2l0.5,3.7l0,0.3l-0.1-0.1l-0.2-0.1l-1-0.2l-0.6,0l-1.5,0.5l-0.9,0.6
		l-1.3-2l0.3-2.2l0.7-0.1L451.1,181.1z	"
        >
          <title id="t1684">Surry, NC</title>
        </path>

        <path
          id="FIPS_37057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.5,188.2l3.5-1.1l0.2,1.2l0.7,5.3l-1.2,0.2l-0.4-0.9l-1.6-1.6l-1.3-0.1l0.1-1.1l0.4-0.3
		l0.1-0.8l-0.1-0.4l-0.1-0.3l-0.1-0.1L454.5,188.2z	"
        >
          <title id="t1687">Davidson, NC</title>
        </path>
        <path
          id="FIPS_37167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.5,194.1l1.2-0.2l0.8,0.4l0.1,0l0.5,0.8l0.2,0.4l0.5,2.3l0,0.1l0,0.1l-0.1,0.3l-2.2-0.3
		l-2.3,0.5L456.5,194.1z	"
        >
          <title id="t1688">Stanly, NC</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16740"
              ? `metroArea clickedArea state-nc state-sc`
              : `metroArea ${colorCode[16740]} state-nc state-sc`
          }
          id="FIPS_16740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37007"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M459.6,198.3l0,0.1l0.1,0.3l0.5,0.2l0.3,0l0.1,0l0.1-0.1l0,0l0-0.1l0.2-0.2l0.1-0.1h0.2
		l0.2,0.2l0.3,0.5l0.8,1.9v0.1l-0.1,0.2l-0.5,1.1l-4.1,0.6l-0.4-5L459.6,198.3z	"
          >
            <title id="t1691">Anson, NC</title>
          </path>
          <path
            id="FIPS_37025"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M456.5,194.1l-1.5,4.4l-0.5-0.2l-1.3-0.6l-1.3-1.6l-0.4-1.1l0-0.1l0-0.1l0.5-0.1L456.5,194.1z
			"
          >
            <title id="t1689">Cabarrus, NC</title>
          </path>
          <path
            id="FIPS_37071"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M444.8,197.1l5.2-0.6l-0.4,3.4l-3,0.3L444.8,197.1z	"
          >
            <title id="t1676">Gaston, NC</title>
          </path>
          <path
            id="FIPS_37119"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M449.9,195.4l1.6-0.5l0,0.1l0,0.1l0.4,1.1l1.3,1.6l1.3,0.6l-2.6,3.1l-0.8-0.9l-1.6-0.7
		l0.4-3.4L449.9,195.4z	"
          >
            <title id="t1680">Mecklenburg, NC</title>
          </path>
          <path
            id="FIPS_37179"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M457.4,198l0.4,5l-2.5,0.4l-2.2,0.3l-0.2,0l0-0.1l-0.1-1.3l-0.7-0.7l2.6-3.1l0.5,0.2
		L457.4,198z	"
          >
            <title id="t1690">Union, NC</title>
          </path>
          <path
            id="FIPS_45091"
            className="FIPS_16740 st0 state-nc state-sc"
            d="M446.6,200.1l3-0.3l1.6,0.7l0.6,3.3l-6,0.9l0.2-0.3l-0.2-0.4l-0.3-0.9l-0.2-1.1l0-0.1l0.7-1.4
		l0.3-0.4L446.6,200.1z	"
          >
            <title id="t2355">York, SC</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "246600"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[24660]} state-nc`
          }
          id="FIPS_24660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37081"
            className="FIPS_24660 st0 state-nc"
            d="M457.6,183.9l5.2-0.7l0.7,4.4l-5.2,0.6l-0.2-1.2L457.6,183.9z	"
          >
            <title id="t1693">Guilford, NC</title>
          </path>
          <path
            id="FIPS_37151"
            className="FIPS_24660 st0 state-nc"
            d="M463.4,187.7l0.1,0.7l0.6,4.2l-2.2,0.4l-3,0.6l-0.7-5.3L463.4,187.7z	"
          >
            <title id="t1694">Randolph, NC</title>
          </path>
          <path
            id="FIPS_37157"
            className="FIPS_24660 st0 state-nc"
            d="M460.2,179.8l2.1-0.3l0.4,3.8l0,0.1l-5.2,0.7l-0.5-3.7L460.2,179.8z	"
          >
            <title id="t1692">Rockingham, NC</title>
          </path>
        </g>
        <path
          id="FIPS_37123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.9,193l1.1,2.8l0,0.2l0.2,0.2l0.6,0.7l0.2,0.2l0.3,0.1l-1.1,0.1l-1.4,0.1l-0.5,0.4
		l-1.1,0.5l-0.2,0l-0.4,0l0.1-0.3l0-0.1l0-0.1l-0.5-2.3l-0.2-0.4l-0.5-0.8l-0.1,0l-0.8-0.4l1.2-0.2L461.9,193z	"
        >
          <title id="t1695">Montgomery, NC</title>
        </path>
        <path
          id="FIPS_37153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M459.6,198.3l0.4,0l0.2,0l1.1-0.5l0.5-0.4l1.4-0.1l1.1-0.1l1.9,1.3l-0.5,0.3l-0.4,0.3
		l-0.2,0.2l-0.1,0.5l0,0.2l0.1,0.1l-0.1,0.7l-0.2,0.3l-0.5,0.7l-2.5,0.4l0.5-1.1l0.1-0.2v-0.1l-0.8-1.9l-0.3-0.5l-0.2-0.2H461
		l-0.1,0.1l-0.2,0.2l0,0.1l0,0l-0.1,0.1l-0.1,0l-0.3,0l-0.5-0.2l-0.1-0.3L459.6,198.3z	"
        >
          <title id="t1696">Richmond, NC</title>
        </path>
        <path
          id="FIPS_37165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.8,200.9l-0.7,2.9l-2.7-1.8l0.5-0.7l0.2-0.3l0.1-0.7l-0.1-0.1l0-0.2l0.1-0.5l0.2-0.2
		l0.4-0.3l0.5-0.3L467.8,200.9z	"
        >
          <title id="t1697">Scotland, NC</title>
        </path>
        <path
          id="FIPS_37033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.1,178.7l0.5,3.9l-1.1,0.2l-2.8,0.4l-0.4-3.8l0.4-0.1l1.3-0.2l1.3-0.2L466.1,178.7z	"
        >
          <title id="t1698">Caswell, NC</title>
        </path>
        <path
          id="FIPS_37001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M462.7,183.2l2.8-0.4l0.9,4.7l-2.9,1l-0.1-0.7l-0.7-4.4L462.7,183.2z	"
        >
          <title id="t1699">Alamance, NC</title>
        </path>
        <path
          id="FIPS_37125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.2,192.2l2.2,2.4l1.2,1.3l0,0.2l-1.6-0.2l-0.4,0.3l-0.5,0.6l-0.6,1.1l-0.3,0.6l-1.9-1.3
		l-0.3-0.1l-0.2-0.2l-0.6-0.7l-0.2-0.2l0-0.2l-1.1-2.8l2.2-0.4L466.2,192.2z	"
        >
          <title id="t1700">Moore, NC</title>
        </path>

        <path
          id="FIPS_37155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.8,198.8l1.7,1.3l1.3,1.7l0,0.2l-0.1,2.3l-0.1,0.3l-0.5,0.5l-0.6,1.3l-0.5,0.9l-4.7-3.4
		l-0.1-0.1l0.7-2.9l1.2-0.2l0.6-0.3L470.8,198.8z	"
        >
          <title id="t1702">Robeson, NC</title>
        </path>
        <path
          id="FIPS_37047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M480.1,204.4l1.1,0.4l-0.6,2l-1.3,0.7l-1.1,0.4l-0.1,0l-0.1,0l-0.3,0.3l-0.5,1.8l-0.1,1
		l-5.2-3.7l0.5-0.9l0.6-1.3l0.5-0.5l0.4,0.2h0.1l0.2,0l1.1-0.3l1.3,0.3l1.5,0.4l1.2-0.1L480.1,204.4z	"
        >
          <title id="t1703">Columbus, NC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "48900"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[48900]} state-nc`
          }
          id="FIPS_48900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37019"
            className="FIPS_48900 st0 state-nc"
            d="M481.2,204.8l1.4,0.1l0.9,1l0.6,1.5l0.2,0.8l0,0.3l0.2,1.4l-0.8,0.7l-0.8-0.1l-0.5,0l-0.4,0.1
		l-1,0.2L480,211l0,0h0l-1.2,0.7l-0.3,0.2l-1.4-1l0.1-1l0.5-1.8l0.3-0.3l0.1,0l0.1,0l1.1-0.4l1.3-0.7L481.2,204.8z	"
          >
            <title id="t1704">Brunswick, NC</title>
          </path>
          <path
            id="FIPS_37129"
            className="FIPS_48900 st0 state-nc"
            d="M486,204.7l-0.2,0.3l-0.2,0.4l-0.5,1.2l-0.1,0.3l-0.2,0.9l0,0.1l-0.3,1.9l-0.2-1.4l0-0.3
		l-0.2-0.8l-0.6-1.5l-0.9-1l1-0.6l0.8-0.4l0.4,0l-0.1,0.1l0,0.1l0.2,0.2l0.7,0.5L486,204.7z	"
          >
            <title id="t1705">New Hanover, NC</title>
          </path>
          <path
            id="FIPS_37141"
            className="FIPS_48900 st0 state-nc"
            d="M480.9,200l4.5-0.8l2.4,3.2l-1.7,2.3h-0.3l-0.7-0.5l-0.2-0.2l0-0.1l0.1-0.1l-0.4,0l-0.8,0.4
		l-1,0.6l-1.4-0.1l-1.1-0.4l0.7-1l-0.4-0.2l-0.3,0l-0.2-0.1l-0.3-0.3l0-0.1l0.1-0.2L480.9,200z	"
          >
            <title id="t1714">Pender, NC</title>
          </path>
        </g>
        <path
          id="FIPS_37017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M476.6,199l3.2,3.4l-0.1,0.2l0,0.1l0.3,0.3l0.2,0.1l0.3,0l0.4,0.2l-0.7,1l-0.8,0.6l-1.2,0.1
		l-1.5-0.4l-1.3-0.3l-1.1,0.3l-0.2,0H474l-0.4-0.2l0.1-0.3l0.1-2.3l0-0.2l-1.3-1.7l0.6-0.3l0.4-0.1l2.8-0.5L476.6,199L476.6,199z	"
        >
          <title id="t1706">Bladen, NC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22180"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[22180]} state-nc`
          }
          id="FIPS_22180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37051"
            className="FIPS_22180 st0 state-nc"
            d="M474.4,194.3l-0.2,2.1v0.1l0.3,0.6l0.3,0.6l0.1,0.1l1.7,1.3l-0.1,0.1l-0.3,0.1l-2.8,0.5
		l-0.4,0.1l-0.6,0.3l-1.7-1.3l-1.2-2.7l0-0.2l0.3-0.1l1.9-0.9l0.9-0.5l0.3-0.1L474.4,194.3z	"
          >
            <title id="t1707">Cumberland, NC</title>
          </path>
          <path
            id="FIPS_37093"
            className="FIPS_22180 st0 state-nc"
            d="M466.2,198.5l0.3-0.6l0.6-1.1l0.5-0.6l0.4-0.3l1.6,0.2l1.2,2.7l-1.2,1.6l-0.6,0.3l-1.2,0.2
		L466.2,198.5z	"
          >
            <title id="t1701">Hoke, NC</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "20500"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[20500]} state-nc`
          }
          id="FIPS_20500"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37037"
            className="FIPS_20500 st0 state-nc"
            d="M470,186.9l0,0.3l-0.3,3.1l0.9,0.2l-0.4,0.9l-1-0.8l-0.2-0.1l-0.1,0l-0.3-0.1l-0.2,0l-0.2,0.1
		l-0.4,0.7l-0.5,0.4l-0.7,0.5l-0.3,0.1l-2.1,0.4l-0.6-4.2l2.9-1l2.4-0.3L470,186.9z	"
          >
            <title id="t1708">Chatham, NC</title>
          </path>
          <path
            id="FIPS_37135"
            className="FIPS_20500 st0 state-nc"
            d="M466.6,182.6l2.1-0.3l0.2,4.9l-2.4,0.3l-0.9-4.7L466.6,182.6z	"
          >
            <title id="t1711">Orange, NC</title>
          </path>
          <path
            id="FIPS_37145"
            className="FIPS_20500 st0 state-nc"
            d="M466.1,178.7l3.5-0.6l0.7,3.9l-1.5,0.2l-2.1,0.3L466.1,178.7z	"
          >
            <title id="t1712">Person, NC</title>
          </path>
          <path
            id="FIPS_37063"
            className="FIPS_20500 st0 state-nc"
            d="M470.2,182l0.9,2l0.6,0.6l0,0.6l-0.1,0.3l-0.2,0.4l-0.6,0.8l-0.8,0.1l-1.1,0.3l-0.2-4.9
		L470.2,182z	"
          >
            <title id="t1713">Durham, NC</title>
          </path>
        </g>

        <path
          id="FIPS_37085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.5,190.6l2.3,0.4l2.2,2.3l-0.6,1l-1.4,0l-0.3,0.1l-0.9,0.5l-1.9,0.9l-0.3,0.1l-1.2-1.3
		l1.7-3.1L470.5,190.6z	"
        >
          <title id="t1709">Harnett, NC</title>
        </path>
        <path
          id="FIPS_37105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.2,192.2l0.3-0.1l0.7-0.5l0.5-0.4l0.4-0.7l0.2-0.1l0.2,0l0.3,0.1l0.1,0l0.2,0.1l1,0.8
		l-1.7,3.1L466.2,192.2z	"
        >
          <title id="t1710">Lee, NC</title>
        </path>

        <path
          id="FIPS_37163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M475,193.3l2.5-0.1l1.7,1l0.3,1.4l0.6,2.2l-0.2,2.2l0.7,0.2l0.1,0l0.1-0.2l-1.1,2.4l-3.2-3.4
		l-1.7-1.3l-0.1-0.1l-0.3-0.6l-0.3-0.6v-0.1l0.2-2.1L475,193.3z	"
        >
          <title id="t1715">Sampson, NC</title>
        </path>
        <path
          id="FIPS_37191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M479.3,188.9l2.5-0.3l0.7,2.6l0.2,2.5l-3.4,0.5l-1.7-1l0.4-0.6l0.8-1.4L479.3,188.9z	"
        >
          <title id="t1716">Wayne, NC</title>
        </path>

        <path
          id="FIPS_37077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.1,178l2.8-0.5l-0.3,0.4l0,0.3l0.1,0.8l0.4,2l0.3,1.2l0.1,0.1l-0.1,2.1l-2.2-0.3l-0.9-2
		l-0.7-3.9L470.1,178z	"
        >
          <title id="t1719">Granville, NC</title>
        </path>
        <path
          id="FIPS_37181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473,177.4l1.3-0.3l0.8,3.5l-1.7,1.5l-0.1-0.1l-0.3-1.2l-0.4-2l-0.1-0.8l0-0.3L473,177.4z	"
        >
          <title id="t1720">Vance, NC</title>
        </path>
        <path
          id="FIPS_37185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M477.1,176.6l1.5-0.3l0.1,0.5l-0.4,4.1l-3.2-0.2l-0.8-3.5L477.1,176.6z	"
        >
          <title id="t1721">Warren, NC</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "39580"
              ? `metroArea clickedArea state-nc`
              : `metroArea ${colorCode[39580]} state-nc`
          }
          id="FIPS_39580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37069"
            className="FIPS_39580 st0 state-nc"
            d="M478.3,180.9l-1.6,5.4l0-0.1l-0.3-0.5l-0.4-0.3l-1.4-0.8l-0.7-0.2l-0.6-0.1l0.1-2.1l1.7-1.5
		L478.3,180.9z	"
          >
            <title id="t1722">Franklin, NC</title>
          </path>
          <path
            id="FIPS_37101"
            className="FIPS_39580 st0 state-nc"
            d="M477.6,187.3l0.4,0.5l0.5,1l0.7,0.1l-0.5,2.3l-0.8,1.4l-0.4,0.6l-2.5,0.1l-2.2-2.3l1.4-2
		l1.4-1.6l1.1-1.1L477.6,187.3z	"
          >
            <title id="t1717">Johnston, NC</title>
          </path>
          <path
            id="FIPS_37183"
            className="FIPS_39580 st0 state-nc"
            d="M471.1,184l2.2,0.3l0.6,0.1l0.7,0.2l1.4,0.8l0.4,0.3l0.3,0.5l0,0.1l-1.1,1.1l-1.4,1.6l-1.4,2
		l-2.3-0.4l-0.9-0.2l0.3-3.1l0-0.3l0.8-0.1l0.6-0.8l0.2-0.4l0.1-0.3l0-0.6L471.1,184z	"
          >
            <title id="t1718">Wake, NC</title>
          </path>
        </g>
        <path
          id="FIPS_37127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.6,180.9l0,0.6l-0.4,2.1l-0.2,1.1l-3.4,2.5l-0.9-1l1.6-5.4L481.6,180.9z	"
        >
          <title id="t1723">Nash, NC</title>
        </path>
        <path
          id="FIPS_37131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486,174.9l0.9,0.8l-0.4,1.5l-0.2,1.6l-0.6,1.2l-0.1,0.1l-0.1,0l-0.9-0.4l-2.3-1.5l-0.2-0.8
		l-1-0.6l-2.4,0l0,0.1l-0.1-0.5l1.3-0.3l4.8-0.9L486,174.9z	"
        >
          <title id="t1724">Northampton, NC</title>
        </path>
        <path
          id="FIPS_37083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M478.7,176.8L478.7,176.8l2.5-0.1l1,0.6l0.2,0.8l2.3,1.5l0.9,0.4l0.1,0l0.1-0.1l-0.1,1.3
		l-0.6,1l-0.2,0.1l-1-0.2l-0.2-0.4l-0.6-0.3l-1.4-0.4l-3.3,0L478.7,176.8z	"
        >
          <title id="t1725">Halifax, NC</title>
        </path>
        <path
          id="FIPS_37065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M485,182.2l1,2.3l-0.4-0.1l-0.8,0.6l-0.2,0.4l-0.3,0.4l-1.1,1.2l-0.7-0.6l-0.5-0.9l-1-0.6
		l0.2-1.1l0.4-2.1l0-0.6l1.4,0.4l0.6,0.3l0.2,0.4l1,0.2L485,182.2z	"
        >
          <title id="t1726">Edgecombe, NC</title>
        </path>
        <path
          id="FIPS_37195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481,184.9l1,0.6l0.5,0.9l0.7,0.6l-0.3,0.4l-1.1,1.3l-2.5,0.3l-0.7-0.1l-0.5-1l-0.4-0.5
		L481,184.9z	"
        >
          <title id="t1727">Wilson, NC</title>
        </path>
        <path
          id="FIPS_37079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482.8,187.3l2.9,2.4l-0.8,0.7l-0.6,0.5l-0.3,0.2l-0.1,0l-0.2-0.2l-1.1,0.2l-0.7-2.6
		L482.8,187.3z	"
        >
          <title id="t1728">Greene, NC</title>
        </path>
        <path
          id="FIPS_37107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486.8,190.7l-0.6,1.6l-0.6-0.1l0.3,0.9l0,0.1l-0.7,1.4l-1.2,1.1l-1.5-2l-0.2-2.5l1.1-0.2
		l0.2,0.2l0.1,0l0.3-0.2l0.6-0.5l0.8-0.7L486.8,190.7z	"
        >
          <title id="t1729">Lenoir, NC</title>
        </path>
        <path
          id="FIPS_37103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486.2,192.3l0.1,0l3.2,1.3l0.3,0.2l0.4-0.2l0.1,0l0.1,0.1l0.2,0.6l0.4,2.4l0.3,0.3l-0.7,0.4
		l-0.8-1.1l0-0.1l-0.6-0.4l-0.3,0h-3l-1.1,0.3l-0.6-0.3l1.2-1.1l0.7-1.4l0-0.1l-0.3-0.9L486.2,192.3z	"
        >
          <title id="t1730">Jones, NC</title>
        </path>
        <path
          id="FIPS_37061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M479.2,194.1l3.4-0.5l1.5,2l0.6,0.3l0.4,0.6l0.1,2.4l0,0.1l0.1,0.1l-4.5,0.8l-0.1,0.2l-0.1,0
		l-0.7-0.2l0.2-2.2l-0.6-2.2L479.2,194.1z	"
        >
          <title id="t1731">Duplin, NC</title>
        </path>
        <path
          id="FIPS_37133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M484.7,196l1.1-0.3h3l0.3,0l0.6,0.4l0,0.1l0.8,1.1l0.9,1.7l-3.7,3.4l-2.4-3.2l-0.1-0.1l0-0.1
		l-0.1-2.4L484.7,196z	"
        >
          <title id="t1732">Onslow, NC</title>
        </path>
        <path
          id="FIPS_37031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M495.3,193.2L495.3,193.2l0.2,0.3l0.4,0l2-0.2l0.3,1.5l2.1-2.2l-0.5,1.2l-2,3.7l-0.5,0.3
		l-0.4-0.1l-1.1-0.2l-0.5,0.1l-0.4,0.1l-0.5,0.1l-0.9,0.3l-0.8,0.3l-0.1,0l0,0l-0.3,0.1l-0.2,0.1l-0.4,0.2l-0.2,0.1l-0.9-1.7
		l0.7-0.4l1.4-0.4l2-0.9l0.6-0.4l0.2-0.6l0-0.3l-0.1-0.1l-0.7-0.4L495.3,193.2z	"
        >
          <title id="t1733">Carteret, NC</title>
        </path>
        <path
          id="FIPS_37137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M494.8,189.1l1.1,0l0.2,0.1l0.2,0.2l0.1,0.2l0,0.2l-0.1,0.7l-0.3,1.3l-0.2,0.4l-0.6,1.1
		l-0.6,0.6l-0.5,0.5l-0.2,0.1l-0.4,0.1l-0.9-0.2l-0.6-0.3l-0.2-0.3l-0.5-1.4l0.1-0.6l0.1-0.3l0.4-0.5l0.6,0.4l2.1-0.7l0.1-0.5v-0.1
		L494.8,189.1z	"
        >
          <title id="t1734">Pamlico, NC</title>
        </path>
        <path
          id="FIPS_37049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488.6,189.3l3.4,1.5l-0.4,0.5l-0.1,0.3l-0.1,0.6l0.5,1.4l0.2,0.3l0.6,0.3l0.9,0.2l0.4-0.1
		l0.2-0.1l0.5-0.5l0.7,0.4l0.1,0.1l0,0.3l-0.2,0.6l-0.6,0.4l-2,0.9l-1.4,0.4l-0.3-0.3l-0.4-2.4l-0.2-0.6l-0.1-0.1l-0.1,0l-0.4,0.2
		l-0.3-0.2l-3.2-1.3l-0.1,0l0.6-1.6L488.6,189.3z	"
        >
          <title id="t1735">Craven, NC</title>
        </path>
        <path
          id="FIPS_37147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486,184.5l2,0.7l0.6,4l-1.9,1.4l-1.1-0.9l-2.9-2.4l0.3-0.4l1.1-1.2l0.3-0.4l0.2-0.4l0.8-0.6
		L486,184.5z	"
        >
          <title id="t1736">Pitt, NC</title>
        </path>
        <path
          id="FIPS_37117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M485.6,181.2L485.6,181.2l0.1,0.2l1.5,1.2l0.1,0.1l1.7,0.6l0.1,0l2-0.2l0.7-0.4l-0.4,2.2
		l-1,0.7l-0.3,0.2l-0.9-0.3l-1.2-0.3l-2-0.7l-1-2.3L485.6,181.2z	"
        >
          <title id="t1737">Martin, NC</title>
        </path>
        <path
          id="FIPS_37041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.4,177.1l1.2-1l0,1.5l0.5,1.6l0,0l0.1,0.1l0.2,0l0.4,0l0.9-0.1l-2.5,1.2l-1-2.8
		L491.4,177.1z	"
        >
          <title id="t1738">Chowan, NC</title>
        </path>
        <path
          id="FIPS_37091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488.5,174.4l0.2,0.3l0,0.1l-0.2,0.5l-0.2,0.1l0.2,0.7l0,0l0.2,0.1l0.3,0.1l0.9,0.2h0.3
		l1.2,0.6l0,0.7l-2,0.4l-1.1,0.3l-1.8,0.3h-0.3l0.2-1.6l0.4-1.5l-0.9-0.8L488.5,174.4L488.5,174.4z	"
        >
          <title id="t1739">Hertford, NC</title>
        </path>
        <path
          id="FIPS_37015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.4,177.8l1,2.8l0,1l-0.5,1.2l-0.7,0.4l-2,0.2l-0.1,0l-1.7-0.6l-0.1-0.1l-1.5-1.2l-0.1-0.1
		l0-0.1l0.1-1.3l0.6-1.2h0.3l1.8-0.3l1.1-0.3L491.4,177.8z	"
        >
          <title id="t1740">Bertie, NC</title>
        </path>
        <path
          id="FIPS_37073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.3,173.5l0.6,0.4l0.7,1.6l-1,0.6l-1.2,1l-1.2-0.6h-0.3l-0.9-0.2l-0.3-0.1l-0.2-0.1l0,0
		l-0.2-0.7l0.2-0.1l0.2-0.5l0-0.1l-0.2-0.3L492.3,173.5z	"
        >
          <title id="t1741">Gates, NC</title>
        </path>
        <path
          id="FIPS_37029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.8,173.4l1.8-0.4l1.9,1.3l1.2,0.7l0,0l0.1,0l0.2,0.1l0.8,0.6l1,1.5l0,0l-1.7,0l-0.3-0.4
		l-0.8-0.6l-1.5-0.9l-2.1-0.9l-0.7-0.4l-0.6-0.4L492.8,173.4z	"
        >
          <title id="t1742">Camden, NC</title>
        </path>
        <path
          id="FIPS_37139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.9,173.9l0.7,0.4l2.1,0.9l1.5,0.9l0.8,0.6l0.3,0.4l-1.3,1.1l-1-0.7l-1.3-0.7l-1-1.2
		l-0.1-0.2L492.9,173.9z	"
        >
          <title id="t1743">Pasquotank, NC</title>
        </path>
        <path
          id="FIPS_37143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M493.6,175.5l0.1,0.2l1,1.2l1.3,0.7l1,0.7l-2.2,1l-0.9,0.1l-0.4,0l-0.2,0l-0.1-0.1l0,0
		l-0.5-1.6l0-1.5L493.6,175.5z	"
        >
          <title id="t1744">Perquimans, NC</title>
        </path>
        <path
          id="FIPS_37013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M493.5,184.5l1.8,1.4l-0.8,0.8l-0.1,0.1l0,0.1v0.1l0,0.2l0.3,0.6l0.4,0.5l0.2,0.2l-0.5,0.8
		l0.1,0.8v0.1l-0.1,0.5l-2.1,0.7l-0.6-0.4l-3.4-1.5l-0.6-4l1.2,0.3l0.9,0.3l0.3-0.2l1-0.7L493.5,184.5z	"
        >
          <title id="t1745">Beaufort, NC</title>
        </path>
        <path
          id="FIPS_37187"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.3,181.6L492.3,181.6l0.2,0.1l0.1,0l0.6-0.2l1-0.4l0.3-0.2l0.1-0.1l0.6-0.3l0.1,0l0.1,0.1
		l0.3,0.3l0.2,1.4l-0.2,0.7l0.3,1.1l-2.5,0.4l-2.1,0.4l0.4-2.2L492.3,181.6z	"
        >
          <title id="t1746">Washington, NC</title>
        </path>
        <path
          id="FIPS_37177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M499.8,183.6l-3.8,0.4l-0.3-1.1l0.2-0.7l-0.2-1.4l0.8-0.6l0.6-0.3l0.4-0.1l1.2-0.2l0.4,0.2
		l0.1,0.1l0.3,0.7l0,0.2l0,0.4l0.1,0.7l0.2,0.7l0.2,0.9L499.8,183.6z	"
        >
          <title id="t1747">Tyrrell, NC</title>
        </path>
        <path
          id="FIPS_37055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M499.8,183.6l0-0.2l-0.2-0.9l-0.2-0.7l-0.1-0.7l0-0.4l0-0.2l0.4-0.8l0.1-0.1l0.4-0.2l0.2-0.1
		l0.2,0l0.1,0l0.5,0.1l0.4,0.3l0.7,1l0.1,0.2l0.5,1.5l0,0.1l0,0.9l-0.3,0.7l-0.2,0.1l-0.4,0.1l-0.4-0.1L499.8,183.6z M502.7,179.6
		l0.2,0.1l0.2,0.1l0.2,0.2l0.2,0.3l0.1,0.5l0,0.1l0,0l-0.5-0.1l-0.1-0.1l-0.8-1.1l-0.1-0.1l0,0l0.1-0.1l0.1,0h0.2L502.7,179.6z
		 M503.9,189l0.2-0.1l0.1-0.1l0.8-0.6l0.9-0.6l0-0.2l0-1.3l-0.1-0.9l-0.1-1.3l-0.1-0.6l-0.1-0.3l-0.1-0.3l-0.2-0.2l-0.1-0.2
		l-0.5-1.1l0,0l0.1,0l0,0l0,0l0.3,0.3l0.1,0.2l0.3,0.6l0.2,0.4l0.3,0.6l0.1,0.6l0,0.2l0.1,0.8l0.1,1.2l0,0.9l0,1.1l-0.1,0.1l-0.1,0
		l-0.2,0l-0.2,0.1l-0.3,0.1l-0.2,0.1l-1.1,0.7L503.9,189 M500.9,175.9l0.6,0.9l0,0l0.3,0.5l0.3,0.4l0.5,0.6l0.6,0.8l0.8,1l0.5,0.8
		l0,0.1l-1-1.1l-1.7-2.1l-1-1.8L500.9,175.9z	"
        >
          <title id="t1748">Dare, NC</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "47260"
              ? `metroArea clickedArea state-nc state-va`
              : `metroArea ${colorCode[47260]} state-nc state-va`
          }
          id="FIPS_47260"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_37053"
            className="FIPS_47260 st0 state-nc state-va"
            d="M496.5,172.6l2.6-0.6l1.8,3.8l-0.2,0.1l-1.1-2.3l-0.7-0.7l-0.1,0l-1,0l-0.2,0.1l0,0l0,0.1
		l0,0.2l0.2,0.3l0.1,0.1l0.1,0.1l0.5,0.2l0.6,0.7l1.8,2.8l0.2,0.4l0,0.1H501l-0.4-0.2l-0.1-0.1l-0.3-0.3l-0.3-0.4l0,0l-1-1.5
		l-0.8-0.6l-0.2-0.1l-0.1,0l0,0l-1.2-0.7l-1.9-1.3L496.5,172.6z	"
          >
            <title id="t1749">Currituck, NC</title>
          </path>
          <path
            id="FIPS_51073"
            className="FIPS_47260 st0 state-nc state-va"
            d="M490.8,161.1l0.6,1.4h-0.1l-0.2,0.3l0,0.2l0.1,0.1l0.6,0.5l0.4,0.3l0,0l-0.1,0.1l-0.6,0.4
		l-0.7,0.3l-2-1.4l-0.7-0.5l0.4-0.5l0.1-0.2l0-0.1v-0.1l-0.1-0.1l-0.3-0.3l0-0.1l0-1L490.8,161.1z	"
          >
            <title id="t2919">Gloucester, VA</title>
          </path>
          <path
            id="FIPS_51093"
            className="FIPS_47260 st0 state-nc state-va"
            d="M488,172.3l0-3.8l1.5-2.2l2.4,2.3l-0.4,0.2l0,0l-2.9,4.2l-0.1,0L488,172.3z	"
          >
            <title id="t2932">Isle of Wight, VA</title>
          </path>
          <path
            id="FIPS_51095"
            className="FIPS_47260 st0 state-nc state-va"
            d="M487.9,162.3l0.4,0.4l0.7,0.5l-0.4,1l-0.1-0.1l-0.2,0.2l0.1,0.6l0.1,0.1l0.1,0.1l0.2,0l0.3,0
		l0.2-0.1l0.1-0.1l0-0.1l0.7,0.3l-0.2,0.4l-1.2-0.2l-1.6,0.2l-0.6-1.9L487.9,162.3z	"
          >
            <title id="t2898">James City, VA</title>
          </path>
          <path
            id="FIPS_51115"
            className="FIPS_47260 st0 state-nc state-va"
            d="M490.8,161.1l0.8-0.5l0.6,0.1l0.1,0l0.1,0.1l0.2,0.3l0.2,0.4l0.2,0.5l0.1,0.2v0.2l-0.2,0.8
		l-0.3-0.2l-1.1-0.6L490.8,161.1z	"
          >
            <title id="t2930">Mathews, VA</title>
          </path>
          <path
            id="FIPS_51199"
            className="FIPS_47260 st0 state-nc state-va"
            d="M488.5,164.2l0.4-1l2,1.4l0,0.1l0.1,0.1l0.2,0.1l0.8-0.3l0,0l0.1,0.3l0,0.1l0,0.2l0,0.2
		l0.2,0.7l-0.4,0.2l-1.9-1.2l-0.7-0.3l-0.1-0.4l-0.3-0.2l-0.1,0L488.5,164.2L488.5,164.2z	"
          >
            <title id="t2897">York, VA</title>
          </path>

          <path
            id="FIPS_51181"
            className="FIPS_47260 st0 state-nc state-va"
            d="M487.1,165.7l1.6-0.2l0.8,0.9l-1.5,2.2l-0.9,0.9l-0.3-0.7l-1-0.7l0,0h-0.3l-0.8-0.3l0,0l0,0
		l0,0l1.5-2.1L487.1,165.7z	"
          >
            <title id="t2899">Surry, VA</title>
          </path>
          <path
            id="FIPS_51550"
            className="FIPS_47260 st0 state-nc state-va"
            d="M494.1,169.6l0.6-0.4l1.8,3.5l-1.9,0.4l-1.8,0.4l-0.1-4.2l0.4,0.7L494.1,169.6z	"
          >
            <title id="t2934">Chesapeake, VA</title>
          </path>
          <path
            id="FIPS_51650"
            className="FIPS_47260 st0 state-nc state-va"
            d="M492.3,166.2l1-0.4l0.6,1l-0.4,0.7l-1,0.3l-0.7-1.4L492.3,166.2z	"
          >
            <title id="t2893">Hampton, VA</title>
          </path>
          <path
            id="FIPS_51830"
            className="FIPS_47260 st0 state-nc state-va"
            d="M489.3,164.9L489.3,164.9l-0.1,0.1l-0.2,0.1l-0.3,0l-0.2,0l-0.1-0.1l-0.1-0.1l-0.1-0.6
		l0.2-0.2l0.1,0.1l0.1,0.1l0.3,0l0.1,0l0.3,0.2L489.3,164.9z	"
          >
            <title id="t2894">Williamsburg, VA</title>
          </path>
          <path
            id="FIPS_51700"
            className="FIPS_47260 st0 state-nc state-va"
            d="M490,165.2l1.9,1.2l0.7,1.4l-0.1,0.2h-0.1l-0.1-0.1l-2.3-1.5l-0.1-0.1l-0.1-0.7L490,165.2z	"
          >
            <title id="t2895">Newport News, VA</title>
          </path>
          <path
            id="FIPS_51735"
            className="FIPS_47260 st0 state-nc state-va"
            d="M492.3,166.2l-0.2-0.7l0-0.2l0-0.2l0-0.1l0.6-0.1l0.5,0.5l0.1,0.4L492.3,166.2z	"
          >
            <title id="t2890">Poquoson, VA</title>
          </path>
          <path
            id="FIPS_51740"
            className="FIPS_47260 st0 state-nc state-va"
            d="M492.7,168.8l0.6-0.4l0.8,1.1l-1,0.4l-0.4-0.7L492.7,168.8z	"
          >
            <title id="t2896">Portsmouth, VA</title>
          </path>

          <path
            id="FIPS_51710"
            className="FIPS_47260 st0 state-nc state-va"
            d="M494.8,167.9l0.2,0.9l-0.4,0.3l-0.6,0.4l-0.8-1.1L494.8,167.9z	"
          >
            <title id="t2931">Norfolk, VA</title>
          </path>

          <path
            id="FIPS_51800"
            className="FIPS_47260 st0 state-nc state-va"
            d="M492.7,168.8l0,0.4l0.1,4.2l-0.5,0.1l-3.8,0.9l0,0l-0.1-1.3l2.9-4.2l0,0l0.4-0.2L492.7,168.8z
			"
          >
            <title id="t2933">Suffolk, VA</title>
          </path>

          <path
            id="FIPS_51810"
            className="FIPS_47260 st0 state-nc state-va"
            d="M494.8,167.9l1.5-0.3l0.2,0l0.1,0l0.1,0.1l0.1,0.1l2.1,3.9l0.2,0.4l-2.6,0.6l-1.8-3.5l0.4-0.3
		L494.8,167.9z	"
          >
            <title id="t2935">Virginia Beach, VA</title>
          </path>
        </g>
        <path
          id="FIPS_37095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M499.8,183.6l1.8,0.7l-0.2,0.2l-0.4,0.7l0,0.1l-0.3,0.7l0,0.1l0,0.1l-0.1,0.4l0,0.1l0,0.1
		l-0.4,0.6l-0.6,0.7l-0.1,0l-2.6,0.3l-0.1,0l-0.8-0.1l-0.7-0.1l-0.2-0.2l-0.4-0.5l-0.3-0.6l0-0.2v-0.1l0-0.1l0.1-0.1l0.8-0.8
		l-1.8-1.4l2.5-0.4L499.8,183.6z M503.9,189l0.1,0.2l-0.2,0.1l-0.2,0.1l-0.5,0.4l-0.7,0.6l-0.3,0.3l-0.3,0.4l-0.2,0.2l-0.1,0.1l0,0
		l0-0.1l0.2-0.5l0.2-0.3l0.7-0.6l1-0.8L503.9,189z	"
        >
          <title id="t1750">Hyde, NC</title>
        </path>

        <path
          id="FIPS_38077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.5,63.3l0.4,1.1l1.2,3l0.3,2.7l0,0.2l0,0.3l0,0.1l-0.2,0.5l0.1,1.1l-6-0.1l-0.2-0.8
		l-0.1-0.8l0-2.9l-0.2,0l0.1-4.5L286.5,63.3z	"
        >
          <title id="t1752">Richland, ND</title>
        </path>
        <path
          id="FIPS_38013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.6,33.8l-1.1-0.1l-0.8,1.1l-0.1,2.2l-5.6-0.4l0.1-1.1l0.1-1.1l-0.5,0l0.3-3.5l7.9,0.5
		L241.6,33.8z	"
        >
          <title id="t1753">Burke, ND</title>
        </path>
        <path
          id="FIPS_38023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M224.4,30.1l9.5,0.8l-0.3,3.5l0.5,0l-0.1,1.1l-10-0.8L224.4,30.1z	"
        >
          <title id="t1754">Divide, ND</title>
        </path>
        <path
          id="FIPS_38105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M224,34.7l10,0.8l-0.1,1.1l-0.2,2.2l0.5,0l-0.2,3.2l-0.4-0.2l-2-0.3l-0.9,0.1l-0.1,0.1
		l-0.2,0.2l-0.2,0.2l0,0l0,0l0.1,0.1l0.1,0.1l0,0.1l0,0.1l-0.1,0.1l-0.4,0.1l-0.6,0.2l-1.3,0.2l-0.1,0l-0.5-0.4l-0.2-0.3l0-0.4
		l-0.2-0.3l-0.6-0.2l-0.2,0l-0.2,0.1l-0.3,0.2l0,0.1l0,0.1l0.2,0.2l-0.3,0.4l-0.8,0.6l-0.6,0.3l-0.3,0.1l-1-0.6l0.4-5L224,34.7z	"
        >
          <title id="t1755">Williams, ND</title>
        </path>
        <path
          id="FIPS_38061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.6,37l2.3,0.1l0.3,2.3l-0.3,4.5l0.2,0.8l0.1,1.5l-4.5-0.3l-0.1,1.1l-2.2-1l0,0l0-0.1
		l0-0.4l0-0.2l0.1-0.3l0-0.1l0.3-0.4l0.2-0.1l0.1-0.1l0.1-0.2l0.1-0.2l0-0.1l0,0l-1.2-1.2l-0.6-0.5l-0.4,0l0.2-3.2l-0.5,0l0.2-2.2
		L239.6,37z	"
        >
          <title id="t1756">Mountrail, ND</title>
        </path>
        <path
          id="FIPS_38053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234.1,42l0.4,0l0.6,0.5l1.2,1.2l0,0l0,0.1l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.2,0.1l-0.3,0.4
		l0,0.1l-0.1,0.3l0,0.2l0,0.4l0,0.1l0,0l-0.1,1.9l-4-0.3l-0.3,4.4l-5-0.4l-3.3-0.3l0.1-0.9l0.7-7.6l1,0.6l0.3-0.1l0.6-0.3l0.8-0.6
		l0.3-0.4l-0.2-0.2l0-0.1l0-0.1l0.3-0.2l0.2-0.1l0.2,0l0.6,0.2l0.2,0.3l0,0.4l0.2,0.3l0.5,0.4l0.1,0l1.3-0.2l0.6-0.2l0.4-0.1
		l0.1-0.1l0-0.1l0-0.1l-0.1-0.1l-0.1-0.1l0,0l0,0l0.2-0.2l0.2-0.2l0.1-0.1l0.9-0.1l2,0.3L234.1,42z	"
        >
          <title id="t1757">McKenzie, ND</title>
        </path>
        <path
          id="FIPS_38025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.6,47l0.3-0.4l0.1-0.1l0.1,0l0.1,0l0.5,0.2l0.1,0.1l0,0.1l0,0.1l0,0.1l-0.1,1.8l0,0.1
		l0,0.1l0.4,0.5l-0.2,3.2l0.5,0l-0.3,4.1l-3.4-0.2l0,0.4l-4.5-0.3l0.3-4.5l-0.6,0l0.3-4.4l4,0.3l0.1-1.9L237.6,47z	"
        >
          <title id="t1758">Dunn, ND</title>
        </path>
        <path
          id="FIPS_38089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.1,56.7l0.4,0.4l-0.2,3.4l-0.1,1.1l-7.4-0.5l-2.7-0.2l0.3-4.5l1.8,0.1l4.5,0.3l0-0.4
		L239.1,56.7z	"
        >
          <title id="t1759">Stark, ND</title>
        </path>
        <path
          id="FIPS_38033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M226,51.6l-0.4,4.5l0.5,0l-0.4,4.5l-1.7-0.1l-0.1,1.1l-2.2-0.2l0.1-1.3l0.7-8.8L226,51.6z	"
        >
          <title id="t1760">Golden Valley, ND</title>
        </path>
        <path
          id="FIPS_38007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M226,51.6l5,0.4l0.6,0l-0.3,4.5l-1.8-0.1l-0.3,4.5l-3.4-0.3l0.4-4.5l-0.5,0L226,51.6z	"
        >
          <title id="t1761">Billings, ND</title>
        </path>
        <path
          id="FIPS_38011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.9,65.5l-0.3,4.3l-9.4-0.7l0.4-4.3L230.9,65.5z	"
        >
          <title id="t1762">Bowman, ND</title>
        </path>
        <path
          id="FIPS_38087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M225.8,60.6l3.4,0.3l2.7,0.2l-0.3,4.5l-0.6,0l-9.4-0.7l0.3-3.3l2.2,0.2l0.1-1.1L225.8,60.6z	"
        >
          <title id="t1763">Slope, ND</title>
        </path>
        <path
          id="FIPS_38041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.2,61.6l0.4,0l0,3l0.2,1.6l-0.1,0.9l-4.5-0.3l0.1-1l-3.8-0.2l0.3-4.5L239.2,61.6z	"
        >
          <title id="t1764">Hettinger, ND</title>
        </path>
        <path
          id="FIPS_38001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.9,65.5l0.6,0l3.8,0.2l-0.1,1l4.5,0.3l-0.2,3.3h0l-8.5-0.6l-0.5,0L230.9,65.5z	"
        >
          <title id="t1765">Adams, ND</title>
        </path>
        <path
          id="FIPS_38057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239,49.4l0.2,0.1l2.5,1l0.6,0.2l0.1,0l0.2-0.1l0.4-0.3l0.3-0.1l2.2-0.2h0.2l0.1,0l0.5,0.5
		l0,0.1l-0.1,0.1l-0.3,0.2l-0.1,0.1l-0.2,0.2l0,0.1l0,0.1l0.7,1.9l0.8,0.7l0,0.3l-4.5-0.3l-0.2,3.3l-2.9-0.2l-0.4-0.4l0.3-4.1
		l-0.5,0L239,49.4z	"
        >
          <title id="t1766">Mercer, ND</title>
        </path>
        <path
          id="FIPS_38037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.3,60.4l3.4,0.2l-0.1,1.1l3.7,0.2l-0.2,3.3l2.2,0.1l0.1,1.1l-0.9,0.9l-0.9,0.7l-0.8,0.6
		l-1.9,0.9l-0.7,0.2l0,0l-0.9-0.2l-1.3-0.5l-0.6-0.2l-0.8,0.1l0.1-2l0.1-0.9l-0.2-1.6l0-3l-0.4,0L239.3,60.4z	"
        >
          <title id="t1767">Grant, ND</title>
        </path>
        <path
          id="FIPS_38085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.5,66.6l0.1-0.5l0.9-0.9l0.4-0.1l0.1,0.1l0.4,0.1l0.9,0.1l0.2-0.1l1-0.4l0.1,0.2l0.2,0.5
		l0.1,0.2l0,0.4l-0.1,1.2l0,0.1l-0.1,0.3l-0.2,0.2l-0.2,0.4l-0.1,0.3l0,0.1l0.1,0.8l0,0.1l0.8,1.6l-2-0.1l-0.2,0l-0.1,0l-1.1-0.1
		l-0.8,0l-2.6-0.1l-0.9-0.1l-0.5,0l-1.1-0.1l-1.4-0.1l-1.3-0.1l-1.1-0.1l-0.1,0l0,0l-0.1,0l0.1-1.4l0.8-0.1l0.6,0.2l1.3,0.5l0.9,0.2
		l0,0l0.7-0.2l1.9-0.9l0.8-0.6l0.9-0.7L248.5,66.6z	"
        >
          <title id="t1768">Sioux, ND</title>
        </path>

        <path
          id="FIPS_38065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M249.6,55.4l0.1,2.2l-7.3-0.4l0.2-3.3l4.5,0.3l0-0.3l1.2-0.3l0.3,0l0.3,0.1l0.2,0.1l0.3,0.2
		l0.2,0.2l0,0.1L249.6,55.4z	"
        >
          <title id="t1770">Oliver, ND</title>
        </path>
        <path
          id="FIPS_38075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.6,33.8l0.2-2.4l4.5,0.3l-0.2,3.6l0.3,2.2l3.4,0.2l-0.1,1.1l-6.8-0.4l0.2-3.3l-1.5-0.1
		L241.6,33.8z	"
        >
          <title id="t1771">Renville, ND</title>
        </path>
        <path
          id="FIPS_38101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.6,37l0.1-2.2l0.8-1.1l1.1,0.1l-0.1,1.1l1.5,0.1l-0.2,3.3l6.8,0.4l-0.1,1.1l0.2,1.2l0,2.3
		l0.2,1l0.1,0l-0.1,2.2l-7.9-0.4l-0.1-1.5l-0.2-0.8l0.3-4.5l-0.3-2.3L239.6,37z	"
        >
          <title id="t1772">Ward, ND</title>
        </path>
        <path
          id="FIPS_38055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250,46.5l3.4,0.2l-0.1,2.2l-0.8,0l0,0.7l-0.2,3.8l-0.7,0l-0.1,2.2l-1.9-0.1l0-1.2l0-0.1
		l-0.2-0.2l-0.3-0.2l-0.2-0.1l-0.3-0.1l-0.3,0l-1.2,0.3l-0.8-0.7l-0.7-1.9l0-0.1l0-0.1l0.2-0.2l0.1-0.1l0.3-0.2l0.1-0.1l0-0.1
		l-0.5-0.5l-0.1,0h-0.2l-2.2,0.2l-0.3,0.1l-0.4,0.3l-0.2,0.1l-0.1,0l-0.6-0.2l-2.5-1l-0.2-0.1l-0.4-0.5l0-0.1l0-0.1l0.1-1.8l0-0.1
		l0-0.1l0-0.1l-0.1-0.1l-0.5-0.2l-0.1,0l-0.1,0l-0.1,0.1l-0.3,0.4l0.1-1.1l4.5,0.3L250,46.5z	"
        >
          <title id="t1773">McLean, ND</title>
        </path>
        <path
          id="FIPS_38009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.3,31.6l11.3,0.6l-0.2,3.6l0.3,0l-0.1,2.2l-1.1,0l-1.1,0l0.1-1.1l-3.4-0.2l-2.3-0.1
		l-0.1,1.1l-3.4-0.2l-0.3-2.2L246.3,31.6z	"
        >
          <title id="t1774">Bottineau, ND</title>
        </path>
        <path
          id="FIPS_38049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.5,38l-0.1,2.2l0.2,1.5l0,3l0.2,0.8l0,1.5l-3.4-0.2l-3.4-0.2l0.1-2.2l-0.1,0l-0.2-1l0-2.3
		l-0.2-1.2l0.1-2.2l0.1-1.1l2.3,0.1l3.4,0.2l-0.1,1.1L256.5,38z	"
        >
          <title id="t1775">McHenry, ND</title>
        </path>
        <path
          id="FIPS_38083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.8,46.9l1.1,0.1l-0.1,2.2l0.3,0l-0.2,4.4l-0.7,0l-4.9-0.2l0.2-3.8l0-0.7l0.8,0l0.1-2.2
		L256.8,46.9z	"
        >
          <title id="t1776">Sheridan, ND</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "13900"
              ? `metroArea clickedArea state-nd`
              : `metroArea ${colorCode[13900]} state-nd`
          }
          id="FIPS_13900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_38015"
            className="FIPS_13900 st0 state-nd"
            d="M257.2,53.6L257,58l0.4,0l-0.2,4.5l-5.2-0.3l-0.6-0.3l-0.4-0.4l-0.4-0.8l-0.5-2l-0.2-0.8
		l0-0.2l-0.1-2.2l1.9,0.1l0.1-2.2l0.7,0L257.2,53.6z	"
          >
            <title id="t1777">Burleigh, ND</title>
          </path>
          <path
            id="FIPS_38059"
            className="FIPS_13900 st0 state-nd"
            d="M239.5,57.1l2.9,0.2l7.3,0.4l0,0.2l0.2,0.8l0.5,2l0.4,0.8l0.4,0.4l0.6,0.3l0.5,0.4l0.2,0.3
		l0.2,0.5l-0.3,0.4l-0.1,0.2l-0.1,0.6l0,0.1l0.1,0.1l-1,0.4l-0.2,0.1l-0.9-0.1l-0.4-0.1l-0.1-0.1l-0.4,0.1l-0.9,0.9l-0.1,0.5
		l-0.1-1.1l-2.2-0.1l0.2-3.3l-3.7-0.2l0.1-1.1l-3.4-0.2L239.5,57.1z	"
          >
            <title id="t1769">Morton, ND</title>
          </path>
        </g>
        <path
          id="FIPS_38029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.1,62.5l1.5,0.1l0.1,4.5l-0.2,4.4l-5.6-0.3l-0.1,0l-0.8-1.6l0-0.1l-0.1-0.8l0-0.1l0.1-0.3
		l0.2-0.4l0.2-0.2l0.1-0.3l0-0.1l0.1-1.2l0-0.4l-0.1-0.2l-0.2-0.5l-0.1-0.2l-0.1-0.1l0-0.1l0.1-0.6l0.1-0.2l0.3-0.4l-0.2-0.5
		l-0.2-0.3l-0.5-0.4L257.1,62.5z	"
        >
          <title id="t1778">Emmons, ND</title>
        </path>
        <path
          id="FIPS_38051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.8,67.1l7.5,0.3l0.3,0l-0.2,4.4l-6.4-0.2l-1.5-0.1L258.8,67.1z	"
        >
          <title id="t1779">McIntosh, ND</title>
        </path>
        <path
          id="FIPS_38047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.6,62.6l4.2,0.2l3.7,0.1l-0.1,4.5l-7.5-0.3L258.6,62.6z	"
        >
          <title id="t1780">Logan, ND</title>
        </path>
        <path
          id="FIPS_38043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.2,53.6l0.7,0l4.9,0.2l-0.2,4.4l0.3,0l-0.2,4.5l-4.2-0.2l-1.5-0.1l0.2-4.5l-0.4,0
		L257.2,53.6z	"
        >
          <title id="t1781">Kidder, ND</title>
        </path>
        <path
          id="FIPS_38103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.9,46.9l2.2,0.1l4.5,0.2l-0.1,2.2l0.3,0l0,1.1l-0.1,3.3l-1.9-0.1l-4.9-0.2l0.2-4.4l-0.3,0
		L257.9,46.9z	"
        >
          <title id="t1782">Wells, ND</title>
        </path>
        <path
          id="FIPS_38069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.6,38l5.6,0.2l-0.1,2.2l-3.1-0.1l-0.2,4.5l0.3,0l-0.1,2.2l-2.2-0.1l-1.1-0.1l0-1.5
		l-0.2-0.8l0-3l-0.2-1.5l0.1-2.2L257.6,38z	"
        >
          <title id="t1783">Pierce, ND</title>
        </path>
        <path
          id="FIPS_38079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.6,38l0.1-2.2l-0.3,0l0.2-3.6l5.6,0.2l-0.1,3.6l0.3,0l-0.1,2.2L257.6,38z	"
        >
          <title id="t1784">Rolette, ND</title>
        </path>
        <path
          id="FIPS_38095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.2,32.4l4.5,0.2l-0.1,2.3l0,1.3l0.3,0l-0.1,2.2l-0.1,2.2l-2-0.1l-2.5-0.1l0.1-2.2l0.1-2.2
		l-0.3,0L263.2,32.4z	"
        >
          <title id="t1785">Towner, ND</title>
        </path>
        <path
          id="FIPS_38005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.2,40.4l2.5,0.1l-0.1,2.7l0.1,0.1l1.8,2l0.3-0.1l1.7,0.2l1.1,1l0.9,0l0,0.9l-6.8-0.2
		l-4.5-0.2l0.1-2.2l-0.3,0l0.2-4.5L263.2,40.4z	"
        >
          <title id="t1786">Benson, ND</title>
        </path>
        <path
          id="FIPS_38027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M264.6,47.2l6.8,0.2l0.2,2.2l0,1.1l-6.7-0.2l0-1.1l-0.3,0L264.6,47.2z	"
        >
          <title id="t1787">Eddy, ND</title>
        </path>
        <path
          id="FIPS_38031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M264.8,50.5l6.7,0.2l-0.1,3.3l-6.8-0.2L264.8,50.5z	"
        >
          <title id="t1788">Foster, ND</title>
        </path>
        <path
          id="FIPS_38093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.8,53.8l1.9,0.1l6.8,0.2l0.3,1.1l-0.1,3.3l0.2,0l-0.1,4.5l-5.3-0.1l-3.7-0.1l0.2-4.5
		l-0.3,0L262.8,53.8z	"
        >
          <title id="t1789">Stutsman, ND</title>
        </path>
        <path
          id="FIPS_38045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.8,63l3.6,0.1l-0.1,4.5l-8.7-0.2l-0.3,0l0.1-4.5L271.8,63z	"
        >
          <title id="t1790">LaMoure, ND</title>
        </path>
        <path
          id="FIPS_38021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.6,67.3l8.7,0.2l0.3,0l-0.1,4.5l-6.4-0.2l-2.5-0.1L266.6,67.3z	"
        >
          <title id="t1791">Dickey, ND</title>
        </path>
        <path
          id="FIPS_38081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.5,67.6l6.5,0.1l0.2,0l0,2.9l0.1,0.8l0.2,0.8l-6.8-0.1l-0.3,0L275.5,67.6z	"
        >
          <title id="t1792">Sargent, ND</title>
        </path>
        <path
          id="FIPS_38073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.4,63.1l3.1,0.1l3.6,0.1l-0.1,4.5l-6.5-0.1l-0.3,0L275.4,63.1z	"
        >
          <title id="t1793">Ransom, ND</title>
        </path>
        <path
          id="FIPS_38003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.2,55.3l2.2,0l0,2.1l0.2,1.3l-0.1,4.5l-3.1-0.1l-3.6-0.1l0.1-4.5l-0.2,0l0.1-3.3
		L276.2,55.3z	"
        >
          <title id="t1794">Barnes, ND</title>
        </path>
        <path
          id="FIPS_38039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.1,49.8l0.1,5.5l-4.5-0.1l-0.3-1.1l0.1-4.4L276.1,49.8z	"
        >
          <title id="t1795">Griggs, ND</title>
        </path>
        <path
          id="FIPS_38091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.1,49.8l0.9,0l3.6,0.1l0.1,5.5l-4.5-0.1L276.1,49.8z	"
        >
          <title id="t1796">Steele, ND</title>
        </path>
        <path
          id="FIPS_38063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M273.5,43l3.4,0.1l0,2.2l0.2,0v0l-0.1,4.4l-0.9,0l-4.5-0.1l-0.2-2.2l0-0.9l0-1.4l0.9,0
		l0.1-2.2L273.5,43z	"
        >
          <title id="t1797">Nelson, ND</title>
        </path>
        <path
          id="FIPS_38071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M273.4,38.6l0,1.5l0.2,0.7l-0.1,2.2l-1.1,0l-0.1,2.2l-0.9,0l0,1.4l-0.9,0l-1.1-1l-1.7-0.2
		l-0.3,0.1l-1.8-2l-0.1-0.1l0.1-2.7l2,0.1l0.1-2.2L273.4,38.6z	"
        >
          <title id="t1798">Ramsey, ND</title>
        </path>
        <path
          id="FIPS_38019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.7,32.6l9,0.2l-0.1,3.6l0.2,0l0,2.2l-3.4-0.1l-5.6-0.2l0.1-2.2l-0.3,0l0-1.3L267.7,32.6z	
		"
        >
          <title id="t1799">Cavalier, ND</title>
        </path>
        <path
          id="FIPS_38067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.7,32.8l6.2,0.1l0,0l0,0.2l0,0.2l0,0.3l0.6,2l0.2,0.5l0.4,0.9l-0.6,1.8l0,0l-6.7-0.1
		l0-2.2l-0.2,0L276.7,32.8z	"
        >
          <title id="t1800">Pembina, ND</title>
        </path>
        <path
          id="FIPS_38099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M273.4,38.6l3.4,0.1l6.7,0.1l0.1,0l0.2,0.2l0.1,3.1l-0.3,1.1l-6.6-0.1l-3.4-0.1l0.1-2.2
		l-0.2-0.7L273.4,38.6z	"
        >
          <title id="t1801">Walsh, ND</title>
        </path>
        <path
          id="FIPS_38035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.5,43.2l0,0.3v0l0.2,0.8l0.8,3l1.1,2.6l-5.1-0.1l-3.6-0.1l0.1-4.4v0l-0.2,0l0-2.2
		L283.5,43.2z	"
        >
          <title id="t1802">Grand Forks, ND</title>
        </path>
        <path
          id="FIPS_38097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.6,49.8l5.1,0.1l0.3,2.2l0.2,3.4l-5.5-0.1L280.6,49.8z	"
        >
          <title id="t1803">Traill, ND</title>
        </path>
        <path
          id="FIPS_31045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223,107.4l4.7,0.4l2,0.1l-0.2,2.8l0.1,0.8l-0.3,3.7l-6.4-0.4l-0.3,0l0.3-4.5l-0.1-0.5l0-1
		L223,107.4z	"
        >
          <title id="t1804">Dawes, NE</title>
        </path>
        <path
          id="FIPS_31165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223,107.4l-0.1,1.3l0,1l0.1,0.5l-0.3,4.5l0.3,0l-0.3,4.5l0.4,0l-0.1,1.1l-6.2-0.5l1.1-12.9
		L223,107.4z	"
        >
          <title id="t1805">Sioux, NE</title>
        </path>
        <path
          id="FIPS_31147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.4,145.7l4.5,0l2.4,3.4H300l-4.4,0h-2.2L293.4,145.7z	"
        >
          <title id="t1806">Richardson, NE</title>
        </path>
        <path
          id="FIPS_31133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289,145.7l3.9,0l0.5,0l0,3.4l-2.2,0l-2.2,0L289,145.7z	"
        >
          <title id="t1807">Pawnee, NE</title>
        </path>
        <path
          id="FIPS_31127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.8,142.3l3.5,0l0.1-0.3l0.4,0.3l-0.2,0.4l-0.1,0.1l0.1,0.2l0.6,1.6l0.7,0.7l0,0.1l0,0v0
		l0,0.2v0l-4.5,0l-0.5,0V142.3z	"
        >
          <title id="t1808">Nemaha, NE</title>
        </path>
        <path
          id="FIPS_31097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.8,142.3v3.4l-3.9,0l0-3.4L292.8,142.3z	"
        >
          <title id="t1809">Johnson, NE</title>
        </path>
        <path
          id="FIPS_31131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M294.9,138.9l0.9,2.6l0.5,0.8l-3.5,0l-3.9,0l0-3.4L294.9,138.9z	"
        >
          <title id="t1810">Otoe, NE</title>
        </path>

        <path
          id="FIPS_31021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M290.9,122.5l1.3,2.4l0.2,2.4l-3.1,0l-1.1-0.8l0-3.6L290.9,122.5z	"
        >
          <title id="t1815">Burt, NE</title>
        </path>
        <path
          id="FIPS_31173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.6,119.5l3.6,0l-0.1,0.8l0.8,2.2l-2.7,0.4l-2.6-1l0-2.3L286.6,119.5z	"
        >
          <title id="t1816">Thurston, NE</title>
        </path>
        <path
          id="FIPS_31043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M287.5,116.3l1.8,0.5l0.3,0l0.1,0l0.1,0.1l0,0.1l0,0.2l-0.1,0.2l0.1,1.5l0.3,0.5l-3.6,0
		L287.5,116.3z	"
        >
          <title id="t1817">Dakota, NE</title>
        </path>
        <path
          id="FIPS_31051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.9,113.2l2,0.7l0.8,0.5l0.1,0.2l0.1,0.2l0,0.2l0,0.1l0,0.1l0.7,1l-0.9,3.2l-0.9,0.2
		l-1.8-1.1L283.9,113.2z	"
        >
          <title id="t1818">Dixon, NE</title>
        </path>
        <path
          id="FIPS_31179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.5,118.5l3.3,0.1l1.8,1.1l0,2.3l-1.9,0l-3.3,0L280.5,118.5z	"
        >
          <title id="t1819">Wayne, NE</title>
        </path>
        <path
          id="FIPS_31139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276,121.8l0.1-4.5l3.3,0l1.1,1.1l-0.1,3.4L276,121.8z	"
        >
          <title id="t1820">Pierce, NE</title>
        </path>
        <path
          id="FIPS_31027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.5,111.9l0.6-0.1l0.9,0l0.7,0.1l1.1,0.9l1.2,0.3l-0.1,5.3l-3.3-0.1l-1.1-1.1L279.5,111.9z
			"
        >
          <title id="t1821">Cedar, NE</title>
        </path>
        <path
          id="FIPS_31107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.7,111.4l1.3,0.6l1,0.9l0.2,0.1l0.2,0l0.2,0l0.5-0.1l0.1-0.1l0.3-0.2l0.2-0.3l1.1-0.4
		l0.8,0.1l1.9-0.1l-0.1,5.4l-3.3,0l-4.4-0.1l0.1-4.2L271.7,111.4z	"
        >
          <title id="t1822">Knox, NE</title>
        </path>
        <path
          id="FIPS_31053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.2,126.5l1.1,0.8l0,2.1l0.1,0.3l0.1,0.2l0.9,1.2l-1.4,0l-4.2-0.8v0l0-3.7L288.2,126.5z	"
        >
          <title id="t1823">Dodge, NE</title>
        </path>
        <path
          id="FIPS_31037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.7,126.4l1.1,0l0,3.7l-0.1,0l-0.1,0l-1.4,0.7l-1,0.2l-0.6,0l0.1-4.7L283.7,126.4z	"
        >
          <title id="t1824">Colfax, NE</title>
        </path>
        <path
          id="FIPS_31039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.8,121.9l1.9,0l2.6,1l0,3.6l-3.4,0l-1.1,0L283.8,121.9z	"
        >
          <title id="t1825">Cuming, NE</title>
        </path>
        <path
          id="FIPS_31167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.8,121.9l-0.1,4.5l-2.2,0l-1.1,0l0.1-4.5L283.8,121.9z	"
        >
          <title id="t1826">Stanton, NE</title>
        </path>
        <path
          id="FIPS_31119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276,121.8l4.4,0.1l-0.1,4.5l-4.4-0.1l0-2.3L276,121.8z	"
        >
          <title id="t1827">Madison, NE</title>
        </path>
        <path
          id="FIPS_31003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276,121.8l0,2.2l-4.4-0.1l0-2.3l0.1-4.5l4.4,0.1L276,121.8z	"
        >
          <title id="t1828">Antelope, NE</title>
        </path>
        <path
          id="FIPS_31011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.6,124l4.4,0.1l0,2.3l0,2.8l-0.5,0l-1.6,0.4l-0.5,0.2l-1.8,0l0-3.4L271.6,124z	"
        >
          <title id="t1829">Boone, NE</title>
        </path>
        <path
          id="FIPS_31141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.4,126.4l1.1,0l-0.1,4.7l-1.1-0.2l-2.2,0.8l-1-0.8l-1.2-1.7l0-2.8L280.4,126.4z	"
        >
          <title id="t1830">Platte, NE</title>
        </path>

        <path
          id="FIPS_31023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.3,135.4l0.1-4.5l1.1,0.2l0.6,0l1-0.2l1.4-0.7l0.1,0l0.1,0v0l-0.1,5.3h0L280.3,135.4z	"
        >
          <title id="t1833">Butler, NE</title>
        </path>
        <path
          id="FIPS_31143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.1,131.7l2.2-0.8l-0.1,4.5l-4.4-0.1l0-1.7L278.1,131.7z	"
        >
          <title id="t1834">Polk, NE</title>
        </path>
        <path
          id="FIPS_31185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.3,135.4l-0.1,4.5l-4.4-0.1h0l0.1-4.5L280.3,135.4z	"
        >
          <title id="t1835">York, NE</title>
        </path>
        <path
          id="FIPS_31081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.8,135.4l-0.1,4.5l-4.4-0.1h0l0.1-2.3l0.5-0.6l1-1l1.2-1l0.4-0.3l0.1,0.1h0l0.2-0.1
		l0.5-0.2l0.1-0.1l0.2-0.2l0.3-0.4l0.1-0.1L275.8,135.4z	"
        >
          <title id="t1836">Hamilton, NE</title>
        </path>
        <path
          id="FIPS_31125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.5,129.6l1.8,0l0.5-0.2l1.6-0.4l0.5,0l1.2,1.7l0,1.1l-1.4,0l-1.5,0.2l-0.9,0.2l-0.4,0.2
		l-1.4,0l0.1-1.7l-0.1,0h0L271.5,129.6z	"
        >
          <title id="t1837">Nance, NE</title>
        </path>
        <path
          id="FIPS_31121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.5,130.7l0.1,0l-0.1,1.7l0.2,0l1.2,0l0.4-0.2l0.9-0.2l1.5-0.2l1.4,0l0-1.1l1,0.8l-2.3,2
		l-0.1,0.1l-0.3,0.4l-0.2,0.2l-0.1,0.1l-0.5,0.2l-0.2,0.1h0l-0.1-0.1l-0.4,0.3l-1.2,1l-1,1l-0.5,0.6l0-2.3L271.5,130.7z	"
        >
          <title id="t1838">Merrick, NE</title>
        </path>
        <path
          id="FIPS_31079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.2,135.1l4.2,0.1l0,2.3l-0.1,2.3l-4.3-0.1L267.2,135.1z	"
        >
          <title id="t1839">Hall, NE</title>
        </path>
        <path
          id="FIPS_31093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.1,130.6l4.4,0.1h0l-0.1,4.5l-4.2-0.1l-0.3,0L267.1,130.6z	"
        >
          <title id="t1840">Howard, NE</title>
        </path>
        <path
          id="FIPS_31163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267,130.6L267,130.6l-0.1,4.5l-4.4-0.1l0.2-4.5L267,130.6z	"
        >
          <title id="t1841">Sherman, NE</title>
        </path>
        <path
          id="FIPS_31015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.9,109.7l7.1,0.2l1.7,1.6l0,1.6l-1.5-0.1l-1-0.2l-1.5-0.5l-0.8-0.3l-1-0.5l-0.2-0.2
		l-0.1,0l-0.1,0l-0.1,0l-1.6,0.7l-0.8,0.3l-0.1,0.1L262.9,109.7z	"
        >
          <title id="t1842">Boyd, NE</title>
        </path>
        <path
          id="FIPS_31089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.8,112.2L262.8,112.2l0.9-0.4l1.6-0.7l0.1,0l0.1,0l0.1,0l0.2,0.2l1,0.5l0.8,0.3l1.5,0.5
		l1,0.2l1.5,0.1l-0.1,4.2l-0.1,4.5l-4.4-0.1l-4.4-0.1l-0.1,0l0.1-4.1l0-4.5L262.8,112.2z	"
        >
          <title id="t1843">Holt, NE</title>
        </path>
        <path
          id="FIPS_31175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.7,126l4.3,0.1h0.1l-0.1,4.5l-4.3-0.1L262.7,126z	"
        >
          <title id="t1844">Valley, NE</title>
        </path>
        <path
          id="FIPS_31077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.5,126.2l0,3.4l0,1.1l-4.4-0.1H267l0.1-4.5L271.5,126.2z	"
        >
          <title id="t1845">Greeley, NE</title>
        </path>
        <path
          id="FIPS_31183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.6,121.7l0,2.3l-0.1,2.2l-4.4-0.1h-0.1l0.1-4.5L271.6,121.7z	"
        >
          <title id="t1846">Wheeler, NE</title>
        </path>
        <path
          id="FIPS_31071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.6,126l0.1-4.5l4.4,0.1l-0.1,4.5L262.6,126L262.6,126z	"
        >
          <title id="t1847">Garfield, NE</title>
        </path>
        <path
          id="FIPS_31115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.7,121.5l0.1,0l-0.1,4.5l-4.4-0.2l0.2-4.5l0.2,0L262.7,121.5z	"
        >
          <title id="t1848">Loup, NE</title>
        </path>
        <path
          id="FIPS_31149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.7,121.5l-4.1-0.1l0.2-4.5h-0.1l0.1-3.8l0.7,0.2l0.5,0.1l0.2,0l0.3-0.1l2.1-0.8l0.1,0
		l0.1-0.1l0.1,0.7l0,4.5L262.7,121.5z	"
        >
          <title id="t1849">Rock, NE</title>
        </path>
        <path
          id="FIPS_31103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254,109.3l6.2,0.3l2.6,0.1l-0.1,2.5l-0.1,0.1l-0.1,0l-2.1,0.8l-0.3,0.1l-0.2,0l-0.5-0.1
		l-0.7-0.2l-0.1,0h-0.2l-0.7-0.1l-2.6-0.8l-0.5-0.2l-0.2-0.1l-0.6-0.5L254,109.3	"
        >
          <title id="t1850">Keya Paha, NE</title>
        </path>
        <path
          id="FIPS_31017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.8,113l-0.1,3.8h0.1l-0.2,4.5l-0.2,0l-4.6-0.2l0.2-4.5l-0.1-5.4l0.6,0.5l0.2,0.1l0.5,0.2
		l2.6,0.8l0.7,0.1L258.8,113L258.8,113z	"
        >
          <title id="t1851">Brown, NE</title>
        </path>
        <path
          id="FIPS_31009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.8,121.1l1,0l4.6,0.2l-0.2,4.5l-5.4-0.2l-0.1,0L252.8,121.1z	"
        >
          <title id="t1852">Blaine, NE</title>
        </path>
        <path
          id="FIPS_31041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.2,125.8l4.4,0.2l0.1,0l-0.1,4.5l-0.2,4.5l-2.1-0.1l-7.7-0.3l-0.1,0l0.1-1.5l0.1-1.3
		l0.1-1.6l-0.1-0.1l0.2-4.5L258.2,125.8z	"
        >
          <title id="t1853">Custer, NE</title>
        </path>
        <path
          id="FIPS_31019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.4,134.9l2.1,0.1l4.4,0.1l0.3,0l-0.1,4.5l0,0.1l-0.3,0l-0.7,0.1l-0.4,0.2l-0.4,0.1l-1.2,0
		l-1.4-0.1l-0.1,0l-2.3-0.2L260.4,134.9z	"
        >
          <title id="t1854">Buffalo, NE</title>
        </path>
        <path
          id="FIPS_31047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.6,134.6l7.7,0.3l-0.1,4.9l-2.2-0.3l-3.3-0.3l-2.3-0.1L252.6,134.6z	"
        >
          <title id="t1855">Dawson, NE</title>
        </path>
        <path
          id="FIPS_31137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.1,139.5l2.2,0.3l2.3,0.2l-0.1,4l-4.4-0.2l-0.1,0L258.1,139.5z	"
        >
          <title id="t1856">Phelps, NE</title>
        </path>
        <path
          id="FIPS_31099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267,139.8l-0.1,4.4l0,0l-4.4-0.1l0.1-4l0.1,0l1.4,0.1l1.2,0l0.4-0.1l0.4-0.2l0.7-0.1
		L267,139.8z	"
        >
          <title id="t1857">Kearney, NE</title>
        </path>
        <path
          id="FIPS_31001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267,139.8l0-0.1l4.3,0.1h0l-0.1,4.5l-4.3-0.1L267,139.8z	"
        >
          <title id="t1858">Adams, NE</title>
        </path>
        <path
          id="FIPS_31035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.7,139.9L275.7,139.9l-0.1,4.5l-4.4-0.1h0l0.1-4.5L275.7,139.9z	"
        >
          <title id="t1859">Clay, NE</title>
        </path>
        <path
          id="FIPS_31059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.2,139.9l-0.1,4.5l-4.4-0.1h0l0.1-4.5L280.2,139.9z	"
        >
          <title id="t1860">Fillmore, NE</title>
        </path>
        <path
          id="FIPS_31151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.2,139.9l4.4,0.1l0,2.3l-0.1,2.3l-4.4-0.1L280.2,139.9z	"
        >
          <title id="t1861">Saline, NE</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "30700"
              ? `metroArea clickedArea state-ne`
              : `metroArea ${colorCode[30700]} state-ne`
          }
          id="FIPS_30700"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_31109"
            className="FIPS_30700 st0 state-ne"
            d="M284.7,135.5l4.3,0l0,0.4l0,3l0,3.4l-4.4,0l0-2.3L284.7,135.5L284.7,135.5z	"
          >
            <title id="t1862">Lancaster, NE</title>
          </path>
          <path
            id="FIPS_31159"
            className="FIPS_30700 st0 state-ne"
            d="M284.7,135.5l-0.1,4.5l-4.4-0.1l0.1-4.5L284.7,135.5z	"
          >
            <title id="t1832">Seward, NE</title>
          </path>
        </g>
        <path
          id="FIPS_31067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289,142.3l0,3.4l0,3.4l-3.4,0l-1.1,0l0-4.5l0.1-2.3L289,142.3z	"
        >
          <title id="t1863">Gage, NE</title>
        </path>
        <path
          id="FIPS_31095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.1,144.5l4.4,0.1l0,4.5l-4.4-0.1L280.1,144.5z	"
        >
          <title id="t1864">Jefferson, NE</title>
        </path>
        <path
          id="FIPS_31169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.1,144.5l-0.1,4.5l-4.4-0.1l0.1-4.5L280.1,144.5z	"
        >
          <title id="t1865">Thayer, NE</title>
        </path>
        <path
          id="FIPS_31129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.7,144.4L275.7,144.4l-0.1,4.5l-1.1,0l-3.4-0.1l0.1-4.5L275.7,144.4z	"
        >
          <title id="t1866">Nuckolls, NE</title>
        </path>
        <path
          id="FIPS_31181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.9,144.2l4.3,0.1h0l-0.1,4.5l-2.3-0.1l-2.2-0.1L266.9,144.2L266.9,144.2z	"
        >
          <title id="t1867">Webster, NE</title>
        </path>
        <path
          id="FIPS_31061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.9,144.2l-0.1,4.5l-3.3-0.1l-1.1,0l0.1-4.5L266.9,144.2z	"
        >
          <title id="t1868">Franklin, NE</title>
        </path>
        <path
          id="FIPS_31083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258,143.9l4.4,0.2l-0.1,4.5l-4.4-0.2h0L258,143.9z	"
        >
          <title id="t1869">Harlan, NE</title>
        </path>
        <path
          id="FIPS_31073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.1,139.5l-0.2,4.3l-4.4-0.2l0-1.1l1.1,0.1l0.1-3.4L258.1,139.5z	"
        >
          <title id="t1870">Gosper, NE</title>
        </path>
        <path
          id="FIPS_31065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.5,143.7l1,0l4.4,0.2l0.1,0l-0.1,4.5l-5.4-0.2l-0.2,0L252.5,143.7z	"
        >
          <title id="t1871">Furnas, NE</title>
        </path>
        <path
          id="FIPS_31145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247,143.4l5.5,0.3l-0.2,4.5l-5.3-0.3l-0.2,0L247,143.4z	"
        >
          <title id="t1872">Red Willow, NE</title>
        </path>
        <path
          id="FIPS_31087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.5,143.1l5.3,0.3l0.2,0l-0.2,4.5l-5.5-0.3L241.5,143.1z	"
        >
          <title id="t1873">Hitchcock, NE</title>
        </path>
        <path
          id="FIPS_31057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.3,143.1l0.2,0l-0.3,4.5l-0.9,0l-6.3-0.4l0.3-4.5L241.3,143.1z	"
        >
          <title id="t1874">Dundy, NE</title>
        </path>
        <path
          id="FIPS_31063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.1,138.9l5.4,0.3l2.3,0.1l-0.1,3.4l-1.1-0.1l0,1.1l-1,0l-5.5-0.3l-0.2,0L247.1,138.9z	"
        >
          <title id="t1875">Frontier, NE</title>
        </path>
        <path
          id="FIPS_31085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.1,138.9l-0.2,4.6l-5.3-0.3l-0.2,0l0.2-4.5l0.9,0.1L247.1,138.9z	"
        >
          <title id="t1876">Hayes, NE</title>
        </path>
        <path
          id="FIPS_31029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234.7,138.2l6.9,0.4l-0.2,4.5l-6.9-0.4L234.7,138.2z	"
        >
          <title id="t1877">Chase, NE</title>
        </path>
        <path
          id="FIPS_31135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235,134.2L235,134.2l7.7,0.4l-0.2,4l-0.9-0.1l-6.9-0.4l0-0.7L235,134.2z	"
        >
          <title id="t1878">Perkins, NE</title>
        </path>
        <path
          id="FIPS_31111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.1,129.9l4.4,0.2l0.1,0.1l-0.1,1.6l-0.1,1.3l-0.1,1.5l0.1,0l-0.2,4.5l-5.4-0.3l-4.6-0.2
		l0.2-4l0.1-5.1L248.1,129.9z	"
        >
          <title id="t1879">Lincoln, NE</title>
        </path>
        <path
          id="FIPS_31101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.9,129.2l5.5,0.3l1.3,0.1l-0.1,5.1l-7.7-0.5l0.1-2.8L235.9,129.2z	"
        >
          <title id="t1880">Keith, NE</title>
        </path>
        <path
          id="FIPS_31113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.4,125.4l4.3,0.2l0.1,0l-0.2,4.5l-4.4-0.2L248.4,125.4z	"
        >
          <title id="t1881">Logan, NE</title>
        </path>
        <path
          id="FIPS_31117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.7,125l2.5,0.1l1.7,0.1l1.3,0.1l1.2,0.1l-0.2,4.5l-5.3-0.3l-1.3-0.1L241.7,125z	"
        >
          <title id="t1882">McPherson, NE</title>
        </path>
        <path
          id="FIPS_31005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.2,124.7l5.4,0.3l0.2,0l-0.3,4.5l-5.5-0.3L236.2,124.7z	"
        >
          <title id="t1883">Arthur, NE</title>
        </path>
        <path
          id="FIPS_31171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.3,120.8l5.5,0.3l-0.2,4.5l-4.3-0.2l-1.2-0.1L247.3,120.8z	"
        >
          <title id="t1884">Thomas, NE</title>
        </path>
        <path
          id="FIPS_31091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.8,120.5l5.5,0.3l-0.2,4.5l-1.3-0.1l-1.7-0.1l-2.5-0.1l-0.2,0L241.8,120.5z	"
        >
          <title id="t1885">Hooker, NE</title>
        </path>
        <path
          id="FIPS_31075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.6,121.2l0.6-1.1l5.5,0.4l-0.3,4.5l-5.4-0.3l-0.8,0L235.6,121.2z	"
        >
          <title id="t1886">Grant, NE</title>
        </path>
        <path
          id="FIPS_31049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.8,131l5.3,0.4l-0.1,2.8l0,0l-5.5-0.4L229.8,131z	"
        >
          <title id="t1887">Deuel, NE</title>
        </path>
        <path
          id="FIPS_31069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.6,121.2l-0.2,3.5l0.8,0l-0.3,4.5l-0.8,2.2l-5.3-0.4l-0.1-2.8l0.2-3.2l-0.2-0.7l-0.1-0.4
		l0-0.2l0-0.7l0.2-2.1L235.6,121.2z	"
        >
          <title id="t1888">Garden, NE</title>
        </path>
        <path
          id="FIPS_31033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.7,128.2l0.1,2.8l-0.3,2.8l-0.3,0l-7-0.5l0.4-5.1l0.1-0.6L229.7,128.2z	"
        >
          <title id="t1889">Cheyenne, NE</title>
        </path>
        <path
          id="FIPS_31123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.6,120.8l0.2,0l-0.2,2.1l0,0.7l0,0.2l0.1,0.4l0.2,0.7l-0.2,3.2l-7-0.5l0.2-3.4l0.4-3.9
		L229.6,120.8z	"
        >
          <title id="t1890">Morrill, NE</title>
        </path>
        <path
          id="FIPS_31105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.6,128.2l-0.4,5.1l-1.9-0.1l-4.6-0.4l0.4-5.1L222.6,128.2z	"
        >
          <title id="t1891">Kimball, NE</title>
        </path>
        <path
          id="FIPS_31007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,124.3l-0.2,3.4l-0.1,0.6l-6.5-0.5l0.3-3.9L222.9,124.3z	"
        >
          <title id="t1892">Banner, NE</title>
        </path>
        <path
          id="FIPS_31157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,120.3l0.4,0l-0.4,3.9l-6.5-0.5l0.3-3.9L222.9,120.3z	"
        >
          <title id="t1893">Scotts Bluff, NE</title>
        </path>
        <path
          id="FIPS_31013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.6,120.8l-6.3-0.4l-0.4,0l0.1-1.1l-0.4,0l0.3-4.5l6.4,0.4l0.2,0l-0.3,4.5l0.2,0.4
		L229.6,120.8z	"
        >
          <title id="t1894">Box Butte, NE</title>
        </path>
        <path
          id="FIPS_31031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.3,108.3l1.9,0.1l2.3,0.2l3.7,0.2l3,0.2l3.4,0.2l1.8,0.1l0.7,0l0.7,0l-0.1,2l0.1,5.4
		l-0.2,4.5l-1,0l-5.5-0.3l-5.5-0.3l-5.5-0.4l-0.3,0l0.3-4.5l-0.1-1.5l0.1-3l0-0.9L236.3,108.3z	"
        >
          <title id="t1895">Cherry, NE</title>
        </path>
        <path
          id="FIPS_31161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.3,108.3l-0.1,1.8l0,0.9l-0.1,3l0.1,1.5l-0.3,4.5l0.3,0l-0.6,1.1l-5.8-0.3l-0.2,0
		l-0.1-0.8l-0.2-0.4l0.3-4.5l-0.2,0l0.3-3.7l-0.1-0.8l0.2-2.8L236.3,108.3z	"
        >
          <title id="t1896">Sheridan, NE</title>
        </path>
        <path
          id="FIPS_33007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M517.4,50.8l0.3,1l1.9,5.8l0.1,0.4l1.7,5.4l-0.1,0.7l-2.6,1.7l-0.7-0.4l-0.4-0.4l-0.3-0.1
		l-1.2-0.3l-1-0.2l-0.9-0.7l0.2,0l0.3-0.2l0,0l0.1-0.2l0.1-0.1l0-0.1l0.4-0.8l0-0.1v0l0.1-0.3l0.1-1.1l-0.2-0.4l0-0.1l-0.2-0.3
		l-0.4-0.5l-0.3-0.3l-0.1-0.2l0-3.2l0.2-0.4l-0.1-0.8l0.2-2.3l0.7-0.9l0.1-0.1l0.2,0.1l0.1,0.2l0,0l0.3,0.1l0.5,0l0.4-0.1l0.1,0
		L517.4,50.8z	"
        >
          <title id="t1897">Coos, NH</title>
        </path>
        <path
          id="FIPS_33009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M513.8,64.4l0.6-0.8l0.9,0.7l1,0.2l1.2,0.3l0.3,0.1l0.4,0.4l0.4,0.6l0.6,1l0.4,2l-1.7,0.8
		l0.5,1.2l0.2,0.4l0.3,0.8l-1.1,0.8l-0.3,1.4l-0.5,0.2l-0.7-0.5l-0.3,0.6l-0.2,0.7l-0.6,0l-1,0l-1-0.2l-1.1,0.1l0.6-2.4l0.2-5.2
		l-0.2-0.1l-0.2-0.2l-0.3-1V66l0-0.1l0.3-0.5l0,0l0,0l0.6-0.4L513.8,64.4z	"
        >
          <title id="t1898">Grafton, NH</title>
        </path>

        <path
          id="FIPS_33005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M512.2,80.8l0.3,0.3L513,81l0-0.3l0.2-0.1l1.5-0.6l0,0.5l0,0.2l1.3-0.3l0.2,1.4l0.2,0.9
		l0.5-0.1l1.1,1.8l0.4,0.9l-3.3,0.7l-1.6,0.3l-1-0.8l-0.3-0.6l0-0.1l0.6-2l-0.2-1.4l0-0.1L512.2,80.8z	"
        >
          <title id="t1901">Cheshire, NH</title>
        </path>
        <path
          id="FIPS_33019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M511.9,75.1L513,75l1,0.2l1,0l0.6,0l-0.6,1.7L515,78l0.4,0.8l0.3,0.3l0.4,0.4l-0.1,0.8
		l-1.3,0.3l0-0.2l0-0.5l-1.5,0.6l-0.2,0.1l0,0.3l-0.6,0.1l-0.3-0.3l0-1l0-1.1l-0.2-0.5l-0.4-2.1L511.9,75.1z	"
        >
          <title id="t1902">Sullivan, NH</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "31700"
              ? `metroArea clickedArea state-nh`
              : `metroArea ${colorCode[31700]} state-nh`
          }
          id="FIPS_31700"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_33011"
            className="FIPS_31700 st0 state-nh"
            d="M516.1,79.5l0.8-0.5l2.4,0.1l1.8,0.9l1.2,0.2l-0.3,1.1l0.2,0.5l0.3,0.7l0.9,0.6l1.1,0.1
		l-0.1,0.1l-0.2,0.6l-3.1,0.7l0,0l-0.1,0l-2.3,0.5l-0.3,0.1l-0.4-0.9l-1.1-1.8l-0.5,0.1l-0.2-0.9l-0.2-1.4L516.1,79.5z	"
          >
            <title id="t1903">Hillsborough, NH</title>
          </path>
        </g>
        <path
          id="FIPS_33001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M518.6,71.1l0.8,0.5l2.3,1.3l1,0.2l-0.2,0.4l0.4,0.9l0.4,1l-0.4,1.1l-1.2-0.5l-2.2-0.8
		l-0.4,0.3l-0.1,0l-0.8-0.6l-0.2-0.1l-0.5-0.5l0.3-1.4l1.1-0.8L518.6,71.1z	"
        >
          <title id="t1904">Belknap, NH</title>
        </path>
        <path
          id="FIPS_33013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M517.5,74.1l0.5,0.5l0.2,0.1l0.8,0.6l0.1,0l0.4-0.3l2.2,0.8l1.2,0.5l-0.1,0.2l-0.4,3.7
		l-1.2-0.2l-1.8-0.9L517,79l-0.8,0.5l-0.4-0.4l-0.3-0.3L515,78l0.1-1.2l0.6-1.7l0.2-0.7l0.3-0.6l0.7,0.5L517.5,74.1z	"
        >
          <title id="t1905">Merrimack, NH</title>
        </path>
        <path
          id="FIPS_33003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M521.5,63.4l1.8,6.1l1.1,3l-0.3,0.6l-1,0.3l-0.4-0.8l-0.2,0.5l-1-0.2l-2.3-1.3l-0.8-0.5
		l-0.2-0.4l-0.5-1.2l1.7-0.8l-0.4-2l-0.6-1l-0.4-0.6l0.7,0.4l2.6-1.7L521.5,63.4z	"
        >
          <title id="t1906">Carroll, NH</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "35620"
              ? `metroArea clickedArea state-ny state-nj state-pa`
              : `metroArea ${colorCode[35620]} state-ny state-nj state-pa`
          }
          id="FIPS_35620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_34003"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M502.1,110.4l3.4,1l0,1.1l0,0.5l-0.3,1.2l-1.5,0.5l0.1-0.5l0,0l0.1-0.5l0-0.1l-0.4-0.7
		l-0.2-0.3l-0.4-0.3l-1-0.4L502.1,110.4z	"
          >
            <title id="t1913">Bergen, NJ</title>
          </path>
          <path
            id="FIPS_34013"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M502.3,113.5l1.6,0.7l-0.1,0.5l0.4,1.4l-2.4-0.3L502.3,113.5z	"
          >
            <title id="t1910">Essex, NJ</title>
          </path>
          <path
            id="FIPS_34017"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M505.2,114.1l-0.1,1.2l-0.1,0.4l-1,0.8l0.1-0.4l-0.4-1.4L505.2,114.1z	"
          >
            <title id="t1912">Hudson, NJ</title>
          </path>
          <path
            id="FIPS_34019"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M496.7,116.2l1.7,0.5l0.1,0l0.1,0.1l0.4,1l-0.1,0.8l-0.1,0.1l-0.2,0.7l0.4,0.9l0.1,0.1
		l-0.5,0.3l-0.3,0.9l-0.7,0.2h-0.1l-0.1,0l-0.9-0.6l-0.7-1.5l-1.4-0.6l0.2-0.4l0.9-1.1l0.5-0.6l0.1-0.1l0.4-0.8L496.7,116.2z	"
          >
            <title id="t1920">Hunterdon, NJ</title>
          </path>
          <path
            id="FIPS_34023"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M503.8,117.2L503.8,117.2l0,0.2l0,0.2l0,0.1h-0.1l-0.1,0l-0.1,0.2l0,0.1l0.1,0.3l-0.1,0.3l0,0
		l0,0.1l0.1,0.2l0.1,0.1l0.3,0h0l-1.8,3.1l-1.6-1.2l0.1,0l0.1-0.1l0.9-1.6l0-0.3l-0.2-0.1l-0.2-0.2l-0.3-0.3l0-0.1l0.1-0.2l0.1-0.1
		l0.4-0.3l0.2,0l1.2-0.4l0.4,0l0.1,0L503.8,117.2z	"
          >
            <title id="t1914">Middlesex, NJ</title>
          </path>
          <path
            id="FIPS_34025"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M503.9,119l1.6-0.1l0.4-0.6l0,0l0,0h0.1l0.1,0.1l0.2,0.3l0.3,0.9l0.1,0.3l0,0l0.1,0.6l0,0.3
		l0,0.6l0,1.8l-1.3,0.2l-0.3,0l-0.8-0.6l-1.4,0.3l-1.1,1.5l-0.5-0.7l-0.4-0.5l0.5-0.4l0.6-0.7v0l-0.1-0.1L503.9,119z	"
          >
            <title id="t1907">Monmouth, NJ</title>
          </path>
          <path
            id="FIPS_34027"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M499.5,111.6l0.9,0.6l0.6,0l0.6,0l0.6,1.3l-0.5,2.2l-0.6,1l-0.5,0.5l-0.5-1.1l0-0.1l-0.1-0.1
		l0,0l-1.5,0.9l-1.7-0.5l0.8-1.8L499.5,111.6z	"
          >
            <title id="t1916">Morris, NJ</title>
          </path>
          <path
            id="FIPS_34029"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M502,124.5l1.1-1.5l1.4-0.3l0.8,0.6l0.3,0l1.3-0.2l0,0.2l0.1,1.1l0,0.3l0.1,0.9l0.2,1.4l0,0.5
		l0,0.1l-0.2,1l-0.5,1.9l-0.2,0.6l-0.3,0.3l-1.2-0.5l0.1-0.2l0-0.3l-0.5-2.2l-2.3-3.3L502,124.5z	"
          >
            <title id="t1908">Ocean, NJ</title>
          </path>

          <path
            id="FIPS_34035"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M501.1,116.7l0.2,1l-0.4,0.3l-0.1,0.1l-0.1,0.2l0,0.1l0.3,0.3l0.2,0.2l0.2,0.1l0,0.3l-0.9,1.6
		l-0.1,0.1l-0.1,0l-0.1-0.1l-0.3,0l-0.6,0.4l-0.4-0.6l-0.1-0.1l-0.4-0.9l0.2-0.7l0.1-0.1l0.1-0.8l-0.4-1l-0.1-0.1l-0.1,0l1.5-0.9
		l0,0l0.1,0.1l0,0.1l0.5,1.1L501.1,116.7z	"
          >
            <title id="t1915">Somerset, NJ</title>
          </path>

          <path
            id="FIPS_34031"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M501.9,110.3l0.2,0.1l-0.2,1.5l1,0.4l0.4,0.3l0.2,0.3l0.4,0.7l0,0.1l-0.1,0.5l0,0l-1.6-0.7
		l-0.6-1.3l-0.6,0l-0.6,0l-0.9-0.6l1-1.8L501.9,110.3z	"
          >
            <title id="t1917">Passaic, NJ</title>
          </path>
          <path
            id="FIPS_34037"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M500.5,109.8l-1,1.8l-2,2.8l-2.4-1.9l-0.1-0.1l0.4-0.5l0.3-0.6l0.1-0.4l0-0.2l0,0l0-0.2
		l0.1-0.5l0-0.1l0.2-0.5l0.3-0.3l0.6-0.4L500.5,109.8z	"
          >
            <title id="t1918">Sussex, NJ</title>
          </path>
          <path
            id="FIPS_34039"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M501.8,115.7l2.4,0.3l-0.1,0.4l-0.2,0l0,0l0,0l-0.1,0.2l0.1,0.5l-0.4,0l-0.1,0l-0.4,0
		l-1.2,0.4l-0.2,0l-0.2-1L501.8,115.7z	"
          >
            <title id="t1911">Union, NJ</title>
          </path>
          <path
            id="FIPS_36005"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M505.5,112.4l1.4,0.2l0.2,1l-0.9,0.3l-0.1-0.7l-0.6-0.3L505.5,112.4z	"
          >
            <title id="t2027">Bronx, NY</title>
          </path>
          <path
            id="FIPS_36047"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M505.2,115.6l0.7-0.6l0.2,0.1l0.3,0.7l-0.1,1.2l-0.6,0l-0.4-0.6L505.2,115.6z	"
          >
            <title id="t2028">Kings, NY</title>
          </path>
          <path
            id="FIPS_36059"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M511.1,115.2l-3.1,1l-0.8-2.7l2.2-2.1L511.1,115.2z	"
          >
            <title id="t2030">Nassau, NY</title>
          </path>
          <path
            id="FIPS_36061"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M506.2,113.9L506.2,113.9l-0.2,1l-0.1,0.1l-0.7,0.6l-0.1-0.3l0.1-1.2l0.3-1.2l0.6,0.3
		L506.2,113.9z	"
          >
            <title id="t2025">New York, NY</title>
          </path>
          <path
            id="FIPS_36079"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M507.4,103.9l0.4,2.1l-4,1.5v0l-0.3-1.4l0.3-0.7l3.2-1.3L507.4,103.9z	"
          >
            <title id="t2035">Putnam, NY</title>
          </path>
          <path
            id="FIPS_36081"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M506.2,113.9l0.9-0.3l0.2,0l0.8,2.7l-1.7,0.7l0.1-1.2l-0.3-0.7l-0.2-0.1l0.1-0.1L506.2,113.9
		L506.2,113.9z	"
          >
            <title id="t2032">Queens, NY</title>
          </path>
          <path
            id="FIPS_36085"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M504.5,117.8L504.5,117.8l-0.1,0.1l-0.1,0.1l0,0l-0.1,0.2l-0.1,0.1l-0.1,0.1l-0.2,0.1l-0.1,0
		l0-0.1l0-0.1l0.1-0.1l0-0.2l0-0.1l0.2-0.2l0-0.2l0-0.2l0-0.1l0-0.1l0.1-0.2l0.1-0.2l0.1-0.1l0.2-0.1l0.3-0.2l0.1,0l0.1,0.1l0.1,0.2
		l0.2,0.2l0,0.1l-0.4,0.7L504.5,117.8L504.5,117.8z	"
          >
            <title id="t1909">Richmond, NY</title>
          </path>
          <path
            id="FIPS_36087"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M503.7,107.5l0.3,0.7l0.6,0.8l0.5,0.6l0.1,0.1l0.3,1.7l-3.4-1l-0.2-0.1L503.7,107.5
		L503.7,107.5z	"
          >
            <title id="t2029">Rockland, NY</title>
          </path>
          <path
            id="FIPS_36103"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M511.1,115.2l-1.6-3.8l0-0.2l0.1-0.1l0.8-0.3l1.8,0.2l5.8-2.7l1.5-1.7l0.5-0.3l2.6,0.9
		l-0.1,0.3l-2.3,2l-0.6,0.5l-5,3.6l-0.8,0.5l-0.6,0.3l-0.3,0.1l-0.2,0.1L511.1,115.2	"
          >
            <title id="t2033">Suffolk, NY</title>
          </path>
          <path
            id="FIPS_36119"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M503.7,107.5l4-1.5l0.2,0.9l-0.3,2.1l-0.1,0.1l-0.7,0.7l1,1.3l-0.9,1.6l-1.4-0.2l0-1.1
		l-0.3-1.7l-0.1-0.1l-0.5-0.6l-0.6-0.8L503.7,107.5z	"
          >
            <title id="t2034">Westchester, NY</title>
          </path>
          <path
            id="FIPS_42103"
            className="FIPS_35620 st0 state-ny state-nj state-pa"
            d="M492.8,106l0.3,0.6l0.4,0.4l0.3,0.3l1,0.5l0.2,0.1l0.8,0l0.4,0l0.8,0.8l-0.6,0.4l-0.3,0.3
		l-0.2,0.5l0,0.1l-0.1,0.5l0,0.2l0,0l0,0.2l-0.1,0.4l-0.3,0.6l-0.4,0.5l-0.1,0.2l-0.3,0.2l-1.4-0.6l0-1.4l-2.1,0.7l0.2-1.2l0.9-2.1
		L492.8,106z	"
          >
            <title id="t2301">Pike, PA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45940"
              ? `metroArea clickedArea state-nj`
              : `metroArea ${colorCode[45940]} state-nj`
          }
          id="FIPS_45940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_34021"
            className="FIPS_45940 st0 state-nj"
            d="M499.1,120.5l0.4,0.6l0.6-0.4l0.3,0l0.1,0.1l1.6,1.2l0.1,0.1v0l-0.6,0.7l-0.5,0.4l0.4,0.5
		l-1.3,0.2l-2.6-2h0.1l0.7-0.2l0.3-0.9L499.1,120.5z	"
          >
            <title id="t1921">Mercer, NJ</title>
          </path>
        </g>

        <path
          id="FIPS_34011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M501.2,134.7l-0.1,2l-2,0l-0.7-0.2l-1.3-0.4l-1.2-0.7l-0.1-0.1l-0.2-0.2l0.2-1l1-1.6l1.8,1
		l0-0.1v-0.3l-0.1-1.1l0.9,0.5L501.2,134.7z	"
        >
          <title id="t1925">Cumberland, NJ</title>
        </path>
        <path
          id="FIPS_34009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M501.2,134.7l3.1-0.4l-0.4,0.6l-0.1,0.2l-0.1,0.3l-0.2,0.6l-0.2,0.9v0l0,0l0,0l-0.4,1.3
		l-0.3,0.6l-0.3,0.6l-0.5,0.3l-0.1,0l-0.3,0l0,0l-0.1-0.1l0-0.8l0-0.2l0-0.3l0.2-0.7l0-0.2l0-0.2l0-0.4l-0.1-0.2l-0.2-0.2l-0.1,0
		L501.2,134.7z	"
        >
          <title id="t1926">Cape May, NJ</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12100"
              ? `metroArea clickedArea state-nj`
              : `metroArea ${colorCode[12100]} state-nj`
          }
          id="FIPS_12100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_34001"
            className="FIPS_12100 st0 state-nj"
            d="M506,131.3l-1.6,3l-3.1,0.4l-1.7-2.2l0.8-1.4l1-1.8l0.1,0.1l0.6,0.3l0.7,0.7l0.9,0.4l0.2,0.1
		l0.4,0.1l0.6-0.1L506,131.3z	"
          >
            <title id="t1927">Atlantic, NJ</title>
          </path>
        </g>

        <path
          id="FIPS_35025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M218.1,229.8l-0.2,2.4l-0.5,5.5l-0.8,11.2l-0.1,1.1l-0.3,0l-0.6,0l-0.8-0.1l-0.6,0l-0.6-0.1
		l-4.3-0.3l0.6-6.7l-1-0.1l0.5-5.7l0.5,0l0.5-5.6l0.7-2.2l2.2,0.2L218.1,229.8z	"
        >
          <title id="t1929">Lea, NM</title>
        </path>
        <path
          id="FIPS_35015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M197.7,241.8l0.1,0l0.5-5.7l11,0.9l-0.5,5.7l1,0.1l-0.6,6.7l-2.8-0.2l-0.5,0l-8.9-0.8l0.3-3.2
		l0,0L197.7,241.8z	"
        >
          <title id="t1930">Eddy, NM</title>
        </path>
        <path
          id="FIPS_35028"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M187.5,195.8l0,0.5l-0.1,1l-0.3,0l0.3,0.2l0,0l-0.1,1.1l-0.1-0.3l-0.2-0.2l-0.4-0.2l-0.3-0.2
		l-0.1,0.1l-0.2,0l-0.2,0l-0.1-0.1l-0.1-0.1l0.3-1.3l0.2-0.4l0.9-0.1l0.4,0L187.5,195.8z	"
        >
          <title id="t1931">Los Alamos, NM</title>
        </path>
        <path
          id="FIPS_35039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177,181.1l4.3,0.5l1.3,0.3l2.6,0.3l1.4,0.2l4.8,0.5l0.1,0.9l-0.1,1.4l-0.1,2.8l0.1,0.8l0,0.8
		l0,0.3l-0.3,1.3l-0.1,0.2l-0.1,0.1l-0.3,0.1l-0.3,0l-0.1,0l-0.2,0.2l0,0.1l2,1.1l0.8,1.4l0.1,0.2l0.1,0.2l2,1.3l-2,0.2l0-0.3
		l-3.6-0.4l0,0.2l0.1,0l0,0.1l-0.1,0.7l-2-0.2l0-0.5l0-0.1l0-0.4l-6.6-0.7l0.2-1.5l0.2-1.3l-3.6-0.4l-4-0.5l0.4-3l0.1-1l0.5-3.4
		l0.3-0.5l1.6-1.4L177,181.1z	"
        >
          <title id="t1932">Rio Arriba, NM</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22140"
              ? `metroArea clickedArea state-nm`
              : `metroArea ${colorCode[22140]} state-nm`
          }
          id="FIPS_22140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_35045"
            className="FIPS_22140 st0 state-nm"
            d="M167.3,179.9l9.1,1.1l0.6,0.1l-0.4,0.6l-1.6,1.4l-0.3,0.5l-0.5,3.4l-0.1,1l-0.4,3l-0.4,2.8
		l-4.8-0.6l-9.8-1.3l1.8-12.8L167.3,179.9z	"
          >
            <title id="t1933">San Juan, NM</title>
          </path>
        </g>
        <path
          id="FIPS_35031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M158.7,191.8l9.8,1.3l4.8,0.6l3.3,0.4l-1.1,8.9l-2.4-0.3l-0.9-0.1l-1.1-0.1l-7.6-1l0,0.2
		l-0.6,4.3l-6-0.8L158.7,191.8z	"
        >
          <title id="t1934">McKinley, NM</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "10740"
              ? `metroArea clickedArea state-nm`
              : `metroArea ${colorCode[10740]} state-nm`
          }
          id="FIPS_10740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_35001"
            className="FIPS_10740 st0 state-nm"
            d="M176.6,204.4l2.4,0.3l2.1,0.2l1.7,0.2l2.5,0.3l1.2,0.2l-0.2,2.3l-0.1,1.1l1,0.1l-0.1,1.1
		l-0.8-0.1l-1.9-0.2l0-0.3l-0.1-0.1l-0.1,0l-2.6-0.3l-0.3,0.3l-0.1,0.1l-3.2-0.4l-0.3-1.2L176.6,204.4z	"
          >
            <title id="t1935">Bernalillo, NM</title>
          </path>
          <path
            id="FIPS_35061"
            className="FIPS_10740 st0 state-nm"
            d="M177.5,207.9l0.3,1.2l3.2,0.4l0.1-0.1l0.3-0.3l2.6,0.3l0.1,0l0.1,0.1l0,0.3l-0.6,0.7l-0.4,2.6
		l-0.1,1.1l0.6,0.1l-0.1,1.1l-0.8-0.3l-2.8-1.3l-1.1-0.7l-0.3,0l-3.1-0.3l0.6-4.9L177.5,207.9z	"
          >
            <title id="t1936">Valencia, NM</title>
          </path>
          <path
            id="FIPS_35043"
            className="FIPS_10740 st0 state-nm"
            d="M173.7,190.9l4,0.5l3.6,0.4l-0.2,1.3l-0.2,1.5l6.6,0.7l0,0.4l0,0.1l-0.2-0.1l-0.4,0l-0.9,0.1
		l-0.2,0.4l-0.3,1.3l0.1,0.1l0.1,0.1l0.2,0l0.2,0l0.1-0.1l0.3,0.2l0.4,0.2l0.2,0.2l0.1,0.3l-0.7,7l-1.2-0.2l-2.5-0.3l-1.7-0.2
		l-2.1-0.2l-2.4-0.3l-1.1-1.2l1.1-8.9l-3.3-0.4L173.7,190.9z M187.3,197.5L187.3,197.5l-0.3-0.2l0.3,0L187.3,197.5z	"
          >
            <title id="t1961">Sandoval, NM</title>
          </path>
          <path
            id="FIPS_35057"
            className="FIPS_10740 st0 state-nm"
            d="M191.7,208.4l4.4,0.4l-0.5,5.6l-0.2,0l-0.3,3.4l-0.1,1.1l-6.4-0.7l-5.2-0.6l0.2-2.3l0.1-1.1
		l-0.6-0.1l0.1-1.1l0.4-2.6l0.6-0.7l1.9,0.2l0.8,0.1l0.1-1.1l-1-0.1l0.1-1.1L191.7,208.4z	"
          >
            <title id="t1948">Torrance, NM</title>
          </path>
        </g>

        <path
          id="FIPS_35006"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M176.6,204.4l1,3.5l-1.4-0.2l-0.6,4.9l-5.5-0.7l-0.7-0.1l-3.5-0.5l-2.5-0.3l-7.1-1l0.7-4.9
		l6,0.8l0.6-4.3l0-0.2l7.6,1l1.1,0.1l0.9,0.1l2.4,0.3L176.6,204.4z	"
        >
          <title id="t1937">Cibola, NM</title>
        </path>
        <path
          id="FIPS_35051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M168.4,226.1l7,0.8l1.2,0.2l3.4,0.4l1.5,0.2l1.2,0.1l0.2,1.2l-0.4,4.4l-6.2,2.3l-0.1,0.6
		l-4.4-0.5l-0.3,2.2l-3.3-0.4l-1.1-0.4l-0.2-0.1l0-0.1l0.1-0.2l0.2-0.8l0.1-0.5l0-0.2l-0.6-5.3l0-0.1l-0.1-0.2l-0.1,0l-1.4-0.2
		l0.5-3.6L168.4,226.1z	"
        >
          <title id="t1938">Sierra, NM</title>
        </path>
        <path
          id="FIPS_35053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M175.5,212.6l3.1,0.3l0.3,0l1.1,0.7l2.8,1.3l0.8,0.3l-0.2,2.3l5.2,0.6l-0.4,3.3l-0.2,2.3
		l-1.4-0.1l-0.2,2.3l-1-0.1l-0.1,0l-1.2-0.2l-1.1-0.1l-0.2,2.3l-1.2-0.1l-1.5-0.2l-3.4-0.4l-1.2-0.2l-7-0.8l0.3-2.1l0.9-8l-0.1,0
		l0.4-3.1l0.1-1L175.5,212.6z	"
        >
          <title id="t1939">Socorro, NM</title>
        </path>
        <path
          id="FIPS_35003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M170,211.9l-0.1,1l-0.4,3.1l0.1,0l-0.9,8l-0.3,2.1l-3.1-0.4l-0.5,3.6l-4.8-0.6l-1-0.2
		l-1.1-0.2l-4.3-0.6l2.4-17.6l7.1,1l2.5,0.3l3.5,0.5L170,211.9z	"
        >
          <title id="t1940">Catron, NM</title>
        </path>
        <path
          id="FIPS_35017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153.8,227.7l4.3,0.6l1.1,0.2l1,0.2l4.8,0.6l1.4,0.2l0.1,0l0.1,0.2l0,0.1l0.6,5.3l0,0.2
		l-0.1,0.5l-0.2,0.8l-0.1,0.2l0,0.1l0.2,0.1l1.1,0.4l-3.4-0.4l-0.1,1.1l-3.3-0.4l-0.7,5.6l0,0.7l-0.1,1.4l-0.1,0.7l-3.3-0.4l0.4-4.1
		l0.6-4.3l-1-1.3l-2.2-0.3l0.3-2.2l-2.1-0.3L153.8,227.7z	"
        >
          <title id="t1941">Grant, NM</title>
        </path>
        <path
          id="FIPS_35023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153,233.2l2.1,0.3l-0.3,2.2l2.2,0.3l1,1.3l-0.6,4.3l-0.4,4.1l3.3,0.4l0,1l-0.5,3.6l-0.3,2.1
		l-7-0.9l-0.1,0l-0.9-0.1l-1.2-0.2l2-14L153,233.2z	"
        >
          <title id="t1942">Hidalgo, NM</title>
        </path>
        <path
          id="FIPS_35029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M171.5,237.9l-1.2,10.6l-9.9-1.2l0-1l0.1-0.7l0.1-1.4l0-0.7l0.7-5.6l3.3,0.4l0.1-1.1l3.4,0.4
		L171.5,237.9z	"
        >
          <title id="t1943">Luna, NM</title>
        </path>
        <path
          id="FIPS_35013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M182.4,233.3l-0.1,1.2l-0.4,0l-1.4,12.3l-2.4-0.3l0,0h0v0l-0.2,0.6l0,0.1l-0.3,1.1l0,0.1
		l0.1,0.1l0.8,0.9l-8.3-1l1.2-10.6l0.3-2.2l4.4,0.5l0.1-0.6L182.4,233.3z	"
        >
          <title id="t1944">Doña Ana, NM</title>
        </path>
        <path
          id="FIPS_35055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M194.3,183.1l5.1,0.5l0,0.8l-0.3,2.1l-0.6,0.6l-0.4,0.1l-0.3,0.1l-0.2,0.2l-0.1,0.9l0,0.7
		l0.1,1.3l-0.2,2.5l-2.3,3l-2-1.3l-0.1-0.2l-0.1-0.2l-0.8-1.4l-2-1.1l0-0.1l0.2-0.2l0.1,0l0.3,0l0.3-0.1l0.1-0.1l0.1-0.2l0.3-1.3
		l0-0.3l0-0.8l-0.1-0.8l0.1-2.8l0.1-1.4l-0.1-0.9L194.3,183.1z	"
        >
          <title id="t1945">Taos, NM</title>
        </path>
        <path
          id="FIPS_35049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M187.4,196.3l2,0.2l0.1-0.7l0-0.1l-0.1,0l0-0.2l3.6,0.4l0,0.3l-0.2,1.4l-1,10.7l-5.5-0.6
		l0.2-2.3l0.7-7l0.1-1.3L187.4,196.3z	"
        >
          <title id="t1946">Santa Fe, NM</title>
        </path>
        <path
          id="FIPS_35035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M182.8,228.9l3.7,0.4l2.9,0.3l-0.1,1.1l4.3,0.4l-0.2,2.2l-0.2,1.5l-0.2,0.7l-0.3,1.1l-0.5,4.6
		l2.2,0.2l0.4,0l2.8,0.3l-0.3,3.4l0,0l-0.3,3.2l-0.8-0.1l-11.7-1.2l-4.1-0.4l1.4-12.3l0.4,0l0.1-1.2L182.8,228.9z	"
        >
          <title id="t1947">Otero, NM</title>
        </path>

        <path
          id="FIPS_35027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M195,217.7l4.4,0.4l-0.3,3.3l-0.3,3.4h0l0,0l-0.5,4.8l-0.5,4l-1.1,0l-3.3-0.3l0.2-2.2
		l-4.3-0.4l0.1-1.1l-2.9-0.3l-3.7-0.4l-0.2-1.2l0.2-2.3l1.1,0.1l1.2,0.2l0.1,0l1,0.1l0.2-2.3l1.4,0.1l0.2-2.3l0.4-3.3l6.4,0.7
		L195,217.7z	"
        >
          <title id="t1949">Lincoln, NM</title>
        </path>
        <path
          id="FIPS_35007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M200,183.7l1.6,0.2l2.7,0.3l7.4,0.6l-0.9,10.1l-4.4-0.4L202,194l0.1-0.6l-4.9-0.5l0.2-2.5
		l-0.1-1.3l0-0.7l0.1-0.9l0.2-0.2l0.3-0.1l0.4-0.1l0.6-0.6l0.3-2.1l0-0.8L200,183.7z	"
        >
          <title id="t1950">Colfax, NM</title>
        </path>
        <path
          id="FIPS_35033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M197.2,193l4.9,0.5L202,194l4.4,0.4l0.2,5.7l-4-0.3l-2.6-0.2l-1-0.6l-2.4-1.1l-3.9-0.4
		l0.2-1.4l2-0.2L197.2,193z	"
        >
          <title id="t1951">Mora, NM</title>
        </path>
        <path
          id="FIPS_35059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M221.1,185.4l0.9,0.1l-0.5,6.5l-0.4,0.3l-0.2,2.1l-0.2,3.4l-0.3,4.1l-3.5-0.3l0.3-3.3l0.1-0.2
		l0.1-0.9l-4.4-0.3l0.1-1.1l-2.2-0.2l0-0.6l0.9-10.1L221.1,185.4z	"
        >
          <title id="t1952">Union, NM</title>
        </path>
        <path
          id="FIPS_35021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.4,194.4l4.4,0.4l0,0.6l2.2,0.2l-0.1,1.1l4.4,0.3l-0.1,0.9l-0.1,0.2l-0.3,3.3l-0.1,1.1
		l-0.3,3.3l-0.1,0.1l-2.6-0.2l0-0.4l-0.9-0.1l-2.2-5.1l-1.6,0.1l-2.5-0.2L206.4,194.4z	"
        >
          <title id="t1953">Harding, NM</title>
        </path>
        <path
          id="FIPS_35047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M192.8,197.6l3.9,0.4l2.4,1.1l1,0.6l2.6,0.2l4,0.3l2.5,0.2l1.6-0.1l2.2,5.1l0.9,0.1l0,0.4
		l-0.2,1.9l-2.3-0.2l0-0.3l-2.9,1.3l0.1-1l-12.2-1.1l-0.2,2.3l-4.4-0.4L192.8,197.6z	"
        >
          <title id="t1954">San Miguel, NM</title>
        </path>
        <path
          id="FIPS_35037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M216.9,201.5l3.5,0.3l-0.1,1.5l-0.4,5.7l-0.2,3l-2.1-0.2l-2.6,2.1l-2.5,0.9l-0.4,1.1l-2.2-0.2
		l-1.9-0.2l0.2-2.3l0.1-1.2l0.2-2.3l0.1-1.2l2.9-1.3l0,0.3l2.3,0.2l0.2-1.9l2.6,0.2l0.1-0.1l0.3-3.3L216.9,201.5z	"
        >
          <title id="t1955">Quay, NM</title>
        </path>
        <path
          id="FIPS_35019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M208.4,208.6l-0.1,1.2l-0.2,2.3l-0.1,1.2l-2.2-0.2l-0.5,1.1l-0.8,1.1l-4.7-0.4l-0.3,3.3
		l-4.4-0.4l0.3-3.4l0.2,0l0.8-7.9l12.2,1.1L208.4,208.6z	"
        >
          <title id="t1956">Guadalupe, NM</title>
        </path>
        <path
          id="FIPS_35011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M208,213.3l-0.2,2.3l1.9,0.2l-0.3,3.8l0,0.7l-0.2,2.3l-2.2-0.2l-0.1,1.1l-2.3-0.2l-4.3-0.4
		l0.1-1.1l-1.1-0.1l0.3-3.3l0.3-3.3l4.7,0.4l0.8-1.1l0.5-1.1L208,213.3z	"
        >
          <title id="t1957">De Baca, NM</title>
        </path>
        <path
          id="FIPS_35009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.6,211.9l-0.2,2.7l-0.4,5.6l0,0.1l-7.4-0.6l0.3-3.9l0.4-1.1l2.5-0.9l2.6-2.1L219.6,211.9z
			"
        >
          <title id="t1958">Curry, NM</title>
        </path>
        <path
          id="FIPS_35041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M211.9,215.9l-0.3,3.9l7.4,0.6l-0.5,6.2l-0.3,3.3l-4.9-0.4l0.1-1.1l-2.2-0.2l0.2-2.1l-1.3-0.1
		l0.3-3.4l-1.1-0.1l0.2-2.3l0-0.7l0.3-3.8L211.9,215.9z	"
        >
          <title id="t1959">Roosevelt, NM</title>
        </path>
        <path
          id="FIPS_35005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M209.2,222.5l1.1,0.1L210,226l1.3,0.1l-0.2,2.1l2.2,0.2l-0.1,1.1l-2.2-0.2l-0.7,2.2l-0.5,5.6
		l-0.5,0l-11-0.9l-0.5,5.7l-0.1,0l-2.8-0.3l-0.4,0l-2.2-0.2l0.5-4.6l0.3-1.1l0.2-0.7l0.2-1.5l3.3,0.3l1.1,0l0.5-4l0.5-4.8l0,0h0
		l0.3-3.4l1.1,0.1l-0.1,1.1l4.3,0.4l2.3,0.2l0.1-1.1L209.2,222.5z	"
        >
          <title id="t1960">Chaves, NM</title>
        </path>

        <path
          id="FIPS_32007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M113,105.1l1.2,0.2l1.4,0.3l2.5,0.6l2,0.4l2.2,0.4l-2.4,12.7l-2.2,11.3l-2-0.4l-5.9-1.2
		l-2.2-0.4l-2.2-0.5l-1.9-0.4l-3-0.6l-1.6-0.3l0-5.7l0-1.3l0-0.4l0.9-4.1l-4.1-0.9l-4.1-0.9l2.8-12.7l3.6,0.8l1.1,0.2L113,105.1z	"
        >
          <title id="t1962">Elko, NV</title>
        </path>
        <path
          id="FIPS_32033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M100.6,127.2l3,0.6l1.9,0.4l2.2,0.5l2.2,0.4l5.9,1.2l2,0.4l-0.5,2.7l-0.9,4.6l-2.1,11
		l-9.3-1.8l-7.6-8l0.7-3.5l0.1-0.3l0.4-0.3l0.2-0.2l0.2-0.3l0.4-0.7l0.9-3.3l0.4-3.2L100.6,127.2z	"
        >
          <title id="t1963">White Pine, NV</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "29820"
              ? `metroArea clickedArea state-nv`
              : `metroArea ${colorCode[29820]} state-nv`
          }
          id="FIPS_29820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_32003"
            className="FIPS_29820 st0 state-nv"
            d="M91.1,168.9l1.3,0.3l0.3-0.1l7.4,1.5l1.6,0.3l0.7,0.3l7.1,1.4l-0.4,2.1l-0.1,0.3l-0.4,2.3
		l-0.2,1.3l-0.4,2.3l-1.3,1.8l-0.1,0.2l0,0l0,0l-0.6,0l-0.2,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.2-0.4l-0.1-0.2l0-0.1l0,0l0-0.1l-0.1-0.3
		l-0.3-0.4l-0.1-0.1l-1.3-0.4l-0.6-0.1H102l-1.2,0.3l-0.1,0.1l-0.1,0.1l0,0.1l-0.1,1.3l-0.3,3.7l-0.1,2.3l0.1,1.6l0.1,0.8l0,0.4
		l-0.1,1.6l0,0.3l-0.1,0.3l-0.1,0.3l-1,1.6l-1.4-2.1l-3.8-5.7l-0.3-0.4l-0.7-1.1l-2.1-3.1l-2-3L91.1,168.9z	"
          >
            <title id="t1964">Clark, NV</title>
          </path>
        </g>
        <path
          id="FIPS_32017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M104.8,147.4l9.3,1.8l-0.3,1.3l-1,5.4l-1.4,6.9l-1.5,7.7l-0.4,2l-7.1-1.4l-0.7-0.3l-1.6-0.3
		l-7.4-1.5l-0.3,0.1l-1.3-0.3l0.2-1l0.6-2.7l2.5-11.6l8.8,1.8L104.8,147.4z	"
        >
          <title id="t1965">Lincoln, NV</title>
        </path>
        <path
          id="FIPS_32009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M77.9,144.2l3.8,7.2l-3,13.1l-5.2-7.8l-4.6-6.9l0.1,0.1l0.6,0.1l3.7-2.6L77.9,144.2z	"
        >
          <title id="t1966">Esmeralda, NV</title>
        </path>
        <path
          id="FIPS_32023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M78,136.3l0.9-0.1l2.8,0l1.7,0.1l7.1,1.6l6.7,1.5l7.6,8l-1.6,8l-8.8-1.8l-2.5,11.6l-0.6,2.7
		l-0.2,1l-2.3,10.7l-0.1-0.2l-1.5-2.2l-0.4-0.5l-2.8-4.1l-3.4-5.1l-0.6-1l-1.1-1.6l-0.2-0.3l3-13.1l-7.4-14l0.2-1L78,136.3z	"
        >
          <title id="t1967">Nye, NV</title>
        </path>
        <path
          id="FIPS_32011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M95.8,114.6l4.1,0.9l-0.9,4.1l0,0.4l0,1.3l0,5.7l1.6,0.3l0,0.3l-0.4,3.2l-0.9,3.3l-0.4,0.7
		l-0.2,0.3l-0.2,0.2l-0.4,0.3l-0.1,0.3l-0.7,3.5l-6.7-1.5l0.2-0.7l0.6-2.3l1-4.3l0.9-4.3l-0.1,0l0,0l1-4.1l1.5-7L95.8,114.6z	"
        >
          <title id="t1968">Eureka, NV</title>
        </path>
        <path
          id="FIPS_32015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M91.7,113.7l4.1,0.9l-0.2,0.7l-1.5,7l-1,4.1l0,0l0.1,0l-0.9,4.3l-1,4.3l-0.6,2.3l-0.2,0.7
		l-7.1-1.6l-1.7-0.1l-2.8,0l-0.1-0.3l0.1-0.4l0.9-2.6l0.1-0.2l0.1-0.1l1.3-0.9l0.7-0.3l0.8-0.2l0.1,0l0.1,0l0.1-0.1l0.1-0.2l0.3-1.1
		l0.8-3.7l-0.3-0.8l3.8-6.1l0.8-1.4l2.2,0.5L91.7,113.7z	"
        >
          <title id="t1969">Lander, NV</title>
        </path>
        <path
          id="FIPS_32021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M69.4,134.2l8.6,2.1l-3.4,0.2l-0.2,1l3.6,6.8l-4.5,3.2l-3.7,2.6l-0.6-0.1l-0.1-0.1l-5.5-8.3
		l2.4,0.6l0.3-1.3l0.8-3.2l0.1-1.1l-0.9-0.2l0.3-1.2l0.6-0.7l0.7-0.8L69.4,134.2z	"
        >
          <title id="t1970">Mineral, NV</title>
        </path>
        <path
          id="FIPS_32005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M57.5,130.7l1.2,0.3l1.1,0.5l0,0.2l1.9,0.5l2.3,0.6l-0.3,1.2h-0.4l-0.5-0.1l-0.3,0.3l-0.4,0.9
		l-0.1,0.4l0,1.2l0.1,0.4l0.2,0.8l-0.1,1.2l-0.2,0.7l-1.9-2.9l-2.4-3.6l-0.5-1.9L57.5,130.7z	"
        >
          <title id="t1971">Douglas, NV</title>
        </path>

        <path
          id="FIPS_32510"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M57.7,130l3.1-0.4l0.2,0.6l0.3,0.3l0.8,0.2l0,0.1l-0.2,1.3l0,0.1l-1.9-0.5l0-0.2l-1.1-0.5
		l-1.2-0.3L57.7,130z	"
        >
          <title id="t1972">Carson City, NV</title>
        </path>

        <path
          id="FIPS_32019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M66.9,126.1l1.1-0.7l0.3-0.1l-0.3,1l-0.6,1.4l-0.4,1.6l0.9,1.6l0.6,0.9l0.5,0.7l0.7,1.2
		l-0.1,0.5l-1.7-0.4l-0.7,0.8l-0.6,0.7l-0.3,1.2l0.9,0.2l-0.1,1.1l-0.8,3.2l-0.3,1.3l-2.4-0.6l-1.3-1.9l0.2-0.7l0.1-1.2l-0.2-0.8
		l-0.1-0.4l0-1.2l0.1-0.4l0.4-0.9l0.3-0.3l0.5,0.1h0.4l0.3-1.2l-2.3-0.6l0-0.1l0.2-1.3l0-0.1l-0.8-0.2l-0.3-0.3l-0.2-0.6l0.7,0
		l1.8-0.5L66,126L66.9,126.1z	"
        >
          <title id="t1973">Lyon, NV</title>
        </path>
        <path
          id="FIPS_32001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M83.9,125.2l0.3,0.8l-0.8,3.7l-0.3,1.1l-0.1,0.2l-0.1,0.1l-0.1,0l-0.1,0l-0.8,0.2l-0.7,0.3
		l-1.3,0.9l-0.1,0.1l-0.1,0.2l-0.9,2.6l-0.1,0.4l0.1,0.3l-0.9,0.1l-8.6-2.1l0.1-0.5l-0.7-1.2l-0.5-0.7l-0.6-0.9l-0.9-1.6l0.4-1.6
		l0.6-1.4l0.3-1l-0.3,0.1l-1.1,0.7l0.2-0.6l0.3-1.4l-0.1-0.5l0.3-1.8l0.1-0.5l5.9,1.5l3.4,0.8l2.9,0.7L83.9,125.2z	"
        >
          <title id="t1974">Churchill, NV</title>
        </path>
        <path
          id="FIPS_32027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M87.7,119.1l-3.8,6.1l-3.9-0.9l-2.9-0.7l-3.4-0.8l-5.9-1.5l-1.1-0.3l1.6-6.5l0.2,0.1l1.4-5.6
		l4.9,1.2l-0.3,1.3l10.8,2.5l-0.5,2.2l3.2,0.7l0.1,0l0,0.1L87.7,119.1z	"
        >
          <title id="t1975">Pershing, NV</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "39900"
              ? `metroArea clickedArea state-nv`
              : `metroArea ${colorCode[39900]} state-nv`
          }
          id="FIPS_39900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_32029"
            className="FIPS_39900 st0 state-nv"
            d="M66,126l-2.8,3.1l-1.8,0.5l-0.7,0l0.8-0.9l0.4-1.5l-0.1-0.4l0-0.6l1.5-0.2l0.7,0.1l1,0
		l0.5-0.1L66,126z	"
          >
            <title id="t1976">Storey, NV</title>
          </path>
          <path
            id="FIPS_32031"
            className="FIPS_39900 st0 state-nv"
            d="M72.8,96l0.3,0.1l-0.5,1.7l-0.8,3.4l-0.3,2.3l-0.3,1.4l-0.2,0.6l-0.2,0.3l-0.6,2.5l-0.2,1
		l0.2,0l-1.4,5.6l-0.2-0.1l-1.6,6.5l1.1,0.3l-0.1,0.5l-0.3,1.8l0.1,0.5l-0.3,1.4l-0.2,0.6L66,126l-0.5,0.1l-0.5,0.1l-1,0l-0.7-0.1
		l-1.5,0.2l0,0.6l0.1,0.4l-0.4,1.5l-0.8,0.9l-3.1,0.4l0.5-1.9l0.4-1.6l0.9-3.5l0.2-0.7l1-3.7l0.6-2.4l0,0l0.2-0.7l0.6-2.2l1.2-4.6
		l1-4l2.6-10.2L72.8,96z	"
          >
            <title id="t1977">Washoe, NV</title>
          </path>
        </g>
        <path
          id="FIPS_32013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M73.1,96l5.1,1.3l5.4,1.2l10.9,2.5l0.1,0l-3.9,17.2l-2.2-0.5l-0.8,1.4l0.4-1.9l0-0.1l-0.1,0
		l-3.2-0.7l0.5-2.2l-10.8-2.5l0.3-1.3l-4.9-1.2l-0.2,0l0.2-1l0.6-2.5l0.2-0.3l0.2-0.6l0.3-1.4l0.3-2.3l0.8-3.4L73.1,96z	"
        >
          <title id="t1978">Humboldt, NV</title>
        </path>
        <path
          id="FIPS_36019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M498.4,59.6l0,0.2l0.3,2.1l0.5,2.7l0.3,0.5l0.1,0.1l0.3,0.2l-1.1,0.4l0,0.2l-0.2,0.5L498,67
		l-0.8,0.5l-0.7,0.1l-1.4,0.5l-0.3-0.9l-0.3-0.9l-0.7-1.6l-1.2-2.9l-0.2-0.6l1.3-0.4l2.2-0.6L498.4,59.6z	"
        >
          <title id="t1979">Clinton, NY</title>
        </path>
        <path
          id="FIPS_36031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M495.1,68.1l1.4-0.5l0.7-0.1l0.8-0.5l0.6-0.4l0.2-0.5l0-0.2l1.1-0.4l0.4,0.5l0.1,0.3l0.2,0.5
		l0,0l0,0.1l0,0.5l0.3,1.6l-0.4,1.1l0,1.1v0.4l0,0.4v0l0,0l1.1,2.5l0.2,0.3l-0.5,0.2l-5.4,2.1l0-0.5l-0.1-0.2l-1-0.2l-0.3,0.1
		l-0.1,0.1l-0.1,0.1l-1.5-1.2l0.6-0.7l-0.7-1.8l1.6-0.6l-1.2-3.3L495.1,68.1z	"
        >
          <title id="t1980">Essex, NY</title>
        </path>

        <path
          id="FIPS_36037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.5,92.5l1.2,1.7l-0.1,1.7l-4.7,0.8l-0.5-2.8l-0.1-0.5l0.5-0.1l3.2-0.6L461.5,92.5z	"
        >
          <title id="t1982">Genesee, NY</title>
        </path>
        <path
          id="FIPS_36121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M457.8,96.7l4.7-0.8l0.5,2.5l-0.2,0.7l-0.3,0.3l-0.1,0.4l-0.1,0.5l0,0l0.2,0.1l-2.5,0.5
		l-1.5,0.1l-0.6-3.1l-0.2,0l-0.2-1.1L457.8,96.7z	"
        >
          <title id="t1983">Wyoming, NY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "40380"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[40380]} state-ny`
          }
          id="FIPS_40380"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36051"
            className="FIPS_40380 st0 state-ny"
            d="M462.6,94.2l1.7-0.3l0.1,0.1l0,0.1l-0.1,0.4l0,0l-0.2,0.1l0,0l0,0l1.1-0.2l0.5-0.2l0.1,0.1
		l0.1,0.1l0.1,0.3l0.1,0.5v0l-0.3,0.1l0,1.2l0.3,1.1l0.9-0.2l0.2,0.6l0.1,0.6l-1.9,1.8l-1.1,0.2l-0.1-0.6l-1.9,0.3l-0.2-0.1l0,0
		l0.1-0.5l0.1-0.4l0.3-0.3l0.2-0.7l-0.5-2.5L462.6,94.2z	"
          >
            <title id="t1984">Livingston, NY</title>
          </path>
          <path
            id="FIPS_36055"
            className="FIPS_40380 st0 state-ny"
            d="M461.5,92.5l-0.5-3l0.4-0.1l1.5,0l1,0.2l0.4,0.2l0.1,0l0.8,0.3l0.3,0l0.2,0l1.4-0.8l0.6,3.1
		l-1.1,0.2l0.3,1.2l-0.9,0.2l-0.5,0.2l-1.1,0.2l0,0l0,0l0.2-0.1l0,0l0.1-0.4l0-0.1l-0.1-0.1l-1.7,0.3L461.5,92.5z	"
          >
            <title id="t2012">Monroe, NY</title>
          </path>
          <path
            id="FIPS_36069"
            className="FIPS_40380 st0 state-ny"
            d="M471.3,92.1l0.4,1.8l-0.1,0.1l0,0l0,0.1l0.3,1.2l-3.1,0.7l-0.2,0.4l0,0.3l-0.1,0.6l0.2,1.2
		l-1.1,0.2l-0.1-0.6l-0.2-0.6l-0.9,0.2l-0.3-1.1l0-1.2l0.3-0.1v0l-0.1-0.5l-0.1-0.3l-0.1-0.1l-0.1-0.1l0.9-0.2l-0.3-1.2l1.1-0.2
		l1.1-0.3l1-0.2l0.1,0.3L471.3,92.1z	"
          >
            <title id="t1989">Ontario, NY</title>
          </path>
          <path
            id="FIPS_36073"
            className="FIPS_40380 st0 state-ny"
            d="M461.5,92.5l-0.6,0.1l-3.2,0.6l-0.5,0.1l-0.6-3.1l4.3-0.7L461.5,92.5z	"
          >
            <title id="t1981">Orleans, NY</title>
          </path>
          <path
            id="FIPS_36117"
            className="FIPS_40380 st0 state-ny"
            d="M472.7,87.5l0.9,4l-2.3,0.6l-1.6,0.3l-0.1-0.3l-1,0.2l-1.1,0.3l-0.6-3.1l0.5-0.2L469,89
		l0.3-0.1l0.4,0L470,89l0.7-0.1l0.1,0l1.3-0.8l0.2-0.2L472.7,87.5z	"
          >
            <title id="t2011">Wayne, NY</title>
          </path>
        </g>
        <path
          id="FIPS_36057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M497.7,86.8l0.1,0.3l0.3,0.7l-1.3,1.5l0,0.2l0,0l-0.6,0.3l-1,0.4l-1.1-0.3l-0.8,0l-1.2-0.2
		l-0.5-2.3l2.2,0.3l0.5-0.1L497.7,86.8z	"
        >
          <title id="t1986">Montgomery, NY</title>
        </path>
        <path
          id="FIPS_36035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.2,84.2l1.8,0.4l2.8-0.9l0.7-0.3l1.2,3.3l-3.6,0.8l-0.5,0.1l-2.2-0.3L491.2,84.2z	"
        >
          <title id="t1987">Fulton, NY</title>
        </path>
        <path
          id="FIPS_36099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.6,91.5l-0.1,0.8l0.4,2.2l0.1,0.2l0.2,0.6l0,0.1l0.1,0.1l0.7,0.9l-0.1,1l-1.8,0.4
		l-1.3-2.7l-0.3-1.2l0-0.1l0,0l0.1-0.1l-0.4-1.8L473.6,91.5z	"
        >
          <title id="t1988">Seneca, NY</title>
        </path>

        <path
          id="FIPS_36123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M471.9,95.3l1.3,2.7l-1.8,1.1l-0.4-0.1l-0.1-0.1l-0.1-0.6l0-0.3l0-0.1l-2.1,0.4l-0.2-1.2
		l0.1-0.6l0-0.3l0.2-0.4L471.9,95.3z	"
        >
          <title id="t1990">Yates, NY</title>
        </path>
        <path
          id="FIPS_36097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.2,98l1.8-0.4l0.2,0.9l0.3,1.1l0,0.2l0.2,1.1l0.7-0.1l0.1,0.4l-0.2,0.2l-0.4,0l-0.5-0.1
		l-0.1-0.5l-1,0.2l-1.1,0.3l0,0.1l-1.1,0.3l-0.1,0l-0.3-1.5l-0.3-1.2L473.2,98z	"
        >
          <title id="t1991">Schuyler, NY</title>
        </path>
        <path
          id="FIPS_36109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M475.1,96.5l1.9-0.4l0,0.1l1.8-0.4l0.7,2.7l-2.3,2.2l-0.8,0.1l-0.7,0.1l-0.2-1.1l0-0.2
		l-0.3-1.1l-0.2-0.9L475.1,96.5z	"
        >
          <title id="t1992">Tompkins, NY</title>
        </path>
        <path
          id="FIPS_36011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.4,86.3l0.4,1.5l0.5,0.5l0.8-0.2l0.1,0.4l0.3,1l0.1,0.5l0,0l-0.2,0l0,0.1l0,0.1l0.3,1.2
		l0.8,1.9l0.9-0.2l0.6,0.4l0.3,0.3l0,0.1l0.5,1.9l-1.8,0.4l0-0.1l-1.9,0.4l-0.7-0.9l-0.1-0.1l0-0.1l-0.2-0.6l-0.1-0.2l-0.4-2.2
		l0.1-0.8l-0.9-4L473.4,86.3z	"
        >
          <title id="t1993">Cayuga, NY</title>
        </path>

        <path
          id="FIPS_36023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.8,92.9l0.2,0.8l1.1,3.9l-2.5,0.6l-1.1,0.3l-0.7-2.7l-0.5-1.9L481.8,92.9z	"
        >
          <title id="t1995">Cortland, NY</title>
        </path>
        <path
          id="FIPS_36017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482,93.7l3.6-1l0.6-0.1l1.2-0.3l0.1,5.7l0.3,1.5l-1.1,0.2l-1,0.2l-0.7-0.3l-1.2,0l-0.1,0.1
		l-0.1-0.2l-0.6-1.9L482,93.7z	"
        >
          <title id="t1996">Chenango, NY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45060"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[45060]} state-ny`
          }
          id="FIPS_45060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36053"
            className="FIPS_45060 st0 state-ny"
            d="M479.8,88.1l1.1,0.1l1-0.4l0.5,0.1l0.2,0.1l0.6,0.3l1.1,0.8l0.3,1.1l0,0.2l1.2,0.6l1.7-0.5
		l-0.1,1.7l-1.2,0.3l-0.6,0.1l-3.6,1l-0.2-0.8l-0.7-2.5l-0.4-1.2l-0.7-0.9L479.8,88.1z	"
          >
            <title id="t1997">Madison, NY</title>
          </path>
          <path
            id="FIPS_36067"
            className="FIPS_45060 st0 state-ny"
            d="M479.8,88.1l0.2,0.2l0.7,0.9l0.4,1.2l0.7,2.5l-3.4,1l0-0.1l-0.3-0.3l-0.6-0.4l-0.9,0.2
		l-0.8-1.9l-0.3-1.2l0-0.1l0-0.1l0.2,0l0,0l-0.1-0.5l-0.3-1l1.4-0.4l1.2-0.6l1.2,0.3L479.8,88.1z	"
          >
            <title id="t1994">Onondaga, NY</title>
          </path>
          <path
            id="FIPS_36075"
            className="FIPS_45060 st0 state-ny"
            d="M476.6,82.2l1.6-0.2l-0.1-0.3l0.4-0.2l1.9-0.2l0.8,2.7l-0.6-0.1l-0.2,2.2l0.2,0l0.3,2.1
		l-1.1-0.1l-0.8-0.2l-1.2-0.3l-1.2,0.6l-1.4,0.4l-0.1-0.4l-0.8,0.2l-0.5-0.5l-0.4-1.5l0.4-0.5l1.1-1.2l0.1,0l0.4-0.1l0.2,0.1l0.1,0
		l0.3-0.1l0.5-0.3l0.1-0.1l0.1-0.2l0-0.2l0-0.2l0-0.3l-0.1-0.6L476.6,82.2z	"
          >
            <title id="t2010">Oswego, NY</title>
          </path>
        </g>
        <path
          id="FIPS_36065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486.7,80.9l1.1,3.5l0.4,1.3l-0.5,1.6l-0.4,0.9l0.6,2.2l-0.3,0.2l-1.7,0.5l-1.2-0.6l0-0.2
		l-0.3-1.1l-1.1-0.8l-0.6-0.3l-0.2-0.1l-0.5-0.1l-1,0.4l-0.3-2.1l-0.2,0l0.2-2.2l0.6,0.1l2.2,0.2L486.7,80.9z	"
        >
          <title id="t1998">Oneida, NY</title>
        </path>
        <path
          id="FIPS_36049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.9,74l2.8,1l1.9,6l-3.3,3.3l-2.2-0.2l-0.8-2.7l-0.4-1.2l0-1.2l1.7-1.6l0.3-0.6l0-0.8
		l-0.6-0.3L481.9,74z	"
        >
          <title id="t1999">Lewis, NY</title>
        </path>
        <path
          id="FIPS_36043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M484.8,74.9l2.9-0.3l2.4,7.2l-0.4,2l1.6,0.4l0.3,3.1l0.5,2.3l-1.2-0.2l0.1,0.9l-0.1,0.1
		l-2-0.7l-0.2,0.7l-0.6,0.2l-0.1-0.3l-0.6-2.2l0.4-0.9l0.5-1.6l-0.4-1.3l-1.1-3.5L484.8,74.9z	"
        >
          <title id="t2000">Herkimer, NY</title>
        </path>
        <path
          id="FIPS_36077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M493.1,89.9l0,0.5l0.1,0.4l0,0.2l0.6,1.2l0.1,0.3l-0.2,0.9l-0.2,0.7l-1.2,0.3l-1.6,1.5
		l-0.8,0.8l-0.4,0.5l-0.9,0.7l-0.2,0.1l-0.7,0.2l-0.1-5.7l0.1-1.7l0.3-0.2l0.1,0.3l0.6-0.2l0.2-0.7l2,0.7l0.1-0.1l-0.1-0.9l1.2,0.2
		L493.1,89.9z	"
        >
          <title id="t2001">Otsego, NY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "24020"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[24020]} state-ny`
          }
          id="FIPS_24020"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36113"
            className="FIPS_24020 st0 state-ny"
            d="M495.8,77.1l5.4-2.1l0,1l-0.1,0.8l-0.5,1.3l-0.2,0.4l-0.1,0.5l0,0.1l0,0.2l0.9,2.3l-0.6,0.7
		L500,83l-0.6-0.2l-0.1-0.1l-0.2-0.7l-0.6-0.9l-0.1-0.1L496,82l-1.5-4.4L495.8,77.1z	"
          >
            <title id="t2005">Warren, NY</title>
          </path>
          <path
            id="FIPS_36115"
            className="FIPS_24020 st0 state-ny"
            d="M501.8,74.8l0.3,0.6l-0.2,1l-0.1,0.5l0.1,0.8l0,0l0.3,0.1l1.5,0.3l0.5,2.5l1,4.7l-3.3,0.8
		l0.1-0.6l0-0.5l0-0.9l0-0.2l-0.7-2.4l-0.1-0.1l-0.9-2.3l0-0.2l0-0.1l0.1-0.5l0.2-0.4l0.5-1.3l0.1-0.8l0-1L501.8,74.8z	"
          >
            <title id="t2039">Washington, NY</title>
          </path>
        </g>
        <path
          id="FIPS_36041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M492.7,72.8l0.7,1.8l-0.6,0.7l1.5,1.2l0.1-0.1l0.1-0.1l0.3-0.1l1,0.2l0.1,0.2l0,0.5l-1.4,0.5
		L496,82l0.5,1.4l-0.7,0.3l-2.8,0.9l-1.8-0.4l-1.6-0.4l0.4-2l-2.4-7.2l2.8-1L492.7,72.8z	"
        >
          <title id="t2006">Hamilton, NY</title>
        </path>
        <path
          id="FIPS_36033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M495.1,68.1l-2,0.8l1.2,3.3l-1.6,0.6l-2.2,0.8l-0.1-0.9l-0.3-1l-1.8-5.2l-1.1-3.4l-0.7,0.2
		l-0.2-0.7l0.2,0l3.7-0.7l1.3-0.3l0.9-0.3l0.1,0l0.2,0.6l1.2,2.9l0.7,1.6l0.3,0.9L495.1,68.1z	"
        >
          <title id="t2007">Franklin, NY</title>
        </path>
        <path
          id="FIPS_36089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486.1,62.6l0.2,0.7l0.7-0.2l1.1,3.4l1.8,5.2l0.3,1l0.1,0.9l-2.8,1l-2.9,0.3l-2.8-1l-0.7-0.3
		l-2-0.7l-1.6-0.6l0.3-1l0.3-0.6l0.5-0.8l1.4-2.2l0.4-0.6l3.3-3.7l0.2-0.1l1.2-0.7l0.2,0L486.1,62.6z	"
        >
          <title id="t2008">St. Lawrence, NY</title>
        </path>
        <path
          id="FIPS_36045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M477.7,72.4l1.6,0.6l2,0.7l0.7,0.3l-0.6,1.6l0.6,0.3l0,0.8l-0.3,0.6l-1.7,1.6l0,1.2l0.4,1.2
		l-1.9,0.2l-0.4,0.2l0.1,0.3l-1.6,0.2l-0.6-1.5l0.6-1.3l0-0.1l0-0.2l-0.2-0.5l-0.1-0.1l-0.1,0l-0.8-0.1l-0.6-0.2l-0.9-0.6l-0.1-0.4
		l0-0.1l0-0.3l0.2-0.9l2.1-2.2L477.7,72.4z	"
        >
          <title id="t2009">Jefferson, NY</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "15380"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[15380]} state-ny`
          }
          id="FIPS_15380"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36063"
            className="FIPS_15380 st0 state-ny"
            d="M457.2,93.4l0.1,0.5l-0.2,0.1l-1,0.3l-3.2,0.7l-0.8,0.1l-0.3-0.1l-0.1-0.2l-0.4-2.2l2-1.1
		l1.7-0.8l0.8-0.3l0.5-0.2l0.1,0l0.2,0L457.2,93.4z	"
          >
            <title id="t2013">Niagara, NY</title>
          </path>
          <path
            id="FIPS_36029"
            className="FIPS_15380 st0 state-ny"
            d="M457.3,93.9l0.5,2.8l-0.2,0l0.2,1.1l0.2,0l0.6,3.1l-1.2,0.6l-1,0.6l-1.1,0.7l-0.2,0.1
		l-0.2,0.1l-0.6-0.3l-1.2-0.7l-0.8-0.3l0-0.3l0.1-0.3l0.4-1.1l0.3-0.2l0.6-0.5l0.2-0.1l0.4-0.5l0.1-0.2v-0.1l-0.3-0.7l-0.5-1
		l-0.1-0.2l-0.1-0.1l-0.4-0.1l-0.4-0.2l-0.1-0.1l-0.1-0.3l-0.2-0.6l0.8-0.1l3.2-0.7l1-0.3L457.3,93.9z	"
          >
            <title id="t2014">Erie, NY</title>
          </path>
        </g>
        <path
          id="FIPS_36013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453,101.9l1.2,6.9l-5.2,0.9l-0.1,0l-1.3,0.2l-0.3-1.7l-0.2-1.4l-0.1-0.3l0.4-0.3l0.6-0.5
		l0.8-0.8l0.8-0.8l0.2-0.3l0.2-0.4l0.4-0.5l0.9-0.7l0.9-0.7L453,101.9z	"
        >
          <title id="t2015">Chautauqua, NY</title>
        </path>
        <path
          id="FIPS_36009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.6,100.9l1.5-0.1l1.3,6.6l-2.7,0.5l-2.6,0.5l-0.4,0.1l-1.3,0.2l-1.2-6.9l1.2,0.7l0.6,0.3
		l0.2-0.1l0.2-0.1l1.1-0.7l1-0.6L458.6,100.9z	"
        >
          <title id="t2016">Cattaraugus, NY</title>
        </path>
        <path
          id="FIPS_36003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M462.6,100.4l1.9-0.3l0.1,0.6l1.1-0.2l0.9,6.1l-4.3,0.8l-0.9,0.2l-1.3-6.6L462.6,100.4z	"
        >
          <title id="t2017">Allegany, NY</title>
        </path>
        <path
          id="FIPS_36101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.5,98.6l1.1-0.2l2.1-0.4l0,0.1l0,0.3l0.1,0.6l0.1,0.1l0.4,0.1l0.3,1.2l0.3,1.5l0.1,0
		l1.1-0.3l0.7,3.5l-6,1.2l-1.3,0.3l-0.9-6.1L467.5,98.6z	"
        >
          <title id="t2018">Steuben, NY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "21300"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[21300]} state-ny`
          }
          id="FIPS_21300"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36015"
            className="FIPS_21300 st0 state-ny"
            d="M477.2,100.6l0.6,3.6l-3.5,0.7l-0.4,0.1l-0.7-3.5l0-0.1l1.1-0.3l1-0.2l0.1,0.5l0.5,0.1l0.4,0
		l0.2-0.2l-0.1-0.4L477.2,100.6z	"
          >
            <title id="t2019">Chemung, NY</title>
          </path>
        </g>
        {/* <g
          className={`metroArea colorKey ${colorCode[13780]}`}
          id="FIPS_13780"
          // ref={f13780}
          data-color-code={colorCode[13780] ? colorCode[13780] : null}
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        > */}
        <path
          id="FIPS_36107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M480.6,98.2L480.6,98.2l0.8,1.8l0,0.1l0.1,0.5l0,0.4l-0.3,0.1l0.6,2.3l-0.4,0.1l-3.8,0.8
		l-0.6-3.6l2.3-2.2L480.6,98.2z	"
        >
          <title id="t2020">Tioga, NY</title>
        </path>
        <path
          id="FIPS_36007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M483.1,97.6l0.6,1.9l0.1,0.2l0.1-0.1l1.2,0l0.7,0.3l1-0.2l1.1-0.2l1.1,2.4l-1.2,0.3l-5.8,1.3
		l-0.6-2.3l0.3-0.1l0-0.4l-0.1-0.5l0-0.1l-0.8-1.7l-0.1-0.1L483.1,97.6z	"
        >
          <title id="t2021">Broome, NY</title>
        </path>
        {/* </g> */}
        <path
          id="FIPS_36025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M493.4,93.9l2.9,1.5l0.2,0l-0.6,2.1l0.9,0.2l-2.6,2.6l-2.9,2.9l-1.2-0.2l-0.3-0.6l-0.2-0.2
		l-0.6-0.4l-0.2,0l-1.1-2.4l-0.3-1.5l0.7-0.2l0.2-0.1l0.9-0.7l0.4-0.5l0.8-0.8l1.6-1.5L493.4,93.9z	"
        >
          <title id="t2022">Delaware, NY</title>
        </path>
        <path
          id="FIPS_36105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491.3,103.3l2.9-2.9l1.3,0.4l2.1,0.7l-0.2,0.6l-0.4,0.8l-0.2,0.5l0.9,0.4l1,0.5l0.4,0.6
		l-0.3,0.3l-0.2,0.4l-0.2,0.6L496,107l-0.1,0.1l0,0l0.1,0.5l0.1,0.3l-0.4,0l-0.8,0l-0.2-0.1l-1-0.5l-0.3-0.3l-0.4-0.4l-0.3-0.6
		L491.3,103.3z	"
        >
          <title id="t2023">Sullivan, NY</title>
        </path>
        <path
          id="FIPS_36039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M502.2,92.6L502.2,92.6L502.2,92.6l0.2,0.2l0.4,1.8l0,0.3l0,0.2l-0.4,0.9L502,97l0,0.2
		l-0.9-0.4l-0.4,0.1l-0.1,1l-1.5,0.2l-0.7,0.1l-1.5-0.4l-0.9-0.2l0.6-2.1l-0.2,0l1.6-1.1L502.2,92.6z	"
        >
          <title id="t2024">Greene, NY</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "28740"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[28740]} state-ny`
          }
          id="FIPS_28740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36111"
            className="FIPS_28740 st0 state-ny"
            d="M502,97.8l0.2,2.2l0.5,1.7l0.2,0.4l0.3,1.9l-0.9,0.3l-0.7,0.1l-0.6,0l-0.7-0.3l-1,0.7
		l-0.4-0.6l-1-0.5l-0.9-0.4l0.2-0.5l0.4-0.8l0.2-0.6l-2.1-0.7l-1.3-0.4l2.6-2.6l1.5,0.4l0.7-0.1l1.5-0.2l0.1-1l0.4-0.1l0.9,0.4
		L502,97.8z	"
          >
            <title id="t2026">Ulster, NY</title>
          </path>
        </g>

        <path
          id="FIPS_36071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M503.2,104l0.2,2l0.3,1.4l-1.8,2.9l-1.4-0.5l-3.5-1.2l-0.8-0.8l-0.1-0.3l-0.1-0.5l0,0l0.1-0.1
		l2.6-0.7l0.2-0.6l0.2-0.4l0.3-0.3l1-0.7l0.7,0.3l0.6,0l0.7-0.1L503.2,104z	"
        >
          <title id="t2031">Orange, NY</title>
        </path>

        <path
          id="FIPS_36027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M506.2,97.2l0.9,4.9l0.3,1.8l-0.5,0.1l-3.2,1.3l-0.3,0.7l-0.2-2l-0.3-1.9l-0.2-0.4l-0.5-1.7
		l-0.2-2.2l0.1-0.1l0.1,0l1.5,0.4l0.5,0.1l1.8-0.1L506.2,97.2L506.2,97.2z	"
        >
          <title id="t2036">Dutchess, NY</title>
        </path>
        <path
          id="FIPS_36021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M502.2,92.6l3.8-1.5l-0.1,5.7l0.2,0.4l-0.1,1l-1.8,0.1l-0.5-0.1l-1.5-0.4l-0.1,0l-0.1,0.1
		l0-0.7l0-0.2l0.3-0.9l0.4-0.9l0-0.2l0-0.3l-0.4-1.8L502.2,92.6L502.2,92.6L502.2,92.6z	"
        >
          <title id="t2037">Columbia, NY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "10580"
              ? `metroArea clickedArea state-ny`
              : `metroArea ${colorCode[10580]} state-ny`
          }
          id="FIPS_10580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_36091"
            className="FIPS_10580 st0 state-ny"
            d="M496,82l2.4-0.9l0.1,0.1l0.6,0.9l0.2,0.7l0.1,0.1L500,83l0.8-0.7l0.6-0.7l0.1,0.1l0.7,2.4
		l0,0.2l0,0.9l0,0.5l-0.1,0.6l0.1,2.1l-1.2,0.3l-0.1,0l-0.1,0L500,88l-0.1-0.3l-0.4-0.3l-1.2-0.3l-0.4,0.1l-0.1-0.3l-1.2-3.3L496,82
		z	"
          >
            <title id="t2004">Saratoga, NY</title>
          </path>
          <path
            id="FIPS_36095"
            className="FIPS_10580 st0 state-ny"
            d="M496.8,89.5l1,0.7l0.2,0.1l0.1,0.6l-0.1,0.7l-0.1,1.2l0,1.5l0,0.2l0.1,0l-1.6,1.1l-2.9-1.5
		l0.2-0.7l0.2-0.9l-0.1-0.3l-0.6-1.2l0-0.2l-0.1-0.4l0-0.5l0.8,0l1.1,0.3l1-0.4L496.8,89.5z	"
          >
            <title id="t2002">Schoharie, NY</title>
          </path>
          <path
            id="FIPS_36093"
            className="FIPS_10580 st0 state-ny"
            d="M497.9,87.1l0.4-0.1l1.2,0.3l0.4,0.3L500,88l0.8,0.7l0.1,0l0.1,0l-3.3,1.4l-1-0.7l0,0l0-0.2
		l1.3-1.5L497.9,87.1z	"
          >
            <title id="t1985">Schenectady, NY</title>
          </path>
          <path
            id="FIPS_36001"
            className="FIPS_10580 st0 state-ny"
            d="M501,88.7l1.2-0.3l0,4.3l-4.2,1.7l-0.1,0l0-0.2l0-1.5l0.1-1.2l0.1-0.7l-0.1-0.6l-0.2-0.1
		L501,88.7z	"
          >
            <title id="t2003">Albany, NY</title>
          </path>
          <path
            id="FIPS_36083"
            className="FIPS_10580 st0 state-ny"
            d="M502.1,86.3l3.3-0.8l0.7,2.5l-0.1,3.2l-3.8,1.5l0-4.3L502.1,86.3z	"
          >
            <title id="t2038">Rensselaer, NY</title>
          </path>
        </g>

        <path
          id="FIPS_39007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.9,113.1l0.7,4.5l-4.6,0.7l-0.4-2.7l-0.3-1.8l4.3-2.3L440.9,113.1z	"
        >
          <title id="t2041">Ashtabula, OH</title>
        </path>
        <path
          id="FIPS_39087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.2,154.7l0.7,0l0,0.9l1.2,0.3l1.2,0.9l0.1,1l0.7-0.1l0,0.6l0,0l0,0.9l0,0.1l0,0.1l0,0.1
		l-0.1,0.1l-0.1,0.1l-1.6,0.6l-0.9,0l-0.9-1l-1.6-0.6l0.6-0.4l0.6-2.1l0-0.2L426.2,154.7z	"
        >
          <title id="t2042">Lawrence, OH</title>
        </path>
        <path
          id="FIPS_39145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.8,153.4l0.6,0.6l0,0l2.1-0.2l1.9-0.2l0.5,0l0,0.6l0.2,0.5l0.9-0.1l0.1,1.1l0,0.2
		l-0.6,2.1l-0.6,0.4l0,0l-0.2-0.1l0,0l-0.1-0.1l-0.1-0.1l0-0.1l-0.3-0.8l-0.1-0.4l0-0.2l0,0v0l0-0.1l0-0.1l0,0l0,0l0,0l0,0l0,0
		l0-0.1l-0.1,0h-0.1l0,0l-0.3,0.1l-0.8,0.4l-0.2,0.1v0l-2.3,1.9L419.8,153.4z	"
        >
          <title id="t2043">Scioto, OH</title>
        </path>
        <path
          id="FIPS_39001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.8,153.4l0.6,5.3l-0.6-0.4l0,0l-0.3-0.2l0,0l-1.1-0.3l-0.4-0.1h0l-0.1,0l-0.1,0l-0.8,0.3
		l-0.1,0.1l-0.1,0.1l-0.1,0.5l-0.6,0.1l-0.3-5l2.8-0.8L419.8,153.4z	"
        >
          <title id="t2044">Adams, OH</title>
        </path>
        <path
          id="FIPS_39131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M418.6,151.2l5.6-0.4l0.2,2.9l-1.9,0.2l-2.1,0.2l0,0l-0.6-0.6l-1.2-0.4L418.6,151.2z	"
        >
          <title id="t2045">Pike, OH</title>
        </path>
        <path
          id="FIPS_39079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.4,150.3l1.1-0.1l1.2,0.1l1.2,0.4l0.1,1.3l-1,2.6l-0.7,0l-0.9,0.1l-0.2-0.5l0-0.6l-0.5,0
		l-0.2-2.9L424.4,150.3z	"
        >
          <title id="t2046">Jackson, OH</title>
        </path>
        <path
          id="FIPS_39053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.1,152l0,0.2l2.3-0.2l0,0.6l-0.2,1.2l-0.1,2.1l0,0l0.3,1.1l0,0.1v0l0,0l0,0.1l0,0.1l0,0.1
		l0,0l-0.1,0l0,0l-0.1,0l-0.2,0l-0.7,0.2l-0.7,0.1l-0.1-1l-1.2-0.9l-1.2-0.3l0-0.9l1-2.6L429.1,152z	"
        >
          <title id="t2047">Gallia, OH</title>
        </path>
        <path
          id="FIPS_39105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.3,149.6l5.1-0.4l0.2,1.1l-0.6,0.3v0.1l0,0.2l0.1,0.1l0.1,0.1l0.2,0.2l0.1,0.1l0.2,1
		l0,0.1l-1,0.7l-0.3,0.1v-0.7l0-0.1l-0.2-0.4l-0.2-0.2l-0.7-0.4h0l-0.2,0l-0.2,0.1l-0.5,0.8l0,0.2l0-0.6l-2.3,0.2l0-0.2L429.3,149.6
		z	"
        >
          <title id="t2048">Meigs, OH</title>
        </path>
        <path
          id="FIPS_39163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.3,148.2l1.1-0.1l1.1-0.3l0-0.3l2.2-0.2l0.1,1.2l0.4,0l0.1,1.2l-0.2,2.3L428,152l-0.1-1.3
		l-1.2-0.4l-1.2-0.1l-1.1,0.1L424.3,148.2z	"
        >
          <title id="t2049">Vinton, OH</title>
        </path>
        <path
          id="FIPS_39167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.2,143l0.4,0.3l2.1-0.2l0,0.4l-0.9,1.4l-2,1.7l-0.4-0.5l-0.1-0.1l-0.3-0.1l-0.1,0l-0.1,0
		l-0.1,0.1l-0.6,0.8l-1.3,1.6l-0.2,0.5l-0.1-0.8l-1,0.1l-0.4-0.5l-0.2-1.7l2.2-2.1L438.2,143z	"
        >
          <title id="t2050">Washington, OH</title>
        </path>
        <path
          id="FIPS_39009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M429.7,144.9l1.1-0.1l2.2,1l0.2,1.7l0.4,0.5l1-0.1l0.1,0.8l-0.2,0.4l-5.1,0.4l-0.1-1.2l-0.4,0
		l-0.2-2.3l1.1-0.1L429.7,144.9z	"
        >
          <title id="t2051">Athens, OH</title>
        </path>
        <path
          id="FIPS_39073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.4,144l2.3,1l0.1,1.2l-1.1,0.1l0.1,1.1l-2.2,0.2l0,0.3l-1.1,0.3l-1.1,0.1l-0.1-1.3
		l-0.1-1.1l0.2-0.2l0.9-0.7l1.1-0.9L427.4,144z	"
        >
          <title id="t2052">Hocking, OH</title>
        </path>
        <path
          id="FIPS_39141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M418.9,147l2.5-0.2l0.2,0.2l0.1,0.1l2.3-0.2l0.1,1.3l0.1,2.1l-0.2,0.5l-5.6,0.4l-0.5-2.3
		L418.9,147z	"
        >
          <title id="t2053">Ross, OH</title>
        </path>
        <path
          id="FIPS_39071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416,149.2l2.1-0.3l0.5,2.3l-0.1,1.9l-2.8,0.8l-2,0.2l-0.3-2.9L416,149.2z	"
        >
          <title id="t2054">Highland, OH</title>
        </path>

        <path
          id="FIPS_39027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.9,147.1l1.1,2.1l-2.5,2l-1.3,0.1h-0.1l-0.2-4.1L414.9,147.1z	"
        >
          <title id="t2058">Clinton, OH</title>
        </path>

        {/* <g
          className={`metroArea colorKey ${colorCode[19380]}`}
          id="FIPS_19380"
          // ref={f19380}
          data-color-code={colorCode[19380] ? colorCode[19380] : null}
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        > */}
        <path
          id="FIPS_39057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.8,144.2l0,0.7l0.1,2.2l-3,0.1l-1.4,0.1l0.1-3.6l0.7,0l0.4,0l1.1,0.1l0,0.3L414.8,144.2z	
		"
        >
          <title id="t2063">Greene, OH</title>
        </path>
        <path
          id="FIPS_39135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.4,143.3l0.6,4.2l-3.3,0.7l-0.2-2.1l-0.3-2.5L406.4,143.3z	"
        >
          <title id="t2061">Preble, OH</title>
        </path>
        <path
          id="FIPS_39113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.9,143.2l2.6-0.4l-0.1,0.2l0.1,0.2l0.1,0.1l1-0.1l0,0.4l-0.1,3.6l-2.5,0.2l-1.1,0.1
		l-0.6-4.2L406.9,143.2z	"
        >
          <title id="t2062">Montgomery, OH</title>
        </path>
        <path
          id="FIPS_39109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.4,139.7l4-0.3l0.1,1.9l0.1,2.1l-1,0.1l-0.1-0.1l-0.1-0.2l0.1-0.2l-2.6,0.4L406.4,139.7z	
		"
        >
          <title id="t2082">Miami, OH</title>
        </path>
        {/* </g> */}

        <path
          id="FIPS_39047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.8,144.9l4-0.2l0.2,2.3l-0.8,1.9l-2.1,0.3l-1.1-2.1L414.8,144.9z	"
        >
          <title id="t2064">Fayette, OH</title>
        </path>

        <path
          id="FIPS_39127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426,140.6l2.3-0.1l1.8,1.6l0.7,2.8l-1.1,0.1l-2.3-1l-0.1-1.1l-0.7-1.1l-0.5,0L426,140.6z	"
        >
          <title id="t2067">Perry, OH</title>
        </path>
        <path
          id="FIPS_39111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.1,139.6l1.1-0.1l2.3-0.2l0.7-0.1l0.1-0.1l0.1,1.7l-0.9,1.6l-0.8,1l0-0.4l-2.1,0.2
		l-0.4-0.3l-0.2-1.3l-0.4,0.1l-0.3-2.1L438.1,139.6z	"
        >
          <title id="t2068">Monroe, OH</title>
        </path>
        <path
          id="FIPS_39121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.9,138.5l0.1,1.1l-0.7,0.1l0.3,2.1l0.4-0.1l0.2,1.3l-2.9,0.7l-1.4-2l-0.1-1.1l1.1-0.1
		l-0.1-0.4l0.3-0.4l1.4-0.9l0.4-0.1L437.9,138.5z	"
        >
          <title id="t2069">Noble, OH</title>
        </path>
        <path
          id="FIPS_39115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.1,142.1l3.7-0.4l1.4,2l-2.2,2.1l-2.2-1L430.1,142.1z	"
        >
          <title id="t2070">Morgan, OH</title>
        </path>
        <path
          id="FIPS_39119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.3,137.1l4.6-0.5l0.3,2.9l0.4,0l0.1,1.1l0.1,1.1l-3.7,0.4l-1.8-1.6L428.3,137.1z	"
        >
          <title id="t2071">Muskingum, OH</title>
        </path>
        <path
          id="FIPS_39013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.9,135.3l1.7-0.3l0,1.6l-0.4,2.4l-0.1,0.1l-0.7,0.1l-2.3,0.2l-1.1,0.1l-0.1-1.1l-0.4-2.8
		L440.9,135.3z	"
        >
          <title id="t2072">Belmont, OH</title>
        </path>
        <path
          id="FIPS_39067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.8,132l0.7-0.1l0.1,0.6l0,0.1l0.3,2.8l-3.3,0.4l-1.2-0.4l-0.1-1.2l0.4-0.1l0.2-0.1
		l-0.2-1.6L439.8,132z	"
        >
          <title id="t2073">Harrison, OH</title>
        </path>
        <path
          id="FIPS_39059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.6,135.6l2.8-0.3l1.2,0.4l0.4,2.8l-1.1,0.1l-0.4,0.1l-1.4,0.9l-0.3,0.4l0.1,0.4l-1.1,0.1
		l-0.1-1.1l-0.4,0l-0.3-2.9l0.4,0l0.1-0.1l-0.1-0.8L433.6,135.6z	"
        >
          <title id="t2074">Guernsey, OH</title>
        </path>
        <path
          id="FIPS_39031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.8,133.4l4.6-0.5l0.1,1l0.9-0.1l0.2,1.9l-0.4,0.1l0.1,0.8l-0.1,0.1l-0.4,0l-4.6,0.5
		l-0.2-0.9L427.8,133.4z	"
        >
          <title id="t2075">Coshocton, OH</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "18140"
              ? `metroArea clickedArea state-oh`
              : `metroArea ${colorCode[18140]} state-oh`
          }
          id="FIPS_18140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39041"
            className="FIPS_18140 st0 state-oh"
            d="M417.5,135l2.2-0.2l2.8,0.7l0.1,0.9l0.2,2l-4,0.3l-0.2-1.3l-0.7,0.1l-0.2-1.7L417.5,135z	"
          >
            <title id="t2077">Delaware, OH</title>
          </path>
          <path
            id="FIPS_39045"
            className="FIPS_18140 st0 state-oh"
            d="M422.9,140.9l3.1-0.3l0.1,1.2l0.5,0l0.7,1.1l0.1,1.1l-1.1,0.1l-1.1,0.9l-0.9,0.7l-0.2,0.2
		l-1.1,0.1l-0.1-1.7l-0.1-1.3L422.9,140.9z	"
          >
            <title id="t2066">Fairfield, OH</title>
          </path>
          <path
            id="FIPS_39049"
            className="FIPS_18140 st0 state-oh"
            d="M422.8,138.5l0.1,2.4l-0.1,1.9l-4.1,0.3l-0.1-3.8l0.3-0.5L422.8,138.5z	"
          >
            <title id="t2078">Franklin, OH</title>
          </path>
          <path
            id="FIPS_39089"
            className="FIPS_18140 st0 state-oh"
            d="M422.6,136.5l2.7-0.2l0,0.2l1.1-0.1l1.6-0.2l0.2,0.9l0,3.3l-2.3,0.1l-3.1,0.3l-0.1-2.4
		L422.6,136.5z	"
          >
            <title id="t2076">Licking, OH</title>
          </path>
          <path
            id="FIPS_39097"
            className="FIPS_18140 st0 state-oh"
            d="M415.6,139.6l2.9-0.3l0.1,3.8l0.1,1.5l-4,0.2l0-0.7l0.9-3.2L415.6,139.6z	"
          >
            <title id="t2079">Madison, OH</title>
          </path>
          <path
            id="FIPS_39117"
            className="FIPS_18140 st0 state-oh"
            d="M420.8,131.1l1.2-0.3l1.3,1.9l0,0.7l0.2,2l-1,0.1l-2.8-0.7l0-0.7l0.3-2.1l0.9-0.1L420.8,131.1
		z	"
          >
            <title id="t2090">Morrow, OH</title>
          </path>
          <path
            id="FIPS_39129"
            className="FIPS_18140 st0 state-oh"
            d="M418.6,143.1l4.1-0.3l0.1,1.3l0.1,1.7l1.1-0.1l0.1,1.1l-2.3,0.2l-0.1-0.1l-0.2-0.2l-2.5,0.2
		l-0.2-2.3L418.6,143.1z	"
          >
            <title id="t2065">Pickaway, OH</title>
          </path>
          <path
            id="FIPS_39159"
            className="FIPS_18140 st0 state-oh"
            d="M414.8,134.6l1-0.1l1.7,0.6l0.1,0.9l0.2,1.7l0.7-0.1l0.2,1.3l-0.3,0.5l-2.9,0.3l-0.7-1.5
		L414.8,134.6z	"
          >
            <title id="t2088">Union, OH</title>
          </path>
        </g>

        <path
          id="FIPS_39023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.5,141.2l5.1-0.3l-0.9,3.2l-1.8-0.1l0-0.3l-1.1-0.1l-0.4,0l-0.7,0l0-0.4L410.5,141.2z	"
        >
          <title id="t2080">Clark, OH</title>
        </path>
        <path
          id="FIPS_39021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.9,138.2l0.7,1.5l0.1,1.3l-5.1,0.3l-0.2-3l2.3-0.1l0.6,0.2L414.9,138.2z	"
        >
          <title id="t2081">Champaign, OH</title>
        </path>

        <path
          id="FIPS_39149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.2,137.6l0.1-0.3l0.6-1.4l0.2,0l3-0.4l0.2,2.7l0.1,1.2l-4,0.3L406.2,137.6L406.2,137.6z	"
        >
          <title id="t2083">Shelby, OH</title>
        </path>
        <path
          id="FIPS_39037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.2,137.6l0.3,2l0.5,3.6l-0.6,0.1l-3.2,0.4l-0.1-1.1l-0.4-3.9l-0.1-0.5L406.2,137.6z	"
        >
          <title id="t2084">Darke, OH</title>
        </path>
        <path
          id="FIPS_39107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.4,133.4l0.7,4.2l0,0l-3.6,0.5l-0.3-2.8l-0.2-2L405.4,133.4z	"
        >
          <title id="t2085">Mercer, OH</title>
        </path>
        <path
          id="FIPS_39011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406,133.3l1.7-0.2l0,0.4l1.9-0.1l1.5-0.2l0.2,1.4l-1.1,0.9l-3,0.4l-0.2,0l-0.6,1.4l-0.1,0.3
		l-0.7-4.2L406,133.3z	"
        >
          <title id="t2086">Auglaize, OH</title>
        </path>
        <path
          id="FIPS_39091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.2,134.6l0.4,0.1l3.1-0.1l0,0.1l0.2,3.6l-1.7,0.1l-0.6-0.2l-2.3,0.1l-0.2-2.7L411.2,134.6
		z	"
        >
          <title id="t2087">Logan, OH</title>
        </path>

        <path
          id="FIPS_39101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M420.8,131.1l0.1,0.8L420,132l-0.3,2.1l0,0.7l-2.2,0.2l-1.7-0.6l-0.3-2.3l2.9-0.6L420.8,131.1
		z	"
        >
          <title id="t2089">Marion, OH</title>
        </path>

        <path
          id="FIPS_39083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M427.2,132l0.6,1.4l0.3,2.8l-1.6,0.2l-1.1,0.1l0-0.2l-2.7,0.2l-0.1-0.9l1-0.1l-0.2-2l0-0.7
		l2.8-0.5L427.2,132z	"
        >
          <title id="t2091">Knox, OH</title>
        </path>
        <path
          id="FIPS_39075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M432.5,129.9l0.1,0.4l-0.1,0.1l0.3,2.4l-0.4,0l-4.6,0.5l-0.6-1.4l0.7-1.4L432.5,129.9z	"
        >
          <title id="t2092">Holmes, OH</title>
        </path>
        <path
          id="FIPS_39157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.7,129.6l0.1,1.1l0.6-0.1l0.4,3.3l-0.2,0.1l-0.4,0.1l0.1,1.2l-2.8,0.3l-0.2-1.9l-0.9,0.1
		l-0.1-1l0.4,0l-0.3-2.4l0.1-0.1L435.7,129.6z	"
        >
          <title id="t2093">Tuscarawas, OH</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "15940"
              ? `metroArea clickedArea state-oh`
              : `metroArea ${colorCode[15940]} state-oh`
          }
          id="FIPS_15940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39019"
            className="FIPS_15940 st0 state-oh"
            d="M437.8,128.3l2.4,1.3l-0.4,2.4l-3.2,0.4l-0.2-1.7l-0.6,0.1l-0.1-1.1l0.7-0.1l-0.1-0.8l0.3-0.3
		L437.8,128.3z	"
          >
            <title id="t2094">Carroll, OH</title>
          </path>
          <path
            id="FIPS_39151"
            className="FIPS_15940 st0 state-oh"
            d="M434.3,125.4l2.9-0.5l0.5,3.3l-1.1,0.2l-0.3,0.3l0.1,0.8l-0.7,0.1l-3.2,0.7l-0.5-3.6
		L434.3,125.4z	"
          >
            <title id="t2097">Stark, OH</title>
          </path>
        </g>
        <path
          id="FIPS_39081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M440.2,129.6l1.9-0.1l0.9,2.3l-0.2,2.8l-0.1,0.4l-1.7,0.3l-0.3-2.8l0-0.1l-0.1-0.6l-0.7,0.1
		L440.2,129.6z	"
        >
          <title id="t2095">Jefferson, OH</title>
        </path>
        <path
          id="FIPS_39029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.9,125.2l0.1,0.6l0.4,2.7l-1.3,1l-1.9,0.1l-2.4-1.3l-0.4-2.3L442.9,125.2z	"
        >
          <title id="t2096">Columbiana, OH</title>
        </path>

        <path
          id="FIPS_39169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.5,125.9l0.5,0.9l0.5,3.2l-4.6,0.7l-0.6-4.2L431.5,125.9z	"
        >
          <title id="t2098">Wayne, OH</title>
        </path>
        <path
          id="FIPS_39005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.7,125.6l0.5,0.9l0.6,4.2l-0.7,1.4l-1.1,0.3l-0.3-2.2l-0.6-1l-0.4-0.9l-0.2-1.5l-0.1,0
		l0.8-1.1L426.7,125.6z	"
        >
          <title id="t2099">Ashland, OH</title>
        </path>
        <path
          id="FIPS_39139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.6,127.2l2.8-0.4l0.1,0l0.2,1.5l0.4,0.9l0.6,1l0.3,2.2l-2.8,0.5l-1.3-1.9L421.6,127.2z	"
        >
          <title id="t2100">Richland, OH</title>
        </path>
        <path
          id="FIPS_39033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421.6,127.2l0.5,3.7l-1.2,0.3l-2.4,0.4l-0.5-3.7l2.7-0.4L421.6,127.2z	"
        >
          <title id="t2101">Crawford, OH</title>
        </path>
        <path
          id="FIPS_39175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.9,128.2l2.9-0.4l0.5,3.7l-2.9,0.6l-0.2,0l-0.6-0.1l-0.2-1.5l-0.2,0L414.9,128.2z	"
        >
          <title id="t2102">Wyandot, OH</title>
        </path>
        <path
          id="FIPS_39065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.8,131l3.5-0.4l0.2,0l0.2,1.5l0.6,0.1l0.2,0l0.3,2.3l-1,0.1l0-0.1l-3.1,0.1l-0.4-0.1
		L410.8,131z	"
        >
          <title id="t2103">Hardin, OH</title>
        </path>
        <path
          id="FIPS_39003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.6,129.7l0.2,1.3l0.3,2.3l-1.5,0.2l-1.9,0.1l0-0.4l-1.7,0.2l0.3-2.3l1.1-0.2l1.1-0.3
		l0-0.4l1.1-0.3L410.6,129.7z	"
        >
          <title id="t2104">Allen, OH</title>
        </path>
        <path
          id="FIPS_39063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.2,126.5l4.4-0.6l0.3,2.2l-0.6,2.4l-3.5,0.4l-0.2-1.3L410.2,126.5z	"
        >
          <title id="t2105">Hancock, OH</title>
        </path>
        <path
          id="FIPS_39137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.2,126.5l0.4,3.2l-1.1,0.1l-1.1,0.3l0,0.4l-1.1,0.3l-1.1,0.2l-0.8-1.6l0.3-2.3l1.1-0.1
		L410.2,126.5z	"
        >
          <title id="t2106">Putnam, OH</title>
        </path>
        <path
          id="FIPS_39161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.6,129.9l3.9-0.5l0.8,1.6l-0.3,2.3l-0.6,0.1l-3.4-0.2l-0.3-2.5L401.6,129.9z	"
        >
          <title id="t2107">Van Wert, OH</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "49660"
              ? `metroArea clickedArea state-oh state-pa`
              : `metroArea ${colorCode[49660]} state-oh state-pa`
          }
          id="FIPS_49660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39099"
            className="FIPS_49660 st0 state-oh state-pa"
            d="M442.4,122.3l0.5,2.9l-5.4,0.8l-0.2-1.1l0.5-2l4.6-0.7L442.4,122.3z	"
          >
            <title id="t2108">Mahoning, OH</title>
          </path>
          <path
            id="FIPS_39155"
            className="FIPS_49660 st0 state-oh state-pa"
            d="M441.6,117.5l0,0.1l0.8,4.6l-4.6,0.7l-0.5-2.7l-0.3-2L441.6,117.5z	"
          >
            <title id="t2040">Trumbull, OH</title>
          </path>
          <path
            id="FIPS_42085"
            className="FIPS_49660 st0 state-oh state-pa"
            d="M441.6,117.7l4.9-0.8l0.7,4.1l-0.7,1.5l-0.6-0.5l-1.1,0l-2.5,0.4l0-0.1L441.6,117.7z	"
          >
            <title id="t2254">Mercer, PA</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "10420"
              ? `metroArea clickedArea state-oh`
              : `metroArea ${colorCode[10420]} state-oh`
          }
          id="FIPS_10420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39133"
            className="FIPS_10420 st0 state-oh"
            d="M433.6,120.8l3.7-0.6l0.5,2.7l-0.5,2l-2.9,0.5L433.6,120.8L433.6,120.8z	"
          >
            <title id="t2109">Portage, OH</title>
          </path>
          <path
            id="FIPS_39153"
            className="FIPS_10420 st0 state-oh"
            d="M433.6,120.8l0.7,4.6l-2.3,1.3l-0.5-0.9l-0.5-3.7l1.1-0.2l-0.3-0.5l-0.2-0.4L433.6,120.8z	"
          >
            <title id="t2110">Summit, OH</title>
          </path>
        </g>

        <path
          id="FIPS_39077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.9,123.6l4.8-0.6l0.5,2.8l-0.8,1.1l-2.8,0.4l-1,0.1L419.9,123.6z	"
        >
          <title id="t2112">Huron, OH</title>
        </path>
        <path
          id="FIPS_39147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M420,124l0.6,3.3l-2.7,0.4l-2.9,0.4l-0.3-2.2l-0.1-1.1L420,124z	"
        >
          <title id="t2113">Seneca, OH</title>
        </path>
        <path
          id="FIPS_39143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M414.1,121.6l0.7-0.1l0.1,0.6l2.6-0.3l1.1-0.2l0.1,0.4l1-0.1l0.4,2.2l-5.5,0.8L414.1,121.6z	"
        >
          <title id="t2114">Sandusky, OH</title>
        </path>

        <path
          id="FIPS_39069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.6,122.4l0.1,0.9l0.4,3.2l-3.3,0.4l-0.4-3.4l-1.1,0.1l-0.1-0.7L409.6,122.4z	"
        >
          <title id="t2116">Henry, OH</title>
        </path>
        <path
          id="FIPS_39125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.8,127.1l-0.3,2.3l-3.9,0.5l-0.4-3.4l3.3-0.4l1.2,0.4L405.8,127.1z	"
        >
          <title id="t2117">Paulding, OH</title>
        </path>
        <path
          id="FIPS_39039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405.4,123.7l1.1-0.1l0.4,3.4l-1.1,0.1l-0.1-0.6l-1.2-0.4l-3.3,0.4l0-0.2l-0.2-2L405.4,123.7z
			"
        >
          <title id="t2118">Defiance, OH</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "17460"
              ? `metroArea clickedArea state-oh`
              : `metroArea ${colorCode[17460]} state-oh`
          }
          id="FIPS_17460"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39035"
            className="FIPS_17460 st0 state-oh"
            d="M432.1,117.3l1,0.6l0.4,2.8h0l-2,0.3l0.2,0.4l0.3,0.5l-1.1,0.2l-1.8,0.3l-0.1-1l-0.9,0.1
		l-0.3-2l0.1,0.1l0,0l0.2,0.1l0.6,0l1.3-0.2l0.1,0l0.2-0.2l0.7-0.6l0.3-0.3l0.8-1L432.1,117.3z	"
          >
            <title id="t2121">Cuyahoga, OH</title>
          </path>
          <path
            id="FIPS_39055"
            className="FIPS_17460 st0 state-oh"
            d="M433.2,118l0.9-0.1l-0.1-0.9l1.6-0.3l0-0.9l0.9-0.2l0.4,2.7l0.3,2l-3.7,0.6L433.2,118z	"
          >
            <title id="t2119">Geauga, OH</title>
          </path>
          <path
            id="FIPS_39085"
            className="FIPS_17460 st0 state-oh"
            d="M436.3,113.7l0.3,1.8l-0.9,0.2l0,0.9l-1.6,0.3l0.1,0.9l-0.9,0.1l-1-0.6l0.4-0.6l0.4-0.5
		l0.3-0.3l0.6-0.5l2.1-1.4L436.3,113.7z	"
          >
            <title id="t2120">Lake, OH</title>
          </path>
          <path
            id="FIPS_39093"
            className="FIPS_17460 st0 state-oh"
            d="M427.8,119.6l0.3,2l0.9-0.1l0.1,1l-0.9,0.3l-1.6,1.9l0.1,0.9l-1.6,0.2l-0.5-2.8l-0.3-1.9
		L427.8,119.6z	"
          >
            <title id="t2122">Lorain, OH</title>
          </path>
          <path
            id="FIPS_39103"
            className="FIPS_17460 st0 state-oh"
            d="M431,122.1l0.5,3.7l-4.2,0.6l-0.5-0.9l-0.1-0.9l1.6-1.9l0.9-0.3L431,122.1z	"
          >
            <title id="t2111">Medina, OH</title>
          </path>
        </g>

        <path
          id="FIPS_39043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M421,120.8l0.9,0.7l0.6,0.3l0.5,0.1l0.1,0l0.2,0l0.2-0.1l0.3-0.2l0.7-0.5l0.3,1.9l-4.8,0.6
		l-0.3-1.8l-1,0.1l-0.1-0.4L421,120.8z	"
        >
          <title id="t2123">Erie, OH</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "45780"
              ? `metroArea clickedArea state-oh`
              : `metroArea ${colorCode[45780]} state-oh`
          }
          id="FIPS_45780"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_39051"
            className="FIPS_45780 st0 state-oh"
            d="M404.7,120.1l4.5-0.7l0.4,3l-4.4,0.6l-0.9-2.8L404.7,120.1z	"
          >
            <title id="t2126">Fulton, OH</title>
          </path>
          <path
            id="FIPS_39095"
            className="FIPS_45780 st0 state-oh"
            d="M410.4,119.2l2.9-0.5l2.9,1l-2.3,0.4l-1.5,0.2l-1.2,1.7l-0.3,0.5l-0.9,0.8l-0.3,0l-0.1-0.9
		l-0.4-3L410.4,119.2z	"
          >
            <title id="t2125">Lucas, OH</title>
          </path>
          <path
            id="FIPS_39123"
            className="FIPS_45780 st0 state-oh"
            d="M416.2,119.7l1,0.2l2.1,0.1l0.3-0.1l1.1,0.6l0.3,0.2l-2.4,0.8l-1.1,0.2l-2.6,0.3l-0.1-0.6
		l-0.7,0.1l-0.2-1.5L416.2,119.7z	"
          >
            <title id="t2124">Ottawa, OH</title>
          </path>
          <path
            id="FIPS_39173"
            className="FIPS_45780 st0 state-oh"
            d="M413.9,120.1l0.2,1.5l0.4,3.2l0.1,1.1l-4.4,0.6l-0.4-3.2l0.3,0l0.9-0.8l0.3-0.5l1.2-1.7
		L413.9,120.1z	"
          >
            <title id="t2115">Wood, OH</title>
          </path>
        </g>
        <path
          id="FIPS_39171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.5,120.8l3.9-0.6l0.9,2.8l0.1,0.7l-4.4,0.6l-0.2-1.3L400.5,120.8z	"
        >
          <title id="t2127">Williams, OH</title>
        </path>
        <path
          id="FIPS_40139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.7,186.5l5,0.2l1.2,0.1l-0.1,1.9l-0.1,0l-0.2,4.5l-1.3-0.1l-5.5-0.3l-4.2-0.3l0.4-6.4
		L236.7,186.5z	"
        >
          <title id="t2128">Texas, OK</title>
        </path>
        <path
          id="FIPS_40025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M221.9,185.5l1.3,0.1l5.3,0.4l3.2,0.2l0.1,0l-0.4,6.4l-1.3-0.1l-8.6-0.6L221.9,185.5z	"
        >
          <title id="t2129">Cimarron, OK</title>
        </path>
        <path
          id="FIPS_40115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.6,188l0,3l0,1.3l-3.9,0l-0.1-4.3L307.6,188z	"
        >
          <title id="t2130">Ottawa, OK</title>
        </path>
        <path
          id="FIPS_40035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303,188.1l0.7,0l0.1,4.3l0,2.1l-3.3,0l-1.1-1.1l0.2-5.2L303,188.1z	"
        >
          <title id="t2131">Craig, OK</title>
        </path>
        <path
          id="FIPS_40097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.7,194.4l0,4.5l-1.1,0l0,1.1l-0.9,0l-2.4,0l0-2.3l0-3.4l1.1,0L303.7,194.4z	"
        >
          <title id="t2132">Mayes, OK</title>
        </path>
        <path
          id="FIPS_40041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.7,192.3l0,2.2l0.6,4.4l-2.4,0l-2.2,0l0-4.5l0-2.1L307.7,192.3z	"
        >
          <title id="t2133">Delaware, OK</title>
        </path>
        <path
          id="FIPS_40001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.9,198.9l2.4,0l0.1,0.8l0.9,6l-3.5,0.1l0-3.4l0.1-1.4L305.9,198.9z	"
        >
          <title id="t2134">Adair, OK</title>
        </path>
        <path
          id="FIPS_40021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.7,198.9l2.2,0l0,2l-0.1,1.4l0,3.4l-3.3,0l-1.5-2.2l0,0l-0.2-1.2l0-0.7l0.1-0.1l0.2-0.2
		l0.1,0l0,0l0.3-0.6l0-0.5l0.9,0l0-1.1L303.7,198.9z	"
        >
          <title id="t2135">Cherokee, OK</title>
        </path>
        <path
          id="FIPS_40135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.4,205.7l0.5,3.1l0,0.2l-0.6,0.7l-2,0.1l-0.5-0.3l-0.2-0.1l-0.2,0l-0.1,0l-0.4,0.4l-1-1
		l-0.3,0l-0.5-0.1l-0.2-0.1l-0.2-0.1l-0.3-0.4l-0.8-2.3l3.3,0L309.4,205.7z	"
        >
          <title id="t2136">Sequoyah, OK</title>
        </path>
        <path
          id="FIPS_40061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M303.4,208.1l0.3,0.4l0.2,0.1l0.2,0.1l0.5,0.1l0.3,0l1,1l0,1.3l-0.8,0.3l-0.4,0l0,1.9l-4.4,0
		l0-1.3l-1.1,0l0-0.6l0-1.2l1.1,0l0.8,0.1l1-0.6l0.3-0.7l0.8-0.9L303.4,208.1z	"
        >
          <title id="t2137">Haskell, OK</title>
        </path>
        <path
          id="FIPS_40079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.9,209l-0.1,5.8l0,2.7l0,2.9l-5,0.1l-1.3-2.2l0-2.3l0.6-0.9l0.7-0.2l0-3.4l0.4,0l0.8-0.3
		l0-1.3l0.4-0.4l0.1,0l0.2,0l0.2,0.1l0.5,0.3l2-0.1L309.9,209z	"
        >
          <title id="t2138">Le Flore, OK</title>
        </path>
        <path
          id="FIPS_40077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.7,213.3l0,1.5L304,215l-0.6,0.9l0,2.3l-4.8,0V217l0-3.3l1.4,0l0.3-0.4L304.7,213.3z	"
        >
          <title id="t2139">Latimer, OK</title>
        </path>
        <path
          id="FIPS_40121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.2,210.2l0,1.2l0,0.6l1.1,0l0,1.3l-0.3,0.4l-1.4,0l0,3.3v1.2l-1.7,1.1l-2.2,0v-1.1h-2.2
		v-1.1l0-3.7l0.3-0.5l0.5-0.7l0.1-0.1l0.2,0l0.4,0l2.1-0.4l0.4-0.2l2-1.1L299.2,210.2z	"
        >
          <title id="t2140">Pittsburg, OK</title>
        </path>
        <path
          id="FIPS_40029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.5,217.1v3.4l-0.6,1.1l-2.8,0l-1.1-1.1l0-2.3h1.1l0-1.1L292.5,217.1z	"
        >
          <title id="t2141">Coal, OK</title>
        </path>
        <path
          id="FIPS_40005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.5,218.2h2.2v1.1l2.2,0l0,1.1l-1.1,0.1l0,4.5h-2.3l-4.4,0l0-3.4l2.8,0l0.6-1.1
		L292.5,218.2z	"
        >
          <title id="t2142">Atoka, OK</title>
        </path>
        <path
          id="FIPS_40127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.6,218.2l4.8,0l1.3,2.2l-1.2,0l0,3.4l-0.7,0l-0.5,0.2l0,0.9l-6.6,0l0-4.5l1.1-0.1l0-1.1
		L298.6,218.2z	"
        >
          <title id="t2143">Pushmataha, OK</title>
        </path>
        <path
          id="FIPS_40089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.7,220.4l5-0.1l0,4.1l0,7.2l-2.8-0.8l-1.3-0.5l-1.8-1.5l-1.2-1.1l0-2.8l0-0.9l0.5-0.2
		l0.7,0l0-3.4L304.7,220.4z	"
        >
          <title id="t2144">McCurtain, OK</title>
        </path>
        <path
          id="FIPS_40023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.4,225l0,2.8l-0.7-0.2l-0.1,0l0,0l0,0h0l-0.2,0.3l0,0v0l0,0l0,0l0,0.1v0l0,0.1l0,0.1
		l-0.1,0.1l-0.1,0.1l-0.3,0.2l-0.1,0l-0.2,0l-0.3,0h0l-0.7,0l-0.4,0l-1.1-0.1l0,0l0-0.1v0l0-0.1l0-0.1l0-0.1l-0.1-0.3l-0.1,0l-0.3,0
		l-0.8,0.4l-0.9,0.5l0,0l-0.9-0.1l-0.8-0.7l-0.2-0.2l0-0.1l0-2.3l-0.6-0.4h2.3L302.4,225z	"
        >
          <title id="t2145">Choctaw, OK</title>
        </path>
        <path
          id="FIPS_40013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.6,225l0.6,0.4l0,2.3l0,0.1l0.2,0.2l0.8,0.7l0.9,0.1l-0.9,0.3l-0.5-0.1l-0.6-0.1l-0.1,0
		l-0.2,0l-1.2,0.1l-0.5,0.1l-0.1,0.3l-0.1,0.3l0,0l0,0l0,0.1l0,0.1l0,0l0,0l-0.1,0.1l0,0l-0.2,0.1l-0.2,0.1l-1.6,0.4l-0.1-0.1
		L289,230v0l-0.1,0l-0.1,0l-0.5,0.1h0l-0.1-0.1l-1.1-0.7l0,0l0-0.1l0-0.2l0-0.2l0.3-3.2l1.9-0.5L293.6,225z	"
        >
          <title id="t2146">Bryan, OK</title>
        </path>
        <path
          id="FIPS_40095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.6,224.8l2.8,0l0.6,0.1l0.4,0.5v0.1l0,0.1l-0.3,3.2l-1.1,0.5l0,0l-0.5,0.1l-1-0.3
		l-0.1-0.1l-0.2-0.2l-0.5-1.1l-0.4-1.5L283.6,224.8z	"
        >
          <title id="t2147">Marshall, OK</title>
        </path>
        <path
          id="FIPS_40069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.8,220.5l3.3,0l1.1,1.1l0,3.4l-1.9,0.5l0-0.1v-0.1l-0.4-0.5l-0.6-0.1l-2.8,0l0-2.1h0.6
		l0-2.2L284.8,220.5z	"
        >
          <title id="t2148">Johnston, OK</title>
        </path>
        <path
          id="FIPS_40123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.3,215.2l0.9,1.9l0,1.1h-1.1l0,2.3l-3.3,0l0-1.1l-1.1,0l0-0.6l0-2.8l0-1.4l1.6,0.8
		L288.3,215.2z	"
        >
          <title id="t2149">Pontotoc, OK</title>
        </path>
        <path
          id="FIPS_40049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.7,215.9l0,2.8l-2.2,0l-0.5,0.2l0,0l0,0.1l0.1,0.2l0.2,0.1l0.1,0.4l0.1,0.6l-0.4,0.1
		l-1.8,0l-2.2,0l-1.1-2.3l0-2.3L283.7,215.9z	"
        >
          <title id="t2150">Garvin, OK</title>
        </path>
        <path
          id="FIPS_40099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.2,220.4l1.8,0l0.4-0.1l-0.1-0.6l-0.1-0.4l-0.2-0.1l-0.1-0.2l0-0.1l0,0l0.5-0.2l2.2,0
		l0,0.6l1.1,0l0,1.1l-0.6,0l0,2.2h-0.6l-1,0l-0.1-0.1l0-0.1v0l0.1-0.1l0-0.3l0,0l-3.3-0.1L279.2,220.4z	"
        >
          <title id="t2151">Murray, OK</title>
        </path>
        <path
          id="FIPS_40085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.9,226l6.3,0.1l0.4,1.5l-0.1,0.1l-1.6,2.8l0,0.1l-0.1,0.1l-0.2,0l-0.2,0l-0.1-0.1
		l-3.1-1.4l-0.1-0.1l-0.1-0.1v0l0,0l0-0.1l-0.2-1l-0.8,0.2L276.9,226z	"
        >
          <title id="t2152">Love, OK</title>
        </path>
        <path
          id="FIPS_40019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277,220.4l2.2,0l0,1.7l3.3,0.1l0,0l0,0.3l-0.1,0.1v0l0,0.1l0.1,0.1l1,0l0,2.1l-0.4,1.3
		l-6.3-0.1l0-2.8L277,220.4z	"
        >
          <title id="t2153">Carter, OK</title>
        </path>
        <path
          id="FIPS_40067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M270.8,223.1l6.1,0.1l0,2.8l0,2.2l-0.4-0.3l-1.1-0.7l-0.4,0.5l-0.6,0.6l-0.5,0.4l-0.3,0.1
		l-0.1,0l-0.9-0.4l-0.1-0.1l0.3-0.6l0.1-0.7l0,0l-0.4-0.2l-0.4,0.1l0,0h-0.2l-0.5-0.1l0,0l0,0l-0.2-0.4L270.8,223.1z	"
        >
          <title id="t2154">Jefferson, OK</title>
        </path>
        <path
          id="FIPS_40137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.9,218.1l1.1,2.3l0,2.8l-6.1-0.1l0-2.8l0.6-2.2L275.9,218.1z	"
        >
          <title id="t2155">Stephens, OK</title>
        </path>
        <path
          id="FIPS_40033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M265.3,221.4l0.6,0l1.1-0.2l2.2-0.3l0.6-0.5l0.4-0.2l0.7,0l0,2.8l0.3,3.3l-0.6-1.1l-1.6-0.5
		l-0.4-0.1l-0.2,0.1l-0.4,0.5l-0.6,0.5l0,0l0,0l-0.3-0.1l-0.5-0.8l-0.2-0.2l-0.2-0.2l-0.1,0l0.1-2.2l-0.6,0L265.3,221.4z	"
        >
          <title id="t2156">Cotton, OK</title>
        </path>
        <path
          id="FIPS_40031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M265.9,215.6l5.5,0.1l0,2.3l-0.6,2.2l-0.7,0l-0.4,0.2l-0.6,0.5l-2.2,0.3l-1.1,0.2l-0.6,0l0-1
		l-0.6-0.3l-1.1,0l0-1.1l0.1-3.4L265.9,215.6z	"
        >
          <title id="t2157">Comanche, OK</title>
        </path>
        <path
          id="FIPS_40141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.7,218.9l0,1.1l1.1,0l0.6,0.3l0,1l0,0.9l0.6,0l-0.1,2.2l-1,0.3l-0.7,0l-1-0.2l-1-0.6
		L262,224h0l-1-0.1l-0.4,0l-0.2,0l-0.4-0.1l-0.2-0.1l-0.1,0l0,0v0l-0.2-1l0-0.3l0-0.3l0.2,0l0-0.1v-0.1l-0.2-0.4l-0.1-0.1l-0.1,0
		l-0.1-0.2l0-0.3l0.2-0.9l0.4-0.9l0.2-0.3l0.2,0l0.4,0l0,0.1l0.1,0l0,0l0-0.3l-0.1-0.2l-0.1-0.2l0.7,0l0.4,0.4l0,0.1L263.7,218.9z	"
        >
          <title id="t2158">Tillman, OK</title>
        </path>
        <path
          id="FIPS_40065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.3,215.8l0.6-0.4l0.1,0l0,0l0.2,0.1l0,0.1l0.9,1.8l-0.5,0.8l0.1,0.2l0.1,0.2l0,0.3l0,0
		l-0.1,0l0-0.1l-0.4,0l-0.2,0l-0.2,0.3l-0.4,0.9l-0.2,0.9l0,0.3l0.1,0.2l0.1,0l0.1,0.1l0.2,0.4v0.1l0,0.1l-0.2,0v0l-0.5-0.9
		l-0.5-0.3l-0.5-0.3l-0.5,0.8l0,0l0,0h0l-0.1,0l-0.4,0l-0.3-0.3l-0.3-0.2l-0.2-0.1l-0.5-0.1l-0.1,0l-0.1,0l-0.4,0.5l-0.4,0h-0.1
		l-0.3-0.1l-0.7-0.7l-0.3-0.3l-0.6-0.7l1.9,0.1l0.1-2.8l1.5,0l1,0l0-0.1l0-0.3l0-0.1l0.4-0.6l1.6,0.1L259.3,215.8z	"
        >
          <title id="t2159">Jackson, OK</title>
        </path>
        <path
          id="FIPS_40075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M257.8,212l0.5,0l5.4,0.2l1.8,0l0.5,0.3l-0.1,3.1l-2.2-0.1l-0.1,3.4l-1.8-0.1l0-0.1l-0.4-0.4
		l-0.7,0l0.5-0.8l-0.9-1.8l0-0.1l-0.2-0.1l0,0l-0.1,0l-0.6,0.4l-0.6-0.6l-0.1-0.1l-0.1-1.5l0.1-0.4l0-0.3l-0.4-0.7L257.8,212z	"
        >
          <title id="t2160">Kiowa, OK</title>
        </path>
        <path
          id="FIPS_40055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.7,212.9l1.1,0.1l0-1.1l3.5,0.1l0.4,0l0.4,0.4l0.4,0.7l0,0.3l-0.1,0.4l0.1,1.5l0.1,0.1
		l0.6,0.6l0,0.1l-1.6-0.1l-0.4,0.6l0,0.1l0,0.3l0,0.1l-1,0l-1.5,0l-0.6-2.9l-1.7-0.1L252.7,212.9z	"
        >
          <title id="t2161">Greer, OK</title>
        </path>
        <path
          id="FIPS_40057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M251.5,212.8l1.2,0l0,1.1l1.7,0.1l0.6,2.9l-0.1,2.8l-1.9-0.1l-1.5-0.8l0.1-2.4L251.5,212.8z	"
        >
          <title id="t2162">Harmon, OK</title>
        </path>
        <path
          id="FIPS_40101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.9,203l1.2,0l1.8,0.7l1.6-0.1h0.6l1.5,2.2l0.8,2.3l-0.2,0.1l-0.8,0.9l-0.3,0.7l-1,0.6
		l-0.8-0.1l0-3.4l-3.8,0l0-2.3l-0.6,0L295.9,203z	"
        >
          <title id="t2163">Muskogee, OK</title>
        </path>
        <path
          id="FIPS_40091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M296.5,206.9l3.8,0l0,3.4l-1.1,0l-0.7,0.2l-2,1.1l-0.4,0.2l-2.1,0.4l-0.4,0l0-1.8v-1.1l1.1,0
		v-0.4l0.2-0.8l0.4-1.1L296.5,206.9z	"
        >
          <title id="t2164">McIntosh, OK</title>
        </path>
        <path
          id="FIPS_40063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.9,210.3l4.8,0l0,1.8l-0.2,0l-0.1,0.1l-0.5,0.7l-0.3,0.5l0,3.7l-3.3,0l-0.9-1.9l0-2.7
		l0.5,0L288.9,210.3z	"
        >
          <title id="t2165">Hughes, OK</title>
        </path>
        <path
          id="FIPS_40133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M287,208.9L287,208.9l0.1,0.1l0.8,0.1l0,0l0-0.1l0-0.2l0.1-0.4l0.6-0.2l0.3-0.1l0,2.3l0,2.3
		l-0.5,0l0,2.7l-3,0.1l0-6.6l0.5-0.2L287,208.9z	"
        >
          <title id="t2166">Seminole, OK</title>
        </path>
        <path
          id="FIPS_40125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M281.6,208l5.4,0.1l0,0.8l-1-0.3l-0.5,0.2l0,6.6l-1.6-0.8l-2.2,0.4l0.1-5.8L281.6,208z	"
        >
          <title id="t2167">Pottawatomie, OK</title>
        </path>

        <path
          id="FIPS_40015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269.4,206.6L269.4,206.6l0.1,0.1l0,2.1l2.2,0l-0.1,6.8l-5.5-0.1l0.1-3.1l0-0.1l0-1.3l0-1.3
		l0.1-2l0-1.1L269.4,206.6z	"
        >
          <title id="t2171">Caddo, OK</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36420"
              ? `metroArea clickedArea state-ok`
              : `metroArea ${colorCode[36420]} state-ok`
          }
          id="FIPS_36420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_40017"
            className="FIPS_36420 st0 state-ok"
            d="M270.5,204.4l5.5,0.1l0,4.5l0,0.5v0l-0.4,0.1l-0.3,0l-1.1-0.1l-1.2-0.2l-1.4-0.4l-2.2,0l0-2.1
		l0-0.1h-0.1L270.5,204.4z	"
          >
            <title id="t2172">Canadian, OK</title>
          </path>
          <path
            id="FIPS_40027"
            className="FIPS_36420 st0 state-ok"
            d="M276,209l5.5,0.1l-0.1,5.8l-0.6,0l-1.3-0.4l-0.1-0.1l-0.1-0.1l-0.1-0.2l-0.1-0.7l-0.2-0.6
		l-0.5-0.8l-2.1-2.1l-0.5-0.4L276,209z	"
          >
            <title id="t2168">Cleveland, OK</title>
          </path>
          <path
            id="FIPS_40081"
            className="FIPS_36420 st0 state-ok"
            d="M287,201.9l0,3.9l-0.1,2.3l-5.4-0.1l0-3.4l0-2.8L287,201.9z	"
          >
            <title id="t2174">Lincoln, OK</title>
          </path>
          <path
            id="FIPS_40083"
            className="FIPS_36420 st0 state-ok"
            d="M276.2,198.8l2.2,0l1.1,0.1l0,2.3l2.2,0.6l0,2.8l-5.5-0.1L276.2,198.8z	"
          >
            <title id="t2184">Logan, OK</title>
          </path>
          <path
            id="FIPS_40087"
            className="FIPS_36420 st0 state-ok"
            d="M276,209.6l0.5,0.4l2.1,2.1l0.5,0.8l0.2,0.6l0.1,0.7l0.1,0.2l0.1,0.1l0.1,0.1l1.3,0.4l0.6,0
		l2.2-0.4l0,1.4l-7.7-0.1L276,209.6L276,209.6z	"
          >
            <title id="t2169">McClain, OK</title>
          </path>
          <path
            id="FIPS_40051"
            className="FIPS_36420 st0 state-ok"
            d="M271.6,208.9l1.4,0.4l1.2,0.2l1.1,0.1l0.3,0l0.4-0.1l-0.1,6.2l0,2.3l-4.4-0.1l0-2.3
		L271.6,208.9z	"
          >
            <title id="t2170">Grady, OK</title>
          </path>
          <path
            id="FIPS_40109"
            className="FIPS_36420 st0 state-ok"
            d="M276.1,204.5l5.5,0.1l0,3.4l0,1.1L276,209L276.1,204.5z	"
          >
            <title id="t2173">Oklahoma, OK</title>
          </path>
        </g>

        <path
          id="FIPS_40107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M291.5,205.8l0,1.1l1.1,0l0,2.3h1.1v1.1l-4.8,0l0-2.3l-0.3,0.1l-0.6,0.2l-0.1,0.4l0,0.2l0,0.1
		l0,0l-0.8-0.1l-0.1,0l-0.1-0.1l0-0.8l0.1-2.3L291.5,205.8z	"
        >
          <title id="t2175">Okfuskee, OK</title>
        </path>

        <path
          id="FIPS_40105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M298.4,188.1l1.2,0l-0.2,5.2l-3.9,0l0.2-5.2L298.4,188.1z	"
        >
          <title id="t2179">Nowata, OK</title>
        </path>
        <path
          id="FIPS_40147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M293.9,188.1l1.8,0l-0.2,5.2l0,2.3h-1.9l0-7.5L293.9,188.1z	"
        >
          <title id="t2180">Washington, OK</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "46140"
              ? `metroArea clickedArea state-ok`
              : `metroArea ${colorCode[46140]} state-ok`
          }
          id="FIPS_46140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_40037"
            className="FIPS_46140 st0 state-ok"
            d="M287.1,199l3.3,0v1.1l2.8,0l0,2.3l0,0.6l-1.7,0l0,2.8l-4.5,0l0-3.9L287.1,199z	"
          >
            <title id="t2182">Creek, OK</title>
          </path>
          <path
            id="FIPS_40111"
            className="FIPS_46140 st0 state-ok"
            d="M295.9,203l0,1.7l0.6,0l0,2.3l-1.1,0l-0.4,1.1l-0.2,0.8v0.4l-1.1,0h-1.1l0-2.3l-1.1,0l0-1.1
		l0-2.8l1.7,0l2.2,0L295.9,203z	"
          >
            <title id="t2176">Okmulgee, OK</title>
          </path>
          <path
            id="FIPS_40117"
            className="FIPS_46140 st0 state-ok"
            d="M283.9,197.9l0-1.1l-1.1,0l0-2.3l0.2,0l0,0.3l0.2,0.3l0.1,0.1l0.3,0.1l2.6,0.4l3.6,2.6
		l0.7,0.9l-0.3,0l-3.3,0h-2l0-1.1L283.9,197.9z	"
          >
            <title id="t2197">Pawnee, OK</title>
          </path>
          <path
            id="FIPS_40113"
            className="FIPS_46140 st0 state-ok"
            d="M285.8,188.1l2.3,0l5.4,0l0,7.5v3.4l-2.8,0l-0.7-0.9l-3.6-2.6l-2.6-0.4l-0.3-0.1l-0.1-0.1
		l-0.2-0.3l0-0.3l-0.5-1.1l0.1-0.6l0.5-0.6l1.5-0.7l0.2,0l0.1,0l0.8-0.5L285.8,188.1z	"
          >
            <title id="t2198">Osage, OK</title>
          </path>
          <path
            id="FIPS_40145"
            className="FIPS_46140 st0 state-ok"
            d="M299.3,200.1l2.4,0l0,0.5l-0.3,0.6l0,0l-0.1,0l-0.2,0.2l-0.1,0.1l0,0.7l0.2,1.2l0,0h-0.6
		l-1.6,0.1l-1.8-0.7l-1.2,0l-0.6,0l0.6-4l1.5,0l0.5,0.6l0.1,0.2l0,0.2l-0.2,0l0,0.1l0.1,0L299.3,200.1z	"
          >
            <title id="t2177">Wagoner, OK</title>
          </path>
          <path
            id="FIPS_40131"
            className="FIPS_46140 st0 state-ok"
            d="M295.5,193.3l3.9,0l1.1,1.1l-1.1,0l0,3.4l0,2.3l-1.4,0l-0.1,0l0-0.1l0.2,0l0-0.2l-0.1-0.2
		l-0.5-0.6l-1.5,0l-0.5-3.4L295.5,193.3z	"
          >
            <title id="t2178">Rogers, OK</title>
          </path>
          <path
            id="FIPS_40143"
            className="FIPS_46140 st0 state-ok"
            d="M293.5,195.6h1.9l0.5,3.4l-0.6,4l-2.2,0l0-0.6l0-2.3l-2.8,0V199l0.3,0l2.8,0L293.5,195.6z	"
          >
            <title id="t2181">Tulsa, OK</title>
          </path>
        </g>
        <path
          id="FIPS_40119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.9,197.9l1.1,0l0,1.1h2l0,2.8l-5.4-0.1l-2.2-0.6l0-2.3l2.2,0l0-1.1L283.9,197.9z	"
        >
          <title id="t2183">Payne, OK</title>
        </path>

        <path
          id="FIPS_40073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M270.6,198.7l1.1,0l4.4,0.1l-0.1,5.7l-5.5-0.1l0.1-2.3l0-1.9L270.6,198.7z	"
        >
          <title id="t2185">Kingfisher, OK</title>
        </path>
        <path
          id="FIPS_40011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.2,198.6l4.4,0.1l0,1.6l0,1.9l-0.1,2.3l-1.2,2.2l-3.2-0.1v-3.4L266.2,198.6z	"
        >
          <title id="t2186">Blaine, OK</title>
        </path>
        <path
          id="FIPS_40149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.1,207.7l-0.1,2l0,1.3l0,1.3l0,0.1l-0.5-0.3l-1.8,0l-5.4-0.2l0.1-4.5L266.1,207.7z	"
        >
          <title id="t2187">Washita, OK</title>
        </path>
        <path
          id="FIPS_40009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.4,206.9l0,0.6l-0.1,4.5l-0.5,0l-0.4,0l-3.5-0.1l0,1.1l-1.1-0.1l-1.2,0l0.1-2l0.1-3.1
		l4.4,0.2l0-1.1L258.4,206.9z	"
        >
          <title id="t2188">Beckham, OK</title>
        </path>
        <path
          id="FIPS_40039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.4,202.9l7.7,0.2v3.4l0,1.1l-7.7-0.3l0-0.6L258.4,202.9z	"
        >
          <title id="t2189">Custer, OK</title>
        </path>
        <path
          id="FIPS_40043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.9,198.5l3.3,0.1l-0.1,4.6l-7.7-0.2l0-2.6l0.1-2L262.9,198.5z	"
        >
          <title id="t2190">Dewey, OK</title>
        </path>
        <path
          id="FIPS_40129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.5,200.3l0,2.6l0,3.9l-2.2-0.1l0,1.1l-4.4-0.2l0.1-2.6l0.1-3.4l1-0.6l1.1,0.3l0.2,0.3
		l0.1,0.1l0.5,0.3l0.3,0.1l0.5,0.1l0.2,0l0.6-0.3l0,0l0.5-0.8l0.2-0.6l0-0.1l0.1-0.1l0.3-0.2l0.2-0.1l0.3-0.1H258.5z	"
        >
          <title id="t2191">Roger Mills, OK</title>
        </path>
        <path
          id="FIPS_40045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.4,192.7l-0.2,4.5l0.1,1.1l2.2,0.1l-0.1,2H258l-0.3,0.1l-0.2,0.1l-0.3,0.2l-0.1,0.1l0,0.1
		l-0.2,0.6l-0.5,0.8l0,0l-0.6,0.3l-0.2,0l-0.5-0.1l-0.3-0.1l-0.5-0.3l-0.1-0.1l-0.2-0.3l-1.1-0.3l-1,0.6l0.1-2.3l0.2-5.8l0.1-1.2
		L256.4,192.7z	"
        >
          <title id="t2192">Ellis, OK</title>
        </path>
        <path
          id="FIPS_40153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.4,192.7l3.2,0.1l0.1-2.9l0,0.2l0.2,0.2l0.2,0.1l0.9,0l0.1,0l0.1,0.1l1.7,2.4l0,1.2
		l-0.1,4.5l-4.4-0.2l-2.2-0.1l-0.1-1.1L256.4,192.7z	"
        >
          <title id="t2193">Woodward, OK</title>
        </path>
        <path
          id="FIPS_40093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.8,194.9l-0.1,3.9l-1.1,0l-4.4-0.1l-3.3-0.1l0.1-4.5l1.2,0l0.2,0.5l0.1,0.1l0.2,0.1
		l0.9,0.5l0.6,0.3l0.2,0.1l0.2,0l0.7-0.1l0-0.9L271.8,194.9z	"
        >
          <title id="t2194">Major, OK</title>
        </path>
        <path
          id="FIPS_40047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.5,193.3L278.5,193.3l-0.1,5.6l-2.2,0l-4.4-0.1l0.1-3.9l0-1.7L278.5,193.3z	"
        >
          <title id="t2195">Garfield, OK</title>
        </path>
        <path
          id="FIPS_40103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M282.6,193.3l0.5,1.1l-0.2,0l0,2.3l1.1,0l0,1.1l-2.2,0l0,1.1l-2.2,0l-1.1-0.1l0.1-5.6
		L282.6,193.3z	"
        >
          <title id="t2196">Noble, OK</title>
        </path>

        <path
          id="FIPS_40071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.5,188l3.2,0l4.1,0l0,2.8l-0.8,0.5l-0.1,0l-0.2,0l-1.5,0.7l-0.5,0.6l-0.1,0.6l-4.2,0h0
		L278.5,188z	"
        >
          <title id="t2199">Kay, OK</title>
        </path>
        <path
          id="FIPS_40053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.1,188l3.5,0.1l-0.1,5.3l-6.6-0.1l-0.1,0l0.1-4.5l0-0.7L275.1,188z	"
        >
          <title id="t2200">Grant, OK</title>
        </path>
        <path
          id="FIPS_40003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269.5,187.8l2.4,0.1l0,0.7l-0.1,4.5l0.1,0l0,1.7l-4.4-0.1l0.1-7L269.5,187.8z	"
        >
          <title id="t2201">Alfalfa, OK</title>
        </path>
        <path
          id="FIPS_40151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.2,187.5l4.7,0.2l4.7,0.1l-0.1,7l0,0.9l-0.7,0.1l-0.2,0l-0.2-0.1l-0.6-0.3l-0.9-0.5
		l-0.2-0.1l-0.1-0.1l-0.2-0.5l-1.2,0l0-1.2l-1.7-2.4l-0.1-0.1l-0.1,0l-0.9,0l-0.2-0.1l-0.2-0.2l0-0.2L258.2,187.5z	"
        >
          <title id="t2202">Woods, OK</title>
        </path>
        <path
          id="FIPS_40059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.6,187.2l4.7,0.2l0.9,0l1.6,2.4l-0.1,2.9l-3.2-0.1l-4.1-0.2L252.6,187.2z	"
        >
          <title id="t2203">Harper, OK</title>
        </path>
        <path
          id="FIPS_40007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M242.9,186.8l3.2,0.1l5.6,0.2l0.9,0l-0.2,5.3l-0.1,1.2l-5.6-0.2l-4.2-0.2l0.2-4.5l0.1,0
		L242.9,186.8z	"
        >
          <title id="t2204">Beaver, OK</title>
        </path>
        <path
          id="FIPS_41007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M51.2,34.4l-1.3,4.5l-1.1-0.3l-2-0.6l0,0l0-0.1l-2.1-0.6l1.2-2.7l0.1-0.4l0.1-0.4l0-0.5l0-0.1
		l3.5-0.5l0.4-0.1l0-0.1l0.6,0l0,0l0,0l0,0.1l0.1,0.2l0.1,0.3l-0.2,0.6L51.2,34.4L51.2,34.4z	"
        >
          <title id="t2205">Clatsop, OR</title>
        </path>

        <path
          id="FIPS_41015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M34.8,74.8l0.8,0.3l0,0l-0.2,0.1l-1.4,1.4l0,0.1l0.1,0.1v0.1l0,0.1l-0.9,1L33,78.2l-0.4,0
		l-0.5-0.2l0,0L32,79.8l0.4,0.2l0.4,0.5l0.1,1.1l0,0.3l-0.2,0.4l-0.2,0.3l-0.6,1.3l0,0.4l0.1,0.3l-3.6-1.1l-0.4-0.7l-0.4-1.3
		l0.1-2.8l0.3-1.1l0.3-0.7l0.1-0.2l0.1-3.5l0-1.2l1.1-1.2l2,0.6l0,0.1l0.4,1.1l0,0.7l-0.1,0.1l-0.1,0.3l-0.1,0.6l-0.1,0.9l0,0.1
		l1.3,0.1l0.7-0.4l0.1-0.1l0.1-0.4l0.7,0L34.8,74.8z	"
        >
          <title id="t2207">Curry, OR</title>
        </path>
        <path
          id="FIPS_41011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M34.8,74.8l-0.3-0.1l-0.7,0l-0.1,0.4l-0.1,0.1l-0.7,0.4l-1.3-0.1l0-0.1l0.1-0.9l0.1-0.6
		l0.1-0.3l0.1-0.1l0-0.7l-0.4-1.1l0-0.1l-2-0.6l4.8-7.4L36,64l1.3,0.4l0.3,2.5l-0.1,2.3l-0.6,2.1l-0.7,0.5l-0.5,0.3l-0.2,0l-0.6,2.1
		L34.8,74.8z	"
        >
          <title id="t2208">Coos, OR</title>
        </path>
        <path
          id="FIPS_41033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M39.8,77.4l-2.6,8.7l-2.6-0.7l-2.8-0.8l-0.1-0.3l0-0.4l0.6-1.3l0.2-0.3l0.2-0.4l0-0.3
		l-0.1-1.1L32.4,80L32,79.8l0.1-1.9l0,0l0.5,0.2l0.4,0l0.2-0.1l0.9-1l0-0.1v-0.1l-0.1-0.1l0-0.1l1.4-1.4l0.2-0.1l0,0l-0.2,0.6
		l1.5,0.8l0.4,0.2l0.3,0.1l0.5-0.1l0.1-0.1h0.4l0.8,0.3l0.2,0.2L39.8,77.4z	"
        >
          <title id="t2209">Josephine, OR</title>
        </path>
        <path
          id="FIPS_41029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M49.4,76.3l-1.8,6.2l-0.2,0.8l-1.5,5.4l-0.5-0.2L45,88.3L43.9,88l-1.2-0.3l-3.1-0.9l-0.2-0.1
		l-0.4-0.1l-1-0.4l-0.7-0.1l0,0l2.6-8.7l0-0.1l0.9-0.4l0.4,0.1l0.9,0.2l2,0.3l1.4-0.8l1.3-0.6l1.7-0.3L49.4,76.3z	"
        >
          <title id="t2210">Jackson, OR</title>
        </path>
        <path
          id="FIPS_41019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M52.3,71.1l0.2,0.1l0.2,0.2l0.4,1l0,0.2l0,1l-1.6,1.9l-1.8-0.2l-0.2,0.9l-1.1-0.3l-1.7,0.3
		l-1.3,0.6L44,77.6l-2-0.3L41,77.1L40.7,77l-0.9,0.4l0,0.1l-0.1-0.3l-0.2-0.2l-0.8-0.3h-0.4l-0.1,0.1l-0.5,0.1l-0.3-0.1L37,76.5
		l-1.5-0.8l0.2-0.6l-0.8-0.3l0.1-0.5l0.6-2.1l0.2,0l0.5-0.3l0.7-0.5l0.6-2.1l0.1-2.3l-0.3-2.5L36,64l-1.7-0.5l1.5-3l0.8,0.3l1,0.3
		l0.3,0l1.2-0.7l1.1,0.3l0.4,0.2l0.2,0.5l0,0.2l0.6,1l0.4,0.4l1,0.7l1.9,0.6l-0.6,2.2l0,0.9l0.9,0.3l0.1,0l0,0l1,0.3l1.2,0.4
		l-0.4,1.3l2.2,0.6L52.3,71.1z	"
        >
          <title id="t2211">Douglas, OR</title>
        </path>
        <path
          id="FIPS_41035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M54.1,69.3l6,1.7l-0.9,3.2L59,74.7l-0.4,1l-1.1,3.8L57,81.7l3,0.8l1.2,0.4l-2.5,9.4l-5.2-1.5
		l-7.7-2.3l1.5-5.4l0.2-0.8l1.8-6.2l0.2-0.9l1.8,0.2l1.6-1.9l0-1l0-0.2l-0.4-1l-0.2-0.2l-0.2-0.1L54.1,69.3	"
        >
          <title id="t2212">Klamath, OR</title>
        </path>
        <path
          id="FIPS_41037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M60.1,70.9l3.1,0.8l0.1,0l5.8,1.6l3.9,1L73,74.7l-1,3.4l-0.7,1.6L70.4,83l-0.6,2.1l1.5,0.4
		l0.7,0.2l3.1,0.8l-1.5,6.1l-0.4,1.6L72.8,96l-5.9-1.5l-2.7-0.7l-0.4-0.1l-3.4-0.9l0,0l-1.7-0.5l2.5-9.4L60,82.6l-3-0.8l0.6-2.2
		l1.1-3.8l0.4-1l0.2-0.5L60.1,70.9z	"
        >
          <title id="t2213">Lake, OR</title>
        </path>
        <path
          id="FIPS_41025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M76.3,70.6l7.6,1.9l0.3-1.1l1.4,0.4l0.7,0.2l3.2,0.8L88.7,76l-0.1,0.4L88.2,78l-0.8,3.5
		l-1.3,5.5l-0.6,2.7L84.3,95l0.1,0.2l-0.1,0.5l-0.7,2.8l-5.4-1.2L73.1,96L72.8,96l0.5-1.8l0.4-1.6l1.5-6.1L72,85.7l-0.7-0.2
		l-1.5-0.4l0.6-2.1l0.9-3.3l0.7-1.6l1-3.4l0.1-0.3l0.3-1.1l1.1,0.3l0.9-3.3L76.3,70.6z	"
        >
          <title id="t2214">Harney, OR</title>
        </path>
        <path
          id="FIPS_41045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M90.1,70l0.4,0.1l0.4-0.1l0.7-0.6l0.7-0.6l0.1-0.3l0.2-0.1l0.4-0.1l3.4,0.8l0.5,0.5l0.3,0.4
		L96.9,71l2.6,0.6l0,0.1l0,0.1l0,0.2l0.1,0.2l1.1,0.5l0.1,0h0l0.4,0.1l0.1,0.1l0.5,0.9l0,0l0,0.1l0,0.1v0l0,0l0,0l0,0l0,0l-0.5,0.6
		l-0.4,1.4l-0.4,0.8l-0.3,0.5l-1,2.4L94.5,101l-10.9-2.5l0.7-2.8l0.1-0.5L84.3,95l1.2-5.4l0.6-2.7l1.3-5.5l0.8-3.5l0.4-1.5l0.1-0.4
		l0.8-3.3L90.1,70z	"
        >
          <title id="t2215">Malheur, OR</title>
        </path>
        <path
          id="FIPS_41001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M92,61.2l0.4-0.3l0.8-0.5l0.2,0l0.4,0.5l0.5,0.4l0.1,0l1.9,0.5l1.9,0.4l0.3-1.1l2.6,0.6l4.3,1
		L105,63l-0.3,0.3l-0.2,0.5l0,0.3l0,0.1l0.1,0.1l0,0.1l0,0l-0.3,0.5l-0.2,0.2l-0.3,0.3l-0.5,0.5l-0.9,0.3l-0.2,0l-0.1,0l-0.2,0.2
		l-2,2.7l-0.1,0.2l-0.3,2.1L96.9,71l0.2-1.1l-0.3-0.4L96.4,69L93,68.2l-0.4,0.1l-0.2,0.1l-0.1,0.3l-0.7,0.6L90.8,70l-0.4,0.1
		L90.1,70l-2.4-0.6l0.1-0.3l0-0.1l1.2-1.8l0.1-0.1l0.5-0.5l0.7-0.8l0.1-0.2l1.6-3.4l0.1-0.5l0-0.3L92,61.2z	"
        >
          <title id="t2216">Baker, OR</title>
        </path>
        <path
          id="FIPS_41063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M97.5,48.6l3.3,0.8l1.1,0.3l4.9,1.2l0.6,2l0,0.1l0,0l0.4,0.4l0.8,0.7l0.3,0.1l0,0l0.2,0.2
		l0.2,0.2v0l0.1,0.2l0.3,1.6l0,0.2l-0.2,0.2l-0.9,0.9l-1.6,2l-0.3,0.6l-1.3,2.2l-4.3-1l0.2-1.1l-1.9-0.4l-0.1-1.4l-0.1-0.4L99,57.8
		l-0.3-0.1l-0.1-0.4l-0.2-0.9l-0.1-1.2l0-2.3l0.2-1.1l0.3-0.3l0.3-0.7l-2-0.5L97.5,48.6z	"
        >
          <title id="t2217">Wallowa, OR</title>
        </path>
        <path
          id="FIPS_41061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M97.1,50.4l2,0.5l-0.3,0.7l-0.3,0.3l-0.2,1.1l0,2.3l0.1,1.2l0.2,0.9l0.1,0.4l0.3,0.1l0.2,0.6
		l0.1,0.4l0.1,1.4l1.9,0.4l-0.2,1.1l-2.6-0.6l-0.3,1.1l-1.9-0.4l-1.9-0.5l-0.1,0l-0.5-0.4l-0.4-0.5l-0.2,0l-0.8,0.5L92,61.2
		l-2.3-1.1L90,59l0.1-1.5l-1-0.2l-0.2-0.9l0.3-1.1l0.8,0.1l1.6,0.4l2.2-0.4l0.7-0.4l0.3-0.5l0.5-2.2l1-1.5L97.1,50.4z	"
        >
          <title id="t2218">Union, OR</title>
        </path>
        <path
          id="FIPS_41023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M79.5,57.6l4.5,1.1l5.7,1.4l2.3,1.1l0,0.3l0,0.3L92,62.2l-1.6,3.4l-0.1,0.2l-0.7,0.8L89,67.1
		l-0.1,0.1l-1.2,1.8l0,0.1l-0.1,0.3l2.4,0.6l-0.6,2.7L86.2,72l-0.7-0.2l-1.4-0.4l-0.3,1.1l-7.6-1.9l1.1-4.4l1.7-6.5l0-0.9L79.5,57.6
		z	"
        >
          <title id="t2219">Grant, OR</title>
        </path>
        <path
          id="FIPS_41069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M72.5,54.8l6.2,1.6l0.8,1.2l-0.3,1.3l0,0.9l-1.7,6.5l-2-0.5l0-1l-0.9-1l-3.2-0.8l0.1-0.5
		l0.3-1.1l1-3.2L72.5,54.8z	"
        >
          <title id="t2220">Wheeler, OR</title>
        </path>
        <path
          id="FIPS_41013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M71.8,61.3l-0.3,1.1l-0.1,0.5l3.2,0.8l0.9,1l0,1l2,0.5l-1.1,4.4l-1.1-0.3l-0.9,3.3l-1.1-0.3
		l-3.1-0.8l-0.2-0.1l0.3-1.1L69.6,70l-3.3-0.9l0.3-1.1l-0.9-0.2l-1.2-0.4l0.6-2.2L64,65l0.2-1l0.6-2.1l1.1,0.3l0.3-1.1l1.4,0.4
		l0.3-1.1L71.8,61.3z	"
        >
          <title id="t2221">Crook, OR</title>
        </path>
        <path
          id="FIPS_41017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M58.3,60l6.5,1.8l-0.6,2.1L64,65l1,0.3l-0.6,2.2l1.2,0.4l0.9,0.2l-0.3,1.1l3.3,0.9l0.8,1.4
		l-0.3,1.1l0.2,0.1l3.1,0.8l-0.3,1.1l-3.9-1l-5.8-1.6l-0.1,0l-3.1-0.8l-6-1.7l0.3-0.4l0.3-0.6l0.4-1.2l1.2-1.2l1.5-1.8l0.1-0.3
		L58,63l0.1-1.3L58.3,60z	"
        >
          <title id="t2222">Deschutes, OR</title>
        </path>
        <path
          id="FIPS_41031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M60.5,54.8l5.9,1.6l1,0.3l5.4,1.5l-1,3.2l-3.9-1l-0.3,1.1L66.1,61l-0.3,1.1l-1.1-0.3L58.3,60
		l1.4-3.5L60.5,54.8z	"
        >
          <title id="t2223">Jefferson, OR</title>
        </path>
        <path
          id="FIPS_41043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M48,52.2l0.8,0.4l1.2,0.2l1.1-0.2l1.4,0.4l2.8,1.1l0.3,0.2l1,0.8l1,0.7l0.6,0.2l1.5,0.4
		L58.3,60l-0.1,1.8l-2-0.6l-2.7-0.7l-0.1,0.1l0,0l0,0l0,0.1l-0.4,0.2l-0.1,0l-1-0.5l-0.6-0.4l-0.3-0.3l-0.3-0.4l-0.2-0.2l-0.5-0.3
		l-0.9-0.2l-0.4,0.3l-0.1,0.3l-0.1,0.5l-2-0.6L45.8,59l0.1-0.4L46,58l0-0.1L46,57.9l-0.1,0l0,0l0-0.1l-0.1-0.7l0.8-2.5l1.7-1l-0.4-1
		L48,52.2z	"
        >
          <title id="t2224">Linn, OR</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "21660"
              ? `metroArea clickedArea state-or`
              : `metroArea ${colorCode[21660]} state-or`
          }
          id="FIPS_21660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_41039"
            className="FIPS_21660 st0 state-or"
            d="M37.7,55.5l3,0.8l1.6,0.5l2,0.5l1.5,0.4l0.1,0L46,58l0,0.1L46,58.6L45.8,59l0.3,0.1l2,0.6
		l0.1-0.5l0.1-0.3l0.4-0.3l0.9,0.2l0.5,0.3l0.2,0.2l0.3,0.4l0.3,0.3l0.6,0.4l1,0.5l0.1,0l0.4-0.2l0-0.1l0,0l0,0l0.1-0.1l2.7,0.7
		l2,0.6L58,63L58,63.6l-0.1,0.3l-1.5,1.8l-1.2,1.2l-0.4,1.2l-0.3,0.6l-0.3,0.4l-1.8,1.9l-3.3-1l-2.2-0.6l0.4-1.3L46,67.9l-1-0.3l0,0
		l-0.1,0l-0.9-0.3l0-0.9l0.6-2.2l-1.9-0.6l-1-0.7l-0.4-0.4l-0.6-1l0-0.2L40.5,61l-0.4-0.2L39,60.4l-1.2,0.7l-0.3,0l-1-0.3l-0.8-0.3
		L37.7,55.5z	"
          >
            <title id="t2225">Lane, OR</title>
          </path>
        </g>
        <path
          id="FIPS_41003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.9,52.6l0.4,1l-1.7,1l-0.8,2.5l0.1,0.7l0,0.1l0,0l-1.5-0.4l-2-0.5l-1.6-0.5l0-0.4l0.1-0.3
		l1.4-0.8l0.6,0.2l0.8-2.6l0.2-1L47.9,52.6z	"
        >
          <title id="t2226">Benton, OR</title>
        </path>
        <path
          id="FIPS_41041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M44,47.1l-1.1,3.8l0.1,0.3l0.9,0.3l-0.2,1L42.9,55l-0.6-0.2l-1.4,0.8l-0.1,0.3l0,0.4l-3-0.8
		l0.3-0.6l0.5-1l0.1-0.1l0.8-2.2l1.4-3.5l0.8-1.7L44,47.1z	"
        >
          <title id="t2227">Lincoln, OR</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41420"
              ? `metroArea clickedArea state-or`
              : `metroArea ${colorCode[41420]} state-or`
          }
          id="FIPS_41420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_41047"
            className="FIPS_41420 st0 state-or"
            d="M52.4,46.7l0.2-0.1l0.4,0.1l0.3,0.3l-0.3,0.8L53,47.9l-0.1,0.2l-0.1,0l-0.1,0.2l-0.1,0.2
		l0.5,1.1l1.2,2.2l0.9,0.7l3.5,0.9l2.3,0.7l-0.4,0.7l-0.8,1.7L58.2,56l-0.6-0.2l-1-0.7l-1-0.8l-0.3-0.2l-2.8-1.1l-1.4-0.4L50,52.9
		l-1.2-0.2L48,52.2l0-0.1l0.2-1l0.3-0.6l0.5-0.5l0,0l0.7-1.3l0.1-0.4l0.5-0.2l0.2-0.4l0.1-0.5l0-0.2l1-0.8L52.4,46.7z	"
          >
            <title id="t2230">Marion, OR</title>
          </path>
          <path
            id="FIPS_41053"
            className="FIPS_41420 st0 state-or"
            d="M44,47.1l0.1-0.4l5.7,1.7l-0.1,0.4L49,50.1l0,0l-0.5,0.5l-0.3,0.6l-0.2,1l0,0.1l-0.2,0.4
		l-4-1.2L43,51.1l-0.1-0.3L44,47.1z	"
          >
            <title id="t2228">Polk, OR</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "38900"
              ? `metroArea clickedArea state-or state-wa`
              : `metroArea ${colorCode[38900]} state-or state-wa`
          }
          id="FIPS_38900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_41005"
            className="FIPS_38900 st0 state-or state-wa"
            d="M54,44.8l0.8,0.2l0-0.3l0.2,0l7.2,2l0.4,2.8l-0.6,0.5l0,0.1l-1.1,2.2l0,0.1l-0.2,0.9l0,0
		l0.4,0.7l-2.3-0.7l-3.5-0.9l-0.9-0.7L53,49.5l-0.5-1.1l0.1-0.2l0.1-0.2l0.1,0l0.1-0.2l0.1-0.2l0.3-0.8l-0.3-0.3l-0.4-0.1l-0.2,0.1
		l0-0.8L54,44.8z	"
          >
            <title id="t2231">Clackamas, OR</title>
          </path>
          <path
            id="FIPS_41009"
            className="FIPS_38900 st0 state-or state-wa"
            d="M52.6,34.5l0.5-0.1l0.4,0.2l1.5,1.8l0.1,0.3l0.3,1.4l-0.1,1.2l-0.1,0.2l-0.2,1.6l-1.5-0.3
		l-0.7-1l-2.9-0.8l1.3-4.5L52.6,34.5z	"
          >
            <title id="t2206">Columbia, OR</title>
          </path>
          <path
            id="FIPS_41051"
            className="FIPS_38900 st0 state-or state-wa"
            d="M54.9,41.1l-0.2,0.3l-0.1,0.2l0,0.3l0.2,0.2l0.5,0.5l0.2,0.2l2.5,1.5l0.3,0.1l0,0l0.2,0.1h0
		l0.1,0l3.2-0.4l0.2,2.6l-7.2-2l-0.2,0l0,0.3L54,44.8l0.2-1.2L54,43.4l-0.5-0.9l-0.4-0.8l0.3-1L54.9,41.1z	"
          >
            <title id="t2238">Multnomah, OR</title>
          </path>
          <path
            id="FIPS_41067"
            className="FIPS_38900 st0 state-or state-wa"
            d="M53.4,40.7l-0.3,1l0.4,0.8l0.5,0.9l0.2,0.1L54,44.8l-1.5,1.1l-0.3-0.2l-0.6-0.8l-0.5-0.6
		l-0.5-0.5l-2.9-0.9l-0.2,0l0.1-0.2l1.2-2.2l0.8-0.7l0.3-0.9l2.9,0.8L53.4,40.7z	"
          >
            <title id="t2239">Washington, OR</title>
          </path>
          <path
            id="FIPS_41071"
            className="FIPS_38900 st0 state-or state-wa"
            d="M47.7,42.9l2.9,0.9l0.5,0.5l0.5,0.6l0.6,0.8l0.3,0.2l0,0.8l-0.7-0.3l-1,0.8l0,0.2l-0.1,0.5
		l-0.2,0.4l-0.5,0.2l-5.7-1.7l-0.5-0.2l0.5-1.7l2.8,0.8l0.4-1.2L47.7,42.9z	"
          >
            <title id="t2229">Yamhill, OR</title>
          </path>
          <path
            id="FIPS_53011"
            className="FIPS_38900 st0 state-or state-wa"
            d="M55.1,39.5l1.4-0.7l1.4-0.3l0.4,0.1l0.2,0.1l0.2,0.2l0.3,0.1l0.8-0.3l0.8-0.3L60,40.2
		l-0.6,1.9l-0.7,2.5l-0.1,0h0l-0.2-0.1l0,0L58,44.4l-2.5-1.5l-0.2-0.2l-0.5-0.5L54.6,42l0-0.3l0.1-0.2l0.2-0.3L55.1,39.5z	"
          >
            <title id="t2968">Clark, WA</title>
          </path>
          <path
            id="FIPS_53059"
            className="FIPS_38900 st0 state-or state-wa"
            d="M67.9,35.9l-1.2,4.3L66,40l-0.6,2.1l-0.3,1.2l0.8,0.3l-0.2,0.7l-1,0l-0.7-0.1L63.7,44
		l-0.6-0.3l-0.5,0l-0.4,0.2l-0.3,0.2l-3.2,0.4l0.7-2.5l0.6-1.9l0.5-1.8l1.2-4.1L67.9,35.9z	"
          >
            <title id="t2969">Skamania, WA</title>
          </path>
        </g>
        <path
          id="FIPS_41059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M88.7,46.5l8.7,2.1l0.2,0l-0.4,1.8l-0.8,0.4l-1,1.5l-0.5,2.2L94.6,55l-0.7,0.4l-2.2,0.4
		L90,55.4l-0.8-0.1l-0.3,1.1l0.2,0.9l1,0.2L90,59l-0.3,1.1L84,58.7l0.4-1l1.4-5.4l-0.6-1.3l-1.6-0.4l0.8-3.3l0.2-0.6l0.5,0l1.4,0.2
		l0.2,0.1l0.2,0.1l0.4,0l0.3,0l0.7-0.2l0.2-0.1L88.7,46.5z	"
        >
          <title id="t2232">Umatilla, OR</title>
        </path>
        <path
          id="FIPS_41049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M79.2,46.6h1.2l0.9,0.1l0.9,0.1l1.7-0.2l0.5,0l-0.2,0.6l-0.8,3.3l1.6,0.4l0.6,1.3l-1.4,5.4
		l-0.4,1l-4.5-1.1l-0.8-1.2l0.3-0.1l0.3-1.1l-0.9-1.1l-1-0.6l0.9-3.2l0.3-1.2L79.2,46.6z	"
        >
          <title id="t2233">Morrow, OR</title>
        </path>
        <path
          id="FIPS_41021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M73.3,46.1l0.2-0.1l0.4,0.1l0.3,0.2l0.2,0.4l0.1,0.2l0.2,0.1l0.7,0.1l1.8,0.1l0.5-0.4l0.3-0.1
		l1.4-0.2h0l-0.6,2.4l-0.3,1.2l-0.9,3.2l1,0.6l0.9,1.1L79,56.3l-0.3,0.1l-6.2-1.6l0-0.2l0.3-0.3l0.2-1.1l-0.3-0.8l0.4-0.9l0.5-0.9
		l1.1-0.6l0.3-0.2l0.1,0l0.1-0.1l-0.2-1.2l-0.6-1.1l-0.8-1L73.3,46.1z	"
        >
          <title id="t2234">Gilliam, OR</title>
        </path>
        <path
          id="FIPS_41055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M70.7,46.7l0.5-0.1l0.8-0.1l1-0.1l0.4-0.2l0.3,0.3l0.8,1l0.6,1.1l0.2,1.2L75,49.7l-0.1,0
		l-0.3,0.2l-1.1,0.6L73,51.5l-0.4,0.9l0.3,0.8l-0.2,1.1l-0.3,0.3L71,54.2l-0.4-0.4l-1.3-1.6l0-1.7l0.9-0.7l0.5-0.9l0.2-0.3l0-0.1
		L70.7,46.7z	"
        >
          <title id="t2235">Sherman, OR</title>
        </path>
        <path
          id="FIPS_41065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M66.3,44.7l0.6,0.1l0.3,0.1l3.3,1.5l0.2,0.3l0.3,1.8l0,0.1l-0.2,0.3l-0.5,0.9l-0.9,0.7l0,1.7
		l1.3,1.6l0.4,0.4l1.4,0.4l0,0.2l0.3,3.4l-5.4-1.5l-1-0.3l-5.9-1.6l0.4-0.7l-0.4-0.7l0,0l0.2-0.9l0-0.1l1.1-2.2l0-0.1l0.6-0.5
		l1.9,0.5l0.1-0.4l0.8-2.9l0.4-0.7L66.3,44.7z	"
        >
          <title id="t2236">Wasco, OR</title>
        </path>
        <path
          id="FIPS_41027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M61.9,44.2l0.3-0.2l0.4-0.2l0.5,0l0.6,0.3l0.2,0.1l0.7,0.1l1,0l0.6,0.5l-0.5,1.4l-0.4,0.7
		l-0.8,2.9l-0.1,0.4l-1.9-0.5l-0.4-2.8L61.9,44.2	"
        >
          <title id="t2237">Hood River, OR</title>
        </path>

        <path
          id="FIPS_41057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M49.9,38.9l-0.3,0.9l-0.8,0.7l-1.2,2.2l-0.1,0.2l0.2,0l-0.4,1.5l-0.4,1.2l-2.8-0.8l-0.5,1.7
		l0.5,0.2L44,47.1l-2.4-0.7l0.3-0.6l0-0.1l0,0l0.3-0.5l0,0l0.1-0.2l0.2-0.5l2-5.6l0.2-0.6l0-0.2V38l0-0.7l2.1,0.6l0,0.1l0,0l2,0.6
		L49.9,38.9z	"
        >
          <title id="t2240">Tillamook, OR</title>
        </path>

        <path
          id="FIPS_42059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.9,137.2l2-1.1l0.1,0l1.1,0l1.8,0l1.4,3.2l-4.9,0.8l-1,0.2L444.9,137.2z	"
        >
          <title id="t2243">Greene, PA</title>
        </path>
        <path
          id="FIPS_42051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.7,134.1l1.3-0.2l2.3-0.6l0.2-0.1l0.2,0.1l0.1,0.1l1.7,0.9l-0.2,0.7l-0.5,1.3l-0.1,0.6
		l0.3,1.5l0.2,0.1l-0.8,0.1l-2.8,0.5l-1.5,0.3l-1.4-3.2L450.7,134.1z	"
        >
          <title id="t2244">Fayette, PA</title>
        </path>
        <path
          id="FIPS_42125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.3,130.4l2,1.6l2.3,0.9l1,0.3l0.1,0.9l-0.9,2l-1.8,0l-1.1,0l-0.1,0l-2,1.1l-0.4-2.5
		l-0.5-3.1l-0.2-1L445.3,130.4z	"
        >
          <title id="t2245">Washington, PA</title>
        </path>
        <path
          id="FIPS_42003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.3,126.8L451.3,126.8l0.4,2.9l0,0.2l0,0.1l-0.5,2.6l-0.1,0.2l-0.5,0.3l-1-0.3l-2.3-0.9
		l-2-1.6l1.1-1.4l0.7-0.7l-0.2-0.8L451.3,126.8z	"
        >
          <title id="t2246">Allegheny, PA</title>
        </path>
        <path
          id="FIPS_42007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443,125.8l3.4-0.6l0.5,2.3l0.2,0.8l-0.7,0.7l-1.1,1.4l-1.5,0.3l-0.3-2.1L443,125.8z	"
        >
          <title id="t2247">Beaver, PA</title>
        </path>
        <path
          id="FIPS_42073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.5,122.4l-0.1,2.8l-3.4,0.6l-0.1-0.6l-0.5-2.9l2.5-0.4l1.1,0L446.5,122.4z	"
        >
          <title id="t2248">Lawrence, PA</title>
        </path>
        <path
          id="FIPS_42019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.2,120.4l1.1,6.4l-4.4,0.7l-0.5-2.3l0.1-2.8l0.7-1.5L450.2,120.4L450.2,120.4z	"
        >
          <title id="t2249">Butler, PA</title>
        </path>
        <path
          id="FIPS_42005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455,121.2l0.3,1.8l0.3,1.7l-1.1,2.4l-0.5,1.1l-2.6-1.4l0,0l-1.1-6.4l0.2,0.9l0,0.1l0.2,0.5
		l1,0.7l0.2,0l0.3,0l0.2-0.1l0.7-0.2l1-0.4L455,121.2z	"
        >
          <title id="t2250">Armstrong, PA</title>
        </path>
        <path
          id="FIPS_42031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.7,117.3l0.7-0.1l-0.1-0.6l0.4-0.1l1.4-0.2l0.2,1.3l0.6,3.6l-0.8,0.8l-1,0.4l-0.7,0.2
		l-0.2,0.1l-0.3,0l-0.2,0l-1-0.7l-0.2-0.5l0-0.1l-0.2-0.9l0,0l0.2-1.1l0.2-0.3l0.2-0.3l0.4-0.4l0.1,0l0.6-0.3L451.7,117.3z	"
        >
          <title id="t2251">Clarion, PA</title>
        </path>
        <path
          id="FIPS_42053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.9,114.3l5.3-0.9l0.3,1.7l-0.1,0.5l-0.8,0.1l-0.2,0.4l0.2,1.1l-1.1,0.3l-0.2-1.3l-1.4,0.2
		l-0.4,0.1l0.1,0.6l-0.7,0.1l-0.1-0.7l-0.5-0.8L450.9,114.3z	"
        >
          <title id="t2252">Forest, PA</title>
        </path>
        <path
          id="FIPS_42121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.9,114.3l0.3,1.5l0.5,0.8l0.1,0.7l0.1,0.6l-0.6,0.3l-0.1,0l-0.4,0.4l-0.2,0.3l-0.2,0.3
		l-0.2,1.1l-2.9,0.5l-0.7-4.1l0.3-0.4l1-1.3l2-0.5l0-0.1L450.9,114.3z	"
        >
          <title id="t2253">Venango, PA</title>
        </path>

        <path
          id="FIPS_42039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.4,111.6l0.5,2.9l0,0.1l-2,0.5l-1,1.3l-0.3,0.4l-4.9,0.8l0-0.1l-0.7-4.5l5.7-1l2.1-0.4
		L449.4,111.6z	"
        >
          <title id="t2255">Crawford, PA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "21500"
              ? `metroArea clickedArea state-pa`
              : `metroArea ${colorCode[21500]} state-pa`
          }
          id="FIPS_21500"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_42049"
            className="FIPS_21500 st0 state-pa"
            d="M449.1,109.7l0.3,1.9l-0.7,0.1l-2.1,0.4l-5.7,1l-0.3-1.6l1.7-1l2.2-1.8l1.7-1.4l0.9-0.7
		l0.1,0.3l0.2,1.4l0.3,1.7l1.3-0.2L449.1,109.7z	"
          >
            <title id="t2256">Erie, PA</title>
          </path>
        </g>
        <path
          id="FIPS_42129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.9,128.2l-0.1,0.2l0.1,0.4l0,0l0.6,0.3l2.4,0.1l1.8-0.1l-0.5,1.6l-1.7,3.5l-1.7-0.9
		l-0.1-0.1l-0.2-0.1l-0.2,0.1l-2.3,0.6l-1.3,0.2l-0.1-0.9l0.5-0.3l0.1-0.2l0.5-2.6l0-0.1l0-0.2l-0.4-2.9L453.9,128.2z	"
        >
          <title id="t2257">Westmoreland, PA</title>
        </path>
        <path
          id="FIPS_42063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.3,122.9l3.9-0.6l0.5,2.3l-0.9,4.5l-1.8,0.1l-2.4-0.1l-0.6-0.3l0,0l-0.1-0.4l0.1-0.2
		l0.5-1.1l1.1-2.4L455.3,122.9z	"
        >
          <title id="t2258">Indiana, PA</title>
        </path>
        <path
          id="FIPS_42065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.4,117.6l1.1-0.3l0.2-0.2l1.1-0.3l2.4,0.9l0.3,0.4l0.1,0.4l-0.5,0.1l-0.2,0.8l0,0l0,0.4
		l0.5,2.7l-3.9,0.6l-0.3-1.8L454.4,117.6z	"
        >
          <title id="t2259">Jefferson, PA</title>
        </path>
        <path
          id="FIPS_42123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.3,108.8l1.3-0.2l0.1,0.6l0.3,1.4l0,0.1l-0.3,0.1l0.4,2.7l-5.3,0.9l-1,0.2l-0.5-2.9
		l-0.3-1.9L454.3,108.8z	"
        >
          <title id="t2260">Warren, PA</title>
        </path>
        <path
          id="FIPS_42083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.3,107.5l0.9-0.2l1,4.9l-2,0.6l-0.7-0.2l-1.3,0.3l-0.5,0.1l-1.5,0.3l-1.2,0.2l-0.4-2.7
		l0.3-0.1l0-0.1l-0.3-1.4l-0.1-0.6l0.4-0.1l2.6-0.5L461.3,107.5z	"
        >
          <title id="t2261">McKean, PA</title>
        </path>
        <path
          id="FIPS_42023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.2,112.7l2-0.6l2.4,1.4l-0.4,3.5l-1.4,0.1l-0.2-1.2l-0.4-1l-1.6,0.3L461.2,112.7z	"
        >
          <title id="t2262">Cameron, PA</title>
        </path>
        <path
          id="FIPS_42047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.1,113.4l1.2-0.2l1.5-0.3l0.5-0.1l1.3-0.3l0.7,0.2l0.5,2.5l1.6-0.3l0.4,1l0.2,1.2
		l-3.1,0.3l-0.8,0.2l-0.5,0.7l-0.1-0.4l-0.3-0.4l-2.4-0.9l-1.1,0.3l-0.2,0.2l-0.2-1.1l0.2-0.4l0.8-0.1l0.1-0.5L456.1,113.4z	"
        >
          <title id="t2263">Elk, PA</title>
        </path>
        <path
          id="FIPS_42033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.9,117.2l1.4-0.1l0.7,0.7l0.1,1.5l0,0.3l-0.1,0.8l-0.1,0.1l-0.5,0.2l-0.5,0.4l-0.1,0.1
		l-1.1,2.3l0,0l0.2,0.2l0.1,0.1l-4.3,0.8l-0.5-2.3l-0.5-2.7l0-0.4l0,0l0.2-0.8l0.5-0.1l0.5-0.7l0.8-0.2L463.9,117.2z	"
        >
          <title id="t2264">Clearfield, PA</title>
        </path>
        <path
          id="FIPS_42013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.9,123.7l2.3-0.5l-0.7,0.7l-0.1,0.2l0,0.1l0.5,1.4l0.5,0.3l0.3,0.4l0,0.1l0,0.1l-0.1,0.5
		l-0.6,2l-0.1,0.4l-0.1,0.4l-1.6-0.1l-1.8-0.3l1.6-5.6L463.9,123.7z	"
        >
          <title id="t2265">Blair, PA</title>
        </path>
        <path
          id="FIPS_42021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M459.7,124.6l4.3-0.8l-1.6,5.6l-0.2,1.1l-0.9,0.2l-1.3,0.2l-0.2-0.3l-0.3-0.1l-1.2,0.2
		l0.5-1.6L459.7,124.6z	"
        >
          <title id="t2266">Cambria, PA</title>
        </path>
        <path
          id="FIPS_42111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M462.2,130.5l-0.4,2.4l0.4,3.2l0,0.4l-0.2,1l-5.7,1l-0.2-0.1l-0.3-1.5l0.1-0.6l0.5-1.3
		l0.2-0.7l1.7-3.5l1.2-0.2l0.3,0.1l0.2,0.3l1.3-0.2L462.2,130.5z	"
        >
          <title id="t2267">Somerset, PA</title>
        </path>
        <path
          id="FIPS_42009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M462.4,129.4l1.8,0.3l1.6,0.1l0.1-0.4l0.1-0.4l1.5,1.5l-0.1,0.6l-0.3,1.9l-0.3,2.2l-0.3,0.9
		l-0.3,0.6l-4.1,0.8l0.2-1l0-0.4l-0.4-3.2l0.4-2.4L462.4,129.4z	"
        >
          <title id="t2268">Bedford, PA</title>
        </path>
        <path
          id="FIPS_42057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.4,130.6l0.6,0.3l1.5,0.1l0.7,0.4l-0.1,0.1l-0.1,0.1l-0.2,0.6l0,0.7l-0.2,1.2l-0.1,0.5
		l-0.4,1.1l-0.2,0.4l-2.4,0.4l-0.4,0.1l0.3-0.6l0.3-0.9l0.3-2.2l0.3-1.9L467.4,130.6z	"
        >
          <title id="t2269">Fulton, PA</title>
        </path>
        <path
          id="FIPS_42061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.2,123.2l1.8,0.3l2.2-0.7l0.2-0.3l-0.1,0.3l-0.5,1.2l-0.3,0.5l-0.1,0.3l-0.1,0.2L469,127
		l0.5,0.4l0.1,0.1l0.3,0l0.6-0.2l0.1-0.2l0.8,1.4l-1,2.9l-0.7-0.4l-1.5-0.1l-0.6-0.3l-1.5-1.5l0.6-2l0.1-0.5l0-0.1l0-0.1l-0.3-0.4
		l-0.5-0.3l-0.5-1.4l0-0.1l0.1-0.2L466.2,123.2z	"
        >
          <title id="t2270">Huntingdon, PA</title>
        </path>
        <path
          id="FIPS_42055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M471.3,128.5l0.2-0.4l0.8,1l-0.1,0.2l0.3,0.4l1.5,1.7l0.4,0.7l0.7,2.8l-0.1,0l-6.1,1.2
		l0.2-0.4l0.4-1.1l0.1-0.5l0.2-1.2l0-0.7l0.2-0.6l0.1-0.1l0.1-0.1L471.3,128.5z	"
        >
          <title id="t2271">Franklin, PA</title>
        </path>
        <path
          id="FIPS_42087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.1,120.4l0.2,0.5l0.9,1.3l-0.5,0.4l-0.3,0.2l-0.6,0.5l-0.3,0.3l-0.9,1.5l-1,2l-0.1,0.2
		l-0.6,0.2l-0.3,0l-0.1-0.1L469,127l0.3-1.9l0.1-0.2l0.1-0.3l0.3-0.5l0.5-1.2l0.1-0.3L473.1,120.4z	"
        >
          <title id="t2272">Mifflin, PA</title>
        </path>
        <path
          id="FIPS_42105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.9,106.2l1.2,5.8l0.2,0.8l-3.7,0.8l-2.4-1.4l-1-4.9l4.3-0.8L467.9,106.2z	"
        >
          <title id="t2273">Potter, PA</title>
        </path>
        <path
          id="FIPS_42035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469.3,112.8l0.1,0.5l0.7,0.6l1.1,1l3.2,2.3l0.2,0l0.1,0.3l-1.7,1.1l-1.5,0.6l-0.9-0.9
		l-0.1-0.3l-0.4-0.2l-3.3-0.9l-0.8,0.9l-0.7-0.7l0.4-3.5L469.3,112.8z	"
        >
          <title id="t2274">Clinton, PA</title>
        </path>
        <path
          id="FIPS_42027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M465.9,117.8l0.8-0.9l3.3,0.9l0.4,0.2l0.1,0.3l0.9,0.9l1.5-0.6l1.7-1.1l-0.4,0.8l-0.5,1.2
		l-0.7,1l-2.7,2.1l-0.2,0.3l-2.2,0.7l-1.8-0.3l-2.3,0.5l-0.2-0.2l0,0l1.1-2.3l0.1-0.1l0.5-0.4l0.5-0.2l0.1-0.1l0.1-0.8l0-0.3
		L465.9,117.8z	"
        >
          <title id="t2275">Centre, PA</title>
        </path>
        <path
          id="FIPS_42119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M474.6,117.2l1.5-0.6l0-0.8l0.6,0l0.2,0.6l0.4,1.4l0,0.2l0.1,0.2l0.3,0.4l0.3,0.2l0.3,0.1
		l-0.3,0l-1,0.2l-1.2,0.5l-2.1,1.1l-0.4,0.2l-0.2-0.5l0.7-1l0.5-1.2l0.4-0.8L474.6,117.2z	"
        >
          <title id="t2276">Union, PA</title>
        </path>
        <path
          id="FIPS_42093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M478.2,115.1l0.9,0l0.4,1l0.5,0.2l0.7,1.1l0.1,0.2l0,0.8l-1-0.7l-0.2-0.1h-0.3l-0.7,0.3
		l-0.5,0.2l0,0l0.1-1.3L478.2,115.1z	"
        >
          <title id="t2277">Montour, PA</title>
        </path>
        <path
          id="FIPS_42117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M474.3,104.9l1.5,5.1l0,0.1l-0.6,0.6l-2.2,0.5l-3.8,0.8l-1.2-5.8l6-1.2L474.3,104.9z	"
        >
          <title id="t2278">Tioga, PA</title>
        </path>
        <path
          id="FIPS_42081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M475.8,110l0.6,0l1.1,2.2l1.8,1l0.4,0.1l1,0l-1.5,1.9l-0.9,0l-1.5,0.7l-0.6,0l0,0.8l-1.5,0.6
		l-0.2,0l-3.2-2.3l-1.1-1l-0.7-0.6l-0.1-0.5l-0.2-0.8l3.8-0.8l2.2-0.5l0.6-0.6L475.8,110z	"
        >
          <title id="t2279">Lycoming, PA</title>
        </path>
        <path
          id="FIPS_42131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482.8,107.8l0,0.1l2.3-0.5l1.4-0.3l-0.1,0.1l-0.3,0.9l-0.1,0.7l0.3,0.2l-0.4,1.1l-0.1,0.1
		l-1.4,0.8l-2.6,0.6l0.1-2.2L482.8,107.8z	"
        >
          <title id="t2280">Wyoming, PA</title>
        </path>
        <path
          id="FIPS_42113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M476.4,109.9l5.7-0.5l-0.1,2.2l-0.1,0.9l-1.2,0.7l-1,0l-0.4-0.1l-1.8-1L476.4,109.9z	"
        >
          <title id="t2281">Sullivan, PA</title>
        </path>
        <path
          id="FIPS_42037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.9,112.5l0.1,1l0.1,0.3l0.6,0.8l1.1,2.2l-0.3,0.5l-0.2,0.5l0,1.1l-0.6,0.5l-1.7-1.1l0-0.8
		l-0.1-0.2l-0.7-1.1l-0.5-0.2l-0.4-1l1.5-1.9L481.9,112.5z	"
        >
          <title id="t2282">Columbia, PA</title>
        </path>
        <path
          id="FIPS_42097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M476.8,115.8l1.5-0.7l0.1,1.6l-0.1,1.3l0,0l0.5-0.2l0.7-0.3h0.3l0.2,0.1l1,0.7l1.7,1.1
		l-2.7,2.1l-0.4,0.1l-1.1,0.7l-0.4,0.2l0,0l-0.1,0l-0.2-0.2l0.1-0.2l0.1-0.1l0.4-0.6l0.1-0.2l0-0.2l0-0.2l-0.1-0.3l0.1-1.1l0.1-0.6
		l-0.3-0.1l-0.3-0.2l-0.3-0.4l-0.1-0.2l0-0.2l-0.4-1.4L476.8,115.8z	"
        >
          <title id="t2283">Northumberland, PA</title>
        </path>
        <path
          id="FIPS_42109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M478.4,118.9l-0.1,0.6l-0.1,1.1l0.1,0.3l0,0.2l0,0.2l-0.1,0.2l-0.4,0.6l-0.1,0.1l0-0.1l-0.1,0
		l-1-0.2l-0.7,0l-0.4,0.2l-1.3,0.1l-0.9-1.3l0.4-0.2l2.1-1.1l1.2-0.5l1-0.2L478.4,118.9z	"
        >
          <title id="t2284">Snyder, PA</title>
        </path>
        <path
          id="FIPS_42067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M477.7,122.3l-0.1,0.2l-1.9,1.3l-1,0.8l-1.4,1.3l-0.7,0.7l-0.8,1.3l-0.2,0.3l-0.2,0.4
		l-0.8-1.4l1-2l0.9-1.5l0.3-0.3l0.6-0.5l0.3-0.2l0.5-0.4l1.3-0.1l0.4-0.2l0.7,0l1,0.2L477.7,122.3L477.7,122.3z	"
        >
          <title id="t2285">Juniata, PA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "25420"
              ? `metroArea clickedArea state-pa`
              : `metroArea ${colorCode[25420]} state-pa`
          }
          id="FIPS_25420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_42041"
            className="FIPS_25420 st0 state-pa"
            d="M478.7,126.2l0.8,1.2l-0.4,0.6l-1.2,1l-0.7,0.9l-0.2,0.4l-0.3,0.3l-0.7,0.3l-1.1,0.5l-0.5,0.8
		l-0.4-0.7l-1.5-1.7l-0.3-0.4l0.1-0.2l0.1,0.2l1.8-1.3l3.5-1.3l0.4-0.2L478.7,126.2z	"
          >
            <title id="t2287">Cumberland, PA</title>
          </path>
          <path
            id="FIPS_42043"
            className="FIPS_25420 st0 state-pa"
            d="M479.9,121.6l1.9,1l-1.1,1.3l1.8,3.3l0,0l-1.3,1.3l-1.6-1.1l-0.8-1.2l-1-0.2l-0.1-0.1
		l-0.1-0.2l0,0l0.1-2.6l0.1-0.6l0.2,0.2l0.1,0l0,0l0.4-0.2l1.1-0.7L479.9,121.6z	"
          >
            <title id="t2290">Dauphin, PA</title>
          </path>
          <path
            id="FIPS_42099"
            className="FIPS_25420 st0 state-pa"
            d="M478.7,126.2l-0.5,0.4l-0.4,0.2l-3.5,1.3l-1.8,1.3l-0.1-0.2l-0.8-1l0.2-0.3l0.8-1.3l0.7-0.7
		l1.4-1.3l1-0.8l1.9-1.3l-0.1,0.6l-0.1,2.6l0,0l0.1,0.2l0.1,0.1L478.7,126.2z	"
          >
            <title id="t2286">Perry, PA</title>
          </path>
        </g>

        <path
          id="FIPS_42001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M477.2,129.9l0.1,0l0.4,0.1l0.8,0.4l0.7,0.9l0,0.2l0.1,0.6l-0.2,0.6v0.1l0.3,1.4l-2.1,0.4
		L475,135l-0.7-2.8l0.5-0.8l1.1-0.5l0.7-0.3l0.3-0.3L477.2,129.9z	"
        >
          <title id="t2288">Adams, PA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "49620"
              ? `metroArea clickedArea state-pa`
              : `metroArea ${colorCode[49620]} state-pa`
          }
          id="FIPS_49620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_42133"
            className="FIPS_49620 st0 state-pa"
            d="M479.5,127.4l1.6,1.1l0.9,0.6l0.6,0l0.3,0l0.2,0.1l1.9,1.6l1.7,1.7l0.1,0.1v0.1l-3.2,0.7
		l-2.1,0.4l-2.1,0.4l-0.3-1.4v-0.1l0.2-0.6l-0.1-0.6l0-0.2l-0.7-0.9l-0.8-0.4l-0.4-0.1l-0.1,0l0.7-0.9l1.2-1L479.5,127.4z	"
          >
            <title id="t2289">York, PA</title>
          </path>
        </g>

        <path
          id="FIPS_42075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.8,122.5l1.1,0.6l3.2,1.7l-1.3,1.1l-1.2,0.5l-1.1,0.8l0,0l-1.8-3.3L481.8,122.5z	"
        >
          <title id="t2291">Lebanon, PA</title>
        </path>
        <path
          id="FIPS_42071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486,124.8l3.1,1.7l-0.6,0.5l-0.1,2.1l0,0.3l0,0.2l0.1,0.3l-0.1,0.7l-0.2,0.6l-0.1,0.3
		l-0.6,0.7l-0.9,0.2l-0.1,0v-0.1l-0.1-0.1l-1.7-1.7l-1.9-1.6l-0.2-0.1l-0.3,0l-0.6,0l-0.9-0.6l1.3-1.3l1.1-0.8l1.2-0.5L486,124.8z	"
        >
          <title id="t2292">Lancaster, PA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "39740"
              ? `metroArea clickedArea state-pa`
              : `metroArea ${colorCode[39740]} state-pa`
          }
          id="FIPS_39740"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_42011"
            className="FIPS_39740 st0 state-pa"
            d="M491.6,121.9l-1,3l-1.4,1.7l-3.1-1.7l-3.2-1.7l1.2-0.5l0.5-0.1l0.2-0.1l1.5-1.1l0.4-0.5l0-0.4
		l0.9-0.7L491.6,121.9z	"
          >
            <title id="t2293">Berks, PA</title>
          </path>
        </g>
        <path
          id="FIPS_42107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M483.8,116.9l2.1,0l2.8,1.8l-1.1,1l-0.9,0.7l0,0.4l-0.4,0.5l-1.5,1.1l-0.2,0.1l-0.5,0.1
		l-1.2,0.5l-1.1-0.6l-1.9-1l2.7-2.1l0.6-0.5l0-1.1l0.2-0.5L483.8,116.9z	"
        >
          <title id="t2294">Schuylkill, PA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "10900"
              ? `metroArea clickedArea state-pa state-nj`
              : `metroArea ${colorCode[10900]} state-pa state-nj`
          }
          id="FIPS_10900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_34041"
            className="FIPS_10900 st0 state-pa state-nj"
            d="M495.1,112.4l2.4,1.9l-0.8,1.8l-0.1,0.2l-0.4,0.8l-0.1,0.1l-0.5,0.6l-0.9,1.1l-0.2,0.4
		l-0.1-0.2l-0.1-0.1l-0.2-0.9l-0.1-0.8l0.2-0.4l0.1,0l0.1,0l0.1,0l0.2-0.3l0.3-1l0-0.1l0-0.1l-0.9-1.1L495.1,112.4z	"
          >
            <title id="t1919">Warren, NJ</title>
          </path>
          <path
            id="FIPS_42025"
            className="FIPS_10900 st0 state-pa state-nj"
            d="M485.9,116.9l2.2-1.7l-0.1-0.3l-0.4-0.3l0-0.3l0-0.1l0-0.1l0.5-0.6l0,0l0.2-0.1l0.2,0.1
		l0.3,0.1l1.5,1.3l-0.6,0.7l1.3,1.5l-1.2,0.6l-1.3,1L485.9,116.9z	"
          >
            <title id="t2295">Carbon, PA</title>
          </path>
          <path
            id="FIPS_42077"
            className="FIPS_10900 st0 state-pa state-nj"
            d="M489.9,117.7l0.2,0.5l0.1,0.2l1.3,0.8l1,0.6l0.7,0.6l-1.1,1.8l-0.5-0.3l-4.1-2.2l1.1-1
		L489.9,117.7z	"
          >
            <title id="t2304">Lehigh, PA</title>
          </path>
          <path
            id="FIPS_42095"
            className="FIPS_10900 st0 state-pa state-nj"
            d="M494,114.4l0.9,1.1l0,0.1l0,0.1l-0.3,1l-0.2,0.3l-0.1,0l-0.1,0l-0.1,0l-0.2,0.4l0.1,0.8
		l0.2,0.9l0.1,0.1l-1.1,1.2l-0.7-0.6l-1-0.6l-1.3-0.8l-0.1-0.2l-0.2-0.5l1.2-0.6L494,114.4z	"
          >
            <title id="t2303">Northampton, PA</title>
          </path>
        </g>

        <path
          id="FIPS_42079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482,111.6l2.6-0.6l1.4-0.8l0.1-0.1l0.1,0.2l0.2,0.3l0.6,0.2l0.6,0.1l0.7,1l0.2,0.9l0.1,0.1
		l0.1,0.1l0.3,0l-0.3,0.6l-0.2-0.1l-0.2,0.1l0,0l-0.5,0.6l0,0.1l0,0.1l0,0.3l0.4,0.3l0.1,0.3l-2.2,1.7l-2.1,0l-1.1-2.2l-0.6-0.8
		l-0.1-0.3l-0.1-1L482,111.6z	"
        >
          <title id="t2296">Luzerne, PA</title>
        </path>
        <path
          id="FIPS_42069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M486.5,107.1l2.4-0.5l1.3,4.8l-0.2,0.2l-0.4,0.3L489,113l-0.3,0l-0.1-0.1l-0.1-0.1l-0.2-0.9
		l-0.7-1l-0.6-0.1l-0.6-0.2l-0.2-0.3l-0.1-0.2l0.4-1.1l-0.3-0.2l0.1-0.7L486.5,107.1L486.5,107.1z	"
        >
          <title id="t2297">Lackawanna, PA</title>
        </path>
        <path
          id="FIPS_42015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M477.7,104.2l3.8-0.8l1.2,4.3l-0.7,1.6l-5.7,0.5l-0.6,0l-1.5-5.1L477.7,104.2z	"
        >
          <title id="t2298">Bradford, PA</title>
        </path>
        <path
          id="FIPS_42115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M481.9,103.4l5.8-1.3l1.2,4.5l-2.4,0.5l-1.4,0.3l-2.3,0.5l0-0.1l-1.2-4.3L481.9,103.4z	"
        >
          <title id="t2299">Susquehanna, PA</title>
        </path>
        <path
          id="FIPS_42127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M487.8,102.1l1.2-0.3l0.2,0l0.6,0.4l0.2,0.2l0.3,0.6l1.2,0.2l1.5,2.7l-0.7,2.1l-0.9,2.1
		l-0.2,1.2l-1.4,0.4l0.4-0.3l0.2-0.2l-1.3-4.8L487.8,102.1z	"
        >
          <title id="t2300">Wayne, PA</title>
        </path>

        <path
          id="FIPS_42089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M491,111.5l2.1-0.7l0,1.4l1.4,0.6l0.3-0.2l0.1-0.2l0.1,0.1l-1,2l-2.9,2.7l-1.3-1.5l0.6-0.7
		l-1.5-1.3l-0.3-0.1l0.3-0.6l0.7-1.1L491,111.5z	"
        >
          <title id="t2302">Monroe, PA</title>
        </path>

        <path
          id="FIPS_45073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.5,203.9l-0.2,0.3l-0.2,0.7l0.7,1.7l1,2.8l-1.3,2.1l-0.7-0.1l-0.6-0.4l-2.7-1.6l-0.2-0.3
		l0.2-1l0.7-1.3l1-0.7l0.2-1l1-0.5L430.5,203.9z	"
        >
          <title id="t2314">Oconee, SC</title>
        </path>
        <path
          id="FIPS_45013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.9,230.8l4.2,2.2l0.6,0.9l0.1,0.1l0,0.2l0,0.2l-0.1,0.7l-0.1,0.1l-2.7,2.8l-0.6,0.5
		l-0.6,0.5l-0.3-0.2l-1.3-1l-0.2-0.3l-0.1-0.3l0-0.1l0.1-0.6l0.6-0.5l0.6-0.6l0.3-0.4l0.1-0.4l0-0.8l-0.4-1.5L457,232l-0.2-0.3
		l-0.3-0.4L456.9,230.8z	"
        >
          <title id="t2315">Beaufort, SC</title>
        </path>
        <path
          id="FIPS_45049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.9,230.8l-0.4,0.6l-0.3,0.6l-0.2,0l-0.3-0.1l-0.1-0.2l0-0.2l0-0.2l-0.4-0.4l-0.4-0.3
		l-0.2,0.2l-2.4,2.8l-1.1-0.5l-0.5-1.9l0.2-0.1l0.5-0.3l0.5-0.8l0.1-0.6l0-0.5l0.2-0.5l0.1-0.2l0.1-0.1l1.2-1L456.9,230.8z	"
        >
          <title id="t2316">Hampton, SC</title>
        </path>
        <path
          id="FIPS_45053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.5,231.4l0.3,0.4l0.2,0.3l0.1,0.1l0.4,1.5l0,0.8l-0.1,0.4l-0.3,0.4l-0.6,0.6l-0.6,0.5
		l-0.1,0.6l0,0.1l0.1,0.3l0.2,0.3l1.3,1l0.3,0.2l0,0.6l-2-0.4l-0.6-0.2l0,0l-0.1-0.6l-0.1-0.5l-0.1-0.3l-0.1-0.7l-1.1-2.3l-1-0.8
		l-0.2-0.1l2.4-2.8l0.2-0.2l0.4,0.3l0.4,0.4l0,0.2l0,0.2l0.1,0.2l0.3,0.1l0.2,0L456.5,231.4z	"
        >
          <title id="t2317">Jasper, SC</title>
        </path>
        <path
          id="FIPS_45067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.1,209l0.1-0.3l0.6-0.6l0.6-0.2l0.3-0.1l2.2-0.2l0.6,0.3l-0.8,2.4l-0.3,0.5l-0.4,0.6
		l0,0.1l0,0.4l0,0.1l1.1,1.6l0.6,0.8l0.4,0.5l-1.5-0.7l-0.1-0.2l-2-1.5l-0.1-0.1l-0.2-0.3l-1.1-2.4l0-0.1v0L467.1,209z	"
        >
          <title id="t2318">Marion, SC</title>
        </path>
        <path
          id="FIPS_45033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.2,203.8l4.7,3.4l-0.5,0.7l-0.6-0.3l-2.2,0.2l-0.3,0.1l-0.6,0.2l-0.6,0.6l-0.1,0.3
		l-1.1-0.7L467.2,203.8z	"
        >
          <title id="t2319">Dillon, SC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "34820"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[34820]} state-sc`
          }
          id="FIPS_34820"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45051"
            className="FIPS_34820 st0 state-sc"
            d="M471.4,207.9l0.5-0.7l5.2,3.7l1.4,1l-0.4,0.2l-0.9,0.5l-0.4,0.3l-0.5,0.5l-0.1,0.1l-0.2,0.2
		l-0.1,0.1l-0.2,0.2l-0.2,0.3l-0.1,0.1l-0.6,1l-0.4,0.7l-0.1,0.3L472,215l-0.4-0.5l-0.6-0.8l-1.1-1.6l0-0.1l0-0.4l0-0.1l0.4-0.6
		l0.3-0.5L471.4,207.9z	"
          >
            <title id="t2320">Horry, SC</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16700"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[16700]} state-sc`
          }
          id="FIPS_16700"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45015"
            className="FIPS_16700 st0 state-sc"
            d="M462.9,219.4l0.2-0.2l0.1,0l0.9-0.1l0.3,0l0.8,0.5l0.4,0.3l0.2,0.2l0.1,0.1l1.1,0.6l1,0.3
		l2.6,0.7l-0.4,0.2l-1.5,1.4l-0.6,1.3l-0.3,0.9l-1.1,1.9l-0.1,0.1l-0.1,0l-0.2-0.1l-0.4-1l-1.1-0.5l-1.3-0.6l-1.8-1.1l-0.3-0.2
		l0.1-0.1l0.1-0.3l-0.7-0.8l-0.2-0.1l1.1-2.6L462.9,219.4z	"
          >
            <title id="t2323">Berkeley, SC</title>
          </path>
          <path
            id="FIPS_45019"
            className="FIPS_16700 st0 state-sc"
            d="M470.4,221.8l1.9,1l-0.5,1.4l-0.5,0.1l-0.8,0.2l-1.1,1.2l-0.8,1.1l-1.6,1.8l-1.8,2l-0.1,0
		l-0.1,0.1l-0.4,0.2l-0.8,0.6l-0.4,0.4l0,0l-0.1-0.1l-0.7,0.3l-0.1,0.1l0.1,0.1l0,0l0,0.1l-0.1,0l-0.2-0.1l-0.5-0.6l-0.6-1.4
		l-0.4-0.7l0.2-1.1l0-0.6l1.3,0l1.4,0.1l0.1,0l0.4-1l0.1-0.6l-1-1.1l1.3,0.6l1.1,0.5l0.4,1l0.2,0.1l0.1,0l0.1-0.1l1.1-1.9l0.3-0.9
		l0.6-1.3l1.5-1.4L470.4,221.8z	"
          >
            <title id="t2321">Charleston, SC</title>
          </path>
          <path
            id="FIPS_45035"
            className="FIPS_16700 st0 state-sc"
            d="M460.6,222.9l0.2,0.1l0.7,0.8l-0.1,0.3l-0.1,0.1l0.3,0.2l1.8,1.1l1,1.1l-0.1,0.6l-0.4,1
		l-0.1,0l-1.4-0.1l-1.3,0l-0.2-2.3l0-0.1l-0.1-0.1h0l-1.3,0.1l-0.7,0.2l-0.3-0.1l0,0l-2-1.1l2.7-2.5l0.1,0l0.1,0.1l0,0.1l0,0.1
		l0,0.1l0.1,0.2l0.1,0.1l0.5,0.1L460.6,222.9z	"
          >
            <title id="t2322">Dorchester, SC</title>
          </path>
        </g>

        <path
          id="FIPS_45043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.5,214.3l1.5,0.7l2.3,1.4l-0.7,1.3l0,0.1l-0.1,0.2l0,0.1l0,0l0,0l-0.2,0.8l0,0.1l0,0.2
		l0,0l0,0.7l0,0.4l0,0.6l0,0l0,0l0,0.2l0,0l0.2,0.4l-0.1,0.4l-0.1,0.1l-0.4,0.6l-0.4,0.3l-1.9-1l-2.6-0.7l-0.1-0.2l0-0.2l0.7-1.5
		l1.2-2.2l0.1-1.2l0.1-0.4l0.4-0.9l0.1-0.1L470.5,214.3z	"
        >
          <title id="t2324">Georgetown, SC</title>
        </path>
        <path
          id="FIPS_45027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.2,213.4l1.2,0.6l-1.5,5.4l-1.2,0.9l-1,0.3l-0.3,0.1l-0.1,0l-0.3-0.1l-0.4-0.3l-0.3-0.3
		l-0.6-0.7l-0.6-1l1.2-1.8l2-1.3L463.2,213.4z	"
        >
          <title id="t2325">Clarendon, SC</title>
        </path>
        <path
          id="FIPS_45089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.4,214.1l0.1,0.2l-0.2,0.1l-0.1,0.1l-0.4,0.9l-0.1,0.4l-0.1,1.2l-1.2,2.2l-0.7,1.5l0,0.2
		l0.1,0.2l-1-0.3l-1.1-0.6l-0.1-0.1l-0.2-0.2l-0.4-0.3l-0.8-0.5l-0.3,0l-0.9,0.1l-0.1,0l-0.2,0.2l1.5-5.4l0.9,0.5l0.8,0.1l2.5,0.1
		l0.5-0.2l0.1-0.1l0.5-0.4l0.1,0l0.2,0L470.4,214.1z	"
        >
          <title id="t2326">Williamsburg, SC</title>
        </path>

        <path
          id="FIPS_45069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.9,202.3l2.5-0.4l2.7,1.8l0.1,0.1l-1.2,4.5l-0.3,0v-0.1l-0.3-0.8l-0.2-0.3l-0.4-0.2
		l-0.1,0l0,0l0,0l-1.3-1l0,0l0-0.2l0-0.1L461.9,202.3z	"
        >
          <title id="t2328">Marlboro, SC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22500"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[22500]} state-sc`
          }
          id="FIPS_22500"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45031"
            className="FIPS_22500 st0 state-sc"
            d="M463.5,205.7L463.5,205.7l0,0.3l0,0l1.3,1l0,0l0,0l0.1,0l0.4,0.2l0.2,0.3l0.3,0.8v0.1
		l-0.7,0.3l-1,1l-2.1,2.3l0,0l-0.9-0.6l-0.2-0.2l0.3-0.4l0.1-0.6l-0.4-0.7l-0.4-0.4l-0.4-0.1l-0.9-0.2v0l2.3-2L463.5,205.7z	"
          >
            <title id="t2329">Darlington, SC</title>
          </path>
          <path
            id="FIPS_45041"
            className="FIPS_22500 st0 state-sc"
            d="M465.8,208.3l0.3,0l1.1,0.7l-0.2,0.6v0l0,0.1l1.1,2.4l0.2,0.3l0.1,0.1l2,1.5l-0.3-0.1l-0.2,0
		l-0.1,0l-0.5,0.4l-0.1,0.1l-0.5,0.2l-2.5-0.1l-0.8-0.1l-0.9-0.5l-1.2-0.6l-0.5-1.2l-0.8-0.4l2.1-2.3l1-1L465.8,208.3z	"
          >
            <title id="t2327">Florence, SC</title>
          </path>
        </g>
        <path
          id="FIPS_45061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M459,208.6l0.9,0.2l0.4,0.1l0.4,0.4l0.4,0.7l-0.1,0.6l-0.3,0.4l0.2,0.2l0.9,0.6l0,0l0.8,0.4
		l-0.2,0.6l-1.3,0.9l-0.2,0.1l-3.4-1.5l-0.2-0.7l0.1-0.2l0.3-0.7l0-0.4l0-0.2l0.3-0.4L459,208.6z	"
        >
          <title id="t2330">Lee, SC</title>
        </path>

        <path
          id="FIPS_45085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M457.5,211.5l0.2,0.7l3.4,1.5l0.2-0.1l1.3-0.9l0.2-0.6l0.5,1.2l-2.1,1.8l-2,1.3l-1.2,1.8
		l-1.1-1.1l-0.7-4.6L457.5,211.5z	"
        >
          <title id="t2332">Sumter, SC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "17900"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[17900]} state-sc`
          }
          id="FIPS_17900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45017"
            className="FIPS_17900 st0 state-sc"
            d="M452.5,216.1l0.6,0.3l1.6,0.7l0.8,0l1.4,0l1.1,1.1l0.6,1l-0.1,0.3l-1.1,1l-0.3,0.1l-3.6-1.5
		l-1-0.9l0.9-0.5l0.3-0.3l-0.1-0.1l-0.3-0.1l-0.5,0.1l-0.2,0.3l-0.3-0.1l0-1.1l0-0.2L452.5,216.1z	"
          >
            <title id="t2333">Calhoun, SC</title>
          </path>
          <path
            id="FIPS_45039"
            className="FIPS_17900 st0 state-sc"
            d="M452.5,207.3l0.2,1.1l0.9,2.3l-1.4,0.4l-1.6,0.7l-1.7,0l-0.4,0l-1.6-3.1l-0.1-1l1.8-0.2
		l2.4-0.2L452.5,207.3z	"
          >
            <title id="t2342">Fairfield, SC</title>
          </path>
          <path
            id="FIPS_45055"
            className="FIPS_17900 st0 state-sc"
            d="M457.3,205.6l1.8,3v0l-1,1l-0.3,0.4l0,0.2l0,0.4l-0.3,0.7l-0.1,0.2l-1.3,1.1l-1,0.6l-1.8-1.2
		l0.3-1.2l-0.9-2.3l1.2-1.3l0.1,0l0,0.4l0.3,0.1l0.7,0l1.2-0.4l-0.4-0.7L457.3,205.6z	"
          >
            <title id="t2331">Kershaw, SC</title>
          </path>
          <path
            id="FIPS_45063"
            className="FIPS_17900 st0 state-sc"
            d="M448.4,212.5l1.2,1.1h0.3l0.4,0l0.4,0.2l1,0.7l0.2,0.2l0.4,0.6l0,0.1l0.1,0.6l-0.2,0.2l0,0.2
		l0,1.1l0.3,0.1l0.2-0.3l0.5-0.1l0.3,0.1l0.1,0.1l-0.3,0.3l-0.9,0.5l-1.4,0.9l-1-0.4l-0.7-0.2l-0.2,0l-0.4,0l-0.2,0l-1.4-1.1
		l-0.4-0.4l0-0.1l0.7-2.7L448.4,212.5z	"
          >
            <title id="t2340">Lexington, SC</title>
          </path>
          <path
            id="FIPS_45079"
            className="FIPS_17900 st0 state-sc"
            d="M453.6,210.8l-0.3,1.2l1.8,1.2l1-0.6l0.7,4.6l-1.4,0l-0.8,0l-1.6-0.7l-0.6-0.3l-0.1-0.6l0-0.1
		l-0.4-0.6l-0.2-0.2l-1-0.7l-0.4-0.2l-0.4,0h-0.3l-1.2-1.1l0.1-0.6l0.4,0l1.7,0l1.6-0.7L453.6,210.8z	"
          >
            <title id="t2341">Richland, SC</title>
          </path>
          <path
            id="FIPS_45081"
            className="FIPS_17900 st0 state-sc"
            d="M443,214.2l0-0.2l0.3-0.3l1.2-0.3l0.3,0.1l0.8,0.3l0.7,0.4l0.3,0.1l0.5,0.1l0.3-0.1l-0.7,2.7
		l-0.7,0.9l-2-0.4l-0.3-0.2l-0.1-0.1l-0.4-1l-0.4,0l-0.8,0.3L443,214.2z	"
          >
            <title id="t2344">Saluda, SC</title>
          </path>
        </g>

        <path
          id="FIPS_45029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.3,224.6l2,1.1l0,0l0.3,0.1l0.7-0.2l1.3-0.1h0l0.1,0.1l0,0.1l0.2,2.3l0,0.6l-0.2,1.1
		l0.4,0.7l0.6,1.4l0.5,0.6l0.2,0.1l0.1,0l0-0.1l0,0l-0.1-0.1l0.1-0.1l0.7-0.3l0.1,0.1l0,0l-0.8,0.8h-0.1l-0.9,0l-0.6,0.1l-4.2-2.2
		l-3.4-3.7L456.3,224.6L456.3,224.6z	"
        >
          <title id="t2334">Colleton, SC</title>
        </path>
        <path
          id="FIPS_45005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.5,227.1l-1.2,1l-0.1,0.1l-0.1,0.2l-0.2,0.5l0,0.5l-0.1,0.6l-0.5,0.8l-0.5,0.3l-0.2,0.1
		l-2-3.6l-0.9-0.5l0.7-1l1,0.2l1,0.2l0.9-0.1l0.9-0.3L453.5,227.1z	"
        >
          <title id="t2335">Allendale, SC</title>
        </path>
        <path
          id="FIPS_45009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.2,224.7l-2.7,2.4l-1.4-1l-0.4-0.4l0-0.2l-0.3-2.6l-0.1-0.5l-0.1-0.4l1.3,0.6l1.2,0.4
		l0.3,0.1l1.1,0.6L456.2,224.7z	"
        >
          <title id="t2336">Bamberg, SC</title>
        </path>
        <path
          id="FIPS_45075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M452.5,218.3l1,0.9l3.6,1.5l0.3-0.1l1.1-1l0.1-0.3l0.6,0.7l0.3,0.3l0.4,0.3l0.3,0.1l0.1,0
		l0.3-0.1l1-0.3l-1.1,2.6l-0.7,0.1l-0.5-0.1l-0.1-0.1l-0.1-0.2l0-0.1l0-0.1l0-0.1l-0.1-0.1l-0.1,0l-2.7,2.5l-0.1,0.1l-1.2-1
		l-1.1-0.6l-0.3-0.1l-1.2-0.4l-1.3-0.6l-1.7-0.4l1.6-2.4L452.5,218.3z	"
        >
          <title id="t2337">Orangeburg, SC</title>
        </path>
        <path
          id="FIPS_45011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.1,222l0.1,0.4l0.1,0.5l0.3,2.6l0,0.2l0.4,0.4l-0.9,0.3l-0.9,0.1l-1-0.2l-1-0.2l-0.7,1
		l-1.8-0.8l3.6-4.6L451.1,222z	"
        >
          <title id="t2338">Barnwell, SC</title>
        </path>
        <path
          id="FIPS_45003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.6,217L446.6,217l0.5,0.5l1.4,1.1l0.2,0l0.4,0l0.2,0l0.7,0.2l1,0.4l-1.6,2.4l-3.6,4.6
		l-1-0.8l-0.7-1l-0.3-1l-0.7-0.8l-0.5-0.5l-0.1-0.1l3.3-4.2L446.6,217z	"
        >
          <title id="t2339">Aiken, SC</title>
        </path>

        <path
          id="FIPS_45071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.9,208.9l1.6,3.1l-0.1,0.6l-1.2,1.8l-0.3,0.1l-0.5-0.1l-0.3-0.1l-0.7-0.4l-0.8-0.3
		l-0.3-0.1l-1.2,0.3l-0.3,0.3l0,0.2l-0.9-0.8l0.3-0.6l0.8-1.4l0.3-0.3l0.6-1.3l0.5-1.1l1.4,0.8l0.4-0.5l0.2-0.1l0.3-0.1L446.9,208.9
		L446.9,208.9z	"
        >
          <title id="t2343">Newberry, SC</title>
        </path>

        <path
          id="FIPS_45037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.8,216.6l0.8-0.3l0.4,0l0.4,1l0.1,0.1l0.3,0.2l2,0.4l-3.3,4.2l-0.2-0.2l-1-0.4l-0.9-1.6
		l-0.1-2.7l1.1-0.5L441.8,216.6z	"
        >
          <title id="t2345">Edgefield, SC</title>
        </path>
        <path
          id="FIPS_45065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.5,216.8l-1.1,0.5l0.1,2.7l0.9,1.6l-1.2-1.1l-0.4-0.8l-0.7-0.5l-0.3-0.2l-0.9-0.5l0,0
		l-0.1,0.1l-0.1,0l-1.6-0.9l-0.4-0.7l0.6-0.9l0.4-0.1l0.4,0.2l0.1,0l0.7-0.1l0.5-0.2l0.5,1l0.8-0.2l0.7-0.1l1.1-0.1L441.5,216.8z	"
        >
          <title id="t2346">McCormick, SC</title>
        </path>
        <path
          id="FIPS_45047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.5,211.2l0.2,0.2l0.9,0.7l1.5,0.8l0.9,0.5l0.9,0.8l-1.1,2.4l-0.4,0.2l0-0.4l-1.1,0.1
		l-0.7,0.1l-0.8,0.2l-0.5-1l0.3-0.4l0.2-0.3l0.1-0.4l0-0.4l0-0.4l-0.1-0.4l-0.2-0.3l-0.2-0.1l-0.2-0.1l-0.1-0.1l-0.4-0.8
		L438.5,211.2z	"
        >
          <title id="t2347">Greenwood, SC</title>
        </path>

        <path
          id="FIPS_45001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.6,210.4l0.8,0.9l-0.8,1l0.4,0.8l0.1,0.1l0.2,0.1l0.2,0.1l0.2,0.3l0.1,0.4l0,0.4l0,0.4
		l-0.1,0.4l-0.2,0.3l-0.3,0.4l-0.5,0.2l-0.7,0.1l-0.1,0l-0.4-0.2l-0.4,0.1l-0.6,0.9l-1.9-2.3L437.6,210.4z	"
        >
          <title id="t2349">Abbeville, SC</title>
        </path>
        <path
          id="FIPS_45007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.9,209.4l3.3-3l0.5,1.9l0,0.1l0.2,0.4l0.5,0.8l1.3,0.8l-4,4.2l-0.4-1l-1.1-1.6l-0.4-0.5
		l0,0l-0.1-0.1l-0.2-0.1l-0.4,0.1l-0.4,0.1l0,0l-0.1,0.1L431.9,209.4z	"
        >
          <title id="t2350">Anderson, SC</title>
        </path>
        <path
          id="FIPS_45087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.1,204l0.7,0.1l1.4,0.1l0.2,0.1l0.1,0.1l0.3,0.3l-0.2,0.3l1.1,3.1l0.1,1l0,0l-0.1,0
		l-0.3,0.1l-0.2,0.1l-0.4,0.5l-1.4-0.8l-2.3-0.5l0.2-1.4l0.1-1.8l0.3-0.6L443.1,204z	"
        >
          <title id="t2351">Union, SC</title>
        </path>
        <path
          id="FIPS_45025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M457.8,202.9l4.1-0.6l1.6,3.3l-2.2,0.9l-2.3,2l-1.8-3l-2-2.3L457.8,202.9z	"
        >
          <title id="t2352">Chesterfield, SC</title>
        </path>
        <path
          id="FIPS_45057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.1,200.6l0.8,0.9l0.7,0.7l0.1,1.3l0,0.1l0.2,0l2.2-0.3l2,2.3l-1.4,0.9l0.4,0.7l-1.2,0.4
		l-0.7,0l-0.3-0.1l0-0.4l-0.1,0l-1.2,1.3l-0.2-1.1l-0.4-1.1l0-0.4l0.1-0.5l-0.2-0.6l-0.2-0.6l-0.1-0.2L451.1,200.6z	"
        >
          <title id="t2353">Lancaster, SC</title>
        </path>
        <path
          id="FIPS_45023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.8,203.8l0.1,0.2l0.2,0.6l0.2,0.6l-0.1,0.5l0,0.4l0.4,1.1l-1.5,0.2l-2.4,0.2l-1.8,0.2
		l-1.1-3.1L451.8,203.8z	"
        >
          <title id="t2354">Chester, SC</title>
        </path>

        <path
          id="FIPS_45021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442,200.6l4.2-0.4l-0.3,0.4l-0.7,1.4l0,0.1l0.2,1.1l0.3,0.9l0.2,0.4l-0.3-0.3l-0.1-0.1
		l-0.2-0.1l-1.4-0.1l-0.7-0.1l-0.5-0.3l-0.6-1.2l-1.1-1.8L442,200.6z	"
        >
          <title id="t2356">Cherokee, SC</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "43900"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[43900]} state-sc`
          }
          id="FIPS_43900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45083"
            className="FIPS_43900 st0 state-sc"
            d="M439.9,200.8l1-0.1l1.1,1.8l0.6,1.2l0.5,0.3l-0.3,0.4l-0.3,0.6l-0.1,1.8l-0.2,1.4l-3.4-2
		l-0.9-0.7l0-0.1l-0.2-2l-0.3-2.3L439.9,200.8z	"
          >
            <title id="t2357">Spartanburg, SC</title>
          </path>
        </g>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "24860"
              ? `metroArea clickedArea state-sc`
              : `metroArea ${colorCode[24860]} state-sc`
          }
          id="FIPS_24860"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_45045"
            className="FIPS_24860 st0 state-sc"
            d="M435.9,201.2l1.5-0.1l0.3,2.3l0.2,2l0,0.1l0.9,0.7l-0.3,1.2l-0.3,1.5l0.1,0.7l-0.7,0.8
		l-1.3-0.8l-0.5-0.8l-0.2-0.4l0-0.1l-0.5-1.9l0.1-0.1l-0.1-0.4l-0.1-0.3l-0.7-1.6l-0.5-0.6l-2,0.2l1.8-1.3L435.9,201.2z	"
          >
            <title id="t2358">Greenville, SC</title>
          </path>
          <path
            id="FIPS_45059"
            className="FIPS_24860 st0 state-sc"
            d="M442.2,208.3l2.3,0.5l-0.5,1.1l-0.6,1.3l-0.3,0.3l-0.8,1.4l-0.3,0.6l-0.9-0.5l-1.5-0.8
		l-0.9-0.7l-0.2-0.2l-0.8-0.9l0.7-0.8l-0.1-0.7l0.3-1.5l0.3-1.2L442.2,208.3z	"
          >
            <title id="t2348">Laurens, SC</title>
          </path>
          <path
            id="FIPS_45077"
            className="FIPS_24860 st0 state-sc"
            d="M431.9,203.6l2-0.2l0.5,0.6l0.7,1.6l0.1,0.3l0.1,0.4l-0.1,0.1l-3.3,3l-1-2.8l-0.7-1.7l0.2-0.7
		l0.2-0.3L431.9,203.6z	"
          >
            <title id="t2313">Pickens, SC</title>
          </path>
        </g>
        <path
          id="FIPS_46105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M231,69.8l8.5,0.6l-0.4,6.1l-0.4,5.6l-8.7-0.6l0.2-2.2l0.2-2.2l0.4-4.5l0.1,0L231,69.8z	"
        >
          <title id="t2359">Perkins, SD</title>
        </path>

        <path
          id="FIPS_46063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M221.1,69.1l9.4,0.7l0.5,0l-0.2,2.7l-0.1,0l-0.4,4.5l-0.2,2.2l-9.8-0.8l0.7-8.6L221.1,69.1z	"
        >
          <title id="t2360">Harding, SD</title>
        </path>
        <path
          id="FIPS_46033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M218.8,96l6.3,0.5l6.4,0.5l0,0.2l-0.1,0.5l-1.1,1.4l-0.9,0.1l-0.9,0.8l-0.1,1.7l-9.8-0.8
		l0-0.3L218.8,96z	"
        >
          <title id="t2361">Custer, SD</title>
        </path>
        <path
          id="FIPS_46047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M218.4,100.8l9.8,0.8l-0.5,6.2l-4.7-0.4l-5.1-0.4L218.4,100.8z	"
        >
          <title id="t2362">Fall River, SD</title>
        </path>
        <path
          id="FIPS_46102"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.4,99.3l-0.2,2.9l0.3,0l-0.1,1.1l-0.2,3.4l0.3,0l-0.1,1.7l-6.7-0.5l-2-0.1l0.5-6.2
		l0.1-1.7l0.9-0.8l0.9-0.1l5.9,0.4L236.4,99.3z	"
        >
          <title id="t2363">Oglala Lakota, SD</title>
        </path>
        <path
          id="FIPS_46007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M244.6,103.8l-0.3,5.1l-3.7-0.2l-2.3-0.2l-1.9-0.1l0.1-1.7l-0.3,0l0.2-3.4L244.6,103.8z	"
        >
          <title id="t2364">Bennett, SD</title>
        </path>
        <path
          id="FIPS_46095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.5,98L246.5,98l0.3-0.1l0.4,0l0.6,0.3l0.5,0.4l3,0.8l1.7,0.2l0.2,0.1l0.1,0.2l1,0.1l0,4.2
		l-9.5-0.5l0.3-5l0.1-0.3l0.1-0.1l0.7-0.4l0.5-0.1L246.5,98L246.5,98z	"
        >
          <title id="t2365">Mellette, SD</title>
        </path>
        <path
          id="FIPS_46121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M244.6,103.8l9.5,0.5l-0.1,5.1l-0.7,0l-0.7,0l-1.8-0.1l-3.4-0.2l-3-0.2L244.6,103.8z	"
        >
          <title id="t2366">Todd, SD</title>
        </path>
        <path
          id="FIPS_46123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.1,100l0.3,0.3l1.4,0.1l1.8,0l0.9-0.5l0.9-0.3l0.1,0l0.2,0.3l-0.1,3.1l0.8,0l-0.2,6.5
		l-6.2-0.3l0.1-5.1L254.1,100z	"
        >
          <title id="t2367">Tripp, SD</title>
        </path>
        <path
          id="FIPS_46053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.7,103.2l0.4,0.8l3.9,3.8l0.9,0.6l1,0.4l0.1,0l0.5,0.2l0.3,0.2l0.1,0.2l0.1,0.2l0,0.1
		l0,0.1l-7.1-0.2l-2.6-0.1l0.2-6.5L262.7,103.2z	"
        >
          <title id="t2368">Gregory, SD</title>
        </path>
        <path
          id="FIPS_46015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.3,97.6l1.1,0l0,5.6l-4.7-0.2l0.1-0.1l0.1-0.1l0-0.1l0-0.1l-0.6-1.5l0-0.1l0.6-2.7l0-0.1
		l0,0l-0.4-0.9L266.3,97.6z	"
        >
          <title id="t2369">Brule, SD</title>
        </path>
        <path
          id="FIPS_46003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.9,97.8l0,1.1l-0.1,4.6l-3.6-0.1l-0.8,0l0-5.6L271.9,97.8z	"
        >
          <title id="t2370">Aurora, SD</title>
        </path>
        <path
          id="FIPS_46035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.2,99l-0.1,4.5l-1.4,0l-1.9-0.1l0.1-4.6L275.2,99z	"
        >
          <title id="t2371">Davison, SD</title>
        </path>
        <path
          id="FIPS_46043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.2,103.3l3.6,0.1l1.9,0.1l0,3.9l-5.1-2.3l-0.2,0l-0.2,0l0-0.7L268.2,103.3z	"
        >
          <title id="t2372">Douglas, SD</title>
        </path>
        <path
          id="FIPS_46023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262.7,103.2l4.7,0.2l0.8,0l0,0.9l0,0.7l0.2,0l0.2,0l5.1,2.3l0.3,0.4l-0.1,0.2l-0.3,2
		l-0.1,1.2l-0.3,0.9l-0.1,0l-1.3-0.6l-1.7-1.6l0-0.1l0-0.1l-0.1-0.2l-0.1-0.2l-0.3-0.2l-0.5-0.2l-0.1,0l-1-0.4l-0.9-0.6l-3.9-3.8
		L262.7,103.2L262.7,103.2z	"
        >
          <title id="t2373">Charles Mix, SD</title>
        </path>
        <path
          id="FIPS_46009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274,107.8l4.1,0.1l-0.5,4.2l-0.8-0.1l-1.1,0.4l-0.2,0.3l-0.3,0.2l-0.1,0.1l-0.5,0.1l-0.2,0
		l-0.2,0l-0.2-0.1l-1-0.9l0.1,0l0.3-0.9l0.1-1.2l0.3-2L274,107.8z	"
        >
          <title id="t2374">Bon Homme, SD</title>
        </path>
        <path
          id="FIPS_46135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.1,107.9l2.2,0l2.2,1.2l0.1,3.9l-1.1-0.9l-0.7-0.1l-0.9,0l-0.6,0.1l-1.9,0.1L278.1,107.9z
			"
        >
          <title id="t2375">Yankton, SD</title>
        </path>
        <path
          id="FIPS_46067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M273.8,103.5l1.4,0l3.3,0.1l1.9,0l0,4.3l-2.2,0l-4.1-0.1l-0.3-0.4L273.8,103.5z	"
        >
          <title id="t2376">Hutchinson, SD</title>
        </path>
        <path
          id="FIPS_46061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M276.3,99l2.3,0.1l-0.1,4.5l-3.3-0.1l0.1-4.5L276.3,99z	"
        >
          <title id="t2377">Hanson, SD</title>
        </path>

        <path
          id="FIPS_46027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.8,109l1.1,0l0,4.9l-2-0.7l-1.2-0.3l-0.1-3.9L284.8,109z	"
        >
          <title id="t2380">Clay, SD</title>
        </path>
        <path
          id="FIPS_46127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.2,109.1l-0.7,2.3l-0.4,1l-0.4,1.7l0.2,0.2l0.3,0.3l0.2,0.4l0.3,0.9l0.3,0.9l-1.8-0.5
		l-0.7-1l0-0.1l0-0.1l0-0.2l-0.1-0.2l-0.1-0.2l-0.8-0.5l0-4.9L289.2,109.1z	"
        >
          <title id="t2381">Union, SD</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "43620"
              ? `metroArea clickedArea state-sd`
              : `metroArea ${colorCode[43620]} state-sd`
          }
          id="FIPS_43620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_46083"
            className="FIPS_43620 st0 state-sd"
            d="M284.9,103.6l3,0l0.2,3.1l0.2,0.5l0.7,0l0.1,0l0.4,1.3l0,0.1l-0.1,0.4l-3.3,0l-1.1,0
		L284.9,103.6z	"
          >
            <title id="t2382">Lincoln, SD</title>
          </path>
          <path
            id="FIPS_46087"
            className="FIPS_43620 st0 state-sd"
            d="M280.8,99.1l2.2,0l-0.1,4.5l-2.5,0l-1.9,0l0.1-4.5L280.8,99.1z	"
          >
            <title id="t2378">McCook, SD</title>
          </path>
          <path
            id="FIPS_46099"
            className="FIPS_43620 st0 state-sd"
            d="M285.2,99.2l4,0l0,4.5l-1.4,0l-3,0l-1.9,0l0.1-4.5L285.2,99.2z	"
          >
            <title id="t2383">Minnehaha, SD</title>
          </path>
          <path
            id="FIPS_46125"
            className="FIPS_43620 st0 state-sd"
            d="M282.9,103.6l1.9,0l0,5.4l-2.2,0l-2.2-1.2l0-4.3L282.9,103.6z	"
          >
            <title id="t2379">Turner, SD</title>
          </path>
        </g>

        <path
          id="FIPS_46085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.4,94.1l0.1,1.2l0,0.1l0.2,0.2l0.2,0.2l0.3,0.1l0.3,0l0.2,0.1l0.5,0.4l0.2,0.2l0.1,0.2
		l0,0.2l0,0.3l-0.1,0.2l0.4,0.9l0,0l0,0.1l-0.6,2.7l0,0.1l0.6,1.5l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1h0l-2.2-0.1l-0.8,0l0.1-3.1
		l-0.2-0.3l-0.1,0l-0.9,0.3l-0.9,0.5l-1.8,0l-1.4-0.1l-0.3-0.3l-1-0.1l0.1-1.4l-0.2-0.3l0.2-4.2l0-0.3l4,0.2l0,0.1l0.3,0.6l0.1,0.1
		l0.1,0.1l0.1,0l0.1,0l2.1,0.4l0.2-0.1l0.1-0.1l0.1-0.1l0-0.1l0-0.1l0-0.1l-0.1-0.1l-0.5-0.9L260.4,94.1	"
        >
          <title id="t2384">Lyman, SD</title>
        </path>
        <path
          id="FIPS_46075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M253.1,94.1l-0.2,4.2l0.2,0.3l-0.1,1.4l-0.1-0.2l-0.2-0.1l-1.7-0.2l-3-0.8l-0.5-0.4l-0.6-0.3
		l-0.4,0l-0.2,0l-0.1,0.1l0.1-2l0.3-2.2L253.1,94.1z	"
        >
          <title id="t2385">Jones, SD</title>
        </path>
        <path
          id="FIPS_46071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.8,95.5l8.7,0.5l-0.1,2l-0.1-0.1l-0.2-0.1l-0.5,0.1l-0.7,0.4l-0.1,0.1l-0.1,0.3l-0.3,5
		l-8.2-0.5l0.1-1.1l-0.3,0l0.2-2.9l0.4,0.2l0.4,0h0l0.3-0.2l0.2-3.7L237.8,95.5z	"
        >
          <title id="t2386">Jackson, SD</title>
        </path>
        <path
          id="FIPS_46117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250.3,86.2l0.8,0.4l0,0l0.1,0.4v0.2l-0.1,0.5L251,88l-0.1,0.1l0,0.3l0,0.2l0.1,0.1l0.1,0.1
		l0.1,0.1l0.1,0.1l0.6,0.1l-0.4,0.6l-0.1,0.1l-0.1,0.2l0,0.1l0,0.1l0.1,0.1l1.8,1.4l0,0l0.2,0.1l0.9,0.2l0.3,0.1l0.4,0l0.1,0
		l0.6,0.2l1.5,0.6l0.1,0l0.1,0.1l0.1,0.2l0,0l-0.4,0.6l-4-0.2l0,0.3l-6.3-0.3l-1.1-0.1l0.1-2.3l0.4-4.5l0.2-0.7l1,0.4l0.3-0.1
		l0.1-0.2l0.6-0.2l0.8-0.1L250.3,86.2z	"
        >
          <title id="t2387">Stanley, SD</title>
        </path>
        <path
          id="FIPS_46055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M238.3,88.9L238.3,88.9l0.1-0.2l2.5-0.6l0.5,0l0.3,0l0.1,0.1l1.5-0.4l2.2-0.8l0.6-0.4l0.2-0.3
		l-0.2,0.7l-0.4,4.5l-0.1,2.3l1.1,0.1l-0.3,2.2l-8.7-0.5l0.3-4.5l0.1,0L238.3,88.9L238.3,88.9z	"
        >
          <title id="t2388">Haakon, SD</title>
        </path>
        <path
          id="FIPS_46103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.1,92.2l5.6,0.5l9.8,0.7l0.3-1.2l0.2-1l0.5-1.4l0.1-0.1l0.1-0.1l0.1-0.1l0.5,0l0.6,0.2
		l0.4,0l0.7-0.8l0.1,0l0.3-0.1l-0.1,2.2l-0.1,0l-0.3,4.5l-0.1,0l-0.2,3.7l-0.3,0.2h0l-0.4,0l-0.4-0.2l-0.4,0.1l-5.9-0.4l1.1-1.4
		l0.1-0.5l0-0.2l-6.4-0.5l-6.3-0.5L219.1,92.2z	"
        >
          <title id="t2389">Pennington, SD</title>
        </path>
        <path
          id="FIPS_46081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.5,86.7l1.4-0.2l0.8-0.1l2.3,0.2l-0.3,3.5l-0.1,0.9l1.1,0.1l-0.1,1.5l-5.6-0.5l0-0.5
		L219.5,86.7z	"
        >
          <title id="t2390">Lawrence, SD</title>
        </path>
        <path
          id="FIPS_46019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.2,79.2l-0.2,2.2h0l-0.3,4l-0.2,1.6l-5.5-0.4l-2.3-0.2l-0.8,0.1l-1.4,0.2l0.5-5.5l0.4-2.8
		L230.2,79.2z	"
        >
          <title id="t2391">Butte, SD</title>
        </path>
        <path
          id="FIPS_46093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M238.8,82.1l-0.4,6.8l0,0L238,89l-0.1,0l-0.7,0.8l-0.4,0l-0.6-0.2l-0.5,0l-0.1,0.1l-0.1,0.1
		l-0.1,0.1l-0.5,1.4l-0.2,1l-0.3,1.2l-9.8-0.7l0.1-1.5l-1.1-0.1l0.1-0.9l0.3-3.5l5.5,0.4l0.2-1.6l0.3-4h0L238.8,82.1z	"
        >
          <title id="t2392">Meade, SD</title>
        </path>
        <path
          id="FIPS_46137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.1,76.5l4.8,0.3l-0.6,5.6l0,0.6l3.3,0.2l-0.2,3.2l-0.2,0.3l-0.6,0.4l-2.2,0.8l-1.5,0.4
		l-0.1-0.1l-0.3,0l-0.5,0l-2.5,0.6l-0.1,0.1l0,0.1l0.4-6.8L239.1,76.5z	"
        >
          <title id="t2393">Ziebach, SD</title>
        </path>
        <path
          id="FIPS_46041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.1,77.3l0.6,1.2l0,0.1l-0.1,0.3l-0.2,0.3l0,0.1l0,0.1l0.1,0.3l0.4,0.6l0,0.1l-0.2,1
		l-0.5,1.1l-0.4,0.6l-0.2,0l-0.1,0l-0.2,0.2l-0.1,0.2l0,0.2l0,0.6l0,0.1l0.2,0.5l0,0.1l-0.1,0.1l-0.2,0.2l-1.1,1l-0.2,0.1l-0.3-0.1
		l-0.2-0.1L251,86l-0.1-0.2l-0.1-0.1l-0.1-0.1l-0.2-0.1l0,0l-0.1,0.1l-0.1,0.2l0,0.1l0,0.1l0,0.1l0,0.1l0.1,0.1l-1-0.2l-0.8,0.1
		l-0.6,0.2l-0.1,0.2l-0.3,0.1l-1-0.4l0.2-3.2l-3.3-0.2l0-0.6l0.6-5.6L254.1,77.3z	"
        >
          <title id="t2394">Dewey, SD</title>
        </path>
        <path
          id="FIPS_46129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M253.4,75.7l6.5,0.3l0.1,0l-0.2,4.5l-5-0.2l-0.4-0.6l-0.1-0.3l0-0.1l0-0.1l0.2-0.3l0.1-0.3
		l0-0.1l-0.6-1.2L253.4,75.7z	"
        >
          <title id="t2395">Walworth, SD</title>
        </path>
        <path
          id="FIPS_46107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.7,80.3l5,0.2l1.2,0.1l-0.2,4.5l-0.9,0l-6.7-0.3l-0.1-0.2l0-0.1l0-0.6l0-0.2l0.1-0.2
		l0.2-0.2l0.1,0l0.2,0l0.4-0.6l0.5-1.1l0.2-1L254.7,80.3z	"
        >
          <title id="t2396">Potter, SD</title>
        </path>
        <path
          id="FIPS_46119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.9,85l-0.2,4.5l-7.8-0.3l-0.6-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.1-0.1l0-0.2l0-0.3
		L251,88l0.1-0.3l0.1-0.5v-0.2l-0.1-0.4l0,0l-0.8-0.4l-0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.1l0.1-0.2l0.1-0.1l0,0l0.2,0.1l0.1,0.1
		l0.1,0.1L251,86l0.3,0.3l0.2,0.1l0.3,0.1l0.2-0.1l1.1-1l0.2-0.2l0.1-0.1l0-0.1l-0.1-0.3L259.9,85z	"
        >
          <title id="t2397">Sully, SD</title>
        </path>
        <path
          id="FIPS_46065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.7,89.5l0,4.3l0.5,0.9l0.1,0.1l0,0.1l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.2,0.1l-2.1-0.4
		l-0.1,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.3-0.6l0-0.1l0.4-0.6l0,0l-0.1-0.2l-0.1-0.1l-0.1,0l-1.5-0.6l-0.6-0.2l-0.1,0l-0.4,0l-0.3-0.1
		l-0.9-0.2l-0.2-0.1l0,0l-1.8-1.4l-0.1-0.1l0-0.1l0-0.1l0.1-0.2l0.1-0.1l0.4-0.6L259.7,89.5	"
        >
          <title id="t2398">Hughes, SD</title>
        </path>
        <path
          id="FIPS_46017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.4,94.1l2.6,0.1l3.4,0.1l-0.1,3.4l-4-0.1l0.1-0.2l0-0.3l0-0.2l-0.1-0.2l-0.2-0.2l-0.5-0.4
		l-0.2-0.1l-0.3,0l-0.3-0.1l-0.2-0.2l-0.2-0.2l0-0.1L260.4,94.1z	"
        >
          <title id="t2399">Buffalo, SD</title>
        </path>
        <path
          id="FIPS_46073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.5,94.3l2.1,0.1l3.4,0.1l-0.1,3.3l-4.4-0.1l-1.1,0L266.5,94.3z	"
        >
          <title id="t2400">Jerauld, SD</title>
        </path>
        <path
          id="FIPS_46111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.9,94.4l4.4,0.1h0l-0.1,4.5l-1.1,0l-3.3-0.1l0-1.1L271.9,94.4z	"
        >
          <title id="t2401">Sanborn, SD</title>
        </path>
        <path
          id="FIPS_46097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.8,94.6l-0.1,4.5l-2.2,0l-2.3-0.1l0.1-4.5L280.8,94.6z	"
        >
          <title id="t2402">Miner, SD</title>
        </path>
        <path
          id="FIPS_46079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.8,94.6l2.2,0l2.2,0l0,4.5l-2.2,0l-2.2,0L280.8,94.6z	"
        >
          <title id="t2403">Lake, SD</title>
        </path>
        <path
          id="FIPS_46101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.3,94.7l0,4.5l-4,0l0-4.5L289.3,94.7z	"
        >
          <title id="t2404">Moody, SD</title>
        </path>
        <path
          id="FIPS_46011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.1,90.1l2.2,0l4,0l0,4.5l-4,0l-2.2,0L283.1,90.1z	"
        >
          <title id="t2405">Brookings, SD</title>
        </path>
        <path
          id="FIPS_46057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M285.4,86.8l0,3.4l-2.2,0l-3.3-0.1l0.1-3.4L285.4,86.8z	"
        >
          <title id="t2406">Hamlin, SD</title>
        </path>
        <path
          id="FIPS_46077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.8,90.1l3.3,0.1l-0.1,4.5l-2.2,0l-4.4-0.1h0l0.1-4.5L279.8,90.1z	"
        >
          <title id="t2407">Kingsbury, SD</title>
        </path>
        <path
          id="FIPS_46005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.3,88.9l1.1,1.2l-0.1,4.5l-4.4-0.1l-3.4-0.1l0.1-5.7L275.3,88.9z	"
        >
          <title id="t2408">Beadle, SD</title>
        </path>
        <path
          id="FIPS_46069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.8,85l2.4,0.1l-0.2,4.5l0.1,0l-0.2,4.6l-2.6-0.1l-0.8-0.4l0-4.3l0.2-4.5L260.8,85z	"
        >
          <title id="t2409">Hyde, SD</title>
        </path>
        <path
          id="FIPS_46059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M263.2,85.1l5.4,0.2v3.4l-0.1,5.7l-2.1-0.1l-3.4-0.1l0.2-4.6l-0.1,0L263.2,85.1z	"
        >
          <title id="t2410">Hand, SD</title>
        </path>
        <path
          id="FIPS_46045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.9,76l8.9,0.3l-0.1,4.5l-7.7-0.3l-1.2-0.1L259.9,76z	"
        >
          <title id="t2411">Edmunds, SD</title>
        </path>
        <path
          id="FIPS_46049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.7,80.8L268.7,80.8l-0.1,4.5l-5.4-0.2l-2.4-0.1l0.2-4.5L268.7,80.8z	"
        >
          <title id="t2412">Faulk, SD</title>
        </path>
        <path
          id="FIPS_46115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.5,81l0,1.1l-0.1,3.2v0.2l0,0l-0.1,3.4l-6.7-0.2v-3.4l0.1-4.5L275.5,81z	"
        >
          <title id="t2413">Spink, SD</title>
        </path>
        <path
          id="FIPS_46025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.9,82.2l0,4.5l-0.1,3.4l-3.3-0.1l-1.1-1.2l0.1-3.4l0,0v-0.2l0.1-3.2L279.9,82.2z	"
        >
          <title id="t2414">Clark, SD</title>
        </path>
        <path
          id="FIPS_46029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.9,82.2l2.4,0l3.1,0.1l0,2.2l0,2.2l-5.6-0.1L279.9,82.2z	"
        >
          <title id="t2415">Codington, SD</title>
        </path>
        <path
          id="FIPS_46039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.4,84.6l0,2.2l0,2.3l0,1.1l-4,0l0-3.4l0-2.2L289.4,84.6z	"
        >
          <title id="t2416">Deuel, SD</title>
        </path>
        <path
          id="FIPS_46051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M289.2,80.1l0.1,0.7l0,3.8l-3.9,0l0-2.2l-3.1-0.1l0-1.9l2,0l0.7-0.4L289.2,80.1z	"
        >
          <title id="t2417">Grant, SD</title>
        </path>
        <path
          id="FIPS_46037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.6,76.5l5.5,0.1l0.1,0.4l1.2,0l-0.1,5.2l-2.4,0l-4.4-0.1L275.6,76.5z	"
        >
          <title id="t2418">Day, SD</title>
        </path>
        <path
          id="FIPS_46109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M288.4,72.2l0,0.6v0l0,0l0,0.3l0,0.3l0,0.1l0,0.1l0,0l0,0l0,0l-0.6,0.9l-0.2,0.2l-0.3,0.2
		l-0.3,0.2l-0.8,0.7l0,0l0,0l0,0l0,0.1l-0.1,0.4l0,0.1l0.2,0.2l0.6,0.8l1.3,1.5l0.9,0.4l0.3,0.2l0.2,0.4l-4.2,0l-0.7,0.4l-2,0l0-3.4
		l0-4.9L288.4,72.2z	"
        >
          <title id="t2419">Roberts, SD</title>
        </path>
        <path
          id="FIPS_46091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M282.4,72.2l0,4.9l-1.2,0l-0.1-0.4l-5.5-0.1l0.1-4.5L282.4,72.2z	"
        >
          <title id="t2420">Marshall, SD</title>
        </path>
        <path
          id="FIPS_46013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269,71.9l6.4,0.2l0.3,0l-0.1,4.5l-0.1,4.5l-6.7-0.2l0,0l0.1-4.5L269,71.9z	"
        >
          <title id="t2421">Brown, SD</title>
        </path>
        <path
          id="FIPS_46089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260,71.5l6.4,0.2l2.5,0.1l-0.1,4.5l-8.9-0.3l-0.1,0L260,71.5z	"
        >
          <title id="t2422">McPherson, SD</title>
        </path>
        <path
          id="FIPS_46021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.6,71.5l1.5,0.1l-0.2,4.5l-6.4-0.3l0.1-0.5l0.1-0.2l0.2-0.1l0.4,0l0.1,0l0.2-0.1l0-0.1
		l0.1-0.2l0-0.2l-0.6-2l-0.1-0.1l-1-1L258.6,71.5z	"
        >
          <title id="t2423">Campbell, SD</title>
        </path>
        <path
          id="FIPS_46031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.5,70.4L239.5,70.4L239.5,70.4l0.2,0l1.1,0.1l1.3,0.1l1.4,0.1l1.1,0.1l0.5,0l0.9,0.1
		l2.6,0.1l0.8,0l1.1,0.1l0.1,0l0.2,0l2,0.1l0.1,0l1,1l0.1,0.1l0.6,2l0,0.2l-0.1,0.2l0,0.1l-0.2,0.1l-0.1,0l-0.4,0l-0.2,0.1l-0.1,0.2
		l-0.1,0.5l0.7,1.6l-10.2-0.5l-4.8-0.3L239.5,70.4L239.5,70.4z	"
        >
          <title id="t2424">Corson, SD</title>
        </path>
        <path
          id="FIPS_47163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.6,182.3l-1.4,1.6l-3,1.9l-0.5,0.1l-0.2,0l-0.5-0.4l-0.4-0.1l-0.6,0.2l-1.3,0.2l-0.6,0.1
		l0.4-2.2l3.2-0.5l0.5-0.1l1-0.1l2.2-0.3l0.1-0.3L438.6,182.3z	"
        >
          <title id="t2425">Sullivan, TN</title>
        </path>
        <path
          id="FIPS_47091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.6,182.3l1.8-0.2l-0.3,0.4l0,2.6l0,0.6l-0.2,0.1h0l-0.2,0l-0.3-0.1l-0.1-0.1l-0.1,0l0,0
		l-0.5,0.4l-0.5,0.5l-0.1,0.2l-0.1,0.3L438,187l-0.3-0.3L437,186l-0.2-0.3l0.8-1.3v0l-0.4-0.4L438.6,182.3z	"
        >
          <title id="t2426">Johnson, TN</title>
        </path>
        <path
          id="FIPS_47109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.2,205.9l0.2,5l-4.2,0.3L369,208l0.8-0.4l0.1-0.5l0.2-0.3l0.3-0.3l0.5-0.3l0.2-0.1
		l0.6-0.1L373.2,205.9z	"
        >
          <title id="t2427">McNairy, TN</title>
        </path>
        <path
          id="FIPS_47023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.4,203.5l2.8,2l0,0.5l-1.6,0.1l-0.6,0.1l-0.2,0.1l-0.5,0.3l-0.3,0.3l-0.2,0.3l-0.1,0.5
		L369,208l-0.2-1l-0.5-0.8l0-0.6L370.4,203.5z	"
        >
          <title id="t2428">Chester, TN</title>
        </path>
        <path
          id="FIPS_47069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.7,205.9l2.5-0.1l0,0.6l0.5,0.8l0.2,1l0.2,3.3l-0.4,0l-2,0.2l-1.9,0.1l-0.2-5.2
		L365.7,205.9z	"
        >
          <title id="t2429">Hardeman, TN</title>
        </path>

        <path
          id="FIPS_47075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M362.5,201.1L362.5,201.1l0.2,0.2l0.1,0.1l0.3,0.2l0.4,0.2l0.2,0l1.1,0.3l0.8,0.3l0.1,3.4
		l-1.1,0.5l-3,0.1l-0.5-2.3l0.1,0l0.2-0.2l0.3-1.9l0-0.1h-0.1l0-0.2l0.1-0.2l0.3-0.6L362.5,201.1z	"
        >
          <title id="t2431">Haywood, TN</title>
        </path>
        <path
          id="FIPS_47113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.2,200.9l0.1,2.6l-2.2,2.3l-2.5,0.1l-0.1-3.4l1.5-1.5l2.2-0.1L370.2,200.9z	"
        >
          <title id="t2432">Madison, TN</title>
        </path>
        <path
          id="FIPS_47033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364,198.6l0.6,0.4l0.1,0.7l0.1,0.3l0.2,0.4l1.3,0.3l0.7,0.4l-1.5,1.5l-0.8-0.3l-1.1-0.3
		l-0.2,0l-0.4-0.2l-0.3-0.2l-0.1-0.1l-0.1-0.2l0,0l0.1-0.8L364,198.6z	"
        >
          <title id="t2433">Crockett, TN</title>
        </path>
        <path
          id="FIPS_47053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M364.2,195.9l2-0.4l0.3,0.3l0.8,0.7l0.1,0l0.1,0l0.9,0.3l0.8,0.6l0.1,3.5L367,201l-0.7-0.4
		l-1.3-0.3l-0.2-0.4l-0.1-0.3l-0.1-0.7l-0.6-0.4L364.2,195.9z	"
        >
          <title id="t2434">Gibson, TN</title>
        </path>
        <path
          id="FIPS_47017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.7,196.1l3.3,0.1l0.6,3.5l0,0.4l-4.1,0.2l-0.2,0.1l-0.1,0.2l-0.1,0.2l-1,0.1l-0.1-3.5
		L370.7,196.1z	"
        >
          <title id="t2435">Carroll, TN</title>
        </path>
        <path
          id="FIPS_47183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.4,191.8l3.1-0.2l0.2,4.6l-1.6,1.3l-0.8-0.6l-0.9-0.3l-0.1,0l-0.1,0l-0.8-0.7l-0.3-0.3
		l-0.1-2.4l0,0l0.2,0l0.1,0l0.1,0.1l0.2,0l0.7-0.3l0-0.8l-0.2-0.4L367.4,191.8z	"
        >
          <title id="t2436">Weakley, TN</title>
        </path>
        <path
          id="FIPS_47131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M367.2,191.8L367.2,191.8l0.2,0.4l0,0.8l-0.7,0.3l-0.2,0l-0.1-0.1l-0.1,0l-0.2,0l0,0l0.1,2.4
		l-2,0.4l-3.4,0.1l1.1-3.9L367.2,191.8z	"
        >
          <title id="t2437">Obion, TN</title>
        </path>
        <path
          id="FIPS_47095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.9,192.2l-1.1,3.9l-1.5,0.5l0.7-2l-0.1-2.1l0.6,0l0.7-0.1L361.9,192.2z	"
        >
          <title id="t2438">Lake, TN</title>
        </path>
        <path
          id="FIPS_47045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M360.8,196l3.4-0.1l-0.2,2.7l-1.5,1.6l-0.1-0.2l-0.1-0.1l-0.5-0.5l-0.9,0l-1.5,0.6l-0.5,0.1
		l-0.6-1.2l0.9-2.5L360.8,196z	"
        >
          <title id="t2439">Dyer, TN</title>
        </path>
        <path
          id="FIPS_47097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M358.9,200.2l0.5-0.1l1.5-0.6l0.9,0l0.5,0.5l0.1,0.1l0.1,0.2l-0.1,0.8l-0.5,0l-0.3,0.6
		l-0.1,0.2l0,0.2h0.1l0,0.1l-0.3,1.9l-0.2,0.2l-0.1,0l-0.5-0.3l-0.8-0.4l-1.4,0.1l-0.3,0.1l-0.2,0.2l-0.5,0.5l-0.2,0.2l-0.2,0.4
		l0.3-2.7l0.9-1.9l0.1-0.1l0,0l0.2-0.1l0.2,0L358.9,200.2z	"
        >
          <title id="t2440">Lauderdale, TN</title>
        </path>

        <path
          id="FIPS_47077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374.6,200.1l0.1,2.7l-0.5,1.1l0.1,1.4l0.1,0l-1.2,0.2l-2.8-2l-0.1-2.6l0.1-0.2l0.1-0.2
		l0.2-0.1L374.6,200.1z	"
        >
          <title id="t2443">Henderson, TN</title>
        </path>
        <path
          id="FIPS_47079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.7,191.5l4.5-0.3l0.8,1.7l-1.1,0.1l0,0l0,0.4l0,0.2l0.2,0.7l-0.8,1.4l-0.4,0.4l-3.3-0.1
		l-0.2-4.6L370.7,191.5z	"
        >
          <title id="t2444">Henry, TN</title>
        </path>
        <path
          id="FIPS_47005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M376,192.9L376,192.9l0.5,1.5l0.4,1l0.2,3v0.2l-0.1,0.5l0,0.1l-0.2,0.3l-0.1,0.3l-2.2-0.2
		l-0.6-3.5l0.4-0.4l0.8-1.4l-0.2-0.7l0-0.2l0-0.4l0,0L376,192.9z	"
        >
          <title id="t2445">Benton, TN</title>
        </path>
        <path
          id="FIPS_47039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M374.6,199.8l2.2,0.2l-0.3,1l-0.2,0.6l0.1,3.3l0.1,0.2l0.1,0.1l0.1,0l0.2,0l-0.1,0.4l-2.3-0.2
		l-0.1,0l-0.1-1.4l0.5-1.1l-0.1-2.7L374.6,199.8z	"
        >
          <title id="t2446">Decatur, TN</title>
        </path>
        <path
          id="FIPS_47071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M373.2,205.4l1.2-0.2l2.3,0.2l0,0.2l0.2,0.9l0.5,1.6l0.2,2.3l-2.2,0.3l-1.7,0.1l-0.2,0l-0.2-5
		L373.2,205.4z	"
        >
          <title id="t2447">Hardin, TN</title>
        </path>
        <path
          id="FIPS_47099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.2,204.2l0.9,0.1l0,0.3l0,0.3l0.3,3.5l0.1,1.5l-4,0.3l-0.1-5.1l0.4,0l0.9-0.4l0-0.5
		l1.3-0.1L384.2,204.2z	"
        >
          <title id="t2448">Lawrence, TN</title>
        </path>
        <path
          id="FIPS_47181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M379.8,204.1l1.6,1l0.1,5.1l-4,0.3l-0.2-2.3l-0.5-1.6l-0.2-0.9l0-0.2l0.1-0.4L379.8,204.1z	"
        >
          <title id="t2449">Wayne, TN</title>
        </path>
        <path
          id="FIPS_47101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M383.5,201.4l-0.1,0.5l0,0.3l0,0.2l0.2,0.1l0.3,0l0.3,0.2l0.3,0.5l0,0.5l0,0.2l-0.1,0.2
		l-0.3-0.1l-1.3,0.1l0,0.5l-0.9,0.4l-0.4,0l-1.6-1l0.5-1.7l0.4-0.3l0.7-0.1l0.9,0.1l0.1,0l0.4-0.2L383.5,201.4z	"
        >
          <title id="t2450">Lewis, TN</title>
        </path>
        <path
          id="FIPS_47135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M379.4,199.4l0.9,2.9l-0.5,1.7l-3,1l-0.2,0l-0.1,0l-0.1-0.1l-0.1-0.2l-0.1-3.3l0.2-0.6l0.3-1
		l0.1-0.3l1.2,0.2l0.3-0.2l0.2,0L379.4,199.4z	"
        >
          <title id="t2451">Perry, TN</title>
        </path>

        <path
          id="FIPS_47085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.6,194.9l0.5,2.4l-1.7,2.2l-0.9,0.1l-0.2,0l-0.3,0.2l-1.2-0.2l0.2-0.3l0-0.1l0.1-0.5v-0.2
		l-0.2-3l-0.4-1l1.2,0l0.4-0.2l0.4,0l1.8,0.4L380.6,194.9z	"
        >
          <title id="t2453">Humphreys, TN</title>
        </path>
        <path
          id="FIPS_47083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M380.1,192.5l0.8,0.4l-0.4,2.1l-0.2-0.2l-1.8-0.4l-0.4,0l-0.4,0.2l-1.2,0l-0.4-1.4l1.1,0.2
		l0.2,0l0.3,0l0.2,0l0.2-0.1l0.3-0.1l0.2-0.1l0.1-0.1L380.1,192.5z	"
        >
          <title id="t2454">Houston, TN</title>
        </path>
        <path
          id="FIPS_47161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M378.7,189.1l0.5-0.1l0.8,3.5l-1.3,0.2l-0.1,0.1l-0.2,0.1l-0.3,0.1l-0.2,0.1l-0.2,0l-0.3,0
		l-0.2,0l-1.1-0.2l-0.1-0.1l-0.8-1.7l-0.4-2.3l0.6,0l1.7,0l0,0.4L378.7,189.1z	"
        >
          <title id="t2455">Stewart, TN</title>
        </path>
        <path
          id="FIPS_47125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.6,188.5l0.2,2.4l-1.5,1.9l-2.3,0l-0.8-0.4l-0.8-3.5l3.1-0.3L384.6,188.5z	"
        >
          <title id="t2456">Montgomery, TN</title>
        </path>

        <path
          id="FIPS_47119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M384.6,198.8l4.7,1.4l-1.5,3.9l-2.6,0l-0.9-0.1l0.1-0.2l0-0.2l0-0.5l-0.3-0.5l-0.3-0.2l-0.3,0
		l-0.2-0.1l0-0.2l0-0.3l0.1-0.5L384.6,198.8z	"
        >
          <title id="t2461">Maury, TN</title>
        </path>
        <path
          id="FIPS_47117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M389.2,200.3l1-0.1l0.5,0.3l0,2.5l0,0.5l0.1,0.3l0.5,0.8l0.2,0l0,0l-2.3,1.5l-1.6-1.9
		L389.2,200.3z	"
        >
          <title id="t2462">Marshall, TN</title>
        </path>
        <path
          id="FIPS_47055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M385.2,204.2l2.6,0l1.6,1.9l0.3,3.5l-3.9,0.3l-0.1,0l-0.1-1.5l-0.3-3.5l0-0.3L385.2,204.2z	"
        >
          <title id="t2463">Giles, TN</title>
        </path>
        <path
          id="FIPS_47103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M392.3,204.6l2.5,2.7l0.2,1.8l-4.9,0.5l-0.5,0.1l-0.3-3.5l2.3-1.5L392.3,204.6z	"
        >
          <title id="t2464">Lincoln, TN</title>
        </path>
        <path
          id="FIPS_47127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395,203.5l0.1,1l-0.3,2.7l-2.5-2.7L395,203.5z	"
        >
          <title id="t2465">Moore, TN</title>
        </path>
        <path
          id="FIPS_47003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M394.9,200.7l0.2,2.8l-2.7,1l-0.8-0.1l0,0l-0.2,0l-0.5-0.8l-0.1-0.3l0-0.5l0-2.5l0-0.2l0.1,0
		l0.8,0l2.6,0.3L394.9,200.7z	"
        >
          <title id="t2466">Bedford, TN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "34980"
              ? `metroArea clickedArea state-tn`
              : `metroArea ${colorCode[34980]} state-tn`
          }
          id="FIPS_34980"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_47015"
            className="FIPS_34980 st0 state-tn"
            d="M396.8,196.2l1.5,1.4l-0.8,2.4l-2.4-0.3l0.2-3.3L396.8,196.2z	"
          >
            <title id="t2471">Cannon, TN</title>
          </path>
          <path
            id="FIPS_47021"
            className="FIPS_34980 st0 state-tn"
            d="M384.8,190.9l2.2,0.7l-1,4.5l-1.3,0.1l0.1-1.8l-0.1-0.5l-0.2-0.2l0.3-0.4l0-0.3l0-0.1
		l-0.2-0.1l-0.5-0.1l-0.6,0.1L384.8,190.9z M384.7,193L384.7,193L384.7,193L384.7,193L384.7,193L384.7,193z	"
          >
            <title id="t2458">Cheatham, TN</title>
          </path>
          <path
            id="FIPS_47037"
            className="FIPS_34980 st0 state-tn"
            d="M387,191.7l1.6-0.4l1.9,1.9l1,1.8l-0.9,1.8l-1.8-0.7l-1.5-0.1l-0.9,0.9l-0.1,0l-0.2-0.7
		L387,191.7z	"
          >
            <title id="t2468">Davidson, TN</title>
          </path>
          <path
            id="FIPS_47043"
            className="FIPS_34980 st0 state-tn"
            d="M380.9,192.9l2.3,0l0.6-0.1l0.5,0.1l0.2,0.1l0,0.1l0,0.3l-0.3,0.4l0.2,0.2l0.1,0.5l-0.1,1.8
		l-0.1,1.2l-3.4-0.1l-0.5-2.4L380.9,192.9z	"
          >
            <title id="t2459">Dickson, TN</title>
          </path>
          <path
            id="FIPS_47081"
            className="FIPS_34980 st0 state-tn"
            d="M384.6,197.4l0,1.4l-1.1,2.6l-0.7,0.4l-0.4,0.2l-0.1,0l-0.9-0.1l-0.7,0.1l-0.4,0.3l-0.9-2.9
		l1.7-2.2L384.6,197.4z	"
          >
            <title id="t2452">Hickman, TN</title>
          </path>
          <path
            id="FIPS_47111"
            className="FIPS_34980 st0 state-tn"
            d="M396.3,187.5l1.9-0.1l-0.1,1.6l0,1.1l-1.6,0l-2.6-0.5l0-2L396.3,187.5z	"
          >
            <title id="t2483">Macon, TN</title>
          </path>
          <path
            id="FIPS_47147"
            className="FIPS_34980 st0 state-tn"
            d="M388.2,188.1h2.1l-0.3,0.7l-0.6,1.7l-0.2,0.5l-0.6,0.2l-1.6,0.4l-2.2-0.7l-0.2-2.4l0.6-0.1
		L388.2,188.1z	"
          >
            <title id="t2457">Robertson, TN</title>
          </path>
          <path
            id="FIPS_47149"
            className="FIPS_34980 st0 state-tn"
            d="M391.5,194.9l0.5,0.3l1.6,1l0.2,0.1l0.7,0.2l1,0l-0.2,3.3l-0.3,1l-0.6-0.2l-2.6-0.3l-0.8,0
		l-0.1,0l0,0.2l-0.5-0.3l0.4-3.4L391.5,194.9z	"
          >
            <title id="t2467">Rutherford, TN</title>
          </path>
          <path
            id="FIPS_47159"
            className="FIPS_34980 st0 state-tn"
            d="M396.6,190.1l1.6,0l0.7,2.2l-0.1,1.4l-2.5,0.9l-1.1-2.6L396.6,190.1z	"
          >
            <title id="t2484">Smith, TN</title>
          </path>
          <path
            id="FIPS_47165"
            className="FIPS_34980 st0 state-tn"
            d="M391.8,187.7l2.1-0.1l0,2l-0.4,1.9l-0.1,0.5l-0.4,0l-0.1-0.1l0-0.2l-0.1-0.1l-0.1-0.1l-0.1,0
		l-0.8,0.4l-1.1,0.7l-0.3,0.6l-1.9-1.9l0.6-0.2l0.2-0.5l0.6-1.7l0.3-0.7L391.8,187.7z	"
          >
            <title id="t2469">Sumner, TN</title>
          </path>
          <path
            id="FIPS_47169"
            className="FIPS_34980 st0 state-tn"
            d="M396.6,190.1l-1.4,1.9l-1.6-0.5l0.4-1.9L396.6,190.1z	"
          >
            <title id="t2482">Hartsville-Trousdale, TN</title>
          </path>
          <path
            id="FIPS_47187"
            className="FIPS_34980 st0 state-tn"
            d="M384.7,196.2l1.3-0.1l0.2,0.7l0.1,0l0.9-0.9l1.5,0.1l1.8,0.7l-0.4,3.4l-1,0.1l-4.7-1.4l0-1.4
		L384.7,196.2z	"
          >
            <title id="t2460">Williamson, TN</title>
          </path>
          <path
            id="FIPS_47189"
            className="FIPS_34980 st0 state-tn"
            d="M395.1,192l1.1,2.6l0.6,1.6l-1.4,0.2l-1,0l-0.7-0.2l-0.2-0.1l-1.6-1l-0.5-0.3l-1-1.8l0.3-0.6
		l1.1-0.7l0.8-0.4l0.1,0l0.1,0.1l0.1,0.1l0,0.2l0.1,0.1l0.4,0l0.1-0.5L395.1,192z	"
          >
            <title id="t2470">Wilson, TN</title>
          </path>
        </g>
        <path
          id="FIPS_47031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M397.5,200l1.3,1.6l0,0l0,0.1l0,1l0.1,0.6l0.2,0.1l-0.1,0.4l-0.2,0.7l-0.1,0.1l-1.4-0.6
		l-1.3-0.1l-0.9,0.3l-0.1,0.1l0,0.1l-0.1-1l-0.2-2.8l0.3-1L397.5,200z	"
        >
          <title id="t2472">Coffee, TN</title>
        </path>
        <path
          id="FIPS_47051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M395.1,204.6L395.1,204.6l0.1-0.2l0.9-0.3l1.3,0.1l1.4,0.6l0.5,0.8l0.4,3l-4.7,0.5l-0.1,0
		l-0.2-1.8L395.1,204.6z	"
        >
          <title id="t2473">Franklin, TN</title>
        </path>

        <path
          id="FIPS_47061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M401.6,201.3l0.8,2.7l-3.1,1.6l-0.5-0.8l0.1-0.1l0.2-0.7l0.1-0.4l-0.2-0.1l-0.1-0.6l0-1l0-0.1
		l0,0l0.5,0.1l0.2,0l0.6-0.2l0.5-0.1L401.6,201.3z	"
        >
          <title id="t2476">Grundy, TN</title>
        </path>
        <path
          id="FIPS_47175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.8,197.5L404.8,197.5l0.2,0.3v0l-1.5,2.8l-1.3,0.6l-0.8-3.3L404.8,197.5z	"
        >
          <title id="t2477">Van Buren, TN</title>
        </path>
        <path
          id="FIPS_47177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M400.4,197.5l0.9,0.4l0.8,3.3l-0.5,0.1l-1,0.1l-0.5,0.1l-0.6,0.2l-0.2,0l-0.5-0.1l-1.3-1.6
		l0.8-2.4L400.4,197.5z	"
        >
          <title id="t2478">Warren, TN</title>
        </path>
        <path
          id="FIPS_47185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M404.5,195.1l0.2,2.4l-3.4,0.4l-0.9-0.4l0.1-2.4l0-0.1l0-0.1l0.2-0.2l0.6-0.5l0.1-0.1l0.4-0.1
		l1.4,0.2l0.5,0.2l0.2,0.1L404.5,195.1z	"
        >
          <title id="t2479">White, TN</title>
        </path>
        <path
          id="FIPS_47041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.7,193.8l1.8,1.3l-0.1,2.4l-2.1,0.1l-1.5-1.4l-0.6-1.6L398.7,193.8z	"
        >
          <title id="t2480">DeKalb, TN</title>
        </path>
        <path
          id="FIPS_47141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.9,192.4l1.5,0.1l0.6-0.2l0.3-0.2l0.1-0.1l0.3-0.5v-0.3l0.9,0.8l2.3,0.8h0.9l0.2,0.1
		l-0.5,0.6l-0.9,0l-0.1,0.1l0,1.6l-0.5-0.5l-0.2-0.1l-0.5-0.2l-1.4-0.2l-0.4,0.1l-0.1,0.1l-0.6,0.5l-0.2,0.2l0,0.1l0,0.1l-1.8-1.3
		L398.9,192.4z	"
        >
          <title id="t2481">Putnam, TN</title>
        </path>

        <path
          id="FIPS_47087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M398.1,189l0.5-0.3l1.3,0.2l0.7,0.2l0.5,0.4l0.4,0.4l0.1,1.3v0.3l-0.3,0.5l-0.1,0.1l-0.3,0.2
		l-0.6,0.2l-1.5-0.1l-0.7-2.2L398.1,189z	"
        >
          <title id="t2485">Jackson, TN</title>
        </path>
        <path
          id="FIPS_47133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.5,188l1.9,1.4l0.1,1.3l0.2,0.5l0.4,0.9l-0.3,0.7h-0.9l-2.3-0.8l-0.9-0.8l-0.1-1.3
		L403.5,188z	"
        >
          <title id="t2486">Overton, TN</title>
        </path>
        <path
          id="FIPS_47027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M403.5,186.8l0,1.2l-2,1.9l-0.4-0.4l-0.5-0.4l-0.7-0.2l-1.3-0.2l-0.5,0.3l0.1-1.6l3.6-0.3
		l1.4-0.3L403.5,186.8z	"
        >
          <title id="t2487">Clay, TN</title>
        </path>
        <path
          id="FIPS_47137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406.6,186.6l1.9-0.1l0.7,1l-1.4-0.4l-0.4-0.1l-0.4,0l-0.6,0.2l-0.4,0.4l-0.2,0.4l-0.1,0.3
		l-0.2,1.2l-1.9-1.4l0-1.2L406.6,186.6z	"
        >
          <title id="t2488">Pickett, TN</title>
        </path>
        <path
          id="FIPS_47007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M405,197.8l1.2-0.2l0.5,0l0.6,0l0.4,0l0.8-0.2l-1.1,1.9l-0.6,0.8l-0.3,1.1l0.2,0.4l-0.8,1.4
		l-2.4-2.5L405,197.8z	"
        >
          <title id="t2489">Bledsoe, TN</title>
        </path>
        <path
          id="FIPS_47049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.2,187.4l0.6,1.9l-1.6,1.2l-0.1,0.1l-0.3,1l0.1,0.7l-2,0.5l-0.2-0.1l0.3-0.7l-0.4-0.9
		l-0.2-0.5l-0.1-1.3l0.2-1.2l0.1-0.3l0.2-0.4l0.4-0.4l0.6-0.2l0.4,0l0.4,0.1L409.2,187.4z	"
        >
          <title id="t2490">Fentress, TN</title>
        </path>
        <path
          id="FIPS_47035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M406,192.9l2-0.5l2.7,2.9l-0.9,1.2l-1.3,1l-0.8,0.2l-0.4,0l-0.6,0l-0.5,0l-1.2,0.2v0l-0.2-0.2
		l0-0.1l-0.2-2.4l0-1.6l0.1-0.1l0.9,0L406,192.9z	"
        >
          <title id="t2491">Cumberland, TN</title>
        </path>
        <path
          id="FIPS_47143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M410.5,197.4l0.1,0.2l0,0.1l0,0.5l-0.6,1.9l-1.1,1.6l-0.1,0l-0.9,0.5l-1.3-0.5l-0.2-0.4
		l0.3-1.1l0.6-0.8l1.1-1.9l1.3-1L410.5,197.4z	"
        >
          <title id="t2492">Rhea, TN</title>
        </path>
        <path
          id="FIPS_47121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M411.7,198.6l-2,4.1l-0.8,0.9l-0.9-1.5l0.9-0.5l0.1,0l1.1-1.6l0.6-1.9l0-0.5l0-0.1l-0.1-0.2
		L411.7,198.6z	"
        >
          <title id="t2493">Meigs, TN</title>
        </path>

        <path
          id="FIPS_47011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M409.6,202.7l1.8,1.2l-0.4,3.4l-0.4,0l-1.7,0.2l-0.3-0.7l-0.4-1l0.1-0.8l0.1-0.2l0.4-1.2
		L409.6,202.7z	"
        >
          <title id="t2495">Bradley, TN</title>
        </path>
        <path
          id="FIPS_47139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M413.5,203.1l2.2,0.8l0,2.8l-3.1,0.4l-1.6,0.2l0.4-3.4l0.3-0.2l0.5-0.2l1.1-0.1L413.5,203.1z	
		"
        >
          <title id="t2496">Polk, TN</title>
        </path>
        <path
          id="FIPS_47123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.2,198.5l0.1,0.1l1.1,0.6l0.5-0.1l1.1,0.6l0,0l0,0.1l-0.2,0.3l-0.4,2.3l-0.2,0.3l-0.4,0.3
		l-1.1,0l-0.9,0.7l-2.2-0.8l0.8-0.7l-0.1-0.9l-1.1-1.9l-0.4-0.7l0-0.1l0-0.1l0.3-0.5l0.3-0.2l0.2-0.1l0.1,0l1,0L416.2,198.5
		L416.2,198.5z	"
        >
          <title id="t2497">Monroe, TN</title>
        </path>
        <path
          id="FIPS_47107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412,198.6l0.6,0.2l0,0.1l0,0.1l0.4,0.7l1.1,1.9l0.1,0.9l-0.8,0.7l-0.2,0.3l-1.1,0.1l-0.5,0.2
		l-0.3,0.2l-1.8-1.2l2-4.1L412,198.6z	"
        >
          <title id="t2498">McMinn, TN</title>
        </path>
        <path
          id="FIPS_47145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.5,198.2l-0.4,0.4l-0.4,0l-1.2-1.3l-0.7-0.9l0.9-1.2l1.5-1l0.8-0.2l0.3-0.3l0.6-0.6
		l0.9,1.7l0.1,0.2l-0.2-0.1l-0.5,0.2l-1.6,2.6L412.5,198.2z	"
        >
          <title id="t2499">Roane, TN</title>
        </path>
        <path
          id="FIPS_47129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M412.7,191.7l1.2,1.4l-0.6,0.6l-0.3,0.3l-0.8,0.2l-1.5,1l-2.7-2.9l-0.1-0.7l0.3-1l0.1-0.1
		l1.6-1.2l1.1,1.2l0.5,0.4l1.1,0.4L412.7,191.7z	"
        >
          <title id="t2500">Morgan, TN</title>
        </path>
        <path
          id="FIPS_47151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M408.6,186.5l5.3-0.5l-0.1,1.1l-0.4,3.1l0,0.7l-0.6,0.8l-0.4-0.4l-1.1-0.4l-0.5-0.4l-1.1-1.2
		l-0.6-1.9L408.6,186.5L408.6,186.5z	"
        >
          <title id="t2501">Scott, TN</title>
        </path>
        <path
          id="FIPS_47013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M416.7,185.6l1.1,2.1l-0.2,0.4l-0.3,1.3l-0.1,0.2l-0.2,0.2l-3.7,1.2l0-0.7l0.4-3.1l0.1-1.1
		l0.4,0L416.7,185.6z	"
        >
          <title id="t2502">Campbell, TN</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "28940"
              ? `metroArea clickedArea state-tn`
              : `metroArea ${colorCode[28940]} state-tn`
          }
          id="FIPS_28940"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_47001"
            className="FIPS_28940 st0 state-tn"
            d="M417,189.8l0.8,1h0l-0.2,0.2l-1.1,1.5l0,0.2l0.2,0.4l-1.7,1.7l-0.2,0.1l-0.9-1.7l-1.2-1.4
		l0.6-0.8L417,189.8z	"
          >
            <title id="t2503">Anderson, TN</title>
          </path>
          <path
            id="FIPS_47105"
            className="FIPS_28940 st0 state-tn"
            d="M415,194.9l1.1,1.1l0.1,2.5l-0.1-0.1l-1.5-0.4l-1,0l-0.1,0l-0.2,0.1l-0.3,0.2l-0.3,0.5
		l-0.6-0.2l0.4-0.4l0.2-0.6l1.6-2.6l0.5-0.2L415,194.9z	"
          >
            <title id="t2504">Loudon, TN</title>
          </path>
          <path
            id="FIPS_47009"
            className="FIPS_28940 st0 state-tn"
            d="M419.8,194.4l0.9,1.5l0.4,0.7l0.4,0.2l0.2,1.6l-2.8,1.8l-0.1,0l0.2-0.3l0-0.1l0,0l-1.1-0.6
		l-0.5,0.1l-1.1-0.6l-0.1-0.1l-0.1-2.5l0.2-0.5l1.5-0.7l0.5,0l0.6,0.3h0.1L419.8,194.4z	"
          >
            <title id="t2505">Blount, TN</title>
          </path>
          <path
            id="FIPS_47093"
            className="FIPS_28940 st0 state-tn"
            d="M420,190.8l0.8,1l0,0.6l-1,2.1l-0.7,0.7h-0.1l-0.6-0.3l-0.5,0l-1.5,0.7l-0.2,0.5l-1.1-1.1
		l-0.1-0.2l0.2-0.1l1.7-1.7l-0.2-0.4l0-0.2l1.1-1.5l0.2-0.2h0L420,190.8z	"
          >
            <title id="t2507">Knox, TN</title>
          </path>
          <path
            id="FIPS_47173"
            className="FIPS_28940 st0 state-tn"
            d="M417.8,187.7l0.3-0.1l0.7-0.2l0.1,0l0.7,0.7l0.8,0.2l-0.4,2.4l-2.2,0l-0.8-1l0.2-0.2l0.1-0.2
		l0.3-1.3L417.8,187.7z	"
          >
            <title id="t2508">Union, TN</title>
          </path>
        </g>
        <path
          id="FIPS_47155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M424.8,193.7l0.9,2.2l0,0.2l-0.4,0.5l-1.8,1.4l-0.1,0.1l-1.5,0.2l-0.2,0l0,0l-0.2-1.6
		l-0.4-0.2l-0.4-0.7l-0.9-1.5l1-2.1l0.7,0.2l2.1,0.8L424.8,193.7z	"
        >
          <title id="t2506">Sevier, TN</title>
        </path>

        <path
          id="FIPS_47025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M419.8,185.1l2.1-0.2l1.2,2.3l-2.8,1.3l-0.8-0.2l-0.7-0.7l-0.1,0l-0.7,0.2l-0.3,0.1l-1.1-2.1
		l0.6-0.1L419.8,185.1z	"
        >
          <title id="t2509">Claiborne, TN</title>
        </path>
        <path
          id="FIPS_47067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.5,184l-1.1,0.8l-0.3,0l-0.3-0.2l0,0l-0.4,0.3l-0.5,0.4l-0.5,0.6l-1.1,1.3l-1.1-0.1
		l-1.2-2.3l5-0.6L428.5,184z	"
        >
          <title id="t2510">Hancock, TN</title>
        </path>
        <path
          id="FIPS_47057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M423.1,187.1l1.1,0.1l0.4,1.3l-2,1.8l-1.9,1.5l-0.8-1l0.4-2.4L423.1,187.1z	"
        >
          <title id="t2511">Grainger, TN</title>
        </path>
        <path
          id="FIPS_47063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M426.5,188.9l-0.7,0.9l-0.5,1.3l-2.5-0.8l2-1.8L426.5,188.9z	"
        >
          <title id="t2512">Hamblen, TN</title>
        </path>
        <path
          id="FIPS_47089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.2,191.1l-0.5,2.5l-1.1-0.3l-2.1-0.8l-0.7-0.2l0-0.6l1.9-1.5L425.2,191.1z	"
        >
          <title id="t2513">Jefferson, TN</title>
        </path>
        <path
          id="FIPS_47029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M425.8,189.8l0,0.3l0.1,0.1l0.4,0.3l0.9,0.5l1.1,0.9l0.7,0.6l-0.4,2l-2.9,1.4l-0.9-2.2
		l0.5-2.5L425.8,189.8z	"
        >
          <title id="t2514">Cocke, TN</title>
        </path>
        <path
          id="FIPS_47171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M434.1,187.7l1.4,1.1l-1.8,1.4l-0.7,1.3l-1.1-0.6l0-0.7l0.6-0.8l0.4-0.1l0.2,0l0.4-0.3
		l0.3-0.5L434.1,187.7z	"
        >
          <title id="t2515">Unicoi, TN</title>
        </path>
        <path
          id="FIPS_47073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.7,183.7l-0.4,2.2l-0.2,0.3l-1.1,0.7l-0.5,0.1l-0.2,0.1l-0.5,0.3l-0.2,0.3l-0.2,0.3
		l-0.2,0.3l-0.4,0.4l-0.1,0.1l-0.1,0l-1.9-0.4l-0.4-1.3l1.1-1.3l0.5-0.6l0.5-0.4l0.4-0.3l0,0l0.3,0.2l0.3,0l1.1-0.8L430.7,183.7z	"
        >
          <title id="t2516">Hawkins, TN</title>
        </path>
        <path
          id="FIPS_47059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.1,186.2l0.7-0.2l0,0.1l0.2,2.7l0.1,0.7l0.6,0.6l0,0.7l-0.2-0.2v0l-0.2-0.1l0,0l-0.3,0.2
		l-0.2,0.1l-0.6,0.6l-0.9,0.9l-0.5,0.1l-0.7-0.6l-1.1-0.9l-0.9-0.5l-0.4-0.3l-0.1-0.1l0-0.3l0.7-0.9l0.1,0l0.1-0.1l0.4-0.4l0.2-0.3
		l0.2-0.3l0.2-0.3l0.5-0.3l0.2-0.1l0.5-0.1L430.1,186.2z	"
        >
          <title id="t2517">Greene, TN</title>
        </path>
        <path
          id="FIPS_47179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.3,185.9l0.6-0.1l1.3-0.2l0.6-0.2l0.4,0.1l0.5,0.4l0.2,0l0.5-0.1l-0.1,1.9l-0.3,0.7
		l-0.3,0.5l-0.4,0.3l-0.2,0l-0.4,0.1l-0.6,0.8l-0.6-0.6l-0.1-0.7l-0.2-2.7l0-0.1l-0.7,0.2L430.3,185.9z	"
        >
          <title id="t2518">Washington, TN</title>
        </path>
        <path
          id="FIPS_47019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.2,183.9l0.4,0.4v0l-0.8,1.3l0.2,0.3l0.7,0.7l0.3,0.3l0.2-0.1l-1.2,2.3l-1.5-0.4l-1.4-1.1
		l0.1-1.9L437.2,183.9z	"
        >
          <title id="t2519">Carter, TN</title>
        </path>
        <path
          id="FIPS_48037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.7,231.6l0.1,0.2l0.1,0.2l0.1,0.1l0.4,0.3l0.2,0.1l0.6,0.3l1-0.5l0.1,0l0.2,0l0.6-0.1
		l1,0.2l0.2,0.1l0.3,0.2l0.1,3.6l-0.1-0.2l-0.2-0.1l-1-0.2l-0.3,0.1l-0.3,0.1l-0.2,0.3l0,0.3l0,0.1l0,0l-4,0l-0.4-0.1l-0.1-0.1
		l0-0.1l-1-0.8l-0.1-4.8L309.7,231.6z	"
        >
          <title id="t2520">Bowie, TX</title>
        </path>
        <path
          id="FIPS_48387"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.5,227.8l1.2,1.1l1.8,1.5l1.3,0.5l0.1,4.8l-0.7-0.4l-3.4-0.3l-1.9,0.2l0,0l-0.1-6.4l0.2,0
		l0.1,0l0.3-0.2l0.1-0.1l0.1-0.1l0-0.1l0-0.1v0l0-0.1l0,0l0,0v0l0,0l0.2-0.3h0l0,0l0,0l0.1,0L302.5,227.8z	"
        >
          <title id="t2521">Red River, TX</title>
        </path>
        <path
          id="FIPS_48107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234.2,227.5l5.6,0.3l-0.3,5.6l-5.5-0.3L234.2,227.5z	"
        >
          <title id="t2522">Crosby, TX</title>
        </path>
        <path
          id="FIPS_48303"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M228.7,227.3l5.6,0.3l-0.3,5.6l-5.6-0.3L228.7,227.3z	"
        >
          <title id="t2523">Lubbock, TX</title>
        </path>
        <path
          id="FIPS_48219"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223,226.9l5.6,0.4l-0.3,5.6l-5.5-0.4L223,226.9z	"
        >
          <title id="t2524">Hockley, TX</title>
        </path>
        <path
          id="FIPS_48079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M218.4,226.6l4.6,0.3l-0.2,5.7l-4.9-0.4l0.2-2.4L218.4,226.6z	"
        >
          <title id="t2525">Cochran, TX</title>
        </path>
        <path
          id="FIPS_48153"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.6,221.3l4.5,0.2l-0.3,6.2l-5.6-0.3l0.4-6.2L235.6,221.3z	"
        >
          <title id="t2526">Floyd, TX</title>
        </path>
        <path
          id="FIPS_48189"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229,220.9l1,0.1l4.6,0.3l-0.4,6.2l-5.6-0.3L229,220.9z	"
        >
          <title id="t2527">Hale, TX</title>
        </path>
        <path
          id="FIPS_48279"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223.5,220.6l0.9,0.1l4.6,0.3l-0.4,6.3l-5.6-0.4L223.5,220.6z	"
        >
          <title id="t2528">Lamb, TX</title>
        </path>
        <path
          id="FIPS_48017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223.5,220.6l-0.4,6.3l-4.6-0.3l0.5-6.2l0-0.1L223.5,220.6z	"
        >
          <title id="t2529">Bailey, TX</title>
        </path>
        <path
          id="FIPS_48045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.9,215.7l4,0.2l1.5,0.1l-0.3,5.6l-1,0l-4.5-0.2L235.9,215.7z	"
        >
          <title id="t2530">Briscoe, TX</title>
        </path>
        <path
          id="FIPS_48437"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.4,215.4l3.9,0.2l1.7,0.1l-0.3,5.6l-1-0.1L230,221L230.4,215.4z	"
        >
          <title id="t2531">Swisher, TX</title>
        </path>
        <path
          id="FIPS_48069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M228.6,215.3l1.8,0.1L230,221l-1-0.1l-4.6-0.3l0.4-5.6L228.6,215.3z	"
        >
          <title id="t2532">Castro, TX</title>
        </path>
        <path
          id="FIPS_48369"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.4,214.6l5.4,0.4l-0.4,5.6l-0.9-0.1l-4.5-0.3L219.4,214.6z	"
        >
          <title id="t2533">Parmer, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "11100"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[11100]} state-tx`
          }
          id="FIPS_11100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48011"
            className="FIPS_11100 st0 state-tx"
            d="M234.6,210l5.6,0.3l-0.3,5.6l-4-0.2l-1.7-0.1L234.6,210z	"
          >
            <title id="t2534">Armstrong, TX</title>
          </path>
          <path
            id="FIPS_48065"
            className="FIPS_11100 st0 state-tx"
            d="M235,204.3L235,204.3l5.6,0.2l0,0.1l-0.3,5.7l-5.6-0.3L235,204.3z	"
          >
            <title id="t2537">Carson, TX</title>
          </path>
          <path
            id="FIPS_48375"
            className="FIPS_11100 st0 state-tx"
            d="M229.4,204l5.6,0.3l-0.3,5.7l-5.7-0.4L229.4,204z	"
          >
            <title id="t2538">Potter, TX</title>
          </path>
          <path
            id="FIPS_48381"
            className="FIPS_11100 st0 state-tx"
            d="M228.9,209.6l5.7,0.4l-0.4,5.6l-3.9-0.2l-1.8-0.1L228.9,209.6z	"
          >
            <title id="t2535">Randall, TX</title>
          </path>
        </g>

        <path
          id="FIPS_48117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.4,214.6l0.2-2.7l0.2-3l2.1,0.1l2.2,0.1l4.8,0.4l-0.4,5.6l-3.7-0.2L219.4,214.6z	"
        >
          <title id="t2536">Deaf Smith, TX</title>
        </path>

        <path
          id="FIPS_48359"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.4,203.9L229.4,203.9l-0.4,5.8l-4.8-0.4l-2.2-0.1l-2.1-0.1l0.4-5.7L229.4,203.9z	"
        >
          <title id="t2539">Oldham, TX</title>
        </path>
        <path
          id="FIPS_48233"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.3,198.7l5.6,0.3l-0.3,5.6l-5.6-0.3L235.3,198.7z	"
        >
          <title id="t2540">Hutchinson, TX</title>
        </path>
        <path
          id="FIPS_48341"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.7,198.3l5.6,0.3l-0.3,5.6v0l-5.6-0.3l0-0.1L229.7,198.3z	"
        >
          <title id="t2541">Moore, TX</title>
        </path>
        <path
          id="FIPS_48205"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M220.6,197.7l9.1,0.6l-0.4,5.5l-9.1-0.6l0.1-1.5L220.6,197.7z	"
        >
          <title id="t2542">Hartley, TX</title>
        </path>
        <path
          id="FIPS_48195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.2,193.2l-0.3,5.7v0l-5.6-0.3l0.3-5.8L241.2,193.2z	"
        >
          <title id="t2543">Hansford, TX</title>
        </path>
        <path
          id="FIPS_48421"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M231.4,192.6l4.2,0.3l-0.3,5.8l-5.6-0.3l0.4-5.8L231.4,192.6z	"
        >
          <title id="t2544">Sherman, TX</title>
        </path>
        <path
          id="FIPS_48111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.1,192.6l-0.4,5.8l-9.1-0.6l0.2-3.4l0.2-2.1l0.4-0.3L230.1,192.6z	"
        >
          <title id="t2545">Dallam, TX</title>
        </path>
        <path
          id="FIPS_48229"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M196.4,248.4l-0.2,1.8l-0.3,3.5l-0.7,8.5l-0.1,0.8l-0.1,0.4l-0.2,2.2l-0.7,0.4l-0.1,0.1
		l-0.6-0.8l-0.9-0.9l-0.8-0.7l-0.4,0l-0.2-0.1l-1.4-0.9l-1.6-1.9l-1.9-2.5l-1.5-1.9l-0.9-1.2l0.5-0.4l0-0.7l-0.3-0.5l0.6-6.3
		L196.4,248.4z	"
        >
          <title id="t2546">Hudspeth, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "21340"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[21340]} state-tx`
          }
          id="FIPS_21340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48141"
            className="FIPS_21340 st0 state-tx"
            d="M184.6,247.2l-0.6,6.3l0.3,0.5l0,0.7l-0.5,0.4l-1.1-0.5l-0.4-0.2l-0.6-0.5l-0.1-0.1l0,0l0,0
		l0,0l-0.1-0.1l-0.3-0.9l-0.9-2.1l-0.2-0.4l-0.4-0.3l-1.2-0.5l-0.8-0.9l-0.1-0.1l0-0.1l0.3-1.1l0-0.1l0.2-0.6v0h0l0,0l2.4,0.3
		L184.6,247.2z	"
          >
            <title id="t2547">El Paso, TX</title>
          </path>
        </g>
        <path
          id="FIPS_48305"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M234,233.2l-0.3,5.6l-1.4-0.1l-4.1-0.2l0.4-5.6L234,233.2z	"
        >
          <title id="t2548">Lynn, TX</title>
        </path>
        <path
          id="FIPS_48445"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,232.5l5.5,0.4l-0.4,5.6l-1.4-0.1l-4.2-0.3L222.9,232.5z	"
        >
          <title id="t2549">Terry, TX</title>
        </path>
        <path
          id="FIPS_48501"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M222.9,232.5l-0.4,5.5l-5-0.4l0.5-5.5L222.9,232.5z	"
        >
          <title id="t2550">Yoakum, TX</title>
        </path>
        <path
          id="FIPS_48115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M228.1,238.4l4.1,0.2l-0.3,5.6l-5.6-0.3l0.3-5.6L228.1,238.4z	"
        >
          <title id="t2551">Dawson, TX</title>
        </path>
        <path
          id="FIPS_48165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M217.4,237.7l5,0.4l4.2,0.3l-0.3,5.6l-0.1,0l-9.2-0.6L217.4,237.7z	"
        >
          <title id="t2552">Gaines, TX</title>
        </path>
        <path
          id="FIPS_48317"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M226.2,244L226.2,244l5.7,0.3l-0.4,5.6l-0.9,0l-4.7-0.3L226.2,244z	"
        >
          <title id="t2553">Martin, TX</title>
        </path>
        <path
          id="FIPS_48003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M217,243.4l9.2,0.6l-0.4,5.6l-0.8-0.1l-5.6-0.4l-2.9-0.2L217,243.4z	"
        >
          <title id="t2554">Andrews, TX</title>
        </path>
        <path
          id="FIPS_48329"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M225,249.6l0.8,0.1l4.7,0.3l-0.3,5.6l-5.6-0.4L225,249.6z	"
        >
          <title id="t2555">Midland, TX</title>
        </path>
        <path
          id="FIPS_48135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M225,249.6l-0.4,5.6l-0.3,0l-4.9-0.3l-0.3,0l0.4-5.6L225,249.6z	"
        >
          <title id="t2556">Ector, TX</title>
        </path>
        <path
          id="FIPS_48103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.4,254.8l4.9,0.3l-0.3,7.3l-1-0.1l-0.3-1.4l-0.1-0.2l0-0.1l-0.1-0.1l-0.5-0.5l-0.1-0.1
		l-1.4-0.8l-0.1,0l-1.2,0.2L219.4,254.8z	"
        >
          <title id="t2557">Crane, TX</title>
        </path>
        <path
          id="FIPS_48377"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.8,269.9l-0.1,1.4l-0.3,3.9l-0.5,6.5l-0.2,3l-1.9-0.6l-0.6-0.2l-0.1,0l0,0l-0.4-0.3
		l-0.8-0.6l-3.9-3.7l-0.2-0.5l-1.2-3.1l0-0.1l0-1.3l0.2-0.9l0.1-1.1l-0.2-0.7l-2-4.9l-0.6-0.4l0.1-0.1l11.7,3.8L206.8,269.9z	"
        >
          <title id="t2558">Presidio, TX</title>
        </path>
        <path
          id="FIPS_48109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M197.1,248.4l8.9,0.8l-1.8,11.4l-9.5,4.9l0.2-2.2l0.1-0.4l0.1-0.8l0.7-8.5l0.3-3.5l0.2-1.8
		L197.1,248.4z	"
        >
          <title id="t2559">Culberson, TX</title>
        </path>
        <path
          id="FIPS_48475"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.1,254.8l0.3,0l-0.3,4.6l-0.8,0.1l-0.5-0.5l-0.3-0.3l-0.3-0.2l-0.7-0.3l-0.6,0l-0.4,0
		l-0.3,0l-0.6-0.1l-3-1l-0.1-0.1l-0.1-0.2l-0.1-0.6l0-0.8l0.1-0.4l-0.1-0.3l-0.2-0.3l-0.9-0.2l3.1,0.2L219.1,254.8z	"
        >
          <title id="t2560">Ward, TX</title>
        </path>
        <path
          id="FIPS_48495"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M216.6,249l2.9,0.2l-0.4,5.6l-5.8-0.4l0.4-4.5l0.6,0.1l0.6,0l0.8,0.1l0.6,0l0.3,0L216.6,249z	
		"
        >
          <title id="t2561">Winkler, TX</title>
        </path>
        <path
          id="FIPS_48301"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.6,249.3l2.8,0.2l4.3,0.3l-0.4,4.5l-3.1-0.2l-0.2-0.5l-0.5-0.8l-0.1,0l-0.2,0l0,0l0,0
		l-0.1,0l-0.2-0.1l-0.1-0.1l-1.5-2.1L206.6,249.3z	"
        >
          <title id="t2562">Loving, TX</title>
        </path>
        <path
          id="FIPS_48389"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M206.1,249.3l0.5,0l0.6,1.3l1.5,2.1l0.1,0.1l0.2,0.1l0.1,0l0,0l0,0l0.2,0l0.1,0l0.5,0.8
		l0.2,0.5l0.9,0.2l0.2,0.3l0.1,0.3l-0.1,0.4l0,0.8l0.1,0.6l0.1,0.2l0.1,0.1l3,1l0.6,0.1l0.3,0l0.4,0l0.6,0l-6.9,7.3l-5.3-4.8
		L206.1,249.3z	"
        >
          <title id="t2563">Reeves, TX</title>
        </path>
        <path
          id="FIPS_48243"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M209.6,265.5l1.5,1.4l-4.3,2.9l-1.1-0.1l-11.7-3.8l0.7-0.4l9.5-4.9L209.6,265.5z	"
        >
          <title id="t2564">Jeff Davis, TX</title>
        </path>
        <path
          id="FIPS_48043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M211.1,266.9l9.1,8.6l2.7,2.5l-0.6,0.4l-1.4,0.6l-2,0.5l-0.3,0.2l0,0l-1.5,2.5l-0.9,2.1
		l-3,4.5l-0.5,0.1h-0.1l-1.3-0.3l-1.1-0.5l-3.6-2.3l-0.1-0.1l-0.5-0.5l-0.2-0.5l0.2-3l0.5-6.5l0.3-3.9l0.1-1.4L211.1,266.9z	"
        >
          <title id="t2565">Brewster, TX</title>
        </path>
        <path
          id="FIPS_48443"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.4,273.1l-0.4,6.6l-0.2-0.1l-0.1,0l-1.1-0.2l-0.7-0.1l-1.1,0.1l-0.1,0.1l-0.7-0.1
		l-2.2-1.2l-2.7-2.5l0.2-3l2.5,0.2l0.3-4l1.5-0.1l0.8-0.4l4.1,0.3l0.2,0l0.6,0.1l0.4,0.4l0.1,0.8l0,0.1l-1.2,2.8L229.4,273.1z	"
        >
          <title id="t2566">Terrell, TX</title>
        </path>
        <path
          id="FIPS_48371"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M219.1,259.4l1.2-0.2l0.1,0l1.4,0.8l0.1,0.1l0.5,0.5l0.1,0.1l0,0.1l0.1,0.2l0.3,1.4l1.5,0.7
		l2.2,0.7l0.7,0.2l1.1,0.9l0.9,3.2l0.1,0.3l-4.1-0.3l-0.8,0.4l-1.5,0.1l-0.3,4l-2.5-0.2l-0.2,3l-9.1-8.6l-1.5-1.4l6.9-7.3l0.7,0.3
		l0.3,0.2l0.3,0.3l0.5,0.5L219.1,259.4z	"
        >
          <title id="t2567">Pecos, TX</title>
        </path>
        <path
          id="FIPS_48461"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M224.3,255.2l0.3,0l5.6,0.4l-0.5,7.4l-5.8-0.5L224.3,255.2z	"
        >
          <title id="t2568">Upton, TX</title>
        </path>
        <path
          id="FIPS_48383"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M230.3,255.5l5.6,0.3l-0.1,1.2l0,0.4l-0.4,5.8l-5.5-0.3L230.3,255.5z	"
        >
          <title id="t2569">Reagan, TX</title>
        </path>
        <path
          id="FIPS_48173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M231.5,250l4.7,0.3l-0.3,5.6l-5.6-0.3l0.3-5.6L231.5,250z	"
        >
          <title id="t2570">Glasscock, TX</title>
        </path>
        <path
          id="FIPS_48227"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.4,244.6l-0.4,5.6l-0.9,0l-4.7-0.3l0.4-5.6L237.4,244.6z	"
        >
          <title id="t2571">Howard, TX</title>
        </path>
        <path
          id="FIPS_48033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M233.6,238.8l4.1,0.2l-0.3,5.6l0,0l-5.6-0.3l0.3-5.6L233.6,238.8z	"
        >
          <title id="t2572">Borden, TX</title>
        </path>
        <path
          id="FIPS_48169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.5,233.4l-0.3,5.5l-1.5,0l-4.1-0.2l0.3-5.6L239.5,233.4z	"
        >
          <title id="t2573">Garza, TX</title>
        </path>
        <path
          id="FIPS_48415"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.2,239l4.1,0.3l-0.3,5.7l-5.6-0.3l0.3-5.6L239.2,239z	"
        >
          <title id="t2574">Scurry, TX</title>
        </path>
        <path
          id="FIPS_48335"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M237.4,244.6l5.6,0.3l-0.3,5.7l-1.7-0.1l-3.9-0.2L237.4,244.6L237.4,244.6z	"
        >
          <title id="t2575">Mitchell, TX</title>
        </path>
        <path
          id="FIPS_48431"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M236.2,250.2l0.9,0l3.9,0.2l-0.3,5l-0.4-0.1l-0.1,1.8l-4.4-0.2l0.1-1.2L236.2,250.2z	"
        >
          <title id="t2576">Sterling, TX</title>
        </path>
        <path
          id="FIPS_48235"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M235.7,257.4l3,0.2l3.3,0.2l-0.2,5.6l-3-0.1l-3.4-0.1L235.7,257.4z	"
        >
          <title id="t2577">Irion, TX</title>
        </path>
        <path
          id="FIPS_48105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M223.1,262.4l1,0.1l5.8,0.5l5.5,0.3l3.4,0.1l-0.2,4.9l-0.3,5.4l-8.9-0.5l0.3-0.5l1.2-2.8
		l0-0.1l-0.1-0.8l-0.4-0.4l-0.6-0.1l-0.2,0l-0.1-0.3l-0.9-3.2l-1.1-0.9l-0.7-0.2l-2.2-0.7L223.1,262.4z	"
        >
          <title id="t2578">Crockett, TX</title>
        </path>
        <path
          id="FIPS_48465"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M229.4,273.1l8.9,0.5l2.9,0.1l-0.4,8.5l-0.1,2.4l-0.1,1l-0.1,0.3L240,287l-0.1,0.2l0,0
		l-0.3-0.1l-2.6-2.4l-2.2-2.7l0-0.1l-1.6-1.8l-0.6-0.2l-0.1,0l-1.6-0.1l-0.3,0l-1.5-0.2L229.4,273.1z	"
        >
          <title id="t2579">Val Verde, TX</title>
        </path>
        <path
          id="FIPS_48505"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M253.6,313.1l1-0.7l0.4,0.6l4.4,0.2l-0.2,6.2l-2.6,2.7l-0.2-0.7l-0.2-0.8v0l-0.3-1.3l-0.3-0.7
		l-0.6-0.8l-0.6-0.4l-0.7-1.2l0-0.5l0,0l0.1,0l0.2-0.3l0.1-1l-0.1-0.9L253.6,313.1L253.6,313.1L253.6,313.1z	"
        >
          <title id="t2580">Zapata, TX</title>
        </path>
        <path
          id="FIPS_48247"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.2,312.2l2.8,0l0.3,0.2l0,1l0.3,0.4l0.8,2.3l-0.1,3.5l-6.2-0.2l0.2-6.2L261.2,312.2z	"
        >
          <title id="t2581">Jim Hogg, TX</title>
        </path>
        <path
          id="FIPS_48427"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.2,319.4l6.2,0.2l1.2,0l-0.9,2l-1.1,2.1l-1.2,2.5l-0.5,0.1l-0.8-0.4l-3.9-1.8l-0.7-0.4
		l-0.7-1.5l0-0.1l0-0.1L259.2,319.4z	"
        >
          <title id="t2582">Starr, TX</title>
        </path>
        <path
          id="FIPS_48489"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.1,322.2l0.4,0l0.7,2.4H279L278.1,322.2z M270.7,321.9l6,0.2l0.7,2.4l-0.5,0.6l-1.3,0.8
		l-3.9-0.7l0-0.9l-0.5-0.2l-1.1-0.2l0.1-0.5l0.2-0.6L270.7,321.9z	"
        >
          <title id="t2583">Willacy, TX</title>
        </path>
        <path
          id="FIPS_48215"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.5,319.7l3.9,0.1l0.3,2.2l-0.3,1l-0.2,0.6l-0.1,0.5l1.1,0.2l0.5,0.2l0,0.9l-0.1,3.7
		l-0.1,0l-0.2,0l-1,0l-0.4,0l0,0.1l-0.4,0.2l-1.4-0.3l-0.9-0.2l-0.3-0.1l-0.2-0.1l-1.2-0.8l-0.6-0.7l-0.3-0.1l0,0l-1.4-0.5h0
		l1.2-2.5l1.1-2.1L266.5,319.7z	"
        >
          <title id="t2584">Hidalgo, TX</title>
        </path>
        <path
          id="FIPS_48047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M264.4,313.5l3.4,0.1l2,0.1l0.8,0.7l-0.1,5.5l-3.9-0.1l-1.2,0l0.1-3.5l-0.8-2.3L264.4,313.5z	
		"
        >
          <title id="t2585">Brooks, TX</title>
        </path>
        <path
          id="FIPS_48261"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277.6,313.6l0.3,0l0,0.1l-0.2,0.7l-0.1,0.6l-0.1,0.8l0,0.7v0.7l0.1,1.1l0.1,0.4l0,0l0.1,0.8
		l0.2,0.9l0.4,1.3l0,0l0,0l0.1,0.4l-0.4,0l-0.8-2.8v-1.6l0-1.4l0-0.5l0-0.8l0-0.6l0.1-0.3L277.6,313.6z M270.5,314.3l4-0.8l0,0.1
		l0,0.2l0,0.1l0.1,0.1l1,0.2l0.3,0l0.1,0l0.1-0.1l0-0.1l0.2-0.1l0.4-0.1l0.3,0l0,0.1l-0.3,1.8l-0.5,1.5l-0.3,2.5l0.4,0.6l0.3,1.6
		l0,0.4l-6-0.2l-0.3-2.2L270.5,314.3z	"
        >
          <title id="t2586">Kenedy, TX</title>
        </path>
        <path
          id="FIPS_48273"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277.6,313.6l1.5-3.9l0.3,0.1l-1.5,3.8L277.6,313.6z M271.2,308.9l0.8,0.5l0.4,0.5l0.1,0
		l5.8,0.1l-0.6,2l-0.3,0.8l0,0.1l-0.1,0.1l-0.1,0l-1,0.5l-1.5-0.1l-4,0.8l-0.8-0.7l0.1-4.8L271.2,308.9z	"
        >
          <title id="t2587">Kleberg, TX</title>
        </path>
        <path
          id="FIPS_48249"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.9,303.4l4,0.1l1,0.8l-1.6,1.4l0,1.4l-0.1,1.8l-1.4,0l-0.1,4.8l-2-0.1L267.9,303.4z	"
        >
          <title id="t2588">Jim Wells, TX</title>
        </path>

        <path
          id="FIPS_48057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284,303l0.2-0.6l2.6-1.8l0.1-0.1l0.6-0.3l0.9-0.2l0.1,0.2l-1.1,0.5l-0.2,0.1l0,0l-0.8,0.5
		l-0.8,0.6l-0.7,0.6l-1.1,0.9l0,0l0,0L284,303z M286.9,295.3l2.9,0.5l0,0.4l-0.7,0.3L288,297l-0.9-0.8l-0.1-0.3L286.9,295.3z
		 M283.4,297.9l-0.2-0.3l-0.3-0.7l0.9-0.6l1.7-0.6l0.6-0.3l-0.2,0.1l0.6,1.4l0,0l0.5,0.1l0.3,0.2l1.3,1.2l0.1,0.1l0.1,0.1l0,0.1
		l-2.1,1.1l-0.1,0l-0.8,0.2l-0.3-0.1l-0.1-0.1l-0.7-0.8L283.4,297.9z	"
        >
          <title id="t2591">Calhoun, TX</title>
        </path>
        <path
          id="FIPS_48391"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.3,297.2l3.1,0.6l1.4,1.3l-0.3,1.2l-3.8,0.6l0,0.3l0.3,0.3l0.4,0.3l0.2,0l0.2,0l-0.1,0.2
		l-1.4,1.1l-1,0.5l0,0l-0.2-0.2l-3.2-1.2l1.9-2.8L280.3,297.2z	"
        >
          <title id="t2592">Refugio, TX</title>
        </path>
        <path
          id="FIPS_48025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M273.3,295.7l0.9,1.6l1.6,1l2,1l-1.9,2.8l-3.2-0.2l0.1-0.1l-3.1-6.2l1-0.3l1-0.4l0.1,0.1
		l0.1,0.2l0.4,0.2l0.4,0.1L273.3,295.7z	"
        >
          <title id="t2593">Bee, TX</title>
        </path>
        <path
          id="FIPS_48297"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269.7,294.1l1,1.3l-1,0.3l3.1,6.2l-0.1,0.1l-0.8,1.5l-4-0.1l-1.1,0l0.2-7.1L269.7,294.1z	"
        >
          <title id="t2594">Live Oak, TX</title>
        </path>
        <path
          id="FIPS_48311"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.7,295.8l5.3,0.1l-0.2,7.5l-5.4-0.1L261.7,295.8z	"
        >
          <title id="t2595">McMullen, TX</title>
        </path>
        <path
          id="FIPS_48131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.4,303.2l5.4,0.1l1.1,0l-0.2,10.2l-3.4-0.1l0-1l-0.3-0.2l-2.8,0L261.4,303.2z	"
        >
          <title id="t2596">Duval, TX</title>
        </path>
        <path
          id="FIPS_48479"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.4,300.8l1.1,0l8.2,0.2l0,2.2l6.7-0.1l-0.2,9l-1.8,1l-4.4-0.2l-0.4-0.6l-1,0.7l-0.2,0
		l-0.2-0.2l0,0l-0.4-0.4l0-0.1l0,0l0,0l0,0l0.1-0.1l0.3-0.4l0.2-0.4l0.1-0.2l0.1-1l-0.4-1.1l-0.2-0.4l-0.2-0.1l-0.5-0.4l-0.3,0l0,0
		l0,0.1l-0.4,0l-2-1.8L249,306l-1.2-2.5l-1-2l-0.1,0L245.4,300.8z	"
        >
          <title id="t2597">Webb, TX</title>
        </path>
        <path
          id="FIPS_48283"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.7,295.7l0,0.1l-0.2,7.4l-6.7,0.1l0-2.2l0.2-5.6L261.7,295.7z	"
        >
          <title id="t2598">La Salle, TX</title>
        </path>
        <path
          id="FIPS_48127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.8,295.1l8,0.4l0.1,0l-0.2,5.6l-8.2-0.2L246.8,295.1z	"
        >
          <title id="t2599">Dimmit, TX</title>
        </path>
        <path
          id="FIPS_48323"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247,289.5l-0.3,5.6l-0.2,5.8l-1.1,0l0,0l-0.5-0.5l-0.4-0.5l-0.6-1.7l-1.6-4.4l-1.4-3.2
		l-0.2-1.3L247,289.5z	"
        >
          <title id="t2600">Maverick, TX</title>
        </path>
        <path
          id="FIPS_48271"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.7,282.3l6.6,0.3l-0.3,6.9l-6.3-0.3l-1.3-2.1l0.3,0.1l0,0l0.1-0.2l0.4-1.1l0.1-0.3l0.1-1
		L240.7,282.3z	"
        >
          <title id="t2601">Kinney, TX</title>
        </path>
        <path
          id="FIPS_48137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.6,274l4,0.2l-0.1,2.8l-1,0l-1.4-0.2l-0.7,2.4l-0.1,1.9l0,1.6l-1.1,0l-6.6-0.3l0.4-8.5
		L247.6,274z	"
        >
          <title id="t2602">Edwards, TX</title>
        </path>
        <path
          id="FIPS_48385"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M251.5,277l0.8,0l-0.1,1.7l0.2,0.5l0.7,0l-0.1,3.6l-4.6-0.1l0-1.6l0.1-1.9l0.7-2.4l1.4,0.2
		L251.5,277z	"
        >
          <title id="t2603">Real, TX</title>
        </path>
        <path
          id="FIPS_48463"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.3,282.6l1.1,0l4.6,0.1l2.1,0.1l-0.3,6.9l-7.9-0.2L247.3,282.6z	"
        >
          <title id="t2604">Uvalde, TX</title>
        </path>
        <path
          id="FIPS_48507"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.9,289.7l-0.1,5.8l-8-0.4l0.3-5.6L254.9,289.7z	"
        >
          <title id="t2605">Zavala, TX</title>
        </path>
        <path
          id="FIPS_48163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.8,290l-0.1,5.7l-6.8-0.1l-0.1,0l0.1-5.8L261.8,290z	"
        >
          <title id="t2606">Frio, TX</title>
        </path>
        <path
          id="FIPS_48175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.7,293.2l0.8,0l0.3,0.2l0.2,0.3l0.2,0.6l0,3l-2.5,2.1l-2-1l-1.6-1l-0.9-1.6l2.3-1.8
		l1.8-1.4h0.1l0.3,0.1l0.5,0.3l0.2,0.1L278.7,293.2z	"
        >
          <title id="t2607">Goliad, TX</title>
        </path>
        <path
          id="FIPS_48469"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M282.5,290.2l0.4,0.5l1.1,0.5l0.1,0.1l0.8,1.6l1.3,2.4l-0.1,0l-0.6,0.3l-1.7,0.6l-0.9,0.6
		l0.3,0.7l0.2,0.3l-3.1-0.6l0-3l-0.2-0.6l-0.2-0.3l-0.3-0.2l-0.8,0L282.5,290.2z	"
        >
          <title id="t2608">Victoria, TX</title>
        </path>
        <path
          id="FIPS_48123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M279.5,286.6l2.9,3.6l-3.8,3l-0.2-0.3l-0.2-0.1l-0.5-0.3l-0.3-0.1h-0.1l-1.8,1.4l-2-2.5
		l1.6-1.3L279.5,286.6z	"
        >
          <title id="t2609">DeWitt, TX</title>
        </path>
        <path
          id="FIPS_48255"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M274,288.6l1.3,1.5l-1.6,1.3l2,2.5l-2.3,1.8l-0.5-0.1l-0.4-0.1l-0.4-0.2l-0.1-0.2l-0.1-0.1
		l-1,0.4l-1-1.3l-1-1.2L274,288.6z	"
        >
          <title id="t2610">Karnes, TX</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41700"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[41700]} state-tx`
          }
          id="FIPS_41700"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48013"
            className="FIPS_41700 st0 state-tx"
            d="M261.9,287.9l4.4,1.9l2.4,3l1,1.2l-2.7,2.2l0-0.4l-5.3-0.1l0-0.1l0.1-5.7L261.9,287.9z	"
          >
            <title id="t2612">Atascosa, TX</title>
          </path>
          <path
            id="FIPS_48019"
            className="FIPS_41700 st0 state-tx"
            d="M253.2,279.2l3.5,0.2l1.3,0.2l0.6,0.3l2.3,1.2l1.5,0.8l-0.3,0.4l-1.4,1.6l-0.5,0.1l0,0l0,0
		l-0.1-0.2l0-0.3l0.1-0.1l0-0.1l0-0.1l-0.1-0.1l-4.8-0.2l-2.1-0.1L253.2,279.2z	"
          >
            <title id="t2614">Bandera, TX</title>
          </path>
          <path
            id="FIPS_48029"
            className="FIPS_41700 st0 state-tx"
            d="M263.8,281.6l1-0.1l0.1,0l1.4,0.2l0.7,0.6l0.5,1.4l0.1,0.4l0.3,0.2l0.5,0.2l1.1,0.7l0,0.4
		l-0.1,0.1l-3.2,4.1l-4.4-1.9l0.1-5.7l0.3-0.4L263.8,281.6z	"
          >
            <title id="t2619">Bexar, TX</title>
          </path>
          <path
            id="FIPS_48259"
            className="FIPS_41700 st0 state-tx"
            d="M260.9,276.5l3.7,0.1l1.9,2.6l-2.7,2.4l-1.5,0.3l-1.5-0.8L260.9,276.5z	"
          >
            <title id="t2618">Kendall, TX</title>
          </path>

          <path
            id="FIPS_48187"
            className="FIPS_41700 st0 state-tx"
            d="M272.5,280.4l2.7,2.7l-2.4,3.5l-2.8-0.1l-0.3,0.2l-0.1-0.2l0-0.2l-0.1-0.7l0.1-0.1l0-0.4
		l-1.1-0.7l-0.5-0.2l-0.3-0.2l-0.1-0.4l3.5-2L272.5,280.4z	"
          >
            <title id="t2620">Guadalupe, TX</title>
          </path>
          <path
            id="FIPS_48091"
            className="FIPS_41700 st0 state-tx"
            d="M267.8,278l2.9,2.5l0.3,1.2l-3.5,2l-0.5-1.4l-0.7-0.6l-1.4-0.2l-0.1,0l-1,0.1l2.7-2.4
		L267.8,278z	"
          >
            <title id="t2621">Comal, TX</title>
          </path>
          <path
            id="FIPS_48325"
            className="FIPS_41700 st0 state-tx"
            d="M262,282.3l-0.1,5.7l-0.1,2.1l-6.9-0.2l0.3-6.9l4.8,0.2l0.1,0.1l0,0.1l0,0.1l-0.1,0.1l0,0.3
		l0.1,0.2l0,0l0,0l0.5-0.1L262,282.3z	"
          >
            <title id="t2613">Medina, TX</title>
          </path>
          <path
            id="FIPS_48493"
            className="FIPS_41700 st0 state-tx"
            d="M272.8,286.6l1.2,2l-5.3,4.2l-2.4-3l3.2-4.1l0.1,0.7l0,0.2l0.1,0.2l0.3-0.2L272.8,286.6z	"
          >
            <title id="t2611">Wilson, TX</title>
          </path>
        </g>

        <path
          id="FIPS_48265"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.7,274.4l-0.1,2l4.2,0.1l-0.1,4.6l-2.3-1.2l-0.6-0.3l-1.3-0.2l-3.5-0.2l-0.7,0l-0.2-0.5
		l0.1-1.7l-0.8,0l0.1-2.8L256.7,274.4z	"
        >
          <title id="t2615">Kerr, TX</title>
        </path>
        <path
          id="FIPS_48171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.8,271.7l3.8,0.1l4.1,0.1l-0.1,4.6l-3.7-0.1l-4.2-0.1L256.8,271.7z	"
        >
          <title id="t2616">Gillespie, TX</title>
        </path>
        <path
          id="FIPS_48031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.4,272.2l2.5,0.8l-0.5,0.9l-1.5,4.1l-1.3,1.3l-1.9-2.6l0.1-4.6L267.4,272.2z	"
        >
          <title id="t2617">Blanco, TX</title>
        </path>

        <path
          id="FIPS_48177"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M278.7,281.4l1.9,2l-0.7,0.6l0,0.9l-0.4,1.6l-4.3,3.5l-1.3-1.5l-1.2-2l2.4-3.5L278.7,281.4z	"
        >
          <title id="t2624">Gonzales, TX</title>
        </path>
        <path
          id="FIPS_48285"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.6,283.5l3,0l0.1,0l0.2,0.1l0.6,0.6l2.6,3.1l-1.1,0.9l-3.2,2.6l-3.4-4.2l0.4-1.6l0-0.9
		L280.6,283.5z	"
        >
          <title id="t2625">Lavaca, TX</title>
        </path>
        <path
          id="FIPS_48239"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.1,288.2l0.2,0.2l3.7,3.7l-0.2,3.7l-2.9-0.5l-0.7,0l-1.3-2.4l-0.8-1.6l-0.1-0.1l-1.1-0.5
		L286.1,288.2z	"
        >
          <title id="t2626">Jackson, TX</title>
        </path>
        <path
          id="FIPS_48321"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M290,292.1l3.9-2.4l1-1.1l0.3,0.3l0.1,0.1l0.5,1.5l0.3,1.1l0.1,0.3l0,0l2.2,1.8l0,0l0.7,0.1
		l-0.2,0.1l-0.5,0.3l-0.2,0.1l-2.6,1.5l-0.8,0.4l-1.3,0.6l-0.9,0.4l-1.6,0.8l-0.6,0.4l0,0l-0.8,0.5l-0.3,0.3l-0.1,0.1l0-0.1l0.1-0.1
		l1.8-1.4l0.3-2.4l-0.1-0.1l-0.1,0l-0.2,0l-0.5,0.1l-0.2,0.1l-0.2,0.1l-0.2,0.4l0-0.4L290,292.1z	"
        >
          <title id="t2627">Matagorda, TX</title>
        </path>
        <path
          id="FIPS_48481"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.5,283.9l0.9,2.2l0.6,1.2l0.8,0.9l0.4,0l-0.3,0.4l-1,1.1l-3.9,2.4l-3.7-3.7l0.4-0.2
		l2.9-1.8l0.2-0.5l0.5-1.1l1.2-1.3L292.5,283.9z	"
        >
          <title id="t2628">Wharton, TX</title>
        </path>
        <path
          id="FIPS_48089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M287.1,279.2l0.4,0.7l0.5,0.4l0.1,0.1l0.7,0.5l0.1,0.1l0.2,0l2.2,2.1l0.3,0.3l-1.2,1.3
		l-0.5,1.1l-0.2,0.5l-2.9,1.8l-0.4,0.2l-0.2-0.2l1.1-0.9l-2.6-3.1l-0.6-0.6l-0.2-0.1l-0.1,0L287.1,279.2z	"
        >
          <title id="t2629">Colorado, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "12420"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[12420]} state-tx`
          }
          id="FIPS_12420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48021"
            className="FIPS_12420 st0 state-tx"
            d="M278.6,273.5l1.5,0.9l1.3,1l0.6,2.7l-3.3,3.4l-3.7-3.7l0.5-0.5l1.3-1.3l1.4-2.7L278.6,273.5z	
		"
          >
            <title id="t2630">Bastrop, TX</title>
          </path>
          <path
            id="FIPS_48055"
            className="FIPS_12420 st0 state-tx"
            d="M274.4,278.3l0.7-0.6l3.7,3.7l0,0l-3.6,1.7l-2.7-2.7l-0.2,0l-0.1,0l0.1-0.3l1.5-1.2
		L274.4,278.3z	"
          >
            <title id="t2623">Caldwell, TX</title>
          </path>
          <path
            id="FIPS_48209"
            className="FIPS_12420 st0 state-tx"
            d="M269.3,273.9l5.1,4.4l-0.6,0.6l-1.5,1.2l-0.1,0.3l0.1,0l0.2,0l-1.4,1.3l-0.3-1.2l-2.9-2.5
		L269.3,273.9z	"
          >
            <title id="t2622">Hays, TX</title>
          </path>
          <path
            id="FIPS_48453"
            className="FIPS_12420 st0 state-tx"
            d="M269.9,273l0.9-2.5l1,0l0.4,0.3l0.5,0.8l0.2,0.9l0.4,0.3l0.4,0.1l0.3,0l0.8-0.3l1-0.5h0.2
		l0.7,0.2l1.6,0.9l-1.4,2.7l-1.3,1.3l-0.5,0.5l-0.7,0.6l-5.1-4.4L269.9,273z	"
          >
            <title id="t2646">Travis, TX</title>
          </path>
          <path
            id="FIPS_48491"
            className="FIPS_12420 st0 state-tx"
            d="M273.3,266.9l1.9,0.4l0.3,0.1l3.4,1.6l1.7,3.8l-2,0.7l-0.4-0.2l-1.6-0.9l-0.7-0.2h-0.2l-1,0.5
		l-0.8,0.3l-0.3,0l-0.4-0.1l-0.4-0.3l-0.2-0.9l-0.5-0.8l-0.4-0.3l-1,0L273.3,266.9z	"
          >
            <title id="t2655">Williamson, TX</title>
          </path>
        </g>
        <path
          id="FIPS_48149"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.6,276.6l0.3,0.3l0.4-0.1l0.4-0.1l0.2-0.1l0.4,0.3l0.2,0.5l0.1,0.5l0,0.3l0.6,1.1
		l-3.4,4.2l-3,0l-1.9-2l0,0l3.3-3.4L284.6,276.6z	"
        >
          <title id="t2631">Fayette, TX</title>
        </path>
        <path
          id="FIPS_48287"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M280.6,272.8l2.1-1.3l1.3,1.6l1,1.2l1.3,0.6l-1.7,1.7L282,278l-0.6-2.7l-1.3-1l-1.5-0.9
		L280.6,272.8z	"
        >
          <title id="t2632">Lee, TX</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "26420"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[26420]} state-tx`
          }
          id="FIPS_26420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48015"
            className="FIPS_26420 st0 state-tx"
            d="M286.5,278.1l0.4-0.3l3.3-0.4l0.2,0l0.5,0.2l0.5,0.2l0.3,0l0.1-0.1l1.3,4.4l-0.6,1.6l-1-0.4
		l-0.3-0.3l-2.2-2.1l-0.2,0l-0.1-0.1l-0.7-0.5l-0.1-0.1l-0.5-0.4l-0.4-0.7L286.5,278.1z	"
          >
            <title id="t2633">Austin, TX</title>
          </path>
          <path
            id="FIPS_48039"
            className="FIPS_26420 st0 state-tx"
            d="M300,284.1l2.3,0.3l-0.2,1.2l1.3,2.2l0.7,1.2l-0.8,1.5l0.1,0.1l-0.1,0.1l-2.8,2.5l-1.5,0.7
		l-0.7-0.1l0,0l-2.2-1.8l0,0l-0.1-0.3l-0.3-1.1l-0.5-1.5l-0.1-0.1l-0.3-0.3l0.3-0.4l0.6-0.6l0.5-0.2l0.4,0.2l1,0l0.4-0.2l1.5-1.5
		L300,284.1z	"
          >
            <title id="t2637">Brazoria, TX</title>
          </path>
          <path
            id="FIPS_48157"
            className="FIPS_26420 st0 state-tx"
            d="M293.1,282.2l2.3-0.8l4.5,2.7l-0.4,1.8l-1.5,1.5l-0.4,0.2l-1,0l-0.4-0.2l-0.5,0.2l-0.6,0.6
		l-0.4,0l-0.8-0.9l-0.6-1.2l-0.9-2.2L293.1,282.2z	"
          >
            <title id="t2636">Fort Bend, TX</title>
          </path>
          <path
            id="FIPS_48071"
            className="FIPS_26420 st0 state-tx"
            d="M310.9,280l0.9,0l0.1,4l0,0.2l-0.2,0.1l-1.7,0.1l-2.3-0.4l0.3-0.5l0.2-0.9l0-0.1l0-0.3
		l-0.3-0.7l-0.1-0.1l-0.1,0l-0.6,0.3l-0.3,0.1l-1.3,1.1l-0.6-2.7L310.9,280z	"
          >
            <title id="t2641">Chambers, TX</title>
          </path>
          <path
            id="FIPS_48167"
            className="FIPS_26420 st0 state-tx"
            d="M311.8,284.3l-0.3,0.2l-1,0.5l-0.1,0l0,0l-0.9,0.4l-0.1,0.1l-0.4,0.2l-0.1,0l-0.2,0.1
		l-0.1,0.1l0,0l-0.1,0.1l-0.1,0.1l0,0.1l0,0l-0.1,0.1l0,0l-0.1,0.1l0,0.1l-0.1,0.1l0,0.1l-0.3,0.1l-0.2,0l0,0l0-0.2l0.2-0.2l0.9-1
		l0.1-0.1l0.9-0.4l0.6-0.2l0.1,0l0.1,0l-0.1-0.1v-0.2L311.8,284.3z M304.5,284.4l0.5,0.6l1.8,2l0.9,0.3l-0.6,0.5l-0.2,0.1l-1.1,0.7
		l-1.3,0.9l-0.1,0.1l-0.1,0.1l-0.4,0.3l-0.1,0.1l0,0l-0.2,0.2l-0.1,0.1l-0.1,0.1l-0.1-0.1l0.8-1.5l-0.7-1.2l-1.3-2.2l0.2-1.2
		l0.5,0.5l1.1-0.6L304.5,284.4z	"
          >
            <title id="t2638">Galveston, TX</title>
          </path>
          <path
            id="FIPS_48339"
            className="FIPS_26420 st0 state-tx"
            d="M295.4,270.6l2.6,1.6l1.2,0l0.7,0l0.7,0l2.2,2l0.8,2.3l-1.1,1.1l-0.7,0.7l-0.3,0l-0.2,0
		l-0.1-0.3l-0.3-0.3l-0.8-0.4l-1.4-0.7L298,277l-0.8,0.4l-0.7,0.1l-0.2,0l-0.5,0l0-2L295.4,270.6z	"
          >
            <title id="t2639">Montgomery, TX</title>
          </path>
          <path
            id="FIPS_48201"
            className="FIPS_26420 st0 state-tx"
            d="M295.7,277.6l0.5,0l0.2,0l0.7-0.1l0.8-0.4l0.5-0.5l1.4,0.7l0.8,0.4l0.3,0.3l0.1,0.3l0.2,0
		l0.3,0l0.7-0.7l1.1-1.1l1.3,3.6l0.6,2.7l-1,1.6l-0.6,0l-1.1,0.6l-0.5-0.5l-2.3-0.3l-4.5-2.7l-1.4-4.3l-0.2-0.5l0.3,0.2l0.2,0.2
		l0.6,0.3L295.7,277.6z	"
          >
            <title id="t2640">Harris, TX</title>
          </path>
          <path
            id="FIPS_48291"
            className="FIPS_26420 st0 state-tx"
            d="M306.3,272.3l1.3,0l1.6,4.8l1.7,0l0.1,2.9l-6,0.1l-1.3-3.6l-0.8-2.3L306.3,272.3z	"
          >
            <title id="t2643">Liberty, TX</title>
          </path>
          <path
            id="FIPS_48407"
            className="FIPS_26420 st0 state-tx"
            d="M300.9,267.6l1.4,0.4l0.8,0.8l2.8,2.7l0.4,0.7l-3.5,1.9l-2.2-2L300.9,267.6z	"
          >
            <title id="t2657">San Jacinto, TX</title>
          </path>
          <path
            id="FIPS_48473"
            className="FIPS_26420 st0 state-tx"
            d="M292.5,275.9l3.2-0.3l0,2l-0.6-0.1l-0.6-0.3l-0.2-0.2l-0.3-0.2l0.2,0.5l1.4,4.3l-2.3,0.8
		l-1.3-4.4L292.5,275.9z	"
          >
            <title id="t2635">Waller, TX</title>
          </path>
        </g>

        <path
          id="FIPS_48477"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M290.2,273.9l0.1,0.2l0.1,0.1l0.1,0l0.6-0.2l0.2-0.2l0.1-0.1l0.1,0l0.3,0.3l0,0.5l0.7,1.4
		l-0.6,2l-0.1,0.1l-0.3,0l-0.5-0.2l-0.5-0.2l-0.2,0l-3.3,0.4l-0.4,0.3l0-0.3l-0.1-0.5l-0.2-0.5l-0.4-0.3l-0.2,0.1l-0.4,0.1l-0.4,0.1
		l-0.3-0.3l1.7-1.7l1.6-0.4l0.3-0.1l1.7-0.6L290.2,273.9L290.2,273.9z	"
        >
          <title id="t2634">Washington, TX</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "13140"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[13140]} state-tx`
          }
          id="FIPS_13140"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48199"
            className="FIPS_13140 st0 state-tx"
            d="M309.6,271.8l5.3-0.1l-0.3,0.7l-0.1,0.3l-0.1,0.5l0,0.2l0.2,0.5l0,0l0.1,0.1l-0.2,1.3
		l-0.1,0.2l0,1l-0.1-0.1l-0.8-0.3l-0.2,0l-0.7,0.2l0,0l0,0.1l0,0.2l0,0.1l-0.1,0.2l-0.1,0l-1.1,0.2l-0.2,0l-0.3-0.2l-1.7,0l-1.6-4.8
		L309.6,271.8z	"
          >
            <title id="t2642">Hardin, TX</title>
          </path>
          <path
            id="FIPS_48245"
            className="FIPS_13140 st0 state-tx"
            d="M310.9,277.1l0.3,0.2l0.2,0l1.1-0.2l0.1,0l0.1-0.2l0-0.1l0-0.2l0-0.1l0,0l0.7-0.2l0.2,0
		l0.8,0.3l0.1,0.1l0,0.2l0.2,0.8l0,0l1.6,1l0.9,0.2l0.1,0.1l0.2,0.3l0,0.1l0,0.1l0,0.3l0.1,2.9l-1,0.2l-0.3,0l-0.5,0l-0.6,0.1
		l-0.8,0.3l-2.5,1.1l0-0.2l-0.1-4l-0.9,0L310.9,277.1z	"
          >
            <title id="t2644">Jefferson, TX</title>
          </path>
          <path
            id="FIPS_48361"
            className="FIPS_13140 st0 state-tx"
            d="M318.9,275.3l0,2.5l-1.3,1.8l0-0.3l0-0.1l0-0.1l-0.2-0.3l-0.1-0.1l-0.9-0.2l-1.6-1l0,0
		l-0.2-0.8l0-0.2l0-1l2.4-0.1L318.9,275.3z	"
          >
            <title id="t2645">Orange, TX</title>
          </path>
        </g>

        <path
          id="FIPS_48263"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.1,233.7l-0.3,5.6l-1.5-0.1l-4.1-0.3l0.3-5.5L245.1,233.7z	"
        >
          <title id="t2647">Kent, TX</title>
        </path>
        <path
          id="FIPS_48267"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.9,268.9l-0.1,2.7l2,0.1l-0.1,2.7l-5-0.2l-4-0.2l0.2-5.4L254.9,268.9z	"
        >
          <title id="t2648">Kimble, TX</title>
        </path>
        <path
          id="FIPS_48435"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247.9,268.6l-0.2,5.4l-6.5-0.3l-2.9-0.1l0.3-5.4L247.9,268.6z	"
        >
          <title id="t2649">Sutton, TX</title>
        </path>
        <path
          id="FIPS_48413"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241.8,263.5l6.3,0.3l-0.2,4.9l-9.4-0.4l0.2-4.9L241.8,263.5z	"
        >
          <title id="t2650">Schleicher, TX</title>
        </path>
        <path
          id="FIPS_48327"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.1,263.7l5.6,0.2l1.2,1.9l-0.1,3l-7-0.3L248.1,263.7z	"
        >
          <title id="t2651">Menard, TX</title>
        </path>
        <path
          id="FIPS_48319"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M255,265.9l4.3,0.1l1.4,0.3l-0.2,5.4l-3.8-0.1l-2-0.1l0.1-2.7L255,265.9z	"
        >
          <title id="t2652">Mason, TX</title>
        </path>
        <path
          id="FIPS_48299"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.7,266.4l5.7,0.2l0.7,1.2l0,3.4l0.1,1.1l-2.7-0.2l-4.1-0.1L260.7,266.4z	"
        >
          <title id="t2653">Llano, TX</title>
        </path>
        <path
          id="FIPS_48053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M272.4,265.2l0.9,1.7l-2.5,3.6l-0.9,2.5l-2.5-0.8l-0.1-1.1l0-3.4l-0.7-1.2l0.1-1.4
		L272.4,265.2z	"
        >
          <title id="t2654">Burnet, TX</title>
        </path>

        <path
          id="FIPS_48051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.6,269.3l0.6,0.5l-0.1,0.1l-0.3,0.6v0l1,0.2l0.9,0.4l1.2,1.7l0.2,1l0,0l-0.1,0l-1.7,0.6
		l-0.3,0.1l-1.6,0.4l-1.3-0.6l-1-1.2l-1.3-1.6L286.6,269.3z	"
        >
          <title id="t2656">Burleson, TX</title>
        </path>

        <path
          id="FIPS_48471"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.7,265.1l1.2,2.5l-0.3,4.6l-0.7,0l-0.7,0l-1.2,0l-2.6-1.6l-0.4-3l2.7-0.9L299.7,265.1z	"
        >
          <title id="t2658">Walker, TX</title>
        </path>
        <path
          id="FIPS_48185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M291.6,268.1l3.4-0.5l0.4,3l0.3,5l-3.2,0.3l-0.7-1.4l0.8-1.2l-0.4-0.3l-0.1-0.1l-0.1-0.2
		l-0.5-1.7l0.1-1.3L291.6,268.1z	"
        >
          <title id="t2659">Grimes, TX</title>
        </path>
        <path
          id="FIPS_48041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M291.6,268.1l-0.1,1.5l-0.1,1.3l0.5,1.7l0.1,0.2l0.1,0.1l0.4,0.3l-0.8,1.2l0-0.5l-0.3-0.3
		l-0.1,0l-0.1,0.1l-0.2,0.2l-0.6,0.2l-0.1,0l-0.1-0.1l-0.1-0.2l-0.2-1l-1.2-1.7l-0.9-0.4l-1-0.2v0l0.3-0.6l0.1-0.1l1.2-0.6l0.3-0.5
		l0.2-0.5l0.2-0.5l0.3-0.5l0.1-0.2l0.2-0.2l0.3-0.2l0.5-0.3l0.2-0.1L291.6,268.1z	"
        >
          <title id="t2660">Brazos, TX</title>
        </path>
        <path
          id="FIPS_48313"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M290.8,266.2l0.8-0.3l1-0.7l1.2-0.6l2.3,0l1.6,2.1l-2.7,0.9l-3.4,0.5L290.8,266.2z	"
        >
          <title id="t2661">Madison, TX</title>
        </path>
        <path
          id="FIPS_48289"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M296.4,259.4l0.1,0.2l0.2,0.5l0.5,1.4l-0.2,0.6l0,0l-0.1,0.1l-0.2,0.3l-0.6,1.8l0,0.2l0.1,0.4
		l-2.3,0l-1.2,0.6l-1,0.7l-0.8,0.3l-0.8-5l0.9-0.7l4.9-2.6L296.4,259.4z	"
        >
          <title id="t2662">Leon, TX</title>
        </path>
        <path
          id="FIPS_48395"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M286.9,263l3.1-1.7l0.8,5l-0.2,0.1l-0.5,0.3l-0.3,0.2l-0.2,0.2l-0.1,0.2l-0.3,0.5l-0.2,0.5
		l-0.2,0.5l-0.3,0.5l-1.2,0.6l-0.6-0.5l-0.5-1.3l-1-1.2l-0.6-1.9l-0.1-0.4L286.9,263z	"
        >
          <title id="t2663">Robertson, TX</title>
        </path>
        <path
          id="FIPS_48331"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.4,264.5l0.1,0.4l0.6,1.9l1,1.2l0.5,1.3l-3.8,2.2l-2.1,1.3l-1.7-3.8l0.6-1.8l2.1-1.2
		L284.4,264.5z	"
        >
          <title id="t2664">Milam, TX</title>
        </path>
        <path
          id="FIPS_48027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277.9,261.6l1.5,0.5l2.2,3.8l-2.1,1.2l-0.6,1.8l-3.4-1.6l-0.3-0.1l-1.9-0.4l-0.9-1.7l0.1-0.4
		L277.9,261.6z	"
        >
          <title id="t2665">Bell, TX</title>
        </path>
        <path
          id="FIPS_48099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.9,258.1l2,3.5l-5.4,3.1l-2.9-5.2l4.6-2.6L275.9,258.1z	"
        >
          <title id="t2666">Coryell, TX</title>
        </path>
        <path
          id="FIPS_48281"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M268.5,260.2l1-0.6l2.9,5.2l-0.1,0.4l-5.8-0.1l-1.3-2.6L268.5,260.2z	"
        >
          <title id="t2667">Lampasas, TX</title>
        </path>
        <path
          id="FIPS_48333"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M266.5,256.7l2,3.5l-3.3,2.3l0-0.2l-0.4-0.9l-1.4-1.3l-0.4,0.3l-2.1-0.8l-0.3-0.4l0-0.2
		l0.6-0.4l1.8-1.2l0.2-1l1-0.1L266.5,256.7z	"
        >
          <title id="t2668">Mills, TX</title>
        </path>
        <path
          id="FIPS_48411"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M260.7,259.1l0,0.2l0.3,0.4l2.1,0.8l0.4-0.3l1.4,1.3l0.4,0.9l0,0.2l1.3,2.6l-0.1,1.4l-5.7-0.2
		l-1.4-0.3l0.2-6.7L260.7,259.1z	"
        >
          <title id="t2669">San Saba, TX</title>
        </path>
        <path
          id="FIPS_48307"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M258.3,259.2l1.2,0.1l-0.2,6.7l-4.3-0.1l-1.2-1.9l0.2-5.2l0.7,0.1l1,0.2l2.1,0.1L258.3,259.2z
			"
        >
          <title id="t2670">McCulloch, TX</title>
        </path>
        <path
          id="FIPS_48095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.7,257.6l1.3,1.1l-0.2,5.2l-5.6-0.2l0.3-6.3L252.7,257.6z	"
        >
          <title id="t2671">Concho, TX</title>
        </path>
        <path
          id="FIPS_48451"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.7,255.5l6.4,0.3l1.3,1.5l-0.3,6.3l-6.3-0.3l0.2-5.6l-3.3-0.2l-3-0.2l0-0.4l4.4,0.2
		l0.1-1.8L240.7,255.5z	"
        >
          <title id="t2672">Tom Green, TX</title>
        </path>
        <path
          id="FIPS_48081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M241,250.5l1.7,0.1l4.7,0.3l-0.2,5l-6.4-0.3L241,250.5z	"
        >
          <title id="t2673">Coke, TX</title>
        </path>
        <path
          id="FIPS_48399"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.3,250.9l4.8,0.2l-0.3,6.5l-4.3-0.2l-1.3-1.5l0.2-5L248.3,250.9z	"
        >
          <title id="t2674">Runnels, TX</title>
        </path>
        <path
          id="FIPS_48083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M253.9,251.1l4.7,0.2l-0.3,7.9l-0.5-0.1l-2.1-0.1l-1-0.2l-0.7-0.1l-1.3-1.1l0.3-6.5
		L253.9,251.1z	"
        >
          <title id="t2675">Coleman, TX</title>
        </path>
        <path
          id="FIPS_48049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.5,251.4l2.1,0.1l2.6,5l-1,0.1l-0.2,1l-1.8,1.2l-0.6,0.4l-1.1,0.3l-1.2-0.1l0.3-7.9
		L259.5,251.4z	"
        >
          <title id="t2676">Brown, TX</title>
        </path>
        <path
          id="FIPS_48093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M265.8,249.2l2.3,4.2l0.8-0.5l0.5,0.8l0.5,1l-3.4,2l-2.2-0.3l-2.6-5L265.8,249.2z	"
        >
          <title id="t2677">Comanche, TX</title>
        </path>
        <path
          id="FIPS_48193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M269.4,253.7l2.2-1.2l2.5,4.5l-4.6,2.6l-1,0.6l-2-3.5l3.4-2L269.4,253.7z	"
        >
          <title id="t2678">Hamilton, TX</title>
        </path>
        <path
          id="FIPS_48035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M275.9,250.2l1.5,0.4l-0.1,0.8l-0.1,0.7l0.1,0.5l1.7,3.1l0.1,0.2l0.4,0.2l-3.6,2l-1.7-1.1
		l-2.5-4.5l1.5-0.9L275.9,250.2z	"
        >
          <title id="t2679">Bosque, TX</title>
        </path>
        <path
          id="FIPS_48145"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M284.7,259.1l2.2,3.9l-2.6,1.5l-2.7,1.5l-2.2-3.8L284.7,259.1z	"
        >
          <title id="t2680">Falls, TX</title>
        </path>
        <path
          id="FIPS_48309"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.3,256.7l1.4,2.4l-5.3,3.1l-1.5-0.5l-2-3.5l3.6-2l2.6-1.5L283.3,256.7z	"
        >
          <title id="t2681">McLennan, TX</title>
        </path>
        <path
          id="FIPS_48217"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277.4,250.6l4.3-1.1l2,2.5l1.9,3.4l-2.3,1.3l-1.1-2l-2.6,1.5l-0.4-0.2l-0.1-0.2l-1.7-3.1
		l-0.1-0.5l0.1-0.7L277.4,250.6z	"
        >
          <title id="t2682">Hill, TX</title>
        </path>
        <path
          id="FIPS_48293"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M285.6,255.3l2.4,0.3l2.8,5l-0.9,0.7l-3.1,1.7l-2.2-3.9l-1.4-2.4L285.6,255.3z	"
        >
          <title id="t2683">Limestone, TX</title>
        </path>
        <path
          id="FIPS_48161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.9,252.9l-0.1,0.6l1,1.8l0.7,0.7l0.4,0.1l0.9,1l0.1,0.7l-4.9,2.6l-2.8-5L292.9,252.9
		L292.9,252.9z	"
        >
          <title id="t2684">Freestone, TX</title>
        </path>
        <path
          id="FIPS_48349"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.7,251.9l5.6-3.3l1,0.5l0.6,0.5l0.4,0.5l0.9,1.1l0.5,0.8l0.1,0.7l-4.8,2.8l-2.4-0.3
		L283.7,251.9z	"
        >
          <title id="t2685">Navarro, TX</title>
        </path>
        <path
          id="FIPS_48425"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M272.3,249.7l3.6-1l0,1.5l-2.8,1.5L272.3,249.7z	"
        >
          <title id="t2686">Somervell, TX</title>
        </path>

        <path
          id="FIPS_48221"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.1,245.5l4.9,0.1l0,3.1l-3.6,1l-1.3-3.6L271.1,245.5z	"
        >
          <title id="t2689">Hood, TX</title>
        </path>
        <path
          id="FIPS_48143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.1,246.1l1.3,3.6l0.8,1.9l-1.5,0.9l-2.2,1.2l-0.5-0.8l-0.8,0.5l-2.3-4.2l0.9-3.2
		L271.1,246.1z	"
        >
          <title id="t2690">Erath, TX</title>
        </path>
        <path
          id="FIPS_48133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.9,245.7l5.6,0.2l1.1,0.1l-0.9,3.2l-4.1,2.3l-2.1-0.1l0.2-5.6L259.9,245.7z	"
        >
          <title id="t2691">Eastland, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "10180"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[10180]} state-tx`
          }
          id="FIPS_10180"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48059"
            className="FIPS_10180 st0 state-tx"
            d="M254.4,245.6l5.4,0.2l-0.2,5.6l-0.8,0l-4.7-0.2l0.2-5.6L254.4,245.6z	"
          >
            <title id="t2692">Callahan, TX</title>
          </path>
          <path
            id="FIPS_48441"
            className="FIPS_10180 st0 state-tx"
            d="M254.2,245.5l-0.2,5.6l-0.9,0l-4.8-0.2l0.3-5.7L254.2,245.5z	"
          >
            <title id="t2693">Taylor, TX</title>
          </path>
          <path
            id="FIPS_48253"
            className="FIPS_10180 st0 state-tx"
            d="M248.8,239.6l1.7,0.1l4.1,0.2l-0.2,5.7l-0.2,0l-5.6-0.3L248.8,239.6z	"
          >
            <title id="t2696">Jones, TX</title>
          </path>
        </g>
        <path
          id="FIPS_48353"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M248.6,245.2l-0.3,5.7l-0.9,0l-4.7-0.3l0.3-5.7L248.6,245.2z	"
        >
          <title id="t2694">Nolan, TX</title>
        </path>
        <path
          id="FIPS_48151"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M244.8,239.3l4,0.2l-0.3,5.6l-5.6-0.3l0.3-5.7L244.8,239.3z	"
        >
          <title id="t2695">Fisher, TX</title>
        </path>

        <path
          id="FIPS_48417"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M254.6,239.8l1.5,0.1l4,0.1l-0.2,5.7l-0.2,0l-5.4-0.2L254.6,239.8z	"
        >
          <title id="t2697">Shackelford, TX</title>
        </path>
        <path
          id="FIPS_48429"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.7,240.1l4,0.1l-0.2,5.7l-5.6-0.2l0.2-5.7L261.7,240.1z	"
        >
          <title id="t2698">Stephens, TX</title>
        </path>
        <path
          id="FIPS_48363"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.4,239.6l4,0.2l-0.2,5.7l0,0.6l-4.4-0.1l-1.1-0.1l0.2-5.7L267.4,239.6z	"
        >
          <title id="t2699">Palo Pinto, TX</title>
        </path>

        <path
          id="FIPS_48379"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295,240.3l2.1,0.2l0.3,3.1l-3.2-1.5L295,240.3z	"
        >
          <title id="t2705">Rains, TX</title>
        </path>
        <path
          id="FIPS_48467"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M294.2,242.1l3.2,1.5l0.4,0.4l0,2.7l1.3,1.4l0.2,0.2l-6.8,0l0-6.2L294.2,242.1z	"
        >
          <title id="t2706">Van Zandt, TX</title>
        </path>
        <path
          id="FIPS_48213"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M292.7,248.3l6.8,0l-0.1,2.8l0.3,0.7l-6.8,1l0-0.1l-0.1-0.7l-0.5-0.8l-0.9-1.1l-0.4-0.5
		l-0.6-0.5l-1-0.5l-0.7-0.4L292.7,248.3z	"
        >
          <title id="t2707">Henderson, TX</title>
        </path>
        <path
          id="FIPS_48001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.7,251.8l-0.2,1.8l0.2,0.9l0.4,1.5l0.8,0.7l0.1,0l0.2,0.3l0.2,0.3l0.2,0.5l0,0.1l-0.2,0.2
		l-2.4,0.4l-1.7,0.3l-1,0.5l-0.5-1.5l-0.1-0.7l-0.9-1l-0.4-0.1l-0.7-0.7l-1-1.8l0.1-0.6L299.7,251.8z	"
        >
          <title id="t2708">Anderson, TX</title>
        </path>
        <path
          id="FIPS_48225"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M296.4,259.4l1-0.5l1.7-0.3l2.4-0.4l0.7,0.3l1.1,1.1l1.2,0.7l0.5,0.5l-5.2,4.3l-2,1.7
		l-1.6-2.1l-0.1-0.4l0-0.2l0.6-1.8l0.2-0.3l0.1-0.1l0,0l0.2-0.6l-0.5-1.4l-0.2-0.5L296.4,259.4z	"
        >
          <title id="t2709">Houston, TX</title>
        </path>
        <path
          id="FIPS_48455"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M306.2,263.9l-3.9,4.2l-1.4-0.4l-1.2-2.5l5.2-4.3L306.2,263.9z	"
        >
          <title id="t2710">Trinity, TX</title>
        </path>
        <path
          id="FIPS_48373"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.4,265l-1.1,0.6l1.3,6.2l-2.1,0.5l-1.3,0l-0.4-0.7l-2.8-2.7l-0.8-0.8l3.9-4.2l1.3,0.5
		l1,0.2L309.4,265z	"
        >
          <title id="t2711">Polk, TX</title>
        </path>
        <path
          id="FIPS_48351"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M319.9,263.3l0.5-0.1l0,4.1l-0.2,0.9l-1.6,3l-0.1,0.5v0l0,0l0.3,0.4l0.2,0.8l0,0.1l0,0.1
		l-0.4,0.4l0,0l0.3,2l-2.1,0.1l0.2-5.5l0-3.6l-0.6-2.7L319.9,263.3z	"
        >
          <title id="t2712">Newton, TX</title>
        </path>
        <path
          id="FIPS_48241"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.1,263.9l1.4-0.3l0.6,2.7l0,3.6l-0.2,5.5l-2.4,0.1l0.1-0.2l0.2-1.3l-0.1-0.1l0,0l-0.2-0.5
		l0-0.2l0.1-0.5l0.1-0.3l0.3-0.7l-0.2-0.3l-0.1-0.4l0-0.1l0.2-0.5l-0.1-0.5l-0.8-1.6l-0.1-0.1l-0.2,0l-0.1,0l0,0l-0.7-2.2l0.1-0.4
		l0-0.1l-0.1-0.1l-0.5-0.2l-0.7,0l-1.1,0l3.6-0.9L315.1,263.9z	"
        >
          <title id="t2713">Jasper, TX</title>
        </path>
        <path
          id="FIPS_48457"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M310.5,265.3l1.1,0l0.7,0l0.5,0.2l0.1,0.1l0,0.1l-0.1,0.4l0.7,2.2l0,0l0.1,0l0.2,0l0.1,0.1
		l0.8,1.6l0.1,0.5l-0.2,0.5l0,0.1l0.1,0.4l0.2,0.3l-5.3,0.1l-1.3-6.2l1.1-0.6L310.5,265.3z	"
        >
          <title id="t2714">Tyler, TX</title>
        </path>
        <path
          id="FIPS_48005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.9,259l0.5,0.5l2,0.5l0.5-0.1l0.4,0.2l0.6,0.3l0.1,0.1l1.8,2.2l2.2,1.6l-3.6,0.9l-1.2-0.3
		l-0.9-0.4l-1-0.2l-1.3-0.5l-1.3-3.1l-0.5-0.5L305.9,259z	"
        >
          <title id="t2715">Angelina, TX</title>
        </path>
        <path
          id="FIPS_48403"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M317.2,258l1.2,1.2l1,1.5l0.3,1.4l0.1,0.4l0.1,0.7l-3.4,0.3l-1.4,0.3l-0.1-0.3l0-1.8l0-1.5
		l0.5-0.5l0.2-0.2l0-1.3L317.2,258z	"
        >
          <title id="t2716">Sabine, TX</title>
        </path>
        <path
          id="FIPS_48405"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M315.6,258.3l0,1.3l-0.2,0.2l-0.5,0.5l0,1.5l0,1.8l0.1,0.3l-1,0.5l-2.2-1.6l0.1-1.5l0.1-2.9
		l-0.8-0.9l-0.3-0.2l3.4,0.4L315.6,258.3z	"
        >
          <title id="t2717">San Augustine, TX</title>
        </path>
        <path
          id="FIPS_48419"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M309.7,253.2l5.4-0.2l1.5,1.7l0.5,3.3l-1.6,0.3l-1.2-0.6l-3.4-0.4l-0.6-2.5L309.7,253.2z	"
        >
          <title id="t2718">Shelby, TX</title>
        </path>
        <path
          id="FIPS_48347"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M305.1,254.9l5.3-0.1l0.6,2.5l0.3,0.2l0.8,0.9l-0.1,2.9l-0.1,1.5l-1.8-2.2l-0.1-0.1l-0.6-0.3
		l-0.4-0.2l-0.5,0.1l-2-0.5l-0.5-0.5l-0.6-0.6l-0.1-0.1l-0.3-0.7l-0.2-0.7l-0.1-1.2L305.1,254.9z	"
        >
          <title id="t2719">Nacogdoches, TX</title>
        </path>
        <path
          id="FIPS_48073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M299.4,251.2l5.2-0.1l0.6,3.8l-0.4,0.8l0.1,1.2l0.2,0.7l0.3,0.7l0.1,0.1l0.6,0.6l-1.5,1.3
		l-1.2-0.7l-1.1-1.1l-0.7-0.3l0.2-0.2l0-0.1l-0.2-0.5l-0.2-0.3l-0.2-0.3l-0.1,0l-0.8-0.7l-0.4-1.5l-0.2-0.9l0.2-1.8L299.4,251.2	"
        >
          <title id="t2720">Cherokee, TX</title>
        </path>
        <path
          id="FIPS_48365"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M314.7,247.7l0.1,2.5l0.4,2.8l-5.4,0.2l-1,0l0-1.4l0.2-1.6l0.2-0.6l0.3-0.6l0.3-0.8l0-0.5
		l0.3,0.3l1.2,0.5l0.1,0L314.7,247.7z	"
        >
          <title id="t2721">Panola, TX</title>
        </path>
        <path
          id="FIPS_48401"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308.9,247.7l1,0l0,0.5l-0.3,0.8l-0.3,0.6l-0.2,0.6l-0.2,1.6l0,1.4l1,0l0.7,1.7l-5.3,0.1
		l-0.6-3.8l0-3l1.9,0l1.8,0L308.9,247.7z	"
        >
          <title id="t2722">Rusk, TX</title>
        </path>
        <path
          id="FIPS_48183"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M304.5,245.9l0.2,0l1.6-0.7l0.6-0.9l0.1,0l0.5,0.1l0,0.1l0,2.6l0,0.4l0.6,0.3l0.6,0.1l0.1,0
		l-0.7,0.3l-1.8,0l-1.9,0L304.5,245.9z	"
        >
          <title id="t2723">Gregg, TX</title>
        </path>
        <path
          id="FIPS_48423"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M297.9,244.1l1,0.9l0.3,0.1l3.1,0.8l0.1,0l0.2-0.1l0.1-0.2l1.8,0.4l0,2.2l0,3l-5.2,0.1
		l0.1-2.8l-0.2-0.2l-1.3-1.4L297.9,244.1z	"
        >
          <title id="t2724">Smith, TX</title>
        </path>
        <path
          id="FIPS_48499"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.6,239.8l0,1.4l0,4.3l-0.1,0.2l-0.2,0.1l-0.1,0l-3.1-0.8l-0.3-0.1l-1-0.9l-0.4-0.4
		l-0.3-3.1l3.8,0L302.6,239.8z	"
        >
          <title id="t2725">Wood, TX</title>
        </path>
        <path
          id="FIPS_48203"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M307.5,242.6l2.1,1.3l1.3,0l0.4-0.2l1.3-0.2l0.8-0.1l0.6,0.1l0.7,0.3l0.1,3.9l-3.3,0.9l-0.1,0
		l-1.2-0.5l-0.3-0.3l-1,0l-0.1,0l-0.6-0.1l-0.6-0.3l0-0.4l0-2.6L307.5,242.6z	"
        >
          <title id="t2726">Harrison, TX</title>
        </path>
        <path
          id="FIPS_48459"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.6,241.2l4.7-0.1l0.2,0.3l0.1,1.1l0,1.8l0-0.1l-0.5-0.1l-0.1,0l-0.6,0.9l-1.6,0.7l-0.2,0
		l-1.8-0.4L302.6,241.2z	"
        >
          <title id="t2727">Upshur, TX</title>
        </path>
        <path
          id="FIPS_48063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.6,239.8l0.3-0.3l0.9-0.5l0.2,0l0.2,0l0.6,0l0.1,0l0.6,0.7l0.6,0.4l1.1,1l-4.7,0.1
		L302.6,239.8z	"
        >
          <title id="t2728">Camp, TX</title>
        </path>
        <path
          id="FIPS_48315"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308,241.5l6.6-0.1l0,2.4l-0.7-0.3l-0.6-0.1l-0.8,0.1l-1.3,0.2l-0.4,0.2l-1.3,0l-2.1-1.3
		l-0.1-1.1L308,241.5z	"
        >
          <title id="t2729">Marion, TX</title>
        </path>
        <path
          id="FIPS_48067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M308,236.4l0,0.1l0.1,0.1l0.4,0.1l4,0l0,0l0-0.1l0-0.3l0.2-0.3l0.3-0.1l0.3-0.1l1,0.2l0.2,0.1
		l0.1,0.2l0.1,3.3l0,1.8l-6.6,0.1L308,236.4z	"
        >
          <title id="t2730">Cass, TX</title>
        </path>
        <path
          id="FIPS_48343"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M306.3,235.2l0.7,0.4l1,0.8l0,5l-0.6,0l-0.2-0.3l-1.1-1L306.3,235.2z	"
        >
          <title id="t2731">Morris, TX</title>
        </path>
        <path
          id="FIPS_48449"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M306.3,235.2l-0.1,4.9l-0.6-0.4L305,239l-0.1,0l-0.6,0l-0.2,0l-0.2,0l-0.9,0.5l0-4.6
		L306.3,235.2z	"
        >
          <title id="t2732">Titus, TX</title>
        </path>
        <path
          id="FIPS_48159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M302.9,234.9l0,4.6l-0.3,0.3l-1.7,0.7l0-5.4l0,0L302.9,234.9z	"
        >
          <title id="t2733">Franklin, TX</title>
        </path>
        <path
          id="FIPS_48223"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295,237.2l0.9-0.5l0.5-0.6l1.3-0.6l0.3-0.1l0.5,0l2.4-0.2l0,5.4l-3.8,0l-2.1-0.2L295,237.2z	
		"
        >
          <title id="t2734">Hopkins, TX</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "19100"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[19100]} state-tx`
          }
          id="FIPS_19100"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48085"
            className="FIPS_19100 st0 state-tx"
            d="M284.5,234.7l4.8,0.1l1,0.6l0,4.8l-2.4,0l-3.5-0.1L284.5,234.7z	"
          >
            <title id="t2737">Collin, TX</title>
          </path>
          <path
            id="FIPS_48119"
            className="FIPS_19100 st0 state-tx"
            d="M295,234l0.8-0.4l0.2-0.1l1.5,0.1l0.2,0l1.2,0.4l0.2,0.1l1.1,0.7l0.7,0.1l0,0l0,0l-2.4,0.2
		l-0.5,0l-0.3,0.1l-1.3,0.6l-0.5,0.6l-0.9,0.5l0-2.5L295,234z	"
          >
            <title id="t2735">Delta, TX</title>
          </path>
          <path
            id="FIPS_48121"
            className="FIPS_19100 st0 state-tx"
            d="M278.7,234.3l4.7,0.2l1.2,0.2l-0.2,5.4l-2,0l-3.9-0.1L278.7,234.3z	"
          >
            <title id="t2738">Denton, TX</title>
          </path>
          <path
            id="FIPS_48113"
            className="FIPS_19100 st0 state-tx"
            d="M282.4,240.1l2,0l3.5,0.1l0,2.2l-0.1,3.5l-5.5-0.1L282.4,240.1z	"
          >
            <title id="t2702">Dallas, TX</title>
          </path>
          <path
            id="FIPS_48139"
            className="FIPS_19100 st0 state-tx"
            d="M281.7,245.8l0.5,0l5.5,0.1l0.8,2.4l0.7,0.4l-5.6,3.3l-2-2.5L281.7,245.8z	"
          >
            <title id="t2687">Ellis, TX</title>
          </path>
          <path
            id="FIPS_48251"
            className="FIPS_19100 st0 state-tx"
            d="M276,245.6l0.7,0l5,0.1l0,3.7l-4.3,1.1l-1.5-0.4l0-1.5L276,245.6z	"
          >
            <title id="t2688">Johnson, TX</title>
          </path>
          <path
            id="FIPS_48231"
            className="FIPS_19100 st0 state-tx"
            d="M295,234.7l0,2.5l0,3.1l-0.8,1.8l-1.5,0l-2.4,0l0-1.8l0-4.8L295,234.7z	"
          >
            <title id="t2736">Hunt, TX</title>
          </path>
          <path
            id="FIPS_48397"
            className="FIPS_19100 st0 state-tx"
            d="M290.3,240.2l0,1.8l-2.4,0.4l0-2.2L290.3,240.2z	"
          >
            <title id="t2703">Rockwall, TX</title>
          </path>
          <path
            id="FIPS_48367"
            className="FIPS_19100 st0 state-tx"
            d="M271.4,239.7l1.4,0.1l4.1,0.2l-0.2,5.7l-0.7,0l-4.9-0.1L271.4,239.7z	"
          >
            <title id="t2700">Parker, TX</title>
          </path>
          <path
            id="FIPS_48257"
            className="FIPS_19100 st0 state-tx"
            d="M290.3,242.1l2.4,0l0,6.2l-4.1,0l-0.8-2.4l0.1-3.5L290.3,242.1z	"
          >
            <title id="t2704">Kaufman, TX</title>
          </path>
          <path
            id="FIPS_48439"
            className="FIPS_19100 st0 state-tx"
            d="M276.9,239.9l1.6,0.1l3.9,0.1l-0.1,5.6l-0.5,0l-5-0.1L276.9,239.9z	"
          >
            <title id="t2701">Tarrant, TX</title>
          </path>
          <path
            id="FIPS_48497"
            className="FIPS_19100 st0 state-tx"
            d="M273,234.2l4.6,0.1l1.1,0.1l-0.2,5.7l-1.6-0.1l-4.1-0.2L273,234.2z	"
          >
            <title id="t2739">Wise, TX</title>
          </path>
        </g>

        <path
          id="FIPS_48237"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M267.6,233.6l4.7,0.1l0.6,0.4l-0.2,5.6l-1.4-0.1l-4-0.2l0.2-5L267.6,233.6z	"
        >
          <title id="t2740">Jack, TX</title>
        </path>
        <path
          id="FIPS_48503"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M261.8,234.4l5.7,0.2l-0.2,5l-1.6,0.6l-4-0.1L261.8,234.4z	"
        >
          <title id="t2741">Young, TX</title>
        </path>
        <path
          id="FIPS_48447"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.3,234.2l5.6,0.2l-0.1,5.7l-1.6-0.1l-4-0.1L256.3,234.2z	"
        >
          <title id="t2742">Throckmorton, TX</title>
        </path>
        <path
          id="FIPS_48207"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M250.7,234l5.6,0.2l-0.2,5.7l-1.5-0.1l-4.1-0.2L250.7,234z	"
        >
          <title id="t2743">Haskell, TX</title>
        </path>
        <path
          id="FIPS_48433"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.1,233.7l5.6,0.3l-0.2,5.7l-1.7-0.1l-4-0.2L245.1,233.7z	"
        >
          <title id="t2744">Stonewall, TX</title>
        </path>
        <path
          id="FIPS_48125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M239.8,227.8l5.6,0.3l-0.3,5.7l-5.6-0.3L239.8,227.8z	"
        >
          <title id="t2745">Dickens, TX</title>
        </path>
        <path
          id="FIPS_48345"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.1,221.6l1,0l4.5,0.2l-0.3,6.2l-5.6-0.3L240.1,221.6z	"
        >
          <title id="t2746">Motley, TX</title>
        </path>
        <path
          id="FIPS_48191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.7,216.2l1.3,0.1l-0.3,5.6l-1.1-0.1l-4.5-0.2l0.3-5.6L245.7,216.2z	"
        >
          <title id="t2747">Hall, TX</title>
        </path>
        <path
          id="FIPS_48129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246,210.6l-0.3,5.6l-4.2-0.2l-1.5-0.1l0.3-5.6L246,210.6z	"
        >
          <title id="t2748">Donley, TX</title>
        </path>
        <path
          id="FIPS_48179"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.6,204.6l5.7,0.3l-0.3,5.7l-5.7-0.3L240.6,204.6z	"
        >
          <title id="t2749">Gray, TX</title>
        </path>
        <path
          id="FIPS_48393"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M240.9,199L240.9,199l5.6,0.3l0.1,0l-0.3,5.7l-5.7-0.3l0-0.1L240.9,199z	"
        >
          <title id="t2750">Roberts, TX</title>
        </path>
        <path
          id="FIPS_48357"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M242.5,193.3l4.2,0.2l-0.3,5.7l-5.6-0.3l0.3-5.7L242.5,193.3z	"
        >
          <title id="t2751">Ochiltree, TX</title>
        </path>
        <path
          id="FIPS_48295"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.7,193.5l5.6,0.2l-0.2,5.8l-5.6-0.3l-0.1,0L246.7,193.5z	"
        >
          <title id="t2752">Lipscomb, TX</title>
        </path>
        <path
          id="FIPS_48211"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.1,199.5l-0.1,2.3l-0.1,3.4l-5.6-0.3l0.3-5.7L252.1,199.5z	"
        >
          <title id="t2753">Hemphill, TX</title>
        </path>
        <path
          id="FIPS_48483"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246.2,204.9l5.6,0.3l-0.2,5.7l-5.6-0.3L246.2,204.9z	"
        >
          <title id="t2754">Wheeler, TX</title>
        </path>
        <path
          id="FIPS_48087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M246,210.6l5.6,0.3l-0.1,2l-0.2,3.7l-4.4-0.2l-1.3-0.1L246,210.6z	"
        >
          <title id="t2755">Collingsworth, TX</title>
        </path>
        <path
          id="FIPS_48075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M247,216.3l4.4,0.2l-0.1,2.4l-0.1,3.2l-4.4-0.2L247,216.3z	"
        >
          <title id="t2756">Childress, TX</title>
        </path>
        <path
          id="FIPS_48101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.7,221.9l1.1,0.1l4.4,0.2l0,1.1L251,223l-0.3,0l-0.1,0.1l-0.2,5.1l-5-0.2L245.7,221.9z	"
        >
          <title id="t2757">Cottle, TX</title>
        </path>
        <path
          id="FIPS_48269"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M245.4,228.1l5,0.2l0.6,0l-0.2,5.7l-5.6-0.3L245.4,228.1z	"
        >
          <title id="t2758">King, TX</title>
        </path>
        <path
          id="FIPS_48275"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M256.4,229.8l-0.1,4.3l-5.6-0.2l0.2-5.7l1.7,0.1l1.4,0.3l1.6,0.4l0.5,0.4l0.2,0.3L256.4,229.8
		z	"
        >
          <title id="t2759">Knox, TX</title>
        </path>
        <path
          id="FIPS_48155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M251.1,223.3l1.9,1.5l2.7,0.9l0.6-0.1l0.1-0.1l0-0.1l-0.1,3.3l0,1.3l0-0.2l-0.2-0.3l-0.5-0.4
		l-1.6-0.4l-1.4-0.3l-1.7-0.1l-0.6,0l0.2-5.1l0.1-0.1l0.3,0L251.1,223.3z	"
        >
          <title id="t2760">Foard, TX</title>
        </path>
        <path
          id="FIPS_48197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M252.8,219.7l0.6,0.7l0.3,0.3l0.7,0.7l0.3,0.1h0.1l0.4,0l0.4-0.5l0.1,0l0.1,0l0.5,0.1l0.2,0.1
		l0.3,0.2l-0.2,4.1l0,0.1l-0.1,0.1l-0.6,0.1l-2.7-0.9l-1.9-1.5l0-1.1l0.1-3.2L252.8,219.7z	"
        >
          <title id="t2761">Hardeman, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "48660"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[48660]} state-tx`
          }
          id="FIPS_48660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48009"
            className="FIPS_48660 st0 state-tx"
            d="M262,228.7l5.6,0.1l-0.1,4.8l0,0.9l-5.7-0.2L262,228.7z	"
          >
            <title id="t2762">Archer, TX</title>
          </path>
          <path
            id="FIPS_48485"
            className="FIPS_48660 st0 state-tx"
            d="M265.8,224.6l0.1,0l0.2,0.2l0.2,0.2l0.5,0.8l0.3,0.1l0,0l0,0l0.6-0.5l-0.1,3.5l-5.6-0.1
		l0.2-4.7l1,0.6l1,0.2l0.7,0L265.8,224.6z	"
          >
            <title id="t2765">Wichita, TX</title>
          </path>
          <path
            id="FIPS_48077"
            className="FIPS_48660 st0 state-tx"
            d="M271.1,226.4l0.2,0.4l0,0l0,0l0.5,0.1h0.2l0,0l0.4-0.1l0.4,0.2l0,0l-0.1,0.7l-0.3,0.6
		l-0.1,5.5l-4.7-0.1l0.1-4.8l0.1-3.5l0.4-0.5l0.2-0.1l0.4,0.1l1.6,0.5L271.1,226.4z	"
          >
            <title id="t2766">Clay, TX</title>
          </path>
        </g>
        <path
          id="FIPS_48023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M262,228.7l-0.2,5.7l-5.6-0.2l0.1-4.3l0-1.3L262,228.7z	"
        >
          <title id="t2763">Baylor, TX</title>
        </path>
        <path
          id="FIPS_48487"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M259.5,222.1l0,0.3l0,0.3l0.2,1v0l0,0l0.1,0l0.2,0.1l0.4,0.1l0.2,0l0.4,0l1,0.1h0l0.1,0.1
		l-0.2,4.7l-5.6-0.2l0.1-3.3l0.2-4.1l0.3,0.3l0.4,0l0.1,0h0l0,0l0,0l0.5-0.8l0.5,0.3l0.5,0.3L259.5,222.1L259.5,222.1z	"
        >
          <title id="t2764">Wilbarger, TX</title>
        </path>

        <path
          id="FIPS_48337"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M277.7,228l-0.1,6.2l-4.6-0.1l-0.6-0.4l0.1-5.5l0.1,0.1l0.9,0.4l0.1,0l0.3-0.1l0.5-0.4
		l0.6-0.6l0.4-0.5l1.1,0.7l0.4,0.3L277.7,228z	"
        >
          <title id="t2767">Montague, TX</title>
        </path>
        <path
          id="FIPS_48097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.4,227.7l-0.1,6.9l-4.7-0.2l-1.1-0.1l0.1-6.2l0.2,1l0,0.1l0,0v0l0.1,0.1l0.1,0.1l3.1,1.4
		l0.1,0.1l0.2,0l0.2,0l0.1-0.1l0-0.1L283.4,227.7z	"
        >
          <title id="t2768">Cooke, TX</title>
        </path>
        <path
          id="FIPS_48147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M295.2,229.1L295,234l0,0.7l-4.7,0.7l-1-0.6l0.1-4.3l0.1,0.1l1.6-0.4l0.2-0.1l0.2-0.1l0,0
		l0.1-0.1l0,0l0,0l0-0.1l0-0.1l0,0l0,0l0.1-0.3l0.1-0.3l0.5-0.1l1.2-0.1l0.2,0l0.1,0l0.6,0.1L295.2,229.1z	"
        >
          <title id="t2769">Fannin, TX</title>
        </path>
        {/* <g
          className={`metroArea colorKey ${colorCode[43300]}`}
          id="FIPS_43300"
          // ref={f43330}
          data-color-code={colorCode[43300] ? colorCode[43300] : null}
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        > */}
        <path
          id="FIPS_48181"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M283.5,227.6l0.5,1.1l0.2,0.2l0.1,0.1l1,0.3l0.5-0.1l0,0l1.1-0.5l0,0.2l0,0.2l0,0.1l0,0
		l1.1,0.7l0.1,0.1h0l0.5-0.1l0.1,0l0.1,0v0l0.5,0.6l-0.1,4.3l-4.8-0.1l-1.2-0.2l0.1-6.9L283.5,227.6z	"
        >
          <title id="t2770">Grayson, TX</title>
        </path>
        {/* </g> */}
        <path
          id="FIPS_48277"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M300.8,228.7l0.1,6.4l-0.7-0.1l-1.1-0.7l-0.2-0.1l-1.2-0.4l-0.2,0l-1.5-0.1l-0.2,0.1L295,234
		l0.1-4.9l0.9-0.3l0,0l0.9-0.5l0.8-0.4l0.3,0l0.1,0l0.1,0.3l0,0.1l0,0.1l0,0.1v0l0,0.1l0,0l1.1,0.1l0.4,0l0.7,0h0L300.8,228.7z	"
        >
          <title id="t2771">Lamar, TX</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "18580"
              ? `metroArea clickedArea state-tx`
              : `metroArea ${colorCode[18580]} state-tx`
          }
          id="FIPS_18580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_48007"
            className="FIPS_18580 st0 state-tx"
            d="M279.1,303.4l0.2,0.2l0,0l1-0.5l1.4-1.1l0.1-0.2l-0.2,0l-0.2,0l-0.4-0.3l-0.3-0.3l0-0.3
		l3.8-0.6l-0.1,0.6l0.1,0.2v0.1l-0.2,0.3l-0.1,0.1l-1.4,1.2l-0.3,0l-1,1.3l-1,1.5L279.1,303.4z M284,303l-0.3,0.6l-2.2,2.8l-0.1-0.2
		L284,303z	"
          >
            <title id="t2772">Aransas, TX</title>
          </path>
          <path
            id="FIPS_48355"
            className="FIPS_18580 st0 state-tx"
            d="M281.5,306.5l-2.1,3.3l-0.3-0.1l2.3-3.4L281.5,306.5z M271.2,308.9l0.1-1.8l0-1.4l1.6-1.4
		l-0.1,0.3l0.1,0.5l1.5,0.8l0.3,0.1l0.6,0.1l0.8,0.1l0.1-0.3l1.8,0l0.8,0l-0.2,0l-0.8,0.3l-0.2,0.2l-0.2,0.3l0,0.4l0.1,0.2l0.2,0.3
		l0.2,0.2l0.3,0.2l0.6,0.4l-0.4,0.8l-0.3,0.7l-5.8-0.1l-0.1,0l-0.4-0.5L271.2,308.9z	"
          >
            <title id="t2589">Nueces, TX</title>
          </path>
          <path
            id="FIPS_48409"
            className="FIPS_18580 st0 state-tx"
            d="M272.7,302l3.2,0.2l3.2,1.2l1.4,2.2l-1.6,0.2l-0.8,0l-1.8,0l-0.1,0.3l-0.8-0.1l-0.6-0.1
		l-0.3-0.1l-1.5-0.8l-0.1-0.5l0.1-0.3l-1-0.8L272.7,302z	"
          >
            <title id="t2590">San Patricio, TX</title>
          </path>
        </g>
        <path
          id="FIPS_48061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M271.8,325.3l3.9,0.7l1.3-0.8l0.5-0.6l0.1,0l0.5,0.8l0,1.1l0.4,2l0.9,1.4l0,0l-0.1,0.4
		l-2.1,1.3l-1-0.3l-0.2-0.1l-0.2-0.1l-0.7-0.5l-1-1.1l0-0.1l-1.3-0.2l-0.9-0.2L271.8,325.3z M279,324.6h0.2l0.3,1.3l0.1,0.5l0.1,1
		l0.2,1.6l-0.1,0l0,0l-0.1-0.1l-0.1-0.9l0-0.4l-0.1-0.5l-0.1-0.7l-0.2-1l-0.1-0.4L279,324.6z	"
        >
          <title id="t2773">Cameron, TX</title>
        </path>
        <path
          id="FIPS_49037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M163,159.6l-0.4,4.5l-0.5,3.5l-0.7,5.1l-0.9,6.3l-9.7-1.4l-3.3-0.5l-1.6-0.3l-2.6-0.4
		l-6.7-1.1l0.3,0l0.7,0l3.4-0.8l0.3-0.1l0.7-0.6l2-1.9l0.2-0.3l1.1-2.1l2.3-2.7l2.1-1.1l1.8-1.4l1.3-1.1l0.1,0l0.9-0.4l0.3-0.3
		l0.1-0.6l0-0.5l-0.5-2.8l0,0l-0.2-0.2L163,159.6z	"
        >
          <title id="t2774">San Juan, UT</title>
        </path>
        <path
          id="FIPS_49017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M128.4,158.9l0.4,0l3.8,0.7l0.2,0.1l0.5,0.1l0.4,0.1l1.1,0.1l4.3,0.7l2.8,0.4l12,1.8l-0.9,0.4
		l-0.1,0l-1.3,1.1l-1.8,1.4l-2.1,1.1l-2.3,2.7l-12-1.9l-0.1,0l-0.1,0l-5.1-0.9l-1.4-0.3l-1.8-0.3l0.4-2.4l0.2-1l1.3-0.8l0.8,0
		l0.3,0.1l0.2-1.1L128.4,158.9z	"
        >
          <title id="t2775">Garfield, UT</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36260"
              ? `metroArea clickedArea state-ut`
              : `metroArea ${colorCode[36260]} state-ut`
          }
          id="FIPS_36260"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_49011"
            className="FIPS_36260 st0 state-ut"
            d="M141,121.6l0.5,3.8l-0.2,0.1l-0.3,0.1l-0.9,0.1l-0.4-0.1l-0.2,0l0-1.1l0-0.2l-0.5-0.1
		l-1.5,0.7l-1.3,0.8l-1.5-4.3l2.4-0.4l0.6-0.1l1.5,0.3L141,121.6z	"
          >
            <title id="t2777">Davis, UT</title>
          </path>
          <path
            id="FIPS_49029"
            className="FIPS_36260 st0 state-ut"
            d="M145.6,119.4l0.9,0.3l0.7,1.9l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.3,0.2l-1.1,0.2l-1.6,0.6
		l-0.2,0.1l-0.2,0.2l-0.4,0.4l0,0.1l0,0.3l0,0.1l0.1,0l0.4,0.5l0.3,0.7l0,0.2l-0.5,0.8l-0.1,0.1l-0.2,0l-0.1,0l-0.8-0.4l-0.8-1
		l-0.5-3.8l-0.1-0.4l0.1-0.2l0.2-0.1l0.5-0.2l0.2,0l0.3,0.1l0.1,0.2l0.2,0.2l0.3,0.1l0.3,0l1.6-0.3l0.3-0.3l0.3-0.3l0.1-0.2
		L145.6,119.4z	"
          >
            <title id="t2776">Morgan, UT</title>
          </path>
          <path
            id="FIPS_49057"
            className="FIPS_36260 st0 state-ut"
            d="M144.9,118.5l0.7,0.9l-0.3,0.8l-0.1,0.2l-0.3,0.3l-0.3,0.3l-1.6,0.3l-0.3,0l-0.3-0.1l-0.2-0.2
		l-0.1-0.2l-0.3-0.1l-0.2,0l-0.5,0.2l-0.2,0.1l-0.1,0.2l0.1,0.4l-1.6-0.5l-1.5-0.3l-0.6,0.1l-2.4,0.4l3-2.9l2,0.3l0.7-0.3l0.9-0.7
		l0.1,0.3l0.1,0.1l0.9,0.5l0.2,0L144.9,118.5z	"
          >
            <title id="t2778">Weber, UT</title>
          </path>
        </g>

        <path
          id="FIPS_49033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M150.5,111.8l-1.5,9.6l-2.3,1l0.3-0.2l0.1-0.1l0.1-0.2l0.1-0.2l-0.7-1.9l-0.9-0.3l-0.7-0.9
		l1-1.5l0.5-1.2l0-0.1l-0.1-3.6l-0.2-1L150.5,111.8z	"
        >
          <title id="t2779">Rich, UT</title>
        </path>
        <path
          id="FIPS_49005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M140,110.1l0.5,0.1l5.7,0.9l0.2,1l0.1,3.6l0,0.1l-0.5,1.2l-1,1.5l-2.4,0.3l-0.2,0l-0.9-0.5
		l-0.1-0.1l-0.1-0.3l0-0.9l0-0.4l-0.2-0.3l0,0l-0.5-0.1l-0.1-1.7l0.2-1.1l0.1-0.5l-0.1-0.7l-0.2-0.6l-0.3-0.4L140,110.1z	"
        >
          <title id="t2780">Cache, UT</title>
        </path>
        <path
          id="FIPS_49003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M122.3,106.9l0.6,0.2l0.8,0.2l0.1,0l0.8,0.1l0.3,0l3.1,0.5l0.3,0l3.8,0.6l2.7,0.5l2.4,0.4
		l2,0.3h0l0.7,0.2l0.2,0.9l0.3,0.4l0.2,0.6l0.1,0.7l-0.1,0.5l-0.2,1.1l0.1,1.7l0.5,0.1l0,0l0.2,0.3l0,0.4l0,0.9l-0.9,0.7l-0.7,0.3
		l-2-0.3l-3,2.9l-3.1,0.5l-11.8-2.2L122.3,106.9z	"
        >
          <title id="t2781">Box Elder, UT</title>
        </path>
        <path
          id="FIPS_49009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M167.6,127.5l-0.6,4.5l-0.7-0.1l-0.3-0.4l0.1-0.8l0-0.5l-0.3-1l-1.8-0.3l-1.3,0.2l-3.1,0.3
		l-0.3,0l-1-0.7l-0.2-0.1l0.3-2.4h0l1.4,0.2l1.3,0.2l0.4,0.1l4.5,0.6L167.6,127.5z	"
        >
          <title id="t2782">Daggett, UT</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "41620"
              ? `metroArea clickedArea state-ut`
              : `metroArea ${colorCode[41620]} state-ut`
          }
          id="FIPS_41620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_49035"
            className="FIPS_41620 st0 state-ut"
            d="M136.4,125.6l1.3-0.8l1.5-0.7l0.5,0.1l0,0.2l0,1.1l0.2,0l0.4,0.1l0.9-0.1l0.3-0.1l0.2-0.1
		l0.8,1l0.4,2.6l-0.5,0.3l-1,0.4l-2.7,0.9l-0.4,0.1l-1.2-0.6l-0.5-0.4L136.4,125.6z	"
          >
            <title id="t2783">Salt Lake, UT</title>
          </path>
          <path
            id="FIPS_49043"
            className="FIPS_41620 st0 state-ut"
            d="M149,121.4l-0.5,3.3l5.2,0.9l4.3,0.6l0.5,0.1l-0.3,2.4l-1.6-0.2l-1.8-0.1l-4.9,0.2l-0.6,0.5
		l-0.7,0.8l-0.1,0.1l-0.4,0.1l-1.5,0.1l-0.7-0.4l-1-0.8l-1.9,0l-0.4-2.6l0.8,0.4l0.1,0l0.2,0l0.1-0.1l0.5-0.8l0-0.2l-0.3-0.7
		l-0.4-0.5l-0.1,0l0-0.1l0-0.3l0-0.1l0.4-0.4l0.2-0.2l0.2-0.1l1.6-0.6l1.1-0.2L149,121.4z	"
          >
            <title id="t2784">Summit, UT</title>
          </path>
          <path
            id="FIPS_49045"
            className="FIPS_41620 st0 state-ut"
            d="M119.9,119.6l11.8,2.2l3.1-0.5l1.5,4.3l0.2,4.1l-0.2-0.1l-0.2,0.1l0,0.1l-0.2,1.9l0,0.8
		l0.2,0.8l-0.3,1.3l-0.4,1l-0.7,0.6l-0.3,0.2l-0.9,0.4l-3.7-0.6l-12.8-2.4l0.5-2.7L119.9,119.6z	"
          >
            <title id="t2787">Tooele, UT</title>
          </path>
        </g>
        <path
          id="FIPS_49051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M142.8,128.8l1.9,0l1,0.8l0.7,0.4l1.5-0.1l0.4-0.1l0.1-0.1l0.7-0.8l-0.5,3.2l-0.6,4.5
		l-0.4,2.4l-1.9-0.3l-1.2-2l-0.1-0.1l0-0.1l0.4-0.9l-0.2-1.6l-0.1-0.2l-0.2-0.4l0,0l-1.1-0.6l-1.1-0.6l-0.2-1l0.1-0.5l0.2-1.4
		L142.8,128.8z	"
        >
          <title id="t2785">Wasatch, UT</title>
        </path>
        <path
          id="FIPS_49049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M142.3,129.2l-0.2,1.4l-0.1,0.5l0.2,1l1.1,0.6l1.1,0.6l0,0l0.2,0.4l0.1,0.2l0.2,1.6l-0.4,0.9
		l0,0.1l0.1,0.1l1.2,2l1.9,0.3l0.2,1.2l-3.8-0.6l-3.8-0.6l-1.1-0.2l0.2-0.5l0-0.2l-0.3-0.8l-0.1-0.1l-0.2-0.2l-1,0.5l-0.7,0.8l0,0.2
		l-0.1,0.1l-0.6,0.2l-0.3,0l-0.3-0.1l-0.1-0.1l0.3-0.9l0.1-0.2l0.2-0.2l0.1-0.1l-0.4-1.1l-0.4-0.5l-0.2-0.1l0.4-1l0.3-1.3l-0.2-0.8
		l0-0.8l0.2-1.9l0-0.1l0.2-0.1l0.2,0.1l0.5,0.4l1.2,0.6l0.4-0.1l2.7-0.9L142.3,129.2z	"
        >
          <title id="t2786">Utah, UT</title>
        </path>

        <path
          id="FIPS_49023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M135.5,135.5l0.2,0.1l0.4,0.5l0.4,1.1l-0.1,0.1l-0.2,0.2l-0.1,0.2l-0.3,0.9l0.1,0.1l0.3,0.1
		l0.3,0l0.6-0.2l0.1-0.1l0-0.2l0.7-0.8l1-0.5l0.2,0.2l0.1,0.1l0.3,0.8l0,0.2l-0.2,0.5l1.1,0.2l-0.2,0.9l-0.8,0.5l-0.3,1.9l-0.2,1.1
		l-0.5,0.9l-1.7-0.3l-1,0.4l-0.1,0.3l-0.6-0.1l-1.2-0.4l0.2-0.6l0.3-1.4l0.1-0.6l0-0.1l-0.2-0.2l-2.1-0.4l-0.7-0.1l-12.8-2.3
		l-2.3-0.3l0.9-4.6l12.8,2.4l3.7,0.6l0.9-0.4l0.3-0.2L135.5,135.5z	"
        >
          <title id="t2788">Juab, UT</title>
        </path>
        <path
          id="FIPS_49027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M116.3,138.2l2.3,0.3l12.8,2.3l0.7,0.1l2.1,0.4l0.2,0.2l0,0.1l-0.1,0.6l-0.3,1.4l-0.2,0.6
		l1.2,0.4l0.6,0.1l-0.6,3.5l-2.6,3.3l-1.5,0.8l-0.2,0l-0.7-0.1l-0.2,0.1l-0.2,0.3l-0.5,0.9l-2.8-0.5l0,0l-1.1-0.2l-11.1-2l0.3-1.3
		L116.3,138.2z	"
        >
          <title id="t2789">Millard, UT</title>
        </path>
        <path
          id="FIPS_49041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M141.9,149.5l-0.2,1l-0.6,3.6l-0.1,0l-0.3,2.1l-4.6-0.6l-2.9-0.5l0-0.1l-0.6-0.1l-3.9-0.6
		l0.2-0.8l0.5-0.9l0.2-0.3l0.2-0.1l0.7,0.1l0.2,0l1.5-0.8l2.6-3.3l1.6,0.3l0.1,0.2L141.9,149.5z	"
        >
          <title id="t2790">Sevier, UT</title>
        </path>
        <path
          id="FIPS_49039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M144.1,139.5l-0.7,4.4l-0.5-0.1l-0.9,5.6l-5.2-0.9l-0.1-0.2l-1.6-0.3l0.6-3.5l0.1-0.3l1-0.4
		l1.7,0.3l0.5-0.9l0.2-1.1l0.3-1.9l0.8-0.5l0.2-0.9L144.1,139.5z	"
        >
          <title id="t2791">Sanpete, UT</title>
        </path>
        <path
          id="FIPS_49007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M144.1,139.5l3.8,0.6l3.1,0.5l0.1,0l0.1,0.1l5.4,0.8l0.8,0.1l0.1,0.2l0,0.1l0,0l0,0l-0.6,0.4
		l-0.4,0.4l-0.7,1.4l-0.1,0.4l-0.1,0.6l0,0.7l-10.3-1.6l-0.1-0.9l-0.8-2.2L144,141l-0.1-0.1L144.1,139.5z	"
        >
          <title id="t2792">Carbon, UT</title>
        </path>
        <path
          id="FIPS_49013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M158.1,128.6l0.2,0.1l-1.1,7.8l-0.3,2.2l-0.4,2.9l-5.4-0.8l-0.1-0.1l-0.1,0l-3.1-0.5l-0.2-1.2
		l0.4-2.4l0.6-4.5l0.5-3.2l0.6-0.5l4.9-0.2l1.8,0.1L158.1,128.6z	"
        >
          <title id="t2793">Duchesne, UT</title>
        </path>
        <path
          id="FIPS_49047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M158.3,128.6l1,0.7l0.3,0l3.1-0.3l1.3-0.2l1.8,0.3l0.3,1l0,0.5l-0.1,0.8l0.3,0.4l0.7,0.1
		l-0.8,5.5l-1,7.2l-0.3,2.1l-0.6,0.4l-9-1.3l0-0.1l0-0.7l0.1-0.6l0.1-0.4l0.7-1.4l0.4-0.4l0.6-0.4l0,0l0,0l0-0.1l-0.1-0.2l-0.8-0.1
		l0.4-2.9l0.3-2.2L158.3,128.6z	"
        >
          <title id="t2794">Uintah, UT</title>
        </path>
        <path
          id="FIPS_49019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M164.9,146.8l-0.7,4.8l-0.3,2.3l-0.1,0.5l-0.4,2.4l-0.4,2.8l-9.6-1.4l0.4-0.3l0.1-0.5v-0.6
		l0-0.1l-0.3,0.1l-0.3,0l-0.1,0l0,0l0-0.1l-0.2-1.5l0-2.6l0.3-1.5l0.5-1.4l0.2-0.3l0-0.1l0.5-0.9l0.6-1.2l0.1-0.6l0-0.7l9,1.3
		L164.9,146.8z	"
        >
          <title id="t2795">Grand, UT</title>
        </path>
        <path
          id="FIPS_49015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M143.9,140.9l0.1,0.1l0.1,0.1l0.8,2.2l0.1,0.9l10.3,1.6l0,0.1l0,0.7l-0.1,0.6l-0.6,1.2
		l-0.5,0.9l0,0.1l-0.2,0.3l-0.5,1.4l-0.3,1.5l0,2.6l0.2,1.5l0,0.1l0,0l0.1,0l0.3,0l0.3-0.1l0,0.1v0.6l-0.1,0.5l-0.4,0.3l-12.7-2
		l0-0.1l0.3-2.1l0.1,0l0.6-3.6l0.2-1l0.9-5.6l0.5,0.1L143.9,140.9z	"
        >
          <title id="t2796">Emery, UT</title>
        </path>
        <path
          id="FIPS_49055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M136.2,155.5l4.6,0.6l0,0.1l12.7,2l0.2,0.2l0,0l0.5,2.8l0,0.5l-0.1,0.6l-0.3,0.3l-12-1.8
		l-2.8-0.4l-4.3-0.7l0.2-1.1l0.4-2.5l0.3-0.4L136.2,155.5z	"
        >
          <title id="t2797">Wayne, UT</title>
        </path>
        <path
          id="FIPS_49031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M128.8,154.1l3.9,0.6l0.6,0.1l0,0.1l2.9,0.5l-0.7,0.5l-0.3,0.4l-0.4,2.5l-0.2,1.1l-1.1-0.1
		l-0.4-0.1l-0.5-0.1l-0.2-0.1l-3.8-0.7l0.9-1.2l0.4-0.3l0.2-0.6l0-0.1l-0.5-1l-0.5-0.4l-0.5-0.6l0-0.1L128.8,154.1z	"
        >
          <title id="t2798">Piute, UT</title>
        </path>
        <path
          id="FIPS_49001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M113.9,150.6l11.1,2l1.1,0.2l0,0l2.8,0.5l-0.2,0.8l0,0.4l0,0.1l0.5,0.6l0.5,0.4l0.5,1l0,0.1
		l-0.2,0.6l-0.4,0.3l-0.9,1.2l-0.4,0l-15.6-2.9L113.9,150.6z	"
        >
          <title id="t2799">Beaver, UT</title>
        </path>
        <path
          id="FIPS_49021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M112.8,156l15.6,2.9l-0.3,2.2l-0.2,1.1l-0.3-0.1l-0.8,0l-1.3,0.8l-0.2,1l-0.4,2.4l-2.3,0.2
		l-1.4-0.2l-0.4,0.1l-0.7,0l-1.1-0.3l-2-1.3l-1-0.9l-4.6-0.9L112.8,156z	"
        >
          <title id="t2800">Iron, UT</title>
        </path>
        <path
          id="FIPS_49053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M111.5,162.9l4.6,0.9l1,0.9l2,1.3l1.1,0.3l0.7,0l0.4-0.1l1.4,0.2l-1.1,6.4l-11.6-2.2
		L111.5,162.9z	"
        >
          <title id="t2801">Washington, UT</title>
        </path>
        <path
          id="FIPS_49025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M122.7,166.4l2.3-0.2l1.8,0.3l1.4,0.3l5.1,0.9l0.1,0l0.1,0l12,1.9l-1.1,2.1l-0.2,0.3l-2,1.9
		l-0.7,0.6l-0.3,0.1l-3.4,0.8l-0.7,0l-0.3,0l-11.4-1.9l-3.6-0.6L122.7,166.4z	"
        >
          <title id="t2802">Kane, UT</title>
        </path>
        <path
          id="FIPS_51001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M497.5,153.2l3.7-1.2l-0.3,1l-0.8,1.3l-0.3,0.1l-0.1,0.1l0,0l0,0l-0.1,0.1l0,0.1l0,0.1l0,0.1
		l-0.1,0.3l-0.2,0.5l-0.3,1.4l0,0.2l-0.3,2.9l0,0.1l-0.5,0.2l-0.9,0.1l-0.1,0l0-0.1l0,0l0.1,0l0.1-0.1l-0.1-0.5l-0.6-0.2l-1,0.3
		l-0.1-0.1l0-0.1l0.1-0.5l0.1-0.3l0.7-2l0.5-0.7l0.2-0.2l0-0.1l0.2-0.5l0-0.2l-0.1-1L497.5,153.2z	"
        >
          <title id="t2803">Accomack, VA</title>
        </path>
        <path
          id="FIPS_51131"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M495.6,159.6l1-0.3l0.6,0.2l0.1,0.5l-0.1,0.1l-0.1,0l0,0l0,0.1l0.1,0l0.9-0.1l0.5-0.2l0,0.1
		l0,0.2l-0.7,3.4l-0.1,0.2l-0.1,0.2l0,0l-0.4,0.7l0,0l-0.1,0.1l-0.1,0.1h-0.1l-0.6-0.1l-0.6-0.9l-0.3-0.6l-0.1-0.4l0-0.4l0-0.2
		l0-1.4l0-0.9l0-0.3L495.6,159.6z	"
        >
          <title id="t2804">Northampton, VA</title>
        </path>
        <path
          id="FIPS_51027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.4,170.6l0.5,0.3l-0.1,0.1l-0.5,0.4l0,0.1l0.1,0.2l0.9,1.2l0.8,0.7h0l0.1,0.1l1.1,0.4
		l-0.2,0.6l-1,0.6l-0.3,0.3L436,176l-0.1,0.1l-0.1,0.2l0,0.2l0,0.3l-0.1,0.2l-0.4,0.3l-0.7,0.1l-0.1,0l-2.1-3.1L435.4,170.6z	"
        >
          <title id="t2805">Buchanan, VA</title>
        </path>
        <path
          id="FIPS_51185"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.9,172.3l1.6,1.1l-0.3,0.9l-1.1,1.7l-0.3,0.7l-0.8,0.2l-0.6,0.3l-1.2,0.5l-0.8,0.2
		l-1.6-2.2l0.3-0.3l1-0.6l0.2-0.6l0.7,0.4l1.2-0.2l0,0l0.4-0.4l0,0l0.9-0.8L441.9,172.3z	"
        >
          <title id="t2806">Tazewell, VA</title>
        </path>
        <path
          id="FIPS_51173"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.5,177.2l1.6,2.2l-3.2,2.1l-0.1,0.1l-1.1-1.9l-1.7-1.6l0.5-0.5l0.8-0.2l1.2-0.5l0.6-0.3
		l0.8-0.2L442.5,177.2z	"
        >
          <title id="t2807">Smyth, VA</title>
        </path>
        <path
          id="FIPS_51520"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M435.4,183l-1,0.1l0.5-1l0.3-0.2l0.3,0l0.2,0.1l0.1,0.3l0,0.3L435.4,183z	"
        >
          <title id="t2808">Bristol, VA</title>
        </path>
        <path
          id="FIPS_51191"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.9,178.2l1.7,1.6l1.1,1.9l0.1-0.1l-0.4,0.4l-1.8,0.2l-1,0.1l-0.1,0.3l-2.2,0.3l0.3-0.5
		l0-0.3l-0.1-0.3l-0.2-0.1l-0.3,0l-0.3,0.2l-0.5,1l-0.5,0.1l-0.6-1.4l2-1.8l1.5-0.7L437.9,178.2z	"
        >
          <title id="t2809">Washington, VA</title>
        </path>
        <path
          id="FIPS_51167"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.9,175.6l1.6,2.2l-0.5,0.5l-1.1,1l-1.5,0.7l-2,1.8l-1.1-2l0.6-1.3l1.7-1.2l0.1,0l0.7-0.1
		l0.4-0.3l0.1-0.2l0-0.3l0-0.2l0.1-0.2l0.1-0.1L436.9,175.6z	"
        >
          <title id="t2810">Russell, VA</title>
        </path>
        <path
          id="FIPS_51720"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430,178.7L430,178.7l0.2,0l0.1,0.1l0,0.3l-0.2,0.5l-0.4,0.1l-0.3-0.3l0-0.2l0.2-0.3l0.2-0.1
		L430,178.7z	"
        >
          <title id="t2811">Norton, VA</title>
        </path>
        <path
          id="FIPS_51195"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.2,175.8l0.2,1l0.8,1l0.2,0.2l1.2,0.7l0.2-0.1l0.2-0.2l-0.6,1.3l-1.4,0.1l-0.7,0.1
		l-0.2,0.1l-1.1,0.8l-0.2,0.3v0.1l-1.3-1.1l0-1l2.7-3.3L430.2,175.8z M430,178.7l-0.1,0l-0.2,0.1l-0.2,0.3l0,0.2l0.3,0.3l0.4-0.1
		l0.2-0.5l0-0.3l-0.1-0.1L430,178.7L430,178.7z	"
        >
          <title id="t2812">Wise, VA</title>
        </path>
        <path
          id="FIPS_51051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M432.5,174.2l2.1,3.1l-1.7,1.2l-0.2,0.2l-0.2,0.1l-1.2-0.7l-0.2-0.2l-0.8-1l-0.2-1l0.4-0.3
		l1.5-0.9L432.5,174.2z	"
        >
          <title id="t2813">Dickenson, VA</title>
        </path>
        <path
          id="FIPS_51169"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.7,181.3v-0.1l0.2-0.3l1.1-0.8l0.2-0.1l0.7-0.1l1.4-0.1l1.1,2l0.6,1.4l-3.2,0.5l-2.3,0.3
		l-1.6,0.2l0.2-1.1l0.4-0.4L428.7,181.3z	"
        >
          <title id="t2814">Scott, VA</title>
        </path>
        <path
          id="FIPS_51105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.7,181.3l-1.2,1.5l-0.4,0.4l-0.2,1.1l-5,0.6l-2.1,0.2l2.1-1.1l1-0.6l2.1-1.2l2-1.7
		l0.2-0.4L428.7,181.3z	"
        >
          <title id="t2815">Lee, VA</title>
        </path>
        <path
          id="FIPS_51021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.5,173.4l2.4-1.1l1.6,1.7l-0.4,1l-1.2,0.6l-0.9,0.3l-1.1-0.1l-0.6,0.5l-0.8,1l-0.7-0.6
		l0.3-0.7l1.1-1.7L443.5,173.4z	"
        >
          <title id="t2816">Bland, VA</title>
        </path>
        <path
          id="FIPS_51077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.2,178.6l1.2,1.4l-0.1,0.1l0,0.2l0,0.1l0.1,0.1l0.3,0.3l0.2,0l0.1-0.1l0-0.2l0.8,0.9
		l-0.7,0.1l-4.6,0.6l-3.3,0.3l0.3-0.4l0.4-0.4l3.2-2.1L446.2,178.6z	"
        >
          <title id="t2817">Grayson, VA</title>
        </path>
        <path
          id="FIPS_51640"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M447.4,180L447.4,180L447.4,180l0.2-0.2l0.3-0.1l0.3,0.1l-0.1,0.4l-0.2,0.3l0,0.1l0,0.2
		l-0.1,0.1l-0.2,0l-0.3-0.3l-0.1-0.1l0-0.1L447.4,180L447.4,180z	"
        >
          <title id="t2818">Galax, VA</title>
        </path>
        <path
          id="FIPS_51197"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.1,177.2l-2.9,1.4l-2.1,0.9l-1.6-2.2l0.8-1l0.6-0.5l1.1,0.1l0.9-0.3l1.2-0.6L449.1,177.2z
			"
        >
          <title id="t2819">Wythe, VA</title>
        </path>
        <path
          id="FIPS_51071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.8,170.3l1,0.6l1.3-0.9l0.1-0.1l1-0.8l0.5,0.7l0.7,1.3l-1.6,1.2l-2.3,1.7l-1.6-1.7
		L446.8,170.3L446.8,170.3z	"
        >
          <title id="t2820">Giles, VA</title>
        </path>
        <path
          id="FIPS_51750"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.3,174.3L450.3,174.3l-0.3-0.2L450,174l0-0.1l0-0.1l0.2-0.2l0.2-0.1l0.1,0l0.1,0l0.1,0
		l0.1-0.1l0.2,0.1l0.1,0.2l-0.1,0.2l-0.4,0.5L450.3,174.3z	"
        >
          <title id="t2821">Radford, VA</title>
        </path>
        <path
          id="FIPS_51155"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M449.7,172.2l0.8,1l-0.1,0l-0.2,0.1l-0.2,0.2l0,0.1l0,0.1l0.1,0.2l0.2,0.2l0.1,0l0.5,1.2
		l-0.8,0.8l-1,0.9l-2.1-2.2l0.4-1L449.7,172.2z	"
        >
          <title id="t2822">Pulaski, VA</title>
        </path>

        <path
          id="FIPS_51035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.1,176.3l2.2,2.6l-0.3,0.8l-0.2,0.1l-0.1,0.1l-0.1,0l-0.3-0.2l-0.1,0l-0.1,0l-0.1,0.5
		l0,0.2l0.2,0.6l-2.3,0.4l-0.8-0.9l0-0.1l0.2-0.3l0.1-0.4l-0.3-0.1l-0.3,0.1l-0.1,0.1l-0.1,0.1l0,0l-1.2-1.4l2.9-1.4L450.1,176.3z	"
        >
          <title id="t2825">Carroll, VA</title>
        </path>
        <path
          id="FIPS_51089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.2,179.8l-3.2,0.5l-0.3,0l-0.1-0.9l-0.2-0.6l-0.1-0.1l-0.2-0.2l-0.3-0.5l-0.1-0.7v0
		l0.1-0.1l0.4-0.1l0.7-0.5l1.8,0.1l0.5-0.2l1-0.9L460.2,179.8z M458.1,177.8L458.1,177.8l-0.3,0.5l0.2,0.2l0.6,0.3l0.2-0.1l0-0.2
		l-0.2-0.7L458.1,177.8L458.1,177.8z	"
        >
          <title id="t2826">Henry, VA</title>
        </path>
        <path
          id="FIPS_51141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.2,176.4l2.1,0.7l-0.4,0.1l-0.1,0.1v0l0.1,0.7l0.3,0.5l0.2,0.2l0.1,0.1l0.2,0.6l0.1,0.9
		l-3.9,0.6l-1.8,0.2l-0.2-0.6l0-0.2l0.1-0.5l0.1,0l0.1,0l0.3,0.2l0.1,0l0.1-0.1l0.2-0.1l0.3-0.8L454.2,176.4z	"
        >
          <title id="t2827">Patrick, VA</title>
        </path>
        <path
          id="FIPS_51063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.8,173l-0.5,3.4l-2,2.5l-2.2-2.6l0.8-0.8l0.7-0.2l0.8-0.3l0.5-0.3l0-0.1l0.5-0.7l1-0.6
		L454.8,173z	"
        >
          <title id="t2828">Floyd, VA</title>
        </path>
        <path
          id="FIPS_51121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453,170.4l0.4,0.7l0.6,0.6l0.4,1.3l0,0.2l-1,0.6l-0.5,0.7l0,0.1l-0.5,0.3l-0.8,0.3l-0.7,0.2
		l-0.5-1.2l0.3-0.2l0.4-0.5l0.1-0.2l-0.1-0.2l-0.2-0.1l-0.1,0.1l-0.1,0l-0.1,0l-0.8-1l1.6-1.2L453,170.4z	"
        >
          <title id="t2829">Montgomery, VA</title>
        </path>
        <path
          id="FIPS_51775"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.5,170.4L455.5,170.4l0,0.7l0.1,0.1l-0.7,0l-0.1-0.7L455.5,170.4z	"
        >
          <title id="t2830">Salem, VA</title>
        </path>
        <path
          id="FIPS_51067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M457.4,171.2l3,1.9l-0.1,2.5l-1,0.9l-0.5,0.2l-1.8-0.1l-0.7,0.5l-2.1-0.7l0.5-3.4l0.8-0.7
		l0.6,0.2l0.2,0l0.1,0l0.4-0.4L457.4,171.2z	"
        >
          <title id="t2831">Franklin Co., VA</title>
        </path>
        <path
          id="FIPS_51161"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.7,169.1l2.5,1.1l0.2,1.1l-0.5,0.9l-0.4,0.4l-0.1,0l-0.2,0l-0.6-0.2l-0.8,0.7l-0.5,0.2
		l0-0.2l-0.4-1.3l-0.6-0.6l-0.4-0.7l0.1-0.2l0.4-0.4l0.6-0.3L454.7,169.1z M455.5,170.4l-0.7,0.1l0.1,0.7l0.7,0l0,0.1l0.7,0.3l0.1,0
		l0.2-0.2l0.2-0.3l0.2-0.6l0-0.2l0,0l-0.2-0.1l-0.7-0.1L455.5,170.4L455.5,170.4z	"
        >
          <title id="t2832">Roanoke Co., VA</title>
        </path>
        <path
          id="FIPS_51019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.6,165.5l2.9,1.5l-0.8,0.2l0.3,1.3l-1.2,4.2l-1.5,0.4l-3-1.9l-0.2-1.1l0.5-0.6l-0.1-0.7
		l0.9-1l0.1-0.1l0.2-0.1l0.1,0l0.1,0.1l0.2,0.2l0.3,0l0,0l0,0l0.5-0.8l0.1-0.3L460.6,165.5z M460.1,169.1h-0.2l0,0.2l0.2,0.2
		l0.2,0.1l0.4-0.1l0.1-0.6l-0.3-0.2l-0.5,0.1L460.1,169.1z	"
        >
          <title id="t2833">Bedford Co., VA</title>
        </path>
        <path
          id="FIPS_51005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.7,162.3l0.5-0.2l0.7,0l0,0l0.5,0.6l0.1,0.1l2,0.3l0.4-0.4l0,1.4l-1.5-0.2l-0.2,0.3l0,0.1
		l0,0.2l-0.1,0.2l-0.3,0.5l-0.8,0.9l-0.2,0.2l-0.2-0.1l-0.9,0.9l-0.7-0.2l-0.2-0.1l-0.9-0.7L453.7,162.3z M454.5,164l0,0.7l0.1,0.1
		l0.2,0.1l0.3-0.3L455,164l0-0.1l-0.4-0.1L454.5,164z	"
        >
          <title id="t2834">Alleghany, VA</title>
        </path>
        <path
          id="FIPS_51045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.7,166.1l-0.1,0.1l0.1,0.2l0.8,0.9l-0.6,1.4l-0.2,0.3l-0.5,0.5l-0.6,0.3l-0.4,0.4
		l-0.1,0.2l-1.7,0.6l-0.7-1.3l0.3-0.2l1.2-1l-0.2-0.4l0.3-0.7l0.6-0.7l0.2,0.1l0.7,0.2l0.9-0.9L454.7,166.1z	"
        >
          <title id="t2835">Craig, VA</title>
        </path>
        <path
          id="FIPS_51023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M457.9,164l2.3,2.6L460,167l-0.5,0.8l0,0l0,0l-0.3,0l-0.2-0.2l-0.1-0.1l-0.1,0l-0.2,0.1
		l-0.1,0.1l-0.9,1l0.1,0.7l-0.5,0.6l-2.5-1.1l0.2-0.3l0.6-1.4l-0.8-0.9l-0.1-0.2l0.1-0.1l0.2-0.2l0.8-0.9l0.3-0.5l0.1-0.2l0-0.2
		l0-0.1l0.2-0.3L457.9,164z	"
        >
          <title id="t2836">Botetourt, VA</title>
        </path>
        <path
          id="FIPS_51009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M462.8,162.6l0.3-0.2l0.7,0.3l0,0l1,0.9l0.3,0.3l0.9,1.4l0.3,0l-1.2,1.7l-0.6,0.6l-1.2-0.7
		l-2.9-1.5h0.1l0.2-0.2l0.3-0.3l0.2-0.2l0.2-1l0.1-0.4l0.1-0.2l0.2-0.4l0.1-0.1L462.8,162.6z	"
        >
          <title id="t2837">Amherst, VA</title>
        </path>
        <path
          id="FIPS_51163"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M459.1,159.6l1.6,0.8l1.7,0.8l0.3,0.2l0.1,1.2l-0.6,0l-0.1,0.1l-0.2,0.4l-0.1,0.2l-0.1,0.4
		l-0.2,1l-0.2,0.2l-0.3,0.3l-0.2,0.2h-0.1l-0.4,1.2l-2.3-2.6l0-1.4L459.1,159.6z M460.3,163.2l0-0.3l-0.4-0.1l-0.3,0.1l-0.2,0.2
		l0.1,0.4l0.2,0.2l0.2-0.1L460.3,163.2z M460.6,163.5l-0.2,0.1l0,0.1l0.1,0.5l0.2,0.2l0.2,0l0.2-0.2l0-0.1l0.2-0.6l0-0.4l-0.3,0
		L460.6,163.5L460.6,163.5z	"
        >
          <title id="t2838">Rockbridge, VA</title>
        </path>
        <path
          id="FIPS_51017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.6,157.8l0.5,0.2l0.5,0.2l1.5,0l0.5,0.1l0.5,1.2l-1.2,3l-0.4,0.4l-2-0.3l-0.1-0.1
		l-0.5-0.6l0,0l-0.7,0l-0.5,0.2l0.7-1.6L455.6,157.8z	"
        >
          <title id="t2839">Bath, VA</title>
        </path>
        <path
          id="FIPS_51091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460,155.1l-0.1,0.1l-0.5,1.5l0,0.2l0,0.1l-0.2,0.6l-0.7,0.8l-0.5-0.1l-1.5,0l-0.5-0.2
		l-0.5-0.2l-0.2-0.5v0l0,0l0.6-1l0.3-0.9l0-0.9l0-1.1l1,0.2l0.2,0.1l0.2,0.2l0.6,0.9L460,155.1z	"
        >
          <title id="t2840">Highland, VA</title>
        </path>
        <path
          id="FIPS_51079"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M468.2,153.5l0.2-0.7l2.1,2.3l-0.6,1.3l-3.1-0.6L468.2,153.5z	"
        >
          <title id="t2841">Greene, VA</title>
        </path>
        <path
          id="FIPS_51165"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.8,150.2l1.8-0.4l2.6,1.6l-0.3,1.3l0.8,0.4l0.8,0.3l0.2,0l0.5,0l-1.4,2.2l-0.7,1.1l-1.7-1
		l-1.5-0.6l-2.1-1L461.8,150.2z M464.2,153.3L464.2,153.3l-0.3,0.5l0,0.2l0.1,0.6l0,0l0.2-0.1l0.5-0.5l0-0.2l-0.1-0.2L464.2,153.3z	
		"
        >
          <title id="t2842">Rockingham, VA</title>
        </path>
        <path
          id="FIPS_51015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460,155.1l0.7-1l2.1,1l1.5,0.6l1.7,1l-0.1,0.4l-0.1,0.7l0.1,0.5v0.1l-0.1,0.2l-0.4,0.3
		l-0.8,1.6l-0.3,0.6l-0.8,0l-0.2,0l-0.1,0.1l-0.6,0.4l-0.3-0.2l-1.7-0.8l-1.6-0.8l-0.5-1.2l0.7-0.8l0.2-0.6l0-0.1l0-0.2l0.5-1.5
		L460,155.1z M463.3,157.4l-0.6,0.2l-0.1,0.2l0,0.2l0.1,0.2l0.2,0.1l0.4,0l0.2-0.2l0.1-0.2l0-0.3l-0.1-0.2l-0.1-0.1H463.3
		L463.3,157.4z M464.7,158.3L464.7,158.3l-0.3,0.2l-0.2,0.2v0.1l0.1,0.2l0.3,0.1l0.4-0.1l0.1-0.1l0-0.3l0-0.1l-0.1-0.2L464.7,158.3
		L464.7,158.3z	"
        >
          <title id="t2843">Augusta, VA</title>
        </path>
        <path
          id="FIPS_51125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M465.6,158.9l2.7,3.7l-1.4,2.6l-0.4,0.2l-0.3,0l-0.9-1.4l-0.3-0.3l-1-0.9l0,0l-0.7-0.3
		l-0.3,0.2l-0.1-1.2l0.6-0.4l0.1-0.1l0.2,0l0.8,0l0.3-0.6L465.6,158.9z	"
        >
          <title id="t2844">Nelson, VA</title>
        </path>
        <path
          id="FIPS_51029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M472.4,162.4l0,0.7l-0.7,1.9l-0.8,2.3l-1.4-0.5l-2.7-1.6l1.4-2.6l0-0.1l0.2-0.3l0.5-0.1
		l0.5-0.1l0.1,0l0,0l0,0l0-0.4L472.4,162.4z	"
        >
          <title id="t2845">Buckingham, VA</title>
        </path>
        <path
          id="FIPS_51011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469.5,166.8l-0.5,2.1l-1.3,0.8l-2.5-2.5l1.2-1.7l0.4-0.2L469.5,166.8z	"
        >
          <title id="t2846">Appomattox, VA</title>
        </path>
        <path
          id="FIPS_51031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M464.6,167.7l0.6-0.6l2.5,2.5l-0.4,2.5l-2-0.2l-0.3-0.2l-1.5-0.4l-0.9,0.2l-0.2,0.3l-0.6,0.8
		l1.2-4.2l0.6,0.4L464.6,167.7z	"
        >
          <title id="t2847">Campbell, VA</title>
        </path>
        <path
          id="FIPS_51083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M465.3,172l2,0.2l1.9,0.6l0.9,1.4l0,1.2l0,0l0.3,0.4l0.2,0.1l-0.5,2.1l-0.6,0.1l-3.5,0.6
		l-0.8,0.1L465.3,172z	"
        >
          <title id="t2848">Halifax, VA</title>
        </path>
        <path
          id="FIPS_51143"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.8,172.7l0.6-0.8l0.2-0.3l0.9-0.2l1.5,0.4l0.3,0.2l-0.1,6.9l-1.3,0.2l0.3-0.4l0-0.1l0-0.1
		l-0.6-0.6l-1.3,0.2l-0.3,0.3l-0.1,0.1l0,0l0.4,0.2l0.3,0.5l-0.4,0.1l-2.1,0.3l0.1-4.2l0.1-2.5L461.8,172.7z	"
        >
          <title id="t2849">Pittsylvania, VA</title>
        </path>
        <path
          id="FIPS_51690"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.1,177.8L458.1,177.8l0.6,0l0.2,0.7l0,0.2l-0.2,0.1l-0.6-0.3l-0.2-0.2L458.1,177.8
		L458.1,177.8z	"
        >
          <title id="t2850">Martinsville, VA</title>
        </path>
        <path
          id="FIPS_51590"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M464,179.1l-1.3,0.2l-0.3-0.5l-0.4-0.2l0,0l0.1-0.1l0.3-0.3l1.3-0.2l0.6,0.6l0,0.1l0,0.1
		L464,179.1z	"
        >
          <title id="t2851">Danville, VA</title>
        </path>
        <path
          id="FIPS_51680"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M464.6,167.7l-1,1.2l-0.6-0.4l-0.3-1.3l0.8-0.2L464.6,167.7z	"
        >
          <title id="t2852">Lynchburg, VA</title>
        </path>
        <path
          id="FIPS_51515"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.1,169.1l0-0.1l0.5-0.1l0.3,0.2l-0.1,0.6l-0.4,0.1l-0.2-0.1l-0.2-0.2l0-0.2H460.1z	"
        >
          <title id="t2853">Bedford, VA</title>
        </path>
        <path
          id="FIPS_51770"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.5,170.4L455.5,170.4l0.5-0.4l0.7,0.1l0.2,0.1l0,0l0,0.2l-0.2,0.6l-0.2,0.3l-0.2,0.2
		l-0.1,0l-0.7-0.3l0-0.1l-0.1-0.1L455.5,170.4L455.5,170.4z	"
        >
          <title id="t2854">Roanoke, VA</title>
        </path>
        <path
          id="FIPS_51530"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.6,163.5L460.6,163.5l0.2-0.3l0.3,0l0,0.4l-0.2,0.6l0,0.1l-0.2,0.2l-0.2,0l-0.2-0.2
		l-0.1-0.5l0-0.1L460.6,163.5z	"
        >
          <title id="t2855">Buena Vista, VA</title>
        </path>
        <path
          id="FIPS_51580"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M454.5,164l0.1-0.1l0.4,0.1l0,0.1l0.1,0.6l-0.3,0.3l-0.2-0.1l-0.1-0.1L454.5,164z	"
        >
          <title id="t2856">Covington, VA</title>
        </path>
        <path
          id="FIPS_51678"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M460.3,163.2l-0.3,0.3l-0.2,0.1l-0.2-0.2l-0.1-0.4l0.2-0.2l0.3-0.1l0.4,0.1L460.3,163.2z	"
        >
          <title id="t2857">Lexington, VA</title>
        </path>
        <path
          id="FIPS_51820"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M464.7,158.3L464.7,158.3l0.3,0l0.1,0.2l0,0.1l0,0.3l-0.1,0.1l-0.4,0.1l-0.3-0.1l-0.1-0.2
		v-0.1l0.2-0.2L464.7,158.3L464.7,158.3z	"
        >
          <title id="t2858">Waynesboro, VA</title>
        </path>
        <path
          id="FIPS_51790"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.3,157.4L463.3,157.4h0.1l0.1,0.1l0.1,0.2l0,0.3l-0.1,0.2l-0.2,0.2l-0.4,0l-0.2-0.1
		l-0.1-0.2l0-0.2l0.1-0.2L463.3,157.4z	"
        >
          <title id="t2859">Staunton, VA</title>
        </path>
        <path
          id="FIPS_51540"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469,157.9l0.2,0l0.2,0.1l0.1,0.2l-0.1,0.4l-0.1,0.2l-0.4,0.1l-0.1,0l-0.1-0.1l0-0.1l0-0.2
		l0.1-0.2L469,157.9z	"
        >
          <title id="t2860">Charlottesville, VA</title>
        </path>
        <path
          id="FIPS_51660"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M464.2,153.3l0.4,0.3l0.1,0.2l0,0.2l-0.5,0.5l-0.2,0.1l0,0l-0.1-0.6l0-0.2L464.2,153.3
		L464.2,153.3z	"
        >
          <title id="t2861">Harrisonburg, VA</title>
        </path>
        <path
          id="FIPS_51003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M466.8,155.6l3.1,0.6l1.7,0.4l-0.7,1.8l-1.3,3l0,0.4l0,0l0,0l-0.1,0l-0.5,0.1l-0.5,0.1
		l-0.2,0.3l0,0.1l-2.7-3.7l0.4-0.3l0.1-0.2v-0.1l-0.1-0.5l0.1-0.7l0.1-0.4L466.8,155.6z M469,157.9l-0.2,0.2l-0.1,0.2l0,0.2l0,0.1
		l0.1,0.1l0.1,0l0.4-0.1l0.1-0.2l0.1-0.4l-0.1-0.2l-0.2-0.1L469,157.9z	"
        >
          <title id="t2862">Albemarle, VA</title>
        </path>
        <path
          id="FIPS_51065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M471,158.5l2.7,0.8l-0.6,2.2l-0.7,0.9l-2.8-0.9L471,158.5z	"
        >
          <title id="t2863">Fluvanna, VA</title>
        </path>

        <path
          id="FIPS_51147"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.2,166.5l0.2,0.9l0.3,2.3l-2,0.9l-2.8-1.7l0.5-2.1l1.4,0.5L473.2,166.5z	"
        >
          <title id="t2865">Prince Edward, VA</title>
        </path>
        <path
          id="FIPS_51037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467.7,169.7l1.3-0.8l2.8,1.7l0,2.5l-1.1,2.8l-0.2-0.1l-0.3-0.4l0,0l0-1.2l-0.9-1.4l-1.9-0.6
		L467.7,169.7z	"
        >
          <title id="t2866">Charlotte, VA</title>
        </path>
        <path
          id="FIPS_51117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M476.7,173.6l0.4,3l-2.8,0.5l-1.3,0.3l-2.8,0.5l0.5-2.1l1.1-2.8L476.7,173.6z	"
        >
          <title id="t2867">Mecklenburg, VA</title>
        </path>

        <path
          id="FIPS_51111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.8,169.7l2.6,0.8l0.4,3.2l-5-0.6l0-2.5L473.8,169.7z	"
        >
          <title id="t2869">Lunenburg, VA</title>
        </path>

        <path
          id="FIPS_51139"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M468.2,148.1l1.2,0.7l-0.2,1.8l-0.8,2.1l-0.2,0.7l-0.5,0l-0.2,0l-0.8-0.3l-0.8-0.4l0.3-1.3
		l0.3-1.1l0.3-0.7l0.4,0.1l0.3-0.4L468.2,148.1z	"
        >
          <title id="t2872">Page, VA</title>
        </path>
        <path
          id="FIPS_51171"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M468.5,145.7l-0.3,2.4l-0.7,1.2l-0.3,0.4l-0.4-0.1l-0.3,0.7l-0.3,1.1l-2.6-1.6l0.4-1.3
		l0.1-0.4l0,0l0-0.1l0.5-0.5l0,0.1l0,0.1l0,0l0.9-0.9l0.3-0.7l0-0.1l0-0.5L468.5,145.7z	"
        >
          <title id="t2873">Shenandoah, VA</title>
        </path>

        <path
          id="FIPS_51840"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469.3,142.8l0.2,0l0.4,0.2l-0.4,1l-0.3-0.3l-0.1-0.5l0-0.2l0.1-0.3L469.3,142.8z	"
        >
          <title id="t2875">Winchester, VA</title>
        </path>
        <path
          id="FIPS_51069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M467,139.9l1.3,0.7l2.2,1.3L470,145l-1.5,0.7l-2.4-0.2l0.3-0.5l0.1-0.1l0.3-0.3l0.2-0.3
		l0.1-0.4l0-0.2l0-2.5L467,139.9z M469.3,142.8l-0.1,0l-0.1,0.3l0,0.2l0.1,0.5l0.3,0.3l0.4-1l-0.4-0.2L469.3,142.8z	"
        >
          <title id="t2876">Frederick, VA</title>
        </path>

        <path
          id="FIPS_51157"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469.4,148.8l1.3-1.6l0.5,0.4l0.8,0.8l0.2,0.4l0.1,0.1l0.1,0.1l0.4,0.1l0.2,0l-0.9,1.1l-1,1.6
		l-0.6,0l-1.3-1L469.4,148.8z	"
        >
          <title id="t2878">Rappahannock, VA</title>
        </path>
        <path
          id="FIPS_51113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M469.1,150.6l1.3,1l1.9,2.6l-1.8,0.9l-2.1-2.3L469.1,150.6z	"
        >
          <title id="t2879">Madison, VA</title>
        </path>
        <path
          id="FIPS_51137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M470.5,155l1.8-0.9l0.9-0.7l0.8-0.5l0.5-0.2l0.9-0.2l0.5,0.1l0.2,0.1l-1.9,3.6l-2.5,0.3
		l-1.7-0.4L470.5,155z	"
        >
          <title id="t2880">Orange, VA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "40060"
              ? `metroArea clickedArea state-va`
              : `metroArea ${colorCode[40060]} state-va`
          }
          id="FIPS_40060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_51007"
            className="FIPS_40060 st0 state-va"
            d="M474,165.2l0.1,0.1l0.2,0l0.3-0.2l0.4-0.3l0.4-0.3l0.6-0.1l0.3,0l0,0l0.3,0.3l0.2,0.3l-0.2,0
		l0,0l0,0.4l0.1,0.2l1.4,1l0.1,0l0.1,0l0.1,0l0,0l0-0.2l0.2-0.2l0,0l0.4,0l0.2,0.3l-1.3,1.2l-4.6-0.5l-0.2-0.9L474,165.2z	"
          >
            <title id="t2884">Amelia, VA</title>
          </path>
          <path
            id="FIPS_51033"
            className="FIPS_40060 st0 state-va"
            d="M480.1,153.5l2.3,0.8l0.9,2.3l-0.9,1.2l-1.4,1.6l-3.5-2l2-3.8L480.1,153.5z	"
          >
            <title id="t2923">Caroline, VA</title>
          </path>
          <path
            id="FIPS_51041"
            className="FIPS_40060 st0 state-va"
            d="M478.5,162.9l0.6,0l0.4,0.6l0.6,0.7l1-0.3l1.9,0.5l0,0.8l-0.1,0.1l-0.5,0.1l-0.3,0.9l0,0
		l-0.1-0.3l0-0.1l0-0.1l-0.1-0.1l-0.2,0l-0.2,0.2l-0.1,0.1l0,0.2l0.2,0.3l-0.2,0.1l-2.1-0.1l-0.2-0.3l-0.4,0l0,0l-0.2,0.2l0,0.2l0,0
		l-0.1,0l-0.1,0l-0.1,0l-1.4-1l-0.1-0.2l0-0.4l0,0l0.2,0L478.5,162.9z	"
          >
            <title id="t2904">Chesterfield, VA</title>
          </path>
          <path
            id="FIPS_51036"
            className="FIPS_40060 st0 state-va"
            d="M483.5,162.9l3,0.9l0.6,1.9l-1-0.1l-3.2-0.3l0-0.8L483.5,162.9z	"
          >
            <title id="t2905">Charles City, VA</title>
          </path>
          <path
            id="FIPS_51049"
            className="FIPS_40060 st0 state-va"
            d="M472.4,162.4l0.7-0.9l1.1,1l-0.1,2.7l-0.8,1.3l-2.2,0.8l0.8-2.3l0.7-1.9L472.4,162.4z	"
          >
            <title id="t2864">Cumberland, VA</title>
          </path>
          <path
            id="FIPS_51053"
            className="FIPS_40060 st0 state-va"
            d="M479.3,166.7l2.1,0.1l-0.1,0.4l0.3,0.2l0.3,0l0.5,2.3l-1.9,1.9l-0.4-0.1l-2.6-0.7l0.4-2.8
		L479.3,166.7z	"
          >
            <title id="t2887">Dinwiddie, VA</title>
          </path>
          <path
            id="FIPS_51075"
            className="FIPS_40060 st0 state-va"
            d="M478.4,161l0.1,1.9l-0.6-0.2l-1.2-0.2l-1.2,0l0,0.1l0,0.1l-0.1,0.1l-0.2,0l-0.1,0l-0.9-0.2
		l-0.1-0.1l-1.1-1l0.6-2.2l0.5,0.1l0.8,0.5l0.3,0.3l1.5,0.9L478.4,161z	"
          >
            <title id="t2882">Goochland, VA</title>
          </path>
          <path
            id="FIPS_51085"
            className="FIPS_40060 st0 state-va"
            d="M477.1,157.3l0.5,0.1l3.5,2l0.4,0.7l0.4,0.2l1.3,0.5l0.6,0.3l-0.8,1.4l-0.2,0l-1.2-0.3
		l-0.5-0.2l-1.5-0.8l-1,0l-1.7,0L477.1,157.3z	"
          >
            <title id="t2915">Hanover, VA</title>
          </path>
          <path
            id="FIPS_51087"
            className="FIPS_40060 st0 state-va"
            d="M478.4,161l1,0l1.5,0.8l0.5,0.2l1.2,0.3l0.2,0l0.6,0.5l-0.4,1.5l-1.9-0.5l0.1-0.8l0-0.4
		l-0.3-0.5l-0.3-0.2l-0.1,0l-0.2,0.1l-0.6,0.3l-0.6,0.5l-0.6,0L478.4,161z	"
          >
            <title id="t2903">Henrico, VA</title>
          </path>
          <path
            id="FIPS_51101"
            className="FIPS_40060 st0 state-va"
            d="M482.4,157.8l0.1-0.1l0.2,0.2l1,1.4l1.8,0.6l1.5,1l0.3,0.4l0,0l0,0.4l0,0.1l-0.8-0.5l-2.1,0
		l-0.8-0.2l-0.6-0.3l-1.3-0.5l-0.4-0.2l-0.4-0.7L482.4,157.8z	"
          >
            <title id="t2916">King William, VA</title>
          </path>
          <path
            id="FIPS_51097"
            className="FIPS_40060 st0 state-va"
            d="M482.4,157.8l0.9-1.2l0.7,1l0.4,0.5l0.7,0.4l0.4-0.1l0.5-0.2l0.4,0l0.1,0.1l0.5,0.5l0.1,0.2
		l1.3,1.4l0,1l0,0.1l0.3,0.3l0.1,0.1v0.1l0,0.1l-0.1,0.2l-0.4,0.5l-0.4-0.4l-0.6-0.5l0-0.1l0-0.4l0,0l-0.3-0.4l-1.5-1l-1.8-0.6
		l-1-1.4l-0.2-0.2L482.4,157.8z	"
          >
            <title id="t2917">King and Queen, VA</title>
          </path>
          <path
            id="FIPS_51109"
            className="FIPS_40060 st0 state-va"
            d="M471.6,156.7l2.5-0.3l2.9,0.9l-0.4,3.8l-1.5-0.9l-0.3-0.3l-0.8-0.5l-0.5-0.1l-2.7-0.8
		L471.6,156.7z	"
          >
            <title id="t2881">Louisa, VA</title>
          </path>
          <path
            id="FIPS_51127"
            className="FIPS_40060 st0 state-va"
            d="M483.6,161l0.8,0.2l2.1,0l0.8,0.5l0.6,0.5l-1.4,1.5l-3-0.9l-0.6-0.5L483.6,161z	"
          >
            <title id="t2906">New Kent, VA</title>
          </path>
          <path
            id="FIPS_51145"
            className="FIPS_40060 st0 state-va"
            d="M478.5,162.9l-1.6,2.2l-0.2-0.3l-0.3-0.3l0,0l-0.3,0l-0.6,0.1l-0.4,0.3l-0.4,0.3l-0.3,0.2
		l-0.2,0l-0.1-0.1l0.1-2.7l0.1,0.1l0.9,0.2l0.1,0l0.2,0l0.1-0.1l0-0.1l0-0.1l1.2,0l1.2,0.2L478.5,162.9z	"
          >
            <title id="t2883">Powhatan, VA</title>
          </path>
          <path
            id="FIPS_51183"
            className="FIPS_40060 st0 state-va"
            d="M484.6,167.6L484.6,167.6L484.6,167.6l0.1,0.1l0.8,0.3h0.3l0,0l1,0.7l0.3,0.7l-4.2,4l-0.6-0.1
		l-1-1.5l-0.7-0.3l1.9-1.9L484.6,167.6z	"
          >
            <title id="t2900">Sussex, VA</title>
          </path>
          <path
            id="FIPS_51149"
            className="FIPS_40060 st0 state-va"
            d="M482.9,165.3l0.1-0.1l3.2,0.3l-1.5,2.1l-2.1,2l-0.5-2.3l0.4,0.1l0.2-0.5l-0.1-0.3l-0.5-0.2
		l0.3-0.9l0.2,0.6l0.3,0.2l0.4-0.3l0.1-0.3l-0.1-0.1L482.9,165.3L482.9,165.3z	"
          >
            <title id="t2901">Prince George, VA</title>
          </path>
          <path
            id="FIPS_51570"
            className="FIPS_40060 st0 state-va"
            d="M481.6,166.7l-0.2-0.3l0-0.2l0.1-0.1l0.2-0.2l0.2,0l0.1,0.1l0,0.1l0,0.1l0.1,0.3l0,0l-0.1,0.1
		l0,0l-0.1,0L481.6,166.7L481.6,166.7z	"
          >
            <title id="t2868">Colonial Heights, VA</title>
          </path>
          <path
            id="FIPS_51670"
            className="FIPS_40060 st0 state-va"
            d="M482.4,165.4l0.5-0.1l0,0l0.3,0.2l0.1,0.1l-0.1,0.3l-0.4,0.3l-0.3-0.2L482.4,165.4z	"
          >
            <title id="t2870">Hopewell, VA</title>
          </path>
          <path
            id="FIPS_51730"
            className="FIPS_40060 st0 state-va"
            d="M482.1,166.4L482.1,166.4l0.5,0.2l0.1,0.3l-0.2,0.5l-0.4-0.1l-0.3,0l-0.3-0.2l0.1-0.4l0.2-0.1
		l0.1,0l0.1-0.1l0.1,0L482.1,166.4L482.1,166.4L482.1,166.4z	"
          >
            <title id="t2902">Petersburg, VA</title>
          </path>
          <path
            id="FIPS_51760"
            className="FIPS_40060 st0 state-va"
            d="M481.1,163.9l-1,0.3l-0.6-0.7l-0.4-0.6l0.6-0.5l0.6-0.3l0.2-0.1l0.1,0l0.3,0.2l0.3,0.5l0,0.4
		L481.1,163.9z	"
          >
            <title id="t2907">Richmond, VA</title>
          </path>
        </g>
        <path
          id="FIPS_51135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M473.8,169.7l-0.3-2.3l4.6,0.5l-0.4,2.8l-1.2-0.2L473.8,169.7z	"
        >
          <title id="t2885">Nottoway, VA</title>
        </path>
        <path
          id="FIPS_51025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M476.4,170.4l1.2,0.2l2.6,0.7l0.5,2.3l-0.7,2.4l-1.3,0.3l-1.5,0.3l-0.4-3L476.4,170.4z	"
        >
          <title id="t2886">Brunswick, VA</title>
        </path>

        <path
          id="FIPS_51595"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482.1,173.5l0.1,0.4l0,0.2l-0.4,0.3l-0.2,0l-0.2-0.4l0-0.1l0.1-0.2l0.5-0.2L482.1,173.5
		L482.1,173.5z	"
        >
          <title id="t2888">Emporia, VA</title>
        </path>
        <path
          id="FIPS_51081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482.9,173.4l1.8,1.8l-4.8,0.9l0.7-2.4l-0.5-2.3l0.4,0.1l0.7,0.3l1,1.5L482.9,173.4z
		 M482.1,173.5L482.1,173.5l-0.2-0.1l-0.5,0.2l-0.1,0.2l0,0.1l0.2,0.4l0.2,0l0.4-0.3l0-0.2L482.1,173.5z	"
        >
          <title id="t2889">Greensville, VA</title>
        </path>

        <path
          id="FIPS_51620"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488,172.3l0.3,0.7l0,0l-0.6,0.2l-0.3-0.3l-0.1-0.3l0-0.2l0.1-0.1l0.2,0L488,172.3z	"
        >
          <title id="t2891">Franklin, VA</title>
        </path>
        <path
          id="FIPS_51175"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488,172.3l-0.2,0l-0.2,0l-0.1,0.1l0,0.2l0.1,0.3l0.3,0.3l0.6-0.2l0,0l0.1,0l0.1,1.3l-2.5,0.5
		l-1.3,0.3l-1.8-1.8l4.2-4l0.9-0.9L488,172.3z	"
        >
          <title id="t2892">Southampton, VA</title>
        </path>

        <path
          id="FIPS_51047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M472.9,149l0.9,0.9l0.6,1l0.9,1.1l0.1,0.1l0.2,0.1l0.1,0l0.9-0.1l0.3,0.5l-0.8,0.3l-0.2-0.1
		l-0.5-0.1l-0.9,0.2L474,153l-0.8,0.5l-0.9,0.7l-1.9-2.6l0.6,0l1-1.6L472.9,149z	"
        >
          <title id="t2913">Culpeper, VA</title>
        </path>

        <path
          id="FIPS_51119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M487.6,158.3l1.4,1.3l0.4,0.3l0.1,0l1.2-0.1l1.3,0.2l0,0l0,0.1l-0.2,0.2l-0.2,0l-0.8,0.5
		l-2.4-0.7l-1.3-1.4L487.6,158.3z	"
        >
          <title id="t2918">Middlesex, VA</title>
        </path>

        <path
          id="FIPS_51103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488,157.9l1.2-0.9l2.3,1.7l0.5,0.5l0.1,0.2l0,0.1l-0.8,0.2l-1.4-0.4l-0.6-0.3L488,157.9z	"
        >
          <title id="t2920">Lancaster, VA</title>
        </path>
        <path
          id="FIPS_51159"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M484.3,154.9l0-0.1l0.5-0.6l0,0l0.8,0.7l0.6,0.6l0.2,0l1.2,0.2l1.6,1.4l-1.2,0.9l-1.5-0.8
		L484.3,154.9z	"
        >
          <title id="t2921">Richmond Co., VA</title>
        </path>
        <path
          id="FIPS_51057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M482.9,154.1l1.5,0.8l2.2,2.2l1.2,1.2l-0.6,0.7l-0.1-0.2l-0.5-0.5l-0.1-0.1l-0.4,0l-0.5,0.2
		l-0.4,0.1l-0.7-0.4l-0.4-0.5l-0.7-1l-0.9-2.3L482.9,154.1z	"
        >
          <title id="t2922">Essex, VA</title>
        </path>

        <path
          id="FIPS_51099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M480.2,152.2l3,0.3l-0.3,1.6l-0.5,0.3l-2.3-0.8L480.2,152.2z	"
        >
          <title id="t2927">King George, VA</title>
        </path>
        <path
          id="FIPS_51193"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M483.2,152.5l0.5,0.7l1,0.4l0.4,0l1-0.1l1.1-0.2l0.1,0l0,0l0.9,0.8l0.1,0.1l0.2,0.3l0,0.1
		l-1,1.1l-1.2-0.2l-0.2,0l-0.6-0.6l-0.8-0.7l0,0l-0.5,0.6l0,0.1l-1.5-0.8L483.2,152.5z	"
        >
          <title id="t2928">Westmoreland, VA</title>
        </path>
        <path
          id="FIPS_51133"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M488.6,154.6l0.2,0.1l1,0.5l0.3,0.1l0.3,0l0.1,0l0.1,0l0,0l0.8,0.3l0.3,0.2l0,0.7l-0.1,1.9
		l-0.2,0.2l-2.3-1.7l-1.6-1.4L488.6,154.6z	"
        >
          <title id="t2929">Northumberland, VA</title>
        </path>

        <path
          id="FIPS_50009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M511.2,56.4l3.5-1l-0.2,0.4l0,3.2l0.1,0.2l0.3,0.3l0.4,0.5l0.2,0.3l0,0.1l0.2,0.4l-0.1,1.1
		l-0.1,0.3v0l0,0.1l-0.4,0.8l0,0.1l-0.1,0.1l-0.1,0.2l0,0l-0.3,0.2l-0.2,0l-0.6,0.8l-1-0.8l-0.4-2.6l0.4-1.1l-1.1-0.4l-0.4-0.1
		l0-1.6L511.2,56.4z	"
        >
          <title id="t2937">Essex, VT</title>
        </path>
        <path
          id="FIPS_50019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M511.2,56.4l0.1,1.3l0,1.6l0.4,0.1l-0.3,0.8l-0.2,0.2l-0.9-0.3l-0.4,1.7l-0.3,1.3l-1.1-0.3
		l-0.2-0.2l-0.8-1l-0.1-0.6l-1.4-0.3l-0.5-2.9L511.2,56.4z	"
        >
          <title id="t2938">Orleans, VT</title>
        </path>
        <path
          id="FIPS_50003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M508.6,80.5l-0.3,0l0.1,0.8l0.2,1.2l-1.2,0.2l0,0.3l0.4,2.1l0.8-0.2l0.5,2.4l-0.9,0.2
		l-2.2,0.5l-0.7-2.5l-1-4.7L508,80L508.6,80.5z	"
        >
          <title id="t2939">Bennington, VT</title>
        </path>

        <path
          id="FIPS_50023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M508.1,63.9l2.1,0.5l0,0l0.1,0.1l0,0.2l-0.7,2.7l-0.5-0.1l-1.3,1.1l-0.1,1l-0.3,1.1l-0.6-0.1
		l-2.3-1.2l0.2-1.6l-0.2,0l0.3-1.7l0.2-0.7l1.5,0.3l1.4-0.7L508.1,63.9z	"
        >
          <title id="t2941">Washington, VT</title>
        </path>
        <path
          id="FIPS_50005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M511.6,59.5l1.1,0.4l-0.4,1.1l0.4,2.6l1,0.8l-0.6,0.4l-0.6,0.4l0,0l0,0l-0.3,0.5l0,0.1V66
		l0.3,1l0.2,0.2l0.2,0.1l-1.3-0.2l-1.2,0.4l-0.6-0.1l0.7-2.7l0-0.2l-0.1-0.1l0,0l-2.1-0.5l0.3-1.1l1.1,0.3l0.3-1.3l0.4-1.7l0.9,0.3
		l0.2-0.2L511.6,59.5z	"
        >
          <title id="t2942">Caledonia, VT</title>
        </path>
        <path
          id="FIPS_50015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M505.9,60.8l1.4,0.3l0.1,0.6l0.8,1l0.2,0.2l-0.3,1.1l-0.2,1.1l-1.4,0.7l-1.5-0.3l-1.6-2
		l0.4-1.1l0.7-1.2l1.2-0.5L505.9,60.8z	"
        >
          <title id="t2943">Lamoille, VT</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "15540"
              ? `metroArea clickedArea state-vt`
              : `metroArea ${colorCode[15540]} state-vt`
          }
          id="FIPS_15540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_50011"
            className="FIPS_15540 st0 state-vt"
            d="M505.4,57.9l0.5,2.9l-0.4-0.2l-1.2,0.5l-0.7,1.2l-0.4,1.1l-3-0.5l-0.6-3.7L505.4,57.9z	"
          >
            <title id="t2944">Franklin, VT</title>
          </path>
          <path
            id="FIPS_50007"
            className="FIPS_15540 st0 state-vt"
            d="M500.3,63l3,0.5l1.6,2l-0.2,0.7l-0.3,1.7l0.2,0l-0.2,1.6l-0.4-1.1l-0.5-0.3l-2.2,0.9l-0.5,0.1
		l-0.3-1.6l0-0.5l0-0.1l0,0l-0.2-0.5l-0.1-0.3l-0.4-0.5l-0.3-0.2L500.3,63z	"
          >
            <title id="t2945">Chittenden, VT</title>
          </path>
          <path
            id="FIPS_50013"
            className="FIPS_15540 st0 state-vt"
            d="M499.8,59.3l0.6,3.7l-0.7,2.3l-0.1-0.1l-0.3-0.5l-0.5-2.7l-0.3-2.1l0-0.2L499.8,59.3z	"
          >
            <title id="t2940">Grand Isle, VT</title>
          </path>
        </g>
        <path
          id="FIPS_50001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M500.9,68.9l0.5-0.1l2.2-0.9l0.5,0.3l0.4,1.1l2.3,1.2l-0.2,1l-0.2,0.6l-0.4,0.4l-0.8,0.6
		l0.2,0.3l0.1,0.2l-0.7-0.1l-1.1,0.3l-0.5,0.2l0.3,0.9l-1.4,0.5l-0.3-0.6l-0.2-0.3l-1.1-2.5l0,0v0l0-0.4v-0.4l0-1.1L500.9,68.9z	"
        >
          <title id="t2946">Addison, VT</title>
        </path>
        <path
          id="FIPS_50021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M502.1,75.4l1.4-0.5l-0.3-0.9l0.5-0.2l1.1-0.3l0.7,0.1l0.7-0.6l0.8,0.2l0.2,0.2l1.2,1.5
		l0.2,2.7l-0.4,1.4L508,80l-3.6,0.7l-0.5-2.5l-1.5-0.3l-0.3-0.1l0,0l-0.1-0.8l0.1-0.5L502.1,75.4z	"
        >
          <title id="t2947">Rutland, VT</title>
        </path>
        <path
          id="FIPS_50025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M508.6,80.5l1.3,0.1l1.2-0.5l1.1-0.2l0,1l0.3,0.5l0,0.1l0.2,1.4l-0.6,2l0,0.1l0.3,0.6l1,0.8
		l-4.4,0.9l-0.5-2.4l-0.8,0.2l-0.4-2.1l0-0.3l1.2-0.2l-0.2-1.2l-0.1-0.8L508.6,80.5z	"
        >
          <title id="t2948">Windham, VT</title>
        </path>
        <path
          id="FIPS_50027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M506.6,71.6l0.1,0.2l0.1,0.2l0.7,0.1l1.1,0.1l2.7,0.3l1.2,0.2l-0.6,2.4l-0.3,1.2l0.4,2.1
		l0.2,0.5l0,1.1l-1.1,0.2l-1.2,0.5l-1.3-0.1L508,80l0.1-1.1l0.4-1.4l-0.2-2.7l-1.2-1.5l-0.2-0.2l-0.8-0.2l-0.7,0.6l-0.1-0.2
		l-0.2-0.3l0.8-0.6l0.4-0.4L506.6,71.6z	"
        >
          <title id="t2949">Windsor, VT</title>
        </path>
        <path
          id="FIPS_50017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M512.7,67.4l-0.2,5.2l-1.2-0.2l-2.7-0.3l-1.1-0.1l-0.7-0.1l-0.1-0.2l-0.1-0.2l0.2-1l0.6,0.1
		l0.3-1.1l0.1-1l1.3-1.1l0.5,0.1l0.6,0.1l1.2-0.4L512.7,67.4z	"
        >
          <title id="t2950">Orange, VT</title>
        </path>
        <path
          id="FIPS_53047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M82.4,5.2l9.6,2.5l4.7,1.2l2.5,0.6l-0.3,1.1l-0.6,2.1l-0.4,1l-0.5,2.1l0,1l-1.4,5.5l-0.1,0.1
		l-1.1-0.1l0-0.2l0.2-0.3l0.2-0.2l0.1-0.1l-0.4-1.4l-0.1-0.1l-0.1-0.2l-0.5-0.3l-0.2,0l-1,0.3L92,20.2l-2.4-0.1L89,19.6l0.2-0.6
		l-0.7-0.3l-0.6,0.2L87.4,19l0,0l0,0l-0.2,1l0,0l0.1,0.1L86.3,20l-0.8-0.3l-1.7-3.4l-1.2-2.7l-0.3-2l0-0.2l-0.3-0.1l0-1.7l0.1,0
		L83,9.1l0-0.1l-0.2-2.5l-0.1-0.5L82.4,5.2	"
        >
          <title id="t2951">Okanogan, WA</title>
        </path>
        <path
          id="FIPS_53073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M82.4,5.2l0.2,0.7l0.1,0.5L83,8.9l0,0.1l-0.8,0.6l-0.1,0l-0.9-0.2l-0.5,0l-2.8-0.8l-7.2-2.1
		l-2.9-0.8l-0.2,0l0-0.9l-0.8-1.2L66,2.1l-0.1-0.7l0,0l0.1-0.1L66.2,1l0.2-0.1l0.2-0.1l2.9,0.8L72,2.4l2.9,0.9l5.2,1.4L82.4,5.2z
		 M63.8,0L63.8,0l0.5,0.1l0,0.3l-0.1,0l-0.5-0.2L63.8,0z	"
        >
          <title id="t2952">Whatcom, WA</title>
        </path>
        <path
          id="FIPS_53069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M48.6,31.7l0.4-1.2l1.9,0.6l1.2,0.4l1.2,0.3l-0.7,2.6l-1.4-0.1l-0.1,0l-0.4-0.6l0.2-0.6
		l-0.1-0.3l-0.1-0.2l0-0.1l0,0l0,0l-0.6,0L48.6,31.7z	"
        >
          <title id="t2953">Wahkiakum, WA</title>
        </path>
        <path
          id="FIPS_53003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M105.4,44.4l1.5,0.8l-0.2,0.6l0.3,1.1l0,0l0.1,0.7l0.1,1.1l-0.4,1.2l0.1,0.9l-4.9-1.2l0.4-1.6
		l0.5,0.1l0.6-2.6l0.2-0.7l0.2-0.1l0.4-0.1l1.1,0.3L105.4,44.4z	"
        >
          <title id="t2954">Asotin, WA</title>
        </path>
        <path
          id="FIPS_53023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M100.4,41.1l1.1-0.6l0.1,0l0.5,0l0.2,0.1l1.3,0.5l0.4,0.3l0.4,0.4l0.9,1.6l0.1,0.5l-0.1,0.5
		l-0.1,0.6l-1.1-0.3l-0.4,0.1l-0.2,0.1l-0.2,0.7l-0.6,2.6l-0.5-0.1l-0.4,1.6l-1.1-0.3l0.4-1.5l0.6-2.7l-0.7-1.9L99.9,43l0.3-1.1
		L100.4,41.1z	"
        >
          <title id="t2955">Garfield, WA</title>
        </path>
        <path
          id="FIPS_53013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M97.1,40.7L97.1,40.7l0.4,0.6l0.1,0l0.4,0.1l0.1,0l2.2-0.1l0.3-0.2l-0.3,0.8L99.9,43l1.1,0.3
		l0.7,1.9l-0.6,2.7l-0.4,1.5l-3.3-0.8l-0.2,0l0.1-0.4L98,46l-1.1-0.3l-0.8-1.4l0.8-3.3L97.1,40.7z	"
        >
          <title id="t2956">Columbia, WA</title>
        </path>
        <path
          id="FIPS_53071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M97.1,40.7l-0.2,0.4l-0.8,3.3l0.8,1.4L98,46l-0.5,2.2l-0.1,0.4l-8.7-2.1l0.1-2.5l0.1-0.2
		l0.1-0.1l0.4-0.1l0.2,0l0.9,0.1l0.7-0.4l1.1-0.7l0.5-0.4l0.3-0.3l0.3-0.7l0.1-0.1l0.3-0.2l0.5-0.3l0.8-0.4l0,0l1.4,0.2l0.6,0.2
		L97.1,40.7z	"
        >
          <title id="t2957">Walla Walla, WA</title>
        </path>

        <path
          id="FIPS_53075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M102.5,33.2l6.7,1.6l-0.4,1.7l-1.6,7.3l-0.3,1.5l-1.5-0.8l0.1-0.5l-0.1-0.5l-0.9-1.6l-0.4-0.4
		l-0.4-0.3l-1.3-0.5l-0.2-0.1l-0.5,0l-0.1,0l-1.1,0.6l-0.3,0.2L98,41.4l-0.1,0l-0.4-0.1l-0.1,0l-0.3-0.5l0.2-1.9l1.8,0l0.3-0.3
		l0.2-0.3l0.4-0.5l0.2-0.6l1-4.3L102.5,33.2z	"
        >
          <title id="t2959">Whitman, WA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "44060"
              ? `metroArea clickedArea state-wa`
              : `metroArea ${colorCode[44060]} state-wa`
          }
          id="FIPS_44060"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_53063"
            className="FIPS_44060 st0 state-wa"
            d="M108.1,24.1l3.4,0.8l-0.2,0.9l-1.7,7.6l-0.3,1.3l-6.7-1.6l1.7-7l0.1,0.2l0.1,0l1.8,0.6
		l0.4,0.1l0.7-3.1L108.1,24.1z	"
          >
            <title id="t2960">Spokane, WA</title>
          </path>
        </g>
        <path
          id="FIPS_53051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M114.2,13.1l-0.4,1.9l-2.3,10l-3.4-0.8l0.2-1.1l-0.2-1.5l1.2-5.1l-1.1-0.2l0.2-1.1l0.9-1
		l0.6-0.5l0.7-0.3l0.2-1L114.2,13.1z	"
        >
          <title id="t2961">Pend Oreille, WA</title>
        </path>
        <path
          id="FIPS_53065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M110.9,12.3l-0.2,1l-0.7,0.3l-0.6,0.5l-0.9,1l-0.2,1.1l1.1,0.2l-1.2,5.1l0.2,1.5l-0.2,1.1
		l-0.8-0.2l-0.7,3.1l-0.4-0.1l-1.8-0.6l-0.1,0l-0.1-0.2l-1.7-0.2l-0.6-0.1l-0.1-0.3l-0.2-0.7l-0.4-1l0,0l-0.4,0l-0.6,0.2l-0.3,0.1
		l-0.1-1.7l0-0.1l0.1,0l0.4-0.1l0.2,0l1-0.3l1.2-1.8l0.1-0.3l1.4-4.6l0.2-1.3l0-0.4l-0.2-0.9l-0.1-0.1l0-0.5l0.1-0.7l0.1-0.4
		l0.1-0.2l0.2-0.1L110.9,12.3z	"
        >
          <title id="t2962">Stevens, WA</title>
        </path>
        <path
          id="FIPS_53043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M94.8,22.3l1.1,0.1l0.1,0.4l0.1,0.1l0.6,0.4l0.2,0l0-0.1l1.5,0.5l0.2,0.4l0.5,0.5l0.3,0.2
		l0.1,0h0.1l0.1-0.1l0.3-0.6l0.3-0.1l0.6-0.2l0.4,0l0,0l0.4,1l0.2,0.7l0.1,0.3l0.6,0.1l1.7,0.2l-1.7,7l-1.2-0.3l-8.7-2.1L94.8,22.3z
			"
        >
          <title id="t2963">Lincoln, WA</title>
        </path>
        <path
          id="FIPS_53001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M101.4,32.9l-1,4.3l-0.2,0.6l-0.4,0.5l-0.2,0.3l-0.3,0.3l-1.8,0l-4.6-1.1l-3.6-0.9l-1.6-0.4
		l0.6-2.2l1.2,0.3l2.1,0.5l1.1-4.4L101.4,32.9z	"
        >
          <title id="t2964">Adams, WA</title>
        </path>
        <path
          id="FIPS_53025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M94.7,22.1l0,0.2l-2.1,8.5l-1.1,4.4l-2.1-0.5l-1.2-0.3l-0.6,2.2L86.7,37l0,0l0-0.1l-0.2-0.4
		l-0.1-0.1l-0.1-0.1l-0.1,0l-0.4,0.3l-0.3,0.2L85.4,37l-0.2,0.1l-0.2,0l-1.6-0.2L83,36.8l-0.1,0l-0.5-1.6l0.4-0.4l0.2-0.2l0.1-0.2
		l0.1-1.7L83,31.1l0.2-0.7l0.3-0.5l0.2-0.7l0-0.1l0-0.1l0.5-1.2l1.3-1.2l2.9,0.7l2.4-1.8l1.6-2.4l0.2-0.6l1.1-0.7L94.7,22.1z	"
        >
          <title id="t2965">Grant, WA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "28420"
              ? `metroArea clickedArea state-wa`
              : `metroArea ${colorCode[28420]} state-wa`
          }
          id="FIPS_28420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_53005"
            className="FIPS_28420 st0 state-wa"
            d="M82.9,36.7L82.9,36.7l0.4,0.1l1.6,0.2l0.2,0l0.2-0.1l0.3-0.2l0.3-0.2l0.4-0.3l0.1,0l0.1,0.1
		l0.1,0.1l0.2,0.4l0,0.1l0,0l0,0.2l0.2,0.7l0.2,0.5l0.4,0.5l0.3,0.5v0.4l-0.7,2.5l-0.1,0.1l0,0.1l0.4,0.6l0.3,0.2l0.3,0.1l0.2,0.1
		l0.6,0.5l-0.1,2.5l-0.3,0.2l-0.2,0.1L87.6,47l-0.3,0l-0.4,0L86.6,47l-0.2-0.1L85,46.7l-0.5,0l-0.5,0l-1.7,0.2l-0.9-0.1l-0.9-0.1
		l0.9-3.5l0.2-0.8l0-0.4L82.9,36.7z	"
          >
            <title id="t2966">Benton, WA</title>
          </path>
          <path
            id="FIPS_53021"
            className="FIPS_28420 st0 state-wa"
            d="M87.6,36.5l1.6,0.4l3.6,0.9l4.6,1.1l-0.2,1.9l-0.1-0.1L97,40.6l-0.6-0.2L95,40.1l0,0l-0.8,0.4
		l-0.5,0.3L93.4,41l-0.1,0.1L93,41.8l-0.3,0.3l-0.5,0.4l-1.1,0.7l-0.7,0.4l-0.9-0.1l-0.2,0L89,43.7l-0.1,0.1L88.8,44l-0.6-0.5
		L88,43.4l-0.3-0.1l-0.3-0.2l-0.4-0.6l0-0.1l0.1-0.1l0.7-2.5v-0.4l-0.3-0.5l-0.4-0.5l-0.2-0.5l-0.2-0.7l0-0.2L87.6,36.5z	"
          >
            <title id="t2958">Franklin, WA</title>
          </path>
        </g>
        <path
          id="FIPS_53039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M81.1,44.1l-0.7,2.6h-1.2l-1.4,0.2l-0.3,0.1l-0.5,0.4l-1.8-0.1L74.6,47l-0.2-0.1l-0.1-0.2
		l-0.2-0.4l-0.3-0.2L73.5,46l-0.2,0.1l-0.4,0.2l-1,0.1l-0.8,0.1l-0.5,0.1l-0.2-0.3l-3.3-1.5l-0.3-0.1l-0.6-0.1l-0.6-0.5l0.2-0.7
		l-0.8-0.3l0.3-1.2L66,40l0.8,0.2l0.9,0.2l2.4,0.6l0.7,0.2l4.1,1.1L81.1,44.1z	"
        >
          <title id="t2967">Klickitat, WA</title>
        </path>

        <path
          id="FIPS_53015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M61.7,34.2l-1.2,4.1l-0.8,0.3L58.9,39l-0.3-0.1l-0.2-0.2l-0.2-0.1l-0.4-0.1l-1.4,0.3l-1.4,0.7
		l0.1-0.2l0.1-1.2L55,36.7l-0.1-0.3l-1.5-1.8l-0.4-0.2l-0.5,0.1l0.7-2.6l1.1,0.3l0.7,0.2l5.1,1.5L61.7,34.2z	"
        >
          <title id="t2970">Cowlitz, WA</title>
        </path>
        <path
          id="FIPS_53049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.3,24.5l2,0.7l2.1,0.6l2,0.6l-0.6,2.1l-0.2,0.9l-0.2,0.9l-0.4,1.2l-1.2-0.4L49,30.5
		l-0.4,1.2l-1.5,0.2l-0.3-0.2l-1-1.4l0.7-2l0.2,0.5l0.2,0.1l0.1,0l0.5,0l0.6-0.4l0.1-0.2l0.5-1.8l0-0.8l-0.7,0.2l-0.2,0l-0.1-0.1
		l-0.4-0.5l0-0.1l0,0l0-0.1L47.3,24.5z	"
        >
          <title id="t2971">Pacific, WA</title>
        </path>
        <path
          id="FIPS_53041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M53.5,26.4l1.8,0.5l-0.1,0.4l2,0.6l6.2,1.8l1.4,0.7l1.7,0.6l0.1-0.1l0.4-0.2l0.1-0.1l0.2,0
		l2.6,0.7l0.3,0.8l0,0.4l-1,3.6L69,36.2l0,0l-0.1,0l-1-0.3l-6.2-1.7l-1.5-0.5l-5.1-1.5l-0.7-0.2l-1.1-0.3l-1.2-0.3l0.4-1.2l0.2-0.9
		l0.2-0.9L53.5,26.4z	"
        >
          <title id="t2972">Lewis, WA</title>
        </path>
        <path
          id="FIPS_53067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M56,23.2l1.1,0.3l1.9-0.4l0.3-0.1l0.4-0.2l0.6,1.8l0.1,0.8l0.2,0.5l0.9,1.7l0.2,0.4l0.3,0.3
		l0.3,0.1l1.2,1.4l-6.2-1.8l-2-0.6l0.1-0.4L56,23.2z	"
        >
          <title id="t2973">Thurston, WA</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "49420"
              ? `metroArea clickedArea state-wa`
              : `metroArea ${colorCode[49420]} state-wa`
          }
          id="FIPS_49420"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_53077"
            className="FIPS_49420 st0 state-wa"
            d="M71.5,27.6l0.8,0.2l0.2,0.1l0.7,1l0.3,0.5l0,0l0,0.3l0.2,0.7l0.1,0.2l3.4,0.9l0,1.1l0.5,1.3
		l3.1,0.8l1.5,0.4l0.5,1.6l-1.3,5.2l0,0.4l-0.2,0.8l-0.3,1l-6.3-1.6l-4.1-1.1l-0.7-0.2l-2.4-0.6l-0.9-0.2l1.2-4.3l1,0.3l0.1,0l0,0
		l0.1-0.2l1-3.6l0-0.4l-0.3-0.8l0.1-0.1l0,0l0.1-1.5l1.4-1.5L71.5,27.6z	"
          >
            <title id="t2975">Yakima, WA</title>
          </path>
        </g>
        <path
          id="FIPS_53037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M71.5,27.6l0-0.6l0.2-3l0-0.2l1.1-0.9l1.7-1l1-0.1l0.4,1l0.7,1.3l0.7,0.5l0.7,0.6l1.6,1.3
		l0.5,0.6l0.2,0.3l0.2,0.2l2.5,0.6l0.6,0.7l0,0.1l0,0.1L83.5,30l-0.3,0.5l-0.2,0.7l0.2,1.5l-0.1,1.7L83,34.5l-0.2,0.2l-0.4,0.4
		l-1.5-0.4L77.8,34l-0.5-1.3l0-1.1L74,30.6l-0.1-0.2l-0.2-0.7l0-0.3l0,0l-0.3-0.5l-0.7-1l-0.2-0.1L71.5,27.6z	"
        >
          <title id="t2976">Kittitas, WA</title>
        </path>
        <path
          id="FIPS_53017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M94.7,22.1l-1-0.3l-1.1,0.7l-0.2,0.6l-1.6,2.4l-2.4,1.8l-2.9-0.7l-1.3,1.2l-0.5,1.2l-0.6-0.7
		l0.1-0.2l0.1-0.3l0.1-0.4l0-0.1L83.1,27l-0.9-0.4l-0.1-0.1l-0.2-0.2l0-0.1l0-0.4v-0.3l0.1-0.2l0.3-0.6l1.4-2.5l0.1-0.1l0.1-0.1
		l0.1,0l0.6-0.1l0.1,0l0.1,0.1l0,0.1l0.1,0l0.8,0l1-1l0.6-0.7v-0.1l0-0.2l-0.1-0.1l0,0l0.2-1l0,0l0,0l0.4-0.1l0.6-0.2l0.7,0.3
		L89,19.6l0.6,0.5l2.4,0.1l0.9-0.5l1-0.3l0.2,0l0.5,0.3l0.1,0.2l0.1,0.1l0.4,1.4l-0.1,0.1L95,21.8L94.7,22.1z	"
        >
          <title id="t2977">Douglas, WA</title>
        </path>
        <path
          id="FIPS_53019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M99.1,9.5l5.3,1.3l-0.2,0.1l-0.1,0.2l-0.1,0.4l-0.1,0.7l0,0.5l0.1,0.1l0.2,0.9l0,0.4l-0.2,1.3
		l-1.4,4.6l-0.1,0.3l-1.2,1.8l-1,0.3l-0.2,0l-0.4,0.1l-0.1,0l0,0.1l0.1,1.7l-0.3,0.6L99.6,25h-0.1l-0.1,0L99,24.7l-0.5-0.5l-0.2-0.4
		l-1.5-0.5l0,0.1l-0.2,0L96,22.9L96,22.8l-0.1-0.4l0.1-0.1l1.4-5.5l0-1l0.5-2.1l0.4-1l0.6-2.1L99.1,9.5	"
        >
          <title id="t2978">Ferry, WA</title>
        </path>
        <path
          id="FIPS_53055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M63.3,7.5l0.1-0.5l0.2-0.4l0.2-0.3l0.4,0l0.7,0l-0.1,0.3l0,0.1l-0.5,0.9l-0.1,0.1l-0.5-0.1
		l-0.1,0L63.3,7.5z M62.4,4.6l0,0.7L62.6,6l0.2,0.7l-0.3,0.2l-0.2-0.2l-0.6-0.6L61.6,6l0-0.1l0-0.2l-0.1-0.8l0-0.1l0.1-0.1l0.2-0.1
		l0.2,0L62.4,4.6z M65.1,5.2L65.1,5.2l-0.3,0.1l0,0l0,0.2l0,0.1l0,0.1L63.2,6L63,5.5l-0.1-0.6V4.7l0.3-0.2L64,4l0.2,0l0.2,0l0.1,0.1
		l0.3,0.3L65.5,5l0,0l-0.1,0.1L65.1,5.2z	"
        >
          <title id="t2979">San Juan, WA</title>
        </path>
        <path
          id="FIPS_53029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M65.6,8.5L65.6,8.5l0.1-0.1l0.1,0l0,0.1l0.1,0.2l0.3,1.1l0,0.1l0,0.1l0,0L66,10.1l-0.1,0
		l-0.2,0l-0.1,0l-0.1-0.2l-0.1-0.1l-0.1,0l-0.2,0l-0.1,0l-0.3,0.2l-0.2,0.3l-0.1,0.2l0.6,1.5l0.2,0.4l0.1,0l0.2,0.1l0.6,0.9l0.2,0.6
		l-0.1,0.4l-0.1,0.3L65.8,15l-0.3,0l-0.8-1.6l-0.2-0.8l-0.2-0.6l-0.5-1.3L64,9.9l1.2-1.5h0.2L65.6,8.5z	"
        >
          <title id="t2980">Island, WA</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "42660"
              ? `metroArea clickedArea state-wa`
              : `metroArea ${colorCode[42660]} state-wa`
          }
          id="FIPS_42660"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_53033"
            className="FIPS_42660 st0 state-wa"
            d="M76.1,19.7l0.2,0.6l-0.1,0.2l-0.5,0.5l0,0.1l0,0.2l-0.1,0.8l-1,0.1l-1.7,1l-1.1,0.9l0,0.2
		l-0.2,3l0,0.6l-0.3-0.1l-1-0.7l-0.6-0.6l-1.2-0.6l-0.1,0l-0.1,0l-0.1,0l-0.3,0.1l0,0l-1-0.4L66.1,25L64,23.2l-0.5-0.9l0.8-0.1
		l0.1-0.1l0.1-0.5l0-0.1l0-1.1l0.4-2.7l0.4-1.1l2.7,0.8l4.1,1.1l1.1,0.3l0.3,0.1L76.1,19.7z	"
          >
            <title id="t2982">King, WA</title>
          </path>
          <path
            id="FIPS_53053"
            className="FIPS_42660 st0 state-wa"
            d="M60.5,20.3l2.4,0.7l-0.3,0.5l0.8,0.7l0.5,0.9l2.1,1.8l0.7,0.4l1,0.4l0,0l0.3-0.1l0.1,0l0.1,0
		l0.1,0l1.2,0.6l0.6,0.6l1,0.7l0.3,0.1L71.4,28L70,29.5L70,31.1l0,0l-0.1,0.1l-2.6-0.7l-0.2,0L67,30.6l-0.4,0.2L66.4,31l-1.7-0.6
		l-1.4-0.7l-1.2-1.4l-0.3-0.1l-0.3-0.3l-0.2-0.4l-0.9-1.7l-0.2-0.5l-0.1-0.8l-0.6-1.8l0-0.8l0-0.1l0.1-0.2l0.1-0.1l0.2-0.1l0.2-0.1
		l0.1-0.2l0.1-0.4L60.5,20.3z	"
          >
            <title id="t2974">Pierce, WA</title>
          </path>
          <path
            id="FIPS_53061"
            className="FIPS_42660 st0 state-wa"
            d="M67.3,10.3l4.5,1.3l2.2,0.6l0.6,0.2l4.2,1.1l0.1,1.2l-0.1,0.7L78.6,16l-0.7,0.2l-0.1,0
		l-0.6,0.1l-0.4,0.1l-0.7,1.3L76,18.8l0.1,0.9L73.5,19l-0.3-0.1l-1.1-0.3L68,17.5l-2.7-0.8l0,0l0.1-0.3l1.2-1.6l0.3,0l0.3,0l0.2-0.1
		l0-0.1l0.1-0.5l0-0.2l-0.3-0.4l-0.4-0.7l-0.1-0.4l0,0l0.1-0.3l0.1-0.3l-0.1-0.7v-0.3L67.3,10.3z	"
          >
            <title id="t2981">Snohomish, WA</title>
          </path>
        </g>
        <path
          id="FIPS_53035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M62.2,16.3l1.6-1.1l0.4-0.8l0.4,0.1l0.1,0.2l0,0.3l-0.2,1.2l-0.7,2.4l-0.2,1L62.9,21l-2.4-0.7
		l0.4-1.4l-1.3-0.4l-0.4-0.1L59,18.3l0.1-0.1l0.7-0.6l0.1,0l0.2,0L62.2,16.3z	"
        >
          <title id="t2983">Kitsap, WA</title>
        </path>
        <path
          id="FIPS_53045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M55,17.2l0.3-1.1l4.7,1.4l-0.2,0l-0.1,0l-0.7,0.6L59,18.3l0.4,0.1l0.4,0.1l1.3,0.4l-0.6,2
		l-0.1,0.4l-0.1,0.2l-0.2,0.1l-0.2,0.1l-0.1,0.1L59.6,22l0,0.1l0,0.8l-0.4,0.2L59,23.2l-1.9,0.4L56,23.2l-2.4-0.7l0,0l0.5-2.2
		L55,17.2z	"
        >
          <title id="t2984">Mason, WA</title>
        </path>
        <path
          id="FIPS_53027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.9,14.8l1.9,0.6l0.6,0.4l4.6,1.4l-1,3.2l-0.5,2.2l0,0l2.4,0.7l-0.7,3.7l-1.8-0.5l-2-0.6
		l-2.1-0.6l-2-0.7l0.1-1.1l0.3-0.2l0.4,0.2l1.6-0.1l0.2,0l0,0l-0.1-0.2l-1-1.2l-0.3-0.2l-0.3-0.1l-0.6-4.4l0-0.2l0.1-0.6L47.9,14.8z
			"
        >
          <title id="t2985">Grays Harbor, WA</title>
        </path>
        <path
          id="FIPS_53031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.1,9.9l1.4,0.4l0.5,0.2l2.1,0.6l3.1,0.9l1.3,0.5l0.6,0.3l4.7,1.4l0.8-2.8l1.1-0.2l0.4,0
		l0.2,0.1L64,12l-0.4,2.4l-1.2,1.2l-0.2,0.5l0,0.1l0,0.1L60,17.5l-4.7-1.4L55,17.2l-4.6-1.4l-0.6-0.4l-1.9-0.6l0-0.2l0.1-0.5l0-0.6
		l0-1.4l0-0.1l-0.2-1l0-0.1l-0.4-0.7l0,0l0,0L47.3,10L47.1,9.9z	"
        >
          <title id="t2986">Jefferson, WA</title>
        </path>
        <path
          id="FIPS_53009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M47.1,9.9L47,9.6l0-1.1l0.2-2.2L48,3.5l0.1,0l0.1,0l0.5,0.2L49,3.8l0.3,0.2l0.3,0.3l0.1,0.1
		l0.6,0.8l2.6,2.4L53.4,8l0.9,0.4l3.6,1.6l1.8,0.4l1.2,0.4l0.9,0.6L61,14.3l-4.7-1.4l-0.6-0.3l-1.3-0.5l-3.1-0.9L49,10.5l-0.5-0.2
		L47.1,9.9z	"
        >
          <title id="t2987">Clallam, WA</title>
        </path>
        <path
          id="FIPS_53057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M82.1,9.7l0,1.7l-1.3-0.5l-0.8,0l-1,0.3l-0.1,0.1l-0.1,0.2L78.3,13l0.4,0.5l-4.2-1.1L74,12.2
		l-2.2-0.6l-4.5-1.3l-0.2-0.4L66.8,8L67.1,8l0,0l0.8-1.5l-0.1-0.3l-0.2-0.3l0.2,0l2.9,0.8l7.2,2.1l2.8,0.8l0.5,0L82.1,9.7z	"
        >
          <title id="t2988">Skagit, WA</title>
        </path>
        <path
          id="FIPS_53007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M82.1,11.3l0.3,0.1l0,0.2l0.3,2l1.2,2.7l1.7,3.4l0.8,0.3l0.9,0.2l0,0.2v0.1l-0.6,0.7l-1,1
		l-0.8,0l-0.1,0l0-0.1L84.5,22l-0.1,0L83.9,22l-0.1,0l-0.1,0.1l-0.1,0.1l-1.4,2.5l-0.3,0.6l-0.1,0.2v0.3l0,0.4l0,0.1l0.2,0.2
		l0.1,0.1l0.9,0.4l0.3,0.4l0,0.1l-0.1,0.4l-0.1,0.3l-0.1,0.2l-2.5-0.6l-0.2-0.2l-0.2-0.3l-0.5-0.6l-1.6-1.3l-0.7-0.6l-0.7-0.5
		L76,22.9l-0.4-1l0.1-0.8l0-0.2l0-0.1l0.5-0.5l0.1-0.2l-0.2-0.6L76,18.8l0.1-1.1l0.7-1.3l0.4-0.1l0.6-0.1l0.1,0l0.7-0.2l0.2-0.5
		l0.1-0.7l-0.1-1.2L78.3,13l0.5-1.6l0.1-0.2l0.1-0.1l1-0.3l0.8,0L82.1,11.3z	"
        >
          <title id="t2989">Chelan, WA</title>
        </path>
        <path
          id="FIPS_55029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M369.2,85.2l0.1-0.6l0.7-1.2l0.2-0.3l2.4-2.8l1.7-3l0.5-0.4l0.3-0.2l0.2,0l0.1,0l0.1,0.1
		l0.1,0.2l0,0.4l0,0.2l-0.5,1.8l-0.3,0.4l-0.8,1.8l-1.2,2.8l-0.2,0.6L369.2,85.2z	"
        >
          <title id="t2990">Door, WI</title>
        </path>

        <path
          id="FIPS_55091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329,87.7l4.4-0.2l0.1,1.1l-3.2,0.1l-0.2,0.1l-0.1,0.1l-0.1,0.2l-0.3,1.7l0,0.4l-1.5-0.6
		l-0.7-1.1L329,87.7z	"
        >
          <title id="t2993">Pepin, WI</title>
        </path>
        <path
          id="FIPS_55011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M334.6,88.6l0.2,4.5l-0.1,1.8l-0.1,1.1l-2.9-2.1l-2.2-2.7l0-0.4l0.3-1.7l0.1-0.2l0.1-0.1
		l0.2-0.1l3.2-0.1L334.6,88.6z	"
        >
          <title id="t2994">Buffalo, WI</title>
        </path>
        <path
          id="FIPS_55121"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.9,88.4l0.2,4.5l0.1,0l0.1,2.2L338,95l-1.1,0.3l-0.3,0.4l0,0l0,0.2l0.1,0.1l0.1,0.1
		l0.1,0.1v0.1l-0.9,0l-1.3-0.5l0.1-1.1l0.1-1.8l-0.2-4.5L337.9,88.4z	"
        >
          <title id="t2995">Trempealeau, WI</title>
        </path>
        <path
          id="FIPS_55053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M337.9,88.4l2.2-0.1l0.1,1.1l1.2,1.1l3.4-0.2l1.1-0.1l0.2,2.3l0.1,1.2h-1.2l-3.2,0.2l-1,0.1
		l-0.4,0.2l-0.2,0.2l0.1,0.8l-1.7,0l-0.1-2.2l-0.1,0L337.9,88.4z	"
        >
          <title id="t2996">Jackson, WI</title>
        </path>
        <path
          id="FIPS_55035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M339.9,84.9l0.2,3.4l-2.2,0.1l-3.3,0.2l-1.1,0l-0.1-1.1l-0.1-2.2L339.9,84.9z	"
        >
          <title id="t2997">Eau Claire, WI</title>
        </path>
        <path
          id="FIPS_55019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M339.8,82.7l5.5-0.3l0.3,4.5l0.2,3.4l-1.1,0.1l-3.4,0.2l-1.2-1.1l-0.1-1.1l-0.2-3.4
		L339.8,82.7z	"
        >
          <title id="t2998">Clark, WI</title>
        </path>
        <path
          id="FIPS_55017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M334,79.6l5.6-0.3l0.3,5.6l-6.7,0.3l-0.3-4.5L334,79.6z	"
        >
          <title id="t2999">Chippewa, WI</title>
        </path>
        <path
          id="FIPS_55033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M332.9,80.7l0.3,4.5l0.1,2.2l-4.4,0.2l-0.1-2.2l-0.4-4.5L332.9,80.7z	"
        >
          <title id="t3000">Dunn, WI</title>
        </path>

        <path
          id="FIPS_55095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.3,75.3l0.2,5.5l-5.5,0.2l0.1-1.1l0.1-0.1l0,0l0.2-0.3l0.3-0.9l-0.2-0.9l-0.4-0.8
		l-0.7-0.4l-0.2,0l-0.4-0.1l-0.1-0.1l0-0.3l0-0.3l0-0.1l0-0.2l3.2-0.1l0-1.1l3.4-0.1L328.3,75.3z	"
        >
          <title id="t3002">Polk, WI</title>
        </path>
        <path
          id="FIPS_55005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M329.4,75.3l4.4-0.2l0.2,4.4l-1.1,1.1l-4.5,0.2l-0.2-5.5L329.4,75.3z	"
        >
          <title id="t3003">Barron, WI</title>
        </path>
        <path
          id="FIPS_55107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M341.6,74.7l0.2,3.4l-2.2,1.2l-5.6,0.3l-0.2-4.4L341.6,74.7z	"
        >
          <title id="t3004">Rusk, WI</title>
        </path>
        <path
          id="FIPS_55119"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.6,77.7l0.2,3.4l-0.9,0.1l-0.5,0.4l0,0.7l-1.1,0.1l-5.5,0.3l-0.2-3.4l2.2-1.2l2-0.1
		l1.2-0.1l1.8-0.1L347.6,77.7z	"
        >
          <title id="t3005">Taylor, WI</title>
        </path>
        <path
          id="FIPS_55099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M344.7,70.1l2.3-0.1l0.1,1.1l0.3,4.4l0.1,2.2l-0.8,0l-1.8,0.1l-1.2,0.1l-2,0.1l-0.2-3.4
		l-0.2-4.4L344.7,70.1z	"
        >
          <title id="t3006">Price, WI</title>
        </path>
        <path
          id="FIPS_55113"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M333.4,68.5l5.6-0.3l0.1,2.1l0,0.2l2.2-0.1l0.2,4.4l-7.8,0.4L333.4,68.5z	"
        >
          <title id="t3007">Sawyer, WI</title>
        </path>
        <path
          id="FIPS_55129"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M328.9,68.6l4.5-0.2l0.4,6.7l-4.4,0.2l-0.2-4.4l-0.2,0L328.9,68.6z	"
        >
          <title id="t3008">Washburn, WI</title>
        </path>
        <path
          id="FIPS_55013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.8,68.7l2.2-0.1l0.1,2.2l0.2,0l0.2,4.4l-1.1,0l0-1.1l-3.4,0.1l0,1.1l-3.2,0.1l0.4-1.1
		l0.9-1.8l0.1-0.2l0.1-0.1l0.4-0.4l0,0l1.9-1.2l1.3-0.8l0-0.5L326.8,68.7z	"
        >
          <title id="t3009">Burnett, WI</title>
        </path>
        <path
          id="FIPS_55031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M326.5,62.2l0.2,0.1l0.2,0l0.3,0l0,0l0,0l0.1-0.3l0-0.1l0,0l0,0v0l0-0.1l0-0.1l0-0.1l0.6-0.4
		l0.2,0l0.5,0.5l0.1,0.1l0,0l0.2,0.2l0.1,0.1l0.1,0l0.2,0l1.1-0.2l0.3-0.1l2.1-0.9l0.1,3.1l0.1,1.1l0.2,3.5l-4.5,0.2l-2.2,0.1
		l-0.1-3.3L326.5,62.2z	"
        >
          <title id="t3010">Douglas, WI</title>
        </path>
        <path
          id="FIPS_55007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.7,62.7l0.3,5.5l-5.6,0.3l-0.2-3.5l-0.1-1.1l-0.1-3.1l0.1,0l0.2,0l3.5-1.5l0.1-0.1
		l0.4-0.3l0.1-0.1l0.3-0.4l0.3-0.3l0,0l0.9-0.3l0.1,0l0.2,0.1l0.5,0.4l0.3,0.3l0,0.1v0.1l-0.4,0.9l-0.6,0.8l-0.6,2.1l0,0l0.1,0.1
		L338.7,62.7z	"
        >
          <title id="t3011">Bayfield, WI</title>
        </path>
        <path
          id="FIPS_55003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.7,62.7L338.7,62.7l0.2,0l0,0l1-0.6l0.2-0.2l0.1-0.1l1.1,0.2l0.7,0.5l0.1,1.1l0.1,1.8
		l0.1,1.5l1.1-0.1l1.2,1l0.1,1.1l0,1.1l-3.4,0.2l-2.2,0.1l0-0.2l-0.1-2.1L338.7,62.7z	"
        >
          <title id="t3012">Ashland, WI</title>
        </path>
        <path
          id="FIPS_55051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.3,62.7l1,0.6l1.8,2.2l0.8,0.2l0.9,0.2l0.3,4.1l-1,0.1l-2.3,0.1l0-1.1l-0.1-1.1l-1.2-1
		l-1.1,0.1l-0.1-1.5l-0.1-1.8l-0.1-1.1L343.3,62.7z	"
        >
          <title id="t3013">Iron, WI</title>
        </path>
        <path
          id="FIPS_55125"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.8,65.8l6.5,1.3l0.5,0.1l0.4,0.1l0.6,0.2l0.6,0.3l0.5,0.3l0.1,1.2l-1,0.1l0.1,1.1L355,71
		l-1.7-0.4l-6.1,0.4l-0.1-1.1l1-0.1L347.8,65.8z	"
        >
          <title id="t3014">Vilas, WI</title>
        </path>
        <path
          id="FIPS_55085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.1,70.5l0.4,5.5l-3.4,0.2l-0.1-1.1l-2.2,0.1l-3.3,0.2l-0.3-4.4l6.1-0.4L355,71L356.1,70.5
		z	"
        >
          <title id="t3015">Oneida, WI</title>
        </path>
        <path
          id="FIPS_55069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.1,76.2l0.3,4.5l-5.6,0.4l-0.2-3.4l-0.1-2.2l3.3-0.2l2.2-0.1L353.1,76.2z	"
        >
          <title id="t3016">Lincoln, WI</title>
        </path>
        <path
          id="FIPS_55067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M353.1,76.2l3.4-0.2l1.1-0.1l0.1,1.1l2.2-0.2l0.1,2.2l0.4,0l0.1,1.1l-3.1,0.2l0.1,1.1
		l-2.2,0.2l-1.9-1L353.1,76.2z	"
        >
          <title id="t3017">Langlade, WI</title>
        </path>
        <path
          id="FIPS_55073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M347.8,81.1l5.6-0.4l1.9,1l0.3,4.5l-5.7,0.3l-4.3,0.3l-0.3-4.5l1.1-0.1l0-0.7l0.5-0.4
		L347.8,81.1z	"
        >
          <title id="t3018">Marathon, WI</title>
        </path>
        <path
          id="FIPS_55141"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M345.6,86.8l4.3-0.3l0.2,2.2l1.1-0.1l0.1,1.8l0.1,1.6l-1.6,0.1l-3.8,0.2l-0.2-2.3L345.6,86.8z
			"
        >
          <title id="t3019">Wood, WI</title>
        </path>
        <path
          id="FIPS_55001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M352.6,92.1l0.2,3.4l0.3,4.4l-1.7,0.1l-1-1.9l-0.8-0.9l-0.2-0.6l-0.6-2.3l0.1-0.4l0.9-1.7
		l1.6-0.1L352.6,92.1z	"
        >
          <title id="t3020">Adams, WI</title>
        </path>
        <path
          id="FIPS_55057"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346,92.4l3.8-0.2l-0.9,1.7l-0.1,0.4l0.6,2.3l0.2,0.6l0.8,0.9l1,1.9l-4.9,0.3l-0.1-1.2
		l-0.3-5.5L346,92.4z	"
        >
          <title id="t3021">Juneau, WI</title>
        </path>
        <path
          id="FIPS_55081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M340,95.1l-0.1-0.8l0.2-0.2l0.4-0.2l1-0.1l3.2-0.2h1.2l0.3,5.5l-5.6,0.4l-0.1-2.6l-0.1-1.8
		L340,95.1z	"
        >
          <title id="t3022">Monroe, WI</title>
        </path>
        <path
          id="FIPS_55063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.4,95.1l1.7,0l0.6,0l0.1,1.8l0.1,2.6l-3.3,0.2l-0.2-1.6l-1.3-1.7l0.9,0v-0.1l-0.1-0.1
		l-0.1-0.1l-0.1-0.1l0-0.2l0,0l0.3-0.4L338,95L338.4,95.1z	"
        >
          <title id="t3023">La Crosse, WI</title>
        </path>
        <path
          id="FIPS_55123"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.4,99.1l0.1,1.2l0.1,1.1l-3.4,0.2l0.1,1.7l-5,0.3l-0.2-1l-0.6-2.9l3.3-0.2L346.4,99.1z	"
        >
          <title id="t3024">Vernon, WI</title>
        </path>
        <path
          id="FIPS_55111"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.5,100.3l4.9-0.3l0.5,0.5l1.3,0.4l0.1,0.1l0.1,2.3l-0.2,0.2l-0.2,0.1l-0.1,0l-0.1,0
		l-0.1,0l-0.4,0.6l0,0.2l0.1,0.1l-1,1.2l-3.3,0.7l0,0l-0.3-5l-1.1,0.1L346.5,100.3z	"
        >
          <title id="t3025">Sauk, WI</title>
        </path>
        <path
          id="FIPS_55103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346.5,101.4l1.1-0.1l0.3,5l0,0l-2.2-0.3l-2.2,0.5l-0.2-3.2l-0.1-1.7L346.5,101.4z	"
        >
          <title id="t3026">Richland, WI</title>
        </path>
        <path
          id="FIPS_55023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M338.3,103.6l5-0.3l0.2,3.2l-0.7,0.7L340,109l-0.1,0l-0.9,0.1l-0.2-1.2l0.2-1l0.7-1.2l0-0.2
		l-0.3-0.5l-0.2-0.3l-1-0.7L338.3,103.6z	"
        >
          <title id="t3027">Crawford, WI</title>
        </path>

        <path
          id="FIPS_55043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M343.5,106.5l2.2-0.5l0.3,5l0.2,4l-2,0.1l0-0.1l0-0.1l-0.1-0.3l-0.6-1.1l-0.1-0.1l-0.1-0.1
		l-0.5-0.1l-1.2-0.2l-0.5-0.1l-0.3-0.1l-0.8-0.5l-0.1-0.2l-0.9-1.9l-0.2-1l0.9-0.1l0.1,0l2.9-1.8L343.5,106.5z	"
        >
          <title id="t3029">Grant, WI</title>
        </path>
        <path
          id="FIPS_55065"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M346,111.1l5.5-0.4l0.3,4l-5.6,0.3L346,111.1z	"
        >
          <title id="t3030">Lafayette, WI</title>
        </path>
        <path
          id="FIPS_55045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M351.5,110.1l4.4-0.1l0.3,4.5l-0.3,0l-4.1,0.2l-0.3-4L351.5,110.1z	"
        >
          <title id="t3031">Green, WI</title>
        </path>
        <path
          id="FIPS_55077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M356.8,95.2l0.1,1.4l-0.2,0.8l-0.4,0.6l0.1,1.6l-3.3,0.2l-0.3-4.4L356.8,95.2z	"
        >
          <title id="t3032">Marquette, WI</title>
        </path>
        <path
          id="FIPS_55097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M349.9,86.5l5.7-0.3l0.4,5.6l-3.4,0.2l-1.2,0.1l-0.1-1.6l-0.1-1.8l-1.1,0.1L349.9,86.5z	"
        >
          <title id="t3033">Portage, WI</title>
        </path>
        <path
          id="FIPS_55135"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M355.6,86.2l5.7-0.4l0.1,1.1l-1.2,0.1l0.1,1.6l0.2,2.9l-1.4,0.1l-3.1,0.2L355.6,86.2z	"
        >
          <title id="t3034">Waupaca, WI</title>
        </path>
        <path
          id="FIPS_55137"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.1,91.6l0.3,3.3l-2.6,0.2l-4,0.3l-0.2-3.4l3.4-0.2L359.1,91.6z	"
        >
          <title id="t3035">Waushara, WI</title>
        </path>
        <path
          id="FIPS_55047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.4,95l0.1,1.1l0.3,3.4l-1.1,0.1l-1.1,0.1l0-0.2l-1.1,0.1l-0.1-1.6l0.4-0.6l0.2-0.8
		l-0.1-1.4L359.4,95z	"
        >
          <title id="t3036">Green Lake, WI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "31540"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[31540]} state-wi`
          }
          id="FIPS_31540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55021"
            className="FIPS_31540 st0 state-wi"
            d="M356.4,99.6l1.1-0.1l0,0.2l1.1-0.1l0.3,4.5l-0.9,0.1l-2.4,0.2l0-0.2l-3.3,0.2l-0.1-0.1l0-0.2
		l0.4-0.6l0.1,0l0.1,0l0.1,0l0.2-0.1l0.2-0.2l-0.1-2.3l-0.1-0.1l-1.3-0.4l-0.5-0.5l1.7-0.1L356.4,99.6z	"
          >
            <title id="t3037">Columbia, WI</title>
          </path>
          <path
            id="FIPS_55025"
            className="FIPS_31540 st0 state-wi"
            d="M358.9,104.1l0.1,1.1l0.3,4.5L356,110l-4.4,0.1l-0.3-4.5l1-1.2l3.3-0.2l0,0.2l2.4-0.2
		L358.9,104.1z	"
          >
            <title id="t3038">Dane, WI</title>
          </path>
          <path
            id="FIPS_55049"
            className="FIPS_31540 st0 state-wi"
            d="M351.2,105.6l0.3,4.5l0,0.6l-5.5,0.4l-0.3-5l2.2,0.3L351.2,105.6z	"
          >
            <title id="t3028">Iowa, WI</title>
          </path>
        </g>

        <path
          id="FIPS_55105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M361.5,109.6l0.4,4.5l-1.5,0.1l-4,0.2L356,110l3.3-0.3L361.5,109.6z	"
        >
          <title id="t3039">Rock, WI</title>
        </path>

        <path
          id="FIPS_55101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M368.2,109.1l2.3-0.2l0.4,2.2l-1.9,0.1l-1.7,0.1l0.1,0.8l-1.1,0.1l-0.2-3L368.2,109.1z	"
        >
          <title id="t3041">Racine, WI</title>
        </path>
        <path
          id="FIPS_55127"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M363.7,109.4l2.2-0.2l0.2,3l0.1,1.5l-3.8,0.3l-0.7,0l-0.4-4.5L363.7,109.4z	"
        >
          <title id="t3042">Walworth, WI</title>
        </path>
        <path
          id="FIPS_55027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.7,99.5l1.1-0.1l3.4-0.2l0.1,0.8l0,0.3l0.2,2.2l-0.2,0l0.2,2.3l-1.1,0.1l-4.4,0.3
		l-0.1-1.1l-0.3-4.5L359.7,99.5z	"
        >
          <title id="t3043">Dodge, WI</title>
        </path>
        <path
          id="FIPS_55055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359,105.2l4.4-0.3l0.3,4.6l-2.2,0.2l-2.2,0.1L359,105.2z	"
        >
          <title id="t3044">Jefferson, WI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "33340"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[33340]} state-wi`
          }
          id="FIPS_33340"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55079"
            className="FIPS_33340 st0 state-wi"
            d="M369.5,104.4l1,4.4l-2.3,0.2l-0.3-4.5L369.5,104.4z	"
          >
            <title id="t3046">Milwaukee, WI</title>
          </path>
          <path
            id="FIPS_55089"
            className="FIPS_33340 st0 state-wi"
            d="M367.7,100l2.3-0.2l0.1,0.6l-0.1,0.4l-0.2,0.4l-0.2,0.4l-0.1,0.2l-0.1,0.2l0,0.1l-0.2,1.6
		l0,0.2l0.2,0.5l0,0.1l-1.6,0.1l-0.2-2.3l0.1-1L367.7,100z	"
          >
            <title id="t3047">Ozaukee, WI</title>
          </path>
          <path
            id="FIPS_55131"
            className="FIPS_33340 st0 state-wi"
            d="M366.6,100.1l1.1-0.1l0.1,1.3l-0.1,1l0.2,2.3l-3.3,0.2l-0.2-2.3l0.2,0l-0.2-2.2L366.6,100.1z	
		"
          >
            <title id="t3048">Washington, WI</title>
          </path>
          <path
            id="FIPS_55133"
            className="FIPS_33340 st0 state-wi"
            d="M367.8,104.6l0.3,4.5l-2.2,0.2l-2.2,0.2l-0.3-4.6l1.1-0.1L367.8,104.6z	"
          >
            <title id="t3045">Waukesha, WI</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "36780"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[36780]} state-wi`
          }
          id="FIPS_36780"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55139"
            className="FIPS_36780 st0 state-wi"
            d="M363.6,91.3l0.4,4.5l-4.5,0.3l-0.1-1.1l-0.3-3.3l1.4-0.1L363.6,91.3z	"
          >
            <title id="t3049">Winnebago, WI</title>
          </path>
        </g>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "22540"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[22540]} state-wi`
          }
          id="FIPS_22540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55039"
            className="FIPS_22540 st0 state-wi"
            d="M366.2,95.6l0.4,4.5l-2.2,0.2l0-0.3l-0.1-0.8l-3.4,0.2l-1.1,0.1l-0.3-3.4l4.5-0.3l0-0.6
		L366.2,95.6z	"
          >
            <title id="t3050">Fond du Lac, WI</title>
          </path>
        </g>
        <path
          id="FIPS_55117"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M370.2,95.3l0.4,1.6l0.1,1l0,0.1l-0.7,1.8l-2.3,0.2l-1.1,0.1l-0.4-4.5l1.1-0.1L370.2,95.3z	"
        >
          <title id="t3051">Sheboygan, WI</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "11540"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[11540]} state-wi`
          }
          id="FIPS_11540"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55015"
            className="FIPS_11540 st0 state-wi"
            d="M365.5,91.1l1.4-0.1l0.4,4.5l-1.1,0.1l-2.3-0.4l-0.3-3.9L365.5,91.1z	"
          >
            <title id="t3052">Calumet, WI</title>
          </path>
          <path
            id="FIPS_55087"
            className="FIPS_11540 st0 state-wi"
            d="M361.4,87l3.3-0.2l0.5-0.1l0.3,3.7l0,0.7l-1.9,0.1l-3.1,0.3l-0.2-2.9l-0.1-1.6L361.4,87z	"
          >
            <title id="t3055">Outagamie, WI</title>
          </path>
        </g>
        <path
          id="FIPS_55071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M369.4,89.7l2.1-0.2l0.4,1.2l0,0.2l0,0.2l0,0.2l-0.2,0.3l-0.2,0.2l-0.3,0.2l-0.2,0.1l-0.2,0.2
		l-0.2,1.1l-0.1,0.4l-0.2,1.3l-2.9,0.3l-0.4-4.5l1.4-0.1l-0.1-1.1l0.6,0L369.4,89.7z	"
        >
          <title id="t3053">Manitowoc, WI</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "24580"
              ? `metroArea clickedArea state-wi`
              : `metroArea ${colorCode[24580]} state-wi`
          }
          id="FIPS_24580"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_55009"
            className="FIPS_24580 st0 state-wi"
            d="M364.6,85.5l2.3-0.2l-0.1,0.2l-0.3,1.2l0,0.1l0.4,0.3l0.3,0.1l0.2,0l0.1-0.1l0.1-0.2l0.1-0.3
		l0-0.1l0-0.1l0,0l0.3-0.3l0.5-0.4l0.4-0.1l0.3,4.1l-0.6,0l-0.6,0l0.1,1.1l-1.4,0.1l-1.4,0.1l0-0.7l-0.3-3.7l-0.5,0.1L364.6,85.5z	"
          >
            <title id="t3054">Brown, WI</title>
          </path>
          <path
            id="FIPS_55083"
            className="FIPS_24580 st0 state-wi"
            d="M362.2,76.7l1.1-0.1l2,3.3l0.1,1.1l1.6,0.3l1.7,0.2l-0.1,0l-0.4,0.2l-0.1,0L368,82l-1.1,2.8
		l0,0.4l0,0.1l-2.3,0.2l-0.2-2.2l-2.2,0.1l-0.1-1.4l-0.1-2l-1.4,0.1l-0.1-1.1l-0.4,0l-0.1-2.2L362.2,76.7z	"
          >
            <title id="t3058">Oconto, WI</title>
          </path>
          <path
            id="FIPS_55061"
            className="FIPS_24580 st0 state-wi"
            d="M369.2,85.2l3.3-0.3l-0.5,1l-0.2,0.7l-0.1,0.5l-0.3,2.4l-2.1,0.2l-0.3-4.1L369.2,85.2z	"
          >
            <title id="t2991">Kewaunee, WI</title>
          </path>
        </g>
        <path
          id="FIPS_55115"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.5,81.6l0.1,1.1l2.2-0.2l0.1,1.1l2.3-0.2l2.2-0.1l0.2,2.2l0.1,1.2l-3.3,0.2l-0.1-1.1
		l-5.7,0.4l-0.3-4.5L357.5,81.6z	"
        >
          <title id="t3056">Shawano, WI</title>
        </path>
        <path
          id="FIPS_55078"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357.5,81.6l-0.1-1.1l3.1-0.2l1.4-0.1l0.1,2l0.1,1.4l-2.3,0.2l-0.1-1.1l-2.2,0.2L357.5,81.6z	
		"
        >
          <title id="t3057">Menominee, WI</title>
        </path>

        <path
          id="FIPS_55041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M357,68.1l2.3,0.6l0.1,0.4l0.2,3.3l2.3-0.2l0.3,4.4l-2.3,0.2l-2.2,0.2l-0.1-1.1l-1.1,0.1
		l-0.4-5.5l-0.1-1.1l1-0.1L357,68.1z	"
        >
          <title id="t3059">Forest, WI</title>
        </path>
        <path
          id="FIPS_55037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M359.2,68.7l0.2,0.3l1.6-0.2l2.6,0.3l0,0l0.2,0l0.3,0.2l0.2,0.1l0.1,0.1l0.3,0.4l0,0l0,0
		l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.2,0.2l0,0l0,0l0.1,0.1l0,0l0.3,0.3l0.1,0l0.1,0l0,0l0.1,0l0.1,0.9l-1.1,0l-2.2,0.1l-2.3,0.2
		l-0.2-3.3L359.2,68.7z	"
        >
          <title id="t3060">Florence, WI</title>
        </path>
        <path
          id="FIPS_55075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M365.1,71.2l2.1,0.6l0.2,0.1l0,0l0,0l0.3,0.3l0.1,2.3l0.8,3.8l0,0l0.1,0.3l0,0.1l0.7,0.8l0,0
		l0.2,0l0.4,0.1l-1.4,1.8l-1.7-0.2l-1.6-0.3l-0.1-1.1l-2-3.3l-1.1,0.1l-0.3-4.4l2.2-0.1l1.1,0L365.1,71.2z	"
        >
          <title id="t3061">Marinette, WI</title>
        </path>

        <path
          id="FIPS_54011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M430.9,157.4l1.8,1.3l0.3,1.3l-1.9,2.2l-2.7-2l1.6-0.6l0.1-0.1l0.1-0.1l0-0.1l0-0.1l0-0.1
		l0-0.9l0,0l0-0.6L430.9,157.4z	"
        >
          <title id="t3064">Cabell, WV</title>
        </path>
        <path
          id="FIPS_54099"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M428.4,160.2l2.7,2l-0.1,0.4l0.3,1.1l0,0.1l0.3,0.4l0.3,0.7l-0.7,1.1l-0.9,1.2l-1-1l0.3-0.5
		v-0.1l0,0l0,0l-1.6-1.5l0,0l-0.2,0l-0.2-0.2v0l-0.1-0.2l0-0.1v0l0.3-1.1l-0.2-2.3L428.4,160.2z	"
        >
          <title id="t3065">Wayne, WV</title>
        </path>
        <path
          id="FIPS_54059"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M431.3,165.9l1.1-0.6l0,0.2l0.7,1.5l0.6,1.1l1.2,1l0.2-0.1l0.3-0.1l0.7-0.1l0.7,0l-0.3,1.5
		l-0.7,0.6l-0.5-0.3l-0.4,0.1l-0.4,0.1l-0.7-0.3h0l-2.1-1.4l-0.4-0.6l0-0.1l0,0l-1-1.4L431.3,165.9z	"
        >
          <title id="t3066">Mingo, WV</title>
        </path>
        <path
          id="FIPS_54045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M434.9,164.3l-0.3,0.3l-0.1,0.2v0.1l0,0.1l1.2,0.3l0.4,0l0.4,0.1l1.4,1.1l0.5,0.4l0.1,0.1
		l-1.2,0.5l-0.1,0.3l0.6,0.4l-0.4,0.3l-0.5,0.3l-0.7,0l-0.7,0.1l-0.3,0.1l-0.2,0.1l-1.2-1l-0.6-1.1l-0.7-1.5l0-0.2L434.9,164.3z	"
        >
          <title id="t3067">Logan, WV</title>
        </path>
        <path
          id="FIPS_54109"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.6,166.9l0.9-0.2l0.6,0l0.4,0.4l1.1,1.5l1.4,1.3l-0.7,1.2l-1.5-0.4l-1.5-0.1l-1.3,0.2
		l-0.9,0l-0.5-0.5l0.3-1.5l0.5-0.3l0.4-0.3l-0.6-0.4l0.1-0.3L438.6,166.9z	"
        >
          <title id="t3068">Wyoming, WV</title>
        </path>
        <path
          id="FIPS_54047"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.5,170.3l0.5,0.5l0.9,0l1.3-0.2l1.5,0.1l1.5,0.4l-0.3,1.2l-0.4,0.8l-0.9,0.8l0,0l-0.4,0.4
		l0,0l-1.2,0.2l-0.7-0.4l-1.1-0.4l-0.1-0.1h0l-0.8-0.7l-0.9-1.2l-0.1-0.2l0-0.1l0.5-0.4l0.1-0.1L436.5,170.3z	"
        >
          <title id="t3069">McDowell, WV</title>
        </path>
        <path
          id="FIPS_54055"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.1,168.6l2.7,1.7l-0.9,1.9l-2.4,1.1l-1.6-1.1l0.3-1.2l0.7-1.2L444.1,168.6z	"
        >
          <title id="t3070">Mercer, WV</title>
        </path>
        <path
          id="FIPS_54063"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448.1,166.1l3.8-0.1l0.9,0.7l-0.6,0.7l-0.3,0.7l0.2,0.4l-1.2,1l-0.3,0.2l-0.5-0.7l-1,0.8
		l-0.1,0.1l-1.3,0.9l-1-0.6l0.6-1.8l0.7-2l0.1-0.2L448.1,166.1z	"
        >
          <title id="t3071">Monroe, WV</title>
        </path>
        <path
          id="FIPS_54089"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.4,164.6l1.7,1.5l0.1,0.2l-0.1,0.2l-0.7,2l-0.6,1.8l0,0l-2.7-1.7l0.1-0.6l0-0.1l0.8-1.1
		l0.3-0.1l0.1,0l0.3,0.1l0.1,0.1v0.1l0.1,0l0.1-0.1l0,0l0-0.1l-0.3-1l-0.4-0.4l-0.1-0.1l-0.1,0L446.4,164.6z	"
        >
          <title id="t3072">Summers, WV</title>
        </path>
        <path
          id="FIPS_54081"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M439.7,164.1l0.8,0.1l1,0.9l0.1,0l2.3,0l1.4,0.3l0.1,0l0.1,0.1l0.4,0.4l0.3,1l0,0.1l0,0
		l-0.1,0.1l-0.1,0V167l-0.1-0.1l-0.3-0.1l-0.1,0l-0.3,0.1l-0.8,1.1l0,0.1l-0.1,0.6l-1.1,1.2l-1.4-1.3l-1.1-1.5l-0.4-0.4l-0.6,0
		L439.7,164.1z	"
        >
          <title id="t3073">Raleigh, WV</title>
        </path>

        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "16620"
              ? `metroArea clickedArea state-wv`
              : `metroArea ${colorCode[16620]} state-wv`
          }
          id="FIPS_16620"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_54005"
            className="FIPS_16620 st0 state-wv"
            d="M439.7,164.1l-0.2,2.6l-0.9,0.2l-0.1-0.1l-0.5-0.4l-1.4-1.1l-0.4-0.1l-0.4,0l-1.2-0.3l0-0.1
		v-0.1l0.1-0.2l0.3-0.3l0.6-2.5l1.1-0.3l0.3-0.1l0.2,0l1.7,1.1l0.7,1.1L439.7,164.1z	"
          >
            <title id="t3074">Boone, WV</title>
          </path>
          <path
            id="FIPS_54015"
            className="FIPS_16620 st0 state-wv"
            d="M442.1,155.5l0.4-0.8l1.8,1.8l0.6,0.1l0.1,0.2l-0.8,1l-2.9,2.4l-0.5-1.4l-0.5-1.2l0.8-0.9
		L442.1,155.5z	"
          >
            <title id="t3081">Clay, WV</title>
          </path>
          <path
            id="FIPS_54039"
            className="FIPS_16620 st0 state-wv"
            d="M436,156.2l1.7-0.1l0.7,0.7l2.5-0.2l0.3,0l-0.8,0.9l0.5,1.2l0.5,1.4l0,0l-0.9,4l-0.8-0.1
		l-0.2-0.5l-0.7-1.1l-1.7-1.1l-0.2,0l-0.3,0.1l-1.1,0.3l-1-1.4l0-1l1.1-2.6L436,156.2z	"
          >
            <title id="t3079">Kanawha, WV</title>
          </path>
          <path
            id="FIPS_54043"
            className="FIPS_16620 st0 state-wv"
            d="M433,160l1.4,0.4l1,1.4l-0.6,2.5l-2.5,1l-1.1,0.6l0.7-1.1l-0.3-0.7l-0.3-0.4l0-0.1l-0.3-1.1
		l0.1-0.4L433,160z	"
          >
            <title id="t3075">Lincoln, WV</title>
          </path>
          <path
            id="FIPS_54079"
            className="FIPS_16620 st0 state-wv"
            d="M436,156.2l-0.5,0.7l-1.1,2.6l0,1l-1.4-0.4l-0.3-1.3l-0.3-1.7l1-0.8l1.8-0.6L436,156.2z	"
          >
            <title id="t3076">Putnam, WV</title>
          </path>
        </g>

        <path
          id="FIPS_54053"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M433.5,153.3L433.5,153.3l0.1,0.2l1.4,1.5l0.3,0.6l-1.8,0.6l-1,0.8l0.3,1.7l-1.8-1.3l0.2,0
		l0.1,0l0,0l0.1,0l0,0l0-0.1l0-0.1l0-0.1l0,0v0l0-0.1l-0.3-1.1l0,0l0.1-2.1l0.2-1.2l0-0.2l0.5-0.8l0.2-0.1l0.2,0h0l0.7,0.4l0.2,0.2
		l0.2,0.4l0,0.1L433.5,153.3z	"
        >
          <title id="t3077">Mason, WV</title>
        </path>
        <path
          id="FIPS_54035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M436.4,150.9l1,1.3l0.4,3.9l-1.7,0.1l-0.9-0.6l-0.3-0.6l-1.4-1.5l-0.1-0.2l0,0l0.3-0.1l1-0.7
		l0-0.1l-0.2-1l-0.1-0.1l-0.2-0.2l-0.1-0.1l-0.1-0.1l0-0.2v-0.1l0.6-0.3L436.4,150.9z	"
        >
          <title id="t3078">Jackson, WV</title>
        </path>

        <path
          id="FIPS_54019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.2,161.7l1.2,2.9l-1.3,0.9l-1.4-0.3l-2.3,0l-0.1,0l-1-0.9l0.9-4l0.8,0.4l0.8,0.3h0.1l0,0
		l0-0.2l0.2-0.2l0.6,0l0.2,0.1l0.3,0.2L445.2,161.7z	"
        >
          <title id="t3080">Fayette, WV</title>
        </path>

        <path
          id="FIPS_54087"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.4,152.2l0.9-0.2l0.8,0.2l0.6-0.3l0.7,0.8l0.1,0.6l0.9,1.9l0.8,0.3l-0.9,1.3l-0.3,0
		l-2.5,0.2l-0.7-0.7L437.4,152.2z	"
        >
          <title id="t3082">Roane, WV</title>
        </path>
        <path
          id="FIPS_54013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.8,150.3l0.3,0.5l0.1,0.1l0.2,1.5l0.4,1.6l-0.4,0.7l-0.4,0.8l-0.8-0.3l-0.9-1.9l-0.1-0.6
		l-0.7-0.8l0.9-1.7L441.8,150.3z	"
        >
          <title id="t3083">Calhoun, WV</title>
        </path>
        <path
          id="FIPS_54105"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M438.9,148.4l1.6,1.8l-0.9,1.7l-0.6,0.3l-0.8-0.2l-0.9,0.2l-1-1.3L438.9,148.4z	"
        >
          <title id="t3084">Wirt, WV</title>
        </path>
        <path
          id="FIPS_54107"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M437.8,146.5l1.4,0.7l-0.4,1.2l-2.5,2.5l-1.8-0.6l-0.2-1.1l0.4-0.9l1.3-1.6l0.6-0.8l0.1-0.1
		l0.1,0l0.1,0l0.3,0.1l0.1,0.1L437.8,146.5z	"
        >
          <title id="t3085">Wood, WV</title>
        </path>
        <path
          id="FIPS_54073"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.4,145.9l-0.7,0.4l-1.3,0.5l-0.1,0.1l0,0.2l0,0.3l-1.4-0.7l2-1.7L441.4,145.9z	"
        >
          <title id="t3086">Pleasants, WV</title>
        </path>
        <path
          id="FIPS_54085"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.4,145.9l1.3,0.5l1.1,2.3l-2,1.6l-1.3-0.1l-1.6-1.8l0.4-1.2l0-0.3l0-0.2l0.1-0.1l1.3-0.5
		L441.4,145.9z	"
        >
          <title id="t3087">Ritchie, WV</title>
        </path>
        <path
          id="FIPS_54021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.8,148.7l0.9,0l1.6,2.3l0,0l-0.1,0l-0.5,0.3l-0.3,0.2l-1.5,1.6l-1,1l-0.4-1.6l-0.2-1.5
		l-0.1-0.1l-0.3-0.5L443.8,148.7z	"
        >
          <title id="t3088">Gilmer, WV</title>
        </path>
        <path
          id="FIPS_54007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.2,151l0.2,0.4l0.1,0.1l0.5-0.1l0.6,0.3l0.4,0.8l0,0.2l0,0.1l-1.5,3l-2.2,0.6l-1.8-1.8
		l0.4-0.7l1-1l1.5-1.6l0.3-0.2l0.5-0.3L446.2,151L446.2,151z	"
        >
          <title id="t3089">Braxton, WV</title>
        </path>
        <path
          id="FIPS_54067"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.6,155.9l-0.2,0.4l0.4,1l0.5,0.7l1.9,0.9l-0.8,1l-1.3,1.6l-0.2,0.2l-1.7,0l-0.8-1.1
		l-0.3-0.2l-0.2-0.1l-0.6,0l-0.2,0.2l0,0.2l0,0H443l-0.8-0.3l-0.8-0.4l0,0l2.9-2.4l0.8-1l-0.1-0.2l-0.6-0.1L446.6,155.9z	"
        >
          <title id="t3090">Nicholas, WV</title>
        </path>
        <path
          id="FIPS_54025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M450.1,159.3l0.2,1.4l1.1,0.7l0.6,0l0.4-0.1l0.6-0.4l1.4-0.3l-0.7,1.6l-1.8,3.7l-3.8,0.1
		l-1.7-1.5l-1.2-2.9l1.7,0l0.2-0.2l1.3-1.6l0.8-1L450.1,159.3z	"
        >
          <title id="t3091">Greenbrier, WV</title>
        </path>
        <path
          id="FIPS_54101"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448,152.8l0.7,0.1l1.2,0.2l1.3,2l-0.3,1.9l-0.7,0.8l-0.2-0.1l0.2,1.5l-0.8-0.4l-1.9-0.9
		l-0.5-0.7l-0.4-1l0.2-0.4L448,152.8z	"
        >
          <title id="t3092">Webster, WV</title>
        </path>
        <path
          id="FIPS_54097"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M448.8,147.9l0.7-0.2l1.8,1.9l0.1,1.4l-0.1,1.3l-1.1,0.2l-0.3,0.7l-1.2-0.2l-0.3-0.5l0-1.4
		l0-0.1l0,0l0.1,0l0.2-0.4l0.2-0.5l-0.1-1.4L448.8,147.9z	"
        >
          <title id="t3093">Upshur, WV</title>
        </path>
        <path
          id="FIPS_54041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445.8,147.6l3,0.3l0,0.6l0.1,1.4l-0.2,0.5l-0.2,0.4l-0.1,0l0,0l0,0.1l0,1.4l0.3,0.5l-0.7-0.1
		l0-0.1l0-0.2l-0.4-0.8l-0.6-0.3l-0.5,0.1l-0.1-0.1l-0.2-0.4l-1.6-2.3L445.8,147.6z	"
        >
          <title id="t3094">Lewis, WV</title>
        </path>
        <path
          id="FIPS_54017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M445,144l0.8,0.2l0,3.4l-1.1,1.1l-0.9,0l-1.1-2.3L445,144z	"
        >
          <title id="t3095">Doddridge, WV</title>
        </path>
        <path
          id="FIPS_54095"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M441.5,142.5l3.5,1.5l-2.3,2.4l-1.3-0.5l-1.6-1l0.9-1.4L441.5,142.5z	"
        >
          <title id="t3096">Tyler, WV</title>
        </path>
        <path
          id="FIPS_54033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.1,143.5l3.1,0.5l0.6,1.9l-0.3,1.8l-0.7,0.2l-3-0.3l0-3.4L446.1,143.5z	"
        >
          <title id="t3097">Harrison, WV</title>
        </path>
        <path
          id="FIPS_54029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.4,128.6l0.3,2.1l0.2,1l-0.9,0.2l-0.9-2.3L443.4,128.6z	"
        >
          <title id="t3098">Hancock, WV</title>
        </path>
        <path
          id="FIPS_54009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M443.9,131.6l0.5,3.1l-1.7-0.1l0.2-2.8L443.9,131.6z	"
        >
          <title id="t3099">Brooke, WV</title>
        </path>
        <path
          id="FIPS_54069"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M442.8,134.6l1.7,0.1l0.3,1.8l-2.1,0.1l0-1.6L442.8,134.6z	"
        >
          <title id="t3100">Ohio, WV</title>
        </path>
        <path
          id="FIPS_54051"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M444.7,136.6l0.6,3.8l-3,0.5l-0.1-1.7l0.4-2.4L444.7,136.6z	"
        >
          <title id="t3101">Marshall, WV</title>
        </path>
        <path
          id="FIPS_54103"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.3,140.2l0.4,1l-0.6,2.3l-0.4,0.6L445,144l-3.5-1.5l0.9-1.6l3-0.5L446.3,140.2z	"
        >
          <title id="t3102">Wetzel, WV</title>
        </path>
        <path
          id="FIPS_54049"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M446.7,141.2l0.5,0.2l1.9-0.3l0.8,0.6l0.5,0.4l1.2,0.6l-2.4,1.2l-3.1-0.5L446.7,141.2z	"
        >
          <title id="t3103">Marion, WV</title>
        </path>
        <path
          id="FIPS_54001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.3,145.5l0.1,1.5l-0.2,0.3l0,0.1l-0.1,1.1l0,0.4l0,0.1l-1.8,0.6l-1.8-1.9l0.3-1.8l2.5-1.2
		L453.3,145.5z	"
        >
          <title id="t3104">Barbour, WV</title>
        </path>
        <path
          id="FIPS_54091"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M451.6,142.8l0.5,0.1l0.3,1.7l-2.5,1.2l-0.6-1.9L451.6,142.8z	"
        >
          <title id="t3105">Taylor, WV</title>
        </path>
        <path
          id="FIPS_54061"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M452.7,139.1l0.1,0.3l-0.1,1l-0.8,2l0.1,0.6l-0.5-0.1l-1.2-0.6l-0.5-0.4l-0.8-0.6l-1.9,0.3
		l-0.5-0.2l-0.4-1l4.9-0.8L452.7,139.1z	"
        >
          <title id="t3106">Monongalia, WV</title>
        </path>
        <path
          id="FIPS_54075"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M456.4,152.4l-0.1,1l0,1.1l0,0.9l-0.3,0.9l-0.6,1l0,0v0l0.2,0.5l-1.2,2.9L453,161l-0.6,0.4
		l-0.4,0.1l-0.6,0l-1.1-0.7l-0.2-1.4l-0.2-1.5l0.2,0.1l0.7-0.8l0.9-1.1l1.1-0.2l1.4-1.5l0.1-1l0-0.2l0.3-1.3l0.1,0l0.2,0l1.4,0.5
		L456.4,152.4z	"
        >
          <title id="t3107">Pocahontas, WV</title>
        </path>
        <path
          id="FIPS_54077"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M455.5,138.6l1.1,6.6l0,0.1l-0.2-0.2l-1.9-0.4l-1.1,0.7l-1-0.7l-0.3-1.7l-0.1-0.6l0.8-2l0.1-1
		l-0.1-0.3L455.5,138.6z	"
        >
          <title id="t3108">Preston, WV</title>
        </path>
        <path
          id="FIPS_54083"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.4,148.1L458.4,148.1l-0.8,0.8l-0.5,0.6l-0.2,0.4v0l0.2,0.3l0.1,0l0.1,0.1l0,0.1l0,0.2
		l-0.2,0.5l-0.5,1l-0.2,0.2l0-0.2l-1.4-0.5l-0.2,0l-0.1,0l-0.3,1.3l0,0.2l-0.1,1l-1.4,1.5l-1.1,0.2l-0.9,1.1l0.3-1.9l-1.3-2l0.3-0.7
		l1.1-0.2l0.1-1.3l-0.1-1.4l1.8-0.6l0-0.1l0-0.4l0.1-1.1l0-0.1l0.2-0.3l0.6,0.9l3,0.3L458.4,148.1z	"
        >
          <title id="t3109">Randolph, WV</title>
        </path>
        <path
          id="FIPS_54071"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.5,148.2l2.4,1.5l0.9,0.5l-1,3.9l-0.7,1l-1.7-0.3l-0.6-0.9l-0.2-0.2l-0.2-0.1l-1-0.2
		l0.1-1l0.2-0.2l0.5-1l0.2-0.5l0-0.2l0-0.1l-0.1-0.1l-0.1,0l-0.2-0.3v0l0.2-0.4l0.5-0.6L458.5,148.2z	"
        >
          <title id="t3110">Pendleton, WV</title>
        </path>
        <path
          id="FIPS_54093"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M453.3,145.5l1.1-0.7l1.9,0.4l0.2,0.2l0.9-0.2l0.7,0.5l0.5,0.9l0,0.3l0,0.4l-0.1,0.4l-0.2,0.3
		l-1.4,0.1l-3-0.3l-0.6-0.9L453.3,145.5z	"
        >
          <title id="t3111">Tucker, WV</title>
        </path>
        <path
          id="FIPS_54023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M458.2,143.3l3.3,0.7l-0.1,0.1l-0.3,1.1l-0.3,1.6l0.2,0.4l0.3,1.3l-0.4,1.2l-2.4-1.5l-0.1-0.1
		l0.2-0.3l0.1-0.4l0-0.4l0-0.3l-0.5-0.9l-0.7-0.5l-0.9,0.2l0-0.1L458.2,143.3z	"
        >
          <title id="t3112">Grant, WV</title>
        </path>
        <path
          id="FIPS_54031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M461.4,143.9l0.9,0.4l1.5,0.3l0.9,0.1l0.6-0.1l0.1-0.1l0.4,0l0.3,0.2l0.4,0.3l-0.3,0.5l0,0.5
		l0,0.1l-0.3,0.7l-0.9,0.9l0,0l0-0.1l0-0.1l-0.5,0.5l0,0.1l0,0l-0.1,0.4l-0.4,1.3l-1.8,0.4l-0.9-0.5l0.4-1.2l-0.3-1.3l-0.2-0.4
		l0.3-1.6l0.3-1.1L461.4,143.9z	"
        >
          <title id="t3113">Hardy, WV</title>
        </path>

        <path
          id="FIPS_54027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M463.9,139.6l1.9-0.1l1.3,0.4l0.1,1.4l0,2.5l0,0.2l-0.1,0.4l-0.2,0.3l-0.3,0.3l-0.1,0.1
		l-0.4-0.3l-0.3-0.2l-0.4,0l-0.1,0.1l-0.6,0.1l-0.9-0.1l-1.5-0.3l-0.9-0.4L463.9,139.6z	"
        >
          <title id="t3115">Hampshire, WV</title>
        </path>

        <path
          id="FIPS_56021"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M204.7,123.3l6,0.6l-0.1,1.1l5.7,0.5l-0.2,2.2l-0.4,5.1l-8.6-0.7l-3.2-0.3L204.7,123.3z	"
        >
          <title id="t3117">Laramie, WY</title>
        </path>
        <path
          id="FIPS_56015"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M217.4,112l-0.7,7.9l-0.3,3.9l-0.1,1.7l-5.7-0.5l0.1-1.1l1.1-12.4l1.6,0.1l2.3,0.2L217.4,112z
			"
        >
          <title id="t3118">Goshen, WY</title>
        </path>
        <path
          id="FIPS_56039"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M155.9,77.7l3.5,0.6l-0.2,1.1l2.7,0.4l0.6,0.5l0.1,0.1l0.1,0.3l0,0.2l0,1.2l0.3,1.2l0.6,1.7
		l0.4,0.9l-1.3,8.6l-0.2,1.1l-2.7-0.4l-0.2,1.1l-2.2-0.3l-0.1,0.7l-2.2-0.3l0.1-0.8l-1-0.4l-1.1-0.2l1.3-8.5l1-6.3L155.9,77.7z	"
        >
          <title id="t3119">Teton, WY</title>
        </path>
        <path
          id="FIPS_56023"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M153.2,95l1.1,0.2l1,0.4l-0.1,0.8l2.2,0.3l-0.2,1.4l-0.8,4.4l-0.2,0.9l-0.5,3.4l0.1,2.3
		l2.1,0.4l2.4,0.4l-0.3,1.9l-0.2,1.9l-0.8,5.1l-9.5-1.5l0.9-5.4l1.1-6.6l1.1-6.5L153.2,95z	"
        >
          <title id="t3120">Lincoln, WY</title>
        </path>
        <path
          id="FIPS_56041"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M149.7,117.2l9.5,1.5l-1.1,7.4l-4.3-0.6l-5.2-0.9l0.5-3.3L149.7,117.2z	"
        >
          <title id="t3121">Uinta, WY</title>
        </path>
        <path
          id="FIPS_56035"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M162.7,94.5l2.7,0.4l0.4,1.3l0.1,0.8l0,0.1l-0.1,0.3l-0.1,0.3l0,0.5l0.1,0.5l0.6,2.3l1.9,2.3
		l1.5,1.8l0.5,0.6l-0.2,3.4l-0.3,2.2l-4.3-0.6l-2.3-0.4l-2.8-0.5l-2.4-0.4l-2.1-0.4l-0.1-2.3l0.5-3.4l0.2-0.9l0.8-4.4l0.2-1.4
		l0.1-0.7l2.2,0.3l0.2-1.1l2.7,0.4L162.7,94.5z	"
        >
          <title id="t3122">Sublette, WY</title>
        </path>
        <path
          id="FIPS_56029"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M167.9,75.1l4.8,0.6l1.7,0.3l0.2,0l1.2,0.2l2.8,0.4l-0.2,1.7l0.2,0.4l-0.3,2.8l-0.1,1.4
		l-0.6,4.5l0.2,0l-0.2,1.1l-2.2-0.3l-1.3,1l-0.1,1.1l-1.7-0.2l-0.2,1.1l-1.7-0.2l-0.4,0l-0.1-0.2l-0.7-1.2l-0.5-0.4l-0.2-0.1
		l-0.4-0.3l-0.1,0l-0.9,0.4l-0.1,0.2l-0.2,0.5l-1.7,0.2l-0.9-1.7l-0.6-0.8l0.2-1.6l-0.4-0.9l-0.6-1.7l-0.3-1.2l0-1.2l0-0.2l-0.1-0.3
		l-0.1-0.1l-0.6-0.5l-2.7-0.4l0.2-1.1l-3.5-0.6l0.8-4.3l1.5,0.2l1.1,0.2l0.4,0.1l1.4,0.2l0,0l3,0.4l1,0l0.8,0.1L167.9,75.1z	"
        >
          <title id="t3123">Park, WY</title>
        </path>
        <path
          id="FIPS_56037"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M160.4,109.8l2.8,0.5l2.3,0.4l4.3,0.6l14.3,1.9l-0.1,1.5l0,0.8l-0.6,4.5l-0.2,1.1l-4-0.5
		l-0.2,2.2l-0.1,1.1l-0.7,5.1l-3.2-0.4l-7.7-1l-1.5-0.2l-4.5-0.6l-0.4-0.1l-1.3-0.2l-1.4-0.2h0l-0.5-0.1l1.1-7.4l0.8-5.1l0.2-1.9
		L160.4,109.8z	"
        >
          <title id="t3124">Sweetwater, WY</title>
        </path>
        <path
          id="FIPS_56013"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M185.5,97.1l0.6,0.1l0.1,0.4l-0.3,2.2l-0.3,2.2l0.1,0.2l-0.5,4.2l-0.4,1.5l-0.5,3l0.2,0
		l-0.3,2.2l-14.3-1.9l0.3-2.2l0.2-3.4l-0.5-0.6l-1.5-1.8l-1.9-2.3l-0.6-2.3l-0.1-0.5l0-0.5l0.1-0.3l0.1-0.3l0-0.1l-0.1-0.8l-0.4-1.3
		l-2.7-0.4l1-7l0.6,0.8l0.9,1.7l1.7-0.2l0.2-0.5l0.1-0.2l0.9-0.4l0.1,0l0.4,0.3l0.2,0.1l0.5,0.4l0.7,1.2l0.1,0.2l0.6,0.7l0.5,0.9
		l-0.1,0.9l1.1,0.3l1,0.1l1.1,0.3l0.7,0.5l0.3,0.6l1,0.5l2.1,0.8l0.8,0.1l0.6,0l0.3-0.1l5.2,0.6L185.5,97.1z	"
        >
          <title id="t3125">Fremont, WY</title>
        </path>
        <path
          id="FIPS_56017"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177.6,88.5l0.6,0.1l0.4,1.2l-0.2,1.1l1,0.9l1.2,0.5l1.5,0.2l0.5,0.8l0.2,0.4l2,0.2l1,1.3
		l-0.2,1.9l-0.1,0.4l-5.2-0.6l-0.3,0.1l-0.6,0l-0.8-0.1l-2.1-0.8l-1-0.5l-0.3-0.6l-0.7-0.5l-1.1-0.3l-1-0.1l-1.1-0.3l0.1-0.9
		l-0.5-0.9l-0.6-0.7l0.4,0l1.7,0.2l0.2-1.1l1.7,0.2l0.1-1.1l1.3-1L177.6,88.5z	"
        >
          <title id="t3126">Hot Springs, WY</title>
        </path>
        <path
          id="FIPS_56043"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M177.6,88.5l0.2-1.1l10.8,1.4l2.1,0.3l0.2,0l-0.5,4.5l-0.3,4.1l-3.9-0.5l-0.6-0.1l0.2-1.9
		l-1-1.3l-2-0.2l-0.2-0.4l-0.5-0.8l-1.5-0.2l-1.2-0.5l-1-0.9l0.2-1.1l-0.4-1.2L177.6,88.5z	"
        >
          <title id="t3127">Washakie, WY</title>
        </path>
        <path
          id="FIPS_56003"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M178.6,76.7l3.4,0.5l3.1,0.4l0.2,0.2l0.1,0.1l0.1,1.1l0.2,1.5l0.6,1l0.4,0.4l0.2,0.1l0.2-0.1
		l0.3-0.1l0.5,0.3l1.4,1.3l0.1,0.2l0,0.3l1.3,1.6l0.2,0.8l0.1,0.9l-0.3,2l-2.1-0.3l-10.8-1.4l-0.2,0l0.6-4.5l0.1-1.4l0.3-2.8
		l-0.2-0.4L178.6,76.7z	"
        >
          <title id="t3128">Big Horn, WY</title>
        </path>
        <path
          id="FIPS_56033"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M199.9,79.3l2.2,0.2l-0.2,1.6l-0.1,1.5l-0.1,1.5l-0.1,0.9l-1.6-0.2l-2.3-0.2l0,0.1l-8.6-1
		l0-0.3l-0.1-0.2l-1.4-1.3l-0.5-0.3l-0.3,0.1l-0.2,0.1l-0.2-0.1l-0.4-0.4l-0.6-1l-0.2-1.5l-0.1-1.1l-0.1-0.1l-0.2-0.2l2.7,0.3
		l4.3,0.5l0.5,0.1l1.7,0.2L199.9,79.3z	"
        >
          <title id="t3129">Sheridan, WY</title>
        </path>
        <path
          id="FIPS_56019"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M190.7,89l0.3-2l-0.1-0.9l-0.2-0.8l-1.3-1.6l8.6,1l0-0.1l2.3,0.2l1.6,0.2l-0.2,1.1l-0.2,1.3
		l-0.3,2.4l0,0.1l0,0.1l-0.1,1.1l-0.3,2.7l-0.2,0.7l-0.3,2.5l-0.2,1.7l-0.6-0.1l-4.7-0.5l-4.9-0.6l0-0.1l0.3-4.1l0.5-4.5L190.7,89z	
		"
        >
          <title id="t3130">Johnson, WY</title>
        </path>

        <path
          id="FIPS_56025"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M186.1,97.2l3.9,0.5l0,0.1l4.9,0.6l4.7,0.5l0,0.5l-0.3,2.6l-0.4,3.3l-0.4,3.8l-0.4,3.4
		l-5.5-0.6l-2.8-0.3l-5.3-0.6l-0.2,0l0.5-3l0.4-1.5l0.5-4.2l-0.1-0.2l0.3-2.2l0.3-2.2L186.1,97.2z	"
        >
          <title id="t3131">Natrona, WY</title>
        </path>

        <path
          id="FIPS_56007"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M184.5,110.9l5.3,0.6l2.8,0.3l5.5,0.6h0l-0.8,8l-0.4,4.3l-0.1,1.1l-1.3-0.1l-1.1-0.1l-0.4,3.5
		l-0.2,1.6l-5.2-0.6l-4.4-0.5l-5.8-0.7l0.7-5.1l0.1-1.1l0.2-2.2l4,0.5l0.2-1.1l0.6-4.5l0-0.8l0.1-1.5L184.5,110.9z	"
        >
          <title id="t3132">Carbon, WY</title>
        </path>
        <path
          id="FIPS_56001"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M198.1,112.5l4.9,0.5l0,0.3l-0.2,0.4l-0.4,0l-0.1,0.9l0.1,0.1l0.9,0.2l1.2,0.1l0.2-0.5l0-0.6
		l0.1-0.4l0.2-0.3l0.5,0l-0.3,4.4l-0.1,1.5l-0.3,3l-0.2,1.1l-0.8,8.5l-8.8-0.9l-1.3-0.1l0.2-1.6l0.4-3.5l1.1,0.1l1.3,0.1l0.1-1.1
		l0.4-4.3L198.1,112.5z	"
        >
          <title id="t3133">Albany, WY</title>
        </path>
        <path
          id="FIPS_56045"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M209.7,90.9l6.3,0.5l3.2,0.3l0,0.5l-0.3,3.7l-0.4,4.5l-7.9-0.7l-1.7-0.1L209.7,90.9z	"
        >
          <title id="t3134">Weston, WY</title>
        </path>
        <path
          id="FIPS_56011"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M210.6,80.3l0.5,0l8.9,0.8l-0.9,10.5l-3.2-0.3l-6.3-0.5l0,0l0-0.5l0.7-6.9l0.1-1.6L210.6,80.3
		z	"
        >
          <title id="t3135">Crook, WY</title>
        </path>
        <path
          id="FIPS_56005"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M202.1,79.6l1,0l0.6,0l6.9,0.7l-0.1,1.5l-0.1,1.6l-0.7,6.9l0,0.5l0,0l-0.8,8.7l-8.7-0.8
		l0.2-1.7l0.3-2.5l0.2-0.7l0.3-2.7l0.1-1.1l0-0.1l0-0.1l0.3-2.4l0.2-1.3l0.2-1.1l0.1-0.9l0.1-1.5l0.1-1.5L202.1,79.6z	"
        >
          <title id="t3136">Campbell, WY</title>
        </path>
        <path
          id="FIPS_56009"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M200.1,98.8l8.7,0.8l1.7,0.1l-0.2,1.9l-0.6,5.9l-0.1,1.4l-0.2,2.2l-1.9-0.2l-1.8-0.1l-0.2,2.2
		l-0.5,0l-0.2,0.3l-0.1,0.4l0,0.6l-0.2,0.5l-1.2-0.1l-0.9-0.2l-0.1-0.1l0.1-0.9l0.4,0l0.2-0.4l0-0.3l-4.9-0.5h0l0.4-3.4l0.4-3.8
		l0.4-3.3l0.3-2.6l0-0.5L200.1,98.8z	"
        >
          <title id="t3137">Converse, WY</title>
        </path>
        <path
          id="FIPS_56027"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M218.4,100.5l-0.5,6.5l-0.4,5l-1.8-0.2l-2.3-0.2l-1.6-0.1l-2.2-0.2l0.2-2.2l0.1-1.4l0.6-5.9
		l0.2-1.9L218.4,100.5z	"
        >
          <title id="t3138">Niobrara, WY</title>
        </path>
        <path
          id="FIPS_56031"
          className={zoomed ? "st0" : "st0-noStroke"}
          d="M209.5,111.3l2.2,0.2l-1.1,12.4l-6-0.6l0.2-1.1l0.3-3l0.1-1.5l0.3-4.4l0.2-2.2l1.8,0.1
		L209.5,111.3z	"
        >
          <title id="t3139">Platte, WY</title>
        </path>
        <g
          className={
            currentClickedArea && currentClickedArea["fips"] === "47900"
              ? `metroArea clickedArea state-dc state-va state-md state-wv`
              : `metroArea ${colorCode[47900]} state-dc state-va state-md state-wv`
          }
          id="FIPS_47900"
          onClick={(e) => {
            handleClickMetroArea(e);
          }}
          onMouseEnter={(e) => {
            handleMouseEnterMetroArea(e);
          }}
          onMouseLeave={(e) => {
            handleMouseLeaveMetroArea(e);
          }}
        >
          <path
            id="FIPS_11001"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M480.3,144.4l0.6-0.9l0.5,0.3l1.2,0.6l-1.1,1.7l-0.1-0.6l-0.3-0.5l-0.5-0.2L480.3,144.4z	"
          >
            <title id="t3140">Washington, DC</title>
          </path>
          <path
            id="FIPS_24009"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M488.9,150.8l-3.1-1.8l-0.1-0.5l-0.7-2.7l0-0.1l0.3-0.2l0.2,0l0.4,0.5l0.7,0l0,0.2l0.1,0.3
		l0.5,1.7l0,0.1l0.2,0.3l0.2,0.3l0.4,0.3l0.8,0.7l0,0.1l0,0.3L488.9,150.8z	"
          >
            <title id="t1195">Calvert, MD</title>
          </path>
          <path
            id="FIPS_24017"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M481.2,147.2l0.6,1.1l0.2-0.3l0-0.1l0-0.1l0.1-0.1l0.3-0.1l1-0.2l1.2,0.3l0,0.1l0.2,0.7
		l0.5,0.1l0.2,0l0.1,0.5l-0.4-0.1l-0.2,0l-0.3,0l-0.1,0.1l-0.5,1.6l0,0.2l0.5,0.9l0.1,0.3v0.2l0,0.1l-3.9-0.6l-0.1,0l-0.4-0.2
		l-0.2-0.4l-0.3-0.8l0-0.4l0.2-0.6l0.4-0.7l0.4-0.5L481.2,147.2z	"
          >
            <title id="t1191">Charles, MD</title>
          </path>
          <path
            id="FIPS_24031"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M478.8,139.1l-0.1,0.1l0,0.1l0,0l0.2,0.3l0.5,0.5l2.1,1.4l0.1,0l0.4,0l0.2-0.1l-0.7,2.3
		l-0.5-0.3l-0.6,0.9l-2.3-1.2l-0.5,0.1l-0.5,0l-0.4,0l0,0l-0.6-0.4l-0.1,0h0l-0.1-0.1l-0.1-0.2l0,0l0-0.1l0-0.2l0-0.1l0-0.1l0.4-0.6
		L478.8,139.1z	"
          >
            <title id="t1203">Montgomery, MD</title>
          </path>

          <path
            id="FIPS_24021"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M475,135l2.3-0.5l-0.4,1l0.8,0.7l1.2,0.9l0,0l0,0.4l-0.2,1.5l0,0l-2.5,2.3l-2.4-0.8l0.2-1.8
		l0-1.2l0.1-0.9l0-0.1l0.4-0.2l0.1-0.1l0.1-0.4L475,135L475,135z	"
          >
            <title id="t1209">Frederick, MD</title>
          </path>

          <path
            id="FIPS_24033"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M482.1,141.4l0.5,0.3l1.7,1.2l0.4,0.8l0.4,2.1l0.7,2.7l-0.2,0l-0.5-0.1l-0.2-0.7l0-0.1
		l-1.2-0.3l-1,0.2l-0.3,0.1l-0.1,0.1l0,0.1l0,0.1l-0.2,0.3l-0.6-1.1l0.2-1.1l0-0.1l1.1-1.7l-1.2-0.6L482.1,141.4z	"
          >
            <title id="t1200">Prince George&apos;s, MD</title>
          </path>
          <path
            id="FIPS_51013"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M480.3,144.4l0.4,0.3l0.5,0.2l0.3,0.5l-0.8,0.1l-0.1,0.2l-0.5-0.4l-0.5-0.4l-0.1-0.1l0,0
		L480.3,144.4z	"
          >
            <title id="t2824">Arlington, VA</title>
          </path>
          <path
            id="FIPS_51043"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M470.6,141.9l2.3,1.3l-1,1.8l-0.3,0.5L470,145L470.6,141.9z	"
          >
            <title id="t2874">Clarke, VA</title>
          </path>
          <path
            id="FIPS_51059"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M478,143.2l2.3,1.2l-0.9,0.5l0,0l-0.3,0.3l0.3,0.4l0.6-0.3l0.5,0.4l-0.2,0.5l0.6,0.1l0.6-0.3
		l-0.2,1.1l-0.3,1l-0.9,0.1l-3.6-2.1L478,143.2z M478.2,145.7l-0.1,0.2v0.2l0.3,0.2l0.3-0.1l0.2-0.1l-0.1-0.4l-0.1-0.1l-0.3,0
		L478.2,145.7z	"
          >
            <title id="t2924">Fairfax Co., VA</title>
          </path>
          <path
            id="FIPS_51107"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M473.5,140.6l0.4,0l2.4,0.8l-0.4,0.6l0,0.1l0,0.1l0,0.2l0,0.1l0,0l0.1,0.2l0.1,0.1h0l0.1,0
		l0.6,0.4l0,0l0.4,0l0.5,0l0.5-0.1l-1.5,3.1l-1.4-1l-3.2-0.3l1-1.8L473.5,140.6z	"
          >
            <title id="t2911">Loudoun, VA</title>
          </path>
          <path
            id="FIPS_51061"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M471.9,144.9l3.2,0.3l-0.3,1.4l0,0.1l2.1,2.7l0.4,0.5l-0.7,2.1l-0.9,0.1l-0.1,0l-0.2-0.1
		l-0.1-0.1l-0.9-1.1l-0.6-1l-0.9-0.9l-0.2,0l-0.4-0.1l-0.1-0.1l-0.1-0.1l-0.2-0.4l-0.8-0.8l-0.5-0.4l1-1.7L471.9,144.9z	"
          >
            <title id="t2912">Fauquier, VA</title>
          </path>
          <path
            id="FIPS_51153"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M475.1,145.3l1.4,1l3.6,2.1l-0.5,1.9l-2.4-0.2l-0.4-0.5l-2.1-2.7l0-0.1L475.1,145.3z
		 M477,147.1L477,147.1l-0.2,0.2l-0.2,0.4l0,0.1l0.1,0.2l0.3,0.1l0.5-0.5l0-0.4l-0.1-0.1l0.1-0.1l0.2-0.2V147l-0.1,0l-0.3-0.1
		l-0.1,0l-0.1,0.1L477,147.1z M477.6,147.4l0.2,0.1l0.1-0.2l-0.1-0.1l-0.1,0l-0.2,0.2L477.6,147.4L477.6,147.4z	"
          >
            <title id="t2925">Prince William, VA</title>
          </path>
          <path
            id="FIPS_51177"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M476.9,152.5l1,0.6l0.5,0.3l0.4-0.1l0.9,0.3l-2,3.8l-0.5-0.1l-2.9-0.9l1.9-3.6L476.9,152.5z	"
          >
            <title id="t2914">Spotsylvania, VA</title>
          </path>
          <path
            id="FIPS_51179"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M476.9,152.5l-0.3-0.5l0.7-2.1l2.4,0.2l0.6,2l-0.1,1.4l-0.4,0.1l-0.9-0.3l0-0.4l-0.2-0.2
		l-0.2,0l-0.3,0l-0.1,0.1l-0.2,0.1l0.1,0.3L476.9,152.5z	"
          >
            <title id="t2926">Stafford, VA</title>
          </path>
          <path
            id="FIPS_51187"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M470,145l1.6,0.5l-1,1.7l-1.3,1.6l-1.2-0.7l0.3-2.4L470,145z	"
          >
            <title id="t2877">Warren, VA</title>
          </path>
          <path
            id="FIPS_51510"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M481.4,145.4l0.1,0.6l0,0.1l-0.6,0.3l-0.6-0.1l0.2-0.5l0.1-0.2L481.4,145.4z	"
          >
            <title id="t2871">Alexandria, VA</title>
          </path>
          <path
            id="FIPS_51600"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M478.2,145.7l0.3-0.2l0.3,0l0.1,0.1l0.1,0.4l-0.2,0.1l-0.3,0.1l-0.3-0.2v-0.2L478.2,145.7z	"
          >
            <title id="t2909">Fairfax, VA</title>
          </path>
          <path
            id="FIPS_51610"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M480.1,145.3l-0.6,0.3l-0.3-0.4l0.3-0.3l0.1,0.1L480.1,145.3z	"
          >
            <title id="t2823">Falls Church, VA</title>
          </path>

          <path
            id="FIPS_51630"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M478.8,153.3l-0.4,0.1l-0.5-0.3l-0.1-0.3l0.2-0.1l0.1-0.1l0.3,0l0.2,0l0.2,0.2L478.8,153.3z	"
          >
            <title id="t2908">Fredericksburg, VA</title>
          </path>

          <path
            id="FIPS_51683"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M477,147.1l0.2,0.1l0.1,0.1l0.1,0.1l0,0.4l-0.5,0.5l-0.3-0.1l-0.1-0.2l0-0.1l0.2-0.4
		L477,147.1L477,147.1z	"
          >
            <title id="t2910">Manassas, VA</title>
          </path>
          <path
            id="FIPS_51685"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M477.3,146.8l-0.1,0l-0.1,0.1l-0.1,0.1l0.2,0.1l0.1,0.1l0.1,0l0.1,0l0,0l0.1,0.1l0,0.1l0.1,0
		l0.2,0.1l0.1-0.2l-0.1-0.1l-0.1,0l-0.1,0V147l-0.1,0L477.3,146.8z	"
          >
            <title id="t2936">Manassas Park, VA</title>
          </path>
          <path
            id="FIPS_54037"
            className="FIPS_47900 st0 state-dc state-va state-md state-wv"
            d="M472,138.6l1.5,2l-0.6,2.6l-2.3-1.3l0-0.2l0-0.1l0.5-1.2l0.1-0.1l0.2-0.1l0.5-0.8l0.1-0.2
		L472,138.6z	"
          >
            <title id="t3063">Jefferson, WV</title>
          </path>
        </g>
      </g>
      <g id="g6288">
        <path
          ref={stateLines}
          id="State_Lines"
          className="st1"
          d="M122.3,106.9l-2.2-0.4l-2-0.4l-2.5-0.6l-1.4-0.3l-1.2-0.2l-13.7-2.9l-1.1-0.2l-3.6-0.8
		l-0.1,0l-10.9-2.5l-5.4-1.2L73.1,96L72.8,96l-5.9-1.5 M234.1,147.2l-0.3,5.6l0,0.1l-0.3,5.6l-0.1,1.1l-0.3,4.5l-0.1,1.1l-0.3,4.5
		l0,0.1l-0.4,6.8l-0.1,1.2l-0.2,3.3l-0.3,5.1l-3.2-0.2l-5.3-0.4l-1.3-0.1l-0.9-0.1l-9.4-0.7l-7.4-0.6l-2.7-0.3l-1.6-0.2l-0.7-0.1
		l-5.1-0.5l-2.9-0.3l-4.8-0.5l-1.4-0.2l-2.6-0.3l-1.3-0.3l-4.3-0.5l-0.6-0.1l-9.1-1.1l-6.7-0.9l-9.7-1.4l-3.3-0.5l-1.6-0.3l-2.6-0.4
		l-6.7-1.1l-11.4-1.9l-3.6-0.6l-11.6-2.2 M178.6,249.4l-0.8-0.9l-0.1-0.1l0-0.1l0.3-1.1l0-0.1l0.2-0.6v0h0l0,0l2.4,0.3l4.1,0.4
		l11.7,1.2l0.8,0.1l8.9,0.8l0.5,0l2.8,0.2l4.3,0.3l0.6,0.1l0.6,0l0.8,0.1l0.6,0l0.3,0l0.1-1.1l0.4-5.6l0.4-5.6l0.5-5.5l0.2-2.4
		l0.3-3.3l0.5-6.2l0-0.1l0.4-5.6l0.2-2.7l0.2-3l0.4-5.7l0.1-1.5l0.3-4.1l0.2-3.4l0.2-2.1l0.4-0.3l0.5-6.5 M289.3,116.8l0.3,0l0.1,0
		l0.1,0.1l0,0.1l0,0.2l-0.1,0.2l0.1,1.5l0.3,0.5l-0.1,0.8l0.8,2.2l1.3,2.4l0.2,2.4l1.3,2.3l0.4,1.5l0.1,2.6l0.7,0.4l-0.1,1.5
		l0.4,1.9l-0.3,1.5l0.9,2.6l0.5,0.8l0.1-0.3l0.4,0.3l-0.2,0.4l-0.1,0.1l0.1,0.2l0.6,1.6l0.7,0.7l0,0.1l0,0v0l0,0.2v0l2.4,3.4l0,0.1
		l0.1,0.1l1.2,1.1l0.5,0.3l0.2,0.1l0.2,0.1l0,0l0,0l0.4,0l0.1,0l0.1-0.1l0,0l0.3-0.4l0.8,1l0.1,0.4l0.1,0.4l-0.2,0.5l-0.2,0
		l-0.7,0.6l0,0l-0.3,0.5l-0.1,0.2l-0.4,1.2l1.3,1.5l1.8,2.8l1.9,0.5l0,0.6l0,0.9l0,2.6l0,1.4l0,3.4l0,1.2l0.1,4.3l0,0.3l0,4.7l0,0.3
		l0.1,3.8l0,0.3l0,3.7l0,0.8l0,3l0,1.3l0,2.2l0.6,4.4l0.1,0.8l0.7,4.4l0.2,1.6l0.5,3.1l0,0.2l-0.1,5.8l0,2.7l0,2.9l0,4.1l0,3.2
		l0,3.9 M329,61.6L329,61.6l-0.2,0l-0.5-0.5l-0.2,0l-0.6,0.4l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0.1l-0.1,0.3l0,0l0,0l-0.3,0l-0.2,0
		l-0.2-0.1l0.1,3.2l0.1,3.3l0,0.6l0,0.5l-1.3,0.8l-1.9,1.2l-0.4,0.4l-0.1,0.1l-0.1,0.2l-0.9,1.8l-0.4,1.1l0,0.2l0,0.1l0,0.3l0,0.3
		l0.1,0.1l0.4,0.1l0.2,0l0.7,0.4l0.4,0.8l0.2,0.9l-0.3,0.9l-0.2,0.3l0,0l-0.1,0.1l-0.1,1.1l-0.2,1.7l0,0.4l0.2,0.5l0.2,0.9l-0.1,1
		l-0.3,1.5l0.7,0.4l1,0.8l0.1,0.1l0,0.1l0.7,0.7l0.1,0.1l0.4,0l1.2,0l0.2,0l0.1,0.1l0.1,0.1l0,0l0.7,1.1l1.5,0.6l2.2,2.7l2.9,2.1
		l1.3,0.5l1.3,1.7l0.2,1.6l0.6,2.9l0.2,1l0,0.7l1,0.7l0.2,0.3l0.3,0.5l0,0.2L339,107l-0.2,1l0.2,1.2l0.2,1l0.9,1.9l0.1,0.2l0.8,0.5
		l0.3,0.1l0.5,0.1l1.2,0.2l0.5,0.1l0.1,0.1l0.1,0.1l0.6,1.1l0.1,0.3l0,0.1l0,0.1l2-0.1l4.7-0.3l0.8,0l4.1-0.2l0.3,0l4-0.2l1.5-0.1
		l0.7,0l3.8-0.3l1-0.1l3.8-0.3 M344.2,115.1l-0.1,0.2l0,0l0,0.1l0,0.1l0.1,0.1l0.2,0.2l0.6,0.3l0.8,0.6l0,0l0,0l0.6,0.7l0,0l0,0
		l-0.1,0.4l-0.1,0.1v0.1l0.1,0.3l0,0l0.3,0.3l0,0l0.2,0.1l0.2,0.1l0.4,0.1l1.7,2l0.1,1.3l-0.7,1.9l-0.7,0.8l-0.1,1.4l-0.5,0.7
		l-0.6,0.7l-1.8,0.9l-0.8,0.2l-0.3,0l-0.1,0l-0.6,0l-1.4,0.4l-0.4,0.1l-0.1,0.1l0,0v0l-0.1,0.1l0,0l-0.1,0.6l-0.1,0.4l-0.3,1.1
		l0,0.1l0.7,0.8l0.3,0.2l0.1,0l0.1,0l0.1,0.1l0.5,0.7l0,0.3l0,0l0,0.1l0,0.3l0,1.1l-0.1,0.4l-0.1,0.1l-0.3,0.2l-0.1,0.1l-0.8,1.1
		l0,0.2l-0.1,1.5l-0.7,0.8l-0.3,0l-0.3,0l-0.1,0l-0.5,0.2l-0.1,0l-0.2,0.1l-0.1,0.1l0,0l0,0l0,0l-0.4,0.6l0,0.1l0,0.1l0.2,0.1
		l0.2,0.2l0.1,0.2l0,0.1l0,1.2l0,0.1l-0.1,0.1l-0.3,0.1l-0.7,1.7l-0.1,0.6l0.7,3.3l1,2.4l0.6,0.9l1.4,1.1l2.4,2.5l2.4,2.1l0.5,1.6
		l0,0.2l-0.3,0.4l0,0l0,0.1v0l0.5,1.4l2.1-0.6l1.8,0.4l0.3,0.1l0.3,0.1l0.2,0.1l1,0.6l0,0.1l0,0.1l0,0.3l0,0.1l-0.7,0.9l0.2,1
		l-0.7,1.7l0,0.2l-0.7,1.8l0,0l0,0.1l-0.1,0.5l0,0.1l0,0.1l0,0.5l0.1,0.6l0.1,0.3l0.2,0.3l0,0l0,0l0.8,0.8l0.5,0.4l2.9,2.6l2.7,0.8
		l1.7,2.9v0.1 M360,192.4l0.6,0l0.1-0.2l0,0l0,0l0-0.1l0,0v-0.1l0,0l0-0.1l-0.1-0.1l0,0l-0.1-0.1l0,0l0,0l0,0l-0.2,0l-0.3,0l-0.2,0
		l-0.1,0l-0.1,0.2l0,0l0,0l0,0.1l0,0l0,0l0,0.1l0,0l0.1,0.2L360,192.4l0.1,2.1l-0.7,2l-0.9,2.5l0.6,1.2l-0.3,0l-0.2,0l-0.2,0.1l0,0
		l-0.1,0.1l-0.9,1.9l-0.3,2.7l-2.4,1.5l0.7,0.7l0,0.1l0.4,3l0,0v0l0,0l0,0l-0.2,0.2l-1.1,0.8l-1,0.3l-0.1,0.4l0,0.2l0.3,1.7
		l-1.2,0.4l-1.6,2.6l0.1,1.5l0.1,1.2l-0.1,0.2l0,0l0,0l-0.4,0.3l-0.5,0.2l-0.6,0.1l-0.6,0.1l-1,1.8l-0.5,1l-0.2,0.3l0,0.1l0.5,0.4
		l0.1,0.3l-0.1,0.4l-2.1,1l-0.9,3.7l-0.1,0.3l0,0l0.1,0.1l0.3,0.2l0.3,0.2v0l0,0.1l-0.2,0.2l-0.8,0.3l0.1,0.4l0,0l0.5,0.4l0.4,0.3
		l0.1,0.3l-0.1,0.3l-0.6,0.2l0.5,1.5l0.4,0.7l0.3,0.3l0,1l-0.3,1.4l-0.3,0.4l-0.1,0.1l-0.4,0.6l-0.1,0.4l0,0.1l0.9,3.9l0.1,0.2l0,0
		l0,0l0,0l0,0l0.1,0.1l0,0l0.3,0.1l0.1,0.2l-0.2,0.8l0,0.2v0l0,0l0,0.1l0,0l1.2,1.3l0.1,1.9l-1.3,0.2l1.1,1.3l-2.2,3.3l-1.2,1.6
		l-0.1,0.2l-0.2,0.3l0,0l-1.2,2.4l0,0.1l0,0.1l0,0l-0.4,3.4l-0.3,1.4l-0.3,2l5.1-0.2l1.3-0.1l2.6-0.1l2.9-0.2l0.2,0l2.2-0.1l1-0.1
		l4.7-0.3l1.2-0.1l0,0.4l-0.1,0.7l-0.1,0.2l-0.1,0l-0.1,0l0,0l-0.1,0.6l-0.2,0.8l-0.1,0.7l-0.1,0.9l1.9,2.6l0,0l0.1,0.1l0.7,1.4
		l0,0.2l-0.1,0.3l0,0.1l0,0.1l0.4,0.7l0.1,0.2l0.2,0.3l0.1,0.1l0,0l0,0l0,0l0,0l0.5,0 M363.7,185.8l-0.5-1.1l2.3-2.2l0.1,0l3.9,1.6
		l0.7,0.1l0.1,0l0.2-0.1l0.1-0.3l0.1-0.7l-0.3-0.6l-0.1-0.1l-0.1-0.1l-0.4-0.5l-0.1-0.3l0-0.1l0.3-1.3l0.1-0.1l0.1-0.2l0.1-0.1
		l0.1-0.1l0.2-0.1l0.1,0l0.6,0.2l0.3-0.3l0.2-0.2l0,0l0,0l0.2-0.1l0,0l0.1,0l0.2,0l0.2,0l1.4-0.3l0.1,0l0.2-0.2v-0.2l-0.8-0.8
		l-0.1-0.1l-0.2-0.6l0,0l-0.1-0.3l0,0l0-0.1l0.1-0.1l0,0l0.1-0.1l0.2-0.3l0,0l0.5-0.3l0.1-0.1l0.1-0.1l0-0.1l0.1-0.5l0.9-1.4
		l2.3-0.2l2.5-0.7l1.5,0.4l0.4,0.3l1.5,1l0.8-1.4l0.6-0.6l1.6-1l1.8,1.9l0.1,0l0.1,0l0.3-0.2l0.7-1.5l-0.1-0.8l0-0.1l0-0.1l0.1,0
		l0.2,0l0.1,0l2-1.3l0,0.4v0l0,0.1l0,0.1l0,0l0.1,0.3l0.1,0.1l0,0l0,0l0.5,0.3l0.4,0.2l0.1,0l1.5,0.1l0.3-0.1l0.5-0.2l0.2-2.3
		l0.9-1.5l1.4-1.4l1.8-2.1l0-0.8l0.7-2.1l1.4,0.5l1.6-1.1l2.2-1.5l-0.1-0.6l-1-1.6l0.5-1l2,0.2l1.1-0.4l2,0.7l1.1,1.8l0.1,0.6
		l1.9,0.5l1.5-0.2l0.3,0l0.1,0l0.1,0.1l0.9,0.9l0.8,0.4l0.6-0.1l0.1-0.5l0.1-0.1l0.1-0.1l0.8-0.3l0.1,0l0.1,0h0l0.4,0.1l1.1,0.3l0,0
		l0.3,0.2l0.6,0.4l2.3-1.9l0.2-0.1l0.8-0.4l0.3-0.1l0,0h0.1l0.1,0l0,0.1l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1v0l0,0l0,0.2l0.1,0.4
		l0.3,0.8l0,0.1l0.1,0.1l0.1,0.1l0,0l0.2,0.1l0,0l1.6,0.6l0.9,1l0.2,2.3l-0.3,1.1l0,0.1l0.1,0.2v0l0.2,0.2l0.2,0l0,0l1.6,1.5l0,0
		l0,0v0.1l-0.3,0.5l1,1l1,1.4l0,0.1l0.4,0.6l2.1,1.4l0.7,0.3l0.4-0.1l0.4-0.1l0.5,0.3l-0.1,0.1l-0.5,0.4l0,0.1l0.1,0.2l0.9,1.2
		l0.8,0.7l0.1,0.1l1.1,0.4l0.7,0.4l1.2-0.2l0,0l0.4-0.4l0,0l0.9-0.8l0.4-0.8l1.6,1.1l2.4-1.1l0.9-1.9l1,0.6l1.3-0.9l0.1-0.1l1-0.8
		l0.5,0.7l0.3-0.2l1.2-1l-0.2-0.4l0.3-0.7l0.6-0.7l-0.9-0.7l1.8-3.7l0.7-1.6l1.2-2.9l-0.2-0.5v0l0,0l0.6-1l0.3-0.9l0-0.9l0-1.1
		l1,0.2l0.2,0.1l0.2,0.2l0.6,0.9l1.7,0.3l0.7-1l1-3.9l1.8-0.4l0.4-1.3l0.1-0.4l0,0l0-0.1l0.5-0.5l0,0.1l0,0.1l0,0l0.9-0.9l0.3-0.7
		l0-0.1l0-0.5l0.3-0.5l0.1-0.1l0.3-0.3l0.2-0.3l0.1-0.4l0-0.2l0-2.5l-0.1-1.4l1.3,0.7l2.2,1.3l2.3,1.3l0.6-2.6 M359.2,178.5l0,0.1
		l0.1,0.3l0,0l0.3,0.5l0.2,0.3l0.3,0.3l0.1,0.2l0.2,0.4l0,0l0,0l0.1,0.2l0,0l0,0l0,0.4l0,0.1l0,0l0,0l0,0l-0.1,0.1l-0.4,0.1l0,1.1
		l0.3,0.4l0.6,1.2l0.4,0.9l0.7,0.6l2,0.2l0.4,0.5l-0.4,1.3l-0.3,0.2v0.3l0.6,0.3l-0.4,1.8l-1.6,0.3l-0.8,1.8l0.7-0.1l5.3-0.4l0.1,0
		l0.1,0l3.1-0.2l0.3,0l4.5-0.3l-0.4-2.3l0.6,0l1.7,0l0,0.4l1.6-0.2l0.5-0.1l3.1-0.3l2.3-0.2l0.6-0.1l3-0.4h2.1l1.5-0.4l2.1-0.1
		l2.3-0.1l1.9-0.1l3.6-0.3l1.4-0.3l0.2,0l3.2-0.2l1.9-0.1l0.1,0l5.3-0.5l0.4,0l2.4-0.3l0.6-0.1l2.6-0.5l2.1-0.2l5-0.6l1.6-0.2
		l2.3-0.3l3.2-0.5l0.5-0.1l1-0.1l2.2-0.3l0.1-0.3l1-0.1l1.8-0.2l-0.3,0.4l3.3-0.3l4.6-0.6l0.7-0.1l2.3-0.4l1.8-0.2l3.9-0.6l0.3,0
		l3.2-0.5l2.1-0.3l0.4-0.1l1.3-0.2l1.3-0.2l0.8-0.1l3.5-0.6l0.6-0.1l2.8-0.5l1.3-0.3l2.8-0.5l1.5-0.3l1.3-0.3l4.8-0.9l1.3-0.3
		l2.5-0.5l4.3-1l1.8-0.4l1.9-0.4l2.6-0.6 M454.2,257.3l-0.2,0l-0.9,0.1l-0.7,0l-1.3-0.1l-1.7-0.4l-0.5-0.3l-1.2,0.7l-0.1,1.4l0,0.3
		l0.2,0.3l0.3,0.4l0.1,0.4l0,0.9l-0.1,0.9l-0.1,0.9l-1.3,0.2l-0.1,0l-0.2-0.2l-0.2-0.3l-0.1-0.3l-0.3-1.8l-2.3,0.1l-0.5,0l-1.4,0.1
		l-1.2,0.1l-5,0.3l-1.9,0.1l-0.5,0l-2.8,0.2l-1.5,0.1l-2.9,0.2l-0.8,0.1l-2.2,0.2L422,262l-5.4,0.4l-2-3.5l-5.4,0.7l-5.9,0.7
		l-1.7,0.2l-2.2,0.2l-3.3,0.3l-1.1,0.1l-4.1,0.4l-4.8,0.5l-0.2,1.7l0.1,0.2l1.1,1.2l0.4,0.2l0.1,0l0.2,0l0.4,0.2l0.5,0.3l0.1,0.2
		l0,0.2l0,0.2l-0.1,2.8l-0.1,1.4l-0.7,0.3 M478.5,212l-1.4-1l-5.2-3.7l-4.7-3.4l-0.1-0.1l-2.7-1.8l-2.5,0.4l-4.1,0.6l-2.5,0.4
		l-2.2,0.3l-0.2,0l0-0.1l-0.1-1.3l-0.7-0.7l-0.8-0.9l-1.6-0.7l-3,0.3l-0.4,0l-4.2,0.4l-1.1,0.1l-1,0.1l-2.6,0.3l-1.5,0.1l-2.1,1.1
		l-1.8,1.3l-1.4,0.3l-1.1,0.5l-1,0.5l-0.2,1l-1,0.7l-0.7,1.3l-0.2,1l0.2,0.3l2.7,1.6l0.6,0.4l0.7,0.1l0.1-0.1l0,0l0.4-0.1l0.4-0.1
		l0.2,0.1l0.1,0.1l0,0l0.4,0.5l1.1,1.6l0.4,1l1.9,2.3l0.4,0.7l1.6,0.9l0.1,0l0.1-0.1l0,0l0.9,0.5l0.3,0.2l0.7,0.5l0.4,0.8l1.2,1.1
		l1,0.4l0.2,0.2l0.1,0.1l0.5,0.5l0.7,0.8l0.3,1l0.7,1l1,0.8l1.8,0.8l0.9,0.5l2,3.6l0.5,1.9l1.1,0.5l0.2,0.1l1,0.8l1.1,2.3l0.1,0.7
		l0.1,0.3l0.1,0.5l0.1,0.6l0,0l0.6,0.2l2,0.4 M497.2,153.9l0.3-0.6l3.7-1.2 M501.9,146.2l-2.9,0.6l-0.1,0l-0.4,0.1l-0.2,0l-0.1,0
		l0,0l-0.5,0.1l-0.2,0l-0.6,0.1l-0.3,0.1l0,0l-0.7,0.1l-0.3,0.1l-0.1-0.4l-0.1-0.4l-0.1-0.5l-0.3-0.9l-0.7-2.4l-1.1-3.9l-0.4-1.3
		l-0.2-0.6l-0.3-1l-1.2-4.3l1.5-1.9l1.8,0.1 M496.9,108.6l-0.6,0.4l-0.3,0.3l-0.2,0.5l0,0.1l-0.1,0.5l0,0.2l0,0l0,0.2l-0.1,0.4
		l-0.3,0.6l-0.4,0.5l0.1,0.1l-1,2l0.9,1.1l0,0.1l0,0.1l-0.3,1l-0.2,0.3l-0.1,0l-0.1,0l-0.1,0l-0.2,0.4l0.1,0.8l0.2,0.9l0.1,0.1
		l0.1,0.2l1.4,0.6l0.7,1.5l0.9,0.6l0.1,0l2.6,2l-2.1,1.8l-0.6,0.9l-0.7,1.4l-0.4,0.6l-1.8,1.2l-0.2,0.4l-0.4,1.2 M505.2,115.3
		l0.1-1.2l0.3-1.2l0-0.5l0-1.1l-3.4-1l-0.2-0.1l-1.4-0.5l-3.5-1.2l-0.8-0.8l-0.4,0l-0.8,0l-0.2-0.1l-1-0.5l-0.3-0.3l-0.4-0.4
		l-0.3-0.6l-1.5-2.7l-1.2-0.2l-0.3-0.6l-0.2-0.2l-0.6-0.4l-0.2,0l-1.2,0.3l-5.8,1.3l-0.4,0.1l-3.8,0.8l-3.5,0.7l-0.4,0.1l-6,1.2
		l-1.3,0.3l-4.3,0.8l-0.9,0.2l-2.7,0.5l-2.6,0.5l-0.4,0.1l-1.3,0.2l-5.2,0.9l-0.1,0l-1.3,0.2l-0.3-1.7l-0.2-1.4l-0.1-0.3 M528,80.6
		l-0.7,0l-0.3,0l-0.1,0l-0.1,0l-0.9,0.6l-0.7,0.6l-0.2,0.2l-0.1,0.1l-0.5,1l-0.1,0.1l-0.2,0.6l-3.1,0.7l0,0l-0.1,0l-2.3,0.5
		l-0.3,0.1l-3.3,0.7l-1.6,0.3l-4.4,0.9l-0.9,0.2l-2.2,0.5l-0.1,3.2l-0.1,5.7l0.2,0.4l0.1,0l4.1-0.9l0.4-0.1l4.6-1.1l3.5-0.8l0.3-0.1
		l0.4-0.1l2.4-0.6l0.1,0.2l2.7-0.8l1.2,0.1l1.3,2.5l1.1,0.6l0.4,0.4l1.3,2 M414.7,258.8l-0.3-0.9l-0.1-0.3l-0.1-0.1l-0.5-0.6l-0.1,0
		h-0.1l-0.1-0.1l-0.1-0.3l-0.2-0.9l0.1-0.3l0.1-0.3l0.1-2.7l-1.2-3L412,249l0.5-2.8l0-1l1.2-2.3l0,0l0.1-0.4l-0.1-0.2l-0.3-0.2
		l-0.7-0.2l-0.1-0.1l0-0.1l0.1-0.5l-0.3-1.8l-1-1.1l-0.8-1.7l-0.7-1.5l-0.9-3l-0.1-0.3l-1-3.8l-0.2-0.7l-0.6-2.1l-0.9-3.1l-0.2-0.8
		l-0.4-1.5l-0.7-2.6l-0.9-3l-0.2-0.8l-0.1-0.4l-0.8-3l-0.4-1.6 M353.2,212.4l6.1-0.4l0.8-0.1l3.1-0.2l1.6-0.1l1.9-0.1l2-0.2l0.4,0
		l4.2-0.3l0.2,0l1.7-0.1l2.2-0.3l4-0.3l4-0.3l0.1,0l3.9-0.3l0.5-0.1l4.9-0.5l0.1,0l4.7-0.5l2.7-0.2l1.4-0.1l1.1-0.1l1-0.1l3-0.4
		l1.8-0.2l0.4,0l1.6-0.2l3.1-0.4l0-2.8l0.9-0.7l1.1,0l0.4-0.3l0.2-0.3l0.4-2.3l0.1,0l2.8-1.8l0,0l0.2,0l1.5-0.2l0.1-0.1l1.8-1.4
		l0.4-0.5l0-0.2l2.9-1.4l0.4-2l0.5-0.1l0.9-0.9l0.6-0.6l0.2-0.1l0.3-0.2l0,0l0.2,0.1l0.2,0.2l1.1,0.6l0.7-1.3l1.8-1.4l1.5,0.4
		l1.2-2.3l0.1-0.3l0.1-0.2l0.5-0.5l0.5-0.4l0,0l0.1,0l0.1,0.1l0.3,0.1l0.2,0h0l0.2-0.1l0-0.6l0-2.6 M506.1,87.9l-0.7-2.5l-1-4.7
		l-0.5-2.5l-1.5-0.3l-0.3-0.1l0,0l-0.1-0.8l0.1-0.5l0.2-1l-0.3-0.6l-0.2-0.3l-1.1-2.5l0,0l0-0.4v-0.4l0-1.1l0.4-1.1l-0.3-1.6l0-0.5
		l0-0.1l0,0l-0.2-0.5l-0.1-0.3l-0.4-0.5l-0.3-0.2l-0.1-0.1l-0.3-0.5l-0.5-2.7l-0.3-2.1l0-0.2 M481.5,146l1.1-1.7l-1.2-0.6l-0.5-0.3
		l-0.6,0.9 M455.5,138.6l1.1,6.6l1.6-1.9l1.8-2.2l1.1,0.2l1.6-2.2l1.2,0.5l1.9-0.1l1-1.8l0.5,0.1l0.1,0l0.3-0.6l0.3-0.4l0.1-0.1
		l0.1,0l0.3,0l0.4,0l0.4,0.1l0.5,0.3l0.2,0.2l2.2,1.2l1.5,2l0.4,0l2.4,0.8l-0.4,0.6l0,0.1l0,0.1l0,0.2l0,0.1l0,0l0.1,0.2l0.1,0.1
		l0.1,0l0.6,0.4l0,0l0.4,0l0.5,0l0.5-0.1l2.3,1.2l0.4,0.3l0.5,0.2l0.3,0.5l0.1,0.6l0,0.1l-0.2,1.1l-0.3,1 M427.5,160.2l0.9,0
		l1.6-0.6l0.1-0.1l0.1-0.1l0-0.1l0-0.1l0-0.1l0-0.9l0,0l0-0.6l0.7-0.2l0.2,0l0.1,0l0,0l0.1,0l0,0l0-0.1l0-0.1l0-0.1l0,0v0l0-0.1
		l-0.3-1.1l0.1-2.1l0.2-1.2l0-0.2l0.5-0.8l0.2-0.1l0.2,0l0.7,0.4l0.2,0.2l0.2,0.4l0,0.1v0.7l0.3-0.1l1-0.7l0-0.1l-0.2-1l-0.1-0.1
		l-0.2-0.2l-0.1-0.1l-0.1-0.1l0-0.2v-0.1l0.6-0.3l-0.2-1.1l0.2-0.4l0.2-0.5l1.3-1.6l0.6-0.8l0.1-0.1l0.1,0l0.1,0l0.3,0.1l0.1,0.1
		l0.4,0.5l2-1.7l0.9-1.4l0.8-1l0.9-1.6l-0.1-1.7l0.4-2.4l0-1.6l0.1-0.4l0.2-2.8l-0.9-2.3l1.3-1 M400.5,120.8l0.3,2.1l0.2,1.3l0.2,2
		l0,0.2l0.4,3.4l0.1,0.9l0.3,2.5l0.2,2l0.3,2.8l0.1,0.5l0.4,3.9l0.1,1.1l0.3,2.5l0.2,2.1l0.1,0.6l0.3,2.8l0.3,2.6 M374,174.3
		l-0.5-1.1l0.5,0l0,0l0,0l0,0l0-0.1l0.1-3l0.1-1.4l0-0.1l1.9-2.6l0.7-2.1l0.2-0.5l0.8-1l0.1-0.1l0.1-0.2l0.1-0.8l0-0.3l-0.4-0.8l0,0
		l0,0l-0.1-0.6l0.1-0.1l0.1-0.2l0-0.4l-0.7-1.3l-0.5-0.6l-0.2-0.7l0.1-1.3l0.5-2.9l-0.2-1.7l-0.3-3.6l-0.3-3.4l-0.3-4.3l0-0.2
		l-0.3-3.2l-0.3-3.5l-0.2-2l-0.2-1.7l-0.2-2.2l-0.3-3.1 M338.2,143.1l-0.6,0l-0.4-0.3l-1-1.2l0-0.1l0-0.3l0-0.1l-0.8-0.6l-0.2-0.1
		l-2.2,0l-2.3,0.2l-1.7,0.1l-2.8,0.2l-0.7,0l-3.7,0.2l-2.7,0.1l-1.8,0l-2.1,0.1l-2.3,0.1l-2.1,0.1l-2.3,0.1l-1.6,0l-2.8,0l-2.8,0
		l-1.7,0l-3.8,0 M343.3,62.7l1,0.6l1.8,2.2l0.8,0.2l0.9,0.2l6.5,1.3l0.5,0.1l0.4,0.1l0.6,0.2l0.6,0.3l0.5,0.3l2.3,0.6l0.2,0.3
		l1.6-0.2l2.6,0.3l0,0l0.2,0l0.3,0.2l0.2,0.1l0.1,0.1l0.3,0.4l0,0l0,0l-0.1,0.2l-0.1,0.2l-0.1,0.1l-0.2,0.2l0,0l0,0l0.1,0.1l0,0
		l0.3,0.3l0.1,0l0.1,0l0,0l0.1,0l2.1,0.6l0.2,0.1l0,0l0,0l0.3,0.3l0.1,2.3l0.8,3.8l0,0l0.1,0.3l0,0.1l0.7,0.8l0,0l0.2,0l0.4,0.1
		 M92.4,223.8l1.1,0.1l1.5-0.9l0.5-0.7l0.1-0.3l0.1-0.8l-0.3-0.7l0,0l0,0l-0.9-0.2l-0.2-0.1l-0.5-0.3l-0.2-0.6l0,0l0.6-3.9l1.1-0.3
		l1.3-1.5l0.4-1.5l0.3-1.5l0.1-0.4l0.3-1l0.3-0.5l1-1.4l1.3-0.5l0.9-0.4l1.4-0.8l0.1-0.6L102,204l-0.6-0.6l-0.7-0.8l-0.7-2.8l0-0.5
		l-0.7-1.1l-0.6-1.5l0-0.1l0-0.2l0.3-1.4l-1.4-2.1l-3.8-5.7l-0.3-0.4l-0.7-1.1l-2.1-3.1l-2-3l-0.1-0.2l-1.5-2.2l-0.4-0.5l-2.8-4.1
		l-3.4-5.1l-0.6-1l-1.1-1.6l-0.2-0.3l-5.2-7.8l-4.6-6.9l-5.5-8.3l-1.3-1.9l-1.9-2.9l-2.4-3.6l-0.5-1.9l0.1-0.6l0.2-0.7l0.5-1.9
		l0.4-1.6l0.9-3.5l0.2-0.7l1-3.7l0.6-2.4l0.2-0.7l0.6-2.2l1.2-4.6l1-4l2.6-10.2l-2.7-0.7l-0.4-0.1l-3.4-0.9l-1.7-0.5l-5.2-1.5
		l-7.7-2.3l-0.5-0.2L45,88.3L43.9,88l-1.2-0.3l-3.1-0.9l-0.2-0.1l-0.4-0.1l-1-0.4l-0.7-0.1l-2.7-0.7l-2.8-0.8l-3.6-1.1 M122.5,14.9
		l-1.3,6.2l-0.8,3.6l-0.6,3l0.3,0.5l1.7,3.5l0,0l0,0l0,0v0l0,0.7l-0.3,0.7l-0.2,0.6l-0.2,1l0,0.3l1.4,1.9l0.2,0.2l0.1,0.1l0.5,0.2
		l0.7,0.3l0.1,0.1l0.8,1.8l0.7,1.7l0.4,0.8l0.2,0.4l0.2,1.3v0l0,0.1l1.3,1.7l0.1,0l0.1,0l0.4,0l0.5,1.2l1,0.2l0.2-0.1l0.1-0.1l0.2,0
		l0.5,0.1l0.2,0.1l0.1,0.1l0,0.1l-0.1,0.3l-0.3,0.9l-0.5,1.2l-0.8,1.8l-2.5,6.3l-0.3,1.7l-0.2,0.9l0,0l0,0l0.4,0.1l0.4,0.1l0.1,0
		l0.7,1l0.1,0.3l0.4,0.1l1.8-0.8l1.1-1l0.8-0.5l0.2,0.2l0.9,1.2l0.1,0.2l0.1,1l0,0.4l-0.1,0.2l0,0.8l0,1l1.4,5.2l1.5,2.1l0.3-0.1
		l0.3,0.3l0.4,0.4l0.2,0.3l0.2,0.6l0.3,1.1v0.1l-0.1,0.1l0,0l0,1.6l0.1,0.6l0.2,0.4l0.7,0.8l0.2,0.1l0.2-0.1l0.1-0.1l0,0l0.1-0.5
		l0.1-0.2l0.4-0.4l0.6-0.1l3.2,0.8l1.4-0.5l2.5,0.3l1.8,0.5l1.2,0l1.6-1.8l1-0.4l0.4,0.4l0.7,1.5l0.4,1.2l0.1,0.3l0.7,0.7
		 M221.1,69.1l-0.1,0.8l-0.7,8.6l-0.4,2.8l-0.5,5.5l-0.4,5l0,0.5l-0.3,3.7l-0.4,4.5l0,0.3l-0.5,6.2l5.1,0.4l4.7,0.4l2,0.1l6.7,0.5
		l1.9,0.1l2.3,0.2l3.7,0.2l3,0.2l3.4,0.2l1.8,0.1l0.7,0l0.7,0l6.2,0.3l2.6,0.1l7.1,0.2l1.7,1.6l1.3,0.6l1,0.9l0.2,0.1l0.2,0l0.2,0
		l0.5-0.1l0.1-0.1l0.3-0.2l0.2-0.3l1.1-0.4l0.8,0.1l1.9-0.1l0.6-0.1l0.9,0l0.7,0.1l1.1,0.9l1.2,0.3l2,0.7l0.8,0.5l0.1,0.2l0.1,0.2
		l0,0.2l0,0.1l0,0.1l0.7,1l1.8,0.5l-0.3-0.9l-0.3-0.9l-0.2-0.4l-0.3-0.3l-0.2-0.2l0.4-1.7l0.4-1l0.7-2.3l0.1-0.4l0-0.1l-0.4-1.3
		l-0.1,0l-0.7,0l-0.2-0.5l-0.2-3.1l1.4,0 M282.9,32.9L282.9,32.9l-0.1,0.2l0,0.2l0,0.3l0.6,2l0.2,0.5l0.4,0.9l-0.6,1.8l0.3,0.3
		l0.1,3.1l-0.3,1.1l0,0.3l0.2,0.8l0.8,3l1.1,2.6l0.3,2.2l0.2,3.4l0,1.1l0,1.6l0.4,1.2l0.1,0.3l-0.2,2.8l0,0.7l0.4,1.1l1.2,3l0.3,2.7
		l0,0.2l0,0.3l0,0.1l-0.2,0.5l0.1,1.1l0,0.6v0l0,0l0,0.3l0,0.3l0,0.1l0,0.1l0,0l0,0l0,0l-0.6,0.9l-0.2,0.2l-0.3,0.2l-0.3,0.2
		l-0.8,0.7l0,0l0,0l0,0l0,0.1l-0.1,0.4l0,0.1l0.2,0.2l0.6,0.8l1.3,1.5l0.9,0.4l0.3,0.2l0.2,0.4l0.1,0.7l0,3.8l0,4.5l0,1.1l0,4.5
		l0,4.5l0,4.5l3.7,0l1.8,0l3.8,0h0.6l4.4,0l0.6,0l3.8-0.1l1.8,0l2.6,0l3-0.1l1.4,0l4.2-0.1l0.2,0l4.4-0.2l1,0l3.4-0.1l3.3-0.1
		l1.1-0.1l3.7-0.2 M94.5,101l4.8-21.2l1-2.4l0.3-0.5l0.4-0.8l0.4-1.4l0.5-0.6l0,0l0,0l0,0l0,0v0l0-0.1l0-0.1l0,0l-0.5-0.9l-0.1-0.1
		l-0.4-0.1h0l-0.1,0l-1.1-0.5L99.5,72l0-0.2l0-0.1l0-0.1l0.3-2.1l0.1-0.2l2-2.7l0.2-0.2l0.1,0l0.2,0l0.9-0.3l0.5-0.5l0.3-0.3
		l0.2-0.2l0.3-0.5l0,0l0-0.1l-0.1-0.1l0-0.1l0-0.3l0.2-0.5L105,63l0.4-0.4l1.3-2.2l0.3-0.6l1.6-2l0.9-0.9l0.2-0.2l0-0.2l-0.3-1.6
		l-0.1-0.2v0l-0.2-0.2l-0.2-0.2l0,0l-0.3-0.1l-0.8-0.7l-0.4-0.4l0,0l0-0.1l-0.6-2l-4.9-1.2l-1.1-0.3l-3.3-0.8l-0.2,0l-8.7-2.1
		l-0.3,0.2l-0.2,0.1L87.6,47l-0.3,0l-0.4,0L86.6,47l-0.2-0.1L85,46.7l-0.5,0l-0.5,0l-1.7,0.2l-0.9-0.1l-0.9-0.1h-1.2l-1.4,0.2
		l-0.3,0.1l-0.5,0.4l-1.8-0.1L74.6,47l-0.2-0.1l-0.1-0.2l-0.2-0.4l-0.3-0.2L73.5,46l-0.2,0.1l-0.4,0.2l-1,0.1l-0.8,0.1l-0.5,0.1
		l-0.2-0.3l-3.3-1.5l-0.3-0.1l-0.6-0.1l-0.6-0.5l-1,0l-0.7-0.1l-0.2-0.1l-0.6-0.3l-0.5,0l-0.4,0.2l-0.3,0.2l-3.2,0.4l-0.2,0
		l-0.3-0.1L58,44.4l-2.5-1.5l-0.2-0.2l-0.5-0.5L54.6,42l0-0.3l0.1-0.2l0.2-0.3l0.2-1.6l0.1-0.2l0.1-1.2L55,36.7l-0.1-0.3l-1.5-1.8
		l-0.4-0.2l-0.5,0.1l-1.4-0.1l-0.1,0l-0.4-0.6l0.2-0.6l-0.1-0.3l-0.1-0.2l0-0.1l0,0l0,0l-0.6,0 M307.6,188l-4,0l-0.7,0l-3.4,0
		l-1.2,0l-2.7,0l-2.2,0l-5.4,0l-2.3,0l-4.1,0l-3.2,0l-3.5-0.1l-3.2-0.1l-2.4-0.1l-2-0.1l-4.7-0.1l-4.7-0.2l-0.9,0l-4.7-0.2l-0.9,0
		l-5.6-0.2l-3.2-0.1l-1.2-0.1l-5-0.2l-4.8-0.3l-0.1,0 M378,270.6l-0.6-4.7l-0.4-3.4l-0.2-1.5l-0.5-4.1l-0.4-3.4l-0.3-2.5l0.1-4.3
		l0-1.1l0.1-3.5l0.1-4.6l0-0.8l0.1-3.9l0.1-3.2l0.1-2.7l0.1-4.1l0-0.4l0.1-3.1l0-1.9l0-1.5l0.1-4.1l-1.2-1.2 M345.5,238.6l-1.1,0
		l-1.8,0.1l-0.3,0l-6.5,0.3l-7.1,0.2l-2.8,0.1l-2.7,0.1l-2.7,0.1l-0.3,0l-3.1,0.1H317l-2.5,0.1 M220,81.2l-8.9-0.8l-0.5,0l-6.9-0.7
		l-0.6,0l-1,0l-2.2-0.2l-5.7-0.7l-1.7-0.2l-0.5-0.1l-4.3-0.5l-2.7-0.3l-3.1-0.4l-3.4-0.5l-2.8-0.4l-1.2-0.2l-0.2,0l-1.7-0.3
		l-4.8-0.6l-2.8-0.4l-1,0l-3-0.4l0,0l-1.4-0.2l-0.4-0.1l-1.1-0.2l-1.5-0.2l-0.8,4.3l-0.3,2.5l-1,6.3l-1,6.2l-0.4,2.4l-0.6,3.8
		l-1.1,6.5l-1.1,6.6l-0.9,5.4l-0.7,4.2l-0.5,3.3l5.2,0.9l4.3,0.6l0.5,0.1h0l1.4,0.2l1.3,0.2l0.4,0.1l4.5,0.6l1.5,0.2l7.7,1l3.2,0.4
		l5.8,0.7l4.4,0.5l5.2,0.6l1.3,0.1l8.8,0.9l3.2,0.3l8.6,0.7l4.6,0.4l1.9,0.1l7,0.5l0.3,0l5.5,0.4l-0.2,3.3l0,0.7l-0.2,3.3l-0.1,1.2
		l-0.3,4.5l6.3,0.4l0.9,0l5.5,0.3l0.2,0l5.3,0.3l0.2,0l5.4,0.2l4.4,0.2l1.1,0l3.3,0.1l2.2,0.1l2.3,0.1l3.4,0.1l1.1,0l4.4,0.1
		l4.4,0.1l1.1,0l3.4,0l2.2,0l2.2,0h2.2l4.4,0h0.3 M106.8,50.9l-0.1-0.9l0.4-1.2l-0.1-1.1L107,47l0,0l-0.3-1.1l0.2-0.6l0.3-1.5
		l1.6-7.3l0.4-1.7l0.3-1.3l1.7-7.6l0.2-0.9l2.3-10l0.4-1.9 M419.8,185.1l2.1-1.1l1-0.6l2.1-1.2l2-1.7l0.2-0.4l0-1l2.7-3.3l0.1-0.1
		l0.4-0.3l1.5-0.9l0.4-0.5l3-3.6 M528.4,78l-1.3-0.5l-0.3-1.4l0,0l-1.1-0.7l-0.5-0.2l-0.2-0.1l-0.3-0.4l-0.1-0.2l-0.1-0.3l-0.2-1.8
		l-1.1-3l-1.8-6.1l-1.7-5.4l-0.1-0.4l-1.9-5.8l-0.3-1 M514.7,55.5l-0.2,0.4l0,3.2l0.1,0.2l0.3,0.3l0.4,0.5l0.2,0.3l0,0.1l0.2,0.4
		l-0.1,1.1l-0.1,0.3v0l0,0.1l-0.4,0.8l0,0.1l-0.1,0.1l-0.1,0.2l0,0l-0.3,0.2l-0.2,0l-0.6,0.8l-0.6,0.4l-0.6,0.4l0,0l0,0l-0.3,0.5
		l0,0.1v0.1l0.3,1l0.2,0.2l0.2,0.1l-0.2,5.2l-0.6,2.4l-0.3,1.2l0.4,2.1l0.2,0.5l0,1.1l0,1l0.3,0.5l0,0.1l0.2,1.4l-0.6,2l0,0.1
		l0.3,0.6l1,0.8 M506.2,97.2l0.9,4.9l0.3,1.8l0.4,2.1l0.2,0.9l-0.3,2.1l-0.1,0.1l-0.7,0.7l1,1.3 M307.7,194.5l5.6-0.1l2.2,0l2.9-0.1
		l2.8-0.1l0.2,0l4.5-0.1l0.8,0l2.5-0.1l3.9-0.2l0.3,0l4.6-0.2l2.3-0.1l0.4,0l2.9-0.2l3.5-0.2l2.1-0.1l3.7-0.2l0.3,0l0.4,0l0.9,1.3
		l0.1,0.1l0.1,1l-0.1,0.3l-0.1,0.1l-1.1,1l-1.6,2.8l0.8-0.1l3.4-0.2l2.3-0.2 M381.2,122l2.9-0.3l2.8-0.3l1.6-0.2l2.6-0.3l1.3-0.1
		l3.5-0.4l0.9-0.1l3.5-0.4l0.3,0.8l3.9-0.6l0.4-0.1l4.5-0.7l1.1-0.2l2.9-0.5 M415.8,206.7l2-0.2l1.3-0.2l0.7-0.1l4-0.6l0.7-0.1
		l3.9-0.6 M361.2,192.3l-0.7,0.1 M150.4,251.7l2-14l0.6-4.5l0.8-5.5l1-7.3l1.4-10.3l0.7-4.9l1.9-13.4l1.8-12.8l0.9-6.3l0.7-5.1
		l0.5-3.5l0.4-4.5l0.4-2.8l0.4-2.4l0.1-0.5l0.3-2.3l0.4-3.1l0.2-1.7l0.3-2.1l1.8-12.8l0.6-4.5 M491.1,131.6l-3.3,0.7l-0.9,0.2
		l-0.1,0l-3.2,0.7l-2.1,0.4l-2.1,0.4l-2.1,0.4L475,135l-0.1,0l-6.1,1.2l-2.4,0.4l-0.4,0.1l-4.1,0.8l-1.2,0.2l-4.5,0.8l-0.8,0.1
		l-2.8,0.5l-1.5,0.3l-4.9,0.8l-1,0.2l-0.5-3.1l-0.1-0.7l-0.3-1.8l-0.5-3.1l-0.2-1l-0.3-2.1l-0.4-2.7l-0.1-0.6l-0.5-2.9l0-0.1
		l-0.8-4.6l0-0.1l-0.7-4.5l-0.3-1.6 M521.9,93.8l1,3.5l0.3,1.1l0.1,0.5l0.2,3.6 M150.5,111.8l-4.3-0.7l-5.7-0.9l-0.5-0.1l-0.7-0.2h0
		l-2-0.3l-2.4-0.4l-2.7-0.5l-3.8-0.6l-0.3,0l-3.1-0.5l-0.3,0l-0.8-0.1l-0.1,0l-0.8-0.2l-0.6-0.2l-2.4,12.7l-2.2,11.3l-0.5,2.7
		l-0.9,4.6l-2.1,11l-0.3,1.3l-1,5.4l-1.4,6.9l-1.5,7.7l-0.4,2l-0.4,2.1l-0.1,0.3l-0.4,2.3l-0.2,1.3l-0.4,2.3l-1.3,1.8l-0.1,0.2l0,0
		l0,0l-0.6,0l-0.2,0l-0.1,0l-0.1-0.1l-0.1-0.1l-0.2-0.4l-0.1-0.2l0-0.1l0,0l0-0.1l-0.1-0.3l-0.3-0.4l-0.1-0.1l-1.3-0.4l-0.6-0.1H102
		l-1.2,0.3l-0.1,0.1l-0.1,0.1l0,0.1l-0.1,1.3l-0.3,3.7l-0.1,2.3l0.1,1.6l0.1,0.8l0,0.4l-0.1,1.6l0,0.3l-0.1,0.3l-0.1,0.3l-1,1.6
		 M217.8,107l-0.4,5l-0.7,7.9l-0.3,3.9l-0.1,1.7l-0.2,2.2l-0.4,5.1 M317.7,282.5l-0.1-2.9l1.3-1.8l0-2.5l-0.3-2l0.4-0.4l0-0.1l0-0.1
		l-0.2-0.8l-0.3-0.4l0,0v0l0.1-0.5l1.6-3l0.2-0.9l0-4.1l-0.5,0.1l-0.1-0.7l-0.1-0.4l-0.3-1.4l-1-1.5l-1.2-1.2l-0.5-3.3l-1.5-1.7
		l-0.4-2.8l-0.1-2.5l-0.1-3.9l0-2.4l0-1.8l-0.1-3.3l-0.1-3.6l-0.3-0.2l-0.2-0.1l-1-0.2l-0.6,0.1l-0.2,0l-0.1,0l-1,0.5l-0.6-0.3
		l-0.2-0.1l-0.4-0.3l-0.1-0.1l-0.1-0.2l-0.1-0.2l-2.8-0.8l-1.3-0.5l-1.8-1.5l-1.2-1.1l-0.7-0.2l-0.1,0l0,0l0,0h0l-0.2,0.3l0,0v0l0,0
		l0,0l0,0.1v0l0,0.1l0,0.1l-0.1,0.1l-0.1,0.1l-0.3,0.2l-0.1,0l-0.2,0l-0.3,0h0l-0.7,0l-0.4,0l-1.1-0.1l0,0l0-0.1v0l0-0.1l0-0.1
		l0-0.1l-0.1-0.3l-0.1,0l-0.3,0l-0.8,0.4l-0.9,0.5l-0.9,0.3l-0.5-0.1l-0.6-0.1l-0.1,0l-0.2,0l-1.2,0.1l-0.5,0.1l-0.1,0.3l-0.1,0.3
		l0,0l0,0l0,0.1l0,0.1l0,0l0,0l-0.1,0.1l0,0l-0.2,0.1l-0.2,0.1l-1.6,0.4l-0.1-0.1L289,230v0l-0.1,0l-0.1,0l-0.5,0.1h0l-0.1-0.1
		l-1.1-0.7l0,0l0-0.1l0-0.2l0-0.2l-1.1,0.5l0,0l-0.5,0.1l-1-0.3l-0.1-0.1l-0.2-0.2l-0.5-1.1l-0.1,0.1l-1.6,2.8l0,0.1l-0.1,0.1
		l-0.2,0l-0.2,0l-0.1-0.1l-3.1-1.4l-0.1-0.1l-0.1-0.1v0l0,0l0-0.1l-0.2-1l-0.8,0.2l-0.4-0.3l-1.1-0.7l-0.4,0.5l-0.6,0.6l-0.5,0.4
		l-0.3,0.1l-0.1,0l-0.9-0.4l-0.1-0.1l0.3-0.6l0.1-0.7l-0.4-0.2l-0.4,0.1l0,0h-0.2l-0.5-0.1l0,0l0,0l-0.2-0.4l-0.6-1.1l-1.6-0.5
		l-0.4-0.1l-0.2,0.1l-0.4,0.5l-0.6,0.5l0,0l0,0l-0.3-0.1l-0.5-0.8l-0.2-0.2l-0.2-0.2l-0.1,0l-1,0.3l-0.7,0l-1-0.2l-1-0.6L262,224
		l-1-0.1l-0.4,0l-0.2,0l-0.4-0.1l-0.2-0.1l-0.1,0l0,0v0l-0.2-1l0-0.3l0-0.3v0l-0.5-0.9l-0.5-0.3l-0.5-0.3l-0.5,0.8l0,0l0,0h0l-0.1,0
		l-0.4,0l-0.3-0.3l-0.3-0.2l-0.2-0.1l-0.5-0.1l-0.1,0l-0.1,0l-0.4,0.5l-0.4,0h-0.1l-0.3-0.1l-0.7-0.7l-0.3-0.3l-0.6-0.7l-1.5-0.8
		l0.1-2.4l0.2-3.7l0.1-2l0.1-3.1l0.1-2.6l0.1-3.4l0.1-2.3l0.2-5.8l-5.6-0.2l-4.2-0.2l-1.3-0.1l-5.5-0.3l-4.2-0.3l-1.3-0.1l-8.6-0.6
		 M288.4,72.2l-6-0.1l-6.8-0.1l-0.3,0l-6.4-0.2l-2.5-0.1l-6.4-0.2l-1.5-0.1l-5.6-0.3l-0.1,0l-2-0.1l-0.2,0l-0.1,0l-1.1-0.1l-0.8,0
		l-2.6-0.1l-0.9-0.1l-0.5,0l-1.1-0.1l-1.4-0.1l-1.3-0.1l-1.1-0.1l-0.1,0l-0.1,0l-8.5-0.6l-0.5,0l-9.4-0.7l0.4-4.3l0.3-3.3l0.1-1.3
		l0.7-8.8l0.1-0.9l0.7-7.6l0.4-5l0.3-3.1l0.4-4.7	"
        >
          <title id="t3141">#State_borders</title>
        </path>
        {/* <path
          id="separator"
          className="st2"
          d="M154.3,294.7v35.4l23.1,20.9 M0.6,251h110.6l43.1,43.7h55.3l34.1,34.7V351"
        /> */}
      </g>
    </svg>
  );
}
export default Map;
